
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

parcelRegister("ih19M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("f5id0", function(module, exports) {

$parcel$export(module.exports, "getSemigroup", function () { return $afb57284fc4a1786$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $afb57284fc4a1786$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "identity", function () { return $afb57284fc4a1786$export$f0954fd7d5368655; });
$parcel$export(module.exports, "unsafeCoerce", function () { return $afb57284fc4a1786$export$401372c57776dc; });
$parcel$export(module.exports, "constant", function () { return $afb57284fc4a1786$export$c983f826f44ff86; });
$parcel$export(module.exports, "constTrue", function () { return $afb57284fc4a1786$export$a68382d9631f6c53; });
$parcel$export(module.exports, "constFalse", function () { return $afb57284fc4a1786$export$7349232f2648ca80; });
$parcel$export(module.exports, "constNull", function () { return $afb57284fc4a1786$export$243c2ee5e7d8b05c; });
$parcel$export(module.exports, "constUndefined", function () { return $afb57284fc4a1786$export$3d16a43570087548; });
$parcel$export(module.exports, "flow", function () { return $afb57284fc4a1786$export$ccc7b0636abaffc3; });
$parcel$export(module.exports, "tuple", function () { return $afb57284fc4a1786$export$65e3907585753458; });
$parcel$export(module.exports, "pipe", function () { return $afb57284fc4a1786$export$a4627e546088548d; });
$parcel$export(module.exports, "SK", function () { return $afb57284fc4a1786$export$5f584391ee0d99b4; });
$parcel$export(module.exports, "dual", function () { return $afb57284fc4a1786$export$d1699a1bbdf17835; });
var $afb57284fc4a1786$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $afb57284fc4a1786$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $afb57284fc4a1786$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $afb57284fc4a1786$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $afb57284fc4a1786$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $afb57284fc4a1786$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $afb57284fc4a1786$export$575097c1c561f76f = function(R) {
    var S = $afb57284fc4a1786$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $afb57284fc4a1786$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $afb57284fc4a1786$export$f0954fd7d5368655(a) {
    return a;
}
var $afb57284fc4a1786$export$401372c57776dc = $afb57284fc4a1786$export$f0954fd7d5368655;
function $afb57284fc4a1786$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $afb57284fc4a1786$export$a68382d9631f6c53 = /*#__PURE__*/ $afb57284fc4a1786$export$c983f826f44ff86(true);
var $afb57284fc4a1786$export$7349232f2648ca80 = /*#__PURE__*/ $afb57284fc4a1786$export$c983f826f44ff86(false);
var $afb57284fc4a1786$export$243c2ee5e7d8b05c = /*#__PURE__*/ $afb57284fc4a1786$export$c983f826f44ff86(null);
var $afb57284fc4a1786$export$3d16a43570087548 = /*#__PURE__*/ $afb57284fc4a1786$export$c983f826f44ff86(undefined);
var $afb57284fc4a1786$export$fe2a8306a887c223 = $afb57284fc4a1786$export$3d16a43570087548;
function $afb57284fc4a1786$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $afb57284fc4a1786$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $afb57284fc4a1786$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $afb57284fc4a1786$export$a2647aa13413c947(n) {
    return n + 1;
}
function $afb57284fc4a1786$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $afb57284fc4a1786$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $afb57284fc4a1786$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $afb57284fc4a1786$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $afb57284fc4a1786$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $afb57284fc4a1786$export$5cc5fd8bb7edf254 = $afb57284fc4a1786$export$f172309911142386;
var $afb57284fc4a1786$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $afb57284fc4a1786$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $afb57284fc4a1786$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $afb57284fc4a1786$export$ccc7b0636abaffc3(first, second);
        },
        empty: $afb57284fc4a1786$export$f0954fd7d5368655
    };
};
var $afb57284fc4a1786$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $afb57284fc4a1786$var$__spreadArray([
                self
            ], args, false));
        };
    };
};

});

parcelRegister("8SAMq", function(module, exports) {

$parcel$export(module.exports, "Iso", function () { return Iso; });
$parcel$export(module.exports, "Prism", function () { return Prism; });
$parcel$export(module.exports, "lens", function () { return (parcelRequire("gnzcc")); });
/**
 * @since 1.0.0
 */ 
var $7XKUT = parcelRequire("7XKUT");

var $lyuPz = parcelRequire("lyuPz");

var $f5id0 = parcelRequire("f5id0");

var $4x239 = parcelRequire("4x239");

var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");

var $lSSmc = parcelRequire("lSSmc");

var $bsqKk = parcelRequire("bsqKk");

var $kXLDY = parcelRequire("kXLDY");

var $gnzcc = parcelRequire("gnzcc");

var $asc1N = parcelRequire("asc1N");

var $3CRtD = parcelRequire("3CRtD");

var $gAohm = parcelRequire("gAohm");
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($bsqKk.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $bsqKk.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($bsqKk.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($bsqKk.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($bsqKk.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($bsqKk.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($bsqKk.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $4CZFO.pipe)(this, $bsqKk.asLens, $gnzcc.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $4CZFO.pipe)(this, $bsqKk.asPrism, $3CRtD.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $4CZFO.pipe)(this, $bsqKk.asOptional, $asc1N.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $bsqKk.asTraversal, $gAohm.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $4CZFO.pipe)($gnzcc.id(), $gnzcc.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $4CZFO.pipe)($gnzcc.id(), $gnzcc.props.apply($gnzcc, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $hVAkz.fromNullable)(s[k]);
                if ((0, $hVAkz.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $gnzcc.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($gnzcc.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($gnzcc.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($gnzcc.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $4CZFO.pipe)(this, $gnzcc.asOptional, $asc1N.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $gnzcc.asTraversal, $gAohm.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $4CZFO.pipe)(this, $gnzcc.compose((0, $4CZFO.pipe)(ab, $bsqKk.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($gnzcc.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($3CRtD.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $hVAkz.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $hVAkz.option).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($3CRtD.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($3CRtD.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $hVAkz.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($3CRtD.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $4CZFO.pipe)(this, $3CRtD.asOptional, $asc1N.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $3CRtD.asTraversal, $gAohm.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $4CZFO.pipe)(this, $3CRtD.compose((0, $4CZFO.pipe)(ab, $bsqKk.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($3CRtD.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $f5id0.identity), (0, $hVAkz.some));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $hVAkz.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $asc1N.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $asc1N.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($asc1N.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $hVAkz.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($asc1N.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $asc1N.asTraversal, $gAohm.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $4CZFO.pipe)(this, $asc1N.compose((0, $4CZFO.pipe)(ab, $gnzcc.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $4CZFO.pipe)(this, $asc1N.compose((0, $4CZFO.pipe)(ab, $3CRtD.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $4CZFO.pipe)(this, $asc1N.compose((0, $4CZFO.pipe)(ab, $bsqKk.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $gAohm.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $gAohm.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($gAohm.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $lyuPz.getApplicative)(M))(function(a) {
                    return (0, $lyuPz.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($gAohm.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $gAohm.compose((0, $4CZFO.pipe)(ab, $gnzcc.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $gAohm.compose((0, $4CZFO.pipe)(ab, $3CRtD.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $4CZFO.pipe)(this, $gAohm.compose((0, $4CZFO.pipe)(ab, $bsqKk.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($lSSmc.fromIso(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($kXLDY.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($kXLDY.fromIso(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($7XKUT.getMonoid())($7XKUT.of);
        this.exist = foldMap((0, $4x239.monoidAny));
        this.all = foldMap((0, $4x239.monoidAll));
        this.foldMapFirst = foldMap((0, $hVAkz.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $hVAkz.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $f5id0.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $gAohm.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});
parcelRegister("7XKUT", function(module, exports) {

$parcel$export(module.exports, "of", function () { return $5cc26fbc162a813e$export$ba255e9e49e00608; });
$parcel$export(module.exports, "getMonoid", function () { return $5cc26fbc162a813e$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Foldable", function () { return $5cc26fbc162a813e$export$41404b31838667c9; });

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $ctkBN = parcelRequire("ctkBN");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $ceJ0M = parcelRequire("ceJ0M");

var $b406R = parcelRequire("b406R");

var $bFSl4 = parcelRequire("bFSl4");

var $erGUW = parcelRequire("erGUW");

var $gJWAH = parcelRequire("gJWAH");
var $5cc26fbc162a813e$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $5cc26fbc162a813e$export$a978c53b4062a525 = $ceJ0M.isNonEmpty;
var $5cc26fbc162a813e$export$68159836694e22c1 = $ceJ0M.prepend;
var $5cc26fbc162a813e$export$c4c4d41eab625797 = $ceJ0M.prependW;
var $5cc26fbc162a813e$export$10d8903dec122b9d = $ceJ0M.append;
var $5cc26fbc162a813e$export$19903a1bf1942f6 = $ceJ0M.appendW;
var $5cc26fbc162a813e$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $ceJ0M.makeBy(f)(n);
};
var $5cc26fbc162a813e$export$606959e7ccb797f0 = function(n, a) {
    return $5cc26fbc162a813e$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $5cc26fbc162a813e$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $5cc26fbc162a813e$export$172ec0a6ebfeb6fa = function(ma) {
    return $aByOK.isNone(ma) ? [] : [
        ma.value
    ];
};
var $5cc26fbc162a813e$export$80c878c9b1d77917 = function(e) {
    return $aByOK.isLeft(e) ? [] : [
        e.right
    ];
};
var $5cc26fbc162a813e$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $5cc26fbc162a813e$export$4659b591c19bdf3d = $5cc26fbc162a813e$export$2d55ea551c238330;
var $5cc26fbc162a813e$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? onNonEmpty($ceJ0M.head(as), $ceJ0M.tail(as)) : onEmpty();
    };
};
var $5cc26fbc162a813e$export$6280271dfaec4919 = $5cc26fbc162a813e$export$ebbe93aa91e3abdc;
var $5cc26fbc162a813e$export$f3163a37d0ef5927 = $5cc26fbc162a813e$export$6280271dfaec4919;
var $5cc26fbc162a813e$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? onNonEmpty($ceJ0M.init(as), $ceJ0M.last(as)) : onEmpty();
    };
};
var $5cc26fbc162a813e$export$b1cacb83a5c6bd02 = $5cc26fbc162a813e$export$364f7f2cc8473008;
var $5cc26fbc162a813e$export$77fa89c00b331c4c = $5cc26fbc162a813e$export$b1cacb83a5c6bd02;
var $5cc26fbc162a813e$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $5cc26fbc162a813e$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $5cc26fbc162a813e$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $5cc26fbc162a813e$export$346677f925de839c = function(as) {
    return as.length;
};
var $5cc26fbc162a813e$export$2fde0b1c54fc39b9 = $ceJ0M.isOutOfBound;
var $5cc26fbc162a813e$export$dfc7155ac0343b8 = $b406R.lookup;
var $5cc26fbc162a813e$export$5fd5031fecdacec3 = $b406R.head;
var $5cc26fbc162a813e$export$4c7897fafd92b108 = $b406R.last;
var $5cc26fbc162a813e$export$c01875f616615628 = function(as) {
    return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? $aByOK.some($ceJ0M.tail(as)) : $aByOK.none;
};
var $5cc26fbc162a813e$export$2cd8252107eb640b = function(as) {
    return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? $aByOK.some($ceJ0M.init(as)) : $aByOK.none;
};
var $5cc26fbc162a813e$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $5cc26fbc162a813e$export$2fde0b1c54fc39b9(n, as) ? $5cc26fbc162a813e$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $5cc26fbc162a813e$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $5cc26fbc162a813e$export$2fde0b1c54fc39b9(n, as) ? $5cc26fbc162a813e$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $5cc26fbc162a813e$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $5cc26fbc162a813e$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $5cc26fbc162a813e$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $5cc26fbc162a813e$export$b0d75975ac0be0e1($5cc26fbc162a813e$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $5cc26fbc162a813e$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $5cc26fbc162a813e$export$dd1bc94b04021eeb(as) ? $5cc26fbc162a813e$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $5cc26fbc162a813e$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $5cc26fbc162a813e$export$dd1bc94b04021eeb(as) ? $5cc26fbc162a813e$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $5cc26fbc162a813e$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($5cc26fbc162a813e$var$spanLeftIndex(as, predicate));
    };
}
var $5cc26fbc162a813e$export$de3a4d4a0d731119 = $b406R.findIndex;
function $5cc26fbc162a813e$export$9a2f228bed5035c2(predicate) {
    return $b406R.findFirst(predicate);
}
var $5cc26fbc162a813e$export$a86c11c94d794a95 = $b406R.findFirstMap;
function $5cc26fbc162a813e$export$296de88ccac4bedb(predicate) {
    return $b406R.findLast(predicate);
}
var $5cc26fbc162a813e$export$8b5e6d6ad82284fa = $b406R.findLastMap;
var $5cc26fbc162a813e$export$8855a8be7bd3e9f8 = $b406R.findLastIndex;
var $5cc26fbc162a813e$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $5cc26fbc162a813e$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $aByOK.none : $aByOK.some($5cc26fbc162a813e$export$f4863e1822a1860c(i, a, as));
    };
};
var $5cc26fbc162a813e$export$b6d8713d53419d4c = function(i, a) {
    return $5cc26fbc162a813e$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $5cc26fbc162a813e$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $5cc26fbc162a813e$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some($5cc26fbc162a813e$export$4937fde8dfc38dbd(i, as));
    };
};
var $5cc26fbc162a813e$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $5cc26fbc162a813e$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some($5cc26fbc162a813e$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $5cc26fbc162a813e$export$66c1ae025e96b4bc = function(as) {
    return $5cc26fbc162a813e$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $5cc26fbc162a813e$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $5cc26fbc162a813e$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $5cc26fbc162a813e$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $5cc26fbc162a813e$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $5cc26fbc162a813e$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $5cc26fbc162a813e$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $5cc26fbc162a813e$export$8901015135f2fb22(bs, as);
    };
    return $5cc26fbc162a813e$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $5cc26fbc162a813e$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $5cc26fbc162a813e$export$849c7567cbd62acc = function(middle) {
    var f = $ceJ0M.prependAll(middle);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $5cc26fbc162a813e$export$af200dcf8b7cb5de = function(middle) {
    var f = $ceJ0M.intersperse(middle);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? f(as) : $5cc26fbc162a813e$export$784d13d8ee351f07(as);
    };
};
var $5cc26fbc162a813e$export$bb628a54ab399bc9 = function(n) {
    var f = $ceJ0M.rotate(n);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? f(as) : $5cc26fbc162a813e$export$784d13d8ee351f07(as);
    };
};
var $5cc26fbc162a813e$export$5bf96401662340b7 = $b406R.elem;
var $5cc26fbc162a813e$export$f70730c3d1fc524e = function(E) {
    var f = $ceJ0M.uniq(E);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? f(as) : $5cc26fbc162a813e$export$784d13d8ee351f07(as);
    };
};
var $5cc26fbc162a813e$export$b035e44d7bb4278f = function(ords) {
    var f = $ceJ0M.sortBy(ords);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? f(as) : $5cc26fbc162a813e$export$784d13d8ee351f07(as);
    };
};
var $5cc26fbc162a813e$export$433fe05b12ba833f = function(f) {
    var g = $ceJ0M.chop(f);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $5cc26fbc162a813e$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $5cc26fbc162a813e$export$a978c53b4062a525(as) ? $ceJ0M.splitAt(n)(as) : $5cc26fbc162a813e$export$dd1bc94b04021eeb(as) ? [
            $5cc26fbc162a813e$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $5cc26fbc162a813e$export$784d13d8ee351f07(as)
        ];
    };
};
var $5cc26fbc162a813e$export$2f0184d5df52135f = function(n) {
    var f = $ceJ0M.chunksOf(n);
    return function(as) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $5cc26fbc162a813e$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $5cc26fbc162a813e$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $5cc26fbc162a813e$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $5cc26fbc162a813e$export$a978c53b4062a525(input) ? $5cc26fbc162a813e$export$5b8affa63fc6df16($ceJ0M.head(input), function(a) {
            return go((0, $f5id0.pipe)(scope, $5cc26fbc162a813e$export$10d8903dec122b9d(a)), $ceJ0M.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $5cc26fbc162a813e$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $5cc26fbc162a813e$export$dd1bc94b04021eeb(first) ? $5cc26fbc162a813e$export$784d13d8ee351f07(second) : $5cc26fbc162a813e$export$dd1bc94b04021eeb(second) ? $5cc26fbc162a813e$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $5cc26fbc162a813e$export$ee1b3e54f0441b22 = $5cc26fbc162a813e$export$c8c959650bbe80e2;
function $5cc26fbc162a813e$export$971dd5b0dfd021b6(E) {
    var unionE = $ceJ0M.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $5cc26fbc162a813e$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $5cc26fbc162a813e$export$a978c53b4062a525(first) && $5cc26fbc162a813e$export$a978c53b4062a525(second) ? unionE(second)(first) : $5cc26fbc162a813e$export$a978c53b4062a525(first) ? $5cc26fbc162a813e$export$784d13d8ee351f07(first) : $5cc26fbc162a813e$export$784d13d8ee351f07(second);
    };
}
function $5cc26fbc162a813e$export$bc86dfbf7795668c(E) {
    var elemE = $5cc26fbc162a813e$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $5cc26fbc162a813e$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $5cc26fbc162a813e$export$acaf96a27438246b(E) {
    var elemE = $5cc26fbc162a813e$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $5cc26fbc162a813e$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $5cc26fbc162a813e$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_mapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$8f07ddce13659f50(f));
};
var $5cc26fbc162a813e$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $5cc26fbc162a813e$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_filter = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_filterMap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_partition = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_partitionMap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$228be17d80722ab(that));
};
var $5cc26fbc162a813e$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_foldMap = function(M) {
    var foldMapM = $5cc26fbc162a813e$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $5cc26fbc162a813e$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_filterMapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_extend = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_traverse = function(F) {
    var traverseF = $5cc26fbc162a813e$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $5cc26fbc162a813e$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $5cc26fbc162a813e$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseWithIndexF(f));
    };
};
var $5cc26fbc162a813e$var$_chainRecDepthFirst = $b406R._chainRecDepthFirst;
var $5cc26fbc162a813e$var$_chainRecBreadthFirst = $b406R._chainRecBreadthFirst;
var $5cc26fbc162a813e$export$ba255e9e49e00608 = $ceJ0M.of;
var $5cc26fbc162a813e$export$7f9972325ebfd559 = function() {
    return [];
};
var $5cc26fbc162a813e$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $5cc26fbc162a813e$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $5cc26fbc162a813e$export$5b8affa63fc6df16(function(f) {
        return (0, $f5id0.pipe)(fa, $5cc26fbc162a813e$export$871de8747c9eaa88(f));
    });
};
var $5cc26fbc162a813e$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return (0, $f5id0.pipe)(ma, $5cc26fbc162a813e$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $5cc26fbc162a813e$export$bffa455ba8c619a6 = /*#__PURE__*/ $5cc26fbc162a813e$export$5b8affa63fc6df16((0, $f5id0.identity));
var $5cc26fbc162a813e$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $5cc26fbc162a813e$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($aByOK.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $5cc26fbc162a813e$export$a04c6c6965dd4709 = function(f) {
    return $5cc26fbc162a813e$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $5cc26fbc162a813e$export$8e16b83750b44988 = /*#__PURE__*/ $5cc26fbc162a813e$export$a04c6c6965dd4709((0, $f5id0.identity));
var $5cc26fbc162a813e$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $bFSl4.separated)(left, right);
};
var $5cc26fbc162a813e$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $5cc26fbc162a813e$export$b29f828819edca8d = function(predicate) {
    return $5cc26fbc162a813e$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $5cc26fbc162a813e$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $bFSl4.separated)(left, right);
    };
};
var $5cc26fbc162a813e$export$3117e3f9ececb6bc = function(f) {
    return $5cc26fbc162a813e$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $5cc26fbc162a813e$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $bFSl4.separated)(left, right);
    };
};
var $5cc26fbc162a813e$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $5cc26fbc162a813e$export$228be17d80722ab = $5cc26fbc162a813e$export$1517cca7889d6aaa;
var $5cc26fbc162a813e$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $5cc26fbc162a813e$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $5cc26fbc162a813e$export$ecd5e8ace626722c = /*#__PURE__*/ $5cc26fbc162a813e$export$8b58be045bf06082((0, $f5id0.identity));
var $5cc26fbc162a813e$export$b66cdc0497d8a99a = $b406R.foldMap;
var $5cc26fbc162a813e$export$18153bb1181268e5 = $b406R.foldMapWithIndex;
var $5cc26fbc162a813e$export$533b26079ad0b4b = $b406R.reduce;
var $5cc26fbc162a813e$export$bbd3ef8720e22369 = $b406R.reduceWithIndex;
var $5cc26fbc162a813e$export$7fef8bcdbb34f435 = $b406R.reduceRight;
var $5cc26fbc162a813e$export$ce2b2fe0b88ccd0a = $b406R.reduceRightWithIndex;
var $5cc26fbc162a813e$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $5cc26fbc162a813e$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $5cc26fbc162a813e$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $5cc26fbc162a813e$var$_reduce(ta, F.of($5cc26fbc162a813e$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $f5id0.pipe)(as, $5cc26fbc162a813e$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $5cc26fbc162a813e$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $5cc26fbc162a813e$export$bbd3ef8720e22369(F.of($5cc26fbc162a813e$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $f5id0.pipe)(bs, $5cc26fbc162a813e$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $5cc26fbc162a813e$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $5cc26fbc162a813e$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $5cc26fbc162a813e$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $5cc26fbc162a813e$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $5cc26fbc162a813e$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($aByOK.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $5cc26fbc162a813e$export$9156e739aa33e19f = 'Array';
var $5cc26fbc162a813e$export$3cb5cd7f7776c81 = $b406R.getShow;
var $5cc26fbc162a813e$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $5cc26fbc162a813e$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $5cc26fbc162a813e$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $5cc26fbc162a813e$export$804fed467fde44e4 = $b406R.getEq;
var $5cc26fbc162a813e$export$1af51209b1b91d07 = $b406R.getOrd;
var $5cc26fbc162a813e$export$baca17b4aff42f82 = function(E) {
    var unionE = $5cc26fbc162a813e$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $5cc26fbc162a813e$export$c487aac9f4157837 = function(E) {
    return {
        concat: $5cc26fbc162a813e$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $5cc26fbc162a813e$export$d379a869a72e4055 = function(E) {
    var intersectionE = $5cc26fbc162a813e$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $5cc26fbc162a813e$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $5cc26fbc162a813e$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $5cc26fbc162a813e$export$bd5b6bfc5fa2ee61 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map
};
var $5cc26fbc162a813e$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($5cc26fbc162a813e$export$bd5b6bfc5fa2ee61);
var $5cc26fbc162a813e$export$59a71046037e6c20 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    of: $5cc26fbc162a813e$export$ba255e9e49e00608
};
var $5cc26fbc162a813e$export$9fdffe0fe1e91cad = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    mapWithIndex: $5cc26fbc162a813e$var$_mapWithIndex
};
var $5cc26fbc162a813e$export$efc21ddc6aeb363d = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap
};
var $5cc26fbc162a813e$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($5cc26fbc162a813e$export$efc21ddc6aeb363d);
var $5cc26fbc162a813e$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($5cc26fbc162a813e$export$efc21ddc6aeb363d);
var $5cc26fbc162a813e$export$1279d2b7807629fd = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    of: $5cc26fbc162a813e$export$ba255e9e49e00608
};
var $5cc26fbc162a813e$export$f18d5acc27d70423 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    chain: $5cc26fbc162a813e$export$5b8affa63fc6df16
};
var $5cc26fbc162a813e$export$e3821ef4970c339c = /*#__PURE__*/ (0, $lcDVT.chainFirst)($5cc26fbc162a813e$export$f18d5acc27d70423);
var $5cc26fbc162a813e$export$fb641926d034ac7d = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    of: $5cc26fbc162a813e$export$ba255e9e49e00608,
    chain: $5cc26fbc162a813e$export$5b8affa63fc6df16
};
var $5cc26fbc162a813e$export$8fa953f00d3b093 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    unfold: $5cc26fbc162a813e$export$c48e357c1a89b78d
};
var $5cc26fbc162a813e$export$25ba4469a069167 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    alt: $5cc26fbc162a813e$var$_alt
};
var $5cc26fbc162a813e$export$aaef8a3eae948f03 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    zero: $5cc26fbc162a813e$export$7f9972325ebfd559
};
var $5cc26fbc162a813e$export$864d727b48066337 = /*#__PURE__*/ (0, $gJWAH.guard)($5cc26fbc162a813e$export$aaef8a3eae948f03, $5cc26fbc162a813e$export$59a71046037e6c20);
var $5cc26fbc162a813e$export$4acb47accde578d2 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    of: $5cc26fbc162a813e$export$ba255e9e49e00608,
    alt: $5cc26fbc162a813e$var$_alt,
    zero: $5cc26fbc162a813e$export$7f9972325ebfd559
};
var $5cc26fbc162a813e$export$5b5dd0e212d2a5bc = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    extend: $5cc26fbc162a813e$var$_extend
};
var $5cc26fbc162a813e$export$4a21ac48141ac3c9 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    compact: $5cc26fbc162a813e$export$8e16b83750b44988,
    separate: $5cc26fbc162a813e$export$709f6946f4e97408
};
var $5cc26fbc162a813e$export$d00e1c48fb621173 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    compact: $5cc26fbc162a813e$export$8e16b83750b44988,
    separate: $5cc26fbc162a813e$export$709f6946f4e97408,
    filter: $5cc26fbc162a813e$var$_filter,
    filterMap: $5cc26fbc162a813e$var$_filterMap,
    partition: $5cc26fbc162a813e$var$_partition,
    partitionMap: $5cc26fbc162a813e$var$_partitionMap
};
var $5cc26fbc162a813e$export$c29a647071e542ec = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    mapWithIndex: $5cc26fbc162a813e$var$_mapWithIndex,
    compact: $5cc26fbc162a813e$export$8e16b83750b44988,
    separate: $5cc26fbc162a813e$export$709f6946f4e97408,
    filter: $5cc26fbc162a813e$var$_filter,
    filterMap: $5cc26fbc162a813e$var$_filterMap,
    partition: $5cc26fbc162a813e$var$_partition,
    partitionMap: $5cc26fbc162a813e$var$_partitionMap,
    partitionMapWithIndex: $5cc26fbc162a813e$var$_partitionMapWithIndex,
    partitionWithIndex: $5cc26fbc162a813e$var$_partitionWithIndex,
    filterMapWithIndex: $5cc26fbc162a813e$var$_filterMapWithIndex,
    filterWithIndex: $5cc26fbc162a813e$var$_filterWithIndex
};
var $5cc26fbc162a813e$export$41404b31838667c9 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    reduce: $5cc26fbc162a813e$var$_reduce,
    foldMap: $5cc26fbc162a813e$var$_foldMap,
    reduceRight: $5cc26fbc162a813e$var$_reduceRight
};
var $5cc26fbc162a813e$export$e8f7d17aaff345cb = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    reduce: $5cc26fbc162a813e$var$_reduce,
    foldMap: $5cc26fbc162a813e$var$_foldMap,
    reduceRight: $5cc26fbc162a813e$var$_reduceRight,
    reduceWithIndex: $5cc26fbc162a813e$var$_reduceWithIndex,
    foldMapWithIndex: $5cc26fbc162a813e$var$_foldMapWithIndex,
    reduceRightWithIndex: $5cc26fbc162a813e$var$_reduceRightWithIndex
};
var $5cc26fbc162a813e$export$a0202666c3bda011 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    reduce: $5cc26fbc162a813e$var$_reduce,
    foldMap: $5cc26fbc162a813e$var$_foldMap,
    reduceRight: $5cc26fbc162a813e$var$_reduceRight,
    traverse: $5cc26fbc162a813e$var$_traverse,
    sequence: $5cc26fbc162a813e$export$49bb65c2ea163039
};
var $5cc26fbc162a813e$export$bd7b528d8c36ec41 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    mapWithIndex: $5cc26fbc162a813e$var$_mapWithIndex,
    reduce: $5cc26fbc162a813e$var$_reduce,
    foldMap: $5cc26fbc162a813e$var$_foldMap,
    reduceRight: $5cc26fbc162a813e$var$_reduceRight,
    reduceWithIndex: $5cc26fbc162a813e$var$_reduceWithIndex,
    foldMapWithIndex: $5cc26fbc162a813e$var$_foldMapWithIndex,
    reduceRightWithIndex: $5cc26fbc162a813e$var$_reduceRightWithIndex,
    traverse: $5cc26fbc162a813e$var$_traverse,
    sequence: $5cc26fbc162a813e$export$49bb65c2ea163039,
    traverseWithIndex: $5cc26fbc162a813e$var$_traverseWithIndex
};
var $5cc26fbc162a813e$var$_wither = /*#__PURE__*/ (0, $erGUW.witherDefault)($5cc26fbc162a813e$export$a0202666c3bda011, $5cc26fbc162a813e$export$4a21ac48141ac3c9);
var $5cc26fbc162a813e$var$_wilt = /*#__PURE__*/ (0, $erGUW.wiltDefault)($5cc26fbc162a813e$export$a0202666c3bda011, $5cc26fbc162a813e$export$4a21ac48141ac3c9);
var $5cc26fbc162a813e$export$748d317b4c426f96 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    compact: $5cc26fbc162a813e$export$8e16b83750b44988,
    separate: $5cc26fbc162a813e$export$709f6946f4e97408,
    filter: $5cc26fbc162a813e$var$_filter,
    filterMap: $5cc26fbc162a813e$var$_filterMap,
    partition: $5cc26fbc162a813e$var$_partition,
    partitionMap: $5cc26fbc162a813e$var$_partitionMap,
    reduce: $5cc26fbc162a813e$var$_reduce,
    foldMap: $5cc26fbc162a813e$var$_foldMap,
    reduceRight: $5cc26fbc162a813e$var$_reduceRight,
    traverse: $5cc26fbc162a813e$var$_traverse,
    sequence: $5cc26fbc162a813e$export$49bb65c2ea163039,
    wither: $5cc26fbc162a813e$var$_wither,
    wilt: $5cc26fbc162a813e$var$_wilt
};
var $5cc26fbc162a813e$export$f855115a79f70c1a = $b406R.chainRecDepthFirst;
var $5cc26fbc162a813e$export$7d808dfaa6d54634 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    chain: $5cc26fbc162a813e$export$5b8affa63fc6df16,
    chainRec: $5cc26fbc162a813e$var$_chainRecDepthFirst
};
var $5cc26fbc162a813e$export$bffee57bb00a6859 = $b406R.chainRecBreadthFirst;
var $5cc26fbc162a813e$export$57f3a385c7e59628 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    chain: $5cc26fbc162a813e$export$5b8affa63fc6df16,
    chainRec: $5cc26fbc162a813e$var$_chainRecBreadthFirst
};
var $5cc26fbc162a813e$export$c40604f35db61519 = /*#__PURE__*/ (0, $erGUW.filterE)($5cc26fbc162a813e$export$748d317b4c426f96);
var $5cc26fbc162a813e$export$825ea6cb6fc48d49 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    fromEither: $5cc26fbc162a813e$export$80c878c9b1d77917
};
var $5cc26fbc162a813e$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $ctkBN.fromEitherK)($5cc26fbc162a813e$export$825ea6cb6fc48d49);
var $5cc26fbc162a813e$export$f4863e1822a1860c = $ceJ0M.unsafeInsertAt;
var $5cc26fbc162a813e$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $5cc26fbc162a813e$export$a978c53b4062a525(as) ? $ceJ0M.unsafeUpdateAt(i, a, as) : [];
};
var $5cc26fbc162a813e$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $5cc26fbc162a813e$export$7ecc1a3b11b57dab = $b406R.every;
var $5cc26fbc162a813e$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $5cc26fbc162a813e$export$f7e9f41ea797a17 = $5cc26fbc162a813e$export$ad14ef4001db2bcd;
var $5cc26fbc162a813e$export$739ec22334c44788 = $b406R.intercalate;
var $5cc26fbc162a813e$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $5cc26fbc162a813e$export$ba255e9e49e00608($aByOK.emptyRecord);
var $5cc26fbc162a813e$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($5cc26fbc162a813e$export$bd5b6bfc5fa2ee61);
var $5cc26fbc162a813e$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($5cc26fbc162a813e$export$bd5b6bfc5fa2ee61);
var $5cc26fbc162a813e$export$2385a24977818dd0 = /*#__PURE__*/ (0, $lcDVT.bind)($5cc26fbc162a813e$export$f18d5acc27d70423);
var $5cc26fbc162a813e$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($5cc26fbc162a813e$export$efc21ddc6aeb363d);
var $5cc26fbc162a813e$export$e08e3b67e392101e = $5cc26fbc162a813e$export$5b8affa63fc6df16;
var $5cc26fbc162a813e$export$d02631cccf789723 = $ceJ0M.range;
var $5cc26fbc162a813e$export$6e22c362a0406a2c = [];
var $5cc26fbc162a813e$export$8327ebbef2a0ba76 = $ceJ0M.cons;
var $5cc26fbc162a813e$export$c40cf5aab899f397 = $ceJ0M.snoc;
var $5cc26fbc162a813e$export$baeb00bf1e27e233 = $5cc26fbc162a813e$export$849c7567cbd62acc;
var $5cc26fbc162a813e$export$2f23118c22fb2630 = {
    URI: $5cc26fbc162a813e$export$9156e739aa33e19f,
    compact: $5cc26fbc162a813e$export$8e16b83750b44988,
    separate: $5cc26fbc162a813e$export$709f6946f4e97408,
    map: $5cc26fbc162a813e$var$_map,
    ap: $5cc26fbc162a813e$var$_ap,
    of: $5cc26fbc162a813e$export$ba255e9e49e00608,
    chain: $5cc26fbc162a813e$export$5b8affa63fc6df16,
    filter: $5cc26fbc162a813e$var$_filter,
    filterMap: $5cc26fbc162a813e$var$_filterMap,
    partition: $5cc26fbc162a813e$var$_partition,
    partitionMap: $5cc26fbc162a813e$var$_partitionMap,
    mapWithIndex: $5cc26fbc162a813e$var$_mapWithIndex,
    partitionMapWithIndex: $5cc26fbc162a813e$var$_partitionMapWithIndex,
    partitionWithIndex: $5cc26fbc162a813e$var$_partitionWithIndex,
    filterMapWithIndex: $5cc26fbc162a813e$var$_filterMapWithIndex,
    filterWithIndex: $5cc26fbc162a813e$var$_filterWithIndex,
    alt: $5cc26fbc162a813e$var$_alt,
    zero: $5cc26fbc162a813e$export$7f9972325ebfd559,
    unfold: $5cc26fbc162a813e$export$c48e357c1a89b78d,
    reduce: $5cc26fbc162a813e$var$_reduce,
    foldMap: $5cc26fbc162a813e$var$_foldMap,
    reduceRight: $5cc26fbc162a813e$var$_reduceRight,
    traverse: $5cc26fbc162a813e$var$_traverse,
    sequence: $5cc26fbc162a813e$export$49bb65c2ea163039,
    reduceWithIndex: $5cc26fbc162a813e$var$_reduceWithIndex,
    foldMapWithIndex: $5cc26fbc162a813e$var$_foldMapWithIndex,
    reduceRightWithIndex: $5cc26fbc162a813e$var$_reduceRightWithIndex,
    traverseWithIndex: $5cc26fbc162a813e$var$_traverseWithIndex,
    extend: $5cc26fbc162a813e$var$_extend,
    wither: $5cc26fbc162a813e$var$_wither,
    wilt: $5cc26fbc162a813e$var$_wilt
};

});
parcelRegister("6IQDS", function(module, exports) {

$parcel$export(module.exports, "ap", function () { return $4e4fafc290a0d833$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "apFirst", function () { return $4e4fafc290a0d833$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $4e4fafc290a0d833$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apS", function () { return $4e4fafc290a0d833$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $4e4fafc290a0d833$export$18979a515d2a828e; });
$parcel$export(module.exports, "sequenceT", function () { return $4e4fafc290a0d833$export$6ec24752b7e97e26; });
$parcel$export(module.exports, "sequenceS", function () { return $4e4fafc290a0d833$export$d04bd2c3b28691e; });
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ 
var $f5id0 = parcelRequire("f5id0");

var $aByOK = parcelRequire("aByOK");
function $4e4fafc290a0d833$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $4e4fafc290a0d833$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $4e4fafc290a0d833$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $4e4fafc290a0d833$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $4e4fafc290a0d833$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $4e4fafc290a0d833$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $4e4fafc290a0d833$var$curried(f, n - 1, combined);
    };
}
var $4e4fafc290a0d833$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $4e4fafc290a0d833$var$getTupleConstructor(len) {
    if (!$aByOK.has.call($4e4fafc290a0d833$var$tupleConstructors, len)) $4e4fafc290a0d833$var$tupleConstructors[len] = $4e4fafc290a0d833$var$curried((0, $f5id0.tuple), len - 1, []);
    return $4e4fafc290a0d833$var$tupleConstructors[len];
}
function $4e4fafc290a0d833$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $4e4fafc290a0d833$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $4e4fafc290a0d833$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $4e4fafc290a0d833$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $4e4fafc290a0d833$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $4e4fafc290a0d833$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("aByOK", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $7b885e22bec6ecc0$export$e56af863d5645d5f; });
$parcel$export(module.exports, "isSome", function () { return $7b885e22bec6ecc0$export$5d7e502287836e58; });
$parcel$export(module.exports, "none", function () { return $7b885e22bec6ecc0$export$f883a24d5edde77c; });
$parcel$export(module.exports, "some", function () { return $7b885e22bec6ecc0$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "isLeft", function () { return $7b885e22bec6ecc0$export$d649b6842e09f2b; });
$parcel$export(module.exports, "isRight", function () { return $7b885e22bec6ecc0$export$a9d71693f0c1a85d; });
$parcel$export(module.exports, "left", function () { return $7b885e22bec6ecc0$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $7b885e22bec6ecc0$export$79ffe56a765070d2; });
$parcel$export(module.exports, "singleton", function () { return $7b885e22bec6ecc0$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "isNonEmpty", function () { return $7b885e22bec6ecc0$export$a978c53b4062a525; });
$parcel$export(module.exports, "head", function () { return $7b885e22bec6ecc0$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tail", function () { return $7b885e22bec6ecc0$export$c01875f616615628; });
$parcel$export(module.exports, "emptyReadonlyArray", function () { return $7b885e22bec6ecc0$export$6ca726a2417e0f3f; });
$parcel$export(module.exports, "emptyRecord", function () { return $7b885e22bec6ecc0$export$4de80339753b012b; });
$parcel$export(module.exports, "has", function () { return $7b885e22bec6ecc0$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "fromReadonlyNonEmptyArray", function () { return $7b885e22bec6ecc0$export$7e77326b0f0e268c; });
$parcel$export(module.exports, "liftNullable", function () { return $7b885e22bec6ecc0$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $7b885e22bec6ecc0$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $7b885e22bec6ecc0$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $7b885e22bec6ecc0$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "flatMapEither", function () { return $7b885e22bec6ecc0$export$979f2bb6a976172d; });
$parcel$export(module.exports, "flatMapIO", function () { return $7b885e22bec6ecc0$export$8b635ef81222764c; });
$parcel$export(module.exports, "flatMapTask", function () { return $7b885e22bec6ecc0$export$43849ff3f7ffa51c; });

var $f5id0 = parcelRequire("f5id0");
var $7b885e22bec6ecc0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $7b885e22bec6ecc0$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $7b885e22bec6ecc0$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $7b885e22bec6ecc0$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $7b885e22bec6ecc0$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $7b885e22bec6ecc0$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $7b885e22bec6ecc0$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $7b885e22bec6ecc0$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $7b885e22bec6ecc0$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $7b885e22bec6ecc0$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $7b885e22bec6ecc0$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $7b885e22bec6ecc0$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $7b885e22bec6ecc0$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $7b885e22bec6ecc0$export$6ca726a2417e0f3f = [];
var $7b885e22bec6ecc0$export$4de80339753b012b = {};
var $7b885e22bec6ecc0$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $7b885e22bec6ecc0$export$7e77326b0f0e268c = function(as) {
    return $7b885e22bec6ecc0$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $7b885e22bec6ecc0$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $7b885e22bec6ecc0$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $7b885e22bec6ecc0$export$79ffe56a765070d2(o));
        };
    };
};
var $7b885e22bec6ecc0$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($7b885e22bec6ecc0$export$e56af863d5645d5f(o) ? $7b885e22bec6ecc0$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $7b885e22bec6ecc0$export$79ffe56a765070d2(o.value));
        };
    };
};
var $7b885e22bec6ecc0$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $f5id0.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, $7b885e22bec6ecc0$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $7b885e22bec6ecc0$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $f5id0.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, $7b885e22bec6ecc0$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $7b885e22bec6ecc0$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $f5id0.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $7b885e22bec6ecc0$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $f5id0.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $7b885e22bec6ecc0$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $f5id0.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $7b885e22bec6ecc0$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $f5id0.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

});


parcelRegister("lcDVT", function(module, exports) {

$parcel$export(module.exports, "chainFirst", function () { return $f6f9b1c59578cb19$export$e3821ef4970c339c; });
$parcel$export(module.exports, "tap", function () { return $f6f9b1c59578cb19$export$3f23594af5f37336; });
$parcel$export(module.exports, "bind", function () { return $f6f9b1c59578cb19$export$2385a24977818dd0; });
function $f6f9b1c59578cb19$export$e3821ef4970c339c(M) {
    var tapM = $f6f9b1c59578cb19$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $f6f9b1c59578cb19$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $f6f9b1c59578cb19$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("ctkBN", function(module, exports) {

$parcel$export(module.exports, "fromOption", function () { return $91482def927b34a0$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromPredicate", function () { return $91482def927b34a0$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromOptionK", function () { return $91482def927b34a0$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $91482def927b34a0$export$12d26179deb6a68a; });
$parcel$export(module.exports, "fromEitherK", function () { return $91482def927b34a0$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "chainEitherK", function () { return $91482def927b34a0$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "tapEither", function () { return $91482def927b34a0$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "filterOrElse", function () { return $91482def927b34a0$export$30af8ca9498ddf5b; });
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 
var $lcDVT = parcelRequire("lcDVT");

var $f5id0 = parcelRequire("f5id0");

var $aByOK = parcelRequire("aByOK");
function $91482def927b34a0$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($aByOK.isNone(ma) ? $aByOK.left(onNone()) : $aByOK.right(ma.value));
        };
    };
}
function $91482def927b34a0$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $aByOK.right(a) : $aByOK.left(onFalse(a)));
        };
    };
}
function $91482def927b34a0$export$a907462f448b49f8(F) {
    var fromOptionF = $91482def927b34a0$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $f5id0.flow)(f, from);
        };
    };
}
function $91482def927b34a0$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $91482def927b34a0$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $91482def927b34a0$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $f5id0.flow)(f, F.fromEither);
    };
}
function $91482def927b34a0$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $91482def927b34a0$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $91482def927b34a0$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $91482def927b34a0$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $91482def927b34a0$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $aByOK.right(a) : $aByOK.left(onFalse(a)));
            });
        };
    };
}
function $91482def927b34a0$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $91482def927b34a0$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $lcDVT.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("hrfTw", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $cb21499e22530652$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flap", function () { return $cb21499e22530652$export$18c957606d8bdf09; });
$parcel$export(module.exports, "bindTo", function () { return $cb21499e22530652$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $cb21499e22530652$export$5d537b797c421217; });
$parcel$export(module.exports, "getFunctorComposition", function () { return $cb21499e22530652$export$7b0f6fce42e2b480; });
$parcel$export(module.exports, "as", function () { return $cb21499e22530652$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $cb21499e22530652$export$9284b360ca18a0fd; });
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
var $f5id0 = parcelRequire("f5id0");
function $cb21499e22530652$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $cb21499e22530652$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $cb21499e22530652$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $cb21499e22530652$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $cb21499e22530652$export$7b0f6fce42e2b480(F, G) {
    var _map = $cb21499e22530652$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $f5id0.pipe)(fga, _map(f));
        }
    };
}
function $cb21499e22530652$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $cb21499e22530652$export$9284b360ca18a0fd(F) {
    var asM = $cb21499e22530652$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});

parcelRegister("ceJ0M", function(module, exports) {

$parcel$export(module.exports, "isNonEmpty", function () { return $8e89b530f487a72f$export$a978c53b4062a525; });
$parcel$export(module.exports, "isOutOfBound", function () { return $8e89b530f487a72f$export$2fde0b1c54fc39b9; });
$parcel$export(module.exports, "prependW", function () { return $8e89b530f487a72f$export$c4c4d41eab625797; });
$parcel$export(module.exports, "prepend", function () { return $8e89b530f487a72f$export$68159836694e22c1; });
$parcel$export(module.exports, "appendW", function () { return $8e89b530f487a72f$export$19903a1bf1942f6; });
$parcel$export(module.exports, "append", function () { return $8e89b530f487a72f$export$10d8903dec122b9d; });
$parcel$export(module.exports, "unsafeInsertAt", function () { return $8e89b530f487a72f$export$f4863e1822a1860c; });
$parcel$export(module.exports, "unsafeUpdateAt", function () { return $8e89b530f487a72f$export$9c0c6889b1fa9bfc; });
$parcel$export(module.exports, "uniq", function () { return $8e89b530f487a72f$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "head", function () { return $8e89b530f487a72f$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tail", function () { return $8e89b530f487a72f$export$c01875f616615628; });
$parcel$export(module.exports, "sortBy", function () { return $8e89b530f487a72f$export$b035e44d7bb4278f; });
$parcel$export(module.exports, "union", function () { return $8e89b530f487a72f$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "rotate", function () { return $8e89b530f487a72f$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "splitAt", function () { return $8e89b530f487a72f$export$b0d75975ac0be0e1; });
$parcel$export(module.exports, "makeBy", function () { return $8e89b530f487a72f$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "range", function () { return $8e89b530f487a72f$export$d02631cccf789723; });
$parcel$export(module.exports, "init", function () { return $8e89b530f487a72f$export$2cd8252107eb640b; });
$parcel$export(module.exports, "last", function () { return $8e89b530f487a72f$export$4c7897fafd92b108; });
$parcel$export(module.exports, "of", function () { return $8e89b530f487a72f$export$ba255e9e49e00608; });
$parcel$export(module.exports, "prependAll", function () { return $8e89b530f487a72f$export$849c7567cbd62acc; });
$parcel$export(module.exports, "intersperse", function () { return $8e89b530f487a72f$export$af200dcf8b7cb5de; });
$parcel$export(module.exports, "chop", function () { return $8e89b530f487a72f$export$433fe05b12ba833f; });
$parcel$export(module.exports, "chunksOf", function () { return $8e89b530f487a72f$export$2f0184d5df52135f; });
$parcel$export(module.exports, "cons", function () { return $8e89b530f487a72f$export$8327ebbef2a0ba76; });
$parcel$export(module.exports, "snoc", function () { return $8e89b530f487a72f$export$c40cf5aab899f397; });

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $12uqT = parcelRequire("12uqT");

var $1ECi6 = parcelRequire("1ECi6");
var $8e89b530f487a72f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8e89b530f487a72f$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $8e89b530f487a72f$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $8e89b530f487a72f$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $8e89b530f487a72f$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $8e89b530f487a72f$export$68159836694e22c1 = $8e89b530f487a72f$export$c4c4d41eab625797;
var $8e89b530f487a72f$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $8e89b530f487a72f$var$__spreadArray($8e89b530f487a72f$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $8e89b530f487a72f$export$10d8903dec122b9d = $8e89b530f487a72f$export$19903a1bf1942f6;
var $8e89b530f487a72f$export$f4863e1822a1860c = function(i, a, as) {
    if ($8e89b530f487a72f$export$a978c53b4062a525(as)) {
        var xs = $8e89b530f487a72f$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $8e89b530f487a72f$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $8e89b530f487a72f$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $8e89b530f487a72f$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $8e89b530f487a72f$export$784d13d8ee351f07(as);
        var out = [
            $8e89b530f487a72f$export$5fd5031fecdacec3(as)
        ];
        var rest = $8e89b530f487a72f$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $8e89b530f487a72f$export$b035e44d7bb4278f = function(ords) {
    if ($8e89b530f487a72f$export$a978c53b4062a525(ords)) {
        var M = (0, $12uqT.getMonoid)();
        return $8e89b530f487a72f$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $8e89b530f487a72f$export$784d13d8ee351f07;
};
var $8e89b530f487a72f$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $8e89b530f487a72f$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $f5id0.pipe)(first, $8e89b530f487a72f$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $8e89b530f487a72f$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($8e89b530f487a72f$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $8e89b530f487a72f$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $8e89b530f487a72f$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $f5id0.pipe)(s, $8e89b530f487a72f$export$ee1b3e54f0441b22(f));
        } else return $8e89b530f487a72f$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $8e89b530f487a72f$export$7e77326b0f0e268c = $aByOK.fromReadonlyNonEmptyArray;
var $8e89b530f487a72f$export$571d59b505e6bb4e = function(as) {
    return $8e89b530f487a72f$export$a978c53b4062a525(as) ? $aByOK.some(as) : $aByOK.none;
};
var $8e89b530f487a72f$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $8e89b530f487a72f$export$606959e7ccb797f0 = function(a) {
    return $8e89b530f487a72f$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $8e89b530f487a72f$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $8e89b530f487a72f$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $8e89b530f487a72f$export$c04edabe9c8d994f = function(as) {
    return [
        $8e89b530f487a72f$export$5fd5031fecdacec3(as),
        $8e89b530f487a72f$export$c01875f616615628(as)
    ];
};
var $8e89b530f487a72f$export$89a97afc72a83708 = function(as) {
    return [
        $8e89b530f487a72f$export$2cd8252107eb640b(as),
        $8e89b530f487a72f$export$4c7897fafd92b108(as)
    ];
};
function $8e89b530f487a72f$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $8e89b530f487a72f$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $8e89b530f487a72f$export$66c1ae025e96b4bc = function(as) {
    return $8e89b530f487a72f$var$__spreadArray([
        $8e89b530f487a72f$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $8e89b530f487a72f$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $8e89b530f487a72f$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($aByOK.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $8e89b530f487a72f$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $8e89b530f487a72f$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $aByOK.none : $aByOK.some($8e89b530f487a72f$export$f4863e1822a1860c(i, a, as));
    };
};
var $8e89b530f487a72f$export$b6d8713d53419d4c = function(i, a) {
    return $8e89b530f487a72f$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $8e89b530f487a72f$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $8e89b530f487a72f$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some($8e89b530f487a72f$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $8e89b530f487a72f$export$784d13d8ee351f07 = $8e89b530f487a72f$export$7e77326b0f0e268c;
var $8e89b530f487a72f$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $8e89b530f487a72f$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $8e89b530f487a72f$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $8e89b530f487a72f$export$8901015135f2fb22(bs, as);
    };
    return $8e89b530f487a72f$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $8e89b530f487a72f$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $8e89b530f487a72f$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $8e89b530f487a72f$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $8e89b530f487a72f$export$c01875f616615628(as);
        return $8e89b530f487a72f$export$a978c53b4062a525(rest) ? (0, $f5id0.pipe)(rest, $8e89b530f487a72f$export$849c7567cbd62acc(middle), $8e89b530f487a72f$export$68159836694e22c1($8e89b530f487a72f$export$5fd5031fecdacec3(as))) : $8e89b530f487a72f$export$784d13d8ee351f07(as);
    };
};
var $8e89b530f487a72f$export$18153bb1181268e5 = $1ECi6.foldMapWithIndex;
var $8e89b530f487a72f$export$b66cdc0497d8a99a = $1ECi6.foldMap;
var $8e89b530f487a72f$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $8e89b530f487a72f$export$7e77326b0f0e268c(f(0, $8e89b530f487a72f$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $8e89b530f487a72f$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($8e89b530f487a72f$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $8e89b530f487a72f$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $8e89b530f487a72f$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $f5id0.pipe)(as.slice(1, m), $8e89b530f487a72f$export$68159836694e22c1($8e89b530f487a72f$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $8e89b530f487a72f$export$2f0184d5df52135f = function(n) {
    return $8e89b530f487a72f$export$433fe05b12ba833f($8e89b530f487a72f$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_mapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $8e89b530f487a72f$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_extend = function(wa, f) {
    return (0, $f5id0.pipe)(wa, $8e89b530f487a72f$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_foldMap = function(M) {
    var foldMapM = $8e89b530f487a72f$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_traverse = function(F) {
    var traverseF = $8e89b530f487a72f$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $8e89b530f487a72f$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $8e89b530f487a72f$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $8e89b530f487a72f$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $8e89b530f487a72f$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseWithIndexF(f));
    };
};
var $8e89b530f487a72f$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $f5id0.pipe)(as, $8e89b530f487a72f$export$c8c959650bbe80e2(that()));
    };
};
var $8e89b530f487a72f$export$228be17d80722ab = $8e89b530f487a72f$export$1517cca7889d6aaa;
var $8e89b530f487a72f$export$2f6ca3d3b1f80bf5 = function(as) {
    return $8e89b530f487a72f$export$5b8affa63fc6df16(function(f) {
        return (0, $f5id0.pipe)(as, $8e89b530f487a72f$export$871de8747c9eaa88(f));
    });
};
var $8e89b530f487a72f$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return (0, $f5id0.pipe)(ma, $8e89b530f487a72f$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $8e89b530f487a72f$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $8e89b530f487a72f$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($8e89b530f487a72f$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $8e89b530f487a72f$export$c01875f616615628(next);
        }
        return out;
    };
};
var $8e89b530f487a72f$export$ecd5e8ace626722c = /*#__PURE__*/ $8e89b530f487a72f$export$8b58be045bf06082((0, $f5id0.identity));
var $8e89b530f487a72f$export$bffa455ba8c619a6 = /*#__PURE__*/ $8e89b530f487a72f$export$5b8affa63fc6df16((0, $f5id0.identity));
var $8e89b530f487a72f$export$871de8747c9eaa88 = function(f) {
    return $8e89b530f487a72f$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $8e89b530f487a72f$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $8e89b530f487a72f$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $8e89b530f487a72f$export$533b26079ad0b4b = $1ECi6.reduce;
var $8e89b530f487a72f$export$bbd3ef8720e22369 = $1ECi6.reduceWithIndex;
var $8e89b530f487a72f$export$7fef8bcdbb34f435 = $1ECi6.reduceRight;
var $8e89b530f487a72f$export$ce2b2fe0b88ccd0a = $1ECi6.reduceRightWithIndex;
var $8e89b530f487a72f$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $8e89b530f487a72f$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $8e89b530f487a72f$export$49bb65c2ea163039 = function(F) {
    return $8e89b530f487a72f$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $8e89b530f487a72f$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $8e89b530f487a72f$export$5fd5031fecdacec3(as)), $8e89b530f487a72f$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $f5id0.pipe)(bs, $8e89b530f487a72f$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $8e89b530f487a72f$export$f9380c9a627682d3 = $1ECi6.head;
var $8e89b530f487a72f$export$9156e739aa33e19f = 'NonEmptyArray';
var $8e89b530f487a72f$export$3cb5cd7f7776c81 = $1ECi6.getShow;
var $8e89b530f487a72f$export$e759a9a7f8d04692 = function() {
    return {
        concat: $8e89b530f487a72f$export$ee1b3e54f0441b22
    };
};
var $8e89b530f487a72f$export$804fed467fde44e4 = $1ECi6.getEq;
var $8e89b530f487a72f$export$baca17b4aff42f82 = function(E) {
    var unionE = $8e89b530f487a72f$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $8e89b530f487a72f$export$bd5b6bfc5fa2ee61 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map
};
var $8e89b530f487a72f$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($8e89b530f487a72f$export$bd5b6bfc5fa2ee61);
var $8e89b530f487a72f$export$59a71046037e6c20 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    of: $8e89b530f487a72f$export$ba255e9e49e00608
};
var $8e89b530f487a72f$export$9fdffe0fe1e91cad = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    mapWithIndex: $8e89b530f487a72f$var$_mapWithIndex
};
var $8e89b530f487a72f$export$efc21ddc6aeb363d = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    ap: $8e89b530f487a72f$var$_ap
};
var $8e89b530f487a72f$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($8e89b530f487a72f$export$efc21ddc6aeb363d);
var $8e89b530f487a72f$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($8e89b530f487a72f$export$efc21ddc6aeb363d);
var $8e89b530f487a72f$export$1279d2b7807629fd = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    ap: $8e89b530f487a72f$var$_ap,
    of: $8e89b530f487a72f$export$ba255e9e49e00608
};
var $8e89b530f487a72f$export$f18d5acc27d70423 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    ap: $8e89b530f487a72f$var$_ap,
    chain: $8e89b530f487a72f$export$5b8affa63fc6df16
};
var $8e89b530f487a72f$export$e3821ef4970c339c = /*#__PURE__*/ (0, $lcDVT.chainFirst)($8e89b530f487a72f$export$f18d5acc27d70423);
var $8e89b530f487a72f$export$fb641926d034ac7d = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    ap: $8e89b530f487a72f$var$_ap,
    of: $8e89b530f487a72f$export$ba255e9e49e00608,
    chain: $8e89b530f487a72f$export$5b8affa63fc6df16
};
var $8e89b530f487a72f$export$41404b31838667c9 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    reduce: $8e89b530f487a72f$var$_reduce,
    foldMap: $8e89b530f487a72f$var$_foldMap,
    reduceRight: $8e89b530f487a72f$var$_reduceRight
};
var $8e89b530f487a72f$export$e8f7d17aaff345cb = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    reduce: $8e89b530f487a72f$var$_reduce,
    foldMap: $8e89b530f487a72f$var$_foldMap,
    reduceRight: $8e89b530f487a72f$var$_reduceRight,
    reduceWithIndex: $8e89b530f487a72f$var$_reduceWithIndex,
    foldMapWithIndex: $8e89b530f487a72f$var$_foldMapWithIndex,
    reduceRightWithIndex: $8e89b530f487a72f$var$_reduceRightWithIndex
};
var $8e89b530f487a72f$export$a0202666c3bda011 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    reduce: $8e89b530f487a72f$var$_reduce,
    foldMap: $8e89b530f487a72f$var$_foldMap,
    reduceRight: $8e89b530f487a72f$var$_reduceRight,
    traverse: $8e89b530f487a72f$var$_traverse,
    sequence: $8e89b530f487a72f$export$49bb65c2ea163039
};
var $8e89b530f487a72f$export$bd7b528d8c36ec41 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    mapWithIndex: $8e89b530f487a72f$var$_mapWithIndex,
    reduce: $8e89b530f487a72f$var$_reduce,
    foldMap: $8e89b530f487a72f$var$_foldMap,
    reduceRight: $8e89b530f487a72f$var$_reduceRight,
    traverse: $8e89b530f487a72f$var$_traverse,
    sequence: $8e89b530f487a72f$export$49bb65c2ea163039,
    reduceWithIndex: $8e89b530f487a72f$var$_reduceWithIndex,
    foldMapWithIndex: $8e89b530f487a72f$var$_foldMapWithIndex,
    reduceRightWithIndex: $8e89b530f487a72f$var$_reduceRightWithIndex,
    traverseWithIndex: $8e89b530f487a72f$var$_traverseWithIndex
};
var $8e89b530f487a72f$export$25ba4469a069167 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    alt: $8e89b530f487a72f$var$_alt
};
var $8e89b530f487a72f$export$fdd73124b9f1de36 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    map: $8e89b530f487a72f$var$_map,
    extend: $8e89b530f487a72f$var$_extend,
    extract: $8e89b530f487a72f$export$f9380c9a627682d3
};
var $8e89b530f487a72f$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $8e89b530f487a72f$export$ba255e9e49e00608($aByOK.emptyRecord);
var $8e89b530f487a72f$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($8e89b530f487a72f$export$bd5b6bfc5fa2ee61);
var $8e89b530f487a72f$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($8e89b530f487a72f$export$bd5b6bfc5fa2ee61);
var $8e89b530f487a72f$export$2385a24977818dd0 = /*#__PURE__*/ (0, $lcDVT.bind)($8e89b530f487a72f$export$f18d5acc27d70423);
var $8e89b530f487a72f$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($8e89b530f487a72f$export$efc21ddc6aeb363d);
var $8e89b530f487a72f$export$5fd5031fecdacec3 = $1ECi6.head;
var $8e89b530f487a72f$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $8e89b530f487a72f$export$4c7897fafd92b108 = $1ECi6.last;
var $8e89b530f487a72f$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $8e89b530f487a72f$export$96ec731ed4dcb222 = $1ECi6.min;
var $8e89b530f487a72f$export$8960430cfd85939f = $1ECi6.max;
var $8e89b530f487a72f$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $8e89b530f487a72f$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($8e89b530f487a72f$export$5fd5031fecdacec3(as), $8e89b530f487a72f$export$c01875f616615628(as));
    };
};
var $8e89b530f487a72f$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($8e89b530f487a72f$export$2cd8252107eb640b(as), $8e89b530f487a72f$export$4c7897fafd92b108(as));
    };
};
var $8e89b530f487a72f$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $8e89b530f487a72f$var$__spreadArray([
            f($8e89b530f487a72f$export$5fd5031fecdacec3(as))
        ], $8e89b530f487a72f$export$c01875f616615628(as), true);
    };
};
var $8e89b530f487a72f$export$20ca6ad9f7762931 = function(a) {
    return $8e89b530f487a72f$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $8e89b530f487a72f$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $f5id0.pipe)($8e89b530f487a72f$export$2cd8252107eb640b(as), $8e89b530f487a72f$export$10d8903dec122b9d(f($8e89b530f487a72f$export$4c7897fafd92b108(as))));
    };
};
var $8e89b530f487a72f$export$d3affa0a0a83d946 = function(a) {
    return $8e89b530f487a72f$export$302ad361c463800a(function() {
        return a;
    });
};
var $8e89b530f487a72f$export$739ec22334c44788 = $1ECi6.intercalate;
var $8e89b530f487a72f$export$e08e3b67e392101e = $8e89b530f487a72f$export$5b8affa63fc6df16;
function $8e89b530f487a72f$export$103ce2c0a67e4e61(O) {
    var sortO = $8e89b530f487a72f$export$97db5808d8f88186(O);
    var groupO = $8e89b530f487a72f$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $8e89b530f487a72f$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $8e89b530f487a72f$export$3dea766d36a8935f(predicate) {
    return $8e89b530f487a72f$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $8e89b530f487a72f$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $8e89b530f487a72f$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $8e89b530f487a72f$export$b446f6baa3bb1430 = $8e89b530f487a72f$export$c04edabe9c8d994f;
var $8e89b530f487a72f$export$712962e076096ed4 = $8e89b530f487a72f$export$89a97afc72a83708;
function $8e89b530f487a72f$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $8e89b530f487a72f$export$68159836694e22c1(head) : (0, $f5id0.pipe)(tail, $8e89b530f487a72f$export$68159836694e22c1(head));
}
var $8e89b530f487a72f$export$c40cf5aab899f397 = function(init, end) {
    return (0, $f5id0.pipe)(init, $8e89b530f487a72f$export$10d8903dec122b9d(end));
};
var $8e89b530f487a72f$export$baeb00bf1e27e233 = $8e89b530f487a72f$export$849c7567cbd62acc;
var $8e89b530f487a72f$export$93e2b83da34ff82a = $1ECi6.concatAll;
var $8e89b530f487a72f$export$a5383a53b408af94 = {
    URI: $8e89b530f487a72f$export$9156e739aa33e19f,
    of: $8e89b530f487a72f$export$ba255e9e49e00608,
    map: $8e89b530f487a72f$var$_map,
    mapWithIndex: $8e89b530f487a72f$var$_mapWithIndex,
    ap: $8e89b530f487a72f$var$_ap,
    chain: $8e89b530f487a72f$export$5b8affa63fc6df16,
    extend: $8e89b530f487a72f$var$_extend,
    extract: $8e89b530f487a72f$export$f9380c9a627682d3,
    reduce: $8e89b530f487a72f$var$_reduce,
    foldMap: $8e89b530f487a72f$var$_foldMap,
    reduceRight: $8e89b530f487a72f$var$_reduceRight,
    traverse: $8e89b530f487a72f$var$_traverse,
    sequence: $8e89b530f487a72f$export$49bb65c2ea163039,
    reduceWithIndex: $8e89b530f487a72f$var$_reduceWithIndex,
    foldMapWithIndex: $8e89b530f487a72f$var$_foldMapWithIndex,
    reduceRightWithIndex: $8e89b530f487a72f$var$_reduceRightWithIndex,
    traverseWithIndex: $8e89b530f487a72f$var$_traverseWithIndex,
    alt: $8e89b530f487a72f$var$_alt
};

});
parcelRegister("12uqT", function(module, exports) {

$parcel$export(module.exports, "equalsDefault", function () { return $0c1d95ae3bf26b54$export$19fbc5aa8790347c; });
$parcel$export(module.exports, "fromCompare", function () { return $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd; });
$parcel$export(module.exports, "tuple", function () { return $0c1d95ae3bf26b54$export$65e3907585753458; });
$parcel$export(module.exports, "reverse", function () { return $0c1d95ae3bf26b54$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "contramap", function () { return $0c1d95ae3bf26b54$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "URI", function () { return $0c1d95ae3bf26b54$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getSemigroup", function () { return $0c1d95ae3bf26b54$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $0c1d95ae3bf26b54$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Contravariant", function () { return $0c1d95ae3bf26b54$export$def901a57d5539c3; });
$parcel$export(module.exports, "trivial", function () { return $0c1d95ae3bf26b54$export$e5bb9f0f2dedbef6; });
$parcel$export(module.exports, "equals", function () { return $0c1d95ae3bf26b54$export$e9bab7fafb253603; });
$parcel$export(module.exports, "lt", function () { return $0c1d95ae3bf26b54$export$b961576059b7aeb6; });
$parcel$export(module.exports, "gt", function () { return $0c1d95ae3bf26b54$export$dafeacbfe3530cd9; });
$parcel$export(module.exports, "leq", function () { return $0c1d95ae3bf26b54$export$8c5f3ec5d3a940d; });
$parcel$export(module.exports, "geq", function () { return $0c1d95ae3bf26b54$export$61f00a763551642c; });
$parcel$export(module.exports, "min", function () { return $0c1d95ae3bf26b54$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $0c1d95ae3bf26b54$export$8960430cfd85939f; });
$parcel$export(module.exports, "clamp", function () { return $0c1d95ae3bf26b54$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "between", function () { return $0c1d95ae3bf26b54$export$cf95c51b03f10bae; });
$parcel$export(module.exports, "getTupleOrd", function () { return $0c1d95ae3bf26b54$export$c41db498223b95e9; });
$parcel$export(module.exports, "getDualOrd", function () { return $0c1d95ae3bf26b54$export$35315ebcdff1b05c; });
$parcel$export(module.exports, "ord", function () { return $0c1d95ae3bf26b54$export$ad12338f1fefb50e; });
$parcel$export(module.exports, "ordBoolean", function () { return $0c1d95ae3bf26b54$export$ef759d57a4e44836; });
$parcel$export(module.exports, "ordString", function () { return $0c1d95ae3bf26b54$export$c5f2758e49b2b86a; });
$parcel$export(module.exports, "ordNumber", function () { return $0c1d95ae3bf26b54$export$5ed021ff2336715c; });
$parcel$export(module.exports, "ordDate", function () { return $0c1d95ae3bf26b54$export$722593c82468f9f4; });

var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");
var $0c1d95ae3bf26b54$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $0c1d95ae3bf26b54$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $0c1d95ae3bf26b54$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $0c1d95ae3bf26b54$export$66c1ae025e96b4bc = function(O) {
    return $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $0c1d95ae3bf26b54$var$contramap_ = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0c1d95ae3bf26b54$export$53b696d27ecb7ba7(f));
};
var $0c1d95ae3bf26b54$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $0c1d95ae3bf26b54$export$9156e739aa33e19f = 'Ord';
var $0c1d95ae3bf26b54$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $0c1d95ae3bf26b54$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $0c1d95ae3bf26b54$export$e759a9a7f8d04692().concat,
        empty: $0c1d95ae3bf26b54$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $0c1d95ae3bf26b54$export$def901a57d5539c3 = {
    URI: $0c1d95ae3bf26b54$export$9156e739aa33e19f,
    contramap: $0c1d95ae3bf26b54$var$contramap_
};
var $0c1d95ae3bf26b54$export$e5bb9f0f2dedbef6 = {
    equals: (0, $f5id0.constTrue),
    compare: /*#__PURE__*/ (0, $f5id0.constant)(0)
};
var $0c1d95ae3bf26b54$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $0c1d95ae3bf26b54$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $0c1d95ae3bf26b54$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $0c1d95ae3bf26b54$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $0c1d95ae3bf26b54$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $0c1d95ae3bf26b54$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $0c1d95ae3bf26b54$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $0c1d95ae3bf26b54$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $0c1d95ae3bf26b54$export$96ec731ed4dcb222(O);
    var maxO = $0c1d95ae3bf26b54$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $0c1d95ae3bf26b54$export$cf95c51b03f10bae = function(O) {
    var ltO = $0c1d95ae3bf26b54$export$b961576059b7aeb6(O);
    var gtO = $0c1d95ae3bf26b54$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $0c1d95ae3bf26b54$export$c41db498223b95e9 = $0c1d95ae3bf26b54$export$65e3907585753458;
var $0c1d95ae3bf26b54$export$35315ebcdff1b05c = $0c1d95ae3bf26b54$export$66c1ae025e96b4bc;
var $0c1d95ae3bf26b54$export$ad12338f1fefb50e = $0c1d95ae3bf26b54$export$def901a57d5539c3;
// default compare for primitive types
function $0c1d95ae3bf26b54$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $0c1d95ae3bf26b54$var$strictOrd = {
    equals: (0, $kJAjV.eqStrict).equals,
    compare: $0c1d95ae3bf26b54$var$compare
};
var $0c1d95ae3bf26b54$export$ef759d57a4e44836 = $0c1d95ae3bf26b54$var$strictOrd;
var $0c1d95ae3bf26b54$export$c5f2758e49b2b86a = $0c1d95ae3bf26b54$var$strictOrd;
var $0c1d95ae3bf26b54$export$5ed021ff2336715c = $0c1d95ae3bf26b54$var$strictOrd;
var $0c1d95ae3bf26b54$export$722593c82468f9f4 = /*#__PURE__*/ (0, $f5id0.pipe)($0c1d95ae3bf26b54$export$5ed021ff2336715c, /*#__PURE__*/ $0c1d95ae3bf26b54$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));

});
parcelRegister("kJAjV", function(module, exports) {

$parcel$export(module.exports, "fromEquals", function () { return $f1842f11b553804a$export$fec6acd8d60e8568; });
$parcel$export(module.exports, "struct", function () { return $f1842f11b553804a$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "tuple", function () { return $f1842f11b553804a$export$65e3907585753458; });
$parcel$export(module.exports, "contramap", function () { return $f1842f11b553804a$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "URI", function () { return $f1842f11b553804a$export$9156e739aa33e19f; });
$parcel$export(module.exports, "eqStrict", function () { return $f1842f11b553804a$export$37a88d8211c10fd3; });
$parcel$export(module.exports, "getSemigroup", function () { return $f1842f11b553804a$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $f1842f11b553804a$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Contravariant", function () { return $f1842f11b553804a$export$def901a57d5539c3; });
$parcel$export(module.exports, "getTupleEq", function () { return $f1842f11b553804a$export$1a50cb133a346493; });
$parcel$export(module.exports, "getStructEq", function () { return $f1842f11b553804a$export$b35b2bde1875587a; });
$parcel$export(module.exports, "strictEqual", function () { return $f1842f11b553804a$export$24d177074f8dc6ef; });
$parcel$export(module.exports, "eq", function () { return $f1842f11b553804a$export$9663ddc1cf085b32; });
$parcel$export(module.exports, "eqBoolean", function () { return $f1842f11b553804a$export$d7927e8ffc1afb48; });
$parcel$export(module.exports, "eqString", function () { return $f1842f11b553804a$export$fa624555ca2acbc8; });
$parcel$export(module.exports, "eqNumber", function () { return $f1842f11b553804a$export$e24978670be1e4f3; });
$parcel$export(module.exports, "eqDate", function () { return $f1842f11b553804a$export$4eced57d6183c43d; });

var $f5id0 = parcelRequire("f5id0");
var $f1842f11b553804a$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $f1842f11b553804a$export$8cf3da7c1c9174ea = function(eqs) {
    return $f1842f11b553804a$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $f1842f11b553804a$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $f1842f11b553804a$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $f1842f11b553804a$var$contramap_ = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $f1842f11b553804a$export$53b696d27ecb7ba7(f));
};
var $f1842f11b553804a$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $f1842f11b553804a$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $f1842f11b553804a$export$9156e739aa33e19f = 'Eq';
var $f1842f11b553804a$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $f1842f11b553804a$var$empty = {
    equals: function() {
        return true;
    }
};
var $f1842f11b553804a$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $f1842f11b553804a$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $f1842f11b553804a$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $f1842f11b553804a$export$e759a9a7f8d04692().concat,
        empty: $f1842f11b553804a$var$empty
    };
};
var $f1842f11b553804a$export$def901a57d5539c3 = {
    URI: $f1842f11b553804a$export$9156e739aa33e19f,
    contramap: $f1842f11b553804a$var$contramap_
};
var $f1842f11b553804a$export$1a50cb133a346493 = $f1842f11b553804a$export$65e3907585753458;
var $f1842f11b553804a$export$b35b2bde1875587a = $f1842f11b553804a$export$8cf3da7c1c9174ea;
var $f1842f11b553804a$export$24d177074f8dc6ef = $f1842f11b553804a$export$37a88d8211c10fd3.equals;
var $f1842f11b553804a$export$9663ddc1cf085b32 = $f1842f11b553804a$export$def901a57d5539c3;
var $f1842f11b553804a$export$d7927e8ffc1afb48 = $f1842f11b553804a$export$37a88d8211c10fd3;
var $f1842f11b553804a$export$fa624555ca2acbc8 = $f1842f11b553804a$export$37a88d8211c10fd3;
var $f1842f11b553804a$export$e24978670be1e4f3 = $f1842f11b553804a$export$37a88d8211c10fd3;
var $f1842f11b553804a$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("1ECi6", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $13473aa332f36b40$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "isNonEmpty", function () { return $13473aa332f36b40$export$a978c53b4062a525; });
$parcel$export(module.exports, "isOutOfBound", function () { return $13473aa332f36b40$export$2fde0b1c54fc39b9; });
$parcel$export(module.exports, "prependW", function () { return $13473aa332f36b40$export$c4c4d41eab625797; });
$parcel$export(module.exports, "prepend", function () { return $13473aa332f36b40$export$68159836694e22c1; });
$parcel$export(module.exports, "appendW", function () { return $13473aa332f36b40$export$19903a1bf1942f6; });
$parcel$export(module.exports, "append", function () { return $13473aa332f36b40$export$10d8903dec122b9d; });
$parcel$export(module.exports, "unsafeInsertAt", function () { return $13473aa332f36b40$export$f4863e1822a1860c; });
$parcel$export(module.exports, "unsafeUpdateAt", function () { return $13473aa332f36b40$export$9c0c6889b1fa9bfc; });
$parcel$export(module.exports, "uniq", function () { return $13473aa332f36b40$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "head", function () { return $13473aa332f36b40$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tail", function () { return $13473aa332f36b40$export$c01875f616615628; });
$parcel$export(module.exports, "sortBy", function () { return $13473aa332f36b40$export$b035e44d7bb4278f; });
$parcel$export(module.exports, "sort", function () { return $13473aa332f36b40$export$97db5808d8f88186; });
$parcel$export(module.exports, "union", function () { return $13473aa332f36b40$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "concat", function () { return $13473aa332f36b40$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "rotate", function () { return $13473aa332f36b40$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "splitAt", function () { return $13473aa332f36b40$export$b0d75975ac0be0e1; });
$parcel$export(module.exports, "fromReadonlyArray", function () { return $13473aa332f36b40$export$9288e031f1846591; });
$parcel$export(module.exports, "makeBy", function () { return $13473aa332f36b40$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "replicate", function () { return $13473aa332f36b40$export$606959e7ccb797f0; });
$parcel$export(module.exports, "range", function () { return $13473aa332f36b40$export$d02631cccf789723; });
$parcel$export(module.exports, "unprepend", function () { return $13473aa332f36b40$export$c04edabe9c8d994f; });
$parcel$export(module.exports, "unappend", function () { return $13473aa332f36b40$export$89a97afc72a83708; });
$parcel$export(module.exports, "init", function () { return $13473aa332f36b40$export$2cd8252107eb640b; });
$parcel$export(module.exports, "last", function () { return $13473aa332f36b40$export$4c7897fafd92b108; });
$parcel$export(module.exports, "fromArray", function () { return $13473aa332f36b40$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "concatW", function () { return $13473aa332f36b40$export$c8c959650bbe80e2; });
$parcel$export(module.exports, "reverse", function () { return $13473aa332f36b40$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "group", function () { return $13473aa332f36b40$export$e5e25fbcc1f7affe; });
$parcel$export(module.exports, "groupBy", function () { return $13473aa332f36b40$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "updateAt", function () { return $13473aa332f36b40$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $13473aa332f36b40$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "zipWith", function () { return $13473aa332f36b40$export$b634740ce272acb5; });
$parcel$export(module.exports, "zip", function () { return $13473aa332f36b40$export$8901015135f2fb22; });
$parcel$export(module.exports, "unzip", function () { return $13473aa332f36b40$export$23c8d3f8757cab88; });
$parcel$export(module.exports, "prependAll", function () { return $13473aa332f36b40$export$849c7567cbd62acc; });
$parcel$export(module.exports, "intersperse", function () { return $13473aa332f36b40$export$af200dcf8b7cb5de; });
$parcel$export(module.exports, "chainWithIndex", function () { return $13473aa332f36b40$export$852cd95c2dfc239; });
$parcel$export(module.exports, "chop", function () { return $13473aa332f36b40$export$433fe05b12ba833f; });
$parcel$export(module.exports, "chunksOf", function () { return $13473aa332f36b40$export$2f0184d5df52135f; });
$parcel$export(module.exports, "map", function () { return $13473aa332f36b40$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithIndex", function () { return $13473aa332f36b40$export$8f07ddce13659f50; });
$parcel$export(module.exports, "ap", function () { return $13473aa332f36b40$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "extend", function () { return $13473aa332f36b40$export$8b58be045bf06082; });
$parcel$export(module.exports, "reduce", function () { return $13473aa332f36b40$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $13473aa332f36b40$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $13473aa332f36b40$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $13473aa332f36b40$export$df3f009e3d155b20; });
$parcel$export(module.exports, "alt", function () { return $13473aa332f36b40$export$228be17d80722ab; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $13473aa332f36b40$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $13473aa332f36b40$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $13473aa332f36b40$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "traverseWithIndex", function () { return $13473aa332f36b40$export$955fdc0d24efa249; });
$parcel$export(module.exports, "of", function () { return $13473aa332f36b40$export$ba255e9e49e00608; });
$parcel$export(module.exports, "altW", function () { return $13473aa332f36b40$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "flatMap", function () { return $13473aa332f36b40$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "duplicate", function () { return $13473aa332f36b40$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "flatten", function () { return $13473aa332f36b40$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "sequence", function () { return $13473aa332f36b40$export$49bb65c2ea163039; });
$parcel$export(module.exports, "extract", function () { return $13473aa332f36b40$export$f9380c9a627682d3; });
$parcel$export(module.exports, "URI", function () { return $13473aa332f36b40$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $13473aa332f36b40$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getSemigroup", function () { return $13473aa332f36b40$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getEq", function () { return $13473aa332f36b40$export$804fed467fde44e4; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $13473aa332f36b40$export$baca17b4aff42f82; });
$parcel$export(module.exports, "Functor", function () { return $13473aa332f36b40$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $13473aa332f36b40$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $13473aa332f36b40$export$59a71046037e6c20; });
$parcel$export(module.exports, "FunctorWithIndex", function () { return $13473aa332f36b40$export$9fdffe0fe1e91cad; });
$parcel$export(module.exports, "Apply", function () { return $13473aa332f36b40$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "apFirst", function () { return $13473aa332f36b40$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $13473aa332f36b40$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "Applicative", function () { return $13473aa332f36b40$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $13473aa332f36b40$export$f18d5acc27d70423; });
$parcel$export(module.exports, "chainFirst", function () { return $13473aa332f36b40$export$e3821ef4970c339c; });
$parcel$export(module.exports, "Monad", function () { return $13473aa332f36b40$export$fb641926d034ac7d; });
$parcel$export(module.exports, "Foldable", function () { return $13473aa332f36b40$export$41404b31838667c9; });
$parcel$export(module.exports, "FoldableWithIndex", function () { return $13473aa332f36b40$export$e8f7d17aaff345cb; });
$parcel$export(module.exports, "Traversable", function () { return $13473aa332f36b40$export$a0202666c3bda011; });
$parcel$export(module.exports, "TraversableWithIndex", function () { return $13473aa332f36b40$export$bd7b528d8c36ec41; });
$parcel$export(module.exports, "Alt", function () { return $13473aa332f36b40$export$25ba4469a069167; });
$parcel$export(module.exports, "Comonad", function () { return $13473aa332f36b40$export$fdd73124b9f1de36; });
$parcel$export(module.exports, "Do", function () { return $13473aa332f36b40$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $13473aa332f36b40$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $13473aa332f36b40$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $13473aa332f36b40$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $13473aa332f36b40$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "min", function () { return $13473aa332f36b40$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $13473aa332f36b40$export$8960430cfd85939f; });
$parcel$export(module.exports, "concatAll", function () { return $13473aa332f36b40$export$b314777ae20abca9; });
$parcel$export(module.exports, "matchLeft", function () { return $13473aa332f36b40$export$6280271dfaec4919; });
$parcel$export(module.exports, "matchRight", function () { return $13473aa332f36b40$export$b1cacb83a5c6bd02; });
$parcel$export(module.exports, "modifyHead", function () { return $13473aa332f36b40$export$5c7327d4e64ef2aa; });
$parcel$export(module.exports, "updateHead", function () { return $13473aa332f36b40$export$20ca6ad9f7762931; });
$parcel$export(module.exports, "modifyLast", function () { return $13473aa332f36b40$export$302ad361c463800a; });
$parcel$export(module.exports, "updateLast", function () { return $13473aa332f36b40$export$d3affa0a0a83d946; });
$parcel$export(module.exports, "intercalate", function () { return $13473aa332f36b40$export$739ec22334c44788; });
$parcel$export(module.exports, "chain", function () { return $13473aa332f36b40$export$e08e3b67e392101e; });
$parcel$export(module.exports, "groupSort", function () { return $13473aa332f36b40$export$103ce2c0a67e4e61; });
$parcel$export(module.exports, "filter", function () { return $13473aa332f36b40$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterWithIndex", function () { return $13473aa332f36b40$export$36e42aef19fc7171; });
$parcel$export(module.exports, "uncons", function () { return $13473aa332f36b40$export$b446f6baa3bb1430; });
$parcel$export(module.exports, "unsnoc", function () { return $13473aa332f36b40$export$712962e076096ed4; });
$parcel$export(module.exports, "cons", function () { return $13473aa332f36b40$export$8327ebbef2a0ba76; });
$parcel$export(module.exports, "snoc", function () { return $13473aa332f36b40$export$c40cf5aab899f397; });
$parcel$export(module.exports, "insertAt", function () { return $13473aa332f36b40$export$9f200c4466975173; });
$parcel$export(module.exports, "prependToAll", function () { return $13473aa332f36b40$export$baeb00bf1e27e233; });
$parcel$export(module.exports, "fold", function () { return $13473aa332f36b40$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "readonlyNonEmptyArray", function () { return $13473aa332f36b40$export$3c6c57333e3dca24; });

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $12uqT = parcelRequire("12uqT");

var $i0LNv = parcelRequire("i0LNv");
var $13473aa332f36b40$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $13473aa332f36b40$export$6e22c362a0406a2c = $aByOK.emptyReadonlyArray;
var $13473aa332f36b40$export$a978c53b4062a525 = $aByOK.isNonEmpty;
var $13473aa332f36b40$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $13473aa332f36b40$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $13473aa332f36b40$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $13473aa332f36b40$export$68159836694e22c1 = $13473aa332f36b40$export$c4c4d41eab625797;
var $13473aa332f36b40$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $13473aa332f36b40$var$__spreadArray($13473aa332f36b40$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $13473aa332f36b40$export$10d8903dec122b9d = $13473aa332f36b40$export$19903a1bf1942f6;
var $13473aa332f36b40$export$f4863e1822a1860c = function(i, a, as) {
    if ($13473aa332f36b40$export$a978c53b4062a525(as)) {
        var xs = $aByOK.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $13473aa332f36b40$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $aByOK.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
var $13473aa332f36b40$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $13473aa332f36b40$export$5fd5031fecdacec3(as)
        ];
        var rest = $13473aa332f36b40$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $13473aa332f36b40$export$b035e44d7bb4278f = function(ords) {
    if ($13473aa332f36b40$export$a978c53b4062a525(ords)) {
        var M = (0, $12uqT.getMonoid)();
        return $13473aa332f36b40$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $f5id0.identity;
};
var $13473aa332f36b40$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $13473aa332f36b40$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $f5id0.pipe)(first, $13473aa332f36b40$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $13473aa332f36b40$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($13473aa332f36b40$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $13473aa332f36b40$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $f5id0.pipe)(s, $13473aa332f36b40$export$ee1b3e54f0441b22(f));
        } else return $13473aa332f36b40$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $13473aa332f36b40$export$9288e031f1846591 = function(as) {
    return $13473aa332f36b40$export$a978c53b4062a525(as) ? $aByOK.some(as) : $aByOK.none;
};
var $13473aa332f36b40$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $13473aa332f36b40$export$606959e7ccb797f0 = function(a) {
    return $13473aa332f36b40$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $13473aa332f36b40$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $13473aa332f36b40$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $13473aa332f36b40$export$c04edabe9c8d994f = function(as) {
    return [
        $13473aa332f36b40$export$5fd5031fecdacec3(as),
        $13473aa332f36b40$export$c01875f616615628(as)
    ];
};
var $13473aa332f36b40$export$89a97afc72a83708 = function(as) {
    return [
        $13473aa332f36b40$export$2cd8252107eb640b(as),
        $13473aa332f36b40$export$4c7897fafd92b108(as)
    ];
};
var $13473aa332f36b40$export$571d59b505e6bb4e = function(as) {
    return $13473aa332f36b40$export$9288e031f1846591(as.slice());
};
function $13473aa332f36b40$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $13473aa332f36b40$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $13473aa332f36b40$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $13473aa332f36b40$var$__spreadArray([
        $13473aa332f36b40$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $13473aa332f36b40$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $13473aa332f36b40$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $13473aa332f36b40$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($aByOK.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $13473aa332f36b40$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $13473aa332f36b40$export$b6d8713d53419d4c = function(i, a) {
    return $13473aa332f36b40$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $13473aa332f36b40$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $13473aa332f36b40$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some($13473aa332f36b40$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $13473aa332f36b40$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $13473aa332f36b40$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $13473aa332f36b40$export$8901015135f2fb22(bs, as);
    };
    return $13473aa332f36b40$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $13473aa332f36b40$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $13473aa332f36b40$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $13473aa332f36b40$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $13473aa332f36b40$export$c01875f616615628(as);
        return $13473aa332f36b40$export$a978c53b4062a525(rest) ? (0, $f5id0.pipe)(rest, $13473aa332f36b40$export$849c7567cbd62acc(middle), $13473aa332f36b40$export$68159836694e22c1($13473aa332f36b40$export$5fd5031fecdacec3(as))) : as;
    };
};
var $13473aa332f36b40$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $aByOK.fromReadonlyNonEmptyArray(f(0, $13473aa332f36b40$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $13473aa332f36b40$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($13473aa332f36b40$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $13473aa332f36b40$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $13473aa332f36b40$export$6e22c362a0406a2c
        ] : [
            (0, $f5id0.pipe)(as.slice(1, m), $13473aa332f36b40$export$68159836694e22c1($13473aa332f36b40$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $13473aa332f36b40$export$2f0184d5df52135f = function(n) {
    return $13473aa332f36b40$export$433fe05b12ba833f($13473aa332f36b40$export$b0d75975ac0be0e1(n));
};
var $13473aa332f36b40$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_mapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$8f07ddce13659f50(f));
};
var $13473aa332f36b40$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $13473aa332f36b40$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_extend = function(wa, f) {
    return (0, $f5id0.pipe)(wa, $13473aa332f36b40$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_foldMap = function(M) {
    var foldMapM = $13473aa332f36b40$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_traverse = function(F) {
    var traverseF = $13473aa332f36b40$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $13473aa332f36b40$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $13473aa332f36b40$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $13473aa332f36b40$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $13473aa332f36b40$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseWithIndexF(f));
    };
};
var $13473aa332f36b40$export$ba255e9e49e00608 = $aByOK.singleton;
var $13473aa332f36b40$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $f5id0.pipe)(as, $13473aa332f36b40$export$c8c959650bbe80e2(that()));
    };
};
var $13473aa332f36b40$export$228be17d80722ab = $13473aa332f36b40$export$1517cca7889d6aaa;
var $13473aa332f36b40$export$2f6ca3d3b1f80bf5 = function(as) {
    return $13473aa332f36b40$export$5b8affa63fc6df16(function(f) {
        return (0, $f5id0.pipe)(as, $13473aa332f36b40$export$871de8747c9eaa88(f));
    });
};
var $13473aa332f36b40$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return (0, $f5id0.pipe)(ma, $13473aa332f36b40$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $13473aa332f36b40$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $13473aa332f36b40$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($13473aa332f36b40$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $13473aa332f36b40$export$c01875f616615628(next);
        }
        return out;
    };
};
var $13473aa332f36b40$export$ecd5e8ace626722c = /*#__PURE__*/ $13473aa332f36b40$export$8b58be045bf06082((0, $f5id0.identity));
var $13473aa332f36b40$export$bffa455ba8c619a6 = /*#__PURE__*/ $13473aa332f36b40$export$5b8affa63fc6df16((0, $f5id0.identity));
var $13473aa332f36b40$export$871de8747c9eaa88 = function(f) {
    return $13473aa332f36b40$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $13473aa332f36b40$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $13473aa332f36b40$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $13473aa332f36b40$export$533b26079ad0b4b = function(b, f) {
    return $13473aa332f36b40$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $13473aa332f36b40$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $13473aa332f36b40$export$7fef8bcdbb34f435 = function(b, f) {
    return $13473aa332f36b40$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $13473aa332f36b40$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $13473aa332f36b40$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $13473aa332f36b40$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $13473aa332f36b40$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $13473aa332f36b40$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $13473aa332f36b40$export$49bb65c2ea163039 = function(F) {
    return $13473aa332f36b40$export$955fdc0d24efa249(F)((0, $f5id0.SK));
};
var $13473aa332f36b40$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $13473aa332f36b40$export$5fd5031fecdacec3(as)), $13473aa332f36b40$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $f5id0.pipe)(bs, $13473aa332f36b40$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $13473aa332f36b40$export$f9380c9a627682d3 = $aByOK.head;
var $13473aa332f36b40$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $13473aa332f36b40$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $13473aa332f36b40$export$e759a9a7f8d04692 = function() {
    return {
        concat: $13473aa332f36b40$export$ee1b3e54f0441b22
    };
};
var $13473aa332f36b40$export$804fed467fde44e4 = function(E) {
    return (0, $kJAjV.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $13473aa332f36b40$export$baca17b4aff42f82 = function(E) {
    var unionE = $13473aa332f36b40$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $13473aa332f36b40$export$bd5b6bfc5fa2ee61 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map
};
var $13473aa332f36b40$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($13473aa332f36b40$export$bd5b6bfc5fa2ee61);
var $13473aa332f36b40$export$59a71046037e6c20 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    of: $13473aa332f36b40$export$ba255e9e49e00608
};
var $13473aa332f36b40$export$9fdffe0fe1e91cad = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    mapWithIndex: $13473aa332f36b40$var$_mapWithIndex
};
var $13473aa332f36b40$export$efc21ddc6aeb363d = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    ap: $13473aa332f36b40$var$_ap
};
var $13473aa332f36b40$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($13473aa332f36b40$export$efc21ddc6aeb363d);
var $13473aa332f36b40$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($13473aa332f36b40$export$efc21ddc6aeb363d);
var $13473aa332f36b40$export$1279d2b7807629fd = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    ap: $13473aa332f36b40$var$_ap,
    of: $13473aa332f36b40$export$ba255e9e49e00608
};
var $13473aa332f36b40$export$f18d5acc27d70423 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    ap: $13473aa332f36b40$var$_ap,
    chain: $13473aa332f36b40$export$5b8affa63fc6df16
};
var $13473aa332f36b40$export$e3821ef4970c339c = /*#__PURE__*/ (0, $lcDVT.chainFirst)($13473aa332f36b40$export$f18d5acc27d70423);
var $13473aa332f36b40$export$fb641926d034ac7d = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    ap: $13473aa332f36b40$var$_ap,
    of: $13473aa332f36b40$export$ba255e9e49e00608,
    chain: $13473aa332f36b40$export$5b8affa63fc6df16
};
var $13473aa332f36b40$export$41404b31838667c9 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    reduce: $13473aa332f36b40$var$_reduce,
    foldMap: $13473aa332f36b40$var$_foldMap,
    reduceRight: $13473aa332f36b40$var$_reduceRight
};
var $13473aa332f36b40$export$e8f7d17aaff345cb = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    reduce: $13473aa332f36b40$var$_reduce,
    foldMap: $13473aa332f36b40$var$_foldMap,
    reduceRight: $13473aa332f36b40$var$_reduceRight,
    reduceWithIndex: $13473aa332f36b40$var$_reduceWithIndex,
    foldMapWithIndex: $13473aa332f36b40$var$_foldMapWithIndex,
    reduceRightWithIndex: $13473aa332f36b40$var$_reduceRightWithIndex
};
var $13473aa332f36b40$export$a0202666c3bda011 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    reduce: $13473aa332f36b40$var$_reduce,
    foldMap: $13473aa332f36b40$var$_foldMap,
    reduceRight: $13473aa332f36b40$var$_reduceRight,
    traverse: $13473aa332f36b40$var$_traverse,
    sequence: $13473aa332f36b40$export$49bb65c2ea163039
};
var $13473aa332f36b40$export$bd7b528d8c36ec41 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    mapWithIndex: $13473aa332f36b40$var$_mapWithIndex,
    reduce: $13473aa332f36b40$var$_reduce,
    foldMap: $13473aa332f36b40$var$_foldMap,
    reduceRight: $13473aa332f36b40$var$_reduceRight,
    traverse: $13473aa332f36b40$var$_traverse,
    sequence: $13473aa332f36b40$export$49bb65c2ea163039,
    reduceWithIndex: $13473aa332f36b40$var$_reduceWithIndex,
    foldMapWithIndex: $13473aa332f36b40$var$_foldMapWithIndex,
    reduceRightWithIndex: $13473aa332f36b40$var$_reduceRightWithIndex,
    traverseWithIndex: $13473aa332f36b40$var$_traverseWithIndex
};
var $13473aa332f36b40$export$25ba4469a069167 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    alt: $13473aa332f36b40$var$_alt
};
var $13473aa332f36b40$export$fdd73124b9f1de36 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    map: $13473aa332f36b40$var$_map,
    extend: $13473aa332f36b40$var$_extend,
    extract: $13473aa332f36b40$export$f9380c9a627682d3
};
var $13473aa332f36b40$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $13473aa332f36b40$export$ba255e9e49e00608($aByOK.emptyRecord);
var $13473aa332f36b40$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($13473aa332f36b40$export$bd5b6bfc5fa2ee61);
var $13473aa332f36b40$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($13473aa332f36b40$export$bd5b6bfc5fa2ee61);
var $13473aa332f36b40$export$2385a24977818dd0 = /*#__PURE__*/ (0, $lcDVT.bind)($13473aa332f36b40$export$f18d5acc27d70423);
var $13473aa332f36b40$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($13473aa332f36b40$export$efc21ddc6aeb363d);
var $13473aa332f36b40$export$5fd5031fecdacec3 = $13473aa332f36b40$export$f9380c9a627682d3;
var $13473aa332f36b40$export$c01875f616615628 = $aByOK.tail;
var $13473aa332f36b40$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $13473aa332f36b40$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $13473aa332f36b40$export$96ec731ed4dcb222 = function(O) {
    var S = $i0LNv.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $13473aa332f36b40$export$8960430cfd85939f = function(O) {
    var S = $i0LNv.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $13473aa332f36b40$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $13473aa332f36b40$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($13473aa332f36b40$export$5fd5031fecdacec3(as), $13473aa332f36b40$export$c01875f616615628(as));
    };
};
var $13473aa332f36b40$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($13473aa332f36b40$export$2cd8252107eb640b(as), $13473aa332f36b40$export$4c7897fafd92b108(as));
    };
};
var $13473aa332f36b40$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $13473aa332f36b40$var$__spreadArray([
            f($13473aa332f36b40$export$5fd5031fecdacec3(as))
        ], $13473aa332f36b40$export$c01875f616615628(as), true);
    };
};
var $13473aa332f36b40$export$20ca6ad9f7762931 = function(a) {
    return $13473aa332f36b40$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $13473aa332f36b40$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $f5id0.pipe)($13473aa332f36b40$export$2cd8252107eb640b(as), $13473aa332f36b40$export$10d8903dec122b9d(f($13473aa332f36b40$export$4c7897fafd92b108(as))));
    };
};
var $13473aa332f36b40$export$d3affa0a0a83d946 = function(a) {
    return $13473aa332f36b40$export$302ad361c463800a(function() {
        return a;
    });
};
var $13473aa332f36b40$export$739ec22334c44788 = function(S) {
    var concatAllS = $13473aa332f36b40$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $f5id0.flow)($13473aa332f36b40$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $13473aa332f36b40$export$e08e3b67e392101e = $13473aa332f36b40$export$5b8affa63fc6df16;
function $13473aa332f36b40$export$103ce2c0a67e4e61(O) {
    var sortO = $13473aa332f36b40$export$97db5808d8f88186(O);
    var groupO = $13473aa332f36b40$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $13473aa332f36b40$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $13473aa332f36b40$export$6e22c362a0406a2c;
    };
}
function $13473aa332f36b40$export$3dea766d36a8935f(predicate) {
    return $13473aa332f36b40$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $13473aa332f36b40$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $13473aa332f36b40$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $13473aa332f36b40$export$b446f6baa3bb1430 = $13473aa332f36b40$export$c04edabe9c8d994f;
var $13473aa332f36b40$export$712962e076096ed4 = $13473aa332f36b40$export$89a97afc72a83708;
function $13473aa332f36b40$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $13473aa332f36b40$export$68159836694e22c1(head) : (0, $f5id0.pipe)(tail, $13473aa332f36b40$export$68159836694e22c1(head));
}
var $13473aa332f36b40$export$c40cf5aab899f397 = function(init, end) {
    return (0, $f5id0.pipe)(init, $13473aa332f36b40$export$ee1b3e54f0441b22([
        end
    ]));
};
var $13473aa332f36b40$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $aByOK.none : $aByOK.some($13473aa332f36b40$export$f4863e1822a1860c(i, a, as));
    };
};
var $13473aa332f36b40$export$baeb00bf1e27e233 = $13473aa332f36b40$export$849c7567cbd62acc;
var $13473aa332f36b40$export$93e2b83da34ff82a = $13473aa332f36b40$export$b314777ae20abca9;
var $13473aa332f36b40$export$3c6c57333e3dca24 = {
    URI: $13473aa332f36b40$export$9156e739aa33e19f,
    of: $13473aa332f36b40$export$ba255e9e49e00608,
    map: $13473aa332f36b40$var$_map,
    mapWithIndex: $13473aa332f36b40$var$_mapWithIndex,
    ap: $13473aa332f36b40$var$_ap,
    chain: $13473aa332f36b40$export$5b8affa63fc6df16,
    extend: $13473aa332f36b40$var$_extend,
    extract: $13473aa332f36b40$export$f9380c9a627682d3,
    reduce: $13473aa332f36b40$var$_reduce,
    foldMap: $13473aa332f36b40$var$_foldMap,
    reduceRight: $13473aa332f36b40$var$_reduceRight,
    traverse: $13473aa332f36b40$var$_traverse,
    sequence: $13473aa332f36b40$export$49bb65c2ea163039,
    reduceWithIndex: $13473aa332f36b40$var$_reduceWithIndex,
    foldMapWithIndex: $13473aa332f36b40$var$_foldMapWithIndex,
    reduceRightWithIndex: $13473aa332f36b40$var$_reduceRightWithIndex,
    traverseWithIndex: $13473aa332f36b40$var$_traverseWithIndex,
    alt: $13473aa332f36b40$var$_alt
};

});
parcelRegister("i0LNv", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $d1cd4dac5dfcbd98$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $d1cd4dac5dfcbd98$export$8960430cfd85939f; });
$parcel$export(module.exports, "constant", function () { return $d1cd4dac5dfcbd98$export$c983f826f44ff86; });
$parcel$export(module.exports, "reverse", function () { return $d1cd4dac5dfcbd98$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "struct", function () { return $d1cd4dac5dfcbd98$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "tuple", function () { return $d1cd4dac5dfcbd98$export$65e3907585753458; });
$parcel$export(module.exports, "intercalate", function () { return $d1cd4dac5dfcbd98$export$739ec22334c44788; });
$parcel$export(module.exports, "first", function () { return $d1cd4dac5dfcbd98$export$43128fadae87b74a; });
$parcel$export(module.exports, "last", function () { return $d1cd4dac5dfcbd98$export$4c7897fafd92b108; });
$parcel$export(module.exports, "concatAll", function () { return $d1cd4dac5dfcbd98$export$b314777ae20abca9; });
$parcel$export(module.exports, "semigroupVoid", function () { return $d1cd4dac5dfcbd98$export$36aabcd6b6e45f3b; });
$parcel$export(module.exports, "getObjectSemigroup", function () { return $d1cd4dac5dfcbd98$export$2f965793fef2fb8a; });
$parcel$export(module.exports, "getLastSemigroup", function () { return $d1cd4dac5dfcbd98$export$edb0acd3f464ffc5; });
$parcel$export(module.exports, "getFirstSemigroup", function () { return $d1cd4dac5dfcbd98$export$84a57d7a8bf6c3ea; });
$parcel$export(module.exports, "getTupleSemigroup", function () { return $d1cd4dac5dfcbd98$export$bd94daf2735ef9c; });
$parcel$export(module.exports, "getStructSemigroup", function () { return $d1cd4dac5dfcbd98$export$98d1814f8ed74e13; });
$parcel$export(module.exports, "getDualSemigroup", function () { return $d1cd4dac5dfcbd98$export$e0cea6c43ec66a1; });
$parcel$export(module.exports, "getJoinSemigroup", function () { return $d1cd4dac5dfcbd98$export$4278e54cd9769e6d; });
$parcel$export(module.exports, "getMeetSemigroup", function () { return $d1cd4dac5dfcbd98$export$7baccd77d16d1a41; });
$parcel$export(module.exports, "getIntercalateSemigroup", function () { return $d1cd4dac5dfcbd98$export$fcc2cca196b2daf0; });
$parcel$export(module.exports, "fold", function () { return $d1cd4dac5dfcbd98$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "semigroupAll", function () { return $d1cd4dac5dfcbd98$export$e8f9875ab703bdff; });
$parcel$export(module.exports, "semigroupAny", function () { return $d1cd4dac5dfcbd98$export$9511aba5be5ac81b; });
$parcel$export(module.exports, "getFunctionSemigroup", function () { return $d1cd4dac5dfcbd98$export$b2ecf5de014857c2; });
$parcel$export(module.exports, "semigroupString", function () { return $d1cd4dac5dfcbd98$export$d9b7100b101f2c5b; });
$parcel$export(module.exports, "semigroupSum", function () { return $d1cd4dac5dfcbd98$export$1481126044ad2de0; });
$parcel$export(module.exports, "semigroupProduct", function () { return $d1cd4dac5dfcbd98$export$a22a2283cc3aa839; });
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 
var $f5id0 = parcelRequire("f5id0");

var $aByOK = parcelRequire("aByOK");

var $krKBY = parcelRequire("krKBY");

var $12uqT = parcelRequire("12uqT");
var $d1cd4dac5dfcbd98$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $12uqT.min(O)
    };
};
var $d1cd4dac5dfcbd98$export$8960430cfd85939f = function(O) {
    return {
        concat: $12uqT.max(O)
    };
};
var $d1cd4dac5dfcbd98$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $d1cd4dac5dfcbd98$export$66c1ae025e96b4bc = $krKBY.reverse;
var $d1cd4dac5dfcbd98$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($aByOK.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $d1cd4dac5dfcbd98$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $d1cd4dac5dfcbd98$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $d1cd4dac5dfcbd98$export$43128fadae87b74a = function() {
    return {
        concat: (0, $f5id0.identity)
    };
};
var $d1cd4dac5dfcbd98$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $d1cd4dac5dfcbd98$export$b314777ae20abca9 = $krKBY.concatAll;
var $d1cd4dac5dfcbd98$export$36aabcd6b6e45f3b = $d1cd4dac5dfcbd98$export$c983f826f44ff86(undefined);
var $d1cd4dac5dfcbd98$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $d1cd4dac5dfcbd98$export$edb0acd3f464ffc5 = $d1cd4dac5dfcbd98$export$4c7897fafd92b108;
var $d1cd4dac5dfcbd98$export$84a57d7a8bf6c3ea = $d1cd4dac5dfcbd98$export$43128fadae87b74a;
var $d1cd4dac5dfcbd98$export$bd94daf2735ef9c = $d1cd4dac5dfcbd98$export$65e3907585753458;
var $d1cd4dac5dfcbd98$export$98d1814f8ed74e13 = $d1cd4dac5dfcbd98$export$8cf3da7c1c9174ea;
var $d1cd4dac5dfcbd98$export$e0cea6c43ec66a1 = $d1cd4dac5dfcbd98$export$66c1ae025e96b4bc;
var $d1cd4dac5dfcbd98$export$4278e54cd9769e6d = $d1cd4dac5dfcbd98$export$8960430cfd85939f;
var $d1cd4dac5dfcbd98$export$7baccd77d16d1a41 = $d1cd4dac5dfcbd98$export$96ec731ed4dcb222;
var $d1cd4dac5dfcbd98$export$fcc2cca196b2daf0 = $d1cd4dac5dfcbd98$export$739ec22334c44788;
function $d1cd4dac5dfcbd98$export$93e2b83da34ff82a(S) {
    var concatAllS = $d1cd4dac5dfcbd98$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $d1cd4dac5dfcbd98$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $d1cd4dac5dfcbd98$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $d1cd4dac5dfcbd98$export$b2ecf5de014857c2 = (0, $f5id0.getSemigroup);
var $d1cd4dac5dfcbd98$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $d1cd4dac5dfcbd98$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $d1cd4dac5dfcbd98$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("krKBY", function(module, exports) {

$parcel$export(module.exports, "reverse", function () { return $ee2a7c50b4792955$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "concatAll", function () { return $ee2a7c50b4792955$export$b314777ae20abca9; });
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $ee2a7c50b4792955$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $ee2a7c50b4792955$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $ee2a7c50b4792955$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $ee2a7c50b4792955$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $ee2a7c50b4792955$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};

});




parcelRegister("b406R", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $80e0273671c816f5$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "isNonEmpty", function () { return $80e0273671c816f5$export$a978c53b4062a525; });
$parcel$export(module.exports, "prepend", function () { return $80e0273671c816f5$export$68159836694e22c1; });
$parcel$export(module.exports, "prependW", function () { return $80e0273671c816f5$export$c4c4d41eab625797; });
$parcel$export(module.exports, "append", function () { return $80e0273671c816f5$export$10d8903dec122b9d; });
$parcel$export(module.exports, "appendW", function () { return $80e0273671c816f5$export$19903a1bf1942f6; });
$parcel$export(module.exports, "makeBy", function () { return $80e0273671c816f5$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "empty", function () { return $80e0273671c816f5$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "replicate", function () { return $80e0273671c816f5$export$606959e7ccb797f0; });
$parcel$export(module.exports, "fromPredicate", function () { return $80e0273671c816f5$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromOption", function () { return $80e0273671c816f5$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromEither", function () { return $80e0273671c816f5$export$80c878c9b1d77917; });
$parcel$export(module.exports, "matchW", function () { return $80e0273671c816f5$export$2d55ea551c238330; });
$parcel$export(module.exports, "match", function () { return $80e0273671c816f5$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchLeftW", function () { return $80e0273671c816f5$export$ebbe93aa91e3abdc; });
$parcel$export(module.exports, "matchLeft", function () { return $80e0273671c816f5$export$6280271dfaec4919; });
$parcel$export(module.exports, "foldLeft", function () { return $80e0273671c816f5$export$f3163a37d0ef5927; });
$parcel$export(module.exports, "matchRightW", function () { return $80e0273671c816f5$export$364f7f2cc8473008; });
$parcel$export(module.exports, "matchRight", function () { return $80e0273671c816f5$export$b1cacb83a5c6bd02; });
$parcel$export(module.exports, "foldRight", function () { return $80e0273671c816f5$export$77fa89c00b331c4c; });
$parcel$export(module.exports, "chainWithIndex", function () { return $80e0273671c816f5$export$852cd95c2dfc239; });
$parcel$export(module.exports, "scanLeft", function () { return $80e0273671c816f5$export$555ac70de528b074; });
$parcel$export(module.exports, "scanRight", function () { return $80e0273671c816f5$export$d799959bdf780177; });
$parcel$export(module.exports, "size", function () { return $80e0273671c816f5$export$346677f925de839c; });
$parcel$export(module.exports, "isOutOfBound", function () { return $80e0273671c816f5$export$2fde0b1c54fc39b9; });
$parcel$export(module.exports, "lookup", function () { return $80e0273671c816f5$export$dfc7155ac0343b8; });
$parcel$export(module.exports, "head", function () { return $80e0273671c816f5$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "last", function () { return $80e0273671c816f5$export$4c7897fafd92b108; });
$parcel$export(module.exports, "tail", function () { return $80e0273671c816f5$export$c01875f616615628; });
$parcel$export(module.exports, "init", function () { return $80e0273671c816f5$export$2cd8252107eb640b; });
$parcel$export(module.exports, "takeLeft", function () { return $80e0273671c816f5$export$8ea13dbc737d576b; });
$parcel$export(module.exports, "takeRight", function () { return $80e0273671c816f5$export$1bbc425ddca7f2c6; });
$parcel$export(module.exports, "takeLeftWhile", function () { return $80e0273671c816f5$export$5b0b82239a6f6d94; });
$parcel$export(module.exports, "spanLeft", function () { return $80e0273671c816f5$export$104948d9b1d3fb14; });
$parcel$export(module.exports, "splitAt", function () { return $80e0273671c816f5$export$b0d75975ac0be0e1; });
$parcel$export(module.exports, "dropLeft", function () { return $80e0273671c816f5$export$738250583454396; });
$parcel$export(module.exports, "dropRight", function () { return $80e0273671c816f5$export$6ba801e3e123536e; });
$parcel$export(module.exports, "dropLeftWhile", function () { return $80e0273671c816f5$export$d265ccd398ee49c9; });
$parcel$export(module.exports, "findIndex", function () { return $80e0273671c816f5$export$de3a4d4a0d731119; });
$parcel$export(module.exports, "findFirst", function () { return $80e0273671c816f5$export$9a2f228bed5035c2; });
$parcel$export(module.exports, "findFirstMap", function () { return $80e0273671c816f5$export$a86c11c94d794a95; });
$parcel$export(module.exports, "findLast", function () { return $80e0273671c816f5$export$296de88ccac4bedb; });
$parcel$export(module.exports, "findLastMap", function () { return $80e0273671c816f5$export$8b5e6d6ad82284fa; });
$parcel$export(module.exports, "findLastIndex", function () { return $80e0273671c816f5$export$8855a8be7bd3e9f8; });
$parcel$export(module.exports, "insertAt", function () { return $80e0273671c816f5$export$9f200c4466975173; });
$parcel$export(module.exports, "updateAt", function () { return $80e0273671c816f5$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $80e0273671c816f5$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "deleteAt", function () { return $80e0273671c816f5$export$90f9093465da3136; });
$parcel$export(module.exports, "unsafeDeleteAt", function () { return $80e0273671c816f5$export$4937fde8dfc38dbd; });
$parcel$export(module.exports, "unsafeUpdateAt", function () { return $80e0273671c816f5$export$9c0c6889b1fa9bfc; });
$parcel$export(module.exports, "reverse", function () { return $80e0273671c816f5$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "rights", function () { return $80e0273671c816f5$export$cae945d60b6cbe50; });
$parcel$export(module.exports, "lefts", function () { return $80e0273671c816f5$export$837c95301ebad184; });
$parcel$export(module.exports, "sort", function () { return $80e0273671c816f5$export$97db5808d8f88186; });
$parcel$export(module.exports, "zipWith", function () { return $80e0273671c816f5$export$b634740ce272acb5; });
$parcel$export(module.exports, "zip", function () { return $80e0273671c816f5$export$8901015135f2fb22; });
$parcel$export(module.exports, "unzip", function () { return $80e0273671c816f5$export$23c8d3f8757cab88; });
$parcel$export(module.exports, "prependAll", function () { return $80e0273671c816f5$export$849c7567cbd62acc; });
$parcel$export(module.exports, "intersperse", function () { return $80e0273671c816f5$export$af200dcf8b7cb5de; });
$parcel$export(module.exports, "rotate", function () { return $80e0273671c816f5$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "elem", function () { return $80e0273671c816f5$export$5bf96401662340b7; });
$parcel$export(module.exports, "uniq", function () { return $80e0273671c816f5$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "sortBy", function () { return $80e0273671c816f5$export$b035e44d7bb4278f; });
$parcel$export(module.exports, "chop", function () { return $80e0273671c816f5$export$433fe05b12ba833f; });
$parcel$export(module.exports, "chunksOf", function () { return $80e0273671c816f5$export$2f0184d5df52135f; });
$parcel$export(module.exports, "fromOptionK", function () { return $80e0273671c816f5$export$a907462f448b49f8; });
$parcel$export(module.exports, "comprehension", function () { return $80e0273671c816f5$export$105c199d42fdf965; });
$parcel$export(module.exports, "flatMap", function () { return $80e0273671c816f5$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "concatW", function () { return $80e0273671c816f5$export$c8c959650bbe80e2; });
$parcel$export(module.exports, "concat", function () { return $80e0273671c816f5$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "union", function () { return $80e0273671c816f5$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersection", function () { return $80e0273671c816f5$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "difference", function () { return $80e0273671c816f5$export$acaf96a27438246b; });
$parcel$export(module.exports, "map", function () { return $80e0273671c816f5$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithIndex", function () { return $80e0273671c816f5$export$8f07ddce13659f50; });
$parcel$export(module.exports, "ap", function () { return $80e0273671c816f5$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "filter", function () { return $80e0273671c816f5$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $80e0273671c816f5$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "partition", function () { return $80e0273671c816f5$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $80e0273671c816f5$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "partitionWithIndex", function () { return $80e0273671c816f5$export$dad5e500f2bab9bc; });
$parcel$export(module.exports, "partitionMapWithIndex", function () { return $80e0273671c816f5$export$bc7c0794b9c6f3ba; });
$parcel$export(module.exports, "alt", function () { return $80e0273671c816f5$export$228be17d80722ab; });
$parcel$export(module.exports, "reduce", function () { return $80e0273671c816f5$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $80e0273671c816f5$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $80e0273671c816f5$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $80e0273671c816f5$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $80e0273671c816f5$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $80e0273671c816f5$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "filterMapWithIndex", function () { return $80e0273671c816f5$export$30c5cbe848021e97; });
$parcel$export(module.exports, "filterWithIndex", function () { return $80e0273671c816f5$export$36e42aef19fc7171; });
$parcel$export(module.exports, "extend", function () { return $80e0273671c816f5$export$8b58be045bf06082; });
$parcel$export(module.exports, "traverse", function () { return $80e0273671c816f5$export$df3f009e3d155b20; });
$parcel$export(module.exports, "traverseWithIndex", function () { return $80e0273671c816f5$export$955fdc0d24efa249; });
$parcel$export(module.exports, "_chainRecDepthFirst", function () { return $80e0273671c816f5$export$c5c44f872d8af73; });
$parcel$export(module.exports, "chainRecDepthFirst", function () { return $80e0273671c816f5$export$f855115a79f70c1a; });
$parcel$export(module.exports, "_chainRecBreadthFirst", function () { return $80e0273671c816f5$export$b9909b62ceeab991; });
$parcel$export(module.exports, "chainRecBreadthFirst", function () { return $80e0273671c816f5$export$bffee57bb00a6859; });
$parcel$export(module.exports, "of", function () { return $80e0273671c816f5$export$ba255e9e49e00608; });
$parcel$export(module.exports, "zero", function () { return $80e0273671c816f5$export$7f9972325ebfd559; });
$parcel$export(module.exports, "altW", function () { return $80e0273671c816f5$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "flatten", function () { return $80e0273671c816f5$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "separate", function () { return $80e0273671c816f5$export$709f6946f4e97408; });
$parcel$export(module.exports, "compact", function () { return $80e0273671c816f5$export$8e16b83750b44988; });
$parcel$export(module.exports, "duplicate", function () { return $80e0273671c816f5$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "sequence", function () { return $80e0273671c816f5$export$49bb65c2ea163039; });
$parcel$export(module.exports, "wither", function () { return $80e0273671c816f5$export$6c36d01819ecdb31; });
$parcel$export(module.exports, "wilt", function () { return $80e0273671c816f5$export$2439a3bc02b13b03; });
$parcel$export(module.exports, "unfold", function () { return $80e0273671c816f5$export$c48e357c1a89b78d; });
$parcel$export(module.exports, "URI", function () { return $80e0273671c816f5$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $80e0273671c816f5$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getSemigroup", function () { return $80e0273671c816f5$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $80e0273671c816f5$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "getEq", function () { return $80e0273671c816f5$export$804fed467fde44e4; });
$parcel$export(module.exports, "getOrd", function () { return $80e0273671c816f5$export$1af51209b1b91d07; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $80e0273671c816f5$export$baca17b4aff42f82; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $80e0273671c816f5$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $80e0273671c816f5$export$d379a869a72e4055; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $80e0273671c816f5$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "Functor", function () { return $80e0273671c816f5$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $80e0273671c816f5$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $80e0273671c816f5$export$59a71046037e6c20; });
$parcel$export(module.exports, "FunctorWithIndex", function () { return $80e0273671c816f5$export$9fdffe0fe1e91cad; });
$parcel$export(module.exports, "Apply", function () { return $80e0273671c816f5$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "apFirst", function () { return $80e0273671c816f5$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $80e0273671c816f5$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "Applicative", function () { return $80e0273671c816f5$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $80e0273671c816f5$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $80e0273671c816f5$export$fb641926d034ac7d; });
$parcel$export(module.exports, "chainFirst", function () { return $80e0273671c816f5$export$e3821ef4970c339c; });
$parcel$export(module.exports, "Unfoldable", function () { return $80e0273671c816f5$export$8fa953f00d3b093; });
$parcel$export(module.exports, "Alt", function () { return $80e0273671c816f5$export$25ba4469a069167; });
$parcel$export(module.exports, "Zero", function () { return $80e0273671c816f5$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "guard", function () { return $80e0273671c816f5$export$864d727b48066337; });
$parcel$export(module.exports, "Alternative", function () { return $80e0273671c816f5$export$4acb47accde578d2; });
$parcel$export(module.exports, "Extend", function () { return $80e0273671c816f5$export$5b5dd0e212d2a5bc; });
$parcel$export(module.exports, "Compactable", function () { return $80e0273671c816f5$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $80e0273671c816f5$export$d00e1c48fb621173; });
$parcel$export(module.exports, "FilterableWithIndex", function () { return $80e0273671c816f5$export$c29a647071e542ec; });
$parcel$export(module.exports, "Foldable", function () { return $80e0273671c816f5$export$41404b31838667c9; });
$parcel$export(module.exports, "FoldableWithIndex", function () { return $80e0273671c816f5$export$e8f7d17aaff345cb; });
$parcel$export(module.exports, "Traversable", function () { return $80e0273671c816f5$export$a0202666c3bda011; });
$parcel$export(module.exports, "TraversableWithIndex", function () { return $80e0273671c816f5$export$bd7b528d8c36ec41; });
$parcel$export(module.exports, "ChainRecDepthFirst", function () { return $80e0273671c816f5$export$7d808dfaa6d54634; });
$parcel$export(module.exports, "ChainRecBreadthFirst", function () { return $80e0273671c816f5$export$57f3a385c7e59628; });
$parcel$export(module.exports, "Witherable", function () { return $80e0273671c816f5$export$748d317b4c426f96; });
$parcel$export(module.exports, "filterE", function () { return $80e0273671c816f5$export$c40604f35db61519; });
$parcel$export(module.exports, "FromEither", function () { return $80e0273671c816f5$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "fromEitherK", function () { return $80e0273671c816f5$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "unsafeInsertAt", function () { return $80e0273671c816f5$export$f4863e1822a1860c; });
$parcel$export(module.exports, "toArray", function () { return $80e0273671c816f5$export$45b10814cc054894; });
$parcel$export(module.exports, "fromArray", function () { return $80e0273671c816f5$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "every", function () { return $80e0273671c816f5$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "some", function () { return $80e0273671c816f5$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "exists", function () { return $80e0273671c816f5$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "intercalate", function () { return $80e0273671c816f5$export$739ec22334c44788; });
$parcel$export(module.exports, "Do", function () { return $80e0273671c816f5$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $80e0273671c816f5$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $80e0273671c816f5$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $80e0273671c816f5$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $80e0273671c816f5$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "chain", function () { return $80e0273671c816f5$export$e08e3b67e392101e; });
$parcel$export(module.exports, "range", function () { return $80e0273671c816f5$export$d02631cccf789723; });
$parcel$export(module.exports, "cons", function () { return $80e0273671c816f5$export$8327ebbef2a0ba76; });
$parcel$export(module.exports, "snoc", function () { return $80e0273671c816f5$export$c40cf5aab899f397; });
$parcel$export(module.exports, "prependToAll", function () { return $80e0273671c816f5$export$baeb00bf1e27e233; });
$parcel$export(module.exports, "readonlyArray", function () { return $80e0273671c816f5$export$95ca155af9fd5713; });

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $kJAjV = parcelRequire("kJAjV");

var $ctkBN = parcelRequire("ctkBN");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $10ZIc = parcelRequire("10ZIc");

var $12uqT = parcelRequire("12uqT");

var $1ECi6 = parcelRequire("1ECi6");

var $bFSl4 = parcelRequire("bFSl4");

var $erGUW = parcelRequire("erGUW");

var $gJWAH = parcelRequire("gJWAH");
var $80e0273671c816f5$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $80e0273671c816f5$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $80e0273671c816f5$export$a978c53b4062a525 = $1ECi6.isNonEmpty;
var $80e0273671c816f5$export$68159836694e22c1 = $1ECi6.prepend;
var $80e0273671c816f5$export$c4c4d41eab625797 = $1ECi6.prependW;
var $80e0273671c816f5$export$10d8903dec122b9d = $1ECi6.append;
var $80e0273671c816f5$export$19903a1bf1942f6 = $1ECi6.appendW;
var $80e0273671c816f5$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $80e0273671c816f5$export$6e22c362a0406a2c : $1ECi6.makeBy(f)(n);
};
var $80e0273671c816f5$export$606959e7ccb797f0 = function(n, a) {
    return $80e0273671c816f5$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $80e0273671c816f5$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $80e0273671c816f5$export$6e22c362a0406a2c;
    };
}
var $80e0273671c816f5$export$172ec0a6ebfeb6fa = function(ma) {
    return $aByOK.isNone(ma) ? $80e0273671c816f5$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $80e0273671c816f5$export$80c878c9b1d77917 = function(e) {
    return $aByOK.isLeft(e) ? $80e0273671c816f5$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $80e0273671c816f5$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $80e0273671c816f5$export$4659b591c19bdf3d = $80e0273671c816f5$export$2d55ea551c238330;
var $80e0273671c816f5$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? onNonEmpty($1ECi6.head(as), $1ECi6.tail(as)) : onEmpty();
    };
};
var $80e0273671c816f5$export$6280271dfaec4919 = $80e0273671c816f5$export$ebbe93aa91e3abdc;
var $80e0273671c816f5$export$f3163a37d0ef5927 = $80e0273671c816f5$export$6280271dfaec4919;
var $80e0273671c816f5$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? onNonEmpty($1ECi6.init(as), $1ECi6.last(as)) : onEmpty();
    };
};
var $80e0273671c816f5$export$b1cacb83a5c6bd02 = $80e0273671c816f5$export$364f7f2cc8473008;
var $80e0273671c816f5$export$77fa89c00b331c4c = $80e0273671c816f5$export$b1cacb83a5c6bd02;
var $80e0273671c816f5$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($80e0273671c816f5$export$dd1bc94b04021eeb(as)) return $80e0273671c816f5$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $80e0273671c816f5$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $80e0273671c816f5$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $80e0273671c816f5$export$346677f925de839c = function(as) {
    return as.length;
};
var $80e0273671c816f5$export$2fde0b1c54fc39b9 = $1ECi6.isOutOfBound;
function $80e0273671c816f5$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $80e0273671c816f5$export$dfc7155ac0343b8(i, as);
    } : $80e0273671c816f5$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some(as[i]);
}
var $80e0273671c816f5$export$5fd5031fecdacec3 = function(as) {
    return $80e0273671c816f5$export$a978c53b4062a525(as) ? $aByOK.some($1ECi6.head(as)) : $aByOK.none;
};
var $80e0273671c816f5$export$4c7897fafd92b108 = function(as) {
    return $80e0273671c816f5$export$a978c53b4062a525(as) ? $aByOK.some($1ECi6.last(as)) : $aByOK.none;
};
var $80e0273671c816f5$export$c01875f616615628 = function(as) {
    return $80e0273671c816f5$export$a978c53b4062a525(as) ? $aByOK.some($1ECi6.tail(as)) : $aByOK.none;
};
var $80e0273671c816f5$export$2cd8252107eb640b = function(as) {
    return $80e0273671c816f5$export$a978c53b4062a525(as) ? $aByOK.some($1ECi6.init(as)) : $aByOK.none;
};
var $80e0273671c816f5$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $80e0273671c816f5$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $80e0273671c816f5$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $80e0273671c816f5$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $80e0273671c816f5$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $80e0273671c816f5$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $80e0273671c816f5$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $80e0273671c816f5$export$6e22c362a0406a2c : out;
    };
}
var $80e0273671c816f5$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $80e0273671c816f5$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $80e0273671c816f5$export$b0d75975ac0be0e1($80e0273671c816f5$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $80e0273671c816f5$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $80e0273671c816f5$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $80e0273671c816f5$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $80e0273671c816f5$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $80e0273671c816f5$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $80e0273671c816f5$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $80e0273671c816f5$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $80e0273671c816f5$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $80e0273671c816f5$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $80e0273671c816f5$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $aByOK.some(i);
        }
        return $aByOK.none;
    };
};
function $80e0273671c816f5$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $aByOK.some(as[i]);
        }
        return $aByOK.none;
    };
}
var $80e0273671c816f5$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($aByOK.isSome(out)) return out;
        }
        return $aByOK.none;
    };
};
function $80e0273671c816f5$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $aByOK.some(as[i]);
        }
        return $aByOK.none;
    };
}
var $80e0273671c816f5$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($aByOK.isSome(out)) return out;
        }
        return $aByOK.none;
    };
};
var $80e0273671c816f5$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $aByOK.some(i);
        }
        return $aByOK.none;
    };
};
var $80e0273671c816f5$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $aByOK.none : $aByOK.some($1ECi6.unsafeInsertAt(i, a, as));
    };
};
var $80e0273671c816f5$export$b6d8713d53419d4c = function(i, a) {
    return $80e0273671c816f5$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $80e0273671c816f5$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $80e0273671c816f5$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some($80e0273671c816f5$export$4937fde8dfc38dbd(i, as));
    };
};
var $80e0273671c816f5$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $80e0273671c816f5$export$2fde0b1c54fc39b9(i, as) ? $aByOK.none : $aByOK.some($80e0273671c816f5$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $80e0273671c816f5$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $80e0273671c816f5$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $80e0273671c816f5$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $80e0273671c816f5$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $80e0273671c816f5$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $80e0273671c816f5$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $80e0273671c816f5$export$8901015135f2fb22(bs, as);
    };
    return $80e0273671c816f5$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $80e0273671c816f5$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $80e0273671c816f5$export$849c7567cbd62acc = function(middle) {
    var f = $1ECi6.prependAll(middle);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $80e0273671c816f5$export$af200dcf8b7cb5de = function(middle) {
    var f = $1ECi6.intersperse(middle);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $80e0273671c816f5$export$bb628a54ab399bc9 = function(n) {
    var f = $1ECi6.rotate(n);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $80e0273671c816f5$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $80e0273671c816f5$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $80e0273671c816f5$export$f70730c3d1fc524e = function(E) {
    var f = $1ECi6.uniq(E);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $80e0273671c816f5$export$b035e44d7bb4278f = function(ords) {
    var f = $1ECi6.sortBy(ords);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $80e0273671c816f5$export$433fe05b12ba833f = function(f) {
    var g = $1ECi6.chop(f);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? g(as) : $80e0273671c816f5$export$6e22c362a0406a2c;
    };
};
var $80e0273671c816f5$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $80e0273671c816f5$export$a978c53b4062a525(as) ? $1ECi6.splitAt(n)(as) : $80e0273671c816f5$export$dd1bc94b04021eeb(as) ? [
            as,
            $80e0273671c816f5$export$6e22c362a0406a2c
        ] : [
            $80e0273671c816f5$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $80e0273671c816f5$export$2f0184d5df52135f = function(n) {
    var f = $1ECi6.chunksOf(n);
    return function(as) {
        return $80e0273671c816f5$export$a978c53b4062a525(as) ? f(as) : $80e0273671c816f5$export$6e22c362a0406a2c;
    };
};
var $80e0273671c816f5$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $80e0273671c816f5$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $80e0273671c816f5$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $80e0273671c816f5$export$a978c53b4062a525(input) ? $80e0273671c816f5$export$5b8affa63fc6df16($1ECi6.head(input), function(a) {
            return go((0, $f5id0.pipe)(scope, $80e0273671c816f5$export$10d8903dec122b9d(a)), $1ECi6.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $80e0273671c816f5$export$6e22c362a0406a2c;
    };
    return go($80e0273671c816f5$export$6e22c362a0406a2c, input);
}
var $80e0273671c816f5$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $80e0273671c816f5$export$dd1bc94b04021eeb(first) ? second : $80e0273671c816f5$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $80e0273671c816f5$export$ee1b3e54f0441b22 = $80e0273671c816f5$export$c8c959650bbe80e2;
function $80e0273671c816f5$export$971dd5b0dfd021b6(E) {
    var unionE = $1ECi6.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $80e0273671c816f5$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $80e0273671c816f5$export$a978c53b4062a525(first) && $80e0273671c816f5$export$a978c53b4062a525(second) ? unionE(second)(first) : $80e0273671c816f5$export$a978c53b4062a525(first) ? first : second;
    };
}
function $80e0273671c816f5$export$bc86dfbf7795668c(E) {
    var elemE = $80e0273671c816f5$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $80e0273671c816f5$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $80e0273671c816f5$export$acaf96a27438246b(E) {
    var elemE = $80e0273671c816f5$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $80e0273671c816f5$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $80e0273671c816f5$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$871de8747c9eaa88(f));
};
var $80e0273671c816f5$var$_mapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$8f07ddce13659f50(f));
};
var $80e0273671c816f5$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $80e0273671c816f5$export$2f6ca3d3b1f80bf5(fa));
};
var $80e0273671c816f5$var$_filter = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$3dea766d36a8935f(predicate));
};
var $80e0273671c816f5$var$_filterMap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$a04c6c6965dd4709(f));
};
var $80e0273671c816f5$var$_partition = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$b29f828819edca8d(predicate));
};
var $80e0273671c816f5$var$_partitionMap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$3117e3f9ececb6bc(f));
};
var $80e0273671c816f5$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $80e0273671c816f5$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$bc7c0794b9c6f3ba(f));
};
var $80e0273671c816f5$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$228be17d80722ab(that));
};
var $80e0273671c816f5$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$533b26079ad0b4b(b, f));
};
var $80e0273671c816f5$var$_foldMap = function(M) {
    var foldMapM = $80e0273671c816f5$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
var $80e0273671c816f5$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$7fef8bcdbb34f435(b, f));
};
var $80e0273671c816f5$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$bbd3ef8720e22369(b, f));
};
var $80e0273671c816f5$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $80e0273671c816f5$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $80e0273671c816f5$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$ce2b2fe0b88ccd0a(b, f));
};
var $80e0273671c816f5$var$_filterMapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$30c5cbe848021e97(f));
};
var $80e0273671c816f5$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$36e42aef19fc7171(predicateWithIndex));
};
var $80e0273671c816f5$var$_extend = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$8b58be045bf06082(f));
};
var $80e0273671c816f5$var$_traverse = function(F) {
    var traverseF = $80e0273671c816f5$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $80e0273671c816f5$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $80e0273671c816f5$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseWithIndexF(f));
    };
};
var $80e0273671c816f5$export$c5c44f872d8af73 = function(a, f) {
    return (0, $f5id0.pipe)(a, $80e0273671c816f5$export$f855115a79f70c1a(f));
};
var $80e0273671c816f5$export$b9909b62ceeab991 = function(a, f) {
    return (0, $f5id0.pipe)(a, $80e0273671c816f5$export$bffee57bb00a6859(f));
};
var $80e0273671c816f5$export$ba255e9e49e00608 = $1ECi6.of;
var $80e0273671c816f5$export$7f9972325ebfd559 = function() {
    return $80e0273671c816f5$export$6e22c362a0406a2c;
};
var $80e0273671c816f5$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $80e0273671c816f5$export$228be17d80722ab = $80e0273671c816f5$export$1517cca7889d6aaa;
var $80e0273671c816f5$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $80e0273671c816f5$export$5b8affa63fc6df16(function(f) {
        return (0, $f5id0.pipe)(fa, $80e0273671c816f5$export$871de8747c9eaa88(f));
    });
};
var $80e0273671c816f5$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return (0, $f5id0.pipe)(ma, $80e0273671c816f5$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $80e0273671c816f5$export$bffa455ba8c619a6 = /*#__PURE__*/ $80e0273671c816f5$export$5b8affa63fc6df16((0, $f5id0.identity));
var $80e0273671c816f5$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $80e0273671c816f5$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $80e0273671c816f5$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $bFSl4.separated)(left, right);
};
var $80e0273671c816f5$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $80e0273671c816f5$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($aByOK.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $80e0273671c816f5$export$a04c6c6965dd4709 = function(f) {
    return $80e0273671c816f5$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $80e0273671c816f5$export$8e16b83750b44988 = /*#__PURE__*/ $80e0273671c816f5$export$a04c6c6965dd4709((0, $f5id0.identity));
var $80e0273671c816f5$export$b29f828819edca8d = function(predicate) {
    return $80e0273671c816f5$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $80e0273671c816f5$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $bFSl4.separated)(left, right);
    };
};
var $80e0273671c816f5$export$3117e3f9ececb6bc = function(f) {
    return $80e0273671c816f5$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $80e0273671c816f5$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $bFSl4.separated)(left, right);
    };
};
var $80e0273671c816f5$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $80e0273671c816f5$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $80e0273671c816f5$export$ecd5e8ace626722c = /*#__PURE__*/ $80e0273671c816f5$export$8b58be045bf06082((0, $f5id0.identity));
var $80e0273671c816f5$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $80e0273671c816f5$export$533b26079ad0b4b = function(b, f) {
    return $80e0273671c816f5$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $80e0273671c816f5$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $80e0273671c816f5$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $80e0273671c816f5$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $80e0273671c816f5$export$7fef8bcdbb34f435 = function(b, f) {
    return $80e0273671c816f5$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $80e0273671c816f5$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $80e0273671c816f5$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $80e0273671c816f5$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $80e0273671c816f5$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $80e0273671c816f5$var$_reduce(ta, F.of($80e0273671c816f5$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $f5id0.pipe)(as, $80e0273671c816f5$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $80e0273671c816f5$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $80e0273671c816f5$export$bbd3ef8720e22369(F.of($80e0273671c816f5$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $f5id0.pipe)(bs, $80e0273671c816f5$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $80e0273671c816f5$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $80e0273671c816f5$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $80e0273671c816f5$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $80e0273671c816f5$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $80e0273671c816f5$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($aByOK.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $80e0273671c816f5$export$9156e739aa33e19f = 'ReadonlyArray';
var $80e0273671c816f5$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $80e0273671c816f5$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $80e0273671c816f5$export$dd1bc94b04021eeb(first) ? second : $80e0273671c816f5$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $80e0273671c816f5$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $80e0273671c816f5$export$e759a9a7f8d04692().concat,
        empty: $80e0273671c816f5$export$6e22c362a0406a2c
    };
};
var $80e0273671c816f5$export$804fed467fde44e4 = function(E) {
    return (0, $kJAjV.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $80e0273671c816f5$export$1af51209b1b91d07 = function(O) {
    return (0, $12uqT.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $10ZIc.Ord.compare(aLen, bLen);
    });
};
var $80e0273671c816f5$export$baca17b4aff42f82 = function(E) {
    var unionE = $80e0273671c816f5$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $80e0273671c816f5$export$c487aac9f4157837 = function(E) {
    return {
        concat: $80e0273671c816f5$export$baca17b4aff42f82(E).concat,
        empty: $80e0273671c816f5$export$6e22c362a0406a2c
    };
};
var $80e0273671c816f5$export$d379a869a72e4055 = function(E) {
    var intersectionE = $80e0273671c816f5$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $80e0273671c816f5$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $80e0273671c816f5$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $80e0273671c816f5$export$bd5b6bfc5fa2ee61 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map
};
var $80e0273671c816f5$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($80e0273671c816f5$export$bd5b6bfc5fa2ee61);
var $80e0273671c816f5$export$59a71046037e6c20 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    of: $80e0273671c816f5$export$ba255e9e49e00608
};
var $80e0273671c816f5$export$9fdffe0fe1e91cad = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    mapWithIndex: $80e0273671c816f5$var$_mapWithIndex
};
var $80e0273671c816f5$export$efc21ddc6aeb363d = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap
};
var $80e0273671c816f5$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($80e0273671c816f5$export$efc21ddc6aeb363d);
var $80e0273671c816f5$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($80e0273671c816f5$export$efc21ddc6aeb363d);
var $80e0273671c816f5$export$1279d2b7807629fd = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    of: $80e0273671c816f5$export$ba255e9e49e00608
};
var $80e0273671c816f5$export$f18d5acc27d70423 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    chain: $80e0273671c816f5$export$5b8affa63fc6df16
};
var $80e0273671c816f5$export$fb641926d034ac7d = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    of: $80e0273671c816f5$export$ba255e9e49e00608,
    chain: $80e0273671c816f5$export$5b8affa63fc6df16
};
var $80e0273671c816f5$export$e3821ef4970c339c = /*#__PURE__*/ (0, $lcDVT.chainFirst)($80e0273671c816f5$export$f18d5acc27d70423);
var $80e0273671c816f5$export$8fa953f00d3b093 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    unfold: $80e0273671c816f5$export$c48e357c1a89b78d
};
var $80e0273671c816f5$export$25ba4469a069167 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    alt: $80e0273671c816f5$var$_alt
};
var $80e0273671c816f5$export$aaef8a3eae948f03 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    zero: $80e0273671c816f5$export$7f9972325ebfd559
};
var $80e0273671c816f5$export$864d727b48066337 = /*#__PURE__*/ (0, $gJWAH.guard)($80e0273671c816f5$export$aaef8a3eae948f03, $80e0273671c816f5$export$59a71046037e6c20);
var $80e0273671c816f5$export$4acb47accde578d2 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    of: $80e0273671c816f5$export$ba255e9e49e00608,
    alt: $80e0273671c816f5$var$_alt,
    zero: $80e0273671c816f5$export$7f9972325ebfd559
};
var $80e0273671c816f5$export$5b5dd0e212d2a5bc = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    extend: $80e0273671c816f5$var$_extend
};
var $80e0273671c816f5$export$4a21ac48141ac3c9 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    compact: $80e0273671c816f5$export$8e16b83750b44988,
    separate: $80e0273671c816f5$export$709f6946f4e97408
};
var $80e0273671c816f5$export$d00e1c48fb621173 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    compact: $80e0273671c816f5$export$8e16b83750b44988,
    separate: $80e0273671c816f5$export$709f6946f4e97408,
    filter: $80e0273671c816f5$var$_filter,
    filterMap: $80e0273671c816f5$var$_filterMap,
    partition: $80e0273671c816f5$var$_partition,
    partitionMap: $80e0273671c816f5$var$_partitionMap
};
var $80e0273671c816f5$export$c29a647071e542ec = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    mapWithIndex: $80e0273671c816f5$var$_mapWithIndex,
    compact: $80e0273671c816f5$export$8e16b83750b44988,
    separate: $80e0273671c816f5$export$709f6946f4e97408,
    filter: $80e0273671c816f5$var$_filter,
    filterMap: $80e0273671c816f5$var$_filterMap,
    partition: $80e0273671c816f5$var$_partition,
    partitionMap: $80e0273671c816f5$var$_partitionMap,
    partitionMapWithIndex: $80e0273671c816f5$var$_partitionMapWithIndex,
    partitionWithIndex: $80e0273671c816f5$var$_partitionWithIndex,
    filterMapWithIndex: $80e0273671c816f5$var$_filterMapWithIndex,
    filterWithIndex: $80e0273671c816f5$var$_filterWithIndex
};
var $80e0273671c816f5$export$41404b31838667c9 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    reduce: $80e0273671c816f5$var$_reduce,
    foldMap: $80e0273671c816f5$var$_foldMap,
    reduceRight: $80e0273671c816f5$var$_reduceRight
};
var $80e0273671c816f5$export$e8f7d17aaff345cb = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    reduce: $80e0273671c816f5$var$_reduce,
    foldMap: $80e0273671c816f5$var$_foldMap,
    reduceRight: $80e0273671c816f5$var$_reduceRight,
    reduceWithIndex: $80e0273671c816f5$var$_reduceWithIndex,
    foldMapWithIndex: $80e0273671c816f5$var$_foldMapWithIndex,
    reduceRightWithIndex: $80e0273671c816f5$var$_reduceRightWithIndex
};
var $80e0273671c816f5$export$a0202666c3bda011 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    reduce: $80e0273671c816f5$var$_reduce,
    foldMap: $80e0273671c816f5$var$_foldMap,
    reduceRight: $80e0273671c816f5$var$_reduceRight,
    traverse: $80e0273671c816f5$var$_traverse,
    sequence: $80e0273671c816f5$export$49bb65c2ea163039
};
var $80e0273671c816f5$export$bd7b528d8c36ec41 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    mapWithIndex: $80e0273671c816f5$var$_mapWithIndex,
    reduce: $80e0273671c816f5$var$_reduce,
    foldMap: $80e0273671c816f5$var$_foldMap,
    reduceRight: $80e0273671c816f5$var$_reduceRight,
    reduceWithIndex: $80e0273671c816f5$var$_reduceWithIndex,
    foldMapWithIndex: $80e0273671c816f5$var$_foldMapWithIndex,
    reduceRightWithIndex: $80e0273671c816f5$var$_reduceRightWithIndex,
    traverse: $80e0273671c816f5$var$_traverse,
    sequence: $80e0273671c816f5$export$49bb65c2ea163039,
    traverseWithIndex: $80e0273671c816f5$var$_traverseWithIndex
};
var $80e0273671c816f5$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $80e0273671c816f5$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($aByOK.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $80e0273671c816f5$export$7d808dfaa6d54634 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    chain: $80e0273671c816f5$export$5b8affa63fc6df16,
    chainRec: $80e0273671c816f5$export$c5c44f872d8af73
};
var $80e0273671c816f5$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($aByOK.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $80e0273671c816f5$export$57f3a385c7e59628 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    chain: $80e0273671c816f5$export$5b8affa63fc6df16,
    chainRec: $80e0273671c816f5$export$b9909b62ceeab991
};
var $80e0273671c816f5$var$_wither = /*#__PURE__*/ (0, $erGUW.witherDefault)($80e0273671c816f5$export$a0202666c3bda011, $80e0273671c816f5$export$4a21ac48141ac3c9);
var $80e0273671c816f5$var$_wilt = /*#__PURE__*/ (0, $erGUW.wiltDefault)($80e0273671c816f5$export$a0202666c3bda011, $80e0273671c816f5$export$4a21ac48141ac3c9);
var $80e0273671c816f5$export$748d317b4c426f96 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    map: $80e0273671c816f5$var$_map,
    compact: $80e0273671c816f5$export$8e16b83750b44988,
    separate: $80e0273671c816f5$export$709f6946f4e97408,
    filter: $80e0273671c816f5$var$_filter,
    filterMap: $80e0273671c816f5$var$_filterMap,
    partition: $80e0273671c816f5$var$_partition,
    partitionMap: $80e0273671c816f5$var$_partitionMap,
    reduce: $80e0273671c816f5$var$_reduce,
    foldMap: $80e0273671c816f5$var$_foldMap,
    reduceRight: $80e0273671c816f5$var$_reduceRight,
    traverse: $80e0273671c816f5$var$_traverse,
    sequence: $80e0273671c816f5$export$49bb65c2ea163039,
    wither: $80e0273671c816f5$var$_wither,
    wilt: $80e0273671c816f5$var$_wilt
};
var $80e0273671c816f5$export$c40604f35db61519 = /*#__PURE__*/ (0, $erGUW.filterE)($80e0273671c816f5$export$748d317b4c426f96);
var $80e0273671c816f5$export$825ea6cb6fc48d49 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    fromEither: $80e0273671c816f5$export$80c878c9b1d77917
};
var $80e0273671c816f5$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $ctkBN.fromEitherK)($80e0273671c816f5$export$825ea6cb6fc48d49);
var $80e0273671c816f5$export$f4863e1822a1860c = $1ECi6.unsafeInsertAt;
var $80e0273671c816f5$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $80e0273671c816f5$export$a978c53b4062a525(as) ? $1ECi6.unsafeUpdateAt(i, a, as) : as;
};
var $80e0273671c816f5$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $80e0273671c816f5$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $80e0273671c816f5$export$571d59b505e6bb4e = function(as) {
    return $80e0273671c816f5$export$dd1bc94b04021eeb(as) ? $80e0273671c816f5$export$6e22c362a0406a2c : as.slice();
};
var $80e0273671c816f5$export$6e22c362a0406a2c = $1ECi6.empty;
function $80e0273671c816f5$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $80e0273671c816f5$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $80e0273671c816f5$export$f7e9f41ea797a17 = $80e0273671c816f5$export$ad14ef4001db2bcd;
var $80e0273671c816f5$export$739ec22334c44788 = function(M) {
    var intercalateM = $1ECi6.intercalate(M);
    return function(middle) {
        return $80e0273671c816f5$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $80e0273671c816f5$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $80e0273671c816f5$export$ba255e9e49e00608($aByOK.emptyRecord);
var $80e0273671c816f5$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($80e0273671c816f5$export$bd5b6bfc5fa2ee61);
var $80e0273671c816f5$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($80e0273671c816f5$export$bd5b6bfc5fa2ee61);
var $80e0273671c816f5$export$2385a24977818dd0 = /*#__PURE__*/ (0, $lcDVT.bind)($80e0273671c816f5$export$f18d5acc27d70423);
var $80e0273671c816f5$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($80e0273671c816f5$export$efc21ddc6aeb363d);
var $80e0273671c816f5$export$e08e3b67e392101e = $80e0273671c816f5$export$5b8affa63fc6df16;
var $80e0273671c816f5$export$d02631cccf789723 = $1ECi6.range;
var $80e0273671c816f5$export$8327ebbef2a0ba76 = $1ECi6.cons;
var $80e0273671c816f5$export$c40cf5aab899f397 = $1ECi6.snoc;
var $80e0273671c816f5$export$baeb00bf1e27e233 = $80e0273671c816f5$export$849c7567cbd62acc;
var $80e0273671c816f5$export$95ca155af9fd5713 = {
    URI: $80e0273671c816f5$export$9156e739aa33e19f,
    compact: $80e0273671c816f5$export$8e16b83750b44988,
    separate: $80e0273671c816f5$export$709f6946f4e97408,
    map: $80e0273671c816f5$var$_map,
    ap: $80e0273671c816f5$var$_ap,
    of: $80e0273671c816f5$export$ba255e9e49e00608,
    chain: $80e0273671c816f5$export$5b8affa63fc6df16,
    filter: $80e0273671c816f5$var$_filter,
    filterMap: $80e0273671c816f5$var$_filterMap,
    partition: $80e0273671c816f5$var$_partition,
    partitionMap: $80e0273671c816f5$var$_partitionMap,
    mapWithIndex: $80e0273671c816f5$var$_mapWithIndex,
    partitionMapWithIndex: $80e0273671c816f5$var$_partitionMapWithIndex,
    partitionWithIndex: $80e0273671c816f5$var$_partitionWithIndex,
    filterMapWithIndex: $80e0273671c816f5$var$_filterMapWithIndex,
    filterWithIndex: $80e0273671c816f5$var$_filterWithIndex,
    alt: $80e0273671c816f5$var$_alt,
    zero: $80e0273671c816f5$export$7f9972325ebfd559,
    unfold: $80e0273671c816f5$export$c48e357c1a89b78d,
    reduce: $80e0273671c816f5$var$_reduce,
    foldMap: $80e0273671c816f5$var$_foldMap,
    reduceRight: $80e0273671c816f5$var$_reduceRight,
    traverse: $80e0273671c816f5$var$_traverse,
    sequence: $80e0273671c816f5$export$49bb65c2ea163039,
    reduceWithIndex: $80e0273671c816f5$var$_reduceWithIndex,
    foldMapWithIndex: $80e0273671c816f5$var$_foldMapWithIndex,
    reduceRightWithIndex: $80e0273671c816f5$var$_reduceRightWithIndex,
    traverseWithIndex: $80e0273671c816f5$var$_traverseWithIndex,
    extend: $80e0273671c816f5$var$_extend,
    wither: $80e0273671c816f5$var$_wither,
    wilt: $80e0273671c816f5$var$_wilt
};

});
parcelRegister("10ZIc", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $0bd5a93ba641e22a$export$7e4aa119212bc614; });
$parcel$export(module.exports, "Eq", function () { return $0bd5a93ba641e22a$export$a2050e5b0c4dcf10; });
$parcel$export(module.exports, "Ord", function () { return $0bd5a93ba641e22a$export$ee8aa95bfab51c5; });
$parcel$export(module.exports, "Bounded", function () { return $0bd5a93ba641e22a$export$88f31472ebc405c8; });
$parcel$export(module.exports, "Show", function () { return $0bd5a93ba641e22a$export$f6a3d19be20f5819; });
$parcel$export(module.exports, "MagmaSub", function () { return $0bd5a93ba641e22a$export$d423c79a04b3ae25; });
$parcel$export(module.exports, "SemigroupSum", function () { return $0bd5a93ba641e22a$export$e5fae4f686b09c06; });
$parcel$export(module.exports, "SemigroupProduct", function () { return $0bd5a93ba641e22a$export$5b0bccec79556292; });
$parcel$export(module.exports, "MonoidSum", function () { return $0bd5a93ba641e22a$export$2517c0450e71e789; });
$parcel$export(module.exports, "MonoidProduct", function () { return $0bd5a93ba641e22a$export$ee1a63590489b690; });
$parcel$export(module.exports, "Field", function () { return $0bd5a93ba641e22a$export$a455218a85c89869; });
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $0bd5a93ba641e22a$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $0bd5a93ba641e22a$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $0bd5a93ba641e22a$export$ee8aa95bfab51c5 = {
    equals: $0bd5a93ba641e22a$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $0bd5a93ba641e22a$export$88f31472ebc405c8 = {
    equals: $0bd5a93ba641e22a$export$a2050e5b0c4dcf10.equals,
    compare: $0bd5a93ba641e22a$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $0bd5a93ba641e22a$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $0bd5a93ba641e22a$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $0bd5a93ba641e22a$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $0bd5a93ba641e22a$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $0bd5a93ba641e22a$export$2517c0450e71e789 = {
    concat: $0bd5a93ba641e22a$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $0bd5a93ba641e22a$export$ee1a63590489b690 = {
    concat: $0bd5a93ba641e22a$export$5b0bccec79556292.concat,
    empty: 1
};
var $0bd5a93ba641e22a$export$a455218a85c89869 = {
    add: $0bd5a93ba641e22a$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $0bd5a93ba641e22a$export$5b0bccec79556292.concat,
    one: 1,
    sub: $0bd5a93ba641e22a$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("bFSl4", function(module, exports) {

$parcel$export(module.exports, "separated", function () { return $87fdac9eccad7769$export$beaabdf62f4a639d; });
$parcel$export(module.exports, "map", function () { return $87fdac9eccad7769$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapLeft", function () { return $87fdac9eccad7769$export$472de43a55e4aa49; });
$parcel$export(module.exports, "bimap", function () { return $87fdac9eccad7769$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "left", function () { return $87fdac9eccad7769$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $87fdac9eccad7769$export$79ffe56a765070d2; });
$parcel$export(module.exports, "URI", function () { return $87fdac9eccad7769$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Bifunctor", function () { return $87fdac9eccad7769$export$fd0fe42029639505; });
$parcel$export(module.exports, "Functor", function () { return $87fdac9eccad7769$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $87fdac9eccad7769$export$18c957606d8bdf09; });
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 
var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");
var $87fdac9eccad7769$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $87fdac9eccad7769$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $87fdac9eccad7769$export$871de8747c9eaa88(f));
};
var $87fdac9eccad7769$var$_mapLeft = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $87fdac9eccad7769$export$472de43a55e4aa49(f));
};
var $87fdac9eccad7769$var$_bimap = function(fa, g, f) {
    return (0, $f5id0.pipe)(fa, $87fdac9eccad7769$export$eb54baf0b342cb1d(g, f));
};
var $87fdac9eccad7769$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $87fdac9eccad7769$export$beaabdf62f4a639d($87fdac9eccad7769$export$eabcd2c8791e7bf4(fa), f($87fdac9eccad7769$export$79ffe56a765070d2(fa)));
    };
};
var $87fdac9eccad7769$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $87fdac9eccad7769$export$beaabdf62f4a639d(f($87fdac9eccad7769$export$eabcd2c8791e7bf4(fa)), $87fdac9eccad7769$export$79ffe56a765070d2(fa));
    };
};
var $87fdac9eccad7769$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $87fdac9eccad7769$export$beaabdf62f4a639d(f($87fdac9eccad7769$export$eabcd2c8791e7bf4(fa)), g($87fdac9eccad7769$export$79ffe56a765070d2(fa)));
    };
};
var $87fdac9eccad7769$export$9156e739aa33e19f = 'Separated';
var $87fdac9eccad7769$export$fd0fe42029639505 = {
    URI: $87fdac9eccad7769$export$9156e739aa33e19f,
    mapLeft: $87fdac9eccad7769$var$_mapLeft,
    bimap: $87fdac9eccad7769$var$_bimap
};
var $87fdac9eccad7769$export$bd5b6bfc5fa2ee61 = {
    URI: $87fdac9eccad7769$export$9156e739aa33e19f,
    map: $87fdac9eccad7769$var$_map
};
var $87fdac9eccad7769$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($87fdac9eccad7769$export$bd5b6bfc5fa2ee61);
var $87fdac9eccad7769$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $87fdac9eccad7769$export$79ffe56a765070d2 = function(s) {
    return s.right;
};

});

parcelRegister("erGUW", function(module, exports) {

$parcel$export(module.exports, "wiltDefault", function () { return $a844e0cd16cbe853$export$f4cb42390e44d1d2; });
$parcel$export(module.exports, "witherDefault", function () { return $a844e0cd16cbe853$export$1f5c6f948d11a182; });
$parcel$export(module.exports, "filterE", function () { return $a844e0cd16cbe853$export$c40604f35db61519; });

var $aByOK = parcelRequire("aByOK");
function $a844e0cd16cbe853$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $a844e0cd16cbe853$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $a844e0cd16cbe853$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $aByOK.some(a) : $aByOK.none;
                    });
                });
            };
        };
    };
}

});

parcelRegister("gJWAH", function(module, exports) {

$parcel$export(module.exports, "guard", function () { return $c2fe4c3c95bc637c$export$864d727b48066337; });
function $c2fe4c3c95bc637c$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("lyuPz", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $fb14b04f4d5b1e17$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "getApplicative", function () { return $fb14b04f4d5b1e17$export$1402880adb2295a7; });

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");
var $fb14b04f4d5b1e17$export$dd44f18ab656f3bb = (0, $f5id0.unsafeCoerce);
function $fb14b04f4d5b1e17$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $fb14b04f4d5b1e17$export$804fed467fde44e4 = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$1af51209b1b91d07 = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$c55397fc301c5a = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$e759a9a7f8d04692 = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$c2a7ef2cc9b32b31 = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$3d48c7fefc7b8ec2 = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$575097c1c561f76f = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$2e73cb3f0f25ed55 = (0, $f5id0.identity);
var $fb14b04f4d5b1e17$export$f37f1abb2c955577 = (0, $f5id0.identity);
function $fb14b04f4d5b1e17$export$81090df2aa47ff12(S) {
    return {
        URI: $fb14b04f4d5b1e17$export$9156e739aa33e19f,
        _E: undefined,
        map: $fb14b04f4d5b1e17$var$_map,
        ap: function(fab, fa) {
            return $fb14b04f4d5b1e17$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $fb14b04f4d5b1e17$export$1402880adb2295a7(M) {
    var A = $fb14b04f4d5b1e17$export$81090df2aa47ff12(M);
    return {
        URI: $fb14b04f4d5b1e17$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $fb14b04f4d5b1e17$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $fb14b04f4d5b1e17$var$_contramap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $fb14b04f4d5b1e17$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $fb14b04f4d5b1e17$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $fb14b04f4d5b1e17$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $fb14b04f4d5b1e17$var$_bimap = function(fa, f, g) {
    return (0, $f5id0.pipe)(fa, $fb14b04f4d5b1e17$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $fb14b04f4d5b1e17$var$_mapLeft = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $fb14b04f4d5b1e17$export$472de43a55e4aa49(f));
};
var $fb14b04f4d5b1e17$export$53b696d27ecb7ba7 = function() {
    return 0, $f5id0.unsafeCoerce;
};
var $fb14b04f4d5b1e17$export$871de8747c9eaa88 = function() {
    return 0, $f5id0.unsafeCoerce;
};
var $fb14b04f4d5b1e17$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $fb14b04f4d5b1e17$export$dd44f18ab656f3bb(f(fa));
    };
};
var $fb14b04f4d5b1e17$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $fb14b04f4d5b1e17$export$dd44f18ab656f3bb(f(fa));
    };
};
var $fb14b04f4d5b1e17$export$9156e739aa33e19f = 'Const';
var $fb14b04f4d5b1e17$export$bd5b6bfc5fa2ee61 = {
    URI: $fb14b04f4d5b1e17$export$9156e739aa33e19f,
    map: $fb14b04f4d5b1e17$var$_map
};
var $fb14b04f4d5b1e17$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($fb14b04f4d5b1e17$export$bd5b6bfc5fa2ee61);
var $fb14b04f4d5b1e17$export$def901a57d5539c3 = {
    URI: $fb14b04f4d5b1e17$export$9156e739aa33e19f,
    contramap: $fb14b04f4d5b1e17$var$_contramap
};
var $fb14b04f4d5b1e17$export$fd0fe42029639505 = {
    URI: $fb14b04f4d5b1e17$export$9156e739aa33e19f,
    bimap: $fb14b04f4d5b1e17$var$_bimap,
    mapLeft: $fb14b04f4d5b1e17$var$_mapLeft
};
var $fb14b04f4d5b1e17$export$dfdd8a9a12668b21 = {
    URI: $fb14b04f4d5b1e17$export$9156e739aa33e19f,
    map: $fb14b04f4d5b1e17$var$_map,
    contramap: $fb14b04f4d5b1e17$var$_contramap,
    bimap: $fb14b04f4d5b1e17$var$_bimap,
    mapLeft: $fb14b04f4d5b1e17$var$_mapLeft
};

});

parcelRegister("4x239", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $34cbd58b894fa73b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $34cbd58b894fa73b$export$8960430cfd85939f; });
$parcel$export(module.exports, "reverse", function () { return $34cbd58b894fa73b$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "struct", function () { return $34cbd58b894fa73b$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "tuple", function () { return $34cbd58b894fa73b$export$65e3907585753458; });
$parcel$export(module.exports, "concatAll", function () { return $34cbd58b894fa73b$export$b314777ae20abca9; });
$parcel$export(module.exports, "monoidVoid", function () { return $34cbd58b894fa73b$export$50d82750fd26461d; });
$parcel$export(module.exports, "getTupleMonoid", function () { return $34cbd58b894fa73b$export$4ab04e39033ac22a; });
$parcel$export(module.exports, "getStructMonoid", function () { return $34cbd58b894fa73b$export$dfc91d1e5b77420b; });
$parcel$export(module.exports, "getDualMonoid", function () { return $34cbd58b894fa73b$export$5ca84f9b29f1c1a2; });
$parcel$export(module.exports, "getJoinMonoid", function () { return $34cbd58b894fa73b$export$9cc0388793460b00; });
$parcel$export(module.exports, "getMeetMonoid", function () { return $34cbd58b894fa73b$export$6d1c667712a51996; });
$parcel$export(module.exports, "fold", function () { return $34cbd58b894fa73b$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "monoidAll", function () { return $34cbd58b894fa73b$export$ea84ccdc68daa647; });
$parcel$export(module.exports, "monoidAny", function () { return $34cbd58b894fa73b$export$c147905ca5134122; });
$parcel$export(module.exports, "getFunctionMonoid", function () { return $34cbd58b894fa73b$export$616ba591d6210ed8; });
$parcel$export(module.exports, "getEndomorphismMonoid", function () { return $34cbd58b894fa73b$export$5c6d2e402d334f37; });
$parcel$export(module.exports, "monoidString", function () { return $34cbd58b894fa73b$export$fc39f3d77fa2e58a; });
$parcel$export(module.exports, "monoidSum", function () { return $34cbd58b894fa73b$export$8f9c64d4a92a9eb6; });
$parcel$export(module.exports, "monoidProduct", function () { return $34cbd58b894fa73b$export$cb362f92c995f3b8; });

var $8aEFw = parcelRequire("8aEFw");

var $f5id0 = parcelRequire("f5id0");

var $aByOK = parcelRequire("aByOK");

var $i0LNv = parcelRequire("i0LNv");
var $34cbd58b894fa73b$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $i0LNv.min(B).concat,
        empty: B.top
    };
};
var $34cbd58b894fa73b$export$8960430cfd85939f = function(B) {
    return {
        concat: $i0LNv.max(B).concat,
        empty: B.bottom
    };
};
var $34cbd58b894fa73b$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $i0LNv.reverse(M).concat,
        empty: M.empty
    };
};
var $34cbd58b894fa73b$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($aByOK.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $i0LNv.struct(monoids).concat,
        empty: empty
    };
};
var $34cbd58b894fa73b$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $i0LNv.tuple.apply($i0LNv, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $34cbd58b894fa73b$export$b314777ae20abca9 = function(M) {
    return $i0LNv.concatAll(M)(M.empty);
};
var $34cbd58b894fa73b$export$50d82750fd26461d = {
    concat: $i0LNv.semigroupVoid.concat,
    empty: undefined
};
var $34cbd58b894fa73b$export$4ab04e39033ac22a = $34cbd58b894fa73b$export$65e3907585753458;
var $34cbd58b894fa73b$export$dfc91d1e5b77420b = $34cbd58b894fa73b$export$8cf3da7c1c9174ea;
var $34cbd58b894fa73b$export$5ca84f9b29f1c1a2 = $34cbd58b894fa73b$export$66c1ae025e96b4bc;
var $34cbd58b894fa73b$export$9cc0388793460b00 = $34cbd58b894fa73b$export$8960430cfd85939f;
var $34cbd58b894fa73b$export$6d1c667712a51996 = $34cbd58b894fa73b$export$96ec731ed4dcb222;
var $34cbd58b894fa73b$export$93e2b83da34ff82a = $34cbd58b894fa73b$export$b314777ae20abca9;
var $34cbd58b894fa73b$export$ea84ccdc68daa647 = {
    concat: $i0LNv.semigroupAll.concat,
    empty: true
};
var $34cbd58b894fa73b$export$c147905ca5134122 = {
    concat: $i0LNv.semigroupAny.concat,
    empty: false
};
var $34cbd58b894fa73b$export$616ba591d6210ed8 = (0, $f5id0.getMonoid);
var $34cbd58b894fa73b$export$5c6d2e402d334f37 = function() {
    return $34cbd58b894fa73b$export$66c1ae025e96b4bc((0, $8aEFw.getMonoid)());
};
var $34cbd58b894fa73b$export$fc39f3d77fa2e58a = {
    concat: $i0LNv.semigroupString.concat,
    empty: ''
};
var $34cbd58b894fa73b$export$8f9c64d4a92a9eb6 = {
    concat: $i0LNv.semigroupSum.concat,
    empty: 0
};
var $34cbd58b894fa73b$export$cb362f92c995f3b8 = {
    concat: $i0LNv.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("8aEFw", function(module, exports) {

$parcel$export(module.exports, "getMonoid", function () { return $5f2ecdd73be38741$export$c2a7ef2cc9b32b31; });
/**
 * @since 2.11.0
 */ 
var $f5id0 = parcelRequire("f5id0");
var $5f2ecdd73be38741$export$9156e739aa33e19f = 'Endomorphism';
var $5f2ecdd73be38741$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $f5id0.flow)(first, second);
        }
    };
};
var $5f2ecdd73be38741$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $5f2ecdd73be38741$export$e759a9a7f8d04692().concat,
        empty: (0, $f5id0.identity)
    };
};

});


parcelRegister("hVAkz", function(module, exports) {

$parcel$export(module.exports, "none", function () { return $d0d3f115c612996a$export$f883a24d5edde77c; });
$parcel$export(module.exports, "some", function () { return $d0d3f115c612996a$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "fromPredicate", function () { return $d0d3f115c612996a$export$23f31c55d7162b91; });
$parcel$export(module.exports, "getLeft", function () { return $d0d3f115c612996a$export$da405662c16fca8e; });
$parcel$export(module.exports, "getRight", function () { return $d0d3f115c612996a$export$482f3615ecf01dc6; });
$parcel$export(module.exports, "map", function () { return $d0d3f115c612996a$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $d0d3f115c612996a$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "reduce", function () { return $d0d3f115c612996a$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $d0d3f115c612996a$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $d0d3f115c612996a$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $d0d3f115c612996a$export$df3f009e3d155b20; });
$parcel$export(module.exports, "alt", function () { return $d0d3f115c612996a$export$228be17d80722ab; });
$parcel$export(module.exports, "filter", function () { return $d0d3f115c612996a$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $d0d3f115c612996a$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "extend", function () { return $d0d3f115c612996a$export$8b58be045bf06082; });
$parcel$export(module.exports, "partition", function () { return $d0d3f115c612996a$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $d0d3f115c612996a$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "URI", function () { return $d0d3f115c612996a$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $d0d3f115c612996a$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "isNone", function () { return $d0d3f115c612996a$export$e56af863d5645d5f; });
$parcel$export(module.exports, "getEq", function () { return $d0d3f115c612996a$export$804fed467fde44e4; });
$parcel$export(module.exports, "getOrd", function () { return $d0d3f115c612996a$export$1af51209b1b91d07; });
$parcel$export(module.exports, "isSome", function () { return $d0d3f115c612996a$export$5d7e502287836e58; });
$parcel$export(module.exports, "getMonoid", function () { return $d0d3f115c612996a$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Functor", function () { return $d0d3f115c612996a$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $d0d3f115c612996a$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $d0d3f115c612996a$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "of", function () { return $d0d3f115c612996a$export$ba255e9e49e00608; });
$parcel$export(module.exports, "Pointed", function () { return $d0d3f115c612996a$export$59a71046037e6c20; });
$parcel$export(module.exports, "Apply", function () { return $d0d3f115c612996a$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "Applicative", function () { return $d0d3f115c612996a$export$1279d2b7807629fd; });
$parcel$export(module.exports, "flatMap", function () { return $d0d3f115c612996a$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "Chain", function () { return $d0d3f115c612996a$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $d0d3f115c612996a$export$fb641926d034ac7d; });
$parcel$export(module.exports, "Foldable", function () { return $d0d3f115c612996a$export$41404b31838667c9; });
$parcel$export(module.exports, "orElse", function () { return $d0d3f115c612996a$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "altW", function () { return $d0d3f115c612996a$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "Alt", function () { return $d0d3f115c612996a$export$25ba4469a069167; });
$parcel$export(module.exports, "zero", function () { return $d0d3f115c612996a$export$7f9972325ebfd559; });
$parcel$export(module.exports, "Zero", function () { return $d0d3f115c612996a$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "guard", function () { return $d0d3f115c612996a$export$864d727b48066337; });
$parcel$export(module.exports, "Alternative", function () { return $d0d3f115c612996a$export$4acb47accde578d2; });
$parcel$export(module.exports, "Extend", function () { return $d0d3f115c612996a$export$5b5dd0e212d2a5bc; });
$parcel$export(module.exports, "compact", function () { return $d0d3f115c612996a$export$8e16b83750b44988; });
$parcel$export(module.exports, "separate", function () { return $d0d3f115c612996a$export$709f6946f4e97408; });
$parcel$export(module.exports, "Compactable", function () { return $d0d3f115c612996a$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $d0d3f115c612996a$export$d00e1c48fb621173; });
$parcel$export(module.exports, "sequence", function () { return $d0d3f115c612996a$export$49bb65c2ea163039; });
$parcel$export(module.exports, "Traversable", function () { return $d0d3f115c612996a$export$a0202666c3bda011; });
$parcel$export(module.exports, "wither", function () { return $d0d3f115c612996a$export$6c36d01819ecdb31; });
$parcel$export(module.exports, "wilt", function () { return $d0d3f115c612996a$export$2439a3bc02b13b03; });
$parcel$export(module.exports, "Witherable", function () { return $d0d3f115c612996a$export$748d317b4c426f96; });
$parcel$export(module.exports, "throwError", function () { return $d0d3f115c612996a$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "MonadThrow", function () { return $d0d3f115c612996a$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "fromEither", function () { return $d0d3f115c612996a$export$80c878c9b1d77917; });
$parcel$export(module.exports, "FromEither", function () { return $d0d3f115c612996a$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "matchW", function () { return $d0d3f115c612996a$export$2d55ea551c238330; });
$parcel$export(module.exports, "foldW", function () { return $d0d3f115c612996a$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "match", function () { return $d0d3f115c612996a$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "fold", function () { return $d0d3f115c612996a$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "getOrElseW", function () { return $d0d3f115c612996a$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "getOrElse", function () { return $d0d3f115c612996a$export$8832081647a02ee7; });
$parcel$export(module.exports, "flap", function () { return $d0d3f115c612996a$export$18c957606d8bdf09; });
$parcel$export(module.exports, "apFirst", function () { return $d0d3f115c612996a$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $d0d3f115c612996a$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "flatten", function () { return $d0d3f115c612996a$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "tap", function () { return $d0d3f115c612996a$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapEither", function () { return $d0d3f115c612996a$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "duplicate", function () { return $d0d3f115c612996a$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "fromEitherK", function () { return $d0d3f115c612996a$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "chainEitherK", function () { return $d0d3f115c612996a$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "chainFirstEitherK", function () { return $d0d3f115c612996a$export$c5f2bdbf9b43f0c0; });
$parcel$export(module.exports, "fromNullable", function () { return $d0d3f115c612996a$export$b601f49376b4621a; });
$parcel$export(module.exports, "tryCatch", function () { return $d0d3f115c612996a$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $d0d3f115c612996a$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "fromNullableK", function () { return $d0d3f115c612996a$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $d0d3f115c612996a$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "toNullable", function () { return $d0d3f115c612996a$export$b187f57ee1822bc5; });
$parcel$export(module.exports, "toUndefined", function () { return $d0d3f115c612996a$export$cb585b8513fa8577; });
$parcel$export(module.exports, "elem", function () { return $d0d3f115c612996a$export$5bf96401662340b7; });
$parcel$export(module.exports, "exists", function () { return $d0d3f115c612996a$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "Do", function () { return $d0d3f115c612996a$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $d0d3f115c612996a$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $d0d3f115c612996a$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $d0d3f115c612996a$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $d0d3f115c612996a$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "ApT", function () { return $d0d3f115c612996a$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $d0d3f115c612996a$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $d0d3f115c612996a$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $d0d3f115c612996a$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $d0d3f115c612996a$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $d0d3f115c612996a$export$d330b60315c14cd1; });
$parcel$export(module.exports, "chain", function () { return $d0d3f115c612996a$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $d0d3f115c612996a$export$e3821ef4970c339c; });
$parcel$export(module.exports, "getRefinement", function () { return $d0d3f115c612996a$export$4a60bf88193d4686; });
$parcel$export(module.exports, "mapNullable", function () { return $d0d3f115c612996a$export$c2a8dfc107523e74; });
$parcel$export(module.exports, "option", function () { return $d0d3f115c612996a$export$a75d1723e6bda2ec; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $d0d3f115c612996a$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $d0d3f115c612996a$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getFirstMonoid", function () { return $d0d3f115c612996a$export$56cd0d85e73e688f; });
$parcel$export(module.exports, "getLastMonoid", function () { return $d0d3f115c612996a$export$ca391a563a1f3001; });

var $6jM4Q = parcelRequire("6jM4Q");

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $ctkBN = parcelRequire("ctkBN");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $IYheM = parcelRequire("IYheM");

var $i0LNv = parcelRequire("i0LNv");

var $bFSl4 = parcelRequire("bFSl4");

var $erGUW = parcelRequire("erGUW");

var $gJWAH = parcelRequire("gJWAH");
var $d0d3f115c612996a$export$f883a24d5edde77c = $aByOK.none;
var $d0d3f115c612996a$export$ad14ef4001db2bcd = $aByOK.some;
function $d0d3f115c612996a$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $d0d3f115c612996a$export$ad14ef4001db2bcd(a) : $d0d3f115c612996a$export$f883a24d5edde77c;
    };
}
var $d0d3f115c612996a$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$ad14ef4001db2bcd(ma.left);
};
var $d0d3f115c612996a$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$ad14ef4001db2bcd(ma.right);
};
var $d0d3f115c612996a$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$871de8747c9eaa88(f));
};
var $d0d3f115c612996a$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $d0d3f115c612996a$export$2f6ca3d3b1f80bf5(fa));
};
var $d0d3f115c612996a$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$533b26079ad0b4b(b, f));
};
var $d0d3f115c612996a$var$_foldMap = function(M) {
    var foldMapM = $d0d3f115c612996a$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
var $d0d3f115c612996a$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$7fef8bcdbb34f435(b, f));
};
var $d0d3f115c612996a$var$_traverse = function(F) {
    var traverseF = $d0d3f115c612996a$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $d0d3f115c612996a$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$228be17d80722ab(that));
};
var $d0d3f115c612996a$var$_filter = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $d0d3f115c612996a$var$_filterMap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $d0d3f115c612996a$var$_extend = function(wa, f) {
    return (0, $f5id0.pipe)(wa, $d0d3f115c612996a$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $d0d3f115c612996a$var$_partition = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $d0d3f115c612996a$var$_partitionMap = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $d0d3f115c612996a$export$3117e3f9ececb6bc(f));
};
var $d0d3f115c612996a$export$9156e739aa33e19f = 'Option';
var $d0d3f115c612996a$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $d0d3f115c612996a$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($d0d3f115c612996a$export$e56af863d5645d5f(x) ? $d0d3f115c612996a$export$e56af863d5645d5f(y) : $d0d3f115c612996a$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $d0d3f115c612996a$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $d0d3f115c612996a$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $d0d3f115c612996a$export$5d7e502287836e58(x) ? $d0d3f115c612996a$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $d0d3f115c612996a$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $d0d3f115c612996a$export$e56af863d5645d5f(x) ? y : $d0d3f115c612996a$export$e56af863d5645d5f(y) ? x : $d0d3f115c612996a$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $d0d3f115c612996a$export$f883a24d5edde77c
    };
};
var $d0d3f115c612996a$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $d0d3f115c612996a$export$bd5b6bfc5fa2ee61 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map
};
var $d0d3f115c612996a$export$6554612db691658e = (0, $f5id0.dual)(2, (0, $hrfTw.as)($d0d3f115c612996a$export$bd5b6bfc5fa2ee61));
var $d0d3f115c612996a$export$9284b360ca18a0fd = (0, $hrfTw.asUnit)($d0d3f115c612996a$export$bd5b6bfc5fa2ee61);
var $d0d3f115c612996a$export$ba255e9e49e00608 = $d0d3f115c612996a$export$ad14ef4001db2bcd;
var $d0d3f115c612996a$export$59a71046037e6c20 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    of: $d0d3f115c612996a$export$ba255e9e49e00608
};
var $d0d3f115c612996a$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(fab) ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $d0d3f115c612996a$export$efc21ddc6aeb363d = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    ap: $d0d3f115c612996a$var$_ap
};
var $d0d3f115c612996a$export$1279d2b7807629fd = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    ap: $d0d3f115c612996a$var$_ap,
    of: $d0d3f115c612996a$export$ba255e9e49e00608
};
var $d0d3f115c612996a$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? $d0d3f115c612996a$export$f883a24d5edde77c : f(ma.value);
});
var $d0d3f115c612996a$export$f18d5acc27d70423 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    ap: $d0d3f115c612996a$var$_ap,
    chain: $d0d3f115c612996a$export$5b8affa63fc6df16
};
var $d0d3f115c612996a$export$fb641926d034ac7d = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    ap: $d0d3f115c612996a$var$_ap,
    of: $d0d3f115c612996a$export$ba255e9e49e00608,
    chain: $d0d3f115c612996a$export$5b8affa63fc6df16
};
var $d0d3f115c612996a$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $d0d3f115c612996a$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $d0d3f115c612996a$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $d0d3f115c612996a$export$41404b31838667c9 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    reduce: $d0d3f115c612996a$var$_reduce,
    foldMap: $d0d3f115c612996a$var$_foldMap,
    reduceRight: $d0d3f115c612996a$var$_reduceRight
};
var $d0d3f115c612996a$export$41d1a04d78e7b141 = (0, $f5id0.dual)(2, function(self, that) {
    return $d0d3f115c612996a$export$e56af863d5645d5f(self) ? that() : self;
});
var $d0d3f115c612996a$export$1517cca7889d6aaa = $d0d3f115c612996a$export$41d1a04d78e7b141;
var $d0d3f115c612996a$export$228be17d80722ab = $d0d3f115c612996a$export$41d1a04d78e7b141;
var $d0d3f115c612996a$export$25ba4469a069167 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    alt: $d0d3f115c612996a$var$_alt
};
var $d0d3f115c612996a$export$7f9972325ebfd559 = function() {
    return $d0d3f115c612996a$export$f883a24d5edde77c;
};
var $d0d3f115c612996a$export$aaef8a3eae948f03 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    zero: $d0d3f115c612996a$export$7f9972325ebfd559
};
var $d0d3f115c612996a$export$864d727b48066337 = /*#__PURE__*/ (0, $gJWAH.guard)($d0d3f115c612996a$export$aaef8a3eae948f03, $d0d3f115c612996a$export$59a71046037e6c20);
var $d0d3f115c612996a$export$4acb47accde578d2 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    ap: $d0d3f115c612996a$var$_ap,
    of: $d0d3f115c612996a$export$ba255e9e49e00608,
    alt: $d0d3f115c612996a$var$_alt,
    zero: $d0d3f115c612996a$export$7f9972325ebfd559
};
var $d0d3f115c612996a$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(wa) ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$ad14ef4001db2bcd(f(wa));
    };
};
var $d0d3f115c612996a$export$5b5dd0e212d2a5bc = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    extend: $d0d3f115c612996a$var$_extend
};
var $d0d3f115c612996a$export$8e16b83750b44988 = /*#__PURE__*/ $d0d3f115c612996a$export$5b8affa63fc6df16((0, $f5id0.identity));
var $d0d3f115c612996a$var$defaultSeparated = /*#__PURE__*/ (0, $bFSl4.separated)($d0d3f115c612996a$export$f883a24d5edde77c, $d0d3f115c612996a$export$f883a24d5edde77c);
var $d0d3f115c612996a$export$709f6946f4e97408 = function(ma) {
    return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? $d0d3f115c612996a$var$defaultSeparated : (0, $bFSl4.separated)($d0d3f115c612996a$export$da405662c16fca8e(ma.value), $d0d3f115c612996a$export$482f3615ecf01dc6(ma.value));
};
var $d0d3f115c612996a$export$4a21ac48141ac3c9 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    compact: $d0d3f115c612996a$export$8e16b83750b44988,
    separate: $d0d3f115c612996a$export$709f6946f4e97408
};
var $d0d3f115c612996a$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? $d0d3f115c612996a$export$f883a24d5edde77c : predicate(fa.value) ? fa : $d0d3f115c612996a$export$f883a24d5edde77c;
    };
};
var $d0d3f115c612996a$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(fa) ? $d0d3f115c612996a$export$f883a24d5edde77c : f(fa.value);
    };
};
var $d0d3f115c612996a$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $bFSl4.separated)($d0d3f115c612996a$var$_filter(fa, (0, $IYheM.not)(predicate)), $d0d3f115c612996a$var$_filter(fa, predicate));
    };
};
var $d0d3f115c612996a$export$3117e3f9ececb6bc = function(f) {
    return (0, $f5id0.flow)($d0d3f115c612996a$export$871de8747c9eaa88(f), $d0d3f115c612996a$export$709f6946f4e97408);
};
var $d0d3f115c612996a$export$d00e1c48fb621173 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    compact: $d0d3f115c612996a$export$8e16b83750b44988,
    separate: $d0d3f115c612996a$export$709f6946f4e97408,
    filter: $d0d3f115c612996a$var$_filter,
    filterMap: $d0d3f115c612996a$var$_filterMap,
    partition: $d0d3f115c612996a$var$_partition,
    partitionMap: $d0d3f115c612996a$var$_partitionMap
};
var $d0d3f115c612996a$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $d0d3f115c612996a$export$e56af863d5645d5f(ta) ? F.of($d0d3f115c612996a$export$f883a24d5edde77c) : F.map(f(ta.value), $d0d3f115c612996a$export$ad14ef4001db2bcd);
        };
    };
};
var $d0d3f115c612996a$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(ta) ? F.of($d0d3f115c612996a$export$f883a24d5edde77c) : F.map(ta.value, $d0d3f115c612996a$export$ad14ef4001db2bcd);
    };
};
var $d0d3f115c612996a$export$a0202666c3bda011 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    reduce: $d0d3f115c612996a$var$_reduce,
    foldMap: $d0d3f115c612996a$var$_foldMap,
    reduceRight: $d0d3f115c612996a$var$_reduceRight,
    traverse: $d0d3f115c612996a$var$_traverse,
    sequence: $d0d3f115c612996a$export$49bb65c2ea163039
};
var $d0d3f115c612996a$var$_wither = /*#__PURE__*/ (0, $erGUW.witherDefault)($d0d3f115c612996a$export$a0202666c3bda011, $d0d3f115c612996a$export$4a21ac48141ac3c9);
var $d0d3f115c612996a$var$_wilt = /*#__PURE__*/ (0, $erGUW.wiltDefault)($d0d3f115c612996a$export$a0202666c3bda011, $d0d3f115c612996a$export$4a21ac48141ac3c9);
var $d0d3f115c612996a$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $d0d3f115c612996a$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $d0d3f115c612996a$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $d0d3f115c612996a$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $d0d3f115c612996a$export$748d317b4c426f96 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    reduce: $d0d3f115c612996a$var$_reduce,
    foldMap: $d0d3f115c612996a$var$_foldMap,
    reduceRight: $d0d3f115c612996a$var$_reduceRight,
    traverse: $d0d3f115c612996a$var$_traverse,
    sequence: $d0d3f115c612996a$export$49bb65c2ea163039,
    compact: $d0d3f115c612996a$export$8e16b83750b44988,
    separate: $d0d3f115c612996a$export$709f6946f4e97408,
    filter: $d0d3f115c612996a$var$_filter,
    filterMap: $d0d3f115c612996a$var$_filterMap,
    partition: $d0d3f115c612996a$var$_partition,
    partitionMap: $d0d3f115c612996a$var$_partitionMap,
    wither: $d0d3f115c612996a$var$_wither,
    wilt: $d0d3f115c612996a$var$_wilt
};
var $d0d3f115c612996a$export$8bf7aba4a9e09055 = function() {
    return $d0d3f115c612996a$export$f883a24d5edde77c;
};
var $d0d3f115c612996a$export$5f956d47d0619c3a = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    ap: $d0d3f115c612996a$var$_ap,
    of: $d0d3f115c612996a$export$ba255e9e49e00608,
    chain: $d0d3f115c612996a$export$5b8affa63fc6df16,
    throwError: $d0d3f115c612996a$export$8bf7aba4a9e09055
};
var $d0d3f115c612996a$export$80c878c9b1d77917 = $d0d3f115c612996a$export$482f3615ecf01dc6;
var $d0d3f115c612996a$export$825ea6cb6fc48d49 = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    fromEither: $d0d3f115c612996a$export$80c878c9b1d77917
};
var $d0d3f115c612996a$export$5d7e502287836e58 = $aByOK.isSome;
var $d0d3f115c612996a$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $d0d3f115c612996a$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $d0d3f115c612996a$export$ccb09033cefa61e8 = $d0d3f115c612996a$export$2d55ea551c238330;
var $d0d3f115c612996a$export$4659b591c19bdf3d = $d0d3f115c612996a$export$2d55ea551c238330;
var $d0d3f115c612996a$export$93e2b83da34ff82a = $d0d3f115c612996a$export$4659b591c19bdf3d;
var $d0d3f115c612996a$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $d0d3f115c612996a$export$8832081647a02ee7 = $d0d3f115c612996a$export$d8a997ff0e6436f3;
var $d0d3f115c612996a$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($d0d3f115c612996a$export$bd5b6bfc5fa2ee61);
var $d0d3f115c612996a$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($d0d3f115c612996a$export$efc21ddc6aeb363d);
var $d0d3f115c612996a$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($d0d3f115c612996a$export$efc21ddc6aeb363d);
var $d0d3f115c612996a$export$bffa455ba8c619a6 = $d0d3f115c612996a$export$8e16b83750b44988;
var $d0d3f115c612996a$export$3f23594af5f37336 = /*#__PURE__*/ (0, $f5id0.dual)(2, $lcDVT.tap($d0d3f115c612996a$export$f18d5acc27d70423));
var $d0d3f115c612996a$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $ctkBN.tapEither)($d0d3f115c612996a$export$825ea6cb6fc48d49, $d0d3f115c612996a$export$f18d5acc27d70423));
var $d0d3f115c612996a$export$ecd5e8ace626722c = /*#__PURE__*/ $d0d3f115c612996a$export$8b58be045bf06082((0, $f5id0.identity));
var $d0d3f115c612996a$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $ctkBN.fromEitherK)($d0d3f115c612996a$export$825ea6cb6fc48d49);
var $d0d3f115c612996a$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $ctkBN.chainEitherK)($d0d3f115c612996a$export$825ea6cb6fc48d49, $d0d3f115c612996a$export$f18d5acc27d70423);
var $d0d3f115c612996a$export$c5f2bdbf9b43f0c0 = $d0d3f115c612996a$export$be3ff275bb5a8ac9;
var $d0d3f115c612996a$export$b601f49376b4621a = function(a) {
    return a == null ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$ad14ef4001db2bcd(a);
};
var $d0d3f115c612996a$export$d234c058d1d4e435 = function(f) {
    try {
        return $d0d3f115c612996a$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $d0d3f115c612996a$export$f883a24d5edde77c;
    }
};
var $d0d3f115c612996a$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $d0d3f115c612996a$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $d0d3f115c612996a$export$c69ca7b73fad45e1 = function(f) {
    return (0, $f5id0.flow)(f, $d0d3f115c612996a$export$b601f49376b4621a);
};
var $d0d3f115c612996a$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? $d0d3f115c612996a$export$f883a24d5edde77c : $d0d3f115c612996a$export$b601f49376b4621a(f(ma.value));
    };
};
var $d0d3f115c612996a$export$b187f57ee1822bc5 = /*#__PURE__*/ $d0d3f115c612996a$export$4659b591c19bdf3d((0, $f5id0.constNull), (0, $f5id0.identity));
var $d0d3f115c612996a$export$cb585b8513fa8577 = /*#__PURE__*/ $d0d3f115c612996a$export$4659b591c19bdf3d((0, $f5id0.constUndefined), (0, $f5id0.identity));
function $d0d3f115c612996a$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $d0d3f115c612996a$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $d0d3f115c612996a$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $d0d3f115c612996a$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $d0d3f115c612996a$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $d0d3f115c612996a$export$ba255e9e49e00608($aByOK.emptyRecord);
var $d0d3f115c612996a$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($d0d3f115c612996a$export$bd5b6bfc5fa2ee61);
var $d0d3f115c612996a$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($d0d3f115c612996a$export$bd5b6bfc5fa2ee61);
var $d0d3f115c612996a$export$2385a24977818dd0 = /*#__PURE__*/ $lcDVT.bind($d0d3f115c612996a$export$f18d5acc27d70423);
var $d0d3f115c612996a$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($d0d3f115c612996a$export$efc21ddc6aeb363d);
var $d0d3f115c612996a$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $d0d3f115c612996a$export$ba255e9e49e00608($aByOK.emptyReadonlyArray);
var $d0d3f115c612996a$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $aByOK.head(as));
        if ($d0d3f115c612996a$export$e56af863d5645d5f(o)) return $d0d3f115c612996a$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($d0d3f115c612996a$export$e56af863d5645d5f(o_1)) return $d0d3f115c612996a$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $d0d3f115c612996a$export$ad14ef4001db2bcd(out);
    };
};
var $d0d3f115c612996a$export$d4e79db5dc14cc1 = function(f) {
    var g = $d0d3f115c612996a$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $d0d3f115c612996a$export$c74b6e34b2b6efb0;
    };
};
var $d0d3f115c612996a$export$104a2841e9cbad06 = $d0d3f115c612996a$export$d4e79db5dc14cc1;
var $d0d3f115c612996a$export$64f39b2a2b79e1b1 = function(f) {
    return $d0d3f115c612996a$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $d0d3f115c612996a$export$d330b60315c14cd1 = /*#__PURE__*/ $d0d3f115c612996a$export$64f39b2a2b79e1b1((0, $f5id0.identity));
var $d0d3f115c612996a$export$e08e3b67e392101e = $d0d3f115c612996a$export$5b8affa63fc6df16;
var $d0d3f115c612996a$export$e3821ef4970c339c = $d0d3f115c612996a$export$3f23594af5f37336;
function $d0d3f115c612996a$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $d0d3f115c612996a$export$5d7e502287836e58(getOption(a));
    };
}
var $d0d3f115c612996a$export$c2a8dfc107523e74 = $d0d3f115c612996a$export$c81f992c08fd0bf3;
var $d0d3f115c612996a$export$a75d1723e6bda2ec = {
    URI: $d0d3f115c612996a$export$9156e739aa33e19f,
    map: $d0d3f115c612996a$var$_map,
    of: $d0d3f115c612996a$export$ba255e9e49e00608,
    ap: $d0d3f115c612996a$var$_ap,
    chain: $d0d3f115c612996a$export$5b8affa63fc6df16,
    reduce: $d0d3f115c612996a$var$_reduce,
    foldMap: $d0d3f115c612996a$var$_foldMap,
    reduceRight: $d0d3f115c612996a$var$_reduceRight,
    traverse: $d0d3f115c612996a$var$_traverse,
    sequence: $d0d3f115c612996a$export$49bb65c2ea163039,
    zero: $d0d3f115c612996a$export$7f9972325ebfd559,
    alt: $d0d3f115c612996a$var$_alt,
    extend: $d0d3f115c612996a$var$_extend,
    compact: $d0d3f115c612996a$export$8e16b83750b44988,
    separate: $d0d3f115c612996a$export$709f6946f4e97408,
    filter: $d0d3f115c612996a$var$_filter,
    filterMap: $d0d3f115c612996a$var$_filterMap,
    partition: $d0d3f115c612996a$var$_partition,
    partitionMap: $d0d3f115c612996a$var$_partitionMap,
    wither: $d0d3f115c612996a$var$_wither,
    wilt: $d0d3f115c612996a$var$_wilt,
    throwError: $d0d3f115c612996a$export$8bf7aba4a9e09055
};
var $d0d3f115c612996a$export$18979a515d2a828e = /*#__PURE__*/ (0, $6IQDS.getApplySemigroup)($d0d3f115c612996a$export$efc21ddc6aeb363d);
var $d0d3f115c612996a$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $6jM4Q.getApplicativeMonoid)($d0d3f115c612996a$export$1279d2b7807629fd);
var $d0d3f115c612996a$export$56cd0d85e73e688f = function() {
    return $d0d3f115c612996a$export$c2a7ef2cc9b32b31((0, $i0LNv.first)());
};
var $d0d3f115c612996a$export$ca391a563a1f3001 = function() {
    return $d0d3f115c612996a$export$c2a7ef2cc9b32b31((0, $i0LNv.last)());
};

});
parcelRegister("6jM4Q", function(module, exports) {

$parcel$export(module.exports, "getApplicativeMonoid", function () { return $4999cf86d1e86c99$export$c8e1a8ea383fd0ff; });
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 
var $6IQDS = parcelRequire("6IQDS");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");
function $4999cf86d1e86c99$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $6IQDS.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $4999cf86d1e86c99$export$9833a940afed18f3(F, G) {
    var map = (0, $hrfTw.getFunctorComposition)(F, G).map;
    var _ap = (0, $6IQDS.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $f5id0.pipe)(fgab, _ap(fga));
        }
    };
}

});

parcelRegister("IYheM", function(module, exports) {

$parcel$export(module.exports, "contramap", function () { return $0872ddefb7b8e8ca$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "URI", function () { return $0872ddefb7b8e8ca$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getSemigroupAny", function () { return $0872ddefb7b8e8ca$export$45c71cec3a7e90aa; });
$parcel$export(module.exports, "or", function () { return $0872ddefb7b8e8ca$export$252bb8b3bbdf6749; });
$parcel$export(module.exports, "getMonoidAny", function () { return $0872ddefb7b8e8ca$export$d795ff673668f564; });
$parcel$export(module.exports, "getSemigroupAll", function () { return $0872ddefb7b8e8ca$export$d900a29579818780; });
$parcel$export(module.exports, "and", function () { return $0872ddefb7b8e8ca$export$21c0ac7fe1cef1b8; });
$parcel$export(module.exports, "getMonoidAll", function () { return $0872ddefb7b8e8ca$export$4c43b04d78b174fa; });
$parcel$export(module.exports, "Contravariant", function () { return $0872ddefb7b8e8ca$export$def901a57d5539c3; });
$parcel$export(module.exports, "not", function () { return $0872ddefb7b8e8ca$export$6003a5f097c73977; });

var $f5id0 = parcelRequire("f5id0");
var $0872ddefb7b8e8ca$var$contramap_ = function(predicate, f) {
    return (0, $f5id0.pipe)(predicate, $0872ddefb7b8e8ca$export$53b696d27ecb7ba7(f));
};
var $0872ddefb7b8e8ca$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $f5id0.flow)(f, predicate);
    };
};
var $0872ddefb7b8e8ca$export$9156e739aa33e19f = 'Predicate';
var $0872ddefb7b8e8ca$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $f5id0.pipe)(first, $0872ddefb7b8e8ca$export$252bb8b3bbdf6749(second));
        }
    };
};
var $0872ddefb7b8e8ca$export$d795ff673668f564 = function() {
    return {
        concat: $0872ddefb7b8e8ca$export$45c71cec3a7e90aa().concat,
        empty: (0, $f5id0.constFalse)
    };
};
var $0872ddefb7b8e8ca$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $f5id0.pipe)(first, $0872ddefb7b8e8ca$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $0872ddefb7b8e8ca$export$4c43b04d78b174fa = function() {
    return {
        concat: $0872ddefb7b8e8ca$export$d900a29579818780().concat,
        empty: (0, $f5id0.constTrue)
    };
};
var $0872ddefb7b8e8ca$export$def901a57d5539c3 = {
    URI: $0872ddefb7b8e8ca$export$9156e739aa33e19f,
    contramap: $0872ddefb7b8e8ca$var$contramap_
};
var $0872ddefb7b8e8ca$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $0872ddefb7b8e8ca$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $0872ddefb7b8e8ca$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};

});


parcelRegister("4CZFO", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $35ea8d0f44ada3df$export$a4627e546088548d; });

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $f5id0 = parcelRequire("f5id0");
function $35ea8d0f44ada3df$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $35ea8d0f44ada3df$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $35ea8d0f44ada3df$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $35ea8d0f44ada3df$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $35ea8d0f44ada3df$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $35ea8d0f44ada3df$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $35ea8d0f44ada3df$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $35ea8d0f44ada3df$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $35ea8d0f44ada3df$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $35ea8d0f44ada3df$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $35ea8d0f44ada3df$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $35ea8d0f44ada3df$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $35ea8d0f44ada3df$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $35ea8d0f44ada3df$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $35ea8d0f44ada3df$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $35ea8d0f44ada3df$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $35ea8d0f44ada3df$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $35ea8d0f44ada3df$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $35ea8d0f44ada3df$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $35ea8d0f44ada3df$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $35ea8d0f44ada3df$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $35ea8d0f44ada3df$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $35ea8d0f44ada3df$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $35ea8d0f44ada3df$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $35ea8d0f44ada3df$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $35ea8d0f44ada3df$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $35ea8d0f44ada3df$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $35ea8d0f44ada3df$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $35ea8d0f44ada3df$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $35ea8d0f44ada3df$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $35ea8d0f44ada3df$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $35ea8d0f44ada3df$export$1124ffa357d27237(I) {
    var r = {};
    if ($35ea8d0f44ada3df$var$isFunctor(I)) r.map = $35ea8d0f44ada3df$export$871de8747c9eaa88(I);
    if ($35ea8d0f44ada3df$var$isContravariant(I)) r.contramap = $35ea8d0f44ada3df$export$53b696d27ecb7ba7(I);
    if ($35ea8d0f44ada3df$var$isFunctorWithIndex(I)) r.mapWithIndex = $35ea8d0f44ada3df$export$8f07ddce13659f50(I);
    if ($35ea8d0f44ada3df$var$isApply(I)) {
        r.ap = $35ea8d0f44ada3df$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $6IQDS.apFirst)(I);
        r.apSecond = (0, $6IQDS.apSecond)(I);
    }
    if ($35ea8d0f44ada3df$var$isChain(I)) {
        r.chain = $35ea8d0f44ada3df$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $lcDVT.chainFirst)(I);
        r.flatten = r.chain((0, $f5id0.identity));
    }
    if ($35ea8d0f44ada3df$var$isBifunctor(I)) {
        r.bimap = $35ea8d0f44ada3df$export$eb54baf0b342cb1d(I);
        r.mapLeft = $35ea8d0f44ada3df$export$472de43a55e4aa49(I);
    }
    if ($35ea8d0f44ada3df$var$isExtend(I)) {
        r.extend = $35ea8d0f44ada3df$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $f5id0.identity));
    }
    if ($35ea8d0f44ada3df$var$isFoldable(I)) {
        r.reduce = $35ea8d0f44ada3df$export$533b26079ad0b4b(I);
        r.foldMap = $35ea8d0f44ada3df$export$b66cdc0497d8a99a(I);
        r.reduceRight = $35ea8d0f44ada3df$export$7fef8bcdbb34f435(I);
    }
    if ($35ea8d0f44ada3df$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $35ea8d0f44ada3df$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $35ea8d0f44ada3df$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $35ea8d0f44ada3df$export$ce2b2fe0b88ccd0a(I);
    }
    if ($35ea8d0f44ada3df$var$isAlt(I)) r.alt = $35ea8d0f44ada3df$export$228be17d80722ab(I);
    if ($35ea8d0f44ada3df$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($35ea8d0f44ada3df$var$isFilterable(I)) {
        r.filter = $35ea8d0f44ada3df$export$3dea766d36a8935f(I);
        r.filterMap = $35ea8d0f44ada3df$export$a04c6c6965dd4709(I);
        r.partition = $35ea8d0f44ada3df$export$b29f828819edca8d(I);
        r.partitionMap = $35ea8d0f44ada3df$export$3117e3f9ececb6bc(I);
    }
    if ($35ea8d0f44ada3df$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $35ea8d0f44ada3df$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $35ea8d0f44ada3df$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $35ea8d0f44ada3df$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $35ea8d0f44ada3df$export$bc7c0794b9c6f3ba(I);
    }
    if ($35ea8d0f44ada3df$var$isProfunctor(I)) r.promap = $35ea8d0f44ada3df$export$6684e88861ab74ec(I);
    if ($35ea8d0f44ada3df$var$isSemigroupoid(I)) r.compose = $35ea8d0f44ada3df$export$f672e0b6f7222cd7(I);
    if ($35ea8d0f44ada3df$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $35ea8d0f44ada3df$export$a4627e546088548d = (0, $f5id0.pipe);

});

parcelRegister("lSSmc", function(module, exports) {

$parcel$export(module.exports, "fromIso", function () { return $fee8ce5109db2870$export$3160d47a1ad63980; });

var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");

var $4CDo2 = parcelRequire("4CDo2");

var $3JkJJ = parcelRequire("3JkJJ");

var $ljPND = parcelRequire("ljPND");
var $fee8ce5109db2870$export$493d36ec626b6698 = $ljPND.at;
var $fee8ce5109db2870$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $fee8ce5109db2870$export$493d36ec626b6698(function(i) {
            return (0, $4CZFO.pipe)(iso, $ljPND.isoAsLens, $ljPND.lensComposeLens(sia.at(i)));
        });
    };
};
var $fee8ce5109db2870$export$ba8573d258bae607 = $ljPND.atReadonlyRecord;
var $fee8ce5109db2870$export$3d6583cb45ca961e = function(E) {
    var lookupE = $4CDo2.lookup(E);
    var deleteAtE = $4CDo2.deleteAt(E);
    var insertAtE = $4CDo2.insertAt(E);
    return function() {
        return $fee8ce5109db2870$export$493d36ec626b6698(function(key) {
            return $ljPND.lens(function(s) {
                return lookupE(key, s);
            }, $hVAkz.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $fee8ce5109db2870$export$388a7d8e51ea972f = function(E) {
    var elemE = $3JkJJ.elem(E);
    var insertE = $3JkJJ.insert(E);
    var removeE = $3JkJJ.remove(E);
    return $fee8ce5109db2870$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $ljPND.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $fee8ce5109db2870$export$1cfc761eca4929a9 = $ljPND.atReadonlyRecord;

});
parcelRegister("4CDo2", function(module, exports) {

$parcel$export(module.exports, "fromMap", function () { return $35d9436b17a9faa7$export$d81aa96f14f987cc; });
$parcel$export(module.exports, "toMap", function () { return $35d9436b17a9faa7$export$e98af36a72b77685; });
$parcel$export(module.exports, "getShow", function () { return $35d9436b17a9faa7$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "size", function () { return $35d9436b17a9faa7$export$346677f925de839c; });
$parcel$export(module.exports, "isEmpty", function () { return $35d9436b17a9faa7$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "member", function () { return $35d9436b17a9faa7$export$6a0d13241802fe80; });
$parcel$export(module.exports, "lookup", function () { return $35d9436b17a9faa7$export$dfc7155ac0343b8; });
$parcel$export(module.exports, "elem", function () { return $35d9436b17a9faa7$export$5bf96401662340b7; });
$parcel$export(module.exports, "keys", function () { return $35d9436b17a9faa7$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $35d9436b17a9faa7$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "collect", function () { return $35d9436b17a9faa7$export$bb44f104e3c54dae; });
$parcel$export(module.exports, "toReadonlyArray", function () { return $35d9436b17a9faa7$export$4aaa3912a3956cb7; });
$parcel$export(module.exports, "toUnfoldable", function () { return $35d9436b17a9faa7$export$823be24f8766da23; });
$parcel$export(module.exports, "upsertAt", function () { return $35d9436b17a9faa7$export$ff82449ce381c54a; });
$parcel$export(module.exports, "lookupWithKey", function () { return $35d9436b17a9faa7$export$40b8019a6fc8a5ae; });
$parcel$export(module.exports, "deleteAt", function () { return $35d9436b17a9faa7$export$90f9093465da3136; });
$parcel$export(module.exports, "updateAt", function () { return $35d9436b17a9faa7$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $35d9436b17a9faa7$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "pop", function () { return $35d9436b17a9faa7$export$3e41007ebfff0e64; });
$parcel$export(module.exports, "isSubmap", function () { return $35d9436b17a9faa7$export$35d0420a84c5d3ae; });
$parcel$export(module.exports, "empty", function () { return $35d9436b17a9faa7$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "getEq", function () { return $35d9436b17a9faa7$export$804fed467fde44e4; });
$parcel$export(module.exports, "getMonoid", function () { return $35d9436b17a9faa7$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "singleton", function () { return $35d9436b17a9faa7$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "fromFoldable", function () { return $35d9436b17a9faa7$export$b7d5d9bb9ff52072; });
$parcel$export(module.exports, "partitionMapWithIndex", function () { return $35d9436b17a9faa7$export$bc7c0794b9c6f3ba; });
$parcel$export(module.exports, "partitionWithIndex", function () { return $35d9436b17a9faa7$export$dad5e500f2bab9bc; });
$parcel$export(module.exports, "filterMapWithIndex", function () { return $35d9436b17a9faa7$export$30c5cbe848021e97; });
$parcel$export(module.exports, "filterWithIndex", function () { return $35d9436b17a9faa7$export$36e42aef19fc7171; });
$parcel$export(module.exports, "compact", function () { return $35d9436b17a9faa7$export$8e16b83750b44988; });
$parcel$export(module.exports, "filter", function () { return $35d9436b17a9faa7$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $35d9436b17a9faa7$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "map", function () { return $35d9436b17a9faa7$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithIndex", function () { return $35d9436b17a9faa7$export$8f07ddce13659f50; });
$parcel$export(module.exports, "partition", function () { return $35d9436b17a9faa7$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $35d9436b17a9faa7$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "separate", function () { return $35d9436b17a9faa7$export$709f6946f4e97408; });
$parcel$export(module.exports, "URI", function () { return $35d9436b17a9faa7$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $35d9436b17a9faa7$export$baca17b4aff42f82; });
$parcel$export(module.exports, "union", function () { return $35d9436b17a9faa7$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $35d9436b17a9faa7$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $35d9436b17a9faa7$export$d379a869a72e4055; });
$parcel$export(module.exports, "intersection", function () { return $35d9436b17a9faa7$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $35d9436b17a9faa7$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "difference", function () { return $35d9436b17a9faa7$export$acaf96a27438246b; });
$parcel$export(module.exports, "getFilterableWithIndex", function () { return $35d9436b17a9faa7$export$d600270efcad85ac; });
$parcel$export(module.exports, "Functor", function () { return $35d9436b17a9faa7$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $35d9436b17a9faa7$export$18c957606d8bdf09; });
$parcel$export(module.exports, "getFunctorWithIndex", function () { return $35d9436b17a9faa7$export$7c7748da5f3db60f; });
$parcel$export(module.exports, "Compactable", function () { return $35d9436b17a9faa7$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $35d9436b17a9faa7$export$d00e1c48fb621173; });
$parcel$export(module.exports, "reduce", function () { return $35d9436b17a9faa7$export$533b26079ad0b4b; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $35d9436b17a9faa7$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMap", function () { return $35d9436b17a9faa7$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $35d9436b17a9faa7$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRight", function () { return $35d9436b17a9faa7$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $35d9436b17a9faa7$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "getFoldable", function () { return $35d9436b17a9faa7$export$d544f02c7cebdaed; });
$parcel$export(module.exports, "getFoldableWithIndex", function () { return $35d9436b17a9faa7$export$6c59d75f118e7bc9; });
$parcel$export(module.exports, "getTraversable", function () { return $35d9436b17a9faa7$export$4e0ffba11065d2c1; });
$parcel$export(module.exports, "getTraversableWithIndex", function () { return $35d9436b17a9faa7$export$46b81797a3375b8c; });
$parcel$export(module.exports, "getWitherable", function () { return $35d9436b17a9faa7$export$bb8ef26a634cac7b; });
$parcel$export(module.exports, "insertAt", function () { return $35d9436b17a9faa7$export$9f200c4466975173; });
$parcel$export(module.exports, "readonlyMap", function () { return $35d9436b17a9faa7$export$28562fb56044e6b5; });

var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $hVAkz = parcelRequire("hVAkz");

var $bFSl4 = parcelRequire("bFSl4");

var $erGUW = parcelRequire("erGUW");
var $35d9436b17a9faa7$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $35d9436b17a9faa7$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $35d9436b17a9faa7$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $35d9436b17a9faa7$export$346677f925de839c = function(m) {
    return m.size;
};
var $35d9436b17a9faa7$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $35d9436b17a9faa7$export$6a0d13241802fe80(E) {
    var lookupE = $35d9436b17a9faa7$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $35d9436b17a9faa7$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $aByOK.isSome(lookupE(k, m));
    };
}
function $35d9436b17a9faa7$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $35d9436b17a9faa7$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $35d9436b17a9faa7$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $35d9436b17a9faa7$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $35d9436b17a9faa7$export$bb44f104e3c54dae(O) {
    var keysO = $35d9436b17a9faa7$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $35d9436b17a9faa7$export$4aaa3912a3956cb7 = function(O) {
    return $35d9436b17a9faa7$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $35d9436b17a9faa7$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $35d9436b17a9faa7$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $aByOK.some([
                kas[b],
                b + 1
            ]) : $aByOK.none;
        });
    };
}
var $35d9436b17a9faa7$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($aByOK.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $35d9436b17a9faa7$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($aByOK.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $35d9436b17a9faa7$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $35d9436b17a9faa7$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $35d9436b17a9faa7$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($aByOK.isNone(found)) return $aByOK.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $aByOK.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $aByOK.some(r);
        };
    };
};
function $35d9436b17a9faa7$export$3e41007ebfff0e64(E) {
    var lookupE = $35d9436b17a9faa7$export$dfc7155ac0343b8(E);
    var deleteAtE = $35d9436b17a9faa7$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $f5id0.pipe)(lookupE(k, m), $hVAkz.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $aByOK.some([
                ka,
                a
            ]);
        }
        return $aByOK.none;
    };
}
function $35d9436b17a9faa7$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $35d9436b17a9faa7$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $f5id0.pipe)(lookupWithKeyE(k, m), $hVAkz.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $35d9436b17a9faa7$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $35d9436b17a9faa7$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($aByOK.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $35d9436b17a9faa7$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $35d9436b17a9faa7$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $35d9436b17a9faa7$export$35d0420a84c5d3ae(SK, SA);
    return (0, $kJAjV.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $35d9436b17a9faa7$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(mx)) return my;
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($aByOK.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $35d9436b17a9faa7$export$6e22c362a0406a2c
    };
}
var $35d9436b17a9faa7$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $35d9436b17a9faa7$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $35d9436b17a9faa7$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($aByOK.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $35d9436b17a9faa7$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $35d9436b17a9faa7$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($aByOK.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $bFSl4.separated)(left, right);
    };
};
function $35d9436b17a9faa7$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $bFSl4.separated)(left, right);
    };
}
var $35d9436b17a9faa7$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($aByOK.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $35d9436b17a9faa7$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $35d9436b17a9faa7$var$_map = function(fa, f) {
    return $35d9436b17a9faa7$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $35d9436b17a9faa7$var$_filter = function(fa, p) {
    return $35d9436b17a9faa7$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $35d9436b17a9faa7$var$_filterMap = function(fa, f) {
    return $35d9436b17a9faa7$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $35d9436b17a9faa7$var$_partition = function(fa, predicate) {
    return $35d9436b17a9faa7$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $35d9436b17a9faa7$var$_partitionMap = function(fa, f) {
    return $35d9436b17a9faa7$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $35d9436b17a9faa7$var$_filterWithIndex = function(fa, p) {
    return (0, $f5id0.pipe)(fa, $35d9436b17a9faa7$export$36e42aef19fc7171(p));
};
var $35d9436b17a9faa7$var$_filterMapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $35d9436b17a9faa7$export$30c5cbe848021e97(f));
};
var $35d9436b17a9faa7$var$_partitionWithIndex = function(fa, p) {
    return (0, $f5id0.pipe)(fa, $35d9436b17a9faa7$export$dad5e500f2bab9bc(p));
};
var $35d9436b17a9faa7$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $35d9436b17a9faa7$export$bc7c0794b9c6f3ba(f));
};
var $35d9436b17a9faa7$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($aByOK.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
var $35d9436b17a9faa7$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $35d9436b17a9faa7$var$_filter(fa, predicate);
    };
};
var $35d9436b17a9faa7$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $35d9436b17a9faa7$var$_filterMap(fa, f);
    };
};
var $35d9436b17a9faa7$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $35d9436b17a9faa7$var$_map(fa, f);
    };
};
var $35d9436b17a9faa7$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $35d9436b17a9faa7$var$_mapWithIndex(fa, f);
    };
};
var $35d9436b17a9faa7$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $35d9436b17a9faa7$var$_partition(fa, predicate);
    };
};
var $35d9436b17a9faa7$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $35d9436b17a9faa7$var$_partitionMap(fa, f);
    };
};
var $35d9436b17a9faa7$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($aByOK.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $bFSl4.separated)(left, right);
};
var $35d9436b17a9faa7$export$9156e739aa33e19f = 'ReadonlyMap';
var $35d9436b17a9faa7$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $35d9436b17a9faa7$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $35d9436b17a9faa7$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $35d9436b17a9faa7$export$baca17b4aff42f82(E, S).concat,
        empty: $35d9436b17a9faa7$export$6e22c362a0406a2c
    };
};
var $35d9436b17a9faa7$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $35d9436b17a9faa7$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $35d9436b17a9faa7$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $35d9436b17a9faa7$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $35d9436b17a9faa7$export$d600270efcad85ac() {
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        map: $35d9436b17a9faa7$var$_map,
        mapWithIndex: $35d9436b17a9faa7$var$_mapWithIndex,
        compact: $35d9436b17a9faa7$export$8e16b83750b44988,
        separate: $35d9436b17a9faa7$export$709f6946f4e97408,
        filter: $35d9436b17a9faa7$var$_filter,
        filterMap: $35d9436b17a9faa7$var$_filterMap,
        partition: $35d9436b17a9faa7$var$_partition,
        partitionMap: $35d9436b17a9faa7$var$_partitionMap,
        partitionMapWithIndex: $35d9436b17a9faa7$var$_partitionMapWithIndex,
        partitionWithIndex: $35d9436b17a9faa7$var$_partitionWithIndex,
        filterMapWithIndex: $35d9436b17a9faa7$var$_filterMapWithIndex,
        filterWithIndex: $35d9436b17a9faa7$var$_filterWithIndex
    };
}
var $35d9436b17a9faa7$export$bd5b6bfc5fa2ee61 = {
    URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
    map: $35d9436b17a9faa7$var$_map
};
var $35d9436b17a9faa7$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($35d9436b17a9faa7$export$bd5b6bfc5fa2ee61);
var $35d9436b17a9faa7$export$7c7748da5f3db60f = function() {
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        map: $35d9436b17a9faa7$var$_map,
        mapWithIndex: $35d9436b17a9faa7$var$_mapWithIndex
    };
};
var $35d9436b17a9faa7$export$4a21ac48141ac3c9 = {
    URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
    compact: $35d9436b17a9faa7$export$8e16b83750b44988,
    separate: $35d9436b17a9faa7$export$709f6946f4e97408
};
var $35d9436b17a9faa7$export$d00e1c48fb621173 = {
    URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
    map: $35d9436b17a9faa7$var$_map,
    compact: $35d9436b17a9faa7$export$8e16b83750b44988,
    separate: $35d9436b17a9faa7$export$709f6946f4e97408,
    filter: $35d9436b17a9faa7$var$_filter,
    filterMap: $35d9436b17a9faa7$var$_filterMap,
    partition: $35d9436b17a9faa7$var$_partition,
    partitionMap: $35d9436b17a9faa7$var$_partitionMap
};
var $35d9436b17a9faa7$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $35d9436b17a9faa7$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $35d9436b17a9faa7$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $35d9436b17a9faa7$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $35d9436b17a9faa7$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $35d9436b17a9faa7$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $35d9436b17a9faa7$export$d544f02c7cebdaed = function(O) {
    var reduceO = $35d9436b17a9faa7$export$533b26079ad0b4b(O);
    var foldMapO = $35d9436b17a9faa7$export$b66cdc0497d8a99a(O);
    var reduceRightO = $35d9436b17a9faa7$export$7fef8bcdbb34f435(O);
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $f5id0.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $f5id0.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $f5id0.pipe)(fa, reduceRightO(b, f));
        }
    };
};
var $35d9436b17a9faa7$export$bbd3ef8720e22369 = function(O) {
    var keysO = $35d9436b17a9faa7$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $35d9436b17a9faa7$export$18153bb1181268e5 = function(O) {
    var keysO = $35d9436b17a9faa7$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $35d9436b17a9faa7$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $35d9436b17a9faa7$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $35d9436b17a9faa7$export$6c59d75f118e7bc9 = function(O) {
    var F = $35d9436b17a9faa7$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $35d9436b17a9faa7$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $35d9436b17a9faa7$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $35d9436b17a9faa7$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $f5id0.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $f5id0.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $f5id0.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $35d9436b17a9faa7$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $35d9436b17a9faa7$export$46b81797a3375b8c(O);
    var F = $35d9436b17a9faa7$export$d544f02c7cebdaed(O);
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        map: $35d9436b17a9faa7$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $35d9436b17a9faa7$export$46b81797a3375b8c = function(O) {
    var FWI = $35d9436b17a9faa7$export$6c59d75f118e7bc9(O);
    var keysO = $35d9436b17a9faa7$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $f5id0.SK));
        };
    };
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        map: $35d9436b17a9faa7$var$_map,
        mapWithIndex: $35d9436b17a9faa7$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $35d9436b17a9faa7$export$bb8ef26a634cac7b(O) {
    var TWI = $35d9436b17a9faa7$export$46b81797a3375b8c(O);
    return {
        URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
        _E: undefined,
        map: $35d9436b17a9faa7$var$_map,
        compact: $35d9436b17a9faa7$export$8e16b83750b44988,
        separate: $35d9436b17a9faa7$export$709f6946f4e97408,
        filter: $35d9436b17a9faa7$var$_filter,
        filterMap: $35d9436b17a9faa7$var$_filterMap,
        partition: $35d9436b17a9faa7$var$_partition,
        partitionMap: $35d9436b17a9faa7$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $35d9436b17a9faa7$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $erGUW.wiltDefault)(TWI, $35d9436b17a9faa7$export$4a21ac48141ac3c9),
        wither: (0, $erGUW.witherDefault)(TWI, $35d9436b17a9faa7$export$4a21ac48141ac3c9)
    };
}
var $35d9436b17a9faa7$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $35d9436b17a9faa7$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(first)) return second;
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($aByOK.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($aByOK.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $35d9436b17a9faa7$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $35d9436b17a9faa7$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(first) || $35d9436b17a9faa7$export$dd1bc94b04021eeb(second)) return $35d9436b17a9faa7$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($aByOK.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $35d9436b17a9faa7$export$acaf96a27438246b = function(E) {
    var memberE = $35d9436b17a9faa7$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(first)) return second;
            if ($35d9436b17a9faa7$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $35d9436b17a9faa7$export$9f200c4466975173 = $35d9436b17a9faa7$export$ff82449ce381c54a;
var $35d9436b17a9faa7$export$28562fb56044e6b5 = {
    URI: $35d9436b17a9faa7$export$9156e739aa33e19f,
    map: $35d9436b17a9faa7$var$_map,
    compact: $35d9436b17a9faa7$export$8e16b83750b44988,
    separate: $35d9436b17a9faa7$export$709f6946f4e97408,
    filter: $35d9436b17a9faa7$var$_filter,
    filterMap: $35d9436b17a9faa7$var$_filterMap,
    partition: $35d9436b17a9faa7$var$_partition,
    partitionMap: $35d9436b17a9faa7$var$_partitionMap
};

});

parcelRegister("3JkJJ", function(module, exports) {

$parcel$export(module.exports, "fromSet", function () { return $2b75a8ec2afb4789$export$7d98477f9d1e986f; });
$parcel$export(module.exports, "singleton", function () { return $2b75a8ec2afb4789$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "fromReadonlyArray", function () { return $2b75a8ec2afb4789$export$9288e031f1846591; });
$parcel$export(module.exports, "elem", function () { return $2b75a8ec2afb4789$export$5bf96401662340b7; });
$parcel$export(module.exports, "toSet", function () { return $2b75a8ec2afb4789$export$f416efe173c6901c; });
$parcel$export(module.exports, "map", function () { return $2b75a8ec2afb4789$export$871de8747c9eaa88; });
$parcel$export(module.exports, "chain", function () { return $2b75a8ec2afb4789$export$e08e3b67e392101e; });
$parcel$export(module.exports, "filter", function () { return $2b75a8ec2afb4789$export$3dea766d36a8935f; });
$parcel$export(module.exports, "partition", function () { return $2b75a8ec2afb4789$export$b29f828819edca8d; });
$parcel$export(module.exports, "union", function () { return $2b75a8ec2afb4789$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "isEmpty", function () { return $2b75a8ec2afb4789$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "intersection", function () { return $2b75a8ec2afb4789$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "empty", function () { return $2b75a8ec2afb4789$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "partitionMap", function () { return $2b75a8ec2afb4789$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "difference", function () { return $2b75a8ec2afb4789$export$acaf96a27438246b; });
$parcel$export(module.exports, "reduce", function () { return $2b75a8ec2afb4789$export$533b26079ad0b4b; });
$parcel$export(module.exports, "toReadonlyArray", function () { return $2b75a8ec2afb4789$export$4aaa3912a3956cb7; });
$parcel$export(module.exports, "foldMap", function () { return $2b75a8ec2afb4789$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $2b75a8ec2afb4789$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "insert", function () { return $2b75a8ec2afb4789$export$21a5ca8aa77d35ff; });
$parcel$export(module.exports, "remove", function () { return $2b75a8ec2afb4789$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "toggle", function () { return $2b75a8ec2afb4789$export$e03c1c3201ee8bb7; });
$parcel$export(module.exports, "compact", function () { return $2b75a8ec2afb4789$export$8e16b83750b44988; });
$parcel$export(module.exports, "filterMap", function () { return $2b75a8ec2afb4789$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "separate", function () { return $2b75a8ec2afb4789$export$709f6946f4e97408; });
$parcel$export(module.exports, "size", function () { return $2b75a8ec2afb4789$export$346677f925de839c; });
$parcel$export(module.exports, "some", function () { return $2b75a8ec2afb4789$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "every", function () { return $2b75a8ec2afb4789$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "isSubset", function () { return $2b75a8ec2afb4789$export$af04532ec9ff13d2; });
$parcel$export(module.exports, "URI", function () { return $2b75a8ec2afb4789$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $2b75a8ec2afb4789$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getEq", function () { return $2b75a8ec2afb4789$export$804fed467fde44e4; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $2b75a8ec2afb4789$export$baca17b4aff42f82; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $2b75a8ec2afb4789$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $2b75a8ec2afb4789$export$d379a869a72e4055; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $2b75a8ec2afb4789$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "fromArray", function () { return $2b75a8ec2afb4789$export$571d59b505e6bb4e; });

var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");

var $IYheM = parcelRequire("IYheM");

var $bFSl4 = parcelRequire("bFSl4");
var $2b75a8ec2afb4789$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $2b75a8ec2afb4789$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $2b75a8ec2afb4789$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $2b75a8ec2afb4789$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $2b75a8ec2afb4789$export$871de8747c9eaa88(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $2b75a8ec2afb4789$export$e08e3b67e392101e(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $2b75a8ec2afb4789$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $2b75a8ec2afb4789$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $bFSl4.separated)(left, right);
    };
}
function $2b75a8ec2afb4789$export$971dd5b0dfd021b6(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $2b75a8ec2afb4789$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($2b75a8ec2afb4789$export$dd1bc94b04021eeb(me)) return that;
        if ($2b75a8ec2afb4789$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $2b75a8ec2afb4789$export$bc86dfbf7795668c(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $2b75a8ec2afb4789$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($2b75a8ec2afb4789$export$dd1bc94b04021eeb(me) || $2b75a8ec2afb4789$export$dd1bc94b04021eeb(that)) return $2b75a8ec2afb4789$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $2b75a8ec2afb4789$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $2b75a8ec2afb4789$export$5bf96401662340b7(EB);
            var hasC = $2b75a8ec2afb4789$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $bFSl4.separated)(left, right);
        };
    };
}
function $2b75a8ec2afb4789$export$acaf96a27438246b(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $2b75a8ec2afb4789$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $2b75a8ec2afb4789$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $2b75a8ec2afb4789$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $2b75a8ec2afb4789$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $2b75a8ec2afb4789$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $2b75a8ec2afb4789$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $2b75a8ec2afb4789$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $2b75a8ec2afb4789$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $2b75a8ec2afb4789$export$21a5ca8aa77d35ff(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $2b75a8ec2afb4789$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $2b75a8ec2afb4789$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $2b75a8ec2afb4789$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    var removeE = $2b75a8ec2afb4789$export$cd7f480d6b8286c3(E);
    var insertE = $2b75a8ec2afb4789$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $2b75a8ec2afb4789$export$8e16b83750b44988 = function(E) {
    return $2b75a8ec2afb4789$export$a04c6c6965dd4709(E)((0, $f5id0.identity));
};
function $2b75a8ec2afb4789$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $2b75a8ec2afb4789$export$5bf96401662340b7(EE);
        var elemEA = $2b75a8ec2afb4789$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $bFSl4.separated)(left, right);
    };
}
function $2b75a8ec2afb4789$export$a04c6c6965dd4709(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $2b75a8ec2afb4789$export$6e22c362a0406a2c = new Set();
var $2b75a8ec2afb4789$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $2b75a8ec2afb4789$export$346677f925de839c = function(set) {
    return set.size;
};
var $2b75a8ec2afb4789$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $2b75a8ec2afb4789$export$7ecc1a3b11b57dab(predicate) {
    return (0, $IYheM.not)($2b75a8ec2afb4789$export$ad14ef4001db2bcd((0, $IYheM.not)(predicate)));
}
function $2b75a8ec2afb4789$export$af04532ec9ff13d2(E) {
    var elemE = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $2b75a8ec2afb4789$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $2b75a8ec2afb4789$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $2b75a8ec2afb4789$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $2b75a8ec2afb4789$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $2b75a8ec2afb4789$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $2b75a8ec2afb4789$export$9156e739aa33e19f = 'ReadonlySet';
function $2b75a8ec2afb4789$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $2b75a8ec2afb4789$export$804fed467fde44e4(E) {
    var subsetE = $2b75a8ec2afb4789$export$af04532ec9ff13d2(E);
    return (0, $kJAjV.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $2b75a8ec2afb4789$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $2b75a8ec2afb4789$export$971dd5b0dfd021b6(E)
    };
};
var $2b75a8ec2afb4789$export$c487aac9f4157837 = function(E) {
    return {
        concat: $2b75a8ec2afb4789$export$baca17b4aff42f82(E).concat,
        empty: $2b75a8ec2afb4789$export$6e22c362a0406a2c
    };
};
var $2b75a8ec2afb4789$export$d379a869a72e4055 = function(E) {
    return {
        concat: $2b75a8ec2afb4789$export$bc86dfbf7795668c(E)
    };
};
var $2b75a8ec2afb4789$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $2b75a8ec2afb4789$export$acaf96a27438246b(E)
    };
};
var $2b75a8ec2afb4789$export$571d59b505e6bb4e = $2b75a8ec2afb4789$export$9288e031f1846591;

});

parcelRegister("ljPND", function(module, exports) {

$parcel$export(module.exports, "iso", function () { return $f8538da5b5e95b24$export$1aba8f741a0eae06; });
$parcel$export(module.exports, "isoAsLens", function () { return $f8538da5b5e95b24$export$d001ee9513dee7c1; });
$parcel$export(module.exports, "lens", function () { return $f8538da5b5e95b24$export$21cde5187c2605a3; });
$parcel$export(module.exports, "isoAsPrism", function () { return $f8538da5b5e95b24$export$fde8c5b9dff57abc; });
$parcel$export(module.exports, "prism", function () { return $f8538da5b5e95b24$export$e469dcfea9910464; });
$parcel$export(module.exports, "isoAsOptional", function () { return $f8538da5b5e95b24$export$4d3db894cf45abd5; });
$parcel$export(module.exports, "optional", function () { return $f8538da5b5e95b24$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "isoAsTraversal", function () { return $f8538da5b5e95b24$export$e55a826b3ba968d2; });
$parcel$export(module.exports, "traversal", function () { return $f8538da5b5e95b24$export$8666ce7a134c2314; });
$parcel$export(module.exports, "lensAsOptional", function () { return $f8538da5b5e95b24$export$bae94c671b4dc75d; });
$parcel$export(module.exports, "lensAsTraversal", function () { return $f8538da5b5e95b24$export$e5de01c31c85830c; });
$parcel$export(module.exports, "lensComposeLens", function () { return $f8538da5b5e95b24$export$62d1b5266563d2b6; });
$parcel$export(module.exports, "prismComposePrism", function () { return $f8538da5b5e95b24$export$af9c087537c23eb1; });
$parcel$export(module.exports, "lensComposePrism", function () { return $f8538da5b5e95b24$export$ffffe1ca21811d93; });
$parcel$export(module.exports, "optionalComposeOptional", function () { return $f8538da5b5e95b24$export$8e08893559c32e38; });
$parcel$export(module.exports, "prismAsOptional", function () { return $f8538da5b5e95b24$export$70f4d204f3bdc8bd; });
$parcel$export(module.exports, "lensId", function () { return $f8538da5b5e95b24$export$a4b03755c6673298; });
$parcel$export(module.exports, "lensProp", function () { return $f8538da5b5e95b24$export$a6ba95b157529836; });
$parcel$export(module.exports, "lensProps", function () { return $f8538da5b5e95b24$export$c19575454e66bf5f; });
$parcel$export(module.exports, "lensComponent", function () { return $f8538da5b5e95b24$export$103f2a6258fae742; });
$parcel$export(module.exports, "lensAtKey", function () { return $f8538da5b5e95b24$export$fc68a3bfc89f0b98; });
$parcel$export(module.exports, "atReadonlyRecord", function () { return $f8538da5b5e95b24$export$ba8573d258bae607; });
$parcel$export(module.exports, "prismSet", function () { return $f8538da5b5e95b24$export$97725fa315d6412c; });
$parcel$export(module.exports, "prismAsTraversal", function () { return $f8538da5b5e95b24$export$18564f4597667b6a; });
$parcel$export(module.exports, "prismModifyOption", function () { return $f8538da5b5e95b24$export$ddb3ff54eaa1c530; });
$parcel$export(module.exports, "prismModify", function () { return $f8538da5b5e95b24$export$f545e0bcbe4b5ea7; });
$parcel$export(module.exports, "prismComposeLens", function () { return $f8538da5b5e95b24$export$dad01448ef670850; });
$parcel$export(module.exports, "prismFromNullable", function () { return $f8538da5b5e95b24$export$258cc98aa6d7d21b; });
$parcel$export(module.exports, "prismFromPredicate", function () { return $f8538da5b5e95b24$export$8f316a2f03469694; });
$parcel$export(module.exports, "prismSome", function () { return $f8538da5b5e95b24$export$782e8b2fe031f968; });
$parcel$export(module.exports, "prismRight", function () { return $f8538da5b5e95b24$export$929e170fdd93186c; });
$parcel$export(module.exports, "prismLeft", function () { return $f8538da5b5e95b24$export$97ae81cf28b21f26; });
$parcel$export(module.exports, "optionalAsTraversal", function () { return $f8538da5b5e95b24$export$a595a5197cc37264; });
$parcel$export(module.exports, "optionalModifyOption", function () { return $f8538da5b5e95b24$export$48aae8aebe6d3ee9; });
$parcel$export(module.exports, "optionalModify", function () { return $f8538da5b5e95b24$export$6d575f282c3c1d48; });
$parcel$export(module.exports, "optionalIndex", function () { return $f8538da5b5e95b24$export$47ac94aa95300c6f; });
$parcel$export(module.exports, "indexReadonlyArray", function () { return $f8538da5b5e95b24$export$bb0c054375ca4b0; });
$parcel$export(module.exports, "optionalIndexNonEmpty", function () { return $f8538da5b5e95b24$export$83e62439a4d30c4c; });
$parcel$export(module.exports, "indexReadonlyNonEmptyArray", function () { return $f8538da5b5e95b24$export$165af7b747e6b1f1; });
$parcel$export(module.exports, "optionalKey", function () { return $f8538da5b5e95b24$export$a6c26e1663200bf4; });
$parcel$export(module.exports, "indexReadonlyRecord", function () { return $f8538da5b5e95b24$export$3c3468aec3b83bbf; });
$parcel$export(module.exports, "optionalFindFirst", function () { return $f8538da5b5e95b24$export$220673392b48821b; });
$parcel$export(module.exports, "optionalFindFirstNonEmpty", function () { return $f8538da5b5e95b24$export$cf29cfc68de9a659; });
$parcel$export(module.exports, "traversalComposeTraversal", function () { return $f8538da5b5e95b24$export$2c68ab81171b083f; });
$parcel$export(module.exports, "ApplicativeIdentity", function () { return $f8538da5b5e95b24$export$7c4912ca011fa00e; });
$parcel$export(module.exports, "fromTraversable", function () { return $f8538da5b5e95b24$export$126b5a87c58d3f9c; });
$parcel$export(module.exports, "traversalTraverse", function () { return $f8538da5b5e95b24$export$35db6fcbd934c57; });
$parcel$export(module.exports, "index", function () { return $f8538da5b5e95b24$export$b610b8812bbcded9; });
$parcel$export(module.exports, "at", function () { return $f8538da5b5e95b24$export$493d36ec626b6698; });

var $b406R = parcelRequire("b406R");

var $g4z4j = parcelRequire("g4z4j");

var $f5id0 = parcelRequire("f5id0");

var $hVAkz = parcelRequire("hVAkz");

var $7cVq5 = parcelRequire("7cVq5");

var $4CZFO = parcelRequire("4CZFO");
var $f8538da5b5e95b24$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f8538da5b5e95b24$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $f8538da5b5e95b24$export$d001ee9513dee7c1 = function(sa) {
    return $f8538da5b5e95b24$export$21cde5187c2605a3(sa.get, (0, $f5id0.flow)(sa.reverseGet, (0, $f5id0.constant)));
};
var $f8538da5b5e95b24$export$fde8c5b9dff57abc = function(sa) {
    return $f8538da5b5e95b24$export$e469dcfea9910464((0, $f5id0.flow)(sa.get, $hVAkz.some), sa.reverseGet);
};
var $f8538da5b5e95b24$export$4d3db894cf45abd5 = function(sa) {
    return $f8538da5b5e95b24$export$516e28dec6a4b6d4((0, $f5id0.flow)(sa.get, $hVAkz.some), (0, $f5id0.flow)(sa.reverseGet, (0, $f5id0.constant)));
};
var $f8538da5b5e95b24$export$e55a826b3ba968d2 = function(sa) {
    return $f8538da5b5e95b24$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $f8538da5b5e95b24$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $f8538da5b5e95b24$export$bae94c671b4dc75d = function(sa) {
    return $f8538da5b5e95b24$export$516e28dec6a4b6d4((0, $f5id0.flow)(sa.get, $hVAkz.some), sa.set);
};
var $f8538da5b5e95b24$export$e5de01c31c85830c = function(sa) {
    return $f8538da5b5e95b24$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $f8538da5b5e95b24$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $f8538da5b5e95b24$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $f8538da5b5e95b24$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $f8538da5b5e95b24$export$e469dcfea9910464((0, $f5id0.flow)(sa.getOption, $hVAkz.chain(ab.getOption)), (0, $f5id0.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $f8538da5b5e95b24$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $f8538da5b5e95b24$export$8e08893559c32e38($f8538da5b5e95b24$export$70f4d204f3bdc8bd(ab))($f8538da5b5e95b24$export$bae94c671b4dc75d(sa));
    };
};
var $f8538da5b5e95b24$export$a4b03755c6673298 = function() {
    return $f8538da5b5e95b24$export$21cde5187c2605a3((0, $f5id0.identity), (0, $f5id0.constant));
};
var $f8538da5b5e95b24$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $f8538da5b5e95b24$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $f8538da5b5e95b24$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $f8538da5b5e95b24$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $f8538da5b5e95b24$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $f8538da5b5e95b24$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $f8538da5b5e95b24$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $f8538da5b5e95b24$export$62d1b5266563d2b6($f8538da5b5e95b24$export$ba8573d258bae607().at(key)));
    };
};
var $f8538da5b5e95b24$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $f8538da5b5e95b24$export$70f4d204f3bdc8bd = function(sa) {
    return $f8538da5b5e95b24$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $f8538da5b5e95b24$export$97725fa315d6412c(a)(sa);
    });
};
var $f8538da5b5e95b24$export$18564f4597667b6a = function(sa) {
    return $f8538da5b5e95b24$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $4CZFO.pipe)(sa.getOption(s), $hVAkz.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $f8538da5b5e95b24$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $f8538da5b5e95b24$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $4CZFO.pipe)(sa.getOption(s), $hVAkz.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $f8538da5b5e95b24$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $f8538da5b5e95b24$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $4CZFO.pipe)(g(s), $hVAkz.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $f8538da5b5e95b24$export$97725fa315d6412c = function(a) {
    return $f8538da5b5e95b24$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $f8538da5b5e95b24$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $f8538da5b5e95b24$export$8e08893559c32e38($f8538da5b5e95b24$export$bae94c671b4dc75d(ab))($f8538da5b5e95b24$export$70f4d204f3bdc8bd(sa));
    };
};
var $f8538da5b5e95b24$export$258cc98aa6d7d21b = function() {
    return $f8538da5b5e95b24$export$e469dcfea9910464($hVAkz.fromNullable, (0, $f5id0.identity));
};
var $f8538da5b5e95b24$export$8f316a2f03469694 = function(predicate) {
    return $f8538da5b5e95b24$export$e469dcfea9910464($hVAkz.fromPredicate(predicate), (0, $f5id0.identity));
};
var $f8538da5b5e95b24$export$782e8b2fe031f968 = function() {
    return $f8538da5b5e95b24$export$e469dcfea9910464((0, $f5id0.identity), $hVAkz.some);
};
var $f8538da5b5e95b24$export$929e170fdd93186c = function() {
    return $f8538da5b5e95b24$export$e469dcfea9910464($hVAkz.fromEither, $7cVq5.right);
};
var $f8538da5b5e95b24$export$97ae81cf28b21f26 = function() {
    return $f8538da5b5e95b24$export$e469dcfea9910464(function(s) {
        return $7cVq5.isLeft(s) ? $hVAkz.some(s.left) : $hVAkz.none;
    }, $7cVq5.left);
};
var $f8538da5b5e95b24$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $f8538da5b5e95b24$export$a595a5197cc37264 = function(sa) {
    return $f8538da5b5e95b24$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $4CZFO.pipe)(sa.getOption(s), $hVAkz.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $f8538da5b5e95b24$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $4CZFO.pipe)(optional.getOption(s), $hVAkz.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $f8538da5b5e95b24$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $f8538da5b5e95b24$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $4CZFO.pipe)(g(s), $hVAkz.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $f8538da5b5e95b24$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $f8538da5b5e95b24$export$516e28dec6a4b6d4((0, $f5id0.flow)(sa.getOption, $hVAkz.chain(ab.getOption)), function(b) {
            return $f8538da5b5e95b24$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $f8538da5b5e95b24$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $f8538da5b5e95b24$export$8e08893559c32e38($f8538da5b5e95b24$export$bb0c054375ca4b0().index(i)));
    };
};
var $f8538da5b5e95b24$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $f8538da5b5e95b24$export$8e08893559c32e38($f8538da5b5e95b24$export$165af7b747e6b1f1().index(i)));
    };
};
var $f8538da5b5e95b24$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $f8538da5b5e95b24$export$8e08893559c32e38($f8538da5b5e95b24$export$3c3468aec3b83bbf().index(key)));
    };
};
var $f8538da5b5e95b24$export$220673392b48821b = function(predicate) {
    return $f8538da5b5e95b24$export$516e28dec6a4b6d4($b406R.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $4CZFO.pipe)($b406R.findIndex(predicate)(s), $hVAkz.fold(function() {
                return s;
            }, function(i) {
                return $b406R.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
var $f8538da5b5e95b24$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $f8538da5b5e95b24$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $f8538da5b5e95b24$export$cf29cfc68de9a659 = function(predicate) {
    return $f8538da5b5e95b24$export$516e28dec6a4b6d4($b406R.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $4CZFO.pipe)($b406R.findIndex(predicate)(as), $hVAkz.fold(function() {
                return as;
            }, function(i) {
                return $f8538da5b5e95b24$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $f8538da5b5e95b24$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $f8538da5b5e95b24$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $f8538da5b5e95b24$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $f8538da5b5e95b24$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $f5id0.identity),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $f8538da5b5e95b24$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $f8538da5b5e95b24$export$126b5a87c58d3f9c(T) {
    return function() {
        return $f8538da5b5e95b24$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $f8538da5b5e95b24$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $f8538da5b5e95b24$export$35db6fcbd934c57(T) {
    return $f8538da5b5e95b24$export$2c68ab81171b083f($f8538da5b5e95b24$export$126b5a87c58d3f9c(T)());
}
var $f8538da5b5e95b24$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $f8538da5b5e95b24$export$bb0c054375ca4b0 = function() {
    return $f8538da5b5e95b24$export$b610b8812bbcded9(function(i) {
        return $f8538da5b5e95b24$export$516e28dec6a4b6d4(function(as) {
            return $b406R.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $4CZFO.pipe)($b406R.lookup(i, as), $hVAkz.fold(function() {
                    return as;
                }, function() {
                    return $b406R.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $f8538da5b5e95b24$export$165af7b747e6b1f1 = function() {
    return $f8538da5b5e95b24$export$b610b8812bbcded9(function(i) {
        return $f8538da5b5e95b24$export$516e28dec6a4b6d4(function(as) {
            return $b406R.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $4CZFO.pipe)($b406R.lookup(i, as), $hVAkz.fold(function() {
                    return as;
                }, function() {
                    return $f8538da5b5e95b24$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $f8538da5b5e95b24$export$3c3468aec3b83bbf = function() {
    return $f8538da5b5e95b24$export$b610b8812bbcded9(function(k) {
        return $f8538da5b5e95b24$export$516e28dec6a4b6d4(function(r) {
            return $g4z4j.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $hVAkz.isNone($g4z4j.lookup(k, r))) return r;
                return $g4z4j.insertAt(k, a)(r);
            };
        });
    });
};
var $f8538da5b5e95b24$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $f8538da5b5e95b24$export$ba8573d258bae607() {
    return $f8538da5b5e95b24$export$493d36ec626b6698(function(key) {
        return $f8538da5b5e95b24$export$21cde5187c2605a3(function(r) {
            return $g4z4j.lookup(key, r);
        }, $hVAkz.fold(function() {
            return $g4z4j.deleteAt(key);
        }, function(a) {
            return $g4z4j.insertAt(key, a);
        }));
    });
}

});
parcelRegister("g4z4j", function(module, exports) {

$parcel$export(module.exports, "fromRecord", function () { return $0305092d3119f0bd$export$6c8271f68d66a228; });
$parcel$export(module.exports, "toRecord", function () { return $0305092d3119f0bd$export$1a8926de16677683; });
$parcel$export(module.exports, "size", function () { return $0305092d3119f0bd$export$346677f925de839c; });
$parcel$export(module.exports, "isEmpty", function () { return $0305092d3119f0bd$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "keys", function () { return $0305092d3119f0bd$export$ed97f33186d4b816; });
$parcel$export(module.exports, "collect", function () { return $0305092d3119f0bd$export$bb44f104e3c54dae; });
$parcel$export(module.exports, "toReadonlyArray", function () { return $0305092d3119f0bd$export$4aaa3912a3956cb7; });
$parcel$export(module.exports, "toUnfoldable", function () { return $0305092d3119f0bd$export$823be24f8766da23; });
$parcel$export(module.exports, "upsertAt", function () { return $0305092d3119f0bd$export$ff82449ce381c54a; });
$parcel$export(module.exports, "has", function () { return $0305092d3119f0bd$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "deleteAt", function () { return $0305092d3119f0bd$export$90f9093465da3136; });
$parcel$export(module.exports, "updateAt", function () { return $0305092d3119f0bd$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $0305092d3119f0bd$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "pop", function () { return $0305092d3119f0bd$export$3e41007ebfff0e64; });
$parcel$export(module.exports, "lookup", function () { return $0305092d3119f0bd$export$dfc7155ac0343b8; });
$parcel$export(module.exports, "isSubrecord", function () { return $0305092d3119f0bd$export$36e6f76a1d117b8a; });
$parcel$export(module.exports, "empty", function () { return $0305092d3119f0bd$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "mapWithIndex", function () { return $0305092d3119f0bd$export$8f07ddce13659f50; });
$parcel$export(module.exports, "map", function () { return $0305092d3119f0bd$export$871de8747c9eaa88; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $0305092d3119f0bd$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $0305092d3119f0bd$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $0305092d3119f0bd$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "singleton", function () { return $0305092d3119f0bd$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "traverseWithIndex", function () { return $0305092d3119f0bd$export$955fdc0d24efa249; });
$parcel$export(module.exports, "traverse", function () { return $0305092d3119f0bd$export$df3f009e3d155b20; });
$parcel$export(module.exports, "_traverse", function () { return $0305092d3119f0bd$export$b3c6f3d9661cffba; });
$parcel$export(module.exports, "sequence", function () { return $0305092d3119f0bd$export$49bb65c2ea163039; });
$parcel$export(module.exports, "_sequence", function () { return $0305092d3119f0bd$export$5d141086b2c0bc6; });
$parcel$export(module.exports, "wither", function () { return $0305092d3119f0bd$export$6c36d01819ecdb31; });
$parcel$export(module.exports, "compact", function () { return $0305092d3119f0bd$export$8e16b83750b44988; });
$parcel$export(module.exports, "wilt", function () { return $0305092d3119f0bd$export$2439a3bc02b13b03; });
$parcel$export(module.exports, "separate", function () { return $0305092d3119f0bd$export$709f6946f4e97408; });
$parcel$export(module.exports, "partitionMapWithIndex", function () { return $0305092d3119f0bd$export$bc7c0794b9c6f3ba; });
$parcel$export(module.exports, "partitionWithIndex", function () { return $0305092d3119f0bd$export$dad5e500f2bab9bc; });
$parcel$export(module.exports, "filterMapWithIndex", function () { return $0305092d3119f0bd$export$30c5cbe848021e97; });
$parcel$export(module.exports, "filterWithIndex", function () { return $0305092d3119f0bd$export$36e42aef19fc7171; });
$parcel$export(module.exports, "fromFoldable", function () { return $0305092d3119f0bd$export$b7d5d9bb9ff52072; });
$parcel$export(module.exports, "fromFoldableMap", function () { return $0305092d3119f0bd$export$f658682c0065ad25; });
$parcel$export(module.exports, "toEntries", function () { return $0305092d3119f0bd$export$9f69d28786a8399c; });
$parcel$export(module.exports, "fromEntries", function () { return $0305092d3119f0bd$export$5150077fc2e7c662; });
$parcel$export(module.exports, "every", function () { return $0305092d3119f0bd$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "some", function () { return $0305092d3119f0bd$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "elem", function () { return $0305092d3119f0bd$export$5bf96401662340b7; });
$parcel$export(module.exports, "union", function () { return $0305092d3119f0bd$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersection", function () { return $0305092d3119f0bd$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "difference", function () { return $0305092d3119f0bd$export$acaf96a27438246b; });
$parcel$export(module.exports, "_map", function () { return $0305092d3119f0bd$export$a0135aecf4a782ab; });
$parcel$export(module.exports, "_mapWithIndex", function () { return $0305092d3119f0bd$export$45e3e46323e6d66c; });
$parcel$export(module.exports, "_reduce", function () { return $0305092d3119f0bd$export$8eef5fdba9512999; });
$parcel$export(module.exports, "reduce", function () { return $0305092d3119f0bd$export$533b26079ad0b4b; });
$parcel$export(module.exports, "_foldMap", function () { return $0305092d3119f0bd$export$11b0d0e0b70641d9; });
$parcel$export(module.exports, "foldMap", function () { return $0305092d3119f0bd$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "_reduceRight", function () { return $0305092d3119f0bd$export$ec882fc9def9e5db; });
$parcel$export(module.exports, "reduceRight", function () { return $0305092d3119f0bd$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "_filter", function () { return $0305092d3119f0bd$export$ec7439dc64f73058; });
$parcel$export(module.exports, "filter", function () { return $0305092d3119f0bd$export$3dea766d36a8935f; });
$parcel$export(module.exports, "_filterMap", function () { return $0305092d3119f0bd$export$e8609d6e184911e6; });
$parcel$export(module.exports, "filterMap", function () { return $0305092d3119f0bd$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "_partition", function () { return $0305092d3119f0bd$export$8d112ad5a197e16a; });
$parcel$export(module.exports, "partition", function () { return $0305092d3119f0bd$export$b29f828819edca8d; });
$parcel$export(module.exports, "_partitionMap", function () { return $0305092d3119f0bd$export$f721fb25a1c72a8d; });
$parcel$export(module.exports, "partitionMap", function () { return $0305092d3119f0bd$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "_reduceWithIndex", function () { return $0305092d3119f0bd$export$dd5ca3bcbad0b6af; });
$parcel$export(module.exports, "_foldMapWithIndex", function () { return $0305092d3119f0bd$export$e08bbf939bdc3250; });
$parcel$export(module.exports, "_reduceRightWithIndex", function () { return $0305092d3119f0bd$export$3b7618311030b1af; });
$parcel$export(module.exports, "_partitionMapWithIndex", function () { return $0305092d3119f0bd$export$18034ec93490e9d2; });
$parcel$export(module.exports, "_partitionWithIndex", function () { return $0305092d3119f0bd$export$31601036bfbf1c76; });
$parcel$export(module.exports, "_filterMapWithIndex", function () { return $0305092d3119f0bd$export$ac207938ecd8ddc4; });
$parcel$export(module.exports, "_filterWithIndex", function () { return $0305092d3119f0bd$export$560430393fed15de; });
$parcel$export(module.exports, "URI", function () { return $0305092d3119f0bd$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $0305092d3119f0bd$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getEq", function () { return $0305092d3119f0bd$export$804fed467fde44e4; });
$parcel$export(module.exports, "getMonoid", function () { return $0305092d3119f0bd$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Functor", function () { return $0305092d3119f0bd$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $0305092d3119f0bd$export$18c957606d8bdf09; });
$parcel$export(module.exports, "FunctorWithIndex", function () { return $0305092d3119f0bd$export$9fdffe0fe1e91cad; });
$parcel$export(module.exports, "getFoldable", function () { return $0305092d3119f0bd$export$d544f02c7cebdaed; });
$parcel$export(module.exports, "getFoldableWithIndex", function () { return $0305092d3119f0bd$export$6c59d75f118e7bc9; });
$parcel$export(module.exports, "Compactable", function () { return $0305092d3119f0bd$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $0305092d3119f0bd$export$d00e1c48fb621173; });
$parcel$export(module.exports, "FilterableWithIndex", function () { return $0305092d3119f0bd$export$c29a647071e542ec; });
$parcel$export(module.exports, "getTraversable", function () { return $0305092d3119f0bd$export$4e0ffba11065d2c1; });
$parcel$export(module.exports, "getTraversableWithIndex", function () { return $0305092d3119f0bd$export$46b81797a3375b8c; });
$parcel$export(module.exports, "getWitherable", function () { return $0305092d3119f0bd$export$bb8ef26a634cac7b; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $0305092d3119f0bd$export$baca17b4aff42f82; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $0305092d3119f0bd$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $0305092d3119f0bd$export$d379a869a72e4055; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $0305092d3119f0bd$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "Foldable", function () { return $0305092d3119f0bd$export$41404b31838667c9; });
$parcel$export(module.exports, "FoldableWithIndex", function () { return $0305092d3119f0bd$export$e8f7d17aaff345cb; });
$parcel$export(module.exports, "Traversable", function () { return $0305092d3119f0bd$export$a0202666c3bda011; });
$parcel$export(module.exports, "TraversableWithIndex", function () { return $0305092d3119f0bd$export$bd7b528d8c36ec41; });
$parcel$export(module.exports, "Witherable", function () { return $0305092d3119f0bd$export$748d317b4c426f96; });
$parcel$export(module.exports, "insertAt", function () { return $0305092d3119f0bd$export$9f200c4466975173; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $0305092d3119f0bd$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "readonlyRecord", function () { return $0305092d3119f0bd$export$74b9182b22de2bc1; });

var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $bFSl4 = parcelRequire("bFSl4");

var $68YxT = parcelRequire("68YxT");

var $erGUW = parcelRequire("erGUW");
var $0305092d3119f0bd$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $0305092d3119f0bd$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $0305092d3119f0bd$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $0305092d3119f0bd$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($aByOK.has.call(r, k)) return false;
    }
    return true;
};
var $0305092d3119f0bd$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $0305092d3119f0bd$export$ed97f33186d4b816 = /*#__PURE__*/ $0305092d3119f0bd$var$keys_($68YxT.Ord);
function $0305092d3119f0bd$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $0305092d3119f0bd$export$bb44f104e3c54dae($68YxT.Ord)(O);
    var keysO = $0305092d3119f0bd$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $0305092d3119f0bd$export$4aaa3912a3956cb7 = /*#__PURE__*/ $0305092d3119f0bd$export$bb44f104e3c54dae($68YxT.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $0305092d3119f0bd$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $0305092d3119f0bd$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $aByOK.some([
                sas[b],
                b + 1
            ]) : $aByOK.none;
        });
    };
}
var $0305092d3119f0bd$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($aByOK.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $0305092d3119f0bd$export$a4f4bb6b1453fff5 = function(k, r) {
    return $aByOK.has.call(r, k);
};
function $0305092d3119f0bd$export$90f9093465da3136(k) {
    return function(r) {
        if (!$aByOK.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $0305092d3119f0bd$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$0305092d3119f0bd$export$a4f4bb6b1453fff5(k, r)) return $aByOK.none;
        if (r[k] === a) return $aByOK.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $aByOK.some(out);
    };
};
var $0305092d3119f0bd$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$0305092d3119f0bd$export$a4f4bb6b1453fff5(k, r)) return $aByOK.none;
        var next = f(r[k]);
        if (next === r[k]) return $aByOK.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $aByOK.some(out);
    };
};
function $0305092d3119f0bd$export$3e41007ebfff0e64(k) {
    var deleteAtk = $0305092d3119f0bd$export$90f9093465da3136(k);
    return function(r) {
        var oa = $0305092d3119f0bd$export$dfc7155ac0343b8(k, r);
        return $aByOK.isNone(oa) ? $aByOK.none : $aByOK.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $0305092d3119f0bd$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $0305092d3119f0bd$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$aByOK.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $0305092d3119f0bd$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $0305092d3119f0bd$export$dfc7155ac0343b8(k, r);
    };
    return $aByOK.has.call(r, k) ? $aByOK.some(r[k]) : $aByOK.none;
}
var $0305092d3119f0bd$export$6e22c362a0406a2c = {};
function $0305092d3119f0bd$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($aByOK.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $0305092d3119f0bd$export$871de8747c9eaa88(f) {
    return $0305092d3119f0bd$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $0305092d3119f0bd$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $0305092d3119f0bd$export$bbd3ef8720e22369($68YxT.Ord).apply(void 0, args);
    var keysO = $0305092d3119f0bd$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $0305092d3119f0bd$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $0305092d3119f0bd$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $0305092d3119f0bd$export$18153bb1181268e5($68YxT.Ord)(O);
}
function $0305092d3119f0bd$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $0305092d3119f0bd$export$ce2b2fe0b88ccd0a($68YxT.Ord).apply(void 0, args);
    var keysO = $0305092d3119f0bd$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $0305092d3119f0bd$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $0305092d3119f0bd$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $0305092d3119f0bd$var$_traverseWithIndex($68YxT.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $0305092d3119f0bd$export$df3f009e3d155b20(F) {
    var traverseOF = $0305092d3119f0bd$export$b3c6f3d9661cffba($68YxT.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $0305092d3119f0bd$export$49bb65c2ea163039(F) {
    return $0305092d3119f0bd$export$5d141086b2c0bc6($68YxT.Ord)(F);
}
var $0305092d3119f0bd$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $0305092d3119f0bd$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $f5id0.pipe)(fa, traverseF(f)), $0305092d3119f0bd$export$8e16b83750b44988);
        };
    };
};
var $0305092d3119f0bd$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $0305092d3119f0bd$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $f5id0.pipe)(fa, traverseF(f)), $0305092d3119f0bd$export$709f6946f4e97408);
        };
    };
};
function $0305092d3119f0bd$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($aByOK.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $bFSl4.separated)(left, right);
    };
}
function $0305092d3119f0bd$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($aByOK.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $bFSl4.separated)(left, right);
    };
}
function $0305092d3119f0bd$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($aByOK.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($aByOK.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $0305092d3119f0bd$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($aByOK.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $0305092d3119f0bd$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $0305092d3119f0bd$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $f5id0.identity));
    };
}
function $0305092d3119f0bd$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $aByOK.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $0305092d3119f0bd$export$9f69d28786a8399c = $0305092d3119f0bd$export$4aaa3912a3956cb7;
var $0305092d3119f0bd$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $0305092d3119f0bd$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $0305092d3119f0bd$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $0305092d3119f0bd$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $0305092d3119f0bd$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $0305092d3119f0bd$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($0305092d3119f0bd$export$dd1bc94b04021eeb(first)) return second;
            if ($0305092d3119f0bd$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($0305092d3119f0bd$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$0305092d3119f0bd$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $0305092d3119f0bd$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($0305092d3119f0bd$export$dd1bc94b04021eeb(first) || $0305092d3119f0bd$export$dd1bc94b04021eeb(second)) return $0305092d3119f0bd$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($0305092d3119f0bd$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $0305092d3119f0bd$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($0305092d3119f0bd$export$dd1bc94b04021eeb(first)) return second;
        if ($0305092d3119f0bd$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$0305092d3119f0bd$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$0305092d3119f0bd$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $0305092d3119f0bd$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$871de8747c9eaa88(f));
};
var $0305092d3119f0bd$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$8f07ddce13659f50(f));
};
var $0305092d3119f0bd$export$8eef5fdba9512999 = function(O) {
    var reduceO = $0305092d3119f0bd$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $f5id0.pipe)(fa, reduceO(b, f));
    };
};
var $0305092d3119f0bd$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $0305092d3119f0bd$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $f5id0.pipe)(fa, foldMapM(f));
        };
    };
};
var $0305092d3119f0bd$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $0305092d3119f0bd$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $f5id0.pipe)(fa, reduceRightO(b, f));
    };
};
var $0305092d3119f0bd$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$3dea766d36a8935f(predicate));
};
var $0305092d3119f0bd$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$a04c6c6965dd4709(f));
};
var $0305092d3119f0bd$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$b29f828819edca8d(predicate));
};
var $0305092d3119f0bd$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$3117e3f9ececb6bc(f));
};
var $0305092d3119f0bd$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $0305092d3119f0bd$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $f5id0.pipe)(fa, reduceWithIndexO(b, f));
    };
};
var $0305092d3119f0bd$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $0305092d3119f0bd$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $f5id0.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
var $0305092d3119f0bd$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $0305092d3119f0bd$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $f5id0.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
var $0305092d3119f0bd$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$bc7c0794b9c6f3ba(f));
};
var $0305092d3119f0bd$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $0305092d3119f0bd$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$30c5cbe848021e97(f));
};
var $0305092d3119f0bd$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $f5id0.pipe)(fa, $0305092d3119f0bd$export$36e42aef19fc7171(predicateWithIndex));
};
var $0305092d3119f0bd$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $0305092d3119f0bd$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $f5id0.flow)((0, $f5id0.SK), f));
        };
    };
};
var $0305092d3119f0bd$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $0305092d3119f0bd$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $f5id0.identity));
        };
    };
};
var $0305092d3119f0bd$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $0305092d3119f0bd$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($0305092d3119f0bd$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $0305092d3119f0bd$export$3dea766d36a8935f = function(predicate) {
    return $0305092d3119f0bd$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $0305092d3119f0bd$export$a04c6c6965dd4709 = function(f) {
    return $0305092d3119f0bd$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $0305092d3119f0bd$export$b29f828819edca8d = function(predicate) {
    return $0305092d3119f0bd$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $0305092d3119f0bd$export$3117e3f9ececb6bc = function(f) {
    return $0305092d3119f0bd$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $0305092d3119f0bd$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $0305092d3119f0bd$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $0305092d3119f0bd$export$533b26079ad0b4b($68YxT.Ord).apply(void 0, args);
}
function $0305092d3119f0bd$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $0305092d3119f0bd$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $0305092d3119f0bd$export$b66cdc0497d8a99a($68YxT.Ord)(O);
}
function $0305092d3119f0bd$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $0305092d3119f0bd$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $0305092d3119f0bd$export$7fef8bcdbb34f435($68YxT.Ord).apply(void 0, args);
}
var $0305092d3119f0bd$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($aByOK.has.call(r, k)) {
        var oa = r[k];
        if ($aByOK.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
var $0305092d3119f0bd$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($aByOK.has.call(r, k)) {
        var e = r[k];
        if ($aByOK.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $bFSl4.separated)(left, right);
};
var $0305092d3119f0bd$export$9156e739aa33e19f = 'ReadonlyRecord';
function $0305092d3119f0bd$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $0305092d3119f0bd$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $0305092d3119f0bd$export$3cb5cd7f7776c81($68YxT.Ord)(O);
}
function $0305092d3119f0bd$export$804fed467fde44e4(E) {
    var isSubrecordE = $0305092d3119f0bd$export$36e6f76a1d117b8a(E);
    return (0, $kJAjV.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $0305092d3119f0bd$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($0305092d3119f0bd$export$dd1bc94b04021eeb(first)) return second;
            if ($0305092d3119f0bd$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($aByOK.has.call(second, k)) r[k] = $aByOK.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $0305092d3119f0bd$export$6e22c362a0406a2c
    };
}
var $0305092d3119f0bd$export$bd5b6bfc5fa2ee61 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab
};
var $0305092d3119f0bd$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($0305092d3119f0bd$export$bd5b6bfc5fa2ee61);
var $0305092d3119f0bd$export$9fdffe0fe1e91cad = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    mapWithIndex: $0305092d3119f0bd$export$45e3e46323e6d66c
};
var $0305092d3119f0bd$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $0305092d3119f0bd$export$9156e739aa33e19f,
        reduce: $0305092d3119f0bd$export$8eef5fdba9512999(O),
        foldMap: $0305092d3119f0bd$export$11b0d0e0b70641d9(O),
        reduceRight: $0305092d3119f0bd$export$ec882fc9def9e5db(O)
    };
};
var $0305092d3119f0bd$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $0305092d3119f0bd$export$9156e739aa33e19f,
        reduce: $0305092d3119f0bd$export$8eef5fdba9512999(O),
        foldMap: $0305092d3119f0bd$export$11b0d0e0b70641d9(O),
        reduceRight: $0305092d3119f0bd$export$ec882fc9def9e5db(O),
        reduceWithIndex: $0305092d3119f0bd$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $0305092d3119f0bd$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $0305092d3119f0bd$export$3b7618311030b1af(O)
    };
};
var $0305092d3119f0bd$export$4a21ac48141ac3c9 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    compact: $0305092d3119f0bd$export$8e16b83750b44988,
    separate: $0305092d3119f0bd$export$709f6946f4e97408
};
var $0305092d3119f0bd$export$d00e1c48fb621173 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    compact: $0305092d3119f0bd$export$8e16b83750b44988,
    separate: $0305092d3119f0bd$export$709f6946f4e97408,
    filter: $0305092d3119f0bd$export$ec7439dc64f73058,
    filterMap: $0305092d3119f0bd$export$e8609d6e184911e6,
    partition: $0305092d3119f0bd$export$8d112ad5a197e16a,
    partitionMap: $0305092d3119f0bd$export$f721fb25a1c72a8d
};
var $0305092d3119f0bd$export$c29a647071e542ec = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    mapWithIndex: $0305092d3119f0bd$export$45e3e46323e6d66c,
    compact: $0305092d3119f0bd$export$8e16b83750b44988,
    separate: $0305092d3119f0bd$export$709f6946f4e97408,
    filter: $0305092d3119f0bd$export$ec7439dc64f73058,
    filterMap: $0305092d3119f0bd$export$e8609d6e184911e6,
    partition: $0305092d3119f0bd$export$8d112ad5a197e16a,
    partitionMap: $0305092d3119f0bd$export$f721fb25a1c72a8d,
    filterMapWithIndex: $0305092d3119f0bd$export$ac207938ecd8ddc4,
    filterWithIndex: $0305092d3119f0bd$export$560430393fed15de,
    partitionMapWithIndex: $0305092d3119f0bd$export$18034ec93490e9d2,
    partitionWithIndex: $0305092d3119f0bd$export$31601036bfbf1c76
};
var $0305092d3119f0bd$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $0305092d3119f0bd$export$9156e739aa33e19f,
        map: $0305092d3119f0bd$export$a0135aecf4a782ab,
        reduce: $0305092d3119f0bd$export$8eef5fdba9512999(O),
        foldMap: $0305092d3119f0bd$export$11b0d0e0b70641d9(O),
        reduceRight: $0305092d3119f0bd$export$ec882fc9def9e5db(O),
        traverse: $0305092d3119f0bd$export$b3c6f3d9661cffba(O),
        sequence: $0305092d3119f0bd$export$5d141086b2c0bc6(O)
    };
};
var $0305092d3119f0bd$export$46b81797a3375b8c = function(O) {
    return {
        URI: $0305092d3119f0bd$export$9156e739aa33e19f,
        map: $0305092d3119f0bd$export$a0135aecf4a782ab,
        mapWithIndex: $0305092d3119f0bd$export$45e3e46323e6d66c,
        reduce: $0305092d3119f0bd$export$8eef5fdba9512999(O),
        foldMap: $0305092d3119f0bd$export$11b0d0e0b70641d9(O),
        reduceRight: $0305092d3119f0bd$export$ec882fc9def9e5db(O),
        reduceWithIndex: $0305092d3119f0bd$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $0305092d3119f0bd$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $0305092d3119f0bd$export$3b7618311030b1af(O),
        traverse: $0305092d3119f0bd$export$b3c6f3d9661cffba(O),
        sequence: $0305092d3119f0bd$export$5d141086b2c0bc6(O),
        traverseWithIndex: $0305092d3119f0bd$var$_traverseWithIndex(O)
    };
};
var $0305092d3119f0bd$export$bb8ef26a634cac7b = function(O) {
    var T = $0305092d3119f0bd$export$4e0ffba11065d2c1(O);
    return {
        URI: $0305092d3119f0bd$export$9156e739aa33e19f,
        map: $0305092d3119f0bd$export$a0135aecf4a782ab,
        reduce: $0305092d3119f0bd$export$8eef5fdba9512999(O),
        foldMap: $0305092d3119f0bd$export$11b0d0e0b70641d9(O),
        reduceRight: $0305092d3119f0bd$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $0305092d3119f0bd$export$8e16b83750b44988,
        separate: $0305092d3119f0bd$export$709f6946f4e97408,
        filter: $0305092d3119f0bd$export$ec7439dc64f73058,
        filterMap: $0305092d3119f0bd$export$e8609d6e184911e6,
        partition: $0305092d3119f0bd$export$8d112ad5a197e16a,
        partitionMap: $0305092d3119f0bd$export$f721fb25a1c72a8d,
        wither: (0, $erGUW.witherDefault)(T, $0305092d3119f0bd$export$4a21ac48141ac3c9),
        wilt: (0, $erGUW.wiltDefault)(T, $0305092d3119f0bd$export$4a21ac48141ac3c9)
    };
};
var $0305092d3119f0bd$export$baca17b4aff42f82 = function(S) {
    var unionS = $0305092d3119f0bd$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $0305092d3119f0bd$export$c487aac9f4157837 = function(S) {
    return {
        concat: $0305092d3119f0bd$export$baca17b4aff42f82(S).concat,
        empty: $0305092d3119f0bd$export$6e22c362a0406a2c
    };
};
var $0305092d3119f0bd$export$d379a869a72e4055 = function(S) {
    var intersectionS = $0305092d3119f0bd$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $0305092d3119f0bd$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $0305092d3119f0bd$export$acaf96a27438246b(second)(first);
        }
    };
};
var $0305092d3119f0bd$export$41404b31838667c9 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $0305092d3119f0bd$export$8eef5fdba9512999($68YxT.Ord),
    foldMap: /*#__PURE__*/ $0305092d3119f0bd$export$11b0d0e0b70641d9($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $0305092d3119f0bd$export$ec882fc9def9e5db($68YxT.Ord)
};
var $0305092d3119f0bd$export$e8f7d17aaff345cb = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $0305092d3119f0bd$export$8eef5fdba9512999($68YxT.Ord),
    foldMap: /*#__PURE__*/ $0305092d3119f0bd$export$11b0d0e0b70641d9($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $0305092d3119f0bd$export$ec882fc9def9e5db($68YxT.Ord),
    reduceWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$dd5ca3bcbad0b6af($68YxT.Ord),
    foldMapWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$e08bbf939bdc3250($68YxT.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$3b7618311030b1af($68YxT.Ord)
};
var $0305092d3119f0bd$export$a0202666c3bda011 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $0305092d3119f0bd$export$8eef5fdba9512999($68YxT.Ord),
    foldMap: /*#__PURE__*/ $0305092d3119f0bd$export$11b0d0e0b70641d9($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $0305092d3119f0bd$export$ec882fc9def9e5db($68YxT.Ord),
    traverse: /*#__PURE__*/ $0305092d3119f0bd$export$b3c6f3d9661cffba($68YxT.Ord),
    sequence: $0305092d3119f0bd$export$49bb65c2ea163039
};
var $0305092d3119f0bd$export$bd7b528d8c36ec41 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    mapWithIndex: $0305092d3119f0bd$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $0305092d3119f0bd$export$8eef5fdba9512999($68YxT.Ord),
    foldMap: /*#__PURE__*/ $0305092d3119f0bd$export$11b0d0e0b70641d9($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $0305092d3119f0bd$export$ec882fc9def9e5db($68YxT.Ord),
    reduceWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$dd5ca3bcbad0b6af($68YxT.Ord),
    foldMapWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$e08bbf939bdc3250($68YxT.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$3b7618311030b1af($68YxT.Ord),
    traverse: /*#__PURE__*/ $0305092d3119f0bd$export$b3c6f3d9661cffba($68YxT.Ord),
    sequence: $0305092d3119f0bd$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $0305092d3119f0bd$var$_traverseWithIndex($68YxT.Ord)
};
var $0305092d3119f0bd$var$_wither = /*#__PURE__*/ (0, $erGUW.witherDefault)($0305092d3119f0bd$export$a0202666c3bda011, $0305092d3119f0bd$export$4a21ac48141ac3c9);
var $0305092d3119f0bd$var$_wilt = /*#__PURE__*/ (0, $erGUW.wiltDefault)($0305092d3119f0bd$export$a0202666c3bda011, $0305092d3119f0bd$export$4a21ac48141ac3c9);
var $0305092d3119f0bd$export$748d317b4c426f96 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $0305092d3119f0bd$export$8eef5fdba9512999($68YxT.Ord),
    foldMap: /*#__PURE__*/ $0305092d3119f0bd$export$11b0d0e0b70641d9($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $0305092d3119f0bd$export$ec882fc9def9e5db($68YxT.Ord),
    traverse: /*#__PURE__*/ $0305092d3119f0bd$export$b3c6f3d9661cffba($68YxT.Ord),
    sequence: $0305092d3119f0bd$export$49bb65c2ea163039,
    compact: $0305092d3119f0bd$export$8e16b83750b44988,
    separate: $0305092d3119f0bd$export$709f6946f4e97408,
    filter: $0305092d3119f0bd$export$ec7439dc64f73058,
    filterMap: $0305092d3119f0bd$export$e8609d6e184911e6,
    partition: $0305092d3119f0bd$export$8d112ad5a197e16a,
    partitionMap: $0305092d3119f0bd$export$f721fb25a1c72a8d,
    wither: $0305092d3119f0bd$var$_wither,
    wilt: $0305092d3119f0bd$var$_wilt
};
var $0305092d3119f0bd$export$9f200c4466975173 = $0305092d3119f0bd$export$ff82449ce381c54a;
function $0305092d3119f0bd$export$5a15a386532a5ea4(k, r) {
    return $aByOK.has.call(r === undefined ? this : r, k);
}
var $0305092d3119f0bd$export$74b9182b22de2bc1 = {
    URI: $0305092d3119f0bd$export$9156e739aa33e19f,
    map: $0305092d3119f0bd$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $0305092d3119f0bd$export$8eef5fdba9512999($68YxT.Ord),
    foldMap: /*#__PURE__*/ $0305092d3119f0bd$export$11b0d0e0b70641d9($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $0305092d3119f0bd$export$ec882fc9def9e5db($68YxT.Ord),
    traverse: /*#__PURE__*/ $0305092d3119f0bd$export$b3c6f3d9661cffba($68YxT.Ord),
    sequence: $0305092d3119f0bd$export$49bb65c2ea163039,
    compact: $0305092d3119f0bd$export$8e16b83750b44988,
    separate: $0305092d3119f0bd$export$709f6946f4e97408,
    filter: $0305092d3119f0bd$export$ec7439dc64f73058,
    filterMap: $0305092d3119f0bd$export$e8609d6e184911e6,
    partition: $0305092d3119f0bd$export$8d112ad5a197e16a,
    partitionMap: $0305092d3119f0bd$export$f721fb25a1c72a8d,
    mapWithIndex: $0305092d3119f0bd$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$dd5ca3bcbad0b6af($68YxT.Ord),
    foldMapWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$e08bbf939bdc3250($68YxT.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $0305092d3119f0bd$export$3b7618311030b1af($68YxT.Ord),
    filterMapWithIndex: $0305092d3119f0bd$export$ac207938ecd8ddc4,
    filterWithIndex: $0305092d3119f0bd$export$560430393fed15de,
    partitionMapWithIndex: $0305092d3119f0bd$export$18034ec93490e9d2,
    partitionWithIndex: $0305092d3119f0bd$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $0305092d3119f0bd$var$_traverseWithIndex($68YxT.Ord),
    wither: $0305092d3119f0bd$var$_wither,
    wilt: $0305092d3119f0bd$var$_wilt
};

});
parcelRegister("68YxT", function(module, exports) {

$parcel$export(module.exports, "Eq", function () { return $479274889ba204fe$export$a2050e5b0c4dcf10; });
$parcel$export(module.exports, "Semigroup", function () { return $479274889ba204fe$export$c16b1dbe8a4166b6; });
$parcel$export(module.exports, "empty", function () { return $479274889ba204fe$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "Monoid", function () { return $479274889ba204fe$export$8f55868b713abdc3; });
$parcel$export(module.exports, "Ord", function () { return $479274889ba204fe$export$ee8aa95bfab51c5; });
$parcel$export(module.exports, "Show", function () { return $479274889ba204fe$export$f6a3d19be20f5819; });
$parcel$export(module.exports, "isString", function () { return $479274889ba204fe$export$844ec244b1367d54; });
$parcel$export(module.exports, "toUpperCase", function () { return $479274889ba204fe$export$d80c591a9e16646; });
$parcel$export(module.exports, "toLowerCase", function () { return $479274889ba204fe$export$84b9399c77df0edf; });
$parcel$export(module.exports, "replace", function () { return $479274889ba204fe$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "trim", function () { return $479274889ba204fe$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "trimLeft", function () { return $479274889ba204fe$export$c5557f40488c48ec; });
$parcel$export(module.exports, "trimRight", function () { return $479274889ba204fe$export$da8e5da96e287379; });
$parcel$export(module.exports, "slice", function () { return $479274889ba204fe$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "isEmpty", function () { return $479274889ba204fe$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "size", function () { return $479274889ba204fe$export$346677f925de839c; });
$parcel$export(module.exports, "split", function () { return $479274889ba204fe$export$65980d18b75784e2; });
$parcel$export(module.exports, "includes", function () { return $479274889ba204fe$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "startsWith", function () { return $479274889ba204fe$export$68326237475e9a7d; });
$parcel$export(module.exports, "endsWith", function () { return $479274889ba204fe$export$10fdab3683b55b22; });

var $1ECi6 = parcelRequire("1ECi6");
var $479274889ba204fe$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $479274889ba204fe$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $479274889ba204fe$export$6e22c362a0406a2c = '';
var $479274889ba204fe$export$8f55868b713abdc3 = {
    concat: $479274889ba204fe$export$c16b1dbe8a4166b6.concat,
    empty: $479274889ba204fe$export$6e22c362a0406a2c
};
var $479274889ba204fe$export$ee8aa95bfab51c5 = {
    equals: $479274889ba204fe$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $479274889ba204fe$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $479274889ba204fe$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $479274889ba204fe$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $479274889ba204fe$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $479274889ba204fe$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $479274889ba204fe$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $479274889ba204fe$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $479274889ba204fe$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $479274889ba204fe$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $479274889ba204fe$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $479274889ba204fe$export$346677f925de839c = function(s) {
    return s.length;
};
var $479274889ba204fe$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $1ECi6.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
var $479274889ba204fe$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $479274889ba204fe$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $479274889ba204fe$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};

});


parcelRegister("7cVq5", function(module, exports) {

$parcel$export(module.exports, "left", function () { return $53f631bec50b1359$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $53f631bec50b1359$export$79ffe56a765070d2; });
$parcel$export(module.exports, "flatMap", function () { return $53f631bec50b1359$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "isLeft", function () { return $53f631bec50b1359$export$d649b6842e09f2b; });
$parcel$export(module.exports, "map", function () { return $53f631bec50b1359$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $53f631bec50b1359$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "reduce", function () { return $53f631bec50b1359$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $53f631bec50b1359$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $53f631bec50b1359$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $53f631bec50b1359$export$df3f009e3d155b20; });
$parcel$export(module.exports, "bimap", function () { return $53f631bec50b1359$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapLeft", function () { return $53f631bec50b1359$export$472de43a55e4aa49; });
$parcel$export(module.exports, "alt", function () { return $53f631bec50b1359$export$228be17d80722ab; });
$parcel$export(module.exports, "extend", function () { return $53f631bec50b1359$export$8b58be045bf06082; });
$parcel$export(module.exports, "URI", function () { return $53f631bec50b1359$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $53f631bec50b1359$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getEq", function () { return $53f631bec50b1359$export$804fed467fde44e4; });
$parcel$export(module.exports, "isRight", function () { return $53f631bec50b1359$export$a9d71693f0c1a85d; });
$parcel$export(module.exports, "getSemigroup", function () { return $53f631bec50b1359$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getCompactable", function () { return $53f631bec50b1359$export$cfae3069ac05ff4c; });
$parcel$export(module.exports, "getFilterable", function () { return $53f631bec50b1359$export$a4e870b0a57ec14e; });
$parcel$export(module.exports, "getWitherable", function () { return $53f631bec50b1359$export$bb8ef26a634cac7b; });
$parcel$export(module.exports, "sequence", function () { return $53f631bec50b1359$export$49bb65c2ea163039; });
$parcel$export(module.exports, "Traversable", function () { return $53f631bec50b1359$export$a0202666c3bda011; });
$parcel$export(module.exports, "getApplicativeValidation", function () { return $53f631bec50b1359$export$d9540e18497e6036; });
$parcel$export(module.exports, "of", function () { return $53f631bec50b1359$export$ba255e9e49e00608; });
$parcel$export(module.exports, "getAltValidation", function () { return $53f631bec50b1359$export$a81dd5ed716f5f73; });
$parcel$export(module.exports, "Functor", function () { return $53f631bec50b1359$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $53f631bec50b1359$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $53f631bec50b1359$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "Pointed", function () { return $53f631bec50b1359$export$59a71046037e6c20; });
$parcel$export(module.exports, "apW", function () { return $53f631bec50b1359$export$321be6e231de8eac; });
$parcel$export(module.exports, "Apply", function () { return $53f631bec50b1359$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "Applicative", function () { return $53f631bec50b1359$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $53f631bec50b1359$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $53f631bec50b1359$export$fb641926d034ac7d; });
$parcel$export(module.exports, "Foldable", function () { return $53f631bec50b1359$export$41404b31838667c9; });
$parcel$export(module.exports, "Bifunctor", function () { return $53f631bec50b1359$export$fd0fe42029639505; });
$parcel$export(module.exports, "altW", function () { return $53f631bec50b1359$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "Alt", function () { return $53f631bec50b1359$export$25ba4469a069167; });
$parcel$export(module.exports, "Extend", function () { return $53f631bec50b1359$export$5b5dd0e212d2a5bc; });
$parcel$export(module.exports, "ChainRec", function () { return $53f631bec50b1359$export$be58f7327716329d; });
$parcel$export(module.exports, "throwError", function () { return $53f631bec50b1359$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "MonadThrow", function () { return $53f631bec50b1359$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "FromEither", function () { return $53f631bec50b1359$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "fromPredicate", function () { return $53f631bec50b1359$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromOption", function () { return $53f631bec50b1359$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "matchW", function () { return $53f631bec50b1359$export$2d55ea551c238330; });
$parcel$export(module.exports, "foldW", function () { return $53f631bec50b1359$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "match", function () { return $53f631bec50b1359$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "fold", function () { return $53f631bec50b1359$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "getOrElseW", function () { return $53f631bec50b1359$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "getOrElse", function () { return $53f631bec50b1359$export$8832081647a02ee7; });
$parcel$export(module.exports, "flap", function () { return $53f631bec50b1359$export$18c957606d8bdf09; });
$parcel$export(module.exports, "apFirst", function () { return $53f631bec50b1359$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apFirstW", function () { return $53f631bec50b1359$export$ac044f4aa9961a4f; });
$parcel$export(module.exports, "apSecond", function () { return $53f631bec50b1359$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apSecondW", function () { return $53f631bec50b1359$export$8a00020751233172; });
$parcel$export(module.exports, "tap", function () { return $53f631bec50b1359$export$3f23594af5f37336; });
$parcel$export(module.exports, "flattenW", function () { return $53f631bec50b1359$export$2409099f1fc434fb; });
$parcel$export(module.exports, "flatten", function () { return $53f631bec50b1359$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "duplicate", function () { return $53f631bec50b1359$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "fromOptionK", function () { return $53f631bec50b1359$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $53f631bec50b1359$export$12d26179deb6a68a; });
$parcel$export(module.exports, "chainOptionKW", function () { return $53f631bec50b1359$export$377cc334277e5c3c; });
$parcel$export(module.exports, "liftNullable", function () { return $53f631bec50b1359$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $53f631bec50b1359$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $53f631bec50b1359$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $53f631bec50b1359$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "filterOrElse", function () { return $53f631bec50b1359$export$30af8ca9498ddf5b; });
$parcel$export(module.exports, "filterOrElseW", function () { return $53f631bec50b1359$export$84511cf4503ec9dd; });
$parcel$export(module.exports, "swap", function () { return $53f631bec50b1359$export$b0e76d9850c64156; });
$parcel$export(module.exports, "orElseW", function () { return $53f631bec50b1359$export$efd845e0c87089a6; });
$parcel$export(module.exports, "orElse", function () { return $53f631bec50b1359$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "fromNullable", function () { return $53f631bec50b1359$export$b601f49376b4621a; });
$parcel$export(module.exports, "tryCatch", function () { return $53f631bec50b1359$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $53f631bec50b1359$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "fromNullableK", function () { return $53f631bec50b1359$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $53f631bec50b1359$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "toUnion", function () { return $53f631bec50b1359$export$a0886ed3a572729f; });
$parcel$export(module.exports, "toError", function () { return $53f631bec50b1359$export$cc3b967c039ed3e7; });
$parcel$export(module.exports, "elem", function () { return $53f631bec50b1359$export$5bf96401662340b7; });
$parcel$export(module.exports, "exists", function () { return $53f631bec50b1359$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "Do", function () { return $53f631bec50b1359$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $53f631bec50b1359$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $53f631bec50b1359$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $53f631bec50b1359$export$2385a24977818dd0; });
$parcel$export(module.exports, "bindW", function () { return $53f631bec50b1359$export$e0d5b1cbe98976d9; });
$parcel$export(module.exports, "apS", function () { return $53f631bec50b1359$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "apSW", function () { return $53f631bec50b1359$export$5c01f27714264b3d; });
$parcel$export(module.exports, "ApT", function () { return $53f631bec50b1359$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $53f631bec50b1359$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $53f631bec50b1359$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $53f631bec50b1359$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $53f631bec50b1359$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $53f631bec50b1359$export$d330b60315c14cd1; });
$parcel$export(module.exports, "chainW", function () { return $53f631bec50b1359$export$8e5885f0163d737a; });
$parcel$export(module.exports, "chain", function () { return $53f631bec50b1359$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $53f631bec50b1359$export$e3821ef4970c339c; });
$parcel$export(module.exports, "chainFirstW", function () { return $53f631bec50b1359$export$5de78197fc44b933; });
$parcel$export(module.exports, "parseJSON", function () { return $53f631bec50b1359$export$27924e57e9afff7f; });
$parcel$export(module.exports, "stringifyJSON", function () { return $53f631bec50b1359$export$702e019c6853c7a; });
$parcel$export(module.exports, "either", function () { return $53f631bec50b1359$export$5f5be1bb6cd1fded; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $53f631bec50b1359$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $53f631bec50b1359$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getValidationSemigroup", function () { return $53f631bec50b1359$export$5c6835227ac7f658; });
$parcel$export(module.exports, "getValidationMonoid", function () { return $53f631bec50b1359$export$c6554235dd19af66; });
$parcel$export(module.exports, "getValidation", function () { return $53f631bec50b1359$export$6843f928420ce3e4; });

var $6jM4Q = parcelRequire("6jM4Q");

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $eqiLn = parcelRequire("eqiLn");

var $ctkBN = parcelRequire("ctkBN");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $bFSl4 = parcelRequire("bFSl4");

var $erGUW = parcelRequire("erGUW");
var $53f631bec50b1359$export$eabcd2c8791e7bf4 = $aByOK.left;
var $53f631bec50b1359$export$79ffe56a765070d2 = $aByOK.right;
var $53f631bec50b1359$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $53f631bec50b1359$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $53f631bec50b1359$export$871de8747c9eaa88(f));
};
var $53f631bec50b1359$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $53f631bec50b1359$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $53f631bec50b1359$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $53f631bec50b1359$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $53f631bec50b1359$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $53f631bec50b1359$export$b66cdc0497d8a99a(M);
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $53f631bec50b1359$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $53f631bec50b1359$export$7fef8bcdbb34f435(b, f));
};
var $53f631bec50b1359$var$_traverse = function(F) {
    var traverseF = $53f631bec50b1359$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
var $53f631bec50b1359$var$_bimap = function(fa, f, g) {
    return (0, $f5id0.pipe)(fa, $53f631bec50b1359$export$eb54baf0b342cb1d(f, g));
};
var $53f631bec50b1359$var$_mapLeft = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $53f631bec50b1359$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $53f631bec50b1359$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $53f631bec50b1359$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $53f631bec50b1359$var$_extend = function(wa, f) {
    return (0, $f5id0.pipe)(wa, $53f631bec50b1359$export$8b58be045bf06082(f));
};
var $53f631bec50b1359$var$_chainRec = function(a, f) {
    return (0, $eqiLn.tailRec)(f(a), function(e) {
        return $53f631bec50b1359$export$d649b6842e09f2b(e) ? $53f631bec50b1359$export$79ffe56a765070d2($53f631bec50b1359$export$eabcd2c8791e7bf4(e.left)) : $53f631bec50b1359$export$d649b6842e09f2b(e.right) ? $53f631bec50b1359$export$eabcd2c8791e7bf4(f(e.right.left)) : $53f631bec50b1359$export$79ffe56a765070d2($53f631bec50b1359$export$79ffe56a765070d2(e.right.right));
    });
};
var $53f631bec50b1359$export$9156e739aa33e19f = 'Either';
var $53f631bec50b1359$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $53f631bec50b1359$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($53f631bec50b1359$export$d649b6842e09f2b(x) ? $53f631bec50b1359$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $53f631bec50b1359$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $53f631bec50b1359$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $53f631bec50b1359$export$d649b6842e09f2b(y) ? x : $53f631bec50b1359$export$d649b6842e09f2b(x) ? y : $53f631bec50b1359$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $53f631bec50b1359$export$cfae3069ac05ff4c = function(M) {
    var empty = $53f631bec50b1359$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $53f631bec50b1359$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $53f631bec50b1359$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? (0, $bFSl4.separated)(ma, ma) : $53f631bec50b1359$export$d649b6842e09f2b(ma.right) ? (0, $bFSl4.separated)($53f631bec50b1359$export$79ffe56a765070d2(ma.right.left), empty) : (0, $bFSl4.separated)(empty, $53f631bec50b1359$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $53f631bec50b1359$export$a4e870b0a57ec14e = function(M) {
    var empty = $53f631bec50b1359$export$eabcd2c8791e7bf4(M.empty);
    var _a = $53f631bec50b1359$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? (0, $bFSl4.separated)(ma, ma) : p(ma.right) ? (0, $bFSl4.separated)(empty, $53f631bec50b1359$export$79ffe56a765070d2(ma.right)) : (0, $bFSl4.separated)($53f631bec50b1359$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $53f631bec50b1359$export$9156e739aa33e19f,
        _E: undefined,
        map: $53f631bec50b1359$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($53f631bec50b1359$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $53f631bec50b1359$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($53f631bec50b1359$export$d649b6842e09f2b(ma)) return (0, $bFSl4.separated)(ma, ma);
            var e = f(ma.right);
            return $53f631bec50b1359$export$d649b6842e09f2b(e) ? (0, $bFSl4.separated)($53f631bec50b1359$export$79ffe56a765070d2(e.left), empty) : (0, $bFSl4.separated)(empty, $53f631bec50b1359$export$79ffe56a765070d2(e.right));
        }
    };
};
var $53f631bec50b1359$export$bb8ef26a634cac7b = function(M) {
    var F_ = $53f631bec50b1359$export$a4e870b0a57ec14e(M);
    var C = $53f631bec50b1359$export$cfae3069ac05ff4c(M);
    return {
        URI: $53f631bec50b1359$export$9156e739aa33e19f,
        _E: undefined,
        map: $53f631bec50b1359$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $53f631bec50b1359$var$_traverse,
        sequence: $53f631bec50b1359$export$49bb65c2ea163039,
        reduce: $53f631bec50b1359$var$_reduce,
        foldMap: $53f631bec50b1359$var$_foldMap,
        reduceRight: $53f631bec50b1359$var$_reduceRight,
        wither: (0, $erGUW.witherDefault)($53f631bec50b1359$export$a0202666c3bda011, C),
        wilt: (0, $erGUW.wiltDefault)($53f631bec50b1359$export$a0202666c3bda011, C)
    };
};
var $53f631bec50b1359$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $53f631bec50b1359$export$9156e739aa33e19f,
        _E: undefined,
        map: $53f631bec50b1359$var$_map,
        ap: function(fab, fa) {
            return $53f631bec50b1359$export$d649b6842e09f2b(fab) ? $53f631bec50b1359$export$d649b6842e09f2b(fa) ? $53f631bec50b1359$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $53f631bec50b1359$export$d649b6842e09f2b(fa) ? fa : $53f631bec50b1359$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $53f631bec50b1359$export$ba255e9e49e00608
    };
};
var $53f631bec50b1359$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $53f631bec50b1359$export$9156e739aa33e19f,
        _E: undefined,
        map: $53f631bec50b1359$var$_map,
        alt: function(me, that) {
            if ($53f631bec50b1359$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $53f631bec50b1359$export$d649b6842e09f2b(ea) ? $53f631bec50b1359$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $53f631bec50b1359$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? fa : $53f631bec50b1359$export$79ffe56a765070d2(f(fa.right));
    };
};
var $53f631bec50b1359$export$bd5b6bfc5fa2ee61 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map
};
var $53f631bec50b1359$export$6554612db691658e = (0, $f5id0.dual)(2, (0, $hrfTw.as)($53f631bec50b1359$export$bd5b6bfc5fa2ee61));
var $53f631bec50b1359$export$9284b360ca18a0fd = (0, $hrfTw.asUnit)($53f631bec50b1359$export$bd5b6bfc5fa2ee61);
var $53f631bec50b1359$export$ba255e9e49e00608 = $53f631bec50b1359$export$79ffe56a765070d2;
var $53f631bec50b1359$export$59a71046037e6c20 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    of: $53f631bec50b1359$export$ba255e9e49e00608
};
var $53f631bec50b1359$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fab) ? fab : $53f631bec50b1359$export$d649b6842e09f2b(fa) ? fa : $53f631bec50b1359$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $53f631bec50b1359$export$2f6ca3d3b1f80bf5 = $53f631bec50b1359$export$321be6e231de8eac;
var $53f631bec50b1359$export$efc21ddc6aeb363d = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    ap: $53f631bec50b1359$var$_ap
};
var $53f631bec50b1359$export$1279d2b7807629fd = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    ap: $53f631bec50b1359$var$_ap,
    of: $53f631bec50b1359$export$ba255e9e49e00608
};
var $53f631bec50b1359$export$f18d5acc27d70423 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    ap: $53f631bec50b1359$var$_ap,
    chain: $53f631bec50b1359$export$5b8affa63fc6df16
};
var $53f631bec50b1359$export$fb641926d034ac7d = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    ap: $53f631bec50b1359$var$_ap,
    of: $53f631bec50b1359$export$ba255e9e49e00608,
    chain: $53f631bec50b1359$export$5b8affa63fc6df16
};
var $53f631bec50b1359$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $53f631bec50b1359$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $53f631bec50b1359$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $53f631bec50b1359$export$41404b31838667c9 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    reduce: $53f631bec50b1359$var$_reduce,
    foldMap: $53f631bec50b1359$var$_foldMap,
    reduceRight: $53f631bec50b1359$var$_reduceRight
};
var $53f631bec50b1359$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $53f631bec50b1359$export$d649b6842e09f2b(ta) ? F.of($53f631bec50b1359$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $53f631bec50b1359$export$79ffe56a765070d2);
        };
    };
};
var $53f631bec50b1359$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? F.of($53f631bec50b1359$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $53f631bec50b1359$export$79ffe56a765070d2);
    };
};
var $53f631bec50b1359$export$a0202666c3bda011 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    reduce: $53f631bec50b1359$var$_reduce,
    foldMap: $53f631bec50b1359$var$_foldMap,
    reduceRight: $53f631bec50b1359$var$_reduceRight,
    traverse: $53f631bec50b1359$var$_traverse,
    sequence: $53f631bec50b1359$export$49bb65c2ea163039
};
var $53f631bec50b1359$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? $53f631bec50b1359$export$eabcd2c8791e7bf4(f(fa.left)) : $53f631bec50b1359$export$79ffe56a765070d2(g(fa.right));
    };
};
var $53f631bec50b1359$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? $53f631bec50b1359$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $53f631bec50b1359$export$fd0fe42029639505 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    bimap: $53f631bec50b1359$var$_bimap,
    mapLeft: $53f631bec50b1359$var$_mapLeft
};
var $53f631bec50b1359$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $53f631bec50b1359$export$228be17d80722ab = $53f631bec50b1359$export$1517cca7889d6aaa;
var $53f631bec50b1359$export$25ba4469a069167 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    alt: $53f631bec50b1359$var$_alt
};
var $53f631bec50b1359$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $53f631bec50b1359$export$d649b6842e09f2b(wa) ? wa : $53f631bec50b1359$export$79ffe56a765070d2(f(wa));
    };
};
var $53f631bec50b1359$export$5b5dd0e212d2a5bc = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    extend: $53f631bec50b1359$var$_extend
};
var $53f631bec50b1359$export$be58f7327716329d = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    ap: $53f631bec50b1359$var$_ap,
    chain: $53f631bec50b1359$export$5b8affa63fc6df16,
    chainRec: $53f631bec50b1359$var$_chainRec
};
var $53f631bec50b1359$export$8bf7aba4a9e09055 = $53f631bec50b1359$export$eabcd2c8791e7bf4;
var $53f631bec50b1359$export$5f956d47d0619c3a = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    ap: $53f631bec50b1359$var$_ap,
    of: $53f631bec50b1359$export$ba255e9e49e00608,
    chain: $53f631bec50b1359$export$5b8affa63fc6df16,
    throwError: $53f631bec50b1359$export$8bf7aba4a9e09055
};
var $53f631bec50b1359$export$825ea6cb6fc48d49 = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    fromEither: (0, $f5id0.identity)
};
var $53f631bec50b1359$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $ctkBN.fromPredicate)($53f631bec50b1359$export$825ea6cb6fc48d49);
var $53f631bec50b1359$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $ctkBN.fromOption)($53f631bec50b1359$export$825ea6cb6fc48d49);
var $53f631bec50b1359$export$d649b6842e09f2b = $aByOK.isLeft;
var $53f631bec50b1359$export$a9d71693f0c1a85d = $aByOK.isRight;
var $53f631bec50b1359$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $53f631bec50b1359$export$ccb09033cefa61e8 = $53f631bec50b1359$export$2d55ea551c238330;
var $53f631bec50b1359$export$4659b591c19bdf3d = $53f631bec50b1359$export$2d55ea551c238330;
var $53f631bec50b1359$export$93e2b83da34ff82a = $53f631bec50b1359$export$4659b591c19bdf3d;
var $53f631bec50b1359$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $53f631bec50b1359$export$8832081647a02ee7 = $53f631bec50b1359$export$d8a997ff0e6436f3;
var $53f631bec50b1359$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($53f631bec50b1359$export$bd5b6bfc5fa2ee61);
var $53f631bec50b1359$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($53f631bec50b1359$export$efc21ddc6aeb363d);
var $53f631bec50b1359$export$ac044f4aa9961a4f = $53f631bec50b1359$export$5f28d9feedcfd46e;
var $53f631bec50b1359$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($53f631bec50b1359$export$efc21ddc6aeb363d);
var $53f631bec50b1359$export$8a00020751233172 = $53f631bec50b1359$export$ed01bc59c3d06bf3;
var $53f631bec50b1359$export$3f23594af5f37336 = /*#__PURE__*/ (0, $f5id0.dual)(2, $lcDVT.tap($53f631bec50b1359$export$f18d5acc27d70423));
var $53f631bec50b1359$export$2409099f1fc434fb = /*#__PURE__*/ $53f631bec50b1359$export$5b8affa63fc6df16((0, $f5id0.identity));
var $53f631bec50b1359$export$bffa455ba8c619a6 = $53f631bec50b1359$export$2409099f1fc434fb;
var $53f631bec50b1359$export$ecd5e8ace626722c = /*#__PURE__*/ $53f631bec50b1359$export$8b58be045bf06082((0, $f5id0.identity));
var $53f631bec50b1359$export$a907462f448b49f8 = /*#__PURE__*/ (0, $ctkBN.fromOptionK)($53f631bec50b1359$export$825ea6cb6fc48d49);
var $53f631bec50b1359$export$12d26179deb6a68a = /*#__PURE__*/ (0, $ctkBN.chainOptionK)($53f631bec50b1359$export$825ea6cb6fc48d49, $53f631bec50b1359$export$f18d5acc27d70423);
var $53f631bec50b1359$export$377cc334277e5c3c = $53f631bec50b1359$export$12d26179deb6a68a;
/** @internal */ var $53f631bec50b1359$var$_FromEither = {
    fromEither: $53f631bec50b1359$export$825ea6cb6fc48d49.fromEither
};
var $53f631bec50b1359$export$cd139e14432f317b = /*#__PURE__*/ $aByOK.liftNullable($53f631bec50b1359$var$_FromEither);
var $53f631bec50b1359$export$ea4a22f93200df79 = /*#__PURE__*/ $aByOK.liftOption($53f631bec50b1359$var$_FromEither);
/** @internal */ var $53f631bec50b1359$var$_FlatMap = {
    flatMap: $53f631bec50b1359$export$5b8affa63fc6df16
};
var $53f631bec50b1359$export$1a0515933c5c84fe = /*#__PURE__*/ $aByOK.flatMapNullable($53f631bec50b1359$var$_FromEither, $53f631bec50b1359$var$_FlatMap);
var $53f631bec50b1359$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $aByOK.flatMapOption($53f631bec50b1359$var$_FromEither, $53f631bec50b1359$var$_FlatMap);
var $53f631bec50b1359$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $ctkBN.filterOrElse)($53f631bec50b1359$export$825ea6cb6fc48d49, $53f631bec50b1359$export$f18d5acc27d70423);
var $53f631bec50b1359$export$84511cf4503ec9dd = $53f631bec50b1359$export$30af8ca9498ddf5b;
var $53f631bec50b1359$export$b0e76d9850c64156 = function(ma) {
    return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? $53f631bec50b1359$export$79ffe56a765070d2(ma.left) : $53f631bec50b1359$export$eabcd2c8791e7bf4(ma.right);
};
var $53f631bec50b1359$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $53f631bec50b1359$export$41d1a04d78e7b141 = $53f631bec50b1359$export$efd845e0c87089a6;
var $53f631bec50b1359$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $53f631bec50b1359$export$eabcd2c8791e7bf4(e) : $53f631bec50b1359$export$79ffe56a765070d2(a);
    };
};
var $53f631bec50b1359$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $53f631bec50b1359$export$79ffe56a765070d2(f());
    } catch (e) {
        return $53f631bec50b1359$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $53f631bec50b1359$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $53f631bec50b1359$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $53f631bec50b1359$export$c69ca7b73fad45e1 = function(e) {
    var from = $53f631bec50b1359$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $f5id0.flow)(f, from);
    };
};
var $53f631bec50b1359$export$c81f992c08fd0bf3 = function(e) {
    var from = $53f631bec50b1359$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $53f631bec50b1359$export$5b8affa63fc6df16(from(f));
    };
};
var $53f631bec50b1359$export$a0886ed3a572729f = /*#__PURE__*/ $53f631bec50b1359$export$ccb09033cefa61e8((0, $f5id0.identity), (0, $f5id0.identity));
function $53f631bec50b1359$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $53f631bec50b1359$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $53f631bec50b1359$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $53f631bec50b1359$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $53f631bec50b1359$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $53f631bec50b1359$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $53f631bec50b1359$export$ba255e9e49e00608($aByOK.emptyRecord);
var $53f631bec50b1359$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($53f631bec50b1359$export$bd5b6bfc5fa2ee61);
var $53f631bec50b1359$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($53f631bec50b1359$export$bd5b6bfc5fa2ee61);
var $53f631bec50b1359$export$2385a24977818dd0 = /*#__PURE__*/ $lcDVT.bind($53f631bec50b1359$export$f18d5acc27d70423);
var $53f631bec50b1359$export$e0d5b1cbe98976d9 = $53f631bec50b1359$export$2385a24977818dd0;
var $53f631bec50b1359$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($53f631bec50b1359$export$efc21ddc6aeb363d);
var $53f631bec50b1359$export$5c01f27714264b3d = $53f631bec50b1359$export$8cbfc0239f42bb49;
var $53f631bec50b1359$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $53f631bec50b1359$export$ba255e9e49e00608($aByOK.emptyReadonlyArray);
var $53f631bec50b1359$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $aByOK.head(as));
        if ($53f631bec50b1359$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($53f631bec50b1359$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $53f631bec50b1359$export$79ffe56a765070d2(out);
    };
};
var $53f631bec50b1359$export$d4e79db5dc14cc1 = function(f) {
    var g = $53f631bec50b1359$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $53f631bec50b1359$export$c74b6e34b2b6efb0;
    };
};
var $53f631bec50b1359$export$104a2841e9cbad06 = $53f631bec50b1359$export$d4e79db5dc14cc1;
var $53f631bec50b1359$export$64f39b2a2b79e1b1 = function(f) {
    return $53f631bec50b1359$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $53f631bec50b1359$export$d330b60315c14cd1 = /*#__PURE__*/ $53f631bec50b1359$export$64f39b2a2b79e1b1((0, $f5id0.identity));
var $53f631bec50b1359$export$8e5885f0163d737a = $53f631bec50b1359$export$5b8affa63fc6df16;
var $53f631bec50b1359$export$e08e3b67e392101e = $53f631bec50b1359$export$5b8affa63fc6df16;
var $53f631bec50b1359$export$e3821ef4970c339c = $53f631bec50b1359$export$3f23594af5f37336;
var $53f631bec50b1359$export$5de78197fc44b933 = $53f631bec50b1359$export$3f23594af5f37336;
function $53f631bec50b1359$export$27924e57e9afff7f(s, onError) {
    return $53f631bec50b1359$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $53f631bec50b1359$export$702e019c6853c7a = function(u, onError) {
    return $53f631bec50b1359$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $53f631bec50b1359$export$5f5be1bb6cd1fded = {
    URI: $53f631bec50b1359$export$9156e739aa33e19f,
    map: $53f631bec50b1359$var$_map,
    of: $53f631bec50b1359$export$ba255e9e49e00608,
    ap: $53f631bec50b1359$var$_ap,
    chain: $53f631bec50b1359$export$5b8affa63fc6df16,
    reduce: $53f631bec50b1359$var$_reduce,
    foldMap: $53f631bec50b1359$var$_foldMap,
    reduceRight: $53f631bec50b1359$var$_reduceRight,
    traverse: $53f631bec50b1359$var$_traverse,
    sequence: $53f631bec50b1359$export$49bb65c2ea163039,
    bimap: $53f631bec50b1359$var$_bimap,
    mapLeft: $53f631bec50b1359$var$_mapLeft,
    alt: $53f631bec50b1359$var$_alt,
    extend: $53f631bec50b1359$var$_extend,
    chainRec: $53f631bec50b1359$var$_chainRec,
    throwError: $53f631bec50b1359$export$8bf7aba4a9e09055
};
var $53f631bec50b1359$export$18979a515d2a828e = /*#__PURE__*/ (0, $6IQDS.getApplySemigroup)($53f631bec50b1359$export$efc21ddc6aeb363d);
var $53f631bec50b1359$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $6jM4Q.getApplicativeMonoid)($53f631bec50b1359$export$1279d2b7807629fd);
var $53f631bec50b1359$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $6IQDS.getApplySemigroup)($53f631bec50b1359$export$d9540e18497e6036(SE))(SA);
};
var $53f631bec50b1359$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $6jM4Q.getApplicativeMonoid)($53f631bec50b1359$export$d9540e18497e6036(SE))(MA);
};
function $53f631bec50b1359$export$6843f928420ce3e4(SE) {
    var ap = $53f631bec50b1359$export$d9540e18497e6036(SE).ap;
    var alt = $53f631bec50b1359$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $53f631bec50b1359$export$9156e739aa33e19f,
        _E: undefined,
        map: $53f631bec50b1359$var$_map,
        of: $53f631bec50b1359$export$ba255e9e49e00608,
        chain: $53f631bec50b1359$export$5b8affa63fc6df16,
        bimap: $53f631bec50b1359$var$_bimap,
        mapLeft: $53f631bec50b1359$var$_mapLeft,
        reduce: $53f631bec50b1359$var$_reduce,
        foldMap: $53f631bec50b1359$var$_foldMap,
        reduceRight: $53f631bec50b1359$var$_reduceRight,
        extend: $53f631bec50b1359$var$_extend,
        traverse: $53f631bec50b1359$var$_traverse,
        sequence: $53f631bec50b1359$export$49bb65c2ea163039,
        chainRec: $53f631bec50b1359$var$_chainRec,
        throwError: $53f631bec50b1359$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("eqiLn", function(module, exports) {

$parcel$export(module.exports, "tailRec", function () { return $a8020c5ffb7c0c16$export$2e586eaa876dd2fd; });
/**
 * @since 2.0.0
 */ var $a8020c5ffb7c0c16$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

});




parcelRegister("bsqKk", function(module, exports) {

$parcel$export(module.exports, "asLens", function () { return $85770e8081685ec0$export$ba6dbfc52e933ec; });
$parcel$export(module.exports, "asPrism", function () { return $85770e8081685ec0$export$6963d4cf5712e556; });
$parcel$export(module.exports, "asOptional", function () { return $85770e8081685ec0$export$81a625dd455a09de; });
$parcel$export(module.exports, "asTraversal", function () { return $85770e8081685ec0$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $85770e8081685ec0$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "reverse", function () { return $85770e8081685ec0$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "modify", function () { return $85770e8081685ec0$export$3ff57735a52b8713; });

var $f5id0 = parcelRequire("f5id0");

var $4CZFO = parcelRequire("4CZFO");

var $ljPND = parcelRequire("ljPND");
var $85770e8081685ec0$export$1aba8f741a0eae06 = $ljPND.iso;
var $85770e8081685ec0$export$d560c7e4a29451c2 = function() {
    return $85770e8081685ec0$export$1aba8f741a0eae06((0, $f5id0.identity), (0, $f5id0.identity));
};
var $85770e8081685ec0$export$ba6dbfc52e933ec = $ljPND.isoAsLens;
var $85770e8081685ec0$export$6963d4cf5712e556 = $ljPND.isoAsPrism;
var $85770e8081685ec0$export$81a625dd455a09de = $ljPND.isoAsOptional;
var $85770e8081685ec0$export$ef38eac73d6f828f = $ljPND.isoAsTraversal;
var $85770e8081685ec0$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $85770e8081685ec0$export$1aba8f741a0eae06((0, $f5id0.flow)(sa.get, ab.get), (0, $f5id0.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $85770e8081685ec0$export$220ad92d18dabdd7 = $85770e8081685ec0$export$f672e0b6f7222cd7;
var $85770e8081685ec0$export$f5c3e419c6a355ce = function(ab) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$ba6dbfc52e933ec, $ljPND.lensComposeLens(ab));
};
var $85770e8081685ec0$export$c1dc05e399870f6 = function(ab) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$6963d4cf5712e556, $ljPND.prismComposePrism(ab));
};
var $85770e8081685ec0$export$323f76c400675c8b = function(ab) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$81a625dd455a09de, $ljPND.optionalComposeOptional(ab));
};
var $85770e8081685ec0$export$aa978f69e007229f = function(ab) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$ef38eac73d6f828f, $ljPND.traversalComposeTraversal(ab));
};
var $85770e8081685ec0$export$66c1ae025e96b4bc = function(sa) {
    return $85770e8081685ec0$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $85770e8081685ec0$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $85770e8081685ec0$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $4CZFO.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $85770e8081685ec0$export$b601f49376b4621a = function(sa) {
    return $85770e8081685ec0$export$c1dc05e399870f6($ljPND.prismFromNullable())(sa);
};
function $85770e8081685ec0$export$3dea766d36a8935f(predicate) {
    return $85770e8081685ec0$export$c1dc05e399870f6($ljPND.prismFromPredicate(predicate));
}
var $85770e8081685ec0$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$ba6dbfc52e933ec, $ljPND.lensProp(prop));
};
var $85770e8081685ec0$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $f5id0.flow)($85770e8081685ec0$export$ba6dbfc52e933ec, $ljPND.lensProps.apply($ljPND, props));
};
var $85770e8081685ec0$export$d8556a2a8f973135 = function(prop) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$ba6dbfc52e933ec, $ljPND.lensComponent(prop));
};
var $85770e8081685ec0$export$b610b8812bbcded9 = function(i) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$81a625dd455a09de, $ljPND.optionalIndex(i));
};
var $85770e8081685ec0$export$84162b00c25b711c = function(i) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$81a625dd455a09de, $ljPND.optionalIndexNonEmpty(i));
};
var $85770e8081685ec0$export$df61b30b684217c0 = function(key) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$81a625dd455a09de, $ljPND.optionalKey(key));
};
var $85770e8081685ec0$export$976574c443b9185b = function(key) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$ba6dbfc52e933ec, $ljPND.lensAtKey(key));
};
var $85770e8081685ec0$export$ad14ef4001db2bcd = /*#__PURE__*/ $85770e8081685ec0$export$c1dc05e399870f6(/*#__PURE__*/ $ljPND.prismSome());
var $85770e8081685ec0$export$79ffe56a765070d2 = /*#__PURE__*/ $85770e8081685ec0$export$c1dc05e399870f6(/*#__PURE__*/ $ljPND.prismRight());
var $85770e8081685ec0$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $85770e8081685ec0$export$c1dc05e399870f6(/*#__PURE__*/ $ljPND.prismLeft());
function $85770e8081685ec0$export$df3f009e3d155b20(T) {
    return (0, $f5id0.flow)($85770e8081685ec0$export$ef38eac73d6f828f, $ljPND.traversalTraverse(T));
}
function $85770e8081685ec0$export$9a2f228bed5035c2(predicate) {
    return $85770e8081685ec0$export$323f76c400675c8b($ljPND.optionalFindFirst(predicate));
}
function $85770e8081685ec0$export$28e1f787311e0a21(predicate) {
    return $85770e8081685ec0$export$323f76c400675c8b($ljPND.optionalFindFirstNonEmpty(predicate));
}
var $85770e8081685ec0$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $85770e8081685ec0$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $85770e8081685ec0$var$imap_ = function(ea, ab, ba) {
    return $85770e8081685ec0$export$1aba8f741a0eae06((0, $f5id0.flow)(ea.get, ab), (0, $f5id0.flow)(ba, ea.reverseGet));
};
var $85770e8081685ec0$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $85770e8081685ec0$export$dbdf692cc5737cfd = {
    URI: $85770e8081685ec0$export$9156e739aa33e19f,
    imap: $85770e8081685ec0$var$imap_
};
var $85770e8081685ec0$export$67666a3fb7d250d8 = {
    URI: $85770e8081685ec0$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $85770e8081685ec0$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $85770e8081685ec0$export$3a8840c5b2ecf003 = {
    URI: $85770e8081685ec0$export$9156e739aa33e19f,
    compose: $85770e8081685ec0$export$67666a3fb7d250d8.compose,
    id: $85770e8081685ec0$export$d560c7e4a29451c2
};

});

parcelRegister("kXLDY", function(module, exports) {

$parcel$export(module.exports, "fromAt", function () { return $f42e4663165916b6$export$c4dd3e639c7af330; });
$parcel$export(module.exports, "fromIso", function () { return $f42e4663165916b6$export$3160d47a1ad63980; });
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 
var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");

var $ljPND = parcelRequire("ljPND");

var $4CDo2 = parcelRequire("4CDo2");
var $f42e4663165916b6$export$b610b8812bbcded9 = $ljPND.index;
var $f42e4663165916b6$export$c4dd3e639c7af330 = function(at) {
    return $f42e4663165916b6$export$b610b8812bbcded9(function(i) {
        return $ljPND.lensComposePrism($ljPND.prismSome())(at.at(i));
    });
};
var $f42e4663165916b6$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $f42e4663165916b6$export$b610b8812bbcded9(function(i) {
            return (0, $4CZFO.pipe)(iso, $ljPND.isoAsOptional, $ljPND.optionalComposeOptional(sia.index(i)));
        });
    };
};
var $f42e4663165916b6$export$bb0c054375ca4b0 = $ljPND.indexReadonlyArray;
var $f42e4663165916b6$export$165af7b747e6b1f1 = $ljPND.indexReadonlyNonEmptyArray;
var $f42e4663165916b6$export$3c3468aec3b83bbf = $ljPND.indexReadonlyRecord;
var $f42e4663165916b6$export$92da200d6ddb6846 = function(E) {
    var lookupE = $4CDo2.lookup(E);
    var insertAtE = $4CDo2.insertAt(E);
    return function() {
        return $f42e4663165916b6$export$b610b8812bbcded9(function(key) {
            return $ljPND.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $4CZFO.pipe)(lookupE(key, s), $hVAkz.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $f42e4663165916b6$export$2cd1c249765cd0a4 = $ljPND.indexReadonlyArray;
var $f42e4663165916b6$export$720226bf1ef46cb2 = $ljPND.indexReadonlyRecord;

});

parcelRegister("gnzcc", function(module, exports) {

$parcel$export(module.exports, "lens", function () { return $beca187c451fcd3c$export$21cde5187c2605a3; });
$parcel$export(module.exports, "id", function () { return $beca187c451fcd3c$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "asOptional", function () { return $beca187c451fcd3c$export$81a625dd455a09de; });
$parcel$export(module.exports, "asTraversal", function () { return $beca187c451fcd3c$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $beca187c451fcd3c$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "composeLens", function () { return $beca187c451fcd3c$export$f5c3e419c6a355ce; });
$parcel$export(module.exports, "composeIso", function () { return $beca187c451fcd3c$export$220ad92d18dabdd7; });
$parcel$export(module.exports, "composePrism", function () { return $beca187c451fcd3c$export$c1dc05e399870f6; });
$parcel$export(module.exports, "composeOptional", function () { return $beca187c451fcd3c$export$323f76c400675c8b; });
$parcel$export(module.exports, "composeTraversal", function () { return $beca187c451fcd3c$export$aa978f69e007229f; });
$parcel$export(module.exports, "modify", function () { return $beca187c451fcd3c$export$3ff57735a52b8713; });
$parcel$export(module.exports, "modifyF", function () { return $beca187c451fcd3c$export$a28005d3e6beb9a6; });
$parcel$export(module.exports, "fromNullable", function () { return $beca187c451fcd3c$export$b601f49376b4621a; });
$parcel$export(module.exports, "filter", function () { return $beca187c451fcd3c$export$3dea766d36a8935f; });
$parcel$export(module.exports, "prop", function () { return $beca187c451fcd3c$export$977f3f6a9323c0f6; });
$parcel$export(module.exports, "props", function () { return $beca187c451fcd3c$export$8128bb6492cf3de7; });
$parcel$export(module.exports, "component", function () { return $beca187c451fcd3c$export$d8556a2a8f973135; });
$parcel$export(module.exports, "index", function () { return $beca187c451fcd3c$export$b610b8812bbcded9; });
$parcel$export(module.exports, "indexNonEmpty", function () { return $beca187c451fcd3c$export$84162b00c25b711c; });
$parcel$export(module.exports, "key", function () { return $beca187c451fcd3c$export$df61b30b684217c0; });
$parcel$export(module.exports, "atKey", function () { return $beca187c451fcd3c$export$976574c443b9185b; });
$parcel$export(module.exports, "some", function () { return $beca187c451fcd3c$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "right", function () { return $beca187c451fcd3c$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $beca187c451fcd3c$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "traverse", function () { return $beca187c451fcd3c$export$df3f009e3d155b20; });
$parcel$export(module.exports, "findFirst", function () { return $beca187c451fcd3c$export$9a2f228bed5035c2; });
$parcel$export(module.exports, "findFirstNonEmpty", function () { return $beca187c451fcd3c$export$28e1f787311e0a21; });
$parcel$export(module.exports, "imap", function () { return $beca187c451fcd3c$export$b2517b0ab3a58435; });
$parcel$export(module.exports, "URI", function () { return $beca187c451fcd3c$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Invariant", function () { return $beca187c451fcd3c$export$dbdf692cc5737cfd; });
$parcel$export(module.exports, "Semigroupoid", function () { return $beca187c451fcd3c$export$67666a3fb7d250d8; });
$parcel$export(module.exports, "Category", function () { return $beca187c451fcd3c$export$3a8840c5b2ecf003; });

var $f5id0 = parcelRequire("f5id0");

var $4CZFO = parcelRequire("4CZFO");

var $ljPND = parcelRequire("ljPND");
var $beca187c451fcd3c$export$21cde5187c2605a3 = $ljPND.lens;
var $beca187c451fcd3c$export$d560c7e4a29451c2 = $ljPND.lensId;
var $beca187c451fcd3c$export$81a625dd455a09de = $ljPND.lensAsOptional;
var $beca187c451fcd3c$export$ef38eac73d6f828f = $ljPND.lensAsTraversal;
var $beca187c451fcd3c$export$f672e0b6f7222cd7 = $ljPND.lensComposeLens;
var $beca187c451fcd3c$export$f5c3e419c6a355ce = $beca187c451fcd3c$export$f672e0b6f7222cd7;
var $beca187c451fcd3c$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.isoAsLens, $beca187c451fcd3c$export$f672e0b6f7222cd7);
var $beca187c451fcd3c$export$c1dc05e399870f6 = $ljPND.lensComposePrism;
var $beca187c451fcd3c$export$323f76c400675c8b = function(ab) {
    return (0, $f5id0.flow)($beca187c451fcd3c$export$81a625dd455a09de, $ljPND.optionalComposeOptional(ab));
};
var $beca187c451fcd3c$export$aa978f69e007229f = function(ab) {
    return (0, $f5id0.flow)($beca187c451fcd3c$export$ef38eac73d6f828f, $ljPND.traversalComposeTraversal(ab));
};
var $beca187c451fcd3c$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $beca187c451fcd3c$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $4CZFO.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $beca187c451fcd3c$export$b601f49376b4621a = function(sa) {
    return $beca187c451fcd3c$export$c1dc05e399870f6($ljPND.prismFromNullable())(sa);
};
function $beca187c451fcd3c$export$3dea766d36a8935f(predicate) {
    return $beca187c451fcd3c$export$c1dc05e399870f6($ljPND.prismFromPredicate(predicate));
}
var $beca187c451fcd3c$export$977f3f6a9323c0f6 = $ljPND.lensProp;
var $beca187c451fcd3c$export$8128bb6492cf3de7 = $ljPND.lensProps;
var $beca187c451fcd3c$export$d8556a2a8f973135 = $ljPND.lensComponent;
var $beca187c451fcd3c$export$b610b8812bbcded9 = function(i) {
    return (0, $f5id0.flow)($beca187c451fcd3c$export$81a625dd455a09de, $ljPND.optionalIndex(i));
};
var $beca187c451fcd3c$export$84162b00c25b711c = function(i) {
    return (0, $f5id0.flow)($beca187c451fcd3c$export$81a625dd455a09de, $ljPND.optionalIndexNonEmpty(i));
};
var $beca187c451fcd3c$export$df61b30b684217c0 = function(key) {
    return (0, $f5id0.flow)($beca187c451fcd3c$export$81a625dd455a09de, $ljPND.optionalKey(key));
};
var $beca187c451fcd3c$export$976574c443b9185b = $ljPND.lensAtKey;
var $beca187c451fcd3c$export$ad14ef4001db2bcd = /*#__PURE__*/ $beca187c451fcd3c$export$c1dc05e399870f6(/*#__PURE__*/ $ljPND.prismSome());
var $beca187c451fcd3c$export$79ffe56a765070d2 = /*#__PURE__*/ $beca187c451fcd3c$export$c1dc05e399870f6(/*#__PURE__*/ $ljPND.prismRight());
var $beca187c451fcd3c$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $beca187c451fcd3c$export$c1dc05e399870f6(/*#__PURE__*/ $ljPND.prismLeft());
function $beca187c451fcd3c$export$df3f009e3d155b20(T) {
    return (0, $f5id0.flow)($beca187c451fcd3c$export$ef38eac73d6f828f, $ljPND.traversalTraverse(T));
}
function $beca187c451fcd3c$export$9a2f228bed5035c2(predicate) {
    return $beca187c451fcd3c$export$323f76c400675c8b($ljPND.optionalFindFirst(predicate));
}
function $beca187c451fcd3c$export$28e1f787311e0a21(predicate) {
    return $beca187c451fcd3c$export$323f76c400675c8b($ljPND.optionalFindFirstNonEmpty(predicate));
}
var $beca187c451fcd3c$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $beca187c451fcd3c$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $beca187c451fcd3c$var$imap_ = function(ea, ab, ba) {
    return $beca187c451fcd3c$export$21cde5187c2605a3((0, $f5id0.flow)(ea.get, ab), (0, $f5id0.flow)(ba, ea.set));
};
var $beca187c451fcd3c$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $beca187c451fcd3c$export$dbdf692cc5737cfd = {
    URI: $beca187c451fcd3c$export$9156e739aa33e19f,
    imap: $beca187c451fcd3c$var$imap_
};
var $beca187c451fcd3c$export$67666a3fb7d250d8 = {
    URI: $beca187c451fcd3c$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $beca187c451fcd3c$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $beca187c451fcd3c$export$3a8840c5b2ecf003 = {
    URI: $beca187c451fcd3c$export$9156e739aa33e19f,
    compose: $beca187c451fcd3c$export$67666a3fb7d250d8.compose,
    id: $beca187c451fcd3c$export$d560c7e4a29451c2
};

});

parcelRegister("asc1N", function(module, exports) {

$parcel$export(module.exports, "optional", function () { return $79c5d96684ef0d98$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "id", function () { return $79c5d96684ef0d98$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "asTraversal", function () { return $79c5d96684ef0d98$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $79c5d96684ef0d98$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "composeOptional", function () { return $79c5d96684ef0d98$export$323f76c400675c8b; });
$parcel$export(module.exports, "composeIso", function () { return $79c5d96684ef0d98$export$220ad92d18dabdd7; });
$parcel$export(module.exports, "composeLens", function () { return $79c5d96684ef0d98$export$f5c3e419c6a355ce; });
$parcel$export(module.exports, "composePrism", function () { return $79c5d96684ef0d98$export$c1dc05e399870f6; });
$parcel$export(module.exports, "composeTraversal", function () { return $79c5d96684ef0d98$export$aa978f69e007229f; });
$parcel$export(module.exports, "modifyOption", function () { return $79c5d96684ef0d98$export$a2ef9d652875bdfa; });
$parcel$export(module.exports, "setOption", function () { return $79c5d96684ef0d98$export$b2a7969df3fe0aa3; });
$parcel$export(module.exports, "modify", function () { return $79c5d96684ef0d98$export$3ff57735a52b8713; });
$parcel$export(module.exports, "modifyF", function () { return $79c5d96684ef0d98$export$a28005d3e6beb9a6; });
$parcel$export(module.exports, "fromNullable", function () { return $79c5d96684ef0d98$export$b601f49376b4621a; });
$parcel$export(module.exports, "filter", function () { return $79c5d96684ef0d98$export$3dea766d36a8935f; });
$parcel$export(module.exports, "prop", function () { return $79c5d96684ef0d98$export$977f3f6a9323c0f6; });
$parcel$export(module.exports, "props", function () { return $79c5d96684ef0d98$export$8128bb6492cf3de7; });
$parcel$export(module.exports, "component", function () { return $79c5d96684ef0d98$export$d8556a2a8f973135; });
$parcel$export(module.exports, "index", function () { return $79c5d96684ef0d98$export$b610b8812bbcded9; });
$parcel$export(module.exports, "indexNonEmpty", function () { return $79c5d96684ef0d98$export$84162b00c25b711c; });
$parcel$export(module.exports, "key", function () { return $79c5d96684ef0d98$export$df61b30b684217c0; });
$parcel$export(module.exports, "atKey", function () { return $79c5d96684ef0d98$export$976574c443b9185b; });
$parcel$export(module.exports, "some", function () { return $79c5d96684ef0d98$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "right", function () { return $79c5d96684ef0d98$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $79c5d96684ef0d98$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "traverse", function () { return $79c5d96684ef0d98$export$df3f009e3d155b20; });
$parcel$export(module.exports, "findFirst", function () { return $79c5d96684ef0d98$export$9a2f228bed5035c2; });
$parcel$export(module.exports, "findFirstNonEmpty", function () { return $79c5d96684ef0d98$export$28e1f787311e0a21; });
$parcel$export(module.exports, "imap", function () { return $79c5d96684ef0d98$export$b2517b0ab3a58435; });
$parcel$export(module.exports, "URI", function () { return $79c5d96684ef0d98$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Invariant", function () { return $79c5d96684ef0d98$export$dbdf692cc5737cfd; });
$parcel$export(module.exports, "Semigroupoid", function () { return $79c5d96684ef0d98$export$67666a3fb7d250d8; });
$parcel$export(module.exports, "Category", function () { return $79c5d96684ef0d98$export$3a8840c5b2ecf003; });

var $f5id0 = parcelRequire("f5id0");

var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");

var $ljPND = parcelRequire("ljPND");
var $79c5d96684ef0d98$export$516e28dec6a4b6d4 = $ljPND.optional;
var $79c5d96684ef0d98$export$d560c7e4a29451c2 = function() {
    return $79c5d96684ef0d98$export$516e28dec6a4b6d4($hVAkz.some, (0, $f5id0.constant));
};
var $79c5d96684ef0d98$export$ef38eac73d6f828f = $ljPND.optionalAsTraversal;
var $79c5d96684ef0d98$export$f672e0b6f7222cd7 = $ljPND.optionalComposeOptional;
var $79c5d96684ef0d98$export$323f76c400675c8b = $79c5d96684ef0d98$export$f672e0b6f7222cd7;
var $79c5d96684ef0d98$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.isoAsOptional, $79c5d96684ef0d98$export$f672e0b6f7222cd7);
var $79c5d96684ef0d98$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.lensAsOptional, $ljPND.optionalComposeOptional);
var $79c5d96684ef0d98$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.prismAsOptional, $ljPND.optionalComposeOptional);
var $79c5d96684ef0d98$export$aa978f69e007229f = function(ab) {
    return (0, $f5id0.flow)($79c5d96684ef0d98$export$ef38eac73d6f828f, $ljPND.traversalComposeTraversal(ab));
};
var $79c5d96684ef0d98$export$a2ef9d652875bdfa = $ljPND.optionalModifyOption;
var $79c5d96684ef0d98$export$b2a7969df3fe0aa3 = function(a) {
    return $79c5d96684ef0d98$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $79c5d96684ef0d98$export$3ff57735a52b8713 = $ljPND.optionalModify;
function $79c5d96684ef0d98$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $4CZFO.pipe)(sa.getOption(s), $hVAkz.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $79c5d96684ef0d98$export$b601f49376b4621a = /*#__PURE__*/ $79c5d96684ef0d98$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsOptional(/*#__PURE__*/ $ljPND.prismFromNullable()));
function $79c5d96684ef0d98$export$3dea766d36a8935f(predicate) {
    return $79c5d96684ef0d98$export$f672e0b6f7222cd7($ljPND.prismAsOptional($ljPND.prismFromPredicate(predicate)));
}
var $79c5d96684ef0d98$export$977f3f6a9323c0f6 = function(prop) {
    return $79c5d96684ef0d98$export$f672e0b6f7222cd7((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensProp(prop), $ljPND.lensAsOptional));
};
var $79c5d96684ef0d98$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $79c5d96684ef0d98$export$f672e0b6f7222cd7((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensProps.apply($ljPND, props), $ljPND.lensAsOptional));
};
var $79c5d96684ef0d98$export$d8556a2a8f973135 = function(prop) {
    return $79c5d96684ef0d98$export$f672e0b6f7222cd7((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensComponent(prop), $ljPND.lensAsOptional));
};
var $79c5d96684ef0d98$export$b610b8812bbcded9 = $ljPND.optionalIndex;
var $79c5d96684ef0d98$export$84162b00c25b711c = $ljPND.optionalIndexNonEmpty;
var $79c5d96684ef0d98$export$df61b30b684217c0 = $ljPND.optionalKey;
var $79c5d96684ef0d98$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $79c5d96684ef0d98$export$f672e0b6f7222cd7($ljPND.lensAsOptional($ljPND.atReadonlyRecord().at(key))));
    };
};
var $79c5d96684ef0d98$export$ad14ef4001db2bcd = /*#__PURE__*/ $79c5d96684ef0d98$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsOptional(/*#__PURE__*/ $ljPND.prismSome()));
var $79c5d96684ef0d98$export$79ffe56a765070d2 = /*#__PURE__*/ $79c5d96684ef0d98$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsOptional(/*#__PURE__*/ $ljPND.prismRight()));
var $79c5d96684ef0d98$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $79c5d96684ef0d98$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsOptional(/*#__PURE__*/ $ljPND.prismLeft()));
function $79c5d96684ef0d98$export$df3f009e3d155b20(T) {
    return (0, $f5id0.flow)($79c5d96684ef0d98$export$ef38eac73d6f828f, $ljPND.traversalTraverse(T));
}
function $79c5d96684ef0d98$export$9a2f228bed5035c2(predicate) {
    return $79c5d96684ef0d98$export$f672e0b6f7222cd7($ljPND.optionalFindFirst(predicate));
}
function $79c5d96684ef0d98$export$28e1f787311e0a21(predicate) {
    return $79c5d96684ef0d98$export$f672e0b6f7222cd7($ljPND.optionalFindFirstNonEmpty(predicate));
}
var $79c5d96684ef0d98$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $79c5d96684ef0d98$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $79c5d96684ef0d98$var$imap_ = function(ea, ab, ba) {
    return $79c5d96684ef0d98$export$516e28dec6a4b6d4((0, $f5id0.flow)(ea.getOption, $hVAkz.map(ab)), (0, $f5id0.flow)(ba, ea.set));
};
var $79c5d96684ef0d98$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $79c5d96684ef0d98$export$dbdf692cc5737cfd = {
    URI: $79c5d96684ef0d98$export$9156e739aa33e19f,
    imap: $79c5d96684ef0d98$var$imap_
};
var $79c5d96684ef0d98$export$67666a3fb7d250d8 = {
    URI: $79c5d96684ef0d98$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $79c5d96684ef0d98$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $79c5d96684ef0d98$export$3a8840c5b2ecf003 = {
    URI: $79c5d96684ef0d98$export$9156e739aa33e19f,
    compose: $79c5d96684ef0d98$export$67666a3fb7d250d8.compose,
    id: $79c5d96684ef0d98$export$d560c7e4a29451c2
};

});

parcelRegister("3CRtD", function(module, exports) {

$parcel$export(module.exports, "fromPredicate", function () { return $2a3e6723f4b6b369$export$23f31c55d7162b91; });
$parcel$export(module.exports, "asOptional", function () { return $2a3e6723f4b6b369$export$81a625dd455a09de; });
$parcel$export(module.exports, "asTraversal", function () { return $2a3e6723f4b6b369$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $2a3e6723f4b6b369$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "composeLens", function () { return $2a3e6723f4b6b369$export$f5c3e419c6a355ce; });

var $f5id0 = parcelRequire("f5id0");

var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");

var $ljPND = parcelRequire("ljPND");
var $2a3e6723f4b6b369$export$e469dcfea9910464 = $ljPND.prism;
var $2a3e6723f4b6b369$export$d560c7e4a29451c2 = function() {
    return $2a3e6723f4b6b369$export$e469dcfea9910464($hVAkz.some, (0, $f5id0.identity));
};
var $2a3e6723f4b6b369$export$23f31c55d7162b91 = $ljPND.prismFromPredicate;
var $2a3e6723f4b6b369$export$81a625dd455a09de = $ljPND.prismAsOptional;
var $2a3e6723f4b6b369$export$ef38eac73d6f828f = $ljPND.prismAsTraversal;
var $2a3e6723f4b6b369$export$f672e0b6f7222cd7 = $ljPND.prismComposePrism;
var $2a3e6723f4b6b369$export$c1dc05e399870f6 = $2a3e6723f4b6b369$export$f672e0b6f7222cd7;
var $2a3e6723f4b6b369$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.isoAsPrism, $2a3e6723f4b6b369$export$f672e0b6f7222cd7);
var $2a3e6723f4b6b369$export$f5c3e419c6a355ce = $ljPND.prismComposeLens;
var $2a3e6723f4b6b369$export$323f76c400675c8b = function(ab) {
    return (0, $f5id0.flow)($2a3e6723f4b6b369$export$81a625dd455a09de, $ljPND.optionalComposeOptional(ab));
};
var $2a3e6723f4b6b369$export$aa978f69e007229f = function(ab) {
    return (0, $f5id0.flow)($2a3e6723f4b6b369$export$ef38eac73d6f828f, $ljPND.traversalComposeTraversal(ab));
};
var $2a3e6723f4b6b369$export$adaa4cf7ef1b65be = $ljPND.prismSet;
var $2a3e6723f4b6b369$export$a2ef9d652875bdfa = $ljPND.prismModifyOption;
var $2a3e6723f4b6b369$export$3ff57735a52b8713 = $ljPND.prismModify;
function $2a3e6723f4b6b369$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $4CZFO.pipe)(sa.getOption(s), $hVAkz.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $2a3e6723f4b6b369$export$b601f49376b4621a = /*#__PURE__*/ $2a3e6723f4b6b369$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismFromNullable());
function $2a3e6723f4b6b369$export$3dea766d36a8935f(predicate) {
    return $2a3e6723f4b6b369$export$f672e0b6f7222cd7($ljPND.prismFromPredicate(predicate));
}
var $2a3e6723f4b6b369$export$977f3f6a9323c0f6 = function(prop) {
    return $2a3e6723f4b6b369$export$f5c3e419c6a355ce((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensProp(prop)));
}; // TODO: simplify?
var $2a3e6723f4b6b369$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $2a3e6723f4b6b369$export$f5c3e419c6a355ce((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensProps.apply($ljPND, props)));
};
var $2a3e6723f4b6b369$export$d8556a2a8f973135 = function(prop) {
    return $2a3e6723f4b6b369$export$f5c3e419c6a355ce((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensComponent(prop)));
};
var $2a3e6723f4b6b369$export$b610b8812bbcded9 = function(i) {
    return (0, $f5id0.flow)($2a3e6723f4b6b369$export$81a625dd455a09de, $ljPND.optionalIndex(i));
};
var $2a3e6723f4b6b369$export$84162b00c25b711c = function(i) {
    return (0, $f5id0.flow)($2a3e6723f4b6b369$export$81a625dd455a09de, $ljPND.optionalIndexNonEmpty(i));
};
var $2a3e6723f4b6b369$export$df61b30b684217c0 = function(key) {
    return (0, $f5id0.flow)($2a3e6723f4b6b369$export$81a625dd455a09de, $ljPND.optionalKey(key));
};
var $2a3e6723f4b6b369$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $ljPND.prismComposeLens($ljPND.atReadonlyRecord().at(key))(sa);
    };
};
var $2a3e6723f4b6b369$export$ad14ef4001db2bcd = /*#__PURE__*/ $2a3e6723f4b6b369$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismSome());
var $2a3e6723f4b6b369$export$79ffe56a765070d2 = /*#__PURE__*/ $2a3e6723f4b6b369$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismRight());
var $2a3e6723f4b6b369$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $2a3e6723f4b6b369$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismLeft());
function $2a3e6723f4b6b369$export$df3f009e3d155b20(T) {
    return (0, $f5id0.flow)($2a3e6723f4b6b369$export$ef38eac73d6f828f, $ljPND.traversalTraverse(T));
}
function $2a3e6723f4b6b369$export$9a2f228bed5035c2(predicate) {
    return $2a3e6723f4b6b369$export$323f76c400675c8b($ljPND.optionalFindFirst(predicate));
}
function $2a3e6723f4b6b369$export$28e1f787311e0a21(predicate) {
    return $2a3e6723f4b6b369$export$323f76c400675c8b($ljPND.optionalFindFirstNonEmpty(predicate));
}
var $2a3e6723f4b6b369$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $2a3e6723f4b6b369$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $2a3e6723f4b6b369$var$imap_ = function(ea, ab, ba) {
    return $2a3e6723f4b6b369$export$e469dcfea9910464((0, $f5id0.flow)(ea.getOption, $hVAkz.map(ab)), (0, $f5id0.flow)(ba, ea.reverseGet));
};
var $2a3e6723f4b6b369$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $2a3e6723f4b6b369$export$dbdf692cc5737cfd = {
    URI: $2a3e6723f4b6b369$export$9156e739aa33e19f,
    imap: $2a3e6723f4b6b369$var$imap_
};
var $2a3e6723f4b6b369$export$67666a3fb7d250d8 = {
    URI: $2a3e6723f4b6b369$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $2a3e6723f4b6b369$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $2a3e6723f4b6b369$export$3a8840c5b2ecf003 = {
    URI: $2a3e6723f4b6b369$export$9156e739aa33e19f,
    compose: $2a3e6723f4b6b369$export$67666a3fb7d250d8.compose,
    id: $2a3e6723f4b6b369$export$d560c7e4a29451c2
};

});

parcelRegister("gAohm", function(module, exports) {

$parcel$export(module.exports, "fromTraversable", function () { return $c132d7704a69e16a$export$126b5a87c58d3f9c; });
$parcel$export(module.exports, "compose", function () { return $c132d7704a69e16a$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "modify", function () { return $c132d7704a69e16a$export$3ff57735a52b8713; });
$parcel$export(module.exports, "set", function () { return $c132d7704a69e16a$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "filter", function () { return $c132d7704a69e16a$export$3dea766d36a8935f; });

var $lyuPz = parcelRequire("lyuPz");

var $f5id0 = parcelRequire("f5id0");

var $4CZFO = parcelRequire("4CZFO");

var $b406R = parcelRequire("b406R");

var $ljPND = parcelRequire("ljPND");
var $c132d7704a69e16a$export$8666ce7a134c2314 = $ljPND.traversal;
var $c132d7704a69e16a$export$d560c7e4a29451c2 = function() {
    return $c132d7704a69e16a$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $c132d7704a69e16a$export$126b5a87c58d3f9c = $ljPND.fromTraversable;
var $c132d7704a69e16a$export$f672e0b6f7222cd7 = $ljPND.traversalComposeTraversal;
var $c132d7704a69e16a$export$aa978f69e007229f = $c132d7704a69e16a$export$f672e0b6f7222cd7;
var $c132d7704a69e16a$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.isoAsTraversal, $c132d7704a69e16a$export$f672e0b6f7222cd7);
var $c132d7704a69e16a$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.lensAsTraversal, $ljPND.traversalComposeTraversal);
var $c132d7704a69e16a$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.prismAsTraversal, $ljPND.traversalComposeTraversal);
var $c132d7704a69e16a$export$323f76c400675c8b = /*#__PURE__*/ (0, $f5id0.flow)($ljPND.optionalAsTraversal, $ljPND.traversalComposeTraversal);
var $c132d7704a69e16a$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($ljPND.ApplicativeIdentity)(f);
    };
};
var $c132d7704a69e16a$export$adaa4cf7ef1b65be = function(a) {
    return $c132d7704a69e16a$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $c132d7704a69e16a$export$b601f49376b4621a = function(sa) {
    return $c132d7704a69e16a$export$c1dc05e399870f6($ljPND.prismFromNullable())(sa);
};
function $c132d7704a69e16a$export$3dea766d36a8935f(predicate) {
    return $c132d7704a69e16a$export$f672e0b6f7222cd7($ljPND.prismAsTraversal($ljPND.prismFromPredicate(predicate)));
}
var $c132d7704a69e16a$export$977f3f6a9323c0f6 = function(prop) {
    return $c132d7704a69e16a$export$f672e0b6f7222cd7((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensProp(prop), $ljPND.lensAsTraversal));
};
var $c132d7704a69e16a$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $c132d7704a69e16a$export$f672e0b6f7222cd7((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensProps.apply($ljPND, props), $ljPND.lensAsTraversal));
};
var $c132d7704a69e16a$export$d8556a2a8f973135 = function(prop) {
    return $c132d7704a69e16a$export$f672e0b6f7222cd7((0, $4CZFO.pipe)($ljPND.lensId(), $ljPND.lensComponent(prop), $ljPND.lensAsTraversal));
};
var $c132d7704a69e16a$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $c132d7704a69e16a$export$f672e0b6f7222cd7($ljPND.optionalAsTraversal($ljPND.indexReadonlyArray().index(i))));
    };
};
var $c132d7704a69e16a$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $c132d7704a69e16a$export$f672e0b6f7222cd7($ljPND.optionalAsTraversal($ljPND.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $c132d7704a69e16a$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $c132d7704a69e16a$export$f672e0b6f7222cd7($ljPND.optionalAsTraversal($ljPND.indexReadonlyRecord().index(key))));
    };
};
var $c132d7704a69e16a$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $4CZFO.pipe)(sa, $c132d7704a69e16a$export$f672e0b6f7222cd7($ljPND.lensAsTraversal($ljPND.atReadonlyRecord().at(key))));
    };
};
var $c132d7704a69e16a$export$ad14ef4001db2bcd = /*#__PURE__*/ $c132d7704a69e16a$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsTraversal(/*#__PURE__*/ $ljPND.prismSome()));
var $c132d7704a69e16a$export$79ffe56a765070d2 = /*#__PURE__*/ $c132d7704a69e16a$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsTraversal(/*#__PURE__*/ $ljPND.prismRight()));
var $c132d7704a69e16a$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $c132d7704a69e16a$export$f672e0b6f7222cd7(/*#__PURE__*/ $ljPND.prismAsTraversal(/*#__PURE__*/ $ljPND.prismLeft()));
var $c132d7704a69e16a$export$df3f009e3d155b20 = $ljPND.traversalTraverse;
function $c132d7704a69e16a$export$9a2f228bed5035c2(predicate) {
    return $c132d7704a69e16a$export$323f76c400675c8b($ljPND.optionalFindFirst(predicate));
}
function $c132d7704a69e16a$export$28e1f787311e0a21(predicate) {
    return $c132d7704a69e16a$export$323f76c400675c8b($ljPND.optionalFindFirstNonEmpty(predicate));
}
var $c132d7704a69e16a$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($lyuPz.getApplicative(M))(function(a) {
                return $lyuPz.make(f(a));
            });
        };
    };
};
var $c132d7704a69e16a$export$93e2b83da34ff82a = function(M) {
    return $c132d7704a69e16a$export$b66cdc0497d8a99a(M)((0, $f5id0.identity));
};
var $c132d7704a69e16a$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $c132d7704a69e16a$export$b66cdc0497d8a99a($b406R.getMonoid())($b406R.of)(sa)(s);
    };
};
var $c132d7704a69e16a$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $c132d7704a69e16a$export$67666a3fb7d250d8 = {
    URI: $c132d7704a69e16a$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $c132d7704a69e16a$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $c132d7704a69e16a$export$3a8840c5b2ecf003 = {
    URI: $c132d7704a69e16a$export$9156e739aa33e19f,
    compose: $c132d7704a69e16a$export$67666a3fb7d250d8.compose,
    id: $c132d7704a69e16a$export$d560c7e4a29451c2
};

});


parcelRegister("5CmBX", function(module, exports) {
'use strict';
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $41720a79fda68d9e$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("sjwE0", function(module, exports) {

$parcel$export(module.exports, "assertUnreachable", function () { return $6f2d229f1b40df68$export$f2525c1d596f8d46; });
$parcel$export(module.exports, "immutableAssign", function () { return $6f2d229f1b40df68$export$c81b44cfe0e874ce; });
$parcel$export(module.exports, "idcOrd", function () { return $6f2d229f1b40df68$export$16dae286fd0a05e9; });
$parcel$export(module.exports, "NotUsed", function () { return $6f2d229f1b40df68$export$6ad3191707c01020; });
$parcel$export(module.exports, "toNotUsed", function () { return $6f2d229f1b40df68$export$bf979031ac269aa6; });
$parcel$export(module.exports, "Dict", function () { return $6f2d229f1b40df68$export$bfa56c8ff106f1d; });
$parcel$export(module.exports, "PartialDict", function () { return $6f2d229f1b40df68$export$38e1f3962181967d; });
$parcel$export(module.exports, "Either", function () { return $6f2d229f1b40df68$export$37cbe166bfc81b63; });
$parcel$export(module.exports, "Maybe", function () { return $6f2d229f1b40df68$export$ad3bd6e4e1ec5d06; });
$parcel$export(module.exports, "List", function () { return $6f2d229f1b40df68$export$54c2e3dc7acea9f5; });
$parcel$export(module.exports, "NonEmptyArray", function () { return $6f2d229f1b40df68$export$f2d78e4bd16a0737; });
$parcel$export(module.exports, "Tuple", function () { return $6f2d229f1b40df68$export$1908877435b1d5e9; });
$parcel$export(module.exports, "Try", function () { return $6f2d229f1b40df68$export$fa957d01b0310fd7; });
$parcel$export(module.exports, "Future", function () { return $6f2d229f1b40df68$export$c9d7bf589772a8ce; });

var $7cVq5 = parcelRequire("7cVq5");
var $4lr6f = parcelRequire("4lr6f");
var $b45Xq = parcelRequire("b45Xq");
var $hVAkz = parcelRequire("hVAkz");
var $12uqT = parcelRequire("12uqT");
var $b406R = parcelRequire("b406R");
var $4CDo2 = parcelRequire("4CDo2");
var $1ECi6 = parcelRequire("1ECi6");
var $g4z4j = parcelRequire("g4z4j");
var $lc7q7 = parcelRequire("lc7q7");
var $6omhk = parcelRequire("6omhk");
var $1brp6 = parcelRequire("1brp6");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $1k68G = parcelRequire("1k68G");

var $1GV7y = parcelRequire("1GV7y");
function $6f2d229f1b40df68$export$402f4892886ef27f(...args) {
    // eslint-disable-next-line functional/no-throw-statements
    throw Error('Missing implementation');
}
function $6f2d229f1b40df68$export$f2525c1d596f8d46(n) {
    // eslint-disable-next-line functional/no-throw-statements
    throw Error(`Unexpected value: ${n}`);
}
const $6f2d229f1b40df68$export$9dec5d1b3b6a130d = (...label)=>(a)=>{
        console.log(...label, a);
        return a;
    };
function $6f2d229f1b40df68$export$c81b44cfe0e874ce(f, b) {
    return Object.assign(f.bind({}), b);
}
function $6f2d229f1b40df68$export$16dae286fd0a05e9({ equals: equals }) {
    return {
        equals: equals,
        compare: (first, second)=>equals(first, second) ? 0 : (0, $12uqT).trivial.compare(first, second)
    };
}
const $6f2d229f1b40df68$export$6ad3191707c01020 = (0, $1k68G.iso)().wrap(undefined);
const $6f2d229f1b40df68$export$bf979031ac269aa6 = (_)=>$6f2d229f1b40df68$export$6ad3191707c01020;
const $6f2d229f1b40df68$export$bfa56c8ff106f1d = {
    ...(0, $g4z4j),
    empty: ()=>(0, $g4z4j).empty
};
const $6f2d229f1b40df68$var$partialDictMap = (0, $g4z4j).map;
const $6f2d229f1b40df68$var$partialDictMapWithIndex = (0, $g4z4j).mapWithIndex;
const $6f2d229f1b40df68$var$partialDictSequence = (0, $g4z4j).sequence;
const $6f2d229f1b40df68$var$partialDictTraverse = (0, $g4z4j).traverse;
const $6f2d229f1b40df68$var$partialDictTraverseWithIndex = (0, $g4z4j).traverseWithIndex;
const $6f2d229f1b40df68$export$38e1f3962181967d = {
    empty: ()=>({}),
    every: (0, $g4z4j).every,
    fromEntries: Object.fromEntries,
    map: (f)=>$6f2d229f1b40df68$var$partialDictMap((a)=>a !== undefined ? f(a) : undefined),
    mapWithIndex: (f)=>$6f2d229f1b40df68$var$partialDictMapWithIndex((k, a)=>a !== undefined ? f(k, a) : undefined),
    sequence: $6f2d229f1b40df68$var$partialDictSequence,
    traverse: (F)=>(f)=>$6f2d229f1b40df68$var$partialDictTraverse(F)((a)=>a !== undefined ? f(a) : F.of(undefined)),
    traverseWithIndex: (F)=>(f)=>$6f2d229f1b40df68$var$partialDictTraverseWithIndex(F)((k, a)=>a !== undefined ? f(k, a) : F.of(undefined))
};
function $6f2d229f1b40df68$export$70151caf3ff99499() {
    return (0, $4CDo2).empty;
}
const $6f2d229f1b40df68$export$37cbe166bfc81b63 = {
    ...(0, $7cVq5),
    exists: (0, $7cVq5).exists
};
const $6f2d229f1b40df68$var$maybeDecoder = (decoder)=>({
        decode: (u)=>u === null || u === undefined ? $4BSZX.success((0, $hVAkz).none) : (0, $f5id0.pipe)(decoder.decode(u), (0, $7cVq5).map((0, $hVAkz).some))
    });
const $6f2d229f1b40df68$var$maybeEncoder = (encoder)=>({
        encode: (0, $f5id0.flow)((0, $hVAkz).map(encoder.encode), (0, $hVAkz).toNullable)
    });
const $6f2d229f1b40df68$export$ad3bd6e4e1ec5d06 = {
    ...(0, $hVAkz),
    every: (predicate)=>(0, $hVAkz).fold(()=>true, predicate),
    decoder: $6f2d229f1b40df68$var$maybeDecoder,
    encoder: $6f2d229f1b40df68$var$maybeEncoder,
    codec: (codec)=>$jPaL5.make($6f2d229f1b40df68$var$maybeDecoder(codec), $6f2d229f1b40df68$var$maybeEncoder(codec))
};
const $6f2d229f1b40df68$var$neaDecoder = (decoder)=>(0, $f5id0.pipe)($4BSZX.array(decoder), $4BSZX.refine($6f2d229f1b40df68$export$54c2e3dc7acea9f5.isNonEmpty, 'NonEmptyArray'));
const $6f2d229f1b40df68$var$neaEncoder = (encoder)=>({
        encode: $6f2d229f1b40df68$export$f2d78e4bd16a0737.map(encoder.encode)
    });
const { groupBy: {}, ...$6f2d229f1b40df68$var$neaMethods } = (0, $1ECi6);
const $6f2d229f1b40df68$export$f2d78e4bd16a0737 = {
    ...$6f2d229f1b40df68$var$neaMethods,
    asMutable: (0, $f5id0.identity),
    decoder: $6f2d229f1b40df68$var$neaDecoder,
    encoder: $6f2d229f1b40df68$var$neaEncoder,
    codec: (codec)=>$jPaL5.make($6f2d229f1b40df68$var$neaDecoder(codec), $6f2d229f1b40df68$var$neaEncoder(codec))
};
function $6f2d229f1b40df68$var$mkString(startOrSep, sep, end) {
    return (list)=>sep !== undefined && end !== undefined ? `${startOrSep}${list.join(sep)}${end}` : list.join(startOrSep);
}
const $6f2d229f1b40df68$var$listDecoder = $4BSZX.array;
const $6f2d229f1b40df68$var$listEncoder = (0, $f5id0.flow)($d9q5l.array, $d9q5l.readonly);
const $6f2d229f1b40df68$export$54c2e3dc7acea9f5 = {
    ...(0, $b406R),
    empty: ()=>(0, $b406R).empty,
    differenceW: (0, $b406R).difference,
    groupBy: (0, $1ECi6).groupBy,
    groupByStr: (0, $1ECi6).groupBy,
    asMutable: (0, $f5id0.identity),
    mkString: $6f2d229f1b40df68$var$mkString,
    decoder: $6f2d229f1b40df68$var$listDecoder,
    encoder: $6f2d229f1b40df68$var$listEncoder,
    codec: (codec)=>$jPaL5.make($6f2d229f1b40df68$var$listDecoder(codec), $6f2d229f1b40df68$var$listEncoder(codec))
};
const $6f2d229f1b40df68$export$1908877435b1d5e9 = {
    ...(0, $lc7q7),
    of: (0, $f5id0.tuple)
};
const { right: {}, left: {}, ...$6f2d229f1b40df68$var$tryMethods } = (0, $7cVq5);
const $6f2d229f1b40df68$export$fa957d01b0310fd7 = {
    ...$6f2d229f1b40df68$var$tryMethods,
    success: (0, $7cVq5).right,
    failure: (0, $7cVq5).left,
    fromNullable: (0, $7cVq5).fromNullable,
    tryCatch: (a)=>$6f2d229f1b40df68$export$37cbe166bfc81b63.tryCatch(a, $6f2d229f1b40df68$export$37cbe166bfc81b63.toError),
    getUnsafe: (t)=>(0, $f5id0.pipe)(t, $6f2d229f1b40df68$export$37cbe166bfc81b63.getOrElse((e)=>{
            // eslint-disable-next-line functional/no-throw-statements
            throw e;
        }))
};
const $6f2d229f1b40df68$var$futureNotUsed = (0, $1brp6).right($6f2d229f1b40df68$export$6ad3191707c01020);
const { right: {}, left: {}, ...$6f2d229f1b40df68$var$futureMethods } = (0, $1brp6);
const $6f2d229f1b40df68$export$c9d7bf589772a8ce = {
    ...$6f2d229f1b40df68$var$futureMethods,
    successful: (0, $1brp6).right,
    failed: (0, $1brp6).left,
    chainFirstIOEitherK: (f)=>(0, $1brp6).chainFirst((0, $f5id0.flow)(f, (0, $1brp6).fromIOEither)),
    orElseEitherK: (f)=>(0, $1brp6).orElse((0, $f5id0.flow)(f, $6f2d229f1b40df68$export$c9d7bf589772a8ce.fromEither)),
    orElseIOEitherK: (f)=>(0, $1brp6).orElse((0, $f5id0.flow)(f, $6f2d229f1b40df68$export$c9d7bf589772a8ce.fromIOEither)),
    fromIO: (0, $1brp6).fromIO,
    tryCatch: (f)=>(0, $1brp6).tryCatch(f, $6f2d229f1b40df68$export$37cbe166bfc81b63.toError),
    notUsed: $6f2d229f1b40df68$var$futureNotUsed,
    todo: (...args)=>(0, $1brp6).fromEither($6f2d229f1b40df68$export$fa957d01b0310fd7.tryCatch(()=>$6f2d229f1b40df68$export$402f4892886ef27f(args))),
    run: (onError)=>(f)=>(0, $f5id0.pipe)(f, (0, $6omhk).chain((0, $7cVq5).fold((0, $f5id0.flow)(onError, (0, $6omhk).fromIO), (0, $6omhk).of)))(),
    runUnsafe: (fa)=>(0, $f5id0.pipe)(fa, (0, $6omhk).map($6f2d229f1b40df68$export$fa957d01b0310fd7.getUnsafe))(),
    delay: (ms)=>(future)=>(0, $f5id0.pipe)(future, (0, $6omhk).delay((0, $1GV7y.MsDuration).unwrap(ms)))
};
const $6f2d229f1b40df68$var$ioNotUsed = (0, $b45Xq).right($6f2d229f1b40df68$export$6ad3191707c01020);
const $6f2d229f1b40df68$var$ioFromIO = (0, $b45Xq).fromIO;
const $6f2d229f1b40df68$var$ioRun = (onError)=>(ioA)=>(0, $f5id0.pipe)(ioA, (0, $4lr6f).chain((0, $7cVq5).fold(onError, (0, $4lr6f).of)))();
const { right: {}, left: {}, ...$6f2d229f1b40df68$var$ioMethods } = (0, $b45Xq);
const $6f2d229f1b40df68$export$8f8422ac5947a789 = {
    ...$6f2d229f1b40df68$var$ioMethods,
    successful: (0, $b45Xq).right,
    failed: (0, $b45Xq).left,
    tryCatch: (a)=>(0, $b45Xq).tryCatch(a, $6f2d229f1b40df68$export$37cbe166bfc81b63.toError),
    fromIO: $6f2d229f1b40df68$var$ioFromIO,
    notUsed: $6f2d229f1b40df68$var$ioNotUsed,
    runFuture: (onError)=>(f)=>()=>{
                // eslint-disable-next-line functional/no-expression-statements
                (0, $f5id0.pipe)(f, $6f2d229f1b40df68$export$c9d7bf589772a8ce.run(onError));
                return $6f2d229f1b40df68$export$6ad3191707c01020;
            },
    run: $6f2d229f1b40df68$var$ioRun,
    runUnsafe: (ioA)=>$6f2d229f1b40df68$export$fa957d01b0310fd7.getUnsafe(ioA()),
    setTimeout: (onError)=>(delay)=>(io_)=>$6f2d229f1b40df68$export$8f8422ac5947a789.tryCatch(()=>setTimeout(()=>(0, $f5id0.pipe)(io_, $6f2d229f1b40df68$var$ioRun(onError)), (0, $1GV7y.MsDuration).unwrap(delay)))
};
const $6f2d229f1b40df68$export$c017b8e600ceae89 = (0, $f5id0.identity);

});
parcelRegister("4lr6f", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $329e250677a5c6f7$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $329e250677a5c6f7$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "of", function () { return $329e250677a5c6f7$export$ba255e9e49e00608; });
$parcel$export(module.exports, "flatMap", function () { return $329e250677a5c6f7$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "flatten", function () { return $329e250677a5c6f7$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "URI", function () { return $329e250677a5c6f7$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Functor", function () { return $329e250677a5c6f7$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $329e250677a5c6f7$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $329e250677a5c6f7$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $329e250677a5c6f7$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $329e250677a5c6f7$export$59a71046037e6c20; });
$parcel$export(module.exports, "Apply", function () { return $329e250677a5c6f7$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "apFirst", function () { return $329e250677a5c6f7$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $329e250677a5c6f7$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "Applicative", function () { return $329e250677a5c6f7$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $329e250677a5c6f7$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $329e250677a5c6f7$export$fb641926d034ac7d; });
$parcel$export(module.exports, "tap", function () { return $329e250677a5c6f7$export$3f23594af5f37336; });
$parcel$export(module.exports, "fromIO", function () { return $329e250677a5c6f7$export$d529793c7ff048a8; });
$parcel$export(module.exports, "MonadIO", function () { return $329e250677a5c6f7$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "ChainRec", function () { return $329e250677a5c6f7$export$be58f7327716329d; });
$parcel$export(module.exports, "FromIO", function () { return $329e250677a5c6f7$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "Do", function () { return $329e250677a5c6f7$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $329e250677a5c6f7$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $329e250677a5c6f7$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $329e250677a5c6f7$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $329e250677a5c6f7$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "ApT", function () { return $329e250677a5c6f7$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $329e250677a5c6f7$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $329e250677a5c6f7$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $329e250677a5c6f7$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $329e250677a5c6f7$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $329e250677a5c6f7$export$d330b60315c14cd1; });
$parcel$export(module.exports, "chain", function () { return $329e250677a5c6f7$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $329e250677a5c6f7$export$e3821ef4970c339c; });
$parcel$export(module.exports, "io", function () { return $329e250677a5c6f7$export$841407ceb083bd74; });
$parcel$export(module.exports, "getSemigroup", function () { return $329e250677a5c6f7$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $329e250677a5c6f7$export$c2a7ef2cc9b32b31; });
/**
 * ```ts
 * interface IO<A> {
 *   (): A
 * }
 * ```
 *
 * `IO<A>` represents a non-deterministic synchronous computation that can cause side effects, yields a value of
 * type `A` and **never fails**.
 *
 * If you want to represent a synchronous computation that may fail, please see `IOEither`.
 * If you want to represent a synchronous computation that may yield nothing, please see `IOOption`.
 *
 * @since 2.0.0
 */ 
var $6jM4Q = parcelRequire("6jM4Q");

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");
var $329e250677a5c6f7$var$_map = function(ma, f) {
    return function() {
        return f(ma());
    };
};
var $329e250677a5c6f7$var$_ap = function(mab, ma) {
    return function() {
        return mab()(ma());
    };
};
var $329e250677a5c6f7$var$_chainRec = function(a, f) {
    return function() {
        var e = f(a)();
        while(e._tag === 'Left')e = f(e.left)();
        return e.right;
    };
};
var $329e250677a5c6f7$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $329e250677a5c6f7$var$_map(fa, f);
    };
};
var $329e250677a5c6f7$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $329e250677a5c6f7$var$_ap(fab, fa);
    };
};
var $329e250677a5c6f7$export$ba255e9e49e00608 = (0, $f5id0.constant);
var $329e250677a5c6f7$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return function() {
        return f(ma())();
    };
});
var $329e250677a5c6f7$export$bffa455ba8c619a6 = /*#__PURE__*/ $329e250677a5c6f7$export$5b8affa63fc6df16((0, $f5id0.identity));
var $329e250677a5c6f7$export$9156e739aa33e19f = 'IO';
var $329e250677a5c6f7$export$bd5b6bfc5fa2ee61 = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map
};
var $329e250677a5c6f7$export$6554612db691658e = (0, $f5id0.dual)(2, (0, $hrfTw.as)($329e250677a5c6f7$export$bd5b6bfc5fa2ee61));
var $329e250677a5c6f7$export$9284b360ca18a0fd = (0, $hrfTw.asUnit)($329e250677a5c6f7$export$bd5b6bfc5fa2ee61);
var $329e250677a5c6f7$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($329e250677a5c6f7$export$bd5b6bfc5fa2ee61);
var $329e250677a5c6f7$export$59a71046037e6c20 = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    of: $329e250677a5c6f7$export$ba255e9e49e00608
};
var $329e250677a5c6f7$export$efc21ddc6aeb363d = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    ap: $329e250677a5c6f7$var$_ap
};
var $329e250677a5c6f7$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($329e250677a5c6f7$export$efc21ddc6aeb363d);
var $329e250677a5c6f7$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($329e250677a5c6f7$export$efc21ddc6aeb363d);
var $329e250677a5c6f7$export$1279d2b7807629fd = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    ap: $329e250677a5c6f7$var$_ap,
    of: $329e250677a5c6f7$export$ba255e9e49e00608
};
var $329e250677a5c6f7$export$f18d5acc27d70423 = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    ap: $329e250677a5c6f7$var$_ap,
    chain: $329e250677a5c6f7$export$5b8affa63fc6df16
};
var $329e250677a5c6f7$export$fb641926d034ac7d = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    ap: $329e250677a5c6f7$var$_ap,
    of: $329e250677a5c6f7$export$ba255e9e49e00608,
    chain: $329e250677a5c6f7$export$5b8affa63fc6df16
};
var $329e250677a5c6f7$export$3f23594af5f37336 = /*#__PURE__*/ (0, $f5id0.dual)(2, $lcDVT.tap($329e250677a5c6f7$export$f18d5acc27d70423));
var $329e250677a5c6f7$export$d529793c7ff048a8 = (0, $f5id0.identity);
var $329e250677a5c6f7$export$dc43ee6ccf36ad90 = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    ap: $329e250677a5c6f7$var$_ap,
    of: $329e250677a5c6f7$export$ba255e9e49e00608,
    chain: $329e250677a5c6f7$export$5b8affa63fc6df16,
    fromIO: $329e250677a5c6f7$export$d529793c7ff048a8
};
var $329e250677a5c6f7$export$be58f7327716329d = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    ap: $329e250677a5c6f7$var$_ap,
    chain: $329e250677a5c6f7$export$5b8affa63fc6df16,
    chainRec: $329e250677a5c6f7$var$_chainRec
};
var $329e250677a5c6f7$export$978d37ea2fe360cf = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    fromIO: (0, $f5id0.identity)
};
var $329e250677a5c6f7$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $329e250677a5c6f7$export$ba255e9e49e00608($aByOK.emptyRecord);
var $329e250677a5c6f7$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($329e250677a5c6f7$export$bd5b6bfc5fa2ee61);
var $329e250677a5c6f7$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($329e250677a5c6f7$export$bd5b6bfc5fa2ee61);
var $329e250677a5c6f7$export$2385a24977818dd0 = /*#__PURE__*/ $lcDVT.bind($329e250677a5c6f7$export$f18d5acc27d70423);
var $329e250677a5c6f7$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($329e250677a5c6f7$export$efc21ddc6aeb363d);
var $329e250677a5c6f7$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $329e250677a5c6f7$export$ba255e9e49e00608($aByOK.emptyReadonlyArray);
var $329e250677a5c6f7$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        return function() {
            var out = [
                f(0, $aByOK.head(as))()
            ];
            for(var i = 1; i < as.length; i++)out.push(f(i, as[i])());
            return out;
        };
    };
};
var $329e250677a5c6f7$export$d4e79db5dc14cc1 = function(f) {
    var g = $329e250677a5c6f7$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $329e250677a5c6f7$export$c74b6e34b2b6efb0;
    };
};
var $329e250677a5c6f7$export$104a2841e9cbad06 = $329e250677a5c6f7$export$d4e79db5dc14cc1;
var $329e250677a5c6f7$export$64f39b2a2b79e1b1 = function(f) {
    return $329e250677a5c6f7$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $329e250677a5c6f7$export$d330b60315c14cd1 = /*#__PURE__*/ $329e250677a5c6f7$export$64f39b2a2b79e1b1((0, $f5id0.identity));
var $329e250677a5c6f7$export$e08e3b67e392101e = $329e250677a5c6f7$export$5b8affa63fc6df16;
var $329e250677a5c6f7$export$e3821ef4970c339c = $329e250677a5c6f7$export$3f23594af5f37336;
var $329e250677a5c6f7$export$841407ceb083bd74 = {
    URI: $329e250677a5c6f7$export$9156e739aa33e19f,
    map: $329e250677a5c6f7$var$_map,
    of: $329e250677a5c6f7$export$ba255e9e49e00608,
    ap: $329e250677a5c6f7$var$_ap,
    chain: $329e250677a5c6f7$export$5b8affa63fc6df16,
    fromIO: $329e250677a5c6f7$export$d529793c7ff048a8,
    chainRec: $329e250677a5c6f7$var$_chainRec
};
var $329e250677a5c6f7$export$e759a9a7f8d04692 = /*#__PURE__*/ (0, $6IQDS.getApplySemigroup)($329e250677a5c6f7$export$efc21ddc6aeb363d);
var $329e250677a5c6f7$export$c2a7ef2cc9b32b31 = /*#__PURE__*/ (0, $6jM4Q.getApplicativeMonoid)($329e250677a5c6f7$export$1279d2b7807629fd);

});

parcelRegister("b45Xq", function(module, exports) {

$parcel$export(module.exports, "left", function () { return $80e4b079733df0a3$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $80e4b079733df0a3$export$79ffe56a765070d2; });
$parcel$export(module.exports, "rightIO", function () { return $80e4b079733df0a3$export$c1cd2021ce1d7fcb; });
$parcel$export(module.exports, "leftIO", function () { return $80e4b079733df0a3$export$9d86f0a38eb969ef; });
$parcel$export(module.exports, "fromEither", function () { return $80e4b079733df0a3$export$80c878c9b1d77917; });
$parcel$export(module.exports, "fromIO", function () { return $80e4b079733df0a3$export$d529793c7ff048a8; });
$parcel$export(module.exports, "match", function () { return $80e4b079733df0a3$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchW", function () { return $80e4b079733df0a3$export$2d55ea551c238330; });
$parcel$export(module.exports, "matchE", function () { return $80e4b079733df0a3$export$398621f19e0a7e4; });
$parcel$export(module.exports, "fold", function () { return $80e4b079733df0a3$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "matchEW", function () { return $80e4b079733df0a3$export$85ac45300d10b517; });
$parcel$export(module.exports, "foldW", function () { return $80e4b079733df0a3$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "getOrElse", function () { return $80e4b079733df0a3$export$8832081647a02ee7; });
$parcel$export(module.exports, "getOrElseW", function () { return $80e4b079733df0a3$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "tryCatch", function () { return $80e4b079733df0a3$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $80e4b079733df0a3$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "toUnion", function () { return $80e4b079733df0a3$export$a0886ed3a572729f; });
$parcel$export(module.exports, "orElse", function () { return $80e4b079733df0a3$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "orElseW", function () { return $80e4b079733df0a3$export$efd845e0c87089a6; });
$parcel$export(module.exports, "tapError", function () { return $80e4b079733df0a3$export$f297679585c88732; });
$parcel$export(module.exports, "orElseFirstIOK", function () { return $80e4b079733df0a3$export$91e9d1839ed8da93; });
$parcel$export(module.exports, "fromIOK", function () { return $80e4b079733df0a3$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "orLeft", function () { return $80e4b079733df0a3$export$e84f0fd7f5bcfbf0; });
$parcel$export(module.exports, "swap", function () { return $80e4b079733df0a3$export$b0e76d9850c64156; });
$parcel$export(module.exports, "map", function () { return $80e4b079733df0a3$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $80e4b079733df0a3$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $80e4b079733df0a3$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "alt", function () { return $80e4b079733df0a3$export$228be17d80722ab; });
$parcel$export(module.exports, "mapBoth", function () { return $80e4b079733df0a3$export$2ab19f8a7e145f0a; });
$parcel$export(module.exports, "bimap", function () { return $80e4b079733df0a3$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapError", function () { return $80e4b079733df0a3$export$d0f6f6f8d08fe167; });
$parcel$export(module.exports, "mapLeft", function () { return $80e4b079733df0a3$export$472de43a55e4aa49; });
$parcel$export(module.exports, "apW", function () { return $80e4b079733df0a3$export$321be6e231de8eac; });
$parcel$export(module.exports, "of", function () { return $80e4b079733df0a3$export$ba255e9e49e00608; });
$parcel$export(module.exports, "flattenW", function () { return $80e4b079733df0a3$export$2409099f1fc434fb; });
$parcel$export(module.exports, "flatten", function () { return $80e4b079733df0a3$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "altW", function () { return $80e4b079733df0a3$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "throwError", function () { return $80e4b079733df0a3$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "URI", function () { return $80e4b079733df0a3$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getApplicativeIOValidation", function () { return $80e4b079733df0a3$export$9b687d4ef3c7df6f; });
$parcel$export(module.exports, "getAltIOValidation", function () { return $80e4b079733df0a3$export$9b5f70484e613d76; });
$parcel$export(module.exports, "getCompactable", function () { return $80e4b079733df0a3$export$cfae3069ac05ff4c; });
$parcel$export(module.exports, "getFilterable", function () { return $80e4b079733df0a3$export$a4e870b0a57ec14e; });
$parcel$export(module.exports, "Functor", function () { return $80e4b079733df0a3$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $80e4b079733df0a3$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $80e4b079733df0a3$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $80e4b079733df0a3$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $80e4b079733df0a3$export$59a71046037e6c20; });
$parcel$export(module.exports, "Bifunctor", function () { return $80e4b079733df0a3$export$fd0fe42029639505; });
$parcel$export(module.exports, "ApplyPar", function () { return $80e4b079733df0a3$export$e825dd8dbbdc0410; });
$parcel$export(module.exports, "apFirst", function () { return $80e4b079733df0a3$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apFirstW", function () { return $80e4b079733df0a3$export$ac044f4aa9961a4f; });
$parcel$export(module.exports, "apSecond", function () { return $80e4b079733df0a3$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apSecondW", function () { return $80e4b079733df0a3$export$8a00020751233172; });
$parcel$export(module.exports, "ApplicativePar", function () { return $80e4b079733df0a3$export$11b888901d89cc2; });
$parcel$export(module.exports, "ApplicativeSeq", function () { return $80e4b079733df0a3$export$9c23f2f51a58ba10; });
$parcel$export(module.exports, "Chain", function () { return $80e4b079733df0a3$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $80e4b079733df0a3$export$fb641926d034ac7d; });
$parcel$export(module.exports, "FromEither", function () { return $80e4b079733df0a3$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "FromIO", function () { return $80e4b079733df0a3$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "tap", function () { return $80e4b079733df0a3$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapEither", function () { return $80e4b079733df0a3$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "tapIO", function () { return $80e4b079733df0a3$export$5bf3b8929fda1158; });
$parcel$export(module.exports, "Alt", function () { return $80e4b079733df0a3$export$25ba4469a069167; });
$parcel$export(module.exports, "MonadIO", function () { return $80e4b079733df0a3$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "MonadThrow", function () { return $80e4b079733df0a3$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "chainFirstIOK", function () { return $80e4b079733df0a3$export$5148ef8785cce359; });
$parcel$export(module.exports, "fromOption", function () { return $80e4b079733df0a3$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromOptionK", function () { return $80e4b079733df0a3$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $80e4b079733df0a3$export$12d26179deb6a68a; });
$parcel$export(module.exports, "chainOptionKW", function () { return $80e4b079733df0a3$export$377cc334277e5c3c; });
$parcel$export(module.exports, "liftNullable", function () { return $80e4b079733df0a3$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $80e4b079733df0a3$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $80e4b079733df0a3$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $80e4b079733df0a3$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "flatMapEither", function () { return $80e4b079733df0a3$export$979f2bb6a976172d; });
$parcel$export(module.exports, "flatMapIO", function () { return $80e4b079733df0a3$export$8b635ef81222764c; });
$parcel$export(module.exports, "chainIOK", function () { return $80e4b079733df0a3$export$dbedca339774a859; });
$parcel$export(module.exports, "chainEitherK", function () { return $80e4b079733df0a3$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "chainEitherKW", function () { return $80e4b079733df0a3$export$148e58f5a13b0a29; });
$parcel$export(module.exports, "chainFirstEitherK", function () { return $80e4b079733df0a3$export$c5f2bdbf9b43f0c0; });
$parcel$export(module.exports, "chainFirstEitherKW", function () { return $80e4b079733df0a3$export$3b38f8f4685eb1a8; });
$parcel$export(module.exports, "fromPredicate", function () { return $80e4b079733df0a3$export$23f31c55d7162b91; });
$parcel$export(module.exports, "filterOrElse", function () { return $80e4b079733df0a3$export$30af8ca9498ddf5b; });
$parcel$export(module.exports, "filterOrElseW", function () { return $80e4b079733df0a3$export$84511cf4503ec9dd; });
$parcel$export(module.exports, "fromEitherK", function () { return $80e4b079733df0a3$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "bracket", function () { return $80e4b079733df0a3$export$df5598cc12b9c8c; });
$parcel$export(module.exports, "bracketW", function () { return $80e4b079733df0a3$export$15093e5f950a635; });
$parcel$export(module.exports, "Do", function () { return $80e4b079733df0a3$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $80e4b079733df0a3$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $80e4b079733df0a3$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $80e4b079733df0a3$export$2385a24977818dd0; });
$parcel$export(module.exports, "bindW", function () { return $80e4b079733df0a3$export$e0d5b1cbe98976d9; });
$parcel$export(module.exports, "apS", function () { return $80e4b079733df0a3$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "apSW", function () { return $80e4b079733df0a3$export$5c01f27714264b3d; });
$parcel$export(module.exports, "ApT", function () { return $80e4b079733df0a3$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $80e4b079733df0a3$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $80e4b079733df0a3$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndexSeq", function () { return $80e4b079733df0a3$export$ccd1b7252ef04791; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndexSeq", function () { return $80e4b079733df0a3$export$674043f9db4279c7; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $80e4b079733df0a3$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $80e4b079733df0a3$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $80e4b079733df0a3$export$d330b60315c14cd1; });
$parcel$export(module.exports, "traverseSeqArrayWithIndex", function () { return $80e4b079733df0a3$export$6702e2a63712b0a0; });
$parcel$export(module.exports, "traverseSeqArray", function () { return $80e4b079733df0a3$export$5932486b5125ca68; });
$parcel$export(module.exports, "sequenceSeqArray", function () { return $80e4b079733df0a3$export$5e316684572fbbb6; });
$parcel$export(module.exports, "Applicative", function () { return $80e4b079733df0a3$export$1279d2b7807629fd; });
$parcel$export(module.exports, "chain", function () { return $80e4b079733df0a3$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainW", function () { return $80e4b079733df0a3$export$8e5885f0163d737a; });
$parcel$export(module.exports, "chainFirst", function () { return $80e4b079733df0a3$export$e3821ef4970c339c; });
$parcel$export(module.exports, "chainFirstW", function () { return $80e4b079733df0a3$export$5de78197fc44b933; });
$parcel$export(module.exports, "orElseFirst", function () { return $80e4b079733df0a3$export$2705983cb222ac0a; });
$parcel$export(module.exports, "orElseFirstW", function () { return $80e4b079733df0a3$export$d43d943be7ad7d62; });
$parcel$export(module.exports, "ioEither", function () { return $80e4b079733df0a3$export$abaf0c7037008059; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $80e4b079733df0a3$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $80e4b079733df0a3$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getSemigroup", function () { return $80e4b079733df0a3$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getIOValidation", function () { return $80e4b079733df0a3$export$9781d05075e655d9; });

var $6jM4Q = parcelRequire("6jM4Q");

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $77QB6 = parcelRequire("77QB6");

var $7cVq5 = parcelRequire("7cVq5");

var $4ygyM = parcelRequire("4ygyM");

var $eUvQQ = parcelRequire("eUvQQ");

var $ctkBN = parcelRequire("ctkBN");

var $6MUOV = parcelRequire("6MUOV");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $4lr6f = parcelRequire("4lr6f");
var $80e4b079733df0a3$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $4ygyM.left($4lr6f.Pointed);
var $80e4b079733df0a3$export$79ffe56a765070d2 = /*#__PURE__*/ $4ygyM.right($4lr6f.Pointed);
var $80e4b079733df0a3$export$c1cd2021ce1d7fcb = /*#__PURE__*/ $4ygyM.rightF($4lr6f.Functor);
var $80e4b079733df0a3$export$9d86f0a38eb969ef = /*#__PURE__*/ $4ygyM.leftF($4lr6f.Functor);
var $80e4b079733df0a3$export$80c878c9b1d77917 = $4lr6f.of;
var $80e4b079733df0a3$export$d529793c7ff048a8 = $80e4b079733df0a3$export$c1cd2021ce1d7fcb;
var $80e4b079733df0a3$export$4659b591c19bdf3d = /*#__PURE__*/ $4ygyM.match($4lr6f.Functor);
var $80e4b079733df0a3$export$2d55ea551c238330 = $80e4b079733df0a3$export$4659b591c19bdf3d;
var $80e4b079733df0a3$export$398621f19e0a7e4 = /*#__PURE__*/ $4ygyM.matchE($4lr6f.Monad);
var $80e4b079733df0a3$export$93e2b83da34ff82a = $80e4b079733df0a3$export$398621f19e0a7e4;
var $80e4b079733df0a3$export$85ac45300d10b517 = $80e4b079733df0a3$export$398621f19e0a7e4;
var $80e4b079733df0a3$export$ccb09033cefa61e8 = $80e4b079733df0a3$export$85ac45300d10b517;
var $80e4b079733df0a3$export$8832081647a02ee7 = /*#__PURE__*/ $4ygyM.getOrElse($4lr6f.Monad);
var $80e4b079733df0a3$export$d8a997ff0e6436f3 = $80e4b079733df0a3$export$8832081647a02ee7;
var $80e4b079733df0a3$export$d234c058d1d4e435 = function(f, onThrow) {
    return function() {
        return $7cVq5.tryCatch(f, onThrow);
    };
};
var $80e4b079733df0a3$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $80e4b079733df0a3$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $80e4b079733df0a3$export$a0886ed3a572729f = /*#__PURE__*/ $4ygyM.toUnion($4lr6f.Functor);
var $80e4b079733df0a3$export$41d1a04d78e7b141 = /*#__PURE__*/ $4ygyM.orElse($4lr6f.Monad);
var $80e4b079733df0a3$export$efd845e0c87089a6 = $80e4b079733df0a3$export$41d1a04d78e7b141;
var $80e4b079733df0a3$export$f297679585c88732 = /*#__PURE__*/ (0, $f5id0.dual)(2, $4ygyM.tapError($4lr6f.Monad));
var $80e4b079733df0a3$export$91e9d1839ed8da93 = function(onLeft) {
    return $80e4b079733df0a3$export$f297679585c88732($80e4b079733df0a3$export$9d3fcca17a044a16(onLeft));
};
var $80e4b079733df0a3$export$e84f0fd7f5bcfbf0 = /*#__PURE__*/ $4ygyM.orLeft($4lr6f.Monad);
var $80e4b079733df0a3$export$b0e76d9850c64156 = /*#__PURE__*/ $4ygyM.swap($4lr6f.Functor);
/* istanbul ignore next */ var $80e4b079733df0a3$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $80e4b079733df0a3$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $80e4b079733df0a3$var$_ap = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $80e4b079733df0a3$export$2f6ca3d3b1f80bf5(fa));
};
var $80e4b079733df0a3$var$_apSeq = function(fab, fa) {
    return $80e4b079733df0a3$export$5b8affa63fc6df16(fab, function(f) {
        return (0, $f5id0.pipe)(fa, $80e4b079733df0a3$export$871de8747c9eaa88(f));
    });
};
/* istanbul ignore next */ var $80e4b079733df0a3$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $80e4b079733df0a3$export$228be17d80722ab(that));
};
var $80e4b079733df0a3$export$871de8747c9eaa88 = /*#__PURE__*/ $4ygyM.map($4lr6f.Functor);
var $80e4b079733df0a3$export$2ab19f8a7e145f0a = /*#__PURE__*/ (0, $f5id0.dual)(3, $4ygyM.mapBoth($4lr6f.Functor));
var $80e4b079733df0a3$export$eb54baf0b342cb1d = $80e4b079733df0a3$export$2ab19f8a7e145f0a;
var $80e4b079733df0a3$export$d0f6f6f8d08fe167 = /*#__PURE__*/ (0, $f5id0.dual)(2, $4ygyM.mapError($4lr6f.Functor));
var $80e4b079733df0a3$export$472de43a55e4aa49 = $80e4b079733df0a3$export$d0f6f6f8d08fe167;
var $80e4b079733df0a3$export$2f6ca3d3b1f80bf5 = /*#__PURE__*/ $4ygyM.ap($4lr6f.Apply);
var $80e4b079733df0a3$export$321be6e231de8eac = $80e4b079733df0a3$export$2f6ca3d3b1f80bf5;
var $80e4b079733df0a3$export$ba255e9e49e00608 = $80e4b079733df0a3$export$79ffe56a765070d2;
var $80e4b079733df0a3$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, $4ygyM.flatMap($4lr6f.Monad));
var $80e4b079733df0a3$export$2409099f1fc434fb = /*#__PURE__*/ $80e4b079733df0a3$export$5b8affa63fc6df16((0, $f5id0.identity));
var $80e4b079733df0a3$export$bffa455ba8c619a6 = $80e4b079733df0a3$export$2409099f1fc434fb;
var $80e4b079733df0a3$export$228be17d80722ab = /*#__PURE__*/ $4ygyM.alt($4lr6f.Monad);
var $80e4b079733df0a3$export$1517cca7889d6aaa = $80e4b079733df0a3$export$228be17d80722ab;
var $80e4b079733df0a3$export$8bf7aba4a9e09055 = $80e4b079733df0a3$export$eabcd2c8791e7bf4;
var $80e4b079733df0a3$export$9156e739aa33e19f = 'IOEither';
function $80e4b079733df0a3$export$9b687d4ef3c7df6f(S) {
    var ap = (0, $6IQDS.ap)($4lr6f.Apply, $7cVq5.getApplicativeValidation(S));
    return {
        URI: $80e4b079733df0a3$export$9156e739aa33e19f,
        _E: undefined,
        map: $80e4b079733df0a3$var$_map,
        ap: function(fab, fa) {
            return (0, $f5id0.pipe)(fab, ap(fa));
        },
        of: $80e4b079733df0a3$export$ba255e9e49e00608
    };
}
function $80e4b079733df0a3$export$9b5f70484e613d76(S) {
    var alt = $4ygyM.altValidation($4lr6f.Monad, S);
    return {
        URI: $80e4b079733df0a3$export$9156e739aa33e19f,
        _E: undefined,
        map: $80e4b079733df0a3$var$_map,
        alt: function(fa, that) {
            return (0, $f5id0.pipe)(fa, alt(that));
        }
    };
}
var $80e4b079733df0a3$export$cfae3069ac05ff4c = function(M) {
    var C = $7cVq5.getCompactable(M);
    return {
        URI: $80e4b079733df0a3$export$9156e739aa33e19f,
        _E: undefined,
        compact: (0, $77QB6.compact)($4lr6f.Functor, C),
        separate: (0, $77QB6.separate)($4lr6f.Functor, C, $7cVq5.Functor)
    };
};
function $80e4b079733df0a3$export$a4e870b0a57ec14e(M) {
    var F = $7cVq5.getFilterable(M);
    var C = $80e4b079733df0a3$export$cfae3069ac05ff4c(M);
    var filter = (0, $eUvQQ.filter)($4lr6f.Functor, F);
    var filterMap = (0, $eUvQQ.filterMap)($4lr6f.Functor, F);
    var partition = (0, $eUvQQ.partition)($4lr6f.Functor, F);
    var partitionMap = (0, $eUvQQ.partitionMap)($4lr6f.Functor, F);
    return {
        URI: $80e4b079733df0a3$export$9156e739aa33e19f,
        _E: undefined,
        map: $80e4b079733df0a3$var$_map,
        compact: C.compact,
        separate: C.separate,
        filter: function(fa, predicate) {
            return (0, $f5id0.pipe)(fa, filter(predicate));
        },
        filterMap: function(fa, f) {
            return (0, $f5id0.pipe)(fa, filterMap(f));
        },
        partition: function(fa, predicate) {
            return (0, $f5id0.pipe)(fa, partition(predicate));
        },
        partitionMap: function(fa, f) {
            return (0, $f5id0.pipe)(fa, partitionMap(f));
        }
    };
}
var $80e4b079733df0a3$export$bd5b6bfc5fa2ee61 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map
};
var $80e4b079733df0a3$export$6554612db691658e = (0, $f5id0.dual)(2, (0, $hrfTw.as)($80e4b079733df0a3$export$bd5b6bfc5fa2ee61));
var $80e4b079733df0a3$export$9284b360ca18a0fd = (0, $hrfTw.asUnit)($80e4b079733df0a3$export$bd5b6bfc5fa2ee61);
var $80e4b079733df0a3$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($80e4b079733df0a3$export$bd5b6bfc5fa2ee61);
var $80e4b079733df0a3$export$59a71046037e6c20 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    of: $80e4b079733df0a3$export$ba255e9e49e00608
};
var $80e4b079733df0a3$export$fd0fe42029639505 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    bimap: $80e4b079733df0a3$export$2ab19f8a7e145f0a,
    mapLeft: $80e4b079733df0a3$export$d0f6f6f8d08fe167
};
var $80e4b079733df0a3$export$e825dd8dbbdc0410 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_ap
};
var $80e4b079733df0a3$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($80e4b079733df0a3$export$e825dd8dbbdc0410);
var $80e4b079733df0a3$export$ac044f4aa9961a4f = $80e4b079733df0a3$export$5f28d9feedcfd46e;
var $80e4b079733df0a3$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($80e4b079733df0a3$export$e825dd8dbbdc0410);
var $80e4b079733df0a3$export$8a00020751233172 = $80e4b079733df0a3$export$ed01bc59c3d06bf3;
var $80e4b079733df0a3$export$11b888901d89cc2 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_ap,
    of: $80e4b079733df0a3$export$ba255e9e49e00608
};
var $80e4b079733df0a3$export$9c23f2f51a58ba10 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_apSeq,
    of: $80e4b079733df0a3$export$ba255e9e49e00608
};
var $80e4b079733df0a3$export$f18d5acc27d70423 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_ap,
    chain: $80e4b079733df0a3$export$5b8affa63fc6df16
};
var $80e4b079733df0a3$export$fb641926d034ac7d = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_ap,
    of: $80e4b079733df0a3$export$ba255e9e49e00608,
    chain: $80e4b079733df0a3$export$5b8affa63fc6df16
};
var $80e4b079733df0a3$export$825ea6cb6fc48d49 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    fromEither: $80e4b079733df0a3$export$80c878c9b1d77917
};
var $80e4b079733df0a3$export$978d37ea2fe360cf = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    fromIO: $80e4b079733df0a3$export$d529793c7ff048a8
};
var $80e4b079733df0a3$export$3f23594af5f37336 = /*#__PURE__*/ (0, $f5id0.dual)(2, $lcDVT.tap($80e4b079733df0a3$export$f18d5acc27d70423));
var $80e4b079733df0a3$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $ctkBN.tapEither)($80e4b079733df0a3$export$825ea6cb6fc48d49, $80e4b079733df0a3$export$f18d5acc27d70423));
var $80e4b079733df0a3$export$5bf3b8929fda1158 = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $6MUOV.tapIO)($80e4b079733df0a3$export$978d37ea2fe360cf, $80e4b079733df0a3$export$f18d5acc27d70423));
var $80e4b079733df0a3$export$25ba4469a069167 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    alt: $80e4b079733df0a3$var$_alt
};
var $80e4b079733df0a3$export$dc43ee6ccf36ad90 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_ap,
    of: $80e4b079733df0a3$export$ba255e9e49e00608,
    chain: $80e4b079733df0a3$export$5b8affa63fc6df16,
    fromIO: $80e4b079733df0a3$export$d529793c7ff048a8
};
var $80e4b079733df0a3$export$5f956d47d0619c3a = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    map: $80e4b079733df0a3$var$_map,
    ap: $80e4b079733df0a3$var$_ap,
    of: $80e4b079733df0a3$export$ba255e9e49e00608,
    chain: $80e4b079733df0a3$export$5b8affa63fc6df16,
    throwError: $80e4b079733df0a3$export$8bf7aba4a9e09055
};
var $80e4b079733df0a3$export$9d3fcca17a044a16 = /*#__PURE__*/ (0, $6MUOV.fromIOK)($80e4b079733df0a3$export$978d37ea2fe360cf);
var $80e4b079733df0a3$export$5148ef8785cce359 = $80e4b079733df0a3$export$5bf3b8929fda1158;
var $80e4b079733df0a3$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $ctkBN.fromOption)($80e4b079733df0a3$export$825ea6cb6fc48d49);
var $80e4b079733df0a3$export$a907462f448b49f8 = /*#__PURE__*/ (0, $ctkBN.fromOptionK)($80e4b079733df0a3$export$825ea6cb6fc48d49);
var $80e4b079733df0a3$export$12d26179deb6a68a = /*#__PURE__*/ (0, $ctkBN.chainOptionK)($80e4b079733df0a3$export$825ea6cb6fc48d49, $80e4b079733df0a3$export$f18d5acc27d70423);
var $80e4b079733df0a3$export$377cc334277e5c3c = $80e4b079733df0a3$export$12d26179deb6a68a;
/** @internal */ var $80e4b079733df0a3$var$_FromEither = {
    fromEither: $80e4b079733df0a3$export$825ea6cb6fc48d49.fromEither
};
/** @internal */ var $80e4b079733df0a3$var$_FromIO = {
    fromIO: $80e4b079733df0a3$export$d529793c7ff048a8
};
var $80e4b079733df0a3$export$cd139e14432f317b = /*#__PURE__*/ $aByOK.liftNullable($80e4b079733df0a3$var$_FromEither);
var $80e4b079733df0a3$export$ea4a22f93200df79 = /*#__PURE__*/ $aByOK.liftOption($80e4b079733df0a3$var$_FromEither);
/** @internal */ var $80e4b079733df0a3$var$_FlatMap = {
    flatMap: $80e4b079733df0a3$export$5b8affa63fc6df16
};
var $80e4b079733df0a3$export$1a0515933c5c84fe = /*#__PURE__*/ $aByOK.flatMapNullable($80e4b079733df0a3$var$_FromEither, $80e4b079733df0a3$var$_FlatMap);
var $80e4b079733df0a3$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $aByOK.flatMapOption($80e4b079733df0a3$var$_FromEither, $80e4b079733df0a3$var$_FlatMap);
var $80e4b079733df0a3$export$979f2bb6a976172d = /*#__PURE__*/ $aByOK.flatMapEither($80e4b079733df0a3$var$_FromEither, $80e4b079733df0a3$var$_FlatMap);
var $80e4b079733df0a3$export$8b635ef81222764c = /*#__PURE__*/ $aByOK.flatMapIO($80e4b079733df0a3$var$_FromIO, $80e4b079733df0a3$var$_FlatMap);
var $80e4b079733df0a3$export$dbedca339774a859 = $80e4b079733df0a3$export$8b635ef81222764c;
var $80e4b079733df0a3$export$a3eef2eba9908c3e = $80e4b079733df0a3$export$979f2bb6a976172d;
var $80e4b079733df0a3$export$148e58f5a13b0a29 = $80e4b079733df0a3$export$979f2bb6a976172d;
var $80e4b079733df0a3$export$c5f2bdbf9b43f0c0 = $80e4b079733df0a3$export$be3ff275bb5a8ac9;
var $80e4b079733df0a3$export$3b38f8f4685eb1a8 = $80e4b079733df0a3$export$be3ff275bb5a8ac9;
var $80e4b079733df0a3$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $ctkBN.fromPredicate)($80e4b079733df0a3$export$825ea6cb6fc48d49);
var $80e4b079733df0a3$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $ctkBN.filterOrElse)($80e4b079733df0a3$export$825ea6cb6fc48d49, $80e4b079733df0a3$export$f18d5acc27d70423);
var $80e4b079733df0a3$export$84511cf4503ec9dd = $80e4b079733df0a3$export$30af8ca9498ddf5b;
var $80e4b079733df0a3$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $ctkBN.fromEitherK)($80e4b079733df0a3$export$825ea6cb6fc48d49);
var $80e4b079733df0a3$export$df5598cc12b9c8c = function(acquire, use, release) {
    return $80e4b079733df0a3$export$15093e5f950a635(acquire, use, release);
};
var $80e4b079733df0a3$export$15093e5f950a635 = function(acquire, use, release) {
    return $80e4b079733df0a3$export$5b8affa63fc6df16(acquire, function(a) {
        return $4lr6f.flatMap(use(a), function(e) {
            return $80e4b079733df0a3$export$5b8affa63fc6df16(release(a, e), function() {
                return $4lr6f.of(e);
            });
        });
    });
};
var $80e4b079733df0a3$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $80e4b079733df0a3$export$ba255e9e49e00608($aByOK.emptyRecord);
var $80e4b079733df0a3$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($80e4b079733df0a3$export$bd5b6bfc5fa2ee61);
var $80e4b079733df0a3$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($80e4b079733df0a3$export$bd5b6bfc5fa2ee61);
var $80e4b079733df0a3$export$2385a24977818dd0 = /*#__PURE__*/ $lcDVT.bind($80e4b079733df0a3$export$f18d5acc27d70423);
var $80e4b079733df0a3$export$e0d5b1cbe98976d9 = $80e4b079733df0a3$export$2385a24977818dd0;
var $80e4b079733df0a3$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($80e4b079733df0a3$export$e825dd8dbbdc0410);
var $80e4b079733df0a3$export$5c01f27714264b3d = $80e4b079733df0a3$export$8cbfc0239f42bb49;
var $80e4b079733df0a3$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $80e4b079733df0a3$export$ba255e9e49e00608($aByOK.emptyReadonlyArray);
var $80e4b079733df0a3$export$817de7d5ba7e6fab = function(f) {
    return (0, $f5id0.flow)($4lr6f.traverseReadonlyNonEmptyArrayWithIndex(f), $4lr6f.map($7cVq5.traverseReadonlyNonEmptyArrayWithIndex((0, $f5id0.SK))));
};
var $80e4b079733df0a3$export$d4e79db5dc14cc1 = function(f) {
    var g = $80e4b079733df0a3$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $80e4b079733df0a3$export$c74b6e34b2b6efb0;
    };
};
var $80e4b079733df0a3$export$ccd1b7252ef04791 = function(f) {
    return function(as) {
        return function() {
            var e = f(0, $aByOK.head(as))();
            if ($aByOK.isLeft(e)) return e;
            var out = [
                e.right
            ];
            for(var i = 1; i < as.length; i++){
                var e_1 = f(i, as[i])();
                if ($aByOK.isLeft(e_1)) return e_1;
                out.push(e_1.right);
            }
            return $aByOK.right(out);
        };
    };
};
var $80e4b079733df0a3$export$674043f9db4279c7 = function(f) {
    var g = $80e4b079733df0a3$export$ccd1b7252ef04791(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $80e4b079733df0a3$export$c74b6e34b2b6efb0;
    };
};
var $80e4b079733df0a3$export$104a2841e9cbad06 = $80e4b079733df0a3$export$d4e79db5dc14cc1;
var $80e4b079733df0a3$export$64f39b2a2b79e1b1 = function(f) {
    return $80e4b079733df0a3$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $80e4b079733df0a3$export$d330b60315c14cd1 = /*#__PURE__*/ $80e4b079733df0a3$export$64f39b2a2b79e1b1((0, $f5id0.identity));
var $80e4b079733df0a3$export$6702e2a63712b0a0 = $80e4b079733df0a3$export$674043f9db4279c7;
var $80e4b079733df0a3$export$5932486b5125ca68 = function(f) {
    return $80e4b079733df0a3$export$674043f9db4279c7(function(_, a) {
        return f(a);
    });
};
var $80e4b079733df0a3$export$5e316684572fbbb6 = /*#__PURE__*/ $80e4b079733df0a3$export$5932486b5125ca68((0, $f5id0.identity));
var $80e4b079733df0a3$export$1279d2b7807629fd = $80e4b079733df0a3$export$11b888901d89cc2;
var $80e4b079733df0a3$export$e08e3b67e392101e = $80e4b079733df0a3$export$5b8affa63fc6df16;
var $80e4b079733df0a3$export$8e5885f0163d737a = $80e4b079733df0a3$export$5b8affa63fc6df16;
var $80e4b079733df0a3$export$e3821ef4970c339c = $80e4b079733df0a3$export$3f23594af5f37336;
var $80e4b079733df0a3$export$5de78197fc44b933 = $80e4b079733df0a3$export$3f23594af5f37336;
var $80e4b079733df0a3$export$2705983cb222ac0a = $80e4b079733df0a3$export$f297679585c88732;
var $80e4b079733df0a3$export$d43d943be7ad7d62 = $80e4b079733df0a3$export$f297679585c88732;
var $80e4b079733df0a3$export$abaf0c7037008059 = {
    URI: $80e4b079733df0a3$export$9156e739aa33e19f,
    bimap: $80e4b079733df0a3$export$2ab19f8a7e145f0a,
    mapLeft: $80e4b079733df0a3$export$d0f6f6f8d08fe167,
    map: $80e4b079733df0a3$var$_map,
    of: $80e4b079733df0a3$export$ba255e9e49e00608,
    ap: $80e4b079733df0a3$var$_ap,
    chain: $80e4b079733df0a3$export$5b8affa63fc6df16,
    alt: $80e4b079733df0a3$var$_alt,
    fromIO: $80e4b079733df0a3$export$d529793c7ff048a8,
    throwError: $80e4b079733df0a3$export$8bf7aba4a9e09055
};
var $80e4b079733df0a3$export$18979a515d2a828e = /*#__PURE__*/ (0, $6IQDS.getApplySemigroup)($80e4b079733df0a3$export$e825dd8dbbdc0410);
var $80e4b079733df0a3$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $6jM4Q.getApplicativeMonoid)($80e4b079733df0a3$export$11b888901d89cc2);
var $80e4b079733df0a3$export$e759a9a7f8d04692 = function(S) {
    return (0, $6IQDS.getApplySemigroup)($4lr6f.Apply)($7cVq5.getSemigroup(S));
};
function $80e4b079733df0a3$export$9781d05075e655d9(SE) {
    var applicativeIOValidation = $80e4b079733df0a3$export$9b687d4ef3c7df6f(SE);
    var altIOValidation = $80e4b079733df0a3$export$9b5f70484e613d76(SE);
    return {
        URI: $80e4b079733df0a3$export$9156e739aa33e19f,
        _E: undefined,
        map: $80e4b079733df0a3$var$_map,
        ap: applicativeIOValidation.ap,
        of: $80e4b079733df0a3$export$ba255e9e49e00608,
        chain: $80e4b079733df0a3$export$5b8affa63fc6df16,
        bimap: $80e4b079733df0a3$export$2ab19f8a7e145f0a,
        mapLeft: $80e4b079733df0a3$export$d0f6f6f8d08fe167,
        alt: altIOValidation.alt,
        fromIO: $80e4b079733df0a3$export$d529793c7ff048a8,
        throwError: $80e4b079733df0a3$export$8bf7aba4a9e09055
    };
}

});
parcelRegister("77QB6", function(module, exports) {

$parcel$export(module.exports, "compact", function () { return $5301fc9f0a359f94$export$8e16b83750b44988; });
$parcel$export(module.exports, "separate", function () { return $5301fc9f0a359f94$export$709f6946f4e97408; });

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $hVAkz = parcelRequire("hVAkz");

var $bFSl4 = parcelRequire("bFSl4");
function $5301fc9f0a359f94$export$8e16b83750b44988(F, G) {
    return function(fga) {
        return F.map(fga, G.compact);
    };
}
function $5301fc9f0a359f94$export$709f6946f4e97408(F, C, G) {
    var _compact = $5301fc9f0a359f94$export$8e16b83750b44988(F, C);
    var _map = (0, $hrfTw.map)(F, G);
    return function(fge) {
        return $bFSl4.separated(_compact((0, $f5id0.pipe)(fge, _map((0, $hVAkz.getLeft)))), _compact((0, $f5id0.pipe)(fge, _map((0, $hVAkz.getRight)))));
    };
}
function $5301fc9f0a359f94$export$11b9309ca56a3cda(F, G) {
    var map = (0, $hrfTw.getFunctorComposition)(F, G).map;
    return {
        map: map,
        compact: $5301fc9f0a359f94$export$8e16b83750b44988(F, G),
        separate: $5301fc9f0a359f94$export$709f6946f4e97408(F, G, G)
    };
}

});

parcelRegister("4ygyM", function(module, exports) {

$parcel$export(module.exports, "right", function () { return $35072edf4291d399$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $35072edf4291d399$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "rightF", function () { return $35072edf4291d399$export$6572c0c90699ea15; });
$parcel$export(module.exports, "leftF", function () { return $35072edf4291d399$export$65a0b8ec3e227a75; });
$parcel$export(module.exports, "fromNullable", function () { return $35072edf4291d399$export$b601f49376b4621a; });
$parcel$export(module.exports, "fromNullableK", function () { return $35072edf4291d399$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $35072edf4291d399$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "map", function () { return $35072edf4291d399$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $35072edf4291d399$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $35072edf4291d399$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "alt", function () { return $35072edf4291d399$export$228be17d80722ab; });
$parcel$export(module.exports, "mapBoth", function () { return $35072edf4291d399$export$2ab19f8a7e145f0a; });
$parcel$export(module.exports, "mapError", function () { return $35072edf4291d399$export$d0f6f6f8d08fe167; });
$parcel$export(module.exports, "altValidation", function () { return $35072edf4291d399$export$4560910d7b3e445f; });
$parcel$export(module.exports, "match", function () { return $35072edf4291d399$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchE", function () { return $35072edf4291d399$export$398621f19e0a7e4; });
$parcel$export(module.exports, "getOrElse", function () { return $35072edf4291d399$export$8832081647a02ee7; });
$parcel$export(module.exports, "orElse", function () { return $35072edf4291d399$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "tapError", function () { return $35072edf4291d399$export$f297679585c88732; });
$parcel$export(module.exports, "orLeft", function () { return $35072edf4291d399$export$e84f0fd7f5bcfbf0; });
$parcel$export(module.exports, "swap", function () { return $35072edf4291d399$export$b0e76d9850c64156; });
$parcel$export(module.exports, "toUnion", function () { return $35072edf4291d399$export$a0886ed3a572729f; });

var $6IQDS = parcelRequire("6IQDS");

var $7cVq5 = parcelRequire("7cVq5");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");
function $35072edf4291d399$export$79ffe56a765070d2(F) {
    return (0, $f5id0.flow)($7cVq5.right, F.of);
}
function $35072edf4291d399$export$eabcd2c8791e7bf4(F) {
    return (0, $f5id0.flow)($7cVq5.left, F.of);
}
function $35072edf4291d399$export$6572c0c90699ea15(F) {
    return function(fa) {
        return F.map(fa, $7cVq5.right);
    };
}
function $35072edf4291d399$export$65a0b8ec3e227a75(F) {
    return function(fe) {
        return F.map(fe, $7cVq5.left);
    };
}
function $35072edf4291d399$export$b601f49376b4621a(F) {
    return function(e) {
        return (0, $f5id0.flow)($7cVq5.fromNullable(e), F.of);
    };
}
function $35072edf4291d399$export$c69ca7b73fad45e1(F) {
    var fromNullableF = $35072edf4291d399$export$b601f49376b4621a(F);
    return function(e) {
        var fromNullableFE = fromNullableF(e);
        return function(f) {
            return (0, $f5id0.flow)(f, fromNullableFE);
        };
    };
}
function $35072edf4291d399$export$c81f992c08fd0bf3(M) {
    var chainM = $35072edf4291d399$export$e08e3b67e392101e(M);
    var fromNullableKM = $35072edf4291d399$export$c69ca7b73fad45e1(M);
    return function(e) {
        var fromNullableKMe = fromNullableKM(e);
        return function(f) {
            return chainM(fromNullableKMe(f));
        };
    };
}
function $35072edf4291d399$export$871de8747c9eaa88(F) {
    return (0, $hrfTw.map)(F, $7cVq5.Functor);
}
function $35072edf4291d399$export$2f6ca3d3b1f80bf5(F) {
    return (0, $6IQDS.ap)(F, $7cVq5.Apply);
}
function $35072edf4291d399$export$e08e3b67e392101e(M) {
    var flatMapM = $35072edf4291d399$export$5b8affa63fc6df16(M);
    return function(f) {
        return function(ma) {
            return flatMapM(ma, f);
        };
    };
}
function $35072edf4291d399$export$5b8affa63fc6df16(M) {
    return function(ma, f) {
        return M.chain(ma, function(e) {
            return $7cVq5.isLeft(e) ? M.of(e) : f(e.right);
        });
    };
}
function $35072edf4291d399$export$228be17d80722ab(M) {
    return function(second) {
        return function(first) {
            return M.chain(first, function(e) {
                return $7cVq5.isLeft(e) ? second() : M.of(e);
            });
        };
    };
}
function $35072edf4291d399$export$eb54baf0b342cb1d(F) {
    var mapBothF = $35072edf4291d399$export$2ab19f8a7e145f0a(F);
    return function(f, g) {
        return function(self) {
            return mapBothF(self, f, g);
        };
    };
}
function $35072edf4291d399$export$2ab19f8a7e145f0a(F) {
    return function(self, f, g) {
        return F.map(self, $7cVq5.bimap(f, g));
    };
}
function $35072edf4291d399$export$472de43a55e4aa49(F) {
    var mapErrorF = $35072edf4291d399$export$d0f6f6f8d08fe167(F);
    return function(f) {
        return function(self) {
            return mapErrorF(self, f);
        };
    };
}
function $35072edf4291d399$export$d0f6f6f8d08fe167(F) {
    return function(self, f) {
        return F.map(self, $7cVq5.mapLeft(f));
    };
}
function $35072edf4291d399$export$4560910d7b3e445f(M, S) {
    return function(second) {
        return function(first) {
            return M.chain(first, $7cVq5.match(function(e1) {
                return M.map(second(), $7cVq5.mapLeft(function(e2) {
                    return S.concat(e1, e2);
                }));
            }, $35072edf4291d399$export$79ffe56a765070d2(M)));
        };
    };
}
function $35072edf4291d399$export$4659b591c19bdf3d(F) {
    return function(onLeft, onRight) {
        return function(ma) {
            return F.map(ma, $7cVq5.match(onLeft, onRight));
        };
    };
}
function $35072edf4291d399$export$398621f19e0a7e4(M) {
    return function(onLeft, onRight) {
        return function(ma) {
            return M.chain(ma, $7cVq5.match(onLeft, onRight));
        };
    };
}
function $35072edf4291d399$export$8832081647a02ee7(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, $7cVq5.match(onLeft, M.of));
        };
    };
}
function $35072edf4291d399$export$41d1a04d78e7b141(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, function(e) {
                return $7cVq5.isLeft(e) ? onLeft(e.left) : M.of(e);
            });
        };
    };
}
function $35072edf4291d399$export$2705983cb222ac0a(M) {
    var tapErrorM = $35072edf4291d399$export$f297679585c88732(M);
    return function(onLeft) {
        return function(ma) {
            return tapErrorM(ma, onLeft);
        };
    };
}
function $35072edf4291d399$export$f297679585c88732(M) {
    var orElseM = $35072edf4291d399$export$41d1a04d78e7b141(M);
    return function(ma, onLeft) {
        return (0, $f5id0.pipe)(ma, orElseM(function(e) {
            return M.map(onLeft(e), function(eb) {
                return $7cVq5.isLeft(eb) ? eb : $7cVq5.left(e);
            });
        }));
    };
}
function $35072edf4291d399$export$e84f0fd7f5bcfbf0(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, $7cVq5.match(function(e) {
                return M.map(onLeft(e), $7cVq5.left);
            }, function(a) {
                return M.of($7cVq5.right(a));
            }));
        };
    };
}
function $35072edf4291d399$export$b0e76d9850c64156(F) {
    return function(ma) {
        return F.map(ma, $7cVq5.swap);
    };
}
function $35072edf4291d399$export$a0886ed3a572729f(F) {
    return function(fa) {
        return F.map(fa, $7cVq5.toUnion);
    };
}
function $35072edf4291d399$export$57fa338b953665e0(M) {
    var _ap = $35072edf4291d399$export$2f6ca3d3b1f80bf5(M);
    var _map = $35072edf4291d399$export$871de8747c9eaa88(M);
    var _chain = $35072edf4291d399$export$e08e3b67e392101e(M);
    var _alt = $35072edf4291d399$export$228be17d80722ab(M);
    var _bimap = $35072edf4291d399$export$eb54baf0b342cb1d(M);
    var _mapLeft = $35072edf4291d399$export$472de43a55e4aa49(M);
    var _fold = $35072edf4291d399$export$398621f19e0a7e4(M);
    var _getOrElse = $35072edf4291d399$export$8832081647a02ee7(M);
    var _orElse = $35072edf4291d399$export$41d1a04d78e7b141(M);
    return {
        map: function(fa, f) {
            return (0, $f5id0.pipe)(fa, _map(f));
        },
        ap: function(fab, fa) {
            return (0, $f5id0.pipe)(fab, _ap(fa));
        },
        of: $35072edf4291d399$export$79ffe56a765070d2(M),
        chain: function(ma, f) {
            return (0, $f5id0.pipe)(ma, _chain(f));
        },
        alt: function(fa, that) {
            return (0, $f5id0.pipe)(fa, _alt(that));
        },
        bimap: function(fea, f, g) {
            return (0, $f5id0.pipe)(fea, _bimap(f, g));
        },
        mapLeft: function(fea, f) {
            return (0, $f5id0.pipe)(fea, _mapLeft(f));
        },
        fold: function(fa, onLeft, onRight) {
            return (0, $f5id0.pipe)(fa, _fold(onLeft, onRight));
        },
        getOrElse: function(fa, onLeft) {
            return (0, $f5id0.pipe)(fa, _getOrElse(onLeft));
        },
        orElse: function(fa, f) {
            return (0, $f5id0.pipe)(fa, _orElse(f));
        },
        swap: $35072edf4291d399$export$b0e76d9850c64156(M),
        rightM: $35072edf4291d399$export$6572c0c90699ea15(M),
        leftM: $35072edf4291d399$export$65a0b8ec3e227a75(M),
        left: $35072edf4291d399$export$eabcd2c8791e7bf4(M)
    };
}

});

parcelRegister("eUvQQ", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $adaf00a6ac8e7a4a$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $adaf00a6ac8e7a4a$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "partition", function () { return $adaf00a6ac8e7a4a$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $adaf00a6ac8e7a4a$export$3117e3f9ececb6bc; });
/**
 * `Filterable` represents data structures which can be _partitioned_/_filtered_.
 *
 * Adapted from https://github.com/LiamGoodacre/purescript-filterable/blob/master/src/Data/Filterable.purs
 *
 * @since 2.0.0
 */ 
var $77QB6 = parcelRequire("77QB6");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $hVAkz = parcelRequire("hVAkz");

var $IYheM = parcelRequire("IYheM");

var $bFSl4 = parcelRequire("bFSl4");
function $adaf00a6ac8e7a4a$export$3dea766d36a8935f(F, G) {
    return function(predicate) {
        return function(fga) {
            return F.map(fga, function(ga) {
                return G.filter(ga, predicate);
            });
        };
    };
}
function $adaf00a6ac8e7a4a$export$a04c6c6965dd4709(F, G) {
    return function(f) {
        return function(fga) {
            return F.map(fga, function(ga) {
                return G.filterMap(ga, f);
            });
        };
    };
}
function $adaf00a6ac8e7a4a$export$b29f828819edca8d(F, G) {
    var _filter = $adaf00a6ac8e7a4a$export$3dea766d36a8935f(F, G);
    return function(predicate) {
        var left = _filter((0, $IYheM.not)(predicate));
        var right = _filter(predicate);
        return function(fgb) {
            return (0, $bFSl4.separated)(left(fgb), right(fgb));
        };
    };
}
function $adaf00a6ac8e7a4a$export$3117e3f9ececb6bc(F, G) {
    var _filterMap = $adaf00a6ac8e7a4a$export$a04c6c6965dd4709(F, G);
    return function(f) {
        return function(fga) {
            return (0, $bFSl4.separated)((0, $f5id0.pipe)(fga, _filterMap(function(a) {
                return (0, $hVAkz.getLeft)(f(a));
            })), (0, $f5id0.pipe)(fga, _filterMap(function(a) {
                return (0, $hVAkz.getRight)(f(a));
            })));
        };
    };
}
function $adaf00a6ac8e7a4a$export$b5e175598dd6497f(F, G) {
    var map = (0, $hrfTw.getFunctorComposition)(F, G).map;
    var _compact = (0, $77QB6.compact)(F, G);
    var _separate = (0, $77QB6.separate)(F, G, G);
    var _filter = $adaf00a6ac8e7a4a$export$3dea766d36a8935f(F, G);
    var _filterMap = $adaf00a6ac8e7a4a$export$a04c6c6965dd4709(F, G);
    var _partition = $adaf00a6ac8e7a4a$export$b29f828819edca8d(F, G);
    var _partitionMap = $adaf00a6ac8e7a4a$export$3117e3f9ececb6bc(F, G);
    return {
        map: map,
        compact: _compact,
        separate: _separate,
        filter: function(fga, f) {
            return (0, $f5id0.pipe)(fga, _filter(f));
        },
        filterMap: function(fga, f) {
            return (0, $f5id0.pipe)(fga, _filterMap(f));
        },
        partition: function(fga, p) {
            return (0, $f5id0.pipe)(fga, _partition(p));
        },
        partitionMap: function(fga, f) {
            return (0, $f5id0.pipe)(fga, _partitionMap(f));
        }
    };
}

});

parcelRegister("6MUOV", function(module, exports) {

$parcel$export(module.exports, "fromIOK", function () { return $4f134d2014702d65$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "tapIO", function () { return $4f134d2014702d65$export$5bf3b8929fda1158; });
/**
 * Lift a computation from the `IO` monad
 *
 * @since 2.10.0
 */ 
var $lcDVT = parcelRequire("lcDVT");

var $f5id0 = parcelRequire("f5id0");
function $4f134d2014702d65$export$9d3fcca17a044a16(F) {
    return function(f) {
        return (0, $f5id0.flow)(f, F.fromIO);
    };
}
function $4f134d2014702d65$export$dbedca339774a859(F, M) {
    return function(f) {
        var g = (0, $f5id0.flow)(f, F.fromIO);
        return function(first) {
            return M.chain(first, g);
        };
    };
}
function $4f134d2014702d65$export$5148ef8785cce359(F, M) {
    var tapIOM = $4f134d2014702d65$export$5bf3b8929fda1158(F, M);
    return function(f) {
        return function(first) {
            return tapIOM(first, f);
        };
    };
}
function $4f134d2014702d65$export$5bf3b8929fda1158(F, M) {
    var chainFirstM = (0, $lcDVT.tap)(M);
    return function(self, f) {
        return chainFirstM(self, (0, $f5id0.flow)(f, F.fromIO));
    };
}

});


parcelRegister("lc7q7", function(module, exports) {

$parcel$export(module.exports, "fst", function () { return $f6e07974456aadd0$export$9e770fa6ce19a9d6; });
$parcel$export(module.exports, "snd", function () { return $f6e07974456aadd0$export$6f71268a1666ab58; });
$parcel$export(module.exports, "swap", function () { return $f6e07974456aadd0$export$b0e76d9850c64156; });
$parcel$export(module.exports, "getApply", function () { return $f6e07974456aadd0$export$81090df2aa47ff12; });
$parcel$export(module.exports, "URI", function () { return $f6e07974456aadd0$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getApplicative", function () { return $f6e07974456aadd0$export$1402880adb2295a7; });
$parcel$export(module.exports, "getChain", function () { return $f6e07974456aadd0$export$f4608058c83a1dc2; });
$parcel$export(module.exports, "getMonad", function () { return $f6e07974456aadd0$export$a024c9fefbcb9ced; });
$parcel$export(module.exports, "getChainRec", function () { return $f6e07974456aadd0$export$4bab931e633547e6; });
$parcel$export(module.exports, "compose", function () { return $f6e07974456aadd0$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "mapFst", function () { return $f6e07974456aadd0$export$b1cdc73ee064e0df; });
$parcel$export(module.exports, "bimap", function () { return $f6e07974456aadd0$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapSnd", function () { return $f6e07974456aadd0$export$96c3d3b04ed42b1c; });
$parcel$export(module.exports, "extend", function () { return $f6e07974456aadd0$export$8b58be045bf06082; });
$parcel$export(module.exports, "reduce", function () { return $f6e07974456aadd0$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $f6e07974456aadd0$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $f6e07974456aadd0$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $f6e07974456aadd0$export$df3f009e3d155b20; });
$parcel$export(module.exports, "extract", function () { return $f6e07974456aadd0$export$f9380c9a627682d3; });
$parcel$export(module.exports, "duplicate", function () { return $f6e07974456aadd0$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "sequence", function () { return $f6e07974456aadd0$export$49bb65c2ea163039; });
$parcel$export(module.exports, "Functor", function () { return $f6e07974456aadd0$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $f6e07974456aadd0$export$18c957606d8bdf09; });
$parcel$export(module.exports, "map", function () { return $f6e07974456aadd0$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapLeft", function () { return $f6e07974456aadd0$export$472de43a55e4aa49; });
$parcel$export(module.exports, "Bifunctor", function () { return $f6e07974456aadd0$export$fd0fe42029639505; });
$parcel$export(module.exports, "Semigroupoid", function () { return $f6e07974456aadd0$export$67666a3fb7d250d8; });
$parcel$export(module.exports, "Comonad", function () { return $f6e07974456aadd0$export$fdd73124b9f1de36; });
$parcel$export(module.exports, "Foldable", function () { return $f6e07974456aadd0$export$41404b31838667c9; });
$parcel$export(module.exports, "Traversable", function () { return $f6e07974456aadd0$export$a0202666c3bda011; });
$parcel$export(module.exports, "readonlyTuple", function () { return $f6e07974456aadd0$export$48e131e4e1ae6412; });

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");
function $f6e07974456aadd0$export$9e770fa6ce19a9d6(ea) {
    return ea[0];
}
function $f6e07974456aadd0$export$6f71268a1666ab58(ea) {
    return ea[1];
}
var $f6e07974456aadd0$export$b0e76d9850c64156 = function(ea) {
    return [
        $f6e07974456aadd0$export$6f71268a1666ab58(ea),
        $f6e07974456aadd0$export$9e770fa6ce19a9d6(ea)
    ];
};
function $f6e07974456aadd0$export$81090df2aa47ff12(S) {
    return {
        URI: $f6e07974456aadd0$export$9156e739aa33e19f,
        _E: undefined,
        map: $f6e07974456aadd0$var$_map,
        ap: function(fab, fa) {
            return [
                $f6e07974456aadd0$export$9e770fa6ce19a9d6(fab)($f6e07974456aadd0$export$9e770fa6ce19a9d6(fa)),
                S.concat($f6e07974456aadd0$export$6f71268a1666ab58(fab), $f6e07974456aadd0$export$6f71268a1666ab58(fa))
            ];
        }
    };
}
var $f6e07974456aadd0$var$of = function(M) {
    return function(a) {
        return [
            a,
            M.empty
        ];
    };
};
function $f6e07974456aadd0$export$1402880adb2295a7(M) {
    var A = $f6e07974456aadd0$export$81090df2aa47ff12(M);
    return {
        URI: $f6e07974456aadd0$export$9156e739aa33e19f,
        _E: undefined,
        map: $f6e07974456aadd0$var$_map,
        ap: A.ap,
        of: $f6e07974456aadd0$var$of(M)
    };
}
function $f6e07974456aadd0$export$f4608058c83a1dc2(S) {
    var A = $f6e07974456aadd0$export$81090df2aa47ff12(S);
    return {
        URI: $f6e07974456aadd0$export$9156e739aa33e19f,
        _E: undefined,
        map: $f6e07974456aadd0$var$_map,
        ap: A.ap,
        chain: function(ma, f) {
            var _a = f($f6e07974456aadd0$export$9e770fa6ce19a9d6(ma)), b = _a[0], s = _a[1];
            return [
                b,
                S.concat($f6e07974456aadd0$export$6f71268a1666ab58(ma), s)
            ];
        }
    };
}
function $f6e07974456aadd0$export$a024c9fefbcb9ced(M) {
    var C = $f6e07974456aadd0$export$f4608058c83a1dc2(M);
    return {
        URI: $f6e07974456aadd0$export$9156e739aa33e19f,
        _E: undefined,
        map: $f6e07974456aadd0$var$_map,
        ap: C.ap,
        chain: C.chain,
        of: $f6e07974456aadd0$var$of(M)
    };
}
function $f6e07974456aadd0$export$4bab931e633547e6(M) {
    var chainRec = function(a, f) {
        var result = f(a);
        var acc = M.empty;
        var s = $f6e07974456aadd0$export$9e770fa6ce19a9d6(result);
        while(s._tag === 'Left'){
            acc = M.concat(acc, $f6e07974456aadd0$export$6f71268a1666ab58(result));
            result = f(s.left);
            s = $f6e07974456aadd0$export$9e770fa6ce19a9d6(result);
        }
        return [
            s.right,
            M.concat(acc, $f6e07974456aadd0$export$6f71268a1666ab58(result))
        ];
    };
    var C = $f6e07974456aadd0$export$f4608058c83a1dc2(M);
    return {
        URI: $f6e07974456aadd0$export$9156e739aa33e19f,
        _E: undefined,
        map: $f6e07974456aadd0$var$_map,
        ap: C.ap,
        chain: C.chain,
        chainRec: chainRec
    };
}
/* istanbul ignore next */ var $f6e07974456aadd0$var$_compose = function(bc, ab) {
    return (0, $f5id0.pipe)(bc, $f6e07974456aadd0$export$f672e0b6f7222cd7(ab));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $f6e07974456aadd0$export$b1cdc73ee064e0df(f));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_bimap = function(fa, f, g) {
    return (0, $f5id0.pipe)(fa, $f6e07974456aadd0$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_mapLeft = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $f6e07974456aadd0$export$96c3d3b04ed42b1c(f));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_extend = function(wa, f) {
    return (0, $f5id0.pipe)(wa, $f6e07974456aadd0$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_reduce = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $f6e07974456aadd0$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_foldMap = function(M) {
    var foldMapM = $f6e07974456aadd0$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $f5id0.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_reduceRight = function(fa, b, f) {
    return (0, $f5id0.pipe)(fa, $f6e07974456aadd0$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $f6e07974456aadd0$var$_traverse = function(F) {
    var traverseF = $f6e07974456aadd0$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $f5id0.pipe)(ta, traverseF(f));
    };
};
var $f6e07974456aadd0$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return [
            g($f6e07974456aadd0$export$9e770fa6ce19a9d6(fa)),
            f($f6e07974456aadd0$export$6f71268a1666ab58(fa))
        ];
    };
};
var $f6e07974456aadd0$export$b1cdc73ee064e0df = function(f) {
    return function(fa) {
        return [
            f($f6e07974456aadd0$export$9e770fa6ce19a9d6(fa)),
            $f6e07974456aadd0$export$6f71268a1666ab58(fa)
        ];
    };
};
var $f6e07974456aadd0$export$96c3d3b04ed42b1c = function(f) {
    return function(fa) {
        return [
            $f6e07974456aadd0$export$9e770fa6ce19a9d6(fa),
            f($f6e07974456aadd0$export$6f71268a1666ab58(fa))
        ];
    };
};
var $f6e07974456aadd0$export$f672e0b6f7222cd7 = function(ab) {
    return function(bc) {
        return [
            $f6e07974456aadd0$export$9e770fa6ce19a9d6(bc),
            $f6e07974456aadd0$export$6f71268a1666ab58(ab)
        ];
    };
};
var $f6e07974456aadd0$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return [
            f(wa),
            $f6e07974456aadd0$export$6f71268a1666ab58(wa)
        ];
    };
};
var $f6e07974456aadd0$export$f9380c9a627682d3 = $f6e07974456aadd0$export$9e770fa6ce19a9d6;
var $f6e07974456aadd0$export$ecd5e8ace626722c = /*#__PURE__*/ $f6e07974456aadd0$export$8b58be045bf06082((0, $f5id0.identity));
var $f6e07974456aadd0$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return f(b, $f6e07974456aadd0$export$9e770fa6ce19a9d6(fa));
    };
};
var $f6e07974456aadd0$export$b66cdc0497d8a99a = function() {
    return function(f) {
        return function(fa) {
            return f($f6e07974456aadd0$export$9e770fa6ce19a9d6(fa));
        };
    };
};
var $f6e07974456aadd0$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return f($f6e07974456aadd0$export$9e770fa6ce19a9d6(fa), b);
    };
};
var $f6e07974456aadd0$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return F.map(f($f6e07974456aadd0$export$9e770fa6ce19a9d6(ta)), function(b) {
                return [
                    b,
                    $f6e07974456aadd0$export$6f71268a1666ab58(ta)
                ];
            });
        };
    };
};
var $f6e07974456aadd0$export$49bb65c2ea163039 = function(F) {
    return function(fas) {
        return F.map($f6e07974456aadd0$export$9e770fa6ce19a9d6(fas), function(a) {
            return [
                a,
                $f6e07974456aadd0$export$6f71268a1666ab58(fas)
            ];
        });
    };
};
var $f6e07974456aadd0$export$9156e739aa33e19f = 'ReadonlyTuple';
var $f6e07974456aadd0$export$bd5b6bfc5fa2ee61 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    map: $f6e07974456aadd0$var$_map
};
var $f6e07974456aadd0$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($f6e07974456aadd0$export$bd5b6bfc5fa2ee61);
var $f6e07974456aadd0$export$871de8747c9eaa88 = $f6e07974456aadd0$export$b1cdc73ee064e0df;
var $f6e07974456aadd0$export$472de43a55e4aa49 = $f6e07974456aadd0$export$96c3d3b04ed42b1c;
var $f6e07974456aadd0$export$fd0fe42029639505 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    bimap: $f6e07974456aadd0$var$_bimap,
    mapLeft: $f6e07974456aadd0$var$_mapLeft
};
var $f6e07974456aadd0$export$67666a3fb7d250d8 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    compose: $f6e07974456aadd0$var$_compose
};
var $f6e07974456aadd0$export$fdd73124b9f1de36 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    map: $f6e07974456aadd0$var$_map,
    extend: $f6e07974456aadd0$var$_extend,
    extract: $f6e07974456aadd0$export$f9380c9a627682d3
};
var $f6e07974456aadd0$export$41404b31838667c9 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    reduce: $f6e07974456aadd0$var$_reduce,
    foldMap: $f6e07974456aadd0$var$_foldMap,
    reduceRight: $f6e07974456aadd0$var$_reduceRight
};
var $f6e07974456aadd0$export$a0202666c3bda011 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    map: $f6e07974456aadd0$var$_map,
    reduce: $f6e07974456aadd0$var$_reduce,
    foldMap: $f6e07974456aadd0$var$_foldMap,
    reduceRight: $f6e07974456aadd0$var$_reduceRight,
    traverse: $f6e07974456aadd0$var$_traverse,
    sequence: $f6e07974456aadd0$export$49bb65c2ea163039
};
var $f6e07974456aadd0$export$48e131e4e1ae6412 = {
    URI: $f6e07974456aadd0$export$9156e739aa33e19f,
    compose: $f6e07974456aadd0$var$_compose,
    map: $f6e07974456aadd0$var$_map,
    bimap: $f6e07974456aadd0$var$_bimap,
    mapLeft: $f6e07974456aadd0$var$_mapLeft,
    extract: $f6e07974456aadd0$export$f9380c9a627682d3,
    extend: $f6e07974456aadd0$var$_extend,
    reduce: $f6e07974456aadd0$var$_reduce,
    foldMap: $f6e07974456aadd0$var$_foldMap,
    reduceRight: $f6e07974456aadd0$var$_reduceRight,
    traverse: $f6e07974456aadd0$var$_traverse,
    sequence: $f6e07974456aadd0$export$49bb65c2ea163039
};

});

parcelRegister("6omhk", function(module, exports) {

$parcel$export(module.exports, "fromIO", function () { return $4a76440276b3a9f9$export$d529793c7ff048a8; });
$parcel$export(module.exports, "delay", function () { return $4a76440276b3a9f9$export$1391212d75b2ee65; });
$parcel$export(module.exports, "map", function () { return $4a76440276b3a9f9$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $4a76440276b3a9f9$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $4a76440276b3a9f9$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "of", function () { return $4a76440276b3a9f9$export$ba255e9e49e00608; });
$parcel$export(module.exports, "flatten", function () { return $4a76440276b3a9f9$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "URI", function () { return $4a76440276b3a9f9$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getRaceMonoid", function () { return $4a76440276b3a9f9$export$2376659cd8d5a91f; });
$parcel$export(module.exports, "never", function () { return $4a76440276b3a9f9$export$b3e22bcfd64c1022; });
$parcel$export(module.exports, "Functor", function () { return $4a76440276b3a9f9$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $4a76440276b3a9f9$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $4a76440276b3a9f9$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $4a76440276b3a9f9$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $4a76440276b3a9f9$export$59a71046037e6c20; });
$parcel$export(module.exports, "ApplyPar", function () { return $4a76440276b3a9f9$export$e825dd8dbbdc0410; });
$parcel$export(module.exports, "apFirst", function () { return $4a76440276b3a9f9$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $4a76440276b3a9f9$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "ApplicativePar", function () { return $4a76440276b3a9f9$export$11b888901d89cc2; });
$parcel$export(module.exports, "ApplySeq", function () { return $4a76440276b3a9f9$export$60f1052cde3ba705; });
$parcel$export(module.exports, "ApplicativeSeq", function () { return $4a76440276b3a9f9$export$9c23f2f51a58ba10; });
$parcel$export(module.exports, "Chain", function () { return $4a76440276b3a9f9$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $4a76440276b3a9f9$export$fb641926d034ac7d; });
$parcel$export(module.exports, "MonadIO", function () { return $4a76440276b3a9f9$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "fromTask", function () { return $4a76440276b3a9f9$export$b13b747e271beee9; });
$parcel$export(module.exports, "MonadTask", function () { return $4a76440276b3a9f9$export$ddc01897af104624; });
$parcel$export(module.exports, "FromIO", function () { return $4a76440276b3a9f9$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "flatMapIO", function () { return $4a76440276b3a9f9$export$8b635ef81222764c; });
$parcel$export(module.exports, "tap", function () { return $4a76440276b3a9f9$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapIO", function () { return $4a76440276b3a9f9$export$5bf3b8929fda1158; });
$parcel$export(module.exports, "fromIOK", function () { return $4a76440276b3a9f9$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "chainIOK", function () { return $4a76440276b3a9f9$export$dbedca339774a859; });
$parcel$export(module.exports, "chainFirstIOK", function () { return $4a76440276b3a9f9$export$5148ef8785cce359; });
$parcel$export(module.exports, "FromTask", function () { return $4a76440276b3a9f9$export$e86019a4d2fb9384; });
$parcel$export(module.exports, "Do", function () { return $4a76440276b3a9f9$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $4a76440276b3a9f9$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $4a76440276b3a9f9$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $4a76440276b3a9f9$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $4a76440276b3a9f9$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "ApT", function () { return $4a76440276b3a9f9$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $4a76440276b3a9f9$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $4a76440276b3a9f9$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndexSeq", function () { return $4a76440276b3a9f9$export$ccd1b7252ef04791; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndexSeq", function () { return $4a76440276b3a9f9$export$674043f9db4279c7; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $4a76440276b3a9f9$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $4a76440276b3a9f9$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $4a76440276b3a9f9$export$d330b60315c14cd1; });
$parcel$export(module.exports, "traverseSeqArrayWithIndex", function () { return $4a76440276b3a9f9$export$6702e2a63712b0a0; });
$parcel$export(module.exports, "traverseSeqArray", function () { return $4a76440276b3a9f9$export$5932486b5125ca68; });
$parcel$export(module.exports, "sequenceSeqArray", function () { return $4a76440276b3a9f9$export$5e316684572fbbb6; });
$parcel$export(module.exports, "chain", function () { return $4a76440276b3a9f9$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $4a76440276b3a9f9$export$e3821ef4970c339c; });
$parcel$export(module.exports, "task", function () { return $4a76440276b3a9f9$export$94e939b87ca64fb4; });
$parcel$export(module.exports, "taskSeq", function () { return $4a76440276b3a9f9$export$c1b89e6e7c80c0d4; });
$parcel$export(module.exports, "getSemigroup", function () { return $4a76440276b3a9f9$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $4a76440276b3a9f9$export$c2a7ef2cc9b32b31; });
/**
 * ```ts
 * interface Task<A> {
 *   (): Promise<A>
 * }
 * ```
 *
 * `Task<A>` represents an asynchronous computation that yields a value of type `A` and **never fails**.
 * If you want to represent an asynchronous computation that may fail, please see `TaskEither`.
 *
 * @since 2.0.0
 */ 
var $6jM4Q = parcelRequire("6jM4Q");

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $6MUOV = parcelRequire("6MUOV");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");
var $4a76440276b3a9f9$export$d529793c7ff048a8 = function(ma) {
    return function() {
        return Promise.resolve().then(ma);
    };
};
function $4a76440276b3a9f9$export$1391212d75b2ee65(millis) {
    return function(ma) {
        return function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    Promise.resolve().then(ma).then(resolve);
                }, millis);
            });
        };
    };
}
var $4a76440276b3a9f9$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $4a76440276b3a9f9$export$871de8747c9eaa88(f));
};
var $4a76440276b3a9f9$var$_apPar = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $4a76440276b3a9f9$export$2f6ca3d3b1f80bf5(fa));
};
var $4a76440276b3a9f9$var$_apSeq = function(fab, fa) {
    return $4a76440276b3a9f9$export$5b8affa63fc6df16(fab, function(f) {
        return (0, $f5id0.pipe)(fa, $4a76440276b3a9f9$export$871de8747c9eaa88(f));
    });
};
var $4a76440276b3a9f9$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return function() {
            return Promise.resolve().then(fa).then(f);
        };
    };
};
var $4a76440276b3a9f9$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return function() {
            return Promise.all([
                Promise.resolve().then(fab),
                Promise.resolve().then(fa)
            ]).then(function(_a) {
                var f = _a[0], a = _a[1];
                return f(a);
            });
        };
    };
};
var $4a76440276b3a9f9$export$ba255e9e49e00608 = function(a) {
    return function() {
        return Promise.resolve(a);
    };
};
var $4a76440276b3a9f9$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(ma, f) {
    return function() {
        return Promise.resolve().then(ma).then(function(a) {
            return f(a)();
        });
    };
});
var $4a76440276b3a9f9$export$bffa455ba8c619a6 = /*#__PURE__*/ $4a76440276b3a9f9$export$5b8affa63fc6df16((0, $f5id0.identity));
var $4a76440276b3a9f9$export$9156e739aa33e19f = 'Task';
function $4a76440276b3a9f9$export$2376659cd8d5a91f() {
    return {
        concat: function(x, y) {
            return function() {
                return Promise.race([
                    Promise.resolve().then(x),
                    Promise.resolve().then(y)
                ]);
            };
        },
        empty: $4a76440276b3a9f9$export$b3e22bcfd64c1022
    };
}
var $4a76440276b3a9f9$export$bd5b6bfc5fa2ee61 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map
};
var $4a76440276b3a9f9$export$6554612db691658e = (0, $f5id0.dual)(2, (0, $hrfTw.as)($4a76440276b3a9f9$export$bd5b6bfc5fa2ee61));
var $4a76440276b3a9f9$export$9284b360ca18a0fd = (0, $hrfTw.asUnit)($4a76440276b3a9f9$export$bd5b6bfc5fa2ee61);
var $4a76440276b3a9f9$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($4a76440276b3a9f9$export$bd5b6bfc5fa2ee61);
var $4a76440276b3a9f9$export$59a71046037e6c20 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608
};
var $4a76440276b3a9f9$export$e825dd8dbbdc0410 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    ap: $4a76440276b3a9f9$var$_apPar
};
var $4a76440276b3a9f9$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($4a76440276b3a9f9$export$e825dd8dbbdc0410);
var $4a76440276b3a9f9$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($4a76440276b3a9f9$export$e825dd8dbbdc0410);
var $4a76440276b3a9f9$export$11b888901d89cc2 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    ap: $4a76440276b3a9f9$var$_apPar,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608
};
var $4a76440276b3a9f9$export$60f1052cde3ba705 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    ap: $4a76440276b3a9f9$var$_apSeq
};
var $4a76440276b3a9f9$export$9c23f2f51a58ba10 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    ap: $4a76440276b3a9f9$var$_apSeq,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608
};
var $4a76440276b3a9f9$export$f18d5acc27d70423 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    ap: $4a76440276b3a9f9$var$_apPar,
    chain: $4a76440276b3a9f9$export$5b8affa63fc6df16
};
var $4a76440276b3a9f9$export$fb641926d034ac7d = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608,
    ap: $4a76440276b3a9f9$var$_apPar,
    chain: $4a76440276b3a9f9$export$5b8affa63fc6df16
};
var $4a76440276b3a9f9$export$dc43ee6ccf36ad90 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608,
    ap: $4a76440276b3a9f9$var$_apPar,
    chain: $4a76440276b3a9f9$export$5b8affa63fc6df16,
    fromIO: $4a76440276b3a9f9$export$d529793c7ff048a8
};
var $4a76440276b3a9f9$export$b13b747e271beee9 = (0, $f5id0.identity);
var $4a76440276b3a9f9$export$ddc01897af104624 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608,
    ap: $4a76440276b3a9f9$var$_apPar,
    chain: $4a76440276b3a9f9$export$5b8affa63fc6df16,
    fromIO: $4a76440276b3a9f9$export$d529793c7ff048a8,
    fromTask: $4a76440276b3a9f9$export$b13b747e271beee9
};
var $4a76440276b3a9f9$export$978d37ea2fe360cf = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    fromIO: $4a76440276b3a9f9$export$d529793c7ff048a8
};
/** @internal */ var $4a76440276b3a9f9$var$_FlatMap = {
    flatMap: $4a76440276b3a9f9$export$5b8affa63fc6df16
};
/** @internal */ var $4a76440276b3a9f9$var$_FromIO = {
    fromIO: $4a76440276b3a9f9$export$978d37ea2fe360cf.fromIO
};
var $4a76440276b3a9f9$export$8b635ef81222764c = $aByOK.flatMapIO($4a76440276b3a9f9$var$_FromIO, $4a76440276b3a9f9$var$_FlatMap);
var $4a76440276b3a9f9$export$3f23594af5f37336 = /*#__PURE__*/ (0, $f5id0.dual)(2, $lcDVT.tap($4a76440276b3a9f9$export$f18d5acc27d70423));
var $4a76440276b3a9f9$export$5bf3b8929fda1158 = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $6MUOV.tapIO)($4a76440276b3a9f9$export$978d37ea2fe360cf, $4a76440276b3a9f9$export$f18d5acc27d70423));
var $4a76440276b3a9f9$export$9d3fcca17a044a16 = /*#__PURE__*/ (0, $6MUOV.fromIOK)($4a76440276b3a9f9$export$978d37ea2fe360cf);
var $4a76440276b3a9f9$export$dbedca339774a859 = $4a76440276b3a9f9$export$8b635ef81222764c;
var $4a76440276b3a9f9$export$5148ef8785cce359 = $4a76440276b3a9f9$export$5bf3b8929fda1158;
var $4a76440276b3a9f9$export$e86019a4d2fb9384 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    fromIO: $4a76440276b3a9f9$export$d529793c7ff048a8,
    fromTask: $4a76440276b3a9f9$export$b13b747e271beee9
};
var $4a76440276b3a9f9$export$b3e22bcfd64c1022 = function() {
    return new Promise(function(_) {
        return undefined;
    });
};
var $4a76440276b3a9f9$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $4a76440276b3a9f9$export$ba255e9e49e00608($aByOK.emptyRecord);
var $4a76440276b3a9f9$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($4a76440276b3a9f9$export$bd5b6bfc5fa2ee61);
var $4a76440276b3a9f9$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($4a76440276b3a9f9$export$bd5b6bfc5fa2ee61);
var $4a76440276b3a9f9$export$2385a24977818dd0 = /*#__PURE__*/ $lcDVT.bind($4a76440276b3a9f9$export$f18d5acc27d70423);
var $4a76440276b3a9f9$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($4a76440276b3a9f9$export$e825dd8dbbdc0410);
var $4a76440276b3a9f9$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $4a76440276b3a9f9$export$ba255e9e49e00608($aByOK.emptyReadonlyArray);
var $4a76440276b3a9f9$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        return function() {
            return Promise.all(as.map(function(a, i) {
                return Promise.resolve().then(function() {
                    return f(i, a)();
                });
            }));
        };
    };
};
var $4a76440276b3a9f9$export$d4e79db5dc14cc1 = function(f) {
    var g = $4a76440276b3a9f9$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $4a76440276b3a9f9$export$c74b6e34b2b6efb0;
    };
};
var $4a76440276b3a9f9$export$ccd1b7252ef04791 = function(f) {
    return function(as) {
        return function() {
            return $aByOK.tail(as).reduce(function(acc, a, i) {
                return acc.then(function(bs) {
                    return Promise.resolve().then(f(i + 1, a)).then(function(b) {
                        bs.push(b);
                        return bs;
                    });
                });
            }, Promise.resolve().then(f(0, $aByOK.head(as))).then($aByOK.singleton));
        };
    };
};
var $4a76440276b3a9f9$export$674043f9db4279c7 = function(f) {
    var g = $4a76440276b3a9f9$export$ccd1b7252ef04791(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $4a76440276b3a9f9$export$c74b6e34b2b6efb0;
    };
};
var $4a76440276b3a9f9$export$104a2841e9cbad06 = $4a76440276b3a9f9$export$d4e79db5dc14cc1;
var $4a76440276b3a9f9$export$64f39b2a2b79e1b1 = function(f) {
    return $4a76440276b3a9f9$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $4a76440276b3a9f9$export$d330b60315c14cd1 = /*#__PURE__*/ $4a76440276b3a9f9$export$64f39b2a2b79e1b1((0, $f5id0.identity));
var $4a76440276b3a9f9$export$6702e2a63712b0a0 = $4a76440276b3a9f9$export$674043f9db4279c7;
var $4a76440276b3a9f9$export$5932486b5125ca68 = function(f) {
    return $4a76440276b3a9f9$export$674043f9db4279c7(function(_, a) {
        return f(a);
    });
};
var $4a76440276b3a9f9$export$5e316684572fbbb6 = /*#__PURE__*/ $4a76440276b3a9f9$export$5932486b5125ca68((0, $f5id0.identity));
var $4a76440276b3a9f9$export$e08e3b67e392101e = $4a76440276b3a9f9$export$5b8affa63fc6df16;
var $4a76440276b3a9f9$export$e3821ef4970c339c = $4a76440276b3a9f9$export$3f23594af5f37336;
var $4a76440276b3a9f9$export$94e939b87ca64fb4 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608,
    ap: $4a76440276b3a9f9$var$_apPar,
    chain: $4a76440276b3a9f9$export$5b8affa63fc6df16,
    fromIO: $4a76440276b3a9f9$export$d529793c7ff048a8,
    fromTask: $4a76440276b3a9f9$export$b13b747e271beee9
};
var $4a76440276b3a9f9$export$c1b89e6e7c80c0d4 = {
    URI: $4a76440276b3a9f9$export$9156e739aa33e19f,
    map: $4a76440276b3a9f9$var$_map,
    of: $4a76440276b3a9f9$export$ba255e9e49e00608,
    ap: $4a76440276b3a9f9$var$_apSeq,
    chain: $4a76440276b3a9f9$export$5b8affa63fc6df16,
    fromIO: $4a76440276b3a9f9$export$d529793c7ff048a8,
    fromTask: $4a76440276b3a9f9$export$b13b747e271beee9
};
var $4a76440276b3a9f9$export$e759a9a7f8d04692 = /*#__PURE__*/ (0, $6IQDS.getApplySemigroup)($4a76440276b3a9f9$export$60f1052cde3ba705);
var $4a76440276b3a9f9$export$c2a7ef2cc9b32b31 = /*#__PURE__*/ (0, $6jM4Q.getApplicativeMonoid)($4a76440276b3a9f9$export$9c23f2f51a58ba10);

});

parcelRegister("1brp6", function(module, exports) {

$parcel$export(module.exports, "left", function () { return $0dcc135d638f28b9$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $0dcc135d638f28b9$export$79ffe56a765070d2; });
$parcel$export(module.exports, "rightTask", function () { return $0dcc135d638f28b9$export$f0188b620f44372a; });
$parcel$export(module.exports, "leftTask", function () { return $0dcc135d638f28b9$export$41a4940678f22127; });
$parcel$export(module.exports, "rightIO", function () { return $0dcc135d638f28b9$export$c1cd2021ce1d7fcb; });
$parcel$export(module.exports, "leftIO", function () { return $0dcc135d638f28b9$export$9d86f0a38eb969ef; });
$parcel$export(module.exports, "fromIO", function () { return $0dcc135d638f28b9$export$d529793c7ff048a8; });
$parcel$export(module.exports, "fromTask", function () { return $0dcc135d638f28b9$export$b13b747e271beee9; });
$parcel$export(module.exports, "fromEither", function () { return $0dcc135d638f28b9$export$80c878c9b1d77917; });
$parcel$export(module.exports, "fromIOEither", function () { return $0dcc135d638f28b9$export$9b09e19fe882abba; });
$parcel$export(module.exports, "fromTaskOption", function () { return $0dcc135d638f28b9$export$691693e0bdd7c0dc; });
$parcel$export(module.exports, "match", function () { return $0dcc135d638f28b9$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchW", function () { return $0dcc135d638f28b9$export$2d55ea551c238330; });
$parcel$export(module.exports, "matchE", function () { return $0dcc135d638f28b9$export$398621f19e0a7e4; });
$parcel$export(module.exports, "fold", function () { return $0dcc135d638f28b9$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "matchEW", function () { return $0dcc135d638f28b9$export$85ac45300d10b517; });
$parcel$export(module.exports, "foldW", function () { return $0dcc135d638f28b9$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "getOrElse", function () { return $0dcc135d638f28b9$export$8832081647a02ee7; });
$parcel$export(module.exports, "getOrElseW", function () { return $0dcc135d638f28b9$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "tryCatch", function () { return $0dcc135d638f28b9$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $0dcc135d638f28b9$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "toUnion", function () { return $0dcc135d638f28b9$export$a0886ed3a572729f; });
$parcel$export(module.exports, "fromNullable", function () { return $0dcc135d638f28b9$export$b601f49376b4621a; });
$parcel$export(module.exports, "fromNullableK", function () { return $0dcc135d638f28b9$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $0dcc135d638f28b9$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "orElse", function () { return $0dcc135d638f28b9$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "orElseW", function () { return $0dcc135d638f28b9$export$efd845e0c87089a6; });
$parcel$export(module.exports, "tapError", function () { return $0dcc135d638f28b9$export$f297679585c88732; });
$parcel$export(module.exports, "orElseFirstIOK", function () { return $0dcc135d638f28b9$export$91e9d1839ed8da93; });
$parcel$export(module.exports, "fromIOK", function () { return $0dcc135d638f28b9$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "orElseFirstTaskK", function () { return $0dcc135d638f28b9$export$85b9777d93691bbc; });
$parcel$export(module.exports, "fromTaskK", function () { return $0dcc135d638f28b9$export$bb6009cf24290313; });
$parcel$export(module.exports, "orLeft", function () { return $0dcc135d638f28b9$export$e84f0fd7f5bcfbf0; });
$parcel$export(module.exports, "swap", function () { return $0dcc135d638f28b9$export$b0e76d9850c64156; });
$parcel$export(module.exports, "fromTaskOptionK", function () { return $0dcc135d638f28b9$export$f956926575b25f94; });
$parcel$export(module.exports, "chainTaskOptionKW", function () { return $0dcc135d638f28b9$export$cc18a684c8cb422d; });
$parcel$export(module.exports, "flatMap", function () { return $0dcc135d638f28b9$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "chainTaskOptionK", function () { return $0dcc135d638f28b9$export$a344f5448340a4a7; });
$parcel$export(module.exports, "fromIOEitherK", function () { return $0dcc135d638f28b9$export$6f981aca7fb40299; });
$parcel$export(module.exports, "map", function () { return $0dcc135d638f28b9$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $0dcc135d638f28b9$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "alt", function () { return $0dcc135d638f28b9$export$228be17d80722ab; });
$parcel$export(module.exports, "mapBoth", function () { return $0dcc135d638f28b9$export$2ab19f8a7e145f0a; });
$parcel$export(module.exports, "bimap", function () { return $0dcc135d638f28b9$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapError", function () { return $0dcc135d638f28b9$export$d0f6f6f8d08fe167; });
$parcel$export(module.exports, "mapLeft", function () { return $0dcc135d638f28b9$export$472de43a55e4aa49; });
$parcel$export(module.exports, "apW", function () { return $0dcc135d638f28b9$export$321be6e231de8eac; });
$parcel$export(module.exports, "flattenW", function () { return $0dcc135d638f28b9$export$2409099f1fc434fb; });
$parcel$export(module.exports, "flatten", function () { return $0dcc135d638f28b9$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "altW", function () { return $0dcc135d638f28b9$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "of", function () { return $0dcc135d638f28b9$export$ba255e9e49e00608; });
$parcel$export(module.exports, "throwError", function () { return $0dcc135d638f28b9$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "URI", function () { return $0dcc135d638f28b9$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getApplicativeTaskValidation", function () { return $0dcc135d638f28b9$export$f55d048c8c810adb; });
$parcel$export(module.exports, "getAltTaskValidation", function () { return $0dcc135d638f28b9$export$93b1fc7a429347dc; });
$parcel$export(module.exports, "getCompactable", function () { return $0dcc135d638f28b9$export$cfae3069ac05ff4c; });
$parcel$export(module.exports, "getFilterable", function () { return $0dcc135d638f28b9$export$a4e870b0a57ec14e; });
$parcel$export(module.exports, "Functor", function () { return $0dcc135d638f28b9$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $0dcc135d638f28b9$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $0dcc135d638f28b9$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $0dcc135d638f28b9$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $0dcc135d638f28b9$export$59a71046037e6c20; });
$parcel$export(module.exports, "ApplyPar", function () { return $0dcc135d638f28b9$export$e825dd8dbbdc0410; });
$parcel$export(module.exports, "apFirst", function () { return $0dcc135d638f28b9$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apFirstW", function () { return $0dcc135d638f28b9$export$ac044f4aa9961a4f; });
$parcel$export(module.exports, "apSecond", function () { return $0dcc135d638f28b9$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apSecondW", function () { return $0dcc135d638f28b9$export$8a00020751233172; });
$parcel$export(module.exports, "ApplicativePar", function () { return $0dcc135d638f28b9$export$11b888901d89cc2; });
$parcel$export(module.exports, "ApplySeq", function () { return $0dcc135d638f28b9$export$60f1052cde3ba705; });
$parcel$export(module.exports, "ApplicativeSeq", function () { return $0dcc135d638f28b9$export$9c23f2f51a58ba10; });
$parcel$export(module.exports, "Chain", function () { return $0dcc135d638f28b9$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $0dcc135d638f28b9$export$fb641926d034ac7d; });
$parcel$export(module.exports, "MonadIO", function () { return $0dcc135d638f28b9$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "MonadTask", function () { return $0dcc135d638f28b9$export$ddc01897af104624; });
$parcel$export(module.exports, "MonadThrow", function () { return $0dcc135d638f28b9$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "FromEither", function () { return $0dcc135d638f28b9$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "FromIO", function () { return $0dcc135d638f28b9$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "FromTask", function () { return $0dcc135d638f28b9$export$e86019a4d2fb9384; });
$parcel$export(module.exports, "tap", function () { return $0dcc135d638f28b9$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapEither", function () { return $0dcc135d638f28b9$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "tapIO", function () { return $0dcc135d638f28b9$export$5bf3b8929fda1158; });
$parcel$export(module.exports, "tapTask", function () { return $0dcc135d638f28b9$export$a8701ebadf2e95ad; });
$parcel$export(module.exports, "Bifunctor", function () { return $0dcc135d638f28b9$export$fd0fe42029639505; });
$parcel$export(module.exports, "Alt", function () { return $0dcc135d638f28b9$export$25ba4469a069167; });
$parcel$export(module.exports, "fromOption", function () { return $0dcc135d638f28b9$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromOptionK", function () { return $0dcc135d638f28b9$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $0dcc135d638f28b9$export$12d26179deb6a68a; });
$parcel$export(module.exports, "chainOptionKW", function () { return $0dcc135d638f28b9$export$377cc334277e5c3c; });
$parcel$export(module.exports, "liftNullable", function () { return $0dcc135d638f28b9$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $0dcc135d638f28b9$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $0dcc135d638f28b9$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $0dcc135d638f28b9$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "flatMapEither", function () { return $0dcc135d638f28b9$export$979f2bb6a976172d; });
$parcel$export(module.exports, "flatMapIO", function () { return $0dcc135d638f28b9$export$8b635ef81222764c; });
$parcel$export(module.exports, "flatMapTask", function () { return $0dcc135d638f28b9$export$43849ff3f7ffa51c; });
$parcel$export(module.exports, "flatMapIOEither", function () { return $0dcc135d638f28b9$export$7514610652fa62c0; });
$parcel$export(module.exports, "flatMapTaskOption", function () { return $0dcc135d638f28b9$export$bd2474f1d21e88eb; });
$parcel$export(module.exports, "chainEitherK", function () { return $0dcc135d638f28b9$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "chainEitherKW", function () { return $0dcc135d638f28b9$export$148e58f5a13b0a29; });
$parcel$export(module.exports, "chainFirstEitherK", function () { return $0dcc135d638f28b9$export$c5f2bdbf9b43f0c0; });
$parcel$export(module.exports, "chainFirstEitherKW", function () { return $0dcc135d638f28b9$export$3b38f8f4685eb1a8; });
$parcel$export(module.exports, "fromPredicate", function () { return $0dcc135d638f28b9$export$23f31c55d7162b91; });
$parcel$export(module.exports, "filterOrElse", function () { return $0dcc135d638f28b9$export$30af8ca9498ddf5b; });
$parcel$export(module.exports, "filterOrElseW", function () { return $0dcc135d638f28b9$export$84511cf4503ec9dd; });
$parcel$export(module.exports, "fromEitherK", function () { return $0dcc135d638f28b9$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "chainIOK", function () { return $0dcc135d638f28b9$export$dbedca339774a859; });
$parcel$export(module.exports, "chainFirstIOK", function () { return $0dcc135d638f28b9$export$5148ef8785cce359; });
$parcel$export(module.exports, "chainTaskK", function () { return $0dcc135d638f28b9$export$9e593613eaf643aa; });
$parcel$export(module.exports, "chainFirstTaskK", function () { return $0dcc135d638f28b9$export$43e2f536f6b41427; });
$parcel$export(module.exports, "chainIOEitherKW", function () { return $0dcc135d638f28b9$export$fdc4db8624c799e8; });
$parcel$export(module.exports, "chainIOEitherK", function () { return $0dcc135d638f28b9$export$f596abf27dc7c7bd; });
$parcel$export(module.exports, "taskify", function () { return $0dcc135d638f28b9$export$9ff351a4cbab6799; });
$parcel$export(module.exports, "bracket", function () { return $0dcc135d638f28b9$export$df5598cc12b9c8c; });
$parcel$export(module.exports, "bracketW", function () { return $0dcc135d638f28b9$export$15093e5f950a635; });
$parcel$export(module.exports, "Do", function () { return $0dcc135d638f28b9$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $0dcc135d638f28b9$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $0dcc135d638f28b9$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $0dcc135d638f28b9$export$2385a24977818dd0; });
$parcel$export(module.exports, "bindW", function () { return $0dcc135d638f28b9$export$e0d5b1cbe98976d9; });
$parcel$export(module.exports, "apS", function () { return $0dcc135d638f28b9$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "apSW", function () { return $0dcc135d638f28b9$export$5c01f27714264b3d; });
$parcel$export(module.exports, "ApT", function () { return $0dcc135d638f28b9$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $0dcc135d638f28b9$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $0dcc135d638f28b9$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndexSeq", function () { return $0dcc135d638f28b9$export$ccd1b7252ef04791; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndexSeq", function () { return $0dcc135d638f28b9$export$674043f9db4279c7; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $0dcc135d638f28b9$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $0dcc135d638f28b9$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $0dcc135d638f28b9$export$d330b60315c14cd1; });
$parcel$export(module.exports, "traverseSeqArrayWithIndex", function () { return $0dcc135d638f28b9$export$6702e2a63712b0a0; });
$parcel$export(module.exports, "traverseSeqArray", function () { return $0dcc135d638f28b9$export$5932486b5125ca68; });
$parcel$export(module.exports, "sequenceSeqArray", function () { return $0dcc135d638f28b9$export$5e316684572fbbb6; });
$parcel$export(module.exports, "chain", function () { return $0dcc135d638f28b9$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainW", function () { return $0dcc135d638f28b9$export$8e5885f0163d737a; });
$parcel$export(module.exports, "chainFirst", function () { return $0dcc135d638f28b9$export$e3821ef4970c339c; });
$parcel$export(module.exports, "chainFirstW", function () { return $0dcc135d638f28b9$export$5de78197fc44b933; });
$parcel$export(module.exports, "orElseFirst", function () { return $0dcc135d638f28b9$export$2705983cb222ac0a; });
$parcel$export(module.exports, "orElseFirstW", function () { return $0dcc135d638f28b9$export$d43d943be7ad7d62; });
$parcel$export(module.exports, "taskEither", function () { return $0dcc135d638f28b9$export$bf17ca9b48f5ebc2; });
$parcel$export(module.exports, "taskEitherSeq", function () { return $0dcc135d638f28b9$export$e669e08ee441ca6e; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $0dcc135d638f28b9$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $0dcc135d638f28b9$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getSemigroup", function () { return $0dcc135d638f28b9$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getTaskValidation", function () { return $0dcc135d638f28b9$export$205c8c90abeec407; });

var $6jM4Q = parcelRequire("6jM4Q");

var $6IQDS = parcelRequire("6IQDS");

var $lcDVT = parcelRequire("lcDVT");

var $77QB6 = parcelRequire("77QB6");

var $7cVq5 = parcelRequire("7cVq5");

var $4ygyM = parcelRequire("4ygyM");

var $eUvQQ = parcelRequire("eUvQQ");

var $ctkBN = parcelRequire("ctkBN");

var $6MUOV = parcelRequire("6MUOV");

var $aoLLt = parcelRequire("aoLLt");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $6omhk = parcelRequire("6omhk");
var $0dcc135d638f28b9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0dcc135d638f28b9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0dcc135d638f28b9$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $4ygyM.left($6omhk.Pointed);
var $0dcc135d638f28b9$export$79ffe56a765070d2 = /*#__PURE__*/ $4ygyM.right($6omhk.Pointed);
var $0dcc135d638f28b9$export$f0188b620f44372a = /*#__PURE__*/ $4ygyM.rightF($6omhk.Functor);
var $0dcc135d638f28b9$export$41a4940678f22127 = /*#__PURE__*/ $4ygyM.leftF($6omhk.Functor);
var $0dcc135d638f28b9$export$c1cd2021ce1d7fcb = /*#__PURE__*/ (0, $f5id0.flow)($6omhk.fromIO, $0dcc135d638f28b9$export$f0188b620f44372a);
var $0dcc135d638f28b9$export$9d86f0a38eb969ef = /*#__PURE__*/ (0, $f5id0.flow)($6omhk.fromIO, $0dcc135d638f28b9$export$41a4940678f22127);
var $0dcc135d638f28b9$export$d529793c7ff048a8 = $0dcc135d638f28b9$export$c1cd2021ce1d7fcb;
var $0dcc135d638f28b9$export$b13b747e271beee9 = $0dcc135d638f28b9$export$f0188b620f44372a;
var $0dcc135d638f28b9$export$80c878c9b1d77917 = $6omhk.of;
var $0dcc135d638f28b9$export$9b09e19fe882abba = $6omhk.fromIO;
var $0dcc135d638f28b9$export$691693e0bdd7c0dc = function(onNone) {
    return $6omhk.map($7cVq5.fromOption(onNone));
};
var $0dcc135d638f28b9$export$4659b591c19bdf3d = /*#__PURE__*/ $4ygyM.match($6omhk.Functor);
var $0dcc135d638f28b9$export$2d55ea551c238330 = $0dcc135d638f28b9$export$4659b591c19bdf3d;
var $0dcc135d638f28b9$export$398621f19e0a7e4 = /*#__PURE__*/ $4ygyM.matchE($6omhk.Monad);
var $0dcc135d638f28b9$export$93e2b83da34ff82a = $0dcc135d638f28b9$export$398621f19e0a7e4;
var $0dcc135d638f28b9$export$85ac45300d10b517 = $0dcc135d638f28b9$export$398621f19e0a7e4;
var $0dcc135d638f28b9$export$ccb09033cefa61e8 = $0dcc135d638f28b9$export$85ac45300d10b517;
var $0dcc135d638f28b9$export$8832081647a02ee7 = /*#__PURE__*/ $4ygyM.getOrElse($6omhk.Monad);
var $0dcc135d638f28b9$export$d8a997ff0e6436f3 = $0dcc135d638f28b9$export$8832081647a02ee7;
var $0dcc135d638f28b9$export$d234c058d1d4e435 = function(f, onRejected) {
    return function() {
        return $0dcc135d638f28b9$var$__awaiter(void 0, void 0, void 0, function() {
            var reason_1;
            return $0dcc135d638f28b9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            f().then($aByOK.right)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        reason_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $aByOK.left(onRejected(reason_1))
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $0dcc135d638f28b9$export$7f3d23c4b0794e72 = function(f, onRejected) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $0dcc135d638f28b9$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onRejected);
    };
};
var $0dcc135d638f28b9$export$a0886ed3a572729f = /*#__PURE__*/ $4ygyM.toUnion($6omhk.Functor);
var $0dcc135d638f28b9$export$b601f49376b4621a = /*#__PURE__*/ $4ygyM.fromNullable($6omhk.Pointed);
var $0dcc135d638f28b9$export$c69ca7b73fad45e1 = /*#__PURE__*/ $4ygyM.fromNullableK($6omhk.Pointed);
var $0dcc135d638f28b9$export$c81f992c08fd0bf3 = /*#__PURE__*/ $4ygyM.chainNullableK($6omhk.Monad);
var $0dcc135d638f28b9$export$41d1a04d78e7b141 = /*#__PURE__*/ $4ygyM.orElse($6omhk.Monad);
var $0dcc135d638f28b9$export$efd845e0c87089a6 = $0dcc135d638f28b9$export$41d1a04d78e7b141;
var $0dcc135d638f28b9$export$f297679585c88732 = /*#__PURE__*/ (0, $f5id0.dual)(2, $4ygyM.tapError($6omhk.Monad));
var $0dcc135d638f28b9$export$91e9d1839ed8da93 = function(onLeft) {
    return $0dcc135d638f28b9$export$f297679585c88732($0dcc135d638f28b9$export$9d3fcca17a044a16(onLeft));
};
var $0dcc135d638f28b9$export$85b9777d93691bbc = function(onLeft) {
    return $0dcc135d638f28b9$export$f297679585c88732($0dcc135d638f28b9$export$bb6009cf24290313(onLeft));
};
var $0dcc135d638f28b9$export$e84f0fd7f5bcfbf0 = /*#__PURE__*/ $4ygyM.orLeft($6omhk.Monad);
var $0dcc135d638f28b9$export$b0e76d9850c64156 = /*#__PURE__*/ $4ygyM.swap($6omhk.Functor);
var $0dcc135d638f28b9$export$f956926575b25f94 = function(onNone) {
    var from = $0dcc135d638f28b9$export$691693e0bdd7c0dc(onNone);
    return function(f) {
        return (0, $f5id0.flow)(f, from);
    };
};
var $0dcc135d638f28b9$export$cc18a684c8cb422d = function(onNone) {
    return function(f) {
        return function(ma) {
            return $0dcc135d638f28b9$export$5b8affa63fc6df16(ma, $0dcc135d638f28b9$export$f956926575b25f94(onNone)(f));
        };
    };
};
var $0dcc135d638f28b9$export$a344f5448340a4a7 = $0dcc135d638f28b9$export$cc18a684c8cb422d;
var $0dcc135d638f28b9$export$6f981aca7fb40299 = function(f) {
    return (0, $f5id0.flow)(f, $0dcc135d638f28b9$export$9b09e19fe882abba);
};
var $0dcc135d638f28b9$var$_map = function(fa, f) {
    return (0, $f5id0.pipe)(fa, $0dcc135d638f28b9$export$871de8747c9eaa88(f));
};
var $0dcc135d638f28b9$var$_apPar = function(fab, fa) {
    return (0, $f5id0.pipe)(fab, $0dcc135d638f28b9$export$2f6ca3d3b1f80bf5(fa));
};
var $0dcc135d638f28b9$var$_apSeq = function(fab, fa) {
    return $0dcc135d638f28b9$export$5b8affa63fc6df16(fab, function(f) {
        return (0, $f5id0.pipe)(fa, $0dcc135d638f28b9$export$871de8747c9eaa88(f));
    });
};
/* istanbul ignore next */ var $0dcc135d638f28b9$var$_alt = function(fa, that) {
    return (0, $f5id0.pipe)(fa, $0dcc135d638f28b9$export$228be17d80722ab(that));
};
var $0dcc135d638f28b9$export$871de8747c9eaa88 = /*#__PURE__*/ $4ygyM.map($6omhk.Functor);
var $0dcc135d638f28b9$export$2ab19f8a7e145f0a = /*#__PURE__*/ (0, $f5id0.dual)(3, $4ygyM.mapBoth($6omhk.Functor));
var $0dcc135d638f28b9$export$eb54baf0b342cb1d = $0dcc135d638f28b9$export$2ab19f8a7e145f0a;
var $0dcc135d638f28b9$export$d0f6f6f8d08fe167 = /*#__PURE__*/ (0, $f5id0.dual)(2, $4ygyM.mapError($6omhk.Functor));
var $0dcc135d638f28b9$export$472de43a55e4aa49 = $0dcc135d638f28b9$export$d0f6f6f8d08fe167;
var $0dcc135d638f28b9$export$2f6ca3d3b1f80bf5 = /*#__PURE__*/ $4ygyM.ap($6omhk.ApplyPar);
var $0dcc135d638f28b9$export$321be6e231de8eac = $0dcc135d638f28b9$export$2f6ca3d3b1f80bf5;
var $0dcc135d638f28b9$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $f5id0.dual)(2, $4ygyM.flatMap($6omhk.Monad));
var $0dcc135d638f28b9$export$2409099f1fc434fb = /*#__PURE__*/ $0dcc135d638f28b9$export$5b8affa63fc6df16((0, $f5id0.identity));
var $0dcc135d638f28b9$export$bffa455ba8c619a6 = $0dcc135d638f28b9$export$2409099f1fc434fb;
var $0dcc135d638f28b9$export$228be17d80722ab = /*#__PURE__*/ $4ygyM.alt($6omhk.Monad);
var $0dcc135d638f28b9$export$1517cca7889d6aaa = $0dcc135d638f28b9$export$228be17d80722ab;
var $0dcc135d638f28b9$export$ba255e9e49e00608 = $0dcc135d638f28b9$export$79ffe56a765070d2;
var $0dcc135d638f28b9$export$8bf7aba4a9e09055 = $0dcc135d638f28b9$export$eabcd2c8791e7bf4;
var $0dcc135d638f28b9$export$9156e739aa33e19f = 'TaskEither';
function $0dcc135d638f28b9$export$f55d048c8c810adb(A, S) {
    var ap = (0, $6IQDS.ap)(A, $7cVq5.getApplicativeValidation(S));
    return {
        URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
        _E: undefined,
        map: $0dcc135d638f28b9$var$_map,
        ap: function(fab, fa) {
            return (0, $f5id0.pipe)(fab, ap(fa));
        },
        of: $0dcc135d638f28b9$export$ba255e9e49e00608
    };
}
function $0dcc135d638f28b9$export$93b1fc7a429347dc(S) {
    var alt = $4ygyM.altValidation($6omhk.Monad, S);
    return {
        URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
        _E: undefined,
        map: $0dcc135d638f28b9$var$_map,
        alt: function(fa, that) {
            return (0, $f5id0.pipe)(fa, alt(that));
        }
    };
}
var $0dcc135d638f28b9$export$cfae3069ac05ff4c = function(M) {
    var C = $7cVq5.getCompactable(M);
    return {
        URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
        _E: undefined,
        compact: (0, $77QB6.compact)($6omhk.Functor, C),
        separate: (0, $77QB6.separate)($6omhk.Functor, C, $7cVq5.Functor)
    };
};
function $0dcc135d638f28b9$export$a4e870b0a57ec14e(M) {
    var F = $7cVq5.getFilterable(M);
    var C = $0dcc135d638f28b9$export$cfae3069ac05ff4c(M);
    var filter = (0, $eUvQQ.filter)($6omhk.Functor, F);
    var filterMap = (0, $eUvQQ.filterMap)($6omhk.Functor, F);
    var partition = (0, $eUvQQ.partition)($6omhk.Functor, F);
    var partitionMap = (0, $eUvQQ.partitionMap)($6omhk.Functor, F);
    return {
        URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
        _E: undefined,
        map: $0dcc135d638f28b9$var$_map,
        compact: C.compact,
        separate: C.separate,
        filter: function(fa, predicate) {
            return (0, $f5id0.pipe)(fa, filter(predicate));
        },
        filterMap: function(fa, f) {
            return (0, $f5id0.pipe)(fa, filterMap(f));
        },
        partition: function(fa, predicate) {
            return (0, $f5id0.pipe)(fa, partition(predicate));
        },
        partitionMap: function(fa, f) {
            return (0, $f5id0.pipe)(fa, partitionMap(f));
        }
    };
}
var $0dcc135d638f28b9$export$bd5b6bfc5fa2ee61 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map
};
var $0dcc135d638f28b9$export$6554612db691658e = (0, $f5id0.dual)(2, (0, $hrfTw.as)($0dcc135d638f28b9$export$bd5b6bfc5fa2ee61));
var $0dcc135d638f28b9$export$9284b360ca18a0fd = (0, $hrfTw.asUnit)($0dcc135d638f28b9$export$bd5b6bfc5fa2ee61);
var $0dcc135d638f28b9$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($0dcc135d638f28b9$export$bd5b6bfc5fa2ee61);
var $0dcc135d638f28b9$export$59a71046037e6c20 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608
};
var $0dcc135d638f28b9$export$e825dd8dbbdc0410 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar
};
var $0dcc135d638f28b9$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $6IQDS.apFirst)($0dcc135d638f28b9$export$e825dd8dbbdc0410);
var $0dcc135d638f28b9$export$ac044f4aa9961a4f = $0dcc135d638f28b9$export$5f28d9feedcfd46e;
var $0dcc135d638f28b9$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $6IQDS.apSecond)($0dcc135d638f28b9$export$e825dd8dbbdc0410);
var $0dcc135d638f28b9$export$8a00020751233172 = $0dcc135d638f28b9$export$ed01bc59c3d06bf3;
var $0dcc135d638f28b9$export$11b888901d89cc2 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608
};
var $0dcc135d638f28b9$export$60f1052cde3ba705 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apSeq
};
var $0dcc135d638f28b9$export$9c23f2f51a58ba10 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apSeq,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608
};
var $0dcc135d638f28b9$export$f18d5acc27d70423 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16
};
var $0dcc135d638f28b9$export$fb641926d034ac7d = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608
};
var $0dcc135d638f28b9$export$dc43ee6ccf36ad90 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608,
    fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8
};
var $0dcc135d638f28b9$export$ddc01897af104624 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608,
    fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8,
    fromTask: $0dcc135d638f28b9$export$b13b747e271beee9
};
var $0dcc135d638f28b9$export$5f956d47d0619c3a = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    ap: $0dcc135d638f28b9$var$_apPar,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608,
    throwError: $0dcc135d638f28b9$export$8bf7aba4a9e09055
};
var $0dcc135d638f28b9$export$825ea6cb6fc48d49 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    fromEither: $0dcc135d638f28b9$export$80c878c9b1d77917
};
var $0dcc135d638f28b9$export$978d37ea2fe360cf = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8
};
var $0dcc135d638f28b9$export$e86019a4d2fb9384 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8,
    fromTask: $0dcc135d638f28b9$export$b13b747e271beee9
};
var $0dcc135d638f28b9$export$3f23594af5f37336 = /*#__PURE__*/ (0, $f5id0.dual)(2, $lcDVT.tap($0dcc135d638f28b9$export$f18d5acc27d70423));
var $0dcc135d638f28b9$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $ctkBN.tapEither)($0dcc135d638f28b9$export$825ea6cb6fc48d49, $0dcc135d638f28b9$export$f18d5acc27d70423));
var $0dcc135d638f28b9$export$5bf3b8929fda1158 = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $6MUOV.tapIO)($0dcc135d638f28b9$export$978d37ea2fe360cf, $0dcc135d638f28b9$export$f18d5acc27d70423));
var $0dcc135d638f28b9$export$a8701ebadf2e95ad = /*#__PURE__*/ (0, $f5id0.dual)(2, (0, $aoLLt.tapTask)($0dcc135d638f28b9$export$e86019a4d2fb9384, $0dcc135d638f28b9$export$f18d5acc27d70423));
var $0dcc135d638f28b9$export$fd0fe42029639505 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    bimap: $0dcc135d638f28b9$export$2ab19f8a7e145f0a,
    mapLeft: $0dcc135d638f28b9$export$d0f6f6f8d08fe167
};
var $0dcc135d638f28b9$export$25ba4469a069167 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    map: $0dcc135d638f28b9$var$_map,
    alt: $0dcc135d638f28b9$var$_alt
};
var $0dcc135d638f28b9$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $ctkBN.fromOption)($0dcc135d638f28b9$export$825ea6cb6fc48d49);
var $0dcc135d638f28b9$export$a907462f448b49f8 = /*#__PURE__*/ (0, $ctkBN.fromOptionK)($0dcc135d638f28b9$export$825ea6cb6fc48d49);
var $0dcc135d638f28b9$export$12d26179deb6a68a = /*#__PURE__*/ (0, $ctkBN.chainOptionK)($0dcc135d638f28b9$export$825ea6cb6fc48d49, $0dcc135d638f28b9$export$f18d5acc27d70423);
var $0dcc135d638f28b9$export$377cc334277e5c3c = $0dcc135d638f28b9$export$12d26179deb6a68a;
/** @internal */ var $0dcc135d638f28b9$var$_FromEither = {
    fromEither: $0dcc135d638f28b9$export$825ea6cb6fc48d49.fromEither
};
var $0dcc135d638f28b9$export$cd139e14432f317b = /*#__PURE__*/ $aByOK.liftNullable($0dcc135d638f28b9$var$_FromEither);
var $0dcc135d638f28b9$export$ea4a22f93200df79 = /*#__PURE__*/ $aByOK.liftOption($0dcc135d638f28b9$var$_FromEither);
/** @internal */ var $0dcc135d638f28b9$var$_FlatMap = {
    flatMap: $0dcc135d638f28b9$export$5b8affa63fc6df16
};
/** @internal */ var $0dcc135d638f28b9$var$_FromIO = {
    fromIO: $0dcc135d638f28b9$export$978d37ea2fe360cf.fromIO
};
/** @internal */ var $0dcc135d638f28b9$var$_FromTask = {
    fromTask: $0dcc135d638f28b9$export$b13b747e271beee9
};
var $0dcc135d638f28b9$export$1a0515933c5c84fe = /*#__PURE__*/ $aByOK.flatMapNullable($0dcc135d638f28b9$var$_FromEither, $0dcc135d638f28b9$var$_FlatMap);
var $0dcc135d638f28b9$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $aByOK.flatMapOption($0dcc135d638f28b9$var$_FromEither, $0dcc135d638f28b9$var$_FlatMap);
var $0dcc135d638f28b9$export$979f2bb6a976172d = /*#__PURE__*/ $aByOK.flatMapEither($0dcc135d638f28b9$var$_FromEither, $0dcc135d638f28b9$var$_FlatMap);
var $0dcc135d638f28b9$export$8b635ef81222764c = /*#__PURE__*/ $aByOK.flatMapIO($0dcc135d638f28b9$var$_FromIO, $0dcc135d638f28b9$var$_FlatMap);
var $0dcc135d638f28b9$export$43849ff3f7ffa51c = /*#__PURE__*/ $aByOK.flatMapTask($0dcc135d638f28b9$var$_FromTask, $0dcc135d638f28b9$var$_FlatMap);
var $0dcc135d638f28b9$export$7514610652fa62c0 = /*#__PURE__*/ (0, $f5id0.dual)(2, function(self, f) {
    return $0dcc135d638f28b9$export$5b8affa63fc6df16(self, $0dcc135d638f28b9$export$6f981aca7fb40299(f));
});
var $0dcc135d638f28b9$export$bd2474f1d21e88eb = /*#__PURE__*/ (0, $f5id0.dual)(3, function(self, f, onNone) {
    return $0dcc135d638f28b9$export$5b8affa63fc6df16(self, function(a) {
        return $0dcc135d638f28b9$export$691693e0bdd7c0dc(function() {
            return onNone(a);
        })(f(a));
    });
});
var $0dcc135d638f28b9$export$a3eef2eba9908c3e = $0dcc135d638f28b9$export$979f2bb6a976172d;
var $0dcc135d638f28b9$export$148e58f5a13b0a29 = $0dcc135d638f28b9$export$979f2bb6a976172d;
var $0dcc135d638f28b9$export$c5f2bdbf9b43f0c0 = $0dcc135d638f28b9$export$be3ff275bb5a8ac9;
var $0dcc135d638f28b9$export$3b38f8f4685eb1a8 = $0dcc135d638f28b9$export$be3ff275bb5a8ac9;
var $0dcc135d638f28b9$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $ctkBN.fromPredicate)($0dcc135d638f28b9$export$825ea6cb6fc48d49);
var $0dcc135d638f28b9$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $ctkBN.filterOrElse)($0dcc135d638f28b9$export$825ea6cb6fc48d49, $0dcc135d638f28b9$export$f18d5acc27d70423);
var $0dcc135d638f28b9$export$84511cf4503ec9dd = $0dcc135d638f28b9$export$30af8ca9498ddf5b;
var $0dcc135d638f28b9$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $ctkBN.fromEitherK)($0dcc135d638f28b9$export$825ea6cb6fc48d49);
var $0dcc135d638f28b9$export$9d3fcca17a044a16 = /*#__PURE__*/ (0, $6MUOV.fromIOK)($0dcc135d638f28b9$export$978d37ea2fe360cf);
var $0dcc135d638f28b9$export$dbedca339774a859 = $0dcc135d638f28b9$export$8b635ef81222764c;
var $0dcc135d638f28b9$export$5148ef8785cce359 = $0dcc135d638f28b9$export$5bf3b8929fda1158;
var $0dcc135d638f28b9$export$bb6009cf24290313 = /*#__PURE__*/ (0, $aoLLt.fromTaskK)($0dcc135d638f28b9$export$e86019a4d2fb9384);
var $0dcc135d638f28b9$export$9e593613eaf643aa = $0dcc135d638f28b9$export$43849ff3f7ffa51c;
var $0dcc135d638f28b9$export$43e2f536f6b41427 = $0dcc135d638f28b9$export$a8701ebadf2e95ad;
var $0dcc135d638f28b9$export$fdc4db8624c799e8 = $0dcc135d638f28b9$export$7514610652fa62c0;
var $0dcc135d638f28b9$export$f596abf27dc7c7bd = $0dcc135d638f28b9$export$7514610652fa62c0;
function $0dcc135d638f28b9$export$9ff351a4cbab6799(f) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return function() {
            return new Promise(function(resolve) {
                var cbResolver = function(e, r) {
                    return e != null ? resolve($aByOK.left(e)) : resolve($aByOK.right(r));
                };
                f.apply(null, args.concat(cbResolver));
            });
        };
    };
}
var $0dcc135d638f28b9$export$df5598cc12b9c8c = function(acquire, use, release) {
    return $0dcc135d638f28b9$export$15093e5f950a635(acquire, use, release);
};
var $0dcc135d638f28b9$export$15093e5f950a635 = function(acquire, use, release) {
    return $0dcc135d638f28b9$export$5b8affa63fc6df16(acquire, function(a) {
        return $6omhk.flatMap(use(a), function(e) {
            return $0dcc135d638f28b9$export$5b8affa63fc6df16(release(a, e), function() {
                return $6omhk.of(e);
            });
        });
    });
};
var $0dcc135d638f28b9$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $0dcc135d638f28b9$export$ba255e9e49e00608($aByOK.emptyRecord);
var $0dcc135d638f28b9$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $hrfTw.bindTo)($0dcc135d638f28b9$export$bd5b6bfc5fa2ee61);
var $0dcc135d638f28b9$export$5d537b797c421217 = /*#__PURE__*/ (0, $hrfTw.let)($0dcc135d638f28b9$export$bd5b6bfc5fa2ee61);
var $0dcc135d638f28b9$export$2385a24977818dd0 = /*#__PURE__*/ $lcDVT.bind($0dcc135d638f28b9$export$f18d5acc27d70423);
var $0dcc135d638f28b9$export$e0d5b1cbe98976d9 = $0dcc135d638f28b9$export$2385a24977818dd0;
var $0dcc135d638f28b9$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $6IQDS.apS)($0dcc135d638f28b9$export$e825dd8dbbdc0410);
var $0dcc135d638f28b9$export$5c01f27714264b3d = $0dcc135d638f28b9$export$8cbfc0239f42bb49;
var $0dcc135d638f28b9$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $0dcc135d638f28b9$export$ba255e9e49e00608($aByOK.emptyReadonlyArray);
var $0dcc135d638f28b9$export$817de7d5ba7e6fab = function(f) {
    return (0, $f5id0.flow)($6omhk.traverseReadonlyNonEmptyArrayWithIndex(f), $6omhk.map($7cVq5.traverseReadonlyNonEmptyArrayWithIndex((0, $f5id0.SK))));
};
var $0dcc135d638f28b9$export$d4e79db5dc14cc1 = function(f) {
    var g = $0dcc135d638f28b9$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $0dcc135d638f28b9$export$c74b6e34b2b6efb0;
    };
};
var $0dcc135d638f28b9$export$ccd1b7252ef04791 = function(f) {
    return function(as) {
        return function() {
            return $aByOK.tail(as).reduce(function(acc, a, i) {
                return acc.then(function(ebs) {
                    return $aByOK.isLeft(ebs) ? acc : f(i + 1, a)().then(function(eb) {
                        if ($aByOK.isLeft(eb)) return eb;
                        ebs.right.push(eb.right);
                        return ebs;
                    });
                });
            }, f(0, $aByOK.head(as))().then($7cVq5.map($aByOK.singleton)));
        };
    };
};
var $0dcc135d638f28b9$export$674043f9db4279c7 = function(f) {
    var g = $0dcc135d638f28b9$export$ccd1b7252ef04791(f);
    return function(as) {
        return $aByOK.isNonEmpty(as) ? g(as) : $0dcc135d638f28b9$export$c74b6e34b2b6efb0;
    };
};
var $0dcc135d638f28b9$export$104a2841e9cbad06 = $0dcc135d638f28b9$export$d4e79db5dc14cc1;
var $0dcc135d638f28b9$export$64f39b2a2b79e1b1 = function(f) {
    return $0dcc135d638f28b9$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $0dcc135d638f28b9$export$d330b60315c14cd1 = /*#__PURE__*/ $0dcc135d638f28b9$export$64f39b2a2b79e1b1((0, $f5id0.identity));
var $0dcc135d638f28b9$export$6702e2a63712b0a0 = $0dcc135d638f28b9$export$674043f9db4279c7;
var $0dcc135d638f28b9$export$5932486b5125ca68 = function(f) {
    return $0dcc135d638f28b9$export$674043f9db4279c7(function(_, a) {
        return f(a);
    });
};
var $0dcc135d638f28b9$export$5e316684572fbbb6 = /*#__PURE__*/ $0dcc135d638f28b9$export$5932486b5125ca68((0, $f5id0.identity));
var $0dcc135d638f28b9$export$e08e3b67e392101e = $0dcc135d638f28b9$export$5b8affa63fc6df16;
var $0dcc135d638f28b9$export$8e5885f0163d737a = $0dcc135d638f28b9$export$5b8affa63fc6df16;
var $0dcc135d638f28b9$export$e3821ef4970c339c = $0dcc135d638f28b9$export$3f23594af5f37336;
var $0dcc135d638f28b9$export$5de78197fc44b933 = $0dcc135d638f28b9$export$3f23594af5f37336;
var $0dcc135d638f28b9$export$2705983cb222ac0a = $0dcc135d638f28b9$export$f297679585c88732;
var $0dcc135d638f28b9$export$d43d943be7ad7d62 = $0dcc135d638f28b9$export$f297679585c88732;
var $0dcc135d638f28b9$export$bf17ca9b48f5ebc2 = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    bimap: $0dcc135d638f28b9$export$2ab19f8a7e145f0a,
    mapLeft: $0dcc135d638f28b9$export$d0f6f6f8d08fe167,
    map: $0dcc135d638f28b9$var$_map,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608,
    ap: $0dcc135d638f28b9$var$_apPar,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
    alt: $0dcc135d638f28b9$var$_alt,
    fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8,
    fromTask: $0dcc135d638f28b9$export$b13b747e271beee9,
    throwError: $0dcc135d638f28b9$export$8bf7aba4a9e09055
};
var $0dcc135d638f28b9$export$e669e08ee441ca6e = {
    URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
    bimap: $0dcc135d638f28b9$export$2ab19f8a7e145f0a,
    mapLeft: $0dcc135d638f28b9$export$d0f6f6f8d08fe167,
    map: $0dcc135d638f28b9$var$_map,
    of: $0dcc135d638f28b9$export$ba255e9e49e00608,
    ap: $0dcc135d638f28b9$var$_apSeq,
    chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
    alt: $0dcc135d638f28b9$var$_alt,
    fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8,
    fromTask: $0dcc135d638f28b9$export$b13b747e271beee9,
    throwError: $0dcc135d638f28b9$export$8bf7aba4a9e09055
};
var $0dcc135d638f28b9$export$18979a515d2a828e = /*#__PURE__*/ (0, $6IQDS.getApplySemigroup)($0dcc135d638f28b9$export$60f1052cde3ba705);
var $0dcc135d638f28b9$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $6jM4Q.getApplicativeMonoid)($0dcc135d638f28b9$export$9c23f2f51a58ba10);
var $0dcc135d638f28b9$export$e759a9a7f8d04692 = function(S) {
    return (0, $6IQDS.getApplySemigroup)($6omhk.ApplySeq)($7cVq5.getSemigroup(S));
};
function $0dcc135d638f28b9$export$205c8c90abeec407(SE) {
    var applicativeTaskValidation = $0dcc135d638f28b9$export$f55d048c8c810adb($6omhk.ApplicativePar, SE);
    var altTaskValidation = $0dcc135d638f28b9$export$93b1fc7a429347dc(SE);
    return {
        URI: $0dcc135d638f28b9$export$9156e739aa33e19f,
        _E: undefined,
        map: $0dcc135d638f28b9$var$_map,
        ap: applicativeTaskValidation.ap,
        of: $0dcc135d638f28b9$export$ba255e9e49e00608,
        chain: $0dcc135d638f28b9$export$5b8affa63fc6df16,
        bimap: $0dcc135d638f28b9$export$2ab19f8a7e145f0a,
        mapLeft: $0dcc135d638f28b9$export$d0f6f6f8d08fe167,
        alt: altTaskValidation.alt,
        fromIO: $0dcc135d638f28b9$export$d529793c7ff048a8,
        fromTask: $0dcc135d638f28b9$export$b13b747e271beee9,
        throwError: $0dcc135d638f28b9$export$8bf7aba4a9e09055
    };
}

});
parcelRegister("aoLLt", function(module, exports) {

$parcel$export(module.exports, "fromTaskK", function () { return $792132566aa4b13b$export$bb6009cf24290313; });
$parcel$export(module.exports, "tapTask", function () { return $792132566aa4b13b$export$a8701ebadf2e95ad; });
/**
 * Lift a computation from the `Task` monad
 *
 * @since 2.10.0
 */ 
var $lcDVT = parcelRequire("lcDVT");

var $f5id0 = parcelRequire("f5id0");
function $792132566aa4b13b$export$bb6009cf24290313(F) {
    return function(f) {
        return (0, $f5id0.flow)(f, F.fromTask);
    };
}
function $792132566aa4b13b$export$9e593613eaf643aa(F, M) {
    return function(f) {
        var g = (0, $f5id0.flow)(f, F.fromTask);
        return function(first) {
            return M.chain(first, g);
        };
    };
}
function $792132566aa4b13b$export$43e2f536f6b41427(F, M) {
    var tapTaskM = $792132566aa4b13b$export$a8701ebadf2e95ad(F, M);
    return function(f) {
        return function(first) {
            return tapTaskM(first, f);
        };
    };
}
function $792132566aa4b13b$export$a8701ebadf2e95ad(F, M) {
    var tapM = (0, $lcDVT.tap)(M);
    return function(self, f) {
        return tapM(self, (0, $f5id0.flow)(f, F.fromTask));
    };
}

});


parcelRegister("jPaL5", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e6eb202a7ac355a0$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "string", function () { return $e6eb202a7ac355a0$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $e6eb202a7ac355a0$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $e6eb202a7ac355a0$export$4a21f16c33752377; });
$parcel$export(module.exports, "struct", function () { return $e6eb202a7ac355a0$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "compose", function () { return $e6eb202a7ac355a0$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "partial", function () { return $e6eb202a7ac355a0$export$e45945969df8035a; });
$parcel$export(module.exports, "readonly", function () { return $e6eb202a7ac355a0$export$6ec456bd5b7b3c51; });
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community, see these tracking
 * [issues](https://github.com/gcanti/io-ts/issues?q=label%3Av2.2+) for further discussions and enhancements.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.2.3
 */ 
var $f5id0 = parcelRequire("f5id0");

var $4CZFO = parcelRequire("4CZFO");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");
function $e6eb202a7ac355a0$export$dd44f18ab656f3bb(decoder, encoder) {
    return {
        decode: decoder.decode,
        encode: encoder.encode
    };
}
function $e6eb202a7ac355a0$export$2d3cac092805cb4f(decoder) {
    return {
        decode: decoder.decode,
        encode: (0, $f5id0.identity)
    };
}
function $e6eb202a7ac355a0$export$c8ec6e1ec9fefcb0() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return $e6eb202a7ac355a0$export$2d3cac092805cb4f($4BSZX.literal.apply($4BSZX, values));
}
var $e6eb202a7ac355a0$export$22b082955e083ec3 = /*#__PURE__*/ $e6eb202a7ac355a0$export$2d3cac092805cb4f($4BSZX.string);
var $e6eb202a7ac355a0$export$98e628dec113755e = /*#__PURE__*/ $e6eb202a7ac355a0$export$2d3cac092805cb4f($4BSZX.number);
var $e6eb202a7ac355a0$export$4a21f16c33752377 = /*#__PURE__*/ $e6eb202a7ac355a0$export$2d3cac092805cb4f($4BSZX.boolean);
var $e6eb202a7ac355a0$export$837c7bec7087434c = /*#__PURE__*/ $e6eb202a7ac355a0$export$2d3cac092805cb4f($4BSZX.UnknownArray);
var $e6eb202a7ac355a0$export$ecfbd036cf5a99af = /*#__PURE__*/ $e6eb202a7ac355a0$export$2d3cac092805cb4f($4BSZX.UnknownRecord);
var $e6eb202a7ac355a0$export$18b028d1bd14e25c = function(f) {
    return function(codec) {
        return $e6eb202a7ac355a0$export$dd44f18ab656f3bb((0, $4CZFO.pipe)(codec, $4BSZX.mapLeftWithInput(f)), codec);
    };
};
var $e6eb202a7ac355a0$export$edc9d475108b3212 = function(refinement, id) {
    var refine = $4BSZX.refine(refinement, id);
    return function(from) {
        return $e6eb202a7ac355a0$export$dd44f18ab656f3bb(refine(from), from);
    };
};
function $e6eb202a7ac355a0$export$133fc36489ac9add(or) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.nullable(or), $d9q5l.nullable(or));
}
function $e6eb202a7ac355a0$export$34355cbaba607122(properties) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.fromStruct(properties), $d9q5l.struct(properties));
}
var $e6eb202a7ac355a0$export$1fc03a2373fc8e75 = $e6eb202a7ac355a0$export$34355cbaba607122;
function $e6eb202a7ac355a0$export$8cf3da7c1c9174ea(properties) {
    return (0, $4CZFO.pipe)($e6eb202a7ac355a0$export$ecfbd036cf5a99af, $e6eb202a7ac355a0$export$f672e0b6f7222cd7($e6eb202a7ac355a0$export$34355cbaba607122(properties)));
}
var $e6eb202a7ac355a0$export$bf9fb029d174d554 = $e6eb202a7ac355a0$export$8cf3da7c1c9174ea;
function $e6eb202a7ac355a0$export$fb157a05f56ae99a(properties) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.fromPartial(properties), $d9q5l.partial(properties));
}
function $e6eb202a7ac355a0$export$e45945969df8035a(properties) {
    return (0, $4CZFO.pipe)($e6eb202a7ac355a0$export$ecfbd036cf5a99af, $e6eb202a7ac355a0$export$f672e0b6f7222cd7($e6eb202a7ac355a0$export$fb157a05f56ae99a(properties)));
}
function $e6eb202a7ac355a0$export$571d59b505e6bb4e(item) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.fromArray(item), $d9q5l.array(item));
}
function $e6eb202a7ac355a0$export$2f23118c22fb2630(item) {
    return (0, $4CZFO.pipe)($e6eb202a7ac355a0$export$837c7bec7087434c, $e6eb202a7ac355a0$export$f672e0b6f7222cd7($e6eb202a7ac355a0$export$571d59b505e6bb4e(item)));
}
function $e6eb202a7ac355a0$export$6c8271f68d66a228(codomain) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.fromRecord(codomain), $d9q5l.record(codomain));
}
function $e6eb202a7ac355a0$export$e5185e241753e543(codomain) {
    return (0, $4CZFO.pipe)($e6eb202a7ac355a0$export$ecfbd036cf5a99af, $e6eb202a7ac355a0$export$f672e0b6f7222cd7($e6eb202a7ac355a0$export$6c8271f68d66a228(codomain)));
}
var $e6eb202a7ac355a0$export$54e67896484d10fe = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.fromTuple.apply($4BSZX, components), $d9q5l.tuple.apply($d9q5l, components));
};
function $e6eb202a7ac355a0$export$65e3907585753458() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return (0, $4CZFO.pipe)($e6eb202a7ac355a0$export$837c7bec7087434c, $e6eb202a7ac355a0$export$f672e0b6f7222cd7($e6eb202a7ac355a0$export$54e67896484d10fe.apply(void 0, components)));
}
var $e6eb202a7ac355a0$export$1f4807a235930d45 = function(right) {
    var intersectD = $4BSZX.intersect(right);
    var intersectE = $d9q5l.intersect(right);
    return function(left) {
        return $e6eb202a7ac355a0$export$dd44f18ab656f3bb(intersectD(left), intersectE(left));
    };
};
var $e6eb202a7ac355a0$export$bf197727082b6243 = function(tag) {
    var decoder = $4BSZX.fromSum(tag);
    var encoder = $d9q5l.sum(tag);
    return function(members) {
        return $e6eb202a7ac355a0$export$dd44f18ab656f3bb(decoder(members), encoder(members));
    };
};
function $e6eb202a7ac355a0$export$8a63f25cc62965f1(tag) {
    var sum = $e6eb202a7ac355a0$export$bf197727082b6243(tag);
    return function(members) {
        return (0, $4CZFO.pipe)($e6eb202a7ac355a0$export$ecfbd036cf5a99af, $e6eb202a7ac355a0$export$f672e0b6f7222cd7(sum(members)));
    };
}
function $e6eb202a7ac355a0$export$488013bae63b21da(id, f) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.lazy(id, f), $d9q5l.lazy(f));
}
var $e6eb202a7ac355a0$export$6ec456bd5b7b3c51 = (0, $f5id0.identity);
var $e6eb202a7ac355a0$export$f672e0b6f7222cd7 = function(to) {
    return function(from) {
        return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.compose(to)(from), $d9q5l.compose(from)(to));
    };
};
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var $e6eb202a7ac355a0$var$imap_ = function(fa, f, g) {
    return $e6eb202a7ac355a0$export$dd44f18ab656f3bb($4BSZX.Functor.map(fa, f), $d9q5l.Contravariant.contramap(fa, g));
};
var $e6eb202a7ac355a0$export$b2517b0ab3a58435 = function(f, g) {
    return function(fa) {
        return $e6eb202a7ac355a0$var$imap_(fa, f, g);
    };
};
var $e6eb202a7ac355a0$export$9156e739aa33e19f = 'io-ts/Codec';
var $e6eb202a7ac355a0$export$dbdf692cc5737cfd = {
    URI: $e6eb202a7ac355a0$export$9156e739aa33e19f,
    imap: $e6eb202a7ac355a0$var$imap_
};

});
parcelRegister("4BSZX", function(module, exports) {

$parcel$export(module.exports, "SE", function () { return $35b547a4c5e704b6$export$88d2e60d4be28663; });
$parcel$export(module.exports, "ap", function () { return $35b547a4c5e704b6$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "error", function () { return $35b547a4c5e704b6$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "success", function () { return $35b547a4c5e704b6$export$fe7c49d056ea1d88; });
$parcel$export(module.exports, "failure", function () { return $35b547a4c5e704b6$export$af2dba6db4e9e1f0; });
$parcel$export(module.exports, "fromRefinement", function () { return $35b547a4c5e704b6$export$675cdb7790c17869; });
$parcel$export(module.exports, "fromGuard", function () { return $35b547a4c5e704b6$export$35358b55571cb9f; });
$parcel$export(module.exports, "literal", function () { return $35b547a4c5e704b6$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "string", function () { return $35b547a4c5e704b6$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $35b547a4c5e704b6$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $35b547a4c5e704b6$export$4a21f16c33752377; });
$parcel$export(module.exports, "UnknownArray", function () { return $35b547a4c5e704b6$export$837c7bec7087434c; });
$parcel$export(module.exports, "UnknownRecord", function () { return $35b547a4c5e704b6$export$ecfbd036cf5a99af; });
$parcel$export(module.exports, "mapLeftWithInput", function () { return $35b547a4c5e704b6$export$18b028d1bd14e25c; });
$parcel$export(module.exports, "withMessage", function () { return $35b547a4c5e704b6$export$d330e88f82633eb9; });
$parcel$export(module.exports, "refine", function () { return $35b547a4c5e704b6$export$edc9d475108b3212; });
$parcel$export(module.exports, "parse", function () { return $35b547a4c5e704b6$export$98e6a39c04603d36; });
$parcel$export(module.exports, "nullable", function () { return $35b547a4c5e704b6$export$133fc36489ac9add; });
$parcel$export(module.exports, "fromStruct", function () { return $35b547a4c5e704b6$export$34355cbaba607122; });
$parcel$export(module.exports, "fromType", function () { return $35b547a4c5e704b6$export$1fc03a2373fc8e75; });
$parcel$export(module.exports, "struct", function () { return $35b547a4c5e704b6$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "compose", function () { return $35b547a4c5e704b6$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "type", function () { return $35b547a4c5e704b6$export$bf9fb029d174d554; });
$parcel$export(module.exports, "fromPartial", function () { return $35b547a4c5e704b6$export$fb157a05f56ae99a; });
$parcel$export(module.exports, "partial", function () { return $35b547a4c5e704b6$export$e45945969df8035a; });
$parcel$export(module.exports, "fromArray", function () { return $35b547a4c5e704b6$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "array", function () { return $35b547a4c5e704b6$export$2f23118c22fb2630; });
$parcel$export(module.exports, "fromRecord", function () { return $35b547a4c5e704b6$export$6c8271f68d66a228; });
$parcel$export(module.exports, "record", function () { return $35b547a4c5e704b6$export$e5185e241753e543; });
$parcel$export(module.exports, "fromTuple", function () { return $35b547a4c5e704b6$export$54e67896484d10fe; });
$parcel$export(module.exports, "tuple", function () { return $35b547a4c5e704b6$export$65e3907585753458; });
$parcel$export(module.exports, "union", function () { return $35b547a4c5e704b6$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersect", function () { return $35b547a4c5e704b6$export$1f4807a235930d45; });
$parcel$export(module.exports, "fromSum", function () { return $35b547a4c5e704b6$export$bf197727082b6243; });
$parcel$export(module.exports, "sum", function () { return $35b547a4c5e704b6$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "lazy", function () { return $35b547a4c5e704b6$export$488013bae63b21da; });
$parcel$export(module.exports, "readonly", function () { return $35b547a4c5e704b6$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "map", function () { return $35b547a4c5e704b6$export$871de8747c9eaa88; });
$parcel$export(module.exports, "alt", function () { return $35b547a4c5e704b6$export$228be17d80722ab; });
$parcel$export(module.exports, "id", function () { return $35b547a4c5e704b6$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "URI", function () { return $35b547a4c5e704b6$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Functor", function () { return $35b547a4c5e704b6$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "Alt", function () { return $35b547a4c5e704b6$export$25ba4469a069167; });
$parcel$export(module.exports, "Category", function () { return $35b547a4c5e704b6$export$3a8840c5b2ecf003; });
$parcel$export(module.exports, "Schemable", function () { return $35b547a4c5e704b6$export$8c48479322816587; });
$parcel$export(module.exports, "WithUnknownContainers", function () { return $35b547a4c5e704b6$export$9fbacd728aa00eea; });
$parcel$export(module.exports, "WithUnion", function () { return $35b547a4c5e704b6$export$70d513615ee15303; });
$parcel$export(module.exports, "WithRefine", function () { return $35b547a4c5e704b6$export$46824d948a594d40; });
$parcel$export(module.exports, "draw", function () { return $35b547a4c5e704b6$export$e529deb2bfd496dc; });
$parcel$export(module.exports, "stringify", function () { return $35b547a4c5e704b6$export$fac44ee5b035f737; });

var $7cVq5 = parcelRequire("7cVq5");

var $f5id0 = parcelRequire("f5id0");

var $4CZFO = parcelRequire("4CZFO");

var $4TDwz = parcelRequire("4TDwz");

var $elkOd = parcelRequire("elkOd");

var $5ZMdr = parcelRequire("5ZMdr");

var $9N4mM = parcelRequire("9N4mM");
var $35b547a4c5e704b6$export$88d2e60d4be28663 = /*#__PURE__*/ $4TDwz.getSemigroup();
var $35b547a4c5e704b6$export$2f6ca3d3b1f80bf5 = function(fab, fa) {
    return $7cVq5.isLeft(fab) ? $7cVq5.isLeft(fa) ? $7cVq5.left($35b547a4c5e704b6$export$88d2e60d4be28663.concat(fab.left, fa.left)) : fab : $7cVq5.isLeft(fa) ? fa : $7cVq5.right(fab.right(fa.right));
};
var $35b547a4c5e704b6$var$M = {
    URI: $7cVq5.URI,
    _E: undefined,
    map: function(fa, f) {
        return (0, $4CZFO.pipe)(fa, $7cVq5.map(f));
    },
    ap: $35b547a4c5e704b6$export$2f6ca3d3b1f80bf5,
    of: $7cVq5.right,
    chain: function(ma, f) {
        return (0, $4CZFO.pipe)(ma, $7cVq5.chain(f));
    },
    throwError: $7cVq5.left,
    bimap: function(fa, f, g) {
        return (0, $4CZFO.pipe)(fa, $7cVq5.bimap(f, g));
    },
    mapLeft: function(fa, f) {
        return (0, $4CZFO.pipe)(fa, $7cVq5.mapLeft(f));
    },
    alt: function(me, that) {
        if ($7cVq5.isRight(me)) return me;
        var ea = that();
        return $7cVq5.isLeft(ea) ? $7cVq5.left($35b547a4c5e704b6$export$88d2e60d4be28663.concat(me.left, ea.left)) : ea;
    }
};
var $35b547a4c5e704b6$export$a3bc9b8ed74fc = function(actual, message) {
    return $elkOd.of($4TDwz.leaf(actual, message));
};
var $35b547a4c5e704b6$export$fe7c49d056ea1d88 = $7cVq5.right;
var $35b547a4c5e704b6$export$af2dba6db4e9e1f0 = function(actual, message) {
    return $7cVq5.left($35b547a4c5e704b6$export$a3bc9b8ed74fc(actual, message));
};
var $35b547a4c5e704b6$export$675cdb7790c17869 = function(refinement, expected) {
    return $9N4mM.fromRefinement($35b547a4c5e704b6$var$M)(refinement, function(u) {
        return $35b547a4c5e704b6$export$a3bc9b8ed74fc(u, expected);
    });
};
var $35b547a4c5e704b6$export$35358b55571cb9f = function(guard, expected) {
    return $35b547a4c5e704b6$export$675cdb7790c17869(guard.is, expected);
};
var $35b547a4c5e704b6$export$c8ec6e1ec9fefcb0 = /*#__PURE__*/ $9N4mM.literal($35b547a4c5e704b6$var$M)(function(u, values) {
    return $35b547a4c5e704b6$export$a3bc9b8ed74fc(u, values.map(function(value) {
        return JSON.stringify(value);
    }).join(' | '));
});
var $35b547a4c5e704b6$export$22b082955e083ec3 = /*#__PURE__*/ $35b547a4c5e704b6$export$35358b55571cb9f($5ZMdr.string, 'string');
var $35b547a4c5e704b6$export$98e628dec113755e = /*#__PURE__*/ $35b547a4c5e704b6$export$35358b55571cb9f($5ZMdr.number, 'number');
var $35b547a4c5e704b6$export$4a21f16c33752377 = /*#__PURE__*/ $35b547a4c5e704b6$export$35358b55571cb9f($5ZMdr.boolean, 'boolean');
var $35b547a4c5e704b6$export$837c7bec7087434c = /*#__PURE__*/ $35b547a4c5e704b6$export$35358b55571cb9f($5ZMdr.UnknownArray, 'Array<unknown>');
var $35b547a4c5e704b6$export$ecfbd036cf5a99af = /*#__PURE__*/ $35b547a4c5e704b6$export$35358b55571cb9f($5ZMdr.UnknownRecord, 'Record<string, unknown>');
var $35b547a4c5e704b6$export$18b028d1bd14e25c = /*#__PURE__*/ $9N4mM.mapLeftWithInput($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$d330e88f82633eb9 = function(message) {
    return $35b547a4c5e704b6$export$18b028d1bd14e25c(function(input, e) {
        return $elkOd.of($4TDwz.wrap(message(input, e), e));
    });
};
var $35b547a4c5e704b6$export$edc9d475108b3212 = function(refinement, id) {
    return $9N4mM.refine($35b547a4c5e704b6$var$M)(refinement, function(a) {
        return $35b547a4c5e704b6$export$a3bc9b8ed74fc(a, id);
    });
};
var $35b547a4c5e704b6$export$98e6a39c04603d36 = /*#__PURE__*/ $9N4mM.parse($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$133fc36489ac9add = /*#__PURE__*/ $9N4mM.nullable($35b547a4c5e704b6$var$M)(function(u, e) {
    return $elkOd.concat($elkOd.of($4TDwz.member(0, $35b547a4c5e704b6$export$a3bc9b8ed74fc(u, 'null'))), $elkOd.of($4TDwz.member(1, e)));
});
var $35b547a4c5e704b6$export$34355cbaba607122 = function(properties) {
    return $9N4mM.fromStruct($35b547a4c5e704b6$var$M)(function(k, e) {
        return $elkOd.of($4TDwz.key(k, $4TDwz.required, e));
    })(properties);
};
var $35b547a4c5e704b6$export$1fc03a2373fc8e75 = $35b547a4c5e704b6$export$34355cbaba607122;
var $35b547a4c5e704b6$export$8cf3da7c1c9174ea = function(properties) {
    return (0, $4CZFO.pipe)($35b547a4c5e704b6$export$ecfbd036cf5a99af, $35b547a4c5e704b6$export$f672e0b6f7222cd7($35b547a4c5e704b6$export$34355cbaba607122(properties)));
};
var $35b547a4c5e704b6$export$bf9fb029d174d554 = $35b547a4c5e704b6$export$8cf3da7c1c9174ea;
var $35b547a4c5e704b6$export$fb157a05f56ae99a = function(properties) {
    return $9N4mM.fromPartial($35b547a4c5e704b6$var$M)(function(k, e) {
        return $elkOd.of($4TDwz.key(k, $4TDwz.optional, e));
    })(properties);
};
var $35b547a4c5e704b6$export$e45945969df8035a = function(properties) {
    return (0, $4CZFO.pipe)($35b547a4c5e704b6$export$ecfbd036cf5a99af, $35b547a4c5e704b6$export$f672e0b6f7222cd7($35b547a4c5e704b6$export$fb157a05f56ae99a(properties)));
};
var $35b547a4c5e704b6$export$571d59b505e6bb4e = function(item) {
    return $9N4mM.fromArray($35b547a4c5e704b6$var$M)(function(i, e) {
        return $elkOd.of($4TDwz.index(i, $4TDwz.optional, e));
    })(item);
};
var $35b547a4c5e704b6$export$2f23118c22fb2630 = function(item) {
    return (0, $4CZFO.pipe)($35b547a4c5e704b6$export$837c7bec7087434c, $35b547a4c5e704b6$export$f672e0b6f7222cd7($35b547a4c5e704b6$export$571d59b505e6bb4e(item)));
};
var $35b547a4c5e704b6$export$6c8271f68d66a228 = function(codomain) {
    return $9N4mM.fromRecord($35b547a4c5e704b6$var$M)(function(k, e) {
        return $elkOd.of($4TDwz.key(k, $4TDwz.optional, e));
    })(codomain);
};
var $35b547a4c5e704b6$export$e5185e241753e543 = function(codomain) {
    return (0, $4CZFO.pipe)($35b547a4c5e704b6$export$ecfbd036cf5a99af, $35b547a4c5e704b6$export$f672e0b6f7222cd7($35b547a4c5e704b6$export$6c8271f68d66a228(codomain)));
};
var $35b547a4c5e704b6$export$54e67896484d10fe = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return $9N4mM.fromTuple($35b547a4c5e704b6$var$M)(function(i, e) {
        return $elkOd.of($4TDwz.index(i, $4TDwz.required, e));
    }).apply(void 0, components);
};
var $35b547a4c5e704b6$export$65e3907585753458 = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return (0, $4CZFO.pipe)($35b547a4c5e704b6$export$837c7bec7087434c, $35b547a4c5e704b6$export$f672e0b6f7222cd7($35b547a4c5e704b6$export$54e67896484d10fe.apply(void 0, components)));
};
var $35b547a4c5e704b6$export$971dd5b0dfd021b6 = /*#__PURE__*/ $9N4mM.union($35b547a4c5e704b6$var$M)(function(i, e) {
    return $elkOd.of($4TDwz.member(i, e));
});
var $35b547a4c5e704b6$export$1f4807a235930d45 = /*#__PURE__*/ $9N4mM.intersect($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$bf197727082b6243 = function(tag) {
    return function(members) {
        return $9N4mM.fromSum($35b547a4c5e704b6$var$M)(function(tag, value, keys) {
            return $elkOd.of($4TDwz.key(tag, $4TDwz.required, $35b547a4c5e704b6$export$a3bc9b8ed74fc(value, keys.length === 0 ? 'never' : keys.map(function(k) {
                return JSON.stringify(k);
            }).join(' | '))));
        })(tag)(members);
    };
};
var $35b547a4c5e704b6$export$8a63f25cc62965f1 = function(tag) {
    return function(members) {
        return (0, $4CZFO.pipe)($35b547a4c5e704b6$export$ecfbd036cf5a99af, $35b547a4c5e704b6$export$f672e0b6f7222cd7($35b547a4c5e704b6$export$bf197727082b6243(tag)(members)));
    };
};
var $35b547a4c5e704b6$export$488013bae63b21da = /*#__PURE__*/ $9N4mM.lazy($35b547a4c5e704b6$var$M)(function(id, e) {
    return $elkOd.of($4TDwz.lazy(id, e));
});
var $35b547a4c5e704b6$export$6ec456bd5b7b3c51 = (0, $f5id0.identity);
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var $35b547a4c5e704b6$var$map_ = function(fa, f) {
    return (0, $4CZFO.pipe)(fa, $35b547a4c5e704b6$export$871de8747c9eaa88(f));
};
var $35b547a4c5e704b6$var$alt_ = function(me, that) {
    return (0, $4CZFO.pipe)(me, $35b547a4c5e704b6$export$228be17d80722ab(that));
};
var $35b547a4c5e704b6$var$compose_ = function(ab, la) {
    return (0, $4CZFO.pipe)(la, $35b547a4c5e704b6$export$f672e0b6f7222cd7(ab));
};
var $35b547a4c5e704b6$export$871de8747c9eaa88 = /*#__PURE__*/ $9N4mM.map($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$228be17d80722ab = /*#__PURE__*/ $9N4mM.alt($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$f672e0b6f7222cd7 = /*#__PURE__*/ $9N4mM.compose($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$d560c7e4a29451c2 = /*#__PURE__*/ $9N4mM.id($35b547a4c5e704b6$var$M);
var $35b547a4c5e704b6$export$9156e739aa33e19f = 'io-ts/Decoder';
var $35b547a4c5e704b6$export$bd5b6bfc5fa2ee61 = {
    URI: $35b547a4c5e704b6$export$9156e739aa33e19f,
    map: $35b547a4c5e704b6$var$map_
};
var $35b547a4c5e704b6$export$25ba4469a069167 = {
    URI: $35b547a4c5e704b6$export$9156e739aa33e19f,
    map: $35b547a4c5e704b6$var$map_,
    alt: $35b547a4c5e704b6$var$alt_
};
var $35b547a4c5e704b6$export$3a8840c5b2ecf003 = {
    URI: $35b547a4c5e704b6$export$9156e739aa33e19f,
    compose: $35b547a4c5e704b6$var$compose_,
    id: $35b547a4c5e704b6$export$d560c7e4a29451c2
};
var $35b547a4c5e704b6$export$8c48479322816587 = {
    URI: $35b547a4c5e704b6$export$9156e739aa33e19f,
    literal: $35b547a4c5e704b6$export$c8ec6e1ec9fefcb0,
    string: $35b547a4c5e704b6$export$22b082955e083ec3,
    number: $35b547a4c5e704b6$export$98e628dec113755e,
    boolean: $35b547a4c5e704b6$export$4a21f16c33752377,
    nullable: $35b547a4c5e704b6$export$133fc36489ac9add,
    type: $35b547a4c5e704b6$export$bf9fb029d174d554,
    struct: $35b547a4c5e704b6$export$8cf3da7c1c9174ea,
    partial: $35b547a4c5e704b6$export$e45945969df8035a,
    record: $35b547a4c5e704b6$export$e5185e241753e543,
    array: $35b547a4c5e704b6$export$2f23118c22fb2630,
    tuple: $35b547a4c5e704b6$export$65e3907585753458,
    intersect: $35b547a4c5e704b6$export$1f4807a235930d45,
    sum: $35b547a4c5e704b6$export$8a63f25cc62965f1,
    lazy: $35b547a4c5e704b6$export$488013bae63b21da,
    readonly: $35b547a4c5e704b6$export$6ec456bd5b7b3c51
};
var $35b547a4c5e704b6$export$9fbacd728aa00eea = {
    UnknownArray: $35b547a4c5e704b6$export$837c7bec7087434c,
    UnknownRecord: $35b547a4c5e704b6$export$ecfbd036cf5a99af
};
var $35b547a4c5e704b6$export$70d513615ee15303 = {
    union: $35b547a4c5e704b6$export$971dd5b0dfd021b6
};
var $35b547a4c5e704b6$export$46824d948a594d40 = {
    refine: $35b547a4c5e704b6$export$edc9d475108b3212
};
var $35b547a4c5e704b6$var$empty = [];
var $35b547a4c5e704b6$var$make = function(value, forest) {
    if (forest === void 0) forest = $35b547a4c5e704b6$var$empty;
    return {
        value: value,
        forest: forest
    };
};
var $35b547a4c5e704b6$var$drawTree = function(tree) {
    return tree.value + $35b547a4c5e704b6$var$drawForest('\n', tree.forest);
};
var $35b547a4c5e704b6$var$drawForest = function(indentation, forest) {
    var r = '';
    var len = forest.length;
    var tree;
    for(var i = 0; i < len; i++){
        tree = forest[i];
        var isLast = i === len - 1;
        r += indentation + (isLast ? "\u2514" : "\u251C") + "\u2500 " + tree.value;
        r += $35b547a4c5e704b6$var$drawForest(indentation + (len > 1 && !isLast ? "\u2502  " : '   '), tree.forest);
    }
    return r;
};
var $35b547a4c5e704b6$var$toTree = $4TDwz.fold({
    Leaf: function(input, error) {
        return $35b547a4c5e704b6$var$make("cannot decode ".concat(JSON.stringify(input), ", should be ").concat(error));
    },
    Key: function(key, kind, errors) {
        return $35b547a4c5e704b6$var$make("".concat(kind, " property ").concat(JSON.stringify(key)), $35b547a4c5e704b6$var$toForest(errors));
    },
    Index: function(index, kind, errors) {
        return $35b547a4c5e704b6$var$make("".concat(kind, " index ").concat(index), $35b547a4c5e704b6$var$toForest(errors));
    },
    Member: function(index, errors) {
        return $35b547a4c5e704b6$var$make("member ".concat(index), $35b547a4c5e704b6$var$toForest(errors));
    },
    Lazy: function(id, errors) {
        return $35b547a4c5e704b6$var$make("lazy type ".concat(id), $35b547a4c5e704b6$var$toForest(errors));
    },
    Wrap: function(error, errors) {
        return $35b547a4c5e704b6$var$make(error, $35b547a4c5e704b6$var$toForest(errors));
    }
});
var $35b547a4c5e704b6$var$toForest = function(e) {
    var stack = [];
    var focus = e;
    var res = [];
    // eslint-disable-next-line no-constant-condition
    while(true)switch(focus._tag){
        case 'Of':
            res.push($35b547a4c5e704b6$var$toTree(focus.value));
            var tmp = stack.pop();
            if (tmp === undefined) return res;
            else focus = tmp;
            break;
        case 'Concat':
            stack.push(focus.right);
            focus = focus.left;
            break;
    }
};
var $35b547a4c5e704b6$export$e529deb2bfd496dc = function(e) {
    return $35b547a4c5e704b6$var$toForest(e).map($35b547a4c5e704b6$var$drawTree).join('\n');
};
var $35b547a4c5e704b6$export$fac44ee5b035f737 = /*#__PURE__*/ $7cVq5.fold($35b547a4c5e704b6$export$e529deb2bfd496dc, function(a) {
    return JSON.stringify(a, null, 2);
});

});
parcelRegister("4TDwz", function(module, exports) {

$parcel$export(module.exports, "required", function () { return $390af53200655bd1$export$a7a0278c004aac3f; });
$parcel$export(module.exports, "optional", function () { return $390af53200655bd1$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "leaf", function () { return $390af53200655bd1$export$bf2348675e1fe8e; });
$parcel$export(module.exports, "key", function () { return $390af53200655bd1$export$df61b30b684217c0; });
$parcel$export(module.exports, "index", function () { return $390af53200655bd1$export$b610b8812bbcded9; });
$parcel$export(module.exports, "member", function () { return $390af53200655bd1$export$6a0d13241802fe80; });
$parcel$export(module.exports, "lazy", function () { return $390af53200655bd1$export$488013bae63b21da; });
$parcel$export(module.exports, "wrap", function () { return $390af53200655bd1$export$4997ffc0176396a6; });
$parcel$export(module.exports, "fold", function () { return $390af53200655bd1$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "getSemigroup", function () { return $390af53200655bd1$export$e759a9a7f8d04692; });

var $elkOd = parcelRequire("elkOd");
var $390af53200655bd1$export$a7a0278c004aac3f = 'required';
var $390af53200655bd1$export$516e28dec6a4b6d4 = 'optional';
var $390af53200655bd1$export$bf2348675e1fe8e = function(actual, error) {
    return {
        _tag: 'Leaf',
        actual: actual,
        error: error
    };
};
var $390af53200655bd1$export$df61b30b684217c0 = function(key, kind, errors) {
    return {
        _tag: 'Key',
        key: key,
        kind: kind,
        errors: errors
    };
};
var $390af53200655bd1$export$b610b8812bbcded9 = function(index, kind, errors) {
    return {
        _tag: 'Index',
        index: index,
        kind: kind,
        errors: errors
    };
};
var $390af53200655bd1$export$6a0d13241802fe80 = function(index, errors) {
    return {
        _tag: 'Member',
        index: index,
        errors: errors
    };
};
var $390af53200655bd1$export$488013bae63b21da = function(id, errors) {
    return {
        _tag: 'Lazy',
        id: id,
        errors: errors
    };
};
var $390af53200655bd1$export$4997ffc0176396a6 = function(error, errors) {
    return {
        _tag: 'Wrap',
        error: error,
        errors: errors
    };
};
var $390af53200655bd1$export$93e2b83da34ff82a = function(patterns) {
    var f = function(e) {
        switch(e._tag){
            case 'Leaf':
                return patterns.Leaf(e.actual, e.error);
            case 'Key':
                return patterns.Key(e.key, e.kind, e.errors);
            case 'Index':
                return patterns.Index(e.index, e.kind, e.errors);
            case 'Member':
                return patterns.Member(e.index, e.errors);
            case 'Lazy':
                return patterns.Lazy(e.id, e.errors);
            case 'Wrap':
                return patterns.Wrap(e.error, e.errors);
        }
    };
    return f;
};
function $390af53200655bd1$export$e759a9a7f8d04692() {
    return $elkOd.getSemigroup();
}

});
parcelRegister("elkOd", function(module, exports) {

$parcel$export(module.exports, "of", function () { return $a7132b1795fecb37$export$ba255e9e49e00608; });
$parcel$export(module.exports, "concat", function () { return $a7132b1795fecb37$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "getSemigroup", function () { return $a7132b1795fecb37$export$e759a9a7f8d04692; });
/**
 * @category constructors
 * @since 2.2.7
 */ var $a7132b1795fecb37$export$ba255e9e49e00608 = function(a) {
    return {
        _tag: 'Of',
        value: a
    };
};
var $a7132b1795fecb37$export$ee1b3e54f0441b22 = function(left, right) {
    return {
        _tag: 'Concat',
        left: left,
        right: right
    };
};
var $a7132b1795fecb37$export$93e2b83da34ff82a = function(onOf, onConcat) {
    return function(f) {
        switch(f._tag){
            case 'Of':
                return onOf(f.value);
            case 'Concat':
                return onConcat(f.left, f.right);
        }
    };
};
function $a7132b1795fecb37$export$e759a9a7f8d04692() {
    return {
        concat: $a7132b1795fecb37$export$ee1b3e54f0441b22
    };
}

});


parcelRegister("5ZMdr", function(module, exports) {

$parcel$export(module.exports, "literal", function () { return $45d80ce73ce996f4$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "string", function () { return $45d80ce73ce996f4$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $45d80ce73ce996f4$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $45d80ce73ce996f4$export$4a21f16c33752377; });
$parcel$export(module.exports, "UnknownArray", function () { return $45d80ce73ce996f4$export$837c7bec7087434c; });
$parcel$export(module.exports, "UnknownRecord", function () { return $45d80ce73ce996f4$export$ecfbd036cf5a99af; });
$parcel$export(module.exports, "refine", function () { return $45d80ce73ce996f4$export$edc9d475108b3212; });
$parcel$export(module.exports, "nullable", function () { return $45d80ce73ce996f4$export$133fc36489ac9add; });
$parcel$export(module.exports, "struct", function () { return $45d80ce73ce996f4$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "type", function () { return $45d80ce73ce996f4$export$bf9fb029d174d554; });
$parcel$export(module.exports, "partial", function () { return $45d80ce73ce996f4$export$e45945969df8035a; });
$parcel$export(module.exports, "array", function () { return $45d80ce73ce996f4$export$2f23118c22fb2630; });
$parcel$export(module.exports, "record", function () { return $45d80ce73ce996f4$export$e5185e241753e543; });
$parcel$export(module.exports, "tuple", function () { return $45d80ce73ce996f4$export$65e3907585753458; });
$parcel$export(module.exports, "intersect", function () { return $45d80ce73ce996f4$export$1f4807a235930d45; });
$parcel$export(module.exports, "union", function () { return $45d80ce73ce996f4$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "sum", function () { return $45d80ce73ce996f4$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "lazy", function () { return $45d80ce73ce996f4$export$488013bae63b21da; });
$parcel$export(module.exports, "readonly", function () { return $45d80ce73ce996f4$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "alt", function () { return $45d80ce73ce996f4$export$228be17d80722ab; });
$parcel$export(module.exports, "zero", function () { return $45d80ce73ce996f4$export$7f9972325ebfd559; });
$parcel$export(module.exports, "compose", function () { return $45d80ce73ce996f4$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "id", function () { return $45d80ce73ce996f4$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "URI", function () { return $45d80ce73ce996f4$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Schemable", function () { return $45d80ce73ce996f4$export$8c48479322816587; });
$parcel$export(module.exports, "WithUnknownContainers", function () { return $45d80ce73ce996f4$export$9fbacd728aa00eea; });
$parcel$export(module.exports, "WithUnion", function () { return $45d80ce73ce996f4$export$70d513615ee15303; });
$parcel$export(module.exports, "WithRefine", function () { return $45d80ce73ce996f4$export$46824d948a594d40; });
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community, see these tracking
 * [issues](https://github.com/gcanti/io-ts/issues?q=label%3Av2.2+) for further discussions and enhancements.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.2.0
 */ 
var $f5id0 = parcelRequire("f5id0");

var $4CZFO = parcelRequire("4CZFO");

var $3cvts = parcelRequire("3cvts");
var $45d80ce73ce996f4$export$c8ec6e1ec9fefcb0 = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return {
        is: function(u) {
            return values.findIndex(function(a) {
                return a === u;
            }) !== -1;
        }
    };
};
var $45d80ce73ce996f4$export$22b082955e083ec3 = {
    is: function(u) {
        return typeof u === 'string';
    }
};
var $45d80ce73ce996f4$export$98e628dec113755e = {
    is: function(u) {
        return typeof u === 'number' && !isNaN(u);
    }
};
var $45d80ce73ce996f4$export$4a21f16c33752377 = {
    is: function(u) {
        return typeof u === 'boolean';
    }
};
var $45d80ce73ce996f4$export$837c7bec7087434c = {
    is: Array.isArray
};
var $45d80ce73ce996f4$export$ecfbd036cf5a99af = {
    is: function(u) {
        return u !== null && typeof u === 'object' && !Array.isArray(u);
    }
};
var $45d80ce73ce996f4$export$edc9d475108b3212 = function(refinement) {
    return function(from) {
        return {
            is: function(i) {
                return from.is(i) && refinement(i);
            }
        };
    };
};
var $45d80ce73ce996f4$export$133fc36489ac9add = function(or) {
    return {
        is: function(i) {
            return i === null || or.is(i);
        }
    };
};
var $45d80ce73ce996f4$export$8cf3da7c1c9174ea = function(properties) {
    return (0, $4CZFO.pipe)($45d80ce73ce996f4$export$ecfbd036cf5a99af, $45d80ce73ce996f4$export$edc9d475108b3212(function(r) {
        for(var k in properties){
            if (!(k in r) || !properties[k].is(r[k])) return false;
        }
        return true;
    }));
};
var $45d80ce73ce996f4$export$bf9fb029d174d554 = $45d80ce73ce996f4$export$8cf3da7c1c9174ea;
var $45d80ce73ce996f4$export$e45945969df8035a = function(properties) {
    return (0, $4CZFO.pipe)($45d80ce73ce996f4$export$ecfbd036cf5a99af, $45d80ce73ce996f4$export$edc9d475108b3212(function(r) {
        for(var k in properties){
            var v = r[k];
            if (v !== undefined && !properties[k].is(v)) return false;
        }
        return true;
    }));
};
var $45d80ce73ce996f4$export$2f23118c22fb2630 = function(item) {
    return (0, $4CZFO.pipe)($45d80ce73ce996f4$export$837c7bec7087434c, $45d80ce73ce996f4$export$edc9d475108b3212(function(us) {
        return us.every(item.is);
    }));
};
var $45d80ce73ce996f4$export$e5185e241753e543 = function(codomain) {
    return (0, $4CZFO.pipe)($45d80ce73ce996f4$export$ecfbd036cf5a99af, $45d80ce73ce996f4$export$edc9d475108b3212(function(r) {
        for(var k in r){
            if (!codomain.is(r[k])) return false;
        }
        return true;
    }));
};
var $45d80ce73ce996f4$export$65e3907585753458 = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return {
        is: function(u) {
            return Array.isArray(u) && u.length === components.length && components.every(function(c, i) {
                return c.is(u[i]);
            });
        }
    };
};
var $45d80ce73ce996f4$export$1f4807a235930d45 = function(right) {
    return function(left) {
        return {
            is: function(u) {
                return left.is(u) && right.is(u);
            }
        };
    };
};
var $45d80ce73ce996f4$export$971dd5b0dfd021b6 = function() {
    var members = [];
    for(var _i = 0; _i < arguments.length; _i++)members[_i] = arguments[_i];
    return {
        is: function(u) {
            return members.some(function(m) {
                return m.is(u);
            });
        }
    };
};
var $45d80ce73ce996f4$export$8a63f25cc62965f1 = function(tag) {
    return function(members) {
        return (0, $4CZFO.pipe)($45d80ce73ce996f4$export$ecfbd036cf5a99af, $45d80ce73ce996f4$export$edc9d475108b3212(function(r) {
            var v = r[tag];
            if (v in members) return members[v].is(r);
            return false;
        }));
    };
};
var $45d80ce73ce996f4$export$488013bae63b21da = function(f) {
    var get = $3cvts.memoize(f);
    return {
        is: function(u) {
            return get().is(u);
        }
    };
};
var $45d80ce73ce996f4$export$6ec456bd5b7b3c51 = (0, $f5id0.identity);
var $45d80ce73ce996f4$export$228be17d80722ab = function(that) {
    return function(me) {
        return {
            is: function(i) {
                return me.is(i) || that().is(i);
            }
        };
    };
};
var $45d80ce73ce996f4$export$7f9972325ebfd559 = function() {
    return {
        is: function(_) {
            return false;
        }
    };
};
var $45d80ce73ce996f4$export$f672e0b6f7222cd7 = function(to) {
    return function(from) {
        return {
            is: function(i) {
                return from.is(i) && to.is(i);
            }
        };
    };
};
var $45d80ce73ce996f4$export$d560c7e4a29451c2 = function() {
    return {
        is: function(_) {
            return true;
        }
    };
};
var $45d80ce73ce996f4$export$9156e739aa33e19f = 'io-ts/Guard';
var $45d80ce73ce996f4$export$8c48479322816587 = {
    URI: $45d80ce73ce996f4$export$9156e739aa33e19f,
    literal: $45d80ce73ce996f4$export$c8ec6e1ec9fefcb0,
    string: $45d80ce73ce996f4$export$22b082955e083ec3,
    number: $45d80ce73ce996f4$export$98e628dec113755e,
    boolean: $45d80ce73ce996f4$export$4a21f16c33752377,
    nullable: $45d80ce73ce996f4$export$133fc36489ac9add,
    type: $45d80ce73ce996f4$export$bf9fb029d174d554,
    struct: $45d80ce73ce996f4$export$8cf3da7c1c9174ea,
    partial: $45d80ce73ce996f4$export$e45945969df8035a,
    record: $45d80ce73ce996f4$export$e5185e241753e543,
    array: $45d80ce73ce996f4$export$2f23118c22fb2630,
    tuple: $45d80ce73ce996f4$export$65e3907585753458,
    intersect: $45d80ce73ce996f4$export$1f4807a235930d45,
    sum: $45d80ce73ce996f4$export$8a63f25cc62965f1,
    lazy: function(_, f) {
        return $45d80ce73ce996f4$export$488013bae63b21da(f);
    },
    readonly: $45d80ce73ce996f4$export$6ec456bd5b7b3c51
};
var $45d80ce73ce996f4$export$9fbacd728aa00eea = {
    UnknownArray: $45d80ce73ce996f4$export$837c7bec7087434c,
    UnknownRecord: $45d80ce73ce996f4$export$ecfbd036cf5a99af
};
var $45d80ce73ce996f4$export$70d513615ee15303 = {
    union: $45d80ce73ce996f4$export$971dd5b0dfd021b6
};
var $45d80ce73ce996f4$export$46824d948a594d40 = {
    refine: $45d80ce73ce996f4$export$edc9d475108b3212
};

});
parcelRegister("3cvts", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $254ae82b1aed7a4c$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "intersect_", function () { return $254ae82b1aed7a4c$export$79215695652d139b; });
/**
 * @since 2.2.0
 */ function $254ae82b1aed7a4c$export$fc10aeed3a532e2a(f) {
    var cache = new Map();
    return function(a) {
        if (!cache.has(a)) {
            var b = f(a);
            cache.set(a, b);
            return b;
        }
        return cache.get(a);
    };
}
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
var $254ae82b1aed7a4c$var$typeOf = function(x) {
    return x === null ? 'null' : typeof x;
};
var $254ae82b1aed7a4c$export$79215695652d139b = function(a, b) {
    if (a !== undefined && b !== undefined) {
        var tx = $254ae82b1aed7a4c$var$typeOf(a);
        var ty = $254ae82b1aed7a4c$var$typeOf(b);
        if (tx === 'object' || ty === 'object') return Object.assign({}, a, b);
    }
    return b;
};

});


parcelRegister("9N4mM", function(module, exports) {

$parcel$export(module.exports, "fromRefinement", function () { return $720c13baf724e755$export$675cdb7790c17869; });
$parcel$export(module.exports, "literal", function () { return $720c13baf724e755$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "mapLeftWithInput", function () { return $720c13baf724e755$export$18b028d1bd14e25c; });
$parcel$export(module.exports, "refine", function () { return $720c13baf724e755$export$edc9d475108b3212; });
$parcel$export(module.exports, "compose", function () { return $720c13baf724e755$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "parse", function () { return $720c13baf724e755$export$98e6a39c04603d36; });
$parcel$export(module.exports, "nullable", function () { return $720c13baf724e755$export$133fc36489ac9add; });
$parcel$export(module.exports, "fromStruct", function () { return $720c13baf724e755$export$34355cbaba607122; });
$parcel$export(module.exports, "fromPartial", function () { return $720c13baf724e755$export$fb157a05f56ae99a; });
$parcel$export(module.exports, "fromArray", function () { return $720c13baf724e755$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "fromRecord", function () { return $720c13baf724e755$export$6c8271f68d66a228; });
$parcel$export(module.exports, "fromTuple", function () { return $720c13baf724e755$export$54e67896484d10fe; });
$parcel$export(module.exports, "union", function () { return $720c13baf724e755$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersect", function () { return $720c13baf724e755$export$1f4807a235930d45; });
$parcel$export(module.exports, "fromSum", function () { return $720c13baf724e755$export$bf197727082b6243; });
$parcel$export(module.exports, "lazy", function () { return $720c13baf724e755$export$488013bae63b21da; });
$parcel$export(module.exports, "id", function () { return $720c13baf724e755$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "map", function () { return $720c13baf724e755$export$871de8747c9eaa88; });
$parcel$export(module.exports, "alt", function () { return $720c13baf724e755$export$228be17d80722ab; });

var $7cVq5 = parcelRequire("7cVq5");

var $5ZMdr = parcelRequire("5ZMdr");

var $3cvts = parcelRequire("3cvts");
function $720c13baf724e755$export$675cdb7790c17869(M) {
    return function(refinement, onError) {
        return {
            decode: function(i) {
                return refinement(i) ? M.of(i) : M.throwError(onError(i));
            }
        };
    };
}
function $720c13baf724e755$export$c8ec6e1ec9fefcb0(M) {
    return function(onError) {
        return function() {
            var values = [];
            for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
            return {
                decode: function(i) {
                    return $5ZMdr.literal.apply($5ZMdr, values).is(i) ? M.of(i) : M.throwError(onError(i, values));
                }
            };
        };
    };
}
function $720c13baf724e755$export$18b028d1bd14e25c(M) {
    return function(f) {
        return function(decoder) {
            return {
                decode: function(i) {
                    return M.mapLeft(decoder.decode(i), function(e) {
                        return f(i, e);
                    });
                }
            };
        };
    };
}
function $720c13baf724e755$export$edc9d475108b3212(M) {
    return function(refinement, onError) {
        return function(from) {
            return $720c13baf724e755$export$f672e0b6f7222cd7(M)($720c13baf724e755$export$675cdb7790c17869(M)(refinement, onError))(from);
        };
    };
}
function $720c13baf724e755$export$98e6a39c04603d36(M) {
    return function(decode) {
        return function(from) {
            return $720c13baf724e755$export$f672e0b6f7222cd7(M)({
                decode: decode
            })(from);
        };
    };
}
function $720c13baf724e755$export$133fc36489ac9add(M) {
    return function(onError) {
        return function(or) {
            return {
                decode: function(i) {
                    return i === null ? M.of(null) : M.bimap(or.decode(i), function(e) {
                        return onError(i, e);
                    }, function(a) {
                        return a;
                    });
                }
            };
        };
    };
}
function $720c13baf724e755$export$34355cbaba607122(M) {
    var traverse = $720c13baf724e755$var$traverseRecordWithIndex(M);
    return function(onPropertyError) {
        return function(properties) {
            return {
                decode: function(i) {
                    return traverse(properties, function(key, decoder) {
                        return M.mapLeft(decoder.decode(i[key]), function(e) {
                            return onPropertyError(key, e);
                        });
                    });
                }
            };
        };
    };
}
var $720c13baf724e755$export$1fc03a2373fc8e75 = $720c13baf724e755$export$34355cbaba607122;
function $720c13baf724e755$export$fb157a05f56ae99a(M) {
    var traverse = $720c13baf724e755$var$traverseRecordWithIndex(M);
    var undefinedProperty = M.of($7cVq5.right(undefined));
    var skipProperty = M.of($7cVq5.left(undefined));
    return function(onPropertyError) {
        return function(properties) {
            return {
                decode: function(i) {
                    return M.map(traverse(properties, function(key, decoder) {
                        var ikey = i[key];
                        if (ikey === undefined) return key in i ? undefinedProperty : skipProperty;
                        return M.bimap(decoder.decode(ikey), function(e) {
                            return onPropertyError(key, e);
                        }, function(a) {
                            return $7cVq5.right(a);
                        });
                    }), $720c13baf724e755$var$compactRecord);
                }
            };
        };
    };
}
function $720c13baf724e755$export$571d59b505e6bb4e(M) {
    var traverse = $720c13baf724e755$var$traverseArrayWithIndex(M);
    return function(onItemError) {
        return function(item) {
            return {
                decode: function(is) {
                    return traverse(is, function(index, i) {
                        return M.mapLeft(item.decode(i), function(e) {
                            return onItemError(index, e);
                        });
                    });
                }
            };
        };
    };
}
function $720c13baf724e755$export$6c8271f68d66a228(M) {
    var traverse = $720c13baf724e755$var$traverseRecordWithIndex(M);
    return function(onKeyError) {
        return function(codomain) {
            return {
                decode: function(ir) {
                    return traverse(ir, function(key, i) {
                        return M.mapLeft(codomain.decode(i), function(e) {
                            return onKeyError(key, e);
                        });
                    });
                }
            };
        };
    };
}
function $720c13baf724e755$export$54e67896484d10fe(M) {
    var traverse = $720c13baf724e755$var$traverseArrayWithIndex(M);
    return function(onIndexError) {
        return function() {
            var components = [];
            for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
            return {
                decode: function(is) {
                    return traverse(components, function(index, decoder) {
                        return M.mapLeft(decoder.decode(is[index]), function(e) {
                            return onIndexError(index, e);
                        });
                    });
                }
            };
        };
    };
}
function $720c13baf724e755$export$971dd5b0dfd021b6(M) {
    return function(onMemberError) {
        return function() {
            var members = [];
            for(var _i = 0; _i < arguments.length; _i++)members[_i] = arguments[_i];
            return {
                decode: function(i) {
                    var out = M.mapLeft(members[0].decode(i), function(e) {
                        return onMemberError(0, e);
                    });
                    var _loop_1 = function(index) {
                        out = M.alt(out, function() {
                            return M.mapLeft(members[index].decode(i), function(e) {
                                return onMemberError(index, e);
                            });
                        });
                    };
                    for(var index = 1; index < members.length; index++)_loop_1(index);
                    return out;
                }
            };
        };
    };
}
function $720c13baf724e755$export$1f4807a235930d45(M) {
    return function(right) {
        return function(left) {
            return {
                decode: function(i) {
                    return M.ap(M.map(left.decode(i), function(a) {
                        return function(b) {
                            return $3cvts.intersect_(a, b);
                        };
                    }), right.decode(i));
                }
            };
        };
    };
}
function $720c13baf724e755$export$bf197727082b6243(M) {
    return function(onTagError) {
        return function(tag) {
            return function(members) {
                var keys = Object.keys(members);
                return {
                    decode: function(ir) {
                        var v = ir[tag];
                        if (Object.prototype.hasOwnProperty.call(members, v)) return members[v].decode(ir);
                        return M.throwError(onTagError(tag, v, keys));
                    }
                };
            };
        };
    };
}
function $720c13baf724e755$export$488013bae63b21da(M) {
    return function(onError) {
        return function(id, f) {
            var get = $3cvts.memoize(f);
            return {
                decode: function(u) {
                    return M.mapLeft(get().decode(u), function(e) {
                        return onError(id, e);
                    });
                }
            };
        };
    };
}
function $720c13baf724e755$export$f672e0b6f7222cd7(M) {
    return function(ab) {
        return function(ia) {
            return {
                decode: function(i) {
                    return M.chain(ia.decode(i), ab.decode);
                }
            };
        };
    };
}
function $720c13baf724e755$export$d560c7e4a29451c2(M) {
    return function() {
        return {
            decode: M.of
        };
    };
}
function $720c13baf724e755$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(ia) {
            return {
                decode: function(i) {
                    return F.map(ia.decode(i), f);
                }
            };
        };
    };
}
function $720c13baf724e755$export$228be17d80722ab(A) {
    return function(that) {
        return function(me) {
            return {
                decode: function(i) {
                    return A.alt(me.decode(i), function() {
                        return that().decode(i);
                    });
                }
            };
        };
    };
}
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
var $720c13baf724e755$var$traverseArrayWithIndex = function(M) {
    return function(as, f) {
        return as.reduce(function(mbs, a, i) {
            return M.ap(M.map(mbs, function(bs) {
                return function(b) {
                    bs.push(b);
                    return bs;
                };
            }), f(i, a));
        }, M.of([]));
    };
};
var $720c13baf724e755$var$traverseRecordWithIndex = function(M) {
    return function(r, f) {
        var ks = Object.keys(r);
        if (ks.length === 0) return M.of({});
        var fr = M.of({});
        var _loop_2 = function(key) {
            fr = M.ap(M.map(fr, function(r) {
                return function(b) {
                    r[key] = b;
                    return r;
                };
            }), f(key, r[key]));
        };
        for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
            var key = ks_1[_i];
            _loop_2(key);
        }
        return fr;
    };
};
var $720c13baf724e755$var$compactRecord = function(r) {
    var out = {};
    for(var k in r){
        var rk = r[k];
        if ($7cVq5.isRight(rk)) out[k] = rk.right;
    }
    return out;
};

});


parcelRegister("d9q5l", function(module, exports) {

$parcel$export(module.exports, "nullable", function () { return $9930599bb3fd70e6$export$133fc36489ac9add; });
$parcel$export(module.exports, "struct", function () { return $9930599bb3fd70e6$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "type", function () { return $9930599bb3fd70e6$export$bf9fb029d174d554; });
$parcel$export(module.exports, "partial", function () { return $9930599bb3fd70e6$export$e45945969df8035a; });
$parcel$export(module.exports, "record", function () { return $9930599bb3fd70e6$export$e5185e241753e543; });
$parcel$export(module.exports, "array", function () { return $9930599bb3fd70e6$export$2f23118c22fb2630; });
$parcel$export(module.exports, "tuple", function () { return $9930599bb3fd70e6$export$65e3907585753458; });
$parcel$export(module.exports, "intersect", function () { return $9930599bb3fd70e6$export$1f4807a235930d45; });
$parcel$export(module.exports, "sum", function () { return $9930599bb3fd70e6$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "lazy", function () { return $9930599bb3fd70e6$export$488013bae63b21da; });
$parcel$export(module.exports, "readonly", function () { return $9930599bb3fd70e6$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "contramap", function () { return $9930599bb3fd70e6$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "compose", function () { return $9930599bb3fd70e6$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "id", function () { return $9930599bb3fd70e6$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "URI", function () { return $9930599bb3fd70e6$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Contravariant", function () { return $9930599bb3fd70e6$export$def901a57d5539c3; });
$parcel$export(module.exports, "Category", function () { return $9930599bb3fd70e6$export$3a8840c5b2ecf003; });

var $f5id0 = parcelRequire("f5id0");

var $3cvts = parcelRequire("3cvts");
function $9930599bb3fd70e6$export$133fc36489ac9add(or) {
    return {
        encode: function(a) {
            return a === null ? null : or.encode(a);
        }
    };
}
function $9930599bb3fd70e6$export$8cf3da7c1c9174ea(properties) {
    return {
        encode: function(a) {
            var o = {};
            for(var k in properties)o[k] = properties[k].encode(a[k]);
            return o;
        }
    };
}
var $9930599bb3fd70e6$export$bf9fb029d174d554 = $9930599bb3fd70e6$export$8cf3da7c1c9174ea;
function $9930599bb3fd70e6$export$e45945969df8035a(properties) {
    return {
        encode: function(a) {
            var o = {};
            for(var k in properties){
                var v = a[k];
                // don't add missing properties
                if (k in a) // don't strip undefined properties
                o[k] = v === undefined ? undefined : properties[k].encode(v);
            }
            return o;
        }
    };
}
function $9930599bb3fd70e6$export$e5185e241753e543(codomain) {
    return {
        encode: function(r) {
            var o = {};
            for(var k in r)o[k] = codomain.encode(r[k]);
            return o;
        }
    };
}
function $9930599bb3fd70e6$export$2f23118c22fb2630(item) {
    return {
        encode: function(as) {
            return as.map(item.encode);
        }
    };
}
function $9930599bb3fd70e6$export$65e3907585753458() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return {
        encode: function(as) {
            return components.map(function(c, i) {
                return c.encode(as[i]);
            });
        }
    };
}
var $9930599bb3fd70e6$export$1f4807a235930d45 = function(right) {
    return function(left) {
        return {
            encode: function(ab) {
                return (0, $3cvts.intersect_)(left.encode(ab), right.encode(ab));
            }
        };
    };
};
function $9930599bb3fd70e6$export$8a63f25cc62965f1(tag) {
    return function(members) {
        return {
            encode: function(a) {
                return members[a[tag]].encode(a);
            }
        };
    };
}
function $9930599bb3fd70e6$export$488013bae63b21da(f) {
    var get = (0, $3cvts.memoize)(f);
    return {
        encode: function(a) {
            return get().encode(a);
        }
    };
}
var $9930599bb3fd70e6$export$6ec456bd5b7b3c51 = (0, $f5id0.identity);
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var $9930599bb3fd70e6$var$contramap_ = function(ea, f) {
    return {
        encode: function(b) {
            return ea.encode(f(b));
        }
    };
};
var $9930599bb3fd70e6$var$compose_ = function(ab, ea) {
    return $9930599bb3fd70e6$var$contramap_(ea, ab.encode);
};
var $9930599bb3fd70e6$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $9930599bb3fd70e6$var$contramap_(fa, f);
    };
};
var $9930599bb3fd70e6$export$f672e0b6f7222cd7 = function(ea) {
    return function(ab) {
        return $9930599bb3fd70e6$var$compose_(ab, ea);
    };
};
function $9930599bb3fd70e6$export$d560c7e4a29451c2() {
    return {
        encode: (0, $f5id0.identity)
    };
}
var $9930599bb3fd70e6$export$9156e739aa33e19f = 'io-ts/Encoder';
var $9930599bb3fd70e6$export$def901a57d5539c3 = {
    URI: $9930599bb3fd70e6$export$9156e739aa33e19f,
    contramap: $9930599bb3fd70e6$var$contramap_
};
var $9930599bb3fd70e6$export$3a8840c5b2ecf003 = {
    URI: $9930599bb3fd70e6$export$9156e739aa33e19f,
    compose: $9930599bb3fd70e6$var$compose_,
    id: $9930599bb3fd70e6$export$d560c7e4a29451c2
};

});


parcelRegister("1k68G", function(module, exports) {

$parcel$export(module.exports, "iso", function () { return $0f6c6bd081989891$export$1aba8f741a0eae06; });

var $f5id0 = parcelRequire("f5id0");

var $hVAkz = parcelRequire("hVAkz");

var $8SAMq = parcelRequire("8SAMq");
var $0f6c6bd081989891$export$804fed467fde44e4 = function(S) {
    return S;
};
var $0f6c6bd081989891$export$1af51209b1b91d07 = function(O) {
    return O;
};
var $0f6c6bd081989891$export$e759a9a7f8d04692 = function(S) {
    return S;
};
var $0f6c6bd081989891$export$c2a7ef2cc9b32b31 = function(M) {
    return M;
};
var $0f6c6bd081989891$export$3d48c7fefc7b8ec2 = function(S) {
    return S;
};
var $0f6c6bd081989891$export$575097c1c561f76f = function(R) {
    return R;
};
var $0f6c6bd081989891$export$2c9b3f539cb25b05 = function(F) {
    return F;
};
//
// isos
//
var $0f6c6bd081989891$var$anyIso = /*#__PURE__*/ new (0, $8SAMq.Iso)((0, $f5id0.unsafeCoerce), (0, $f5id0.unsafeCoerce));
function $0f6c6bd081989891$export$1aba8f741a0eae06() {
    return $0f6c6bd081989891$var$anyIso;
}
function $0f6c6bd081989891$export$e469dcfea9910464(predicate) {
    return new (0, $8SAMq.Prism)(function(s) {
        return predicate(s) ? (0, $hVAkz.some)(s) : (0, $hVAkz.none);
    }, (0, $f5id0.identity));
}

});

parcelRegister("1GV7y", function(module, exports) {

$parcel$export(module.exports, "MsDuration", function () { return $ec65e83b75f66adb$export$1b670aa85a2d9176; });
// import type { StringValue } from 'ms'
// import vercelMs from 'ms'

var $10ZIc = parcelRequire("10ZIc");
var $12uqT = parcelRequire("12uqT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $1k68G = parcelRequire("1k68G");
const { wrap: $ec65e83b75f66adb$var$wrap, unwrap: $ec65e83b75f66adb$var$unwrap } = (0, $1k68G.iso)();
const $ec65e83b75f66adb$var$milliseconds = $ec65e83b75f66adb$var$wrap;
const $ec65e83b75f66adb$var$codec = $jPaL5.make((0, $f5id0.pipe)($jPaL5.number, $4BSZX.map($ec65e83b75f66adb$var$wrap)), (0, $f5id0.pipe)($jPaL5.number, $d9q5l.contramap($ec65e83b75f66adb$var$unwrap)));
// const fromStringDecoder = pipe(
//   D.string,
//   D.parse(str =>
//     pipe(
//       fromString(str),
//       either.fromOption(() => D.error(str, 'MsDuration')),
//     ),
//   ),
// )
// const fromString = (str: string): Option<MsDuration> =>
//   pipe(
//     option.tryCatch(() => vercelMs(str as StringValue)),
//     option.filter(predicate.not(isNaN)),
//     option.map(wrap),
//   )
const $ec65e83b75f66adb$var$infinity = $ec65e83b75f66adb$var$milliseconds(Infinity);
const $ec65e83b75f66adb$var$seconds = (n)=>$ec65e83b75f66adb$var$milliseconds(1000 * n);
const $ec65e83b75f66adb$var$minutes = (n)=>$ec65e83b75f66adb$var$seconds(60 * n);
const $ec65e83b75f66adb$var$hours = (n)=>$ec65e83b75f66adb$var$minutes(60 * n);
const $ec65e83b75f66adb$var$days = (n)=>$ec65e83b75f66adb$var$hours(24 * n);
const $ec65e83b75f66adb$var$fromDate = (date)=>$ec65e83b75f66adb$var$milliseconds(date.getTime());
const $ec65e83b75f66adb$var$add = (b)=>(a)=>$ec65e83b75f66adb$var$milliseconds($ec65e83b75f66adb$var$unwrap(a) + $ec65e83b75f66adb$var$unwrap(b));
const $ec65e83b75f66adb$var$Ord = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap($ec65e83b75f66adb$var$unwrap));
const $ec65e83b75f66adb$export$1b670aa85a2d9176 = {
    codec: $ec65e83b75f66adb$var$codec,
    infinity: // fromStringDecoder,
    // fromString,
    $ec65e83b75f66adb$var$infinity,
    millisecond: $ec65e83b75f66adb$var$milliseconds,
    milliseconds: $ec65e83b75f66adb$var$milliseconds,
    unwrap: $ec65e83b75f66adb$var$unwrap,
    seconds: $ec65e83b75f66adb$var$seconds,
    second: $ec65e83b75f66adb$var$seconds,
    minutes: $ec65e83b75f66adb$var$minutes,
    minute: $ec65e83b75f66adb$var$minutes,
    hours: $ec65e83b75f66adb$var$hours,
    hour: $ec65e83b75f66adb$var$hours,
    days: $ec65e83b75f66adb$var$days,
    day: $ec65e83b75f66adb$var$days,
    fromDate: $ec65e83b75f66adb$var$fromDate,
    add: $ec65e83b75f66adb$var$add,
    Ord: $ec65e83b75f66adb$var$Ord
};

});


parcelRegister("hHBpg", function(module, exports) {

$parcel$export(module.exports, "decodeError", function () { return $406da2160226ab56$export$449744f9c2a1ef0d; });
$parcel$export(module.exports, "fromNewtype", function () { return $406da2160226ab56$export$5ee9f719c2ac1d11; });
$parcel$export(module.exports, "NonEmptyString", function () { return $406da2160226ab56$export$5e0a9ee3d3833c14; });
$parcel$export(module.exports, "DayJsFromISOString", function () { return $406da2160226ab56$export$4ad1d7c17da58c9f; });
$parcel$export(module.exports, "URLFromString", function () { return $406da2160226ab56$export$9e15310cd81d7993; });
$parcel$export(module.exports, "BooleanFromString", function () { return $406da2160226ab56$export$92cd16fb2cb73b9e; });
$parcel$export(module.exports, "NumberFromString", function () { return $406da2160226ab56$export$bc32a0669f971f2e; });
$parcel$export(module.exports, "SetFromString", function () { return $406da2160226ab56$export$b54a41b1bfb1de0e; });
$parcel$export(module.exports, "StrictPartial", function () { return $406da2160226ab56$export$436dcbd2431a511d; });
$parcel$export(module.exports, "MapFromArray", function () { return $406da2160226ab56$export$af572413ef85051; });

var $aUw4I = parcelRequire("aUw4I");
var $IYheM = parcelRequire("IYheM");
var $4CDo2 = parcelRequire("4CDo2");
var $3JkJJ = parcelRequire("3JkJJ");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $kXnAC = parcelRequire("kXnAC");

var $895LH = parcelRequire("895LH");

var $cWphj = parcelRequire("cWphj");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");
const $406da2160226ab56$var$limit = 10000;
const $406da2160226ab56$export$528aa702d7f7420 = (name)=>(value)=>(error)=>(0, $dOJeV.StringUtils).stripMargins(`Couldn't decode ${name}:
      |Error:
      |${(0, $f5id0.pipe)($4BSZX.draw(error), (0, $dOJeV.StringUtils).ellipse($406da2160226ab56$var$limit))}
      |
      |Value: ${(0, $f5id0.pipe)((0, $aUw4I).stringify(value), (0, $sjwE0.Either).getOrElse(()=>`${value}`), (0, $dOJeV.StringUtils).ellipse($406da2160226ab56$var$limit))}`);
const $406da2160226ab56$export$449744f9c2a1ef0d = (name)=>(value)=>(error)=>Error($406da2160226ab56$export$528aa702d7f7420(name)(value)(error));
const $406da2160226ab56$export$5ee9f719c2ac1d11 = (codec)=>codec;
/**
 * NonEmptyString
 */ const $406da2160226ab56$var$nonEmptyStringDecoder = (0, $f5id0.pipe)($4BSZX.string, $4BSZX.refine((str)=>!(0, $68YxT).isEmpty(str), 'NonEmptyString'));
const $406da2160226ab56$var$nonEmptyStringEncoder = $d9q5l.id();
const $406da2160226ab56$var$nonEmptyStringCodec = $jPaL5.make($406da2160226ab56$var$nonEmptyStringDecoder, $406da2160226ab56$var$nonEmptyStringEncoder);
const $406da2160226ab56$export$5e0a9ee3d3833c14 = {
    decoder: $406da2160226ab56$var$nonEmptyStringDecoder,
    encoder: $406da2160226ab56$var$nonEmptyStringEncoder,
    codec: $406da2160226ab56$var$nonEmptyStringCodec
};
/**
 * DayJsFromISOString
 */ const $406da2160226ab56$var$dayJsFromISOStringDecoder = (0, $f5id0.pipe)($4BSZX.string, $4BSZX.parse((str)=>{
    const d = (0, $kXnAC.DayJs).of(str);
    return (0, $kXnAC.DayJs).isValid(d) ? $4BSZX.success(d) : $4BSZX.failure(str, 'DayJsFromISOString');
}));
const $406da2160226ab56$var$dayJsFromISOStringEncoder = {
    encode: (0, $kXnAC.DayJs).toISOString
};
const $406da2160226ab56$var$dayJsFromISOStringCodec = $jPaL5.make($406da2160226ab56$var$dayJsFromISOStringDecoder, $406da2160226ab56$var$dayJsFromISOStringEncoder);
const $406da2160226ab56$export$4ad1d7c17da58c9f = {
    decoder: $406da2160226ab56$var$dayJsFromISOStringDecoder,
    encoder: $406da2160226ab56$var$dayJsFromISOStringEncoder,
    codec: $406da2160226ab56$var$dayJsFromISOStringCodec
};
/**
 * URLFromString
 */ const $406da2160226ab56$var$urlFromStringDecoder = (0, $f5id0.pipe)($4BSZX.string, $4BSZX.parse((s)=>(0, $f5id0.pipe)((0, $sjwE0.Maybe).tryCatch(()=>new URL(s)), (0, $sjwE0.Maybe).fold(()=>$4BSZX.failure(s, 'URLFromString'), $4BSZX.success))));
const $406da2160226ab56$export$9e15310cd81d7993 = {
    decoder: $406da2160226ab56$var$urlFromStringDecoder
};
/**
 * BooleanFromString
 */ const $406da2160226ab56$var$booleanFromStringDecoder = (0, $f5id0.pipe)($4BSZX.string, $4BSZX.parse((s)=>s === 'true' ? $4BSZX.success(true) : s === 'false' ? $4BSZX.success(false) : $4BSZX.failure(s, 'BooleanFromString')));
const $406da2160226ab56$export$92cd16fb2cb73b9e = {
    decoder: $406da2160226ab56$var$booleanFromStringDecoder
};
/**
 * NumberFromString
 */ const $406da2160226ab56$var$numberFromStringDecoder = (0, $f5id0.pipe)($4BSZX.string, $4BSZX.parse((s)=>{
    const n = Number(s);
    return isNaN(n) ? $4BSZX.failure(s, 'NumberFromString') : $4BSZX.success(n);
}));
const $406da2160226ab56$var$numberFromStringEncoder = (0, $f5id0.pipe)($d9q5l.id(), $d9q5l.contramap(String));
const $406da2160226ab56$var$numberFromStringCodec = $jPaL5.make($406da2160226ab56$var$numberFromStringDecoder, $406da2160226ab56$var$numberFromStringEncoder);
const $406da2160226ab56$export$bc32a0669f971f2e = {
    decoder: $406da2160226ab56$var$numberFromStringDecoder,
    encoder: $406da2160226ab56$var$numberFromStringEncoder,
    codec: $406da2160226ab56$var$numberFromStringCodec
};
/**
 * ArrayFromString
 */ const $406da2160226ab56$var$prepareArray = (separator)=>(0, $f5id0.flow)((0, $68YxT).split(separator), (0, $sjwE0.NonEmptyArray).map((0, $68YxT).trim), (0, $sjwE0.List).filter((0, $IYheM).not((0, $68YxT).isEmpty)));
const $406da2160226ab56$var$arrayFromStringDecoder = (separator)=>(decoder)=>(0, $f5id0.pipe)($4BSZX.string, $4BSZX.map($406da2160226ab56$var$prepareArray(separator)), $4BSZX.compose((0, $sjwE0.List).decoder(decoder)));
const $406da2160226ab56$var$arrayFromStringEncoder = (separator)=>(encoder)=>({
            encode: (0, $f5id0.flow)((0, $sjwE0.List).map(encoder.encode), (0, $sjwE0.List).mkString(separator))
        });
const $406da2160226ab56$var$arrayFromStringCodec = (separator)=>(codec)=>$jPaL5.make($406da2160226ab56$var$arrayFromStringDecoder(separator)(codec), $406da2160226ab56$var$arrayFromStringEncoder(separator)(codec));
const $406da2160226ab56$export$74c6dc94601093e1 = {
    decoder: $406da2160226ab56$var$arrayFromStringDecoder,
    encoder: $406da2160226ab56$var$arrayFromStringEncoder,
    codec: $406da2160226ab56$var$arrayFromStringCodec
};
/**
 * SetFromString
 */ const $406da2160226ab56$var$setFromStringDecoder = (separator)=>(decoder, eq_)=>(0, $f5id0.pipe)($406da2160226ab56$var$arrayFromStringDecoder(separator)(decoder), $4BSZX.map((0, $3JkJJ).fromReadonlyArray(eq_)));
const $406da2160226ab56$var$setFromStringEncoder = (separator)=>(ord)=>(encoder)=>(0, $f5id0.pipe)($406da2160226ab56$var$arrayFromStringEncoder(separator)(encoder), $d9q5l.contramap((0, $3JkJJ).toReadonlyArray(ord)));
const $406da2160226ab56$var$setFromStringCodec = (separator)=>(codec, ord)=>$jPaL5.make($406da2160226ab56$var$setFromStringDecoder(separator)(codec, ord), $406da2160226ab56$var$setFromStringEncoder(separator)(ord)(codec));
const $406da2160226ab56$export$b54a41b1bfb1de0e = {
    decoder: $406da2160226ab56$var$setFromStringDecoder,
    encoder: $406da2160226ab56$var$setFromStringEncoder,
    codec: $406da2160226ab56$var$setFromStringCodec
};
/**
 * NonEmptyArrayFromString
 */ const $406da2160226ab56$var$nonEmptyArrayFromStringDecoder = (separator)=>(decoder)=>(0, $f5id0.pipe)($4BSZX.string, $4BSZX.map($406da2160226ab56$var$prepareArray(separator)), $4BSZX.compose((0, $sjwE0.NonEmptyArray).decoder(decoder)));
const $406da2160226ab56$export$31b3d0b5e9317fb7 = {
    decoder: $406da2160226ab56$var$nonEmptyArrayFromStringDecoder
};
/**
 * StrictStruct
 */ const $406da2160226ab56$var$strictStructDecoder = (properties)=>(0, $f5id0.pipe)($4BSZX.UnknownRecord, $4BSZX.parse((pjo)=>(0, $f5id0.pipe)($4BSZX.fromStruct(properties), $4BSZX.parse((res)=>{
            const diff = (0, $f5id0.pipe)((0, $895LH.DictUtils).keys(pjo), (0, $sjwE0.List).difference((0, $68YxT).Eq)((0, $895LH.DictUtils).keys(res)));
            if ((0, $sjwE0.List).isNonEmpty(diff)) return $4BSZX.failure(pjo, $406da2160226ab56$var$notParsed('StrictStruct', diff));
            return $4BSZX.success(res);
        })).decode(pjo)));
function $406da2160226ab56$var$notParsed(name, diff) {
    return (0, $f5id0.pipe)(diff, (0, $sjwE0.List).map(JSON.stringify), (0, $sjwE0.List).mkString(`${name}<{ notParsed: `, ' | ', ' }>'));
}
const $406da2160226ab56$export$755acf784375ada8 = {
    decoder: $406da2160226ab56$var$strictStructDecoder
};
/**
 * StrictPartial
 */ const $406da2160226ab56$var$strictPartialDecoder = (properties)=>(0, $f5id0.pipe)($4BSZX.UnknownRecord, $4BSZX.parse((pjo)=>(0, $f5id0.pipe)($4BSZX.fromPartial(properties), $4BSZX.parse((res)=>{
            const diff = (0, $f5id0.pipe)((0, $895LH.DictUtils).keys(pjo), (0, $sjwE0.List).difference((0, $68YxT).Eq)((0, $895LH.DictUtils).keys(res)));
            if ((0, $sjwE0.List).isNonEmpty(diff)) return $4BSZX.failure(pjo, $406da2160226ab56$var$notParsed('StrictPartial', diff));
            return $4BSZX.success(res);
        })).decode(pjo)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $406da2160226ab56$var$strictPartialCodec = (properties)=>$jPaL5.make($406da2160226ab56$var$strictPartialDecoder(properties), $d9q5l.partial(properties));
const $406da2160226ab56$export$436dcbd2431a511d = {
    decoder: $406da2160226ab56$var$strictPartialDecoder,
    codec: $406da2160226ab56$var$strictPartialCodec
};
/**
 * StrictTuple
 */ const $406da2160226ab56$var$strictTupleDecoder = (...components)=>(0, $f5id0.pipe)($4BSZX.UnknownArray, $4BSZX.refine($406da2160226ab56$var$refinementFromPredicate((us)=>us.length === components.length), `ArrayOfLength${components.length}`), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $4BSZX.compose($4BSZX.fromTuple(...components)));
const $406da2160226ab56$export$5b6abe6fe632fddd = {
    decoder: $406da2160226ab56$var$strictTupleDecoder
};
const $406da2160226ab56$var$refinementFromPredicate = (0, $f5id0.identity);
/**
 * SetFromArray
 */ const $406da2160226ab56$var$setFromArrayDecoder = (eq)=>(decoder)=>(0, $f5id0.pipe)((0, $sjwE0.List).decoder(decoder), $4BSZX.map((0, $3JkJJ).fromReadonlyArray(eq)));
const $406da2160226ab56$var$setFromArrayEncoder = (encoder)=>(0, $f5id0.pipe)((0, $sjwE0.List).encoder(encoder), $d9q5l.contramap((as)=>[
            ...as
        ]));
const $406da2160226ab56$var$setFromArrayCodec = (eq)=>(codec)=>$jPaL5.make($406da2160226ab56$var$setFromArrayDecoder(eq)(codec), $406da2160226ab56$var$setFromArrayEncoder(codec));
const $406da2160226ab56$export$8d90948fe855fc4d = {
    decoder: $406da2160226ab56$var$setFromArrayDecoder,
    encoder: $406da2160226ab56$var$setFromArrayEncoder,
    codec: $406da2160226ab56$var$setFromArrayCodec
};
/**
 * MapFromArray
 */ const $406da2160226ab56$var$mapFromArrayDecoder = (eq)=>(keyDecoder, valueDecoder)=>(0, $f5id0.pipe)((0, $sjwE0.List).decoder($4BSZX.tuple(keyDecoder, valueDecoder)), $4BSZX.map((0, $cWphj.MapUtils).fromReadonlyArray(eq)));
const $406da2160226ab56$var$mapFromArrayEncoder = (ord)=>(keyEncoder, valueEncoder)=>(0, $f5id0.pipe)((0, $sjwE0.List).encoder($d9q5l.readonly($d9q5l.tuple(keyEncoder, valueEncoder))), $d9q5l.contramap((m)=>(0, $4CDo2).toReadonlyArray(ord)(m)));
const $406da2160226ab56$var$mapFromArrayCodec = (ord)=>(keyCodec, valueCodec)=>$jPaL5.make($406da2160226ab56$var$mapFromArrayDecoder(ord)(keyCodec, valueCodec), $406da2160226ab56$var$mapFromArrayEncoder(ord)(keyCodec, valueCodec));
const $406da2160226ab56$export$af572413ef85051 = {
    decoder: $406da2160226ab56$var$mapFromArrayDecoder,
    encoder: $406da2160226ab56$var$mapFromArrayEncoder,
    codec: $406da2160226ab56$var$mapFromArrayCodec
};

});
parcelRegister("aUw4I", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $7f1803c5aa557539$export$98e6a39c04603d36; });
$parcel$export(module.exports, "stringify", function () { return $7f1803c5aa557539$export$fac44ee5b035f737; });
/**
 * @since 2.10.0
 */ 
var $7cVq5 = parcelRequire("7cVq5");

var $f5id0 = parcelRequire("f5id0");
var $7f1803c5aa557539$export$98e6a39c04603d36 = function(s) {
    return (0, $7cVq5.tryCatch)(function() {
        return JSON.parse(s);
    }, (0, $f5id0.identity));
};
var $7f1803c5aa557539$export$fac44ee5b035f737 = function(a) {
    return (0, $7cVq5.tryCatch)(function() {
        var s = JSON.stringify(a);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, (0, $f5id0.identity));
};

});

parcelRegister("kXnAC", function(module, exports) {

$parcel$export(module.exports, "DayJs", function () { return $30ef5fe1271e2c25$export$e8e34f7172c7371a; });

var $jCgCX = parcelRequire("jCgCX");
parcelRequire("866J8");

var $ejD0p = parcelRequire("ejD0p");

var $2qsnz = parcelRequire("2qsnz");

var $5VMx0 = parcelRequire("5VMx0");

var $4lr6f = parcelRequire("4lr6f");
var $12uqT = parcelRequire("12uqT");

var $f5id0 = parcelRequire("f5id0");

var $1k68G = parcelRequire("1k68G");

var $1GV7y = parcelRequire("1GV7y");
/* eslint-disable functional/no-expression-statements */ (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($ejD0p))));
(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5VMx0))));
(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($2qsnz))));
(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).locale('fr') // TODO: always FR?
;
const { wrap: $30ef5fe1271e2c25$var$wrap, unwrap: $30ef5fe1271e2c25$var$unwrap } = (0, $1k68G.iso)();
const $30ef5fe1271e2c25$var$modify = (0, $f5id0.identity);
function $30ef5fe1271e2c25$var$of(date, format, { locale: locale = false } = {}) {
    return $30ef5fe1271e2c25$var$wrap((locale ? (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))) : (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).utc)(date, format, true));
}
const $30ef5fe1271e2c25$var$now = (0, $f5id0.pipe)((0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).utc, (0, $4lr6f).map($30ef5fe1271e2c25$var$wrap));
// tests
const $30ef5fe1271e2c25$var$isValid = (date)=>$30ef5fe1271e2c25$var$unwrap(date).isValid();
const $30ef5fe1271e2c25$var$isHourSharp = (h)=>(date)=>$30ef5fe1271e2c25$var$hour.get(date) === h && $30ef5fe1271e2c25$var$minute.get(date) === 0;
// modifiers
const $30ef5fe1271e2c25$var$add = (ms)=>$30ef5fe1271e2c25$var$modify((d)=>d.add((0, $1GV7y.MsDuration).unwrap(ms), 'millisecond'));
const $30ef5fe1271e2c25$var$subtract = (ms)=>$30ef5fe1271e2c25$var$modify((d)=>d.subtract((0, $1GV7y.MsDuration).unwrap(ms), 'millisecond'));
const $30ef5fe1271e2c25$var$startOf = (unit)=>$30ef5fe1271e2c25$var$modify((d)=>d.startOf(unit));
const $30ef5fe1271e2c25$var$format = (template, { locale: locale = false } = {})=>(date)=>{
        const unwrapped = $30ef5fe1271e2c25$var$unwrap(date);
        return (locale ? unwrapped.local() : unwrapped).format(template);
    };
const $30ef5fe1271e2c25$var$toDate = (date)=>$30ef5fe1271e2c25$var$unwrap(date).toDate();
const $30ef5fe1271e2c25$var$toISOString = (date)=>$30ef5fe1271e2c25$var$unwrap(date).toISOString();
const $30ef5fe1271e2c25$var$unix = (date)=>$30ef5fe1271e2c25$var$unwrap(date).unix();
const $30ef5fe1271e2c25$var$unixMs = (date)=>(0, $1GV7y.MsDuration).milliseconds($30ef5fe1271e2c25$var$unwrap(date).valueOf());
function $30ef5fe1271e2c25$var$diff(b, unit) {
    return (a)=>unit === undefined ? (0, $1GV7y.MsDuration).milliseconds($30ef5fe1271e2c25$var$unwrap(a).diff($30ef5fe1271e2c25$var$unwrap(b))) : $30ef5fe1271e2c25$var$unwrap(a).diff($30ef5fe1271e2c25$var$unwrap(b), unit);
}
// Ord
const $30ef5fe1271e2c25$var$Ord = (0, $12uqT).fromCompare((first, second)=>{
    const f = $30ef5fe1271e2c25$var$unwrap(first);
    const s = $30ef5fe1271e2c25$var$unwrap(second);
    if (f.isSame(s)) return 0;
    if (f.isBefore(s)) return -1;
    return 1;
});
// Eq
const $30ef5fe1271e2c25$var$Eq = $30ef5fe1271e2c25$var$Ord;
// Lens
const $30ef5fe1271e2c25$var$year = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).year(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.year(n))
};
const $30ef5fe1271e2c25$var$month = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).month(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.month(n))
};
// date of month
const $30ef5fe1271e2c25$var$date = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).date(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.date(n))
};
// day of week
const $30ef5fe1271e2c25$var$day = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).day(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.day(n))
};
const $30ef5fe1271e2c25$var$hour = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).hour(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.hour(n))
};
const $30ef5fe1271e2c25$var$minute = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).minute(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.minute(n))
};
const $30ef5fe1271e2c25$var$second = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).second(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.second(n))
};
const $30ef5fe1271e2c25$var$millisecond = {
    get: (d)=>$30ef5fe1271e2c25$var$unwrap(d).millisecond(),
    set: (n)=>$30ef5fe1271e2c25$var$modify((d)=>d.millisecond(n))
};
const $30ef5fe1271e2c25$export$e8e34f7172c7371a = {
    of: $30ef5fe1271e2c25$var$of,
    now: $30ef5fe1271e2c25$var$now,
    isValid: $30ef5fe1271e2c25$var$isValid,
    isHourSharp: $30ef5fe1271e2c25$var$isHourSharp,
    add: $30ef5fe1271e2c25$var$add,
    subtract: $30ef5fe1271e2c25$var$subtract,
    startOf: $30ef5fe1271e2c25$var$startOf,
    format: $30ef5fe1271e2c25$var$format,
    toDate: $30ef5fe1271e2c25$var$toDate,
    toISOString: $30ef5fe1271e2c25$var$toISOString,
    unix: $30ef5fe1271e2c25$var$unix,
    unixMs: $30ef5fe1271e2c25$var$unixMs,
    diff: $30ef5fe1271e2c25$var$diff,
    unwrap: $30ef5fe1271e2c25$var$unwrap,
    Eq: $30ef5fe1271e2c25$var$Eq,
    Ord: $30ef5fe1271e2c25$var$Ord,
    year: $30ef5fe1271e2c25$var$year,
    month: $30ef5fe1271e2c25$var$month,
    date: $30ef5fe1271e2c25$var$date,
    day: $30ef5fe1271e2c25$var$day,
    hour: $30ef5fe1271e2c25$var$hour,
    minute: $30ef5fe1271e2c25$var$minute,
    second: $30ef5fe1271e2c25$var$second,
    millisecond: $30ef5fe1271e2c25$var$millisecond,
    Duration: {
        formatSeconds: (s)=>(0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).duration(s, 'seconds').format('m:ss')
    }
};

});
parcelRegister("jCgCX", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("866J8", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("jCgCX")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), i = {
        name: "fr",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        ordinal: function(e) {
            return "" + e + (1 === e ? "er" : "");
        }
    };
    return t.default.locale(i, null, !0), i;
});

});

parcelRegister("ejD0p", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("2qsnz", function(module, exports) {
!function(t, s) {
    module.exports = s();
}(module.exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

});

parcelRegister("5VMx0", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});


parcelRegister("895LH", function(module, exports) {

$parcel$export(module.exports, "DictUtils", function () { return $5a7a9b3e47453433$export$df53bd4d4dca8e93; });
const $5a7a9b3e47453433$export$df53bd4d4dca8e93 = {
    entries: Object.entries,
    keys: Object.keys,
    values: Object.values,
    partial: {
        entries: Object.entries,
        values: Object.values
    }
};

});

parcelRegister("cWphj", function(module, exports) {

$parcel$export(module.exports, "MapUtils", function () { return $245446eae9f5a854$export$947bf818db604d74; });

var $4CDo2 = parcelRequire("4CDo2");
var $i0LNv = parcelRequire("i0LNv");

var $sjwE0 = parcelRequire("sjwE0");
const $245446eae9f5a854$var$fromReadonlyArray = (eq)=>(fa)=>(0, $4CDo2).fromFoldable(eq, (0, $i0LNv).last(), (0, $sjwE0.List).Foldable)(fa);
const $245446eae9f5a854$export$947bf818db604d74 = {
    fromReadonlyArray: $245446eae9f5a854$var$fromReadonlyArray
};

});

parcelRegister("dOJeV", function(module, exports) {

$parcel$export(module.exports, "StringUtils", function () { return $4a2e9c875ee76649$export$ecc754f99843e759; });

var $f5id0 = parcelRequire("f5id0");

var $kXnAC = parcelRequire("kXnAC");

var $1GV7y = parcelRequire("1GV7y");

var $sjwE0 = parcelRequire("sjwE0");
const $4a2e9c875ee76649$var$margin = /^\s*\|/gm;
const $4a2e9c875ee76649$var$stripMargins = (str)=>str.replace($4a2e9c875ee76649$var$margin, '');
const $4a2e9c875ee76649$var$ellipse = (take)=>(str)=>take < str.length && 3 <= take ? `${str.slice(0, take - 3)}...` : str;
const $4a2e9c875ee76649$var$matcher = (regex, f)=>(str)=>(0, $f5id0.pipe)(str.match(regex), (0, $sjwE0.Maybe).fromNullable, (0, $sjwE0.Maybe).map(f));
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $4a2e9c875ee76649$var$matcher1 = (regex)=>$4a2e9c875ee76649$var$matcher(regex, ([, a])=>a);
const $4a2e9c875ee76649$var$matcher2 = (regex)=>$4a2e9c875ee76649$var$matcher(regex, ([, a, b])=>[
            a,
            b
        ]);
const $4a2e9c875ee76649$var$matcher3 = (regex)=>$4a2e9c875ee76649$var$matcher(regex, ([, a, b, c])=>[
            a,
            b,
            c
        ]);
const $4a2e9c875ee76649$var$padStart = (maxLength)=>(n)=>`${n}`.padStart(maxLength, '0');
const $4a2e9c875ee76649$var$pad10 = $4a2e9c875ee76649$var$padStart(2);
const $4a2e9c875ee76649$var$pad100 = $4a2e9c875ee76649$var$padStart(3);
const $4a2e9c875ee76649$var$cleanUTF8ToASCII = (str)=>str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $4a2e9c875ee76649$var$whiteSpaces = /\s+/g;
const $4a2e9c875ee76649$var$cleanWhitespaces = (str)=>str.replace($4a2e9c875ee76649$var$whiteSpaces, ' ');
const $4a2e9c875ee76649$var$nonAZ = /[^a-z]/g;
const $4a2e9c875ee76649$var$cleanChampionName = (name)=>$4a2e9c875ee76649$export$ecc754f99843e759.cleanUTF8ToASCII(name).toLowerCase().replaceAll($4a2e9c875ee76649$var$nonAZ, '');
const $4a2e9c875ee76649$var$cleanHtml = (str)=>$4a2e9c875ee76649$var$cleanWhitespaces(str// newline please
    .trim().normalize());
const $4a2e9c875ee76649$var$prettyMs = (ms)=>{
    const date = (0, $kXnAC.DayJs).of((0, $1GV7y.MsDuration).unwrap(ms));
    const zero = (0, $kXnAC.DayJs).of(0);
    const d = (0, $f5id0.pipe)(date, (0, $kXnAC.DayJs).diff(zero, 'days'));
    const h = (0, $kXnAC.DayJs).hour.get(date);
    const m = (0, $kXnAC.DayJs).minute.get(date);
    const s = (0, $kXnAC.DayJs).second.get(date);
    const ms_ = (0, $kXnAC.DayJs).millisecond.get(date);
    if (d !== 0) return `${d}d${$4a2e9c875ee76649$var$pad10(h)}h${$4a2e9c875ee76649$var$pad10(m)}'${$4a2e9c875ee76649$var$pad10(s)}.${$4a2e9c875ee76649$var$pad100(ms_)}"`;
    if (h !== 0) return `${$4a2e9c875ee76649$var$pad10(h)}h${$4a2e9c875ee76649$var$pad10(m)}'${$4a2e9c875ee76649$var$pad10(s)}.${$4a2e9c875ee76649$var$pad100(ms_)}"`;
    if (m !== 0) return `${$4a2e9c875ee76649$var$pad10(m)}'${$4a2e9c875ee76649$var$pad10(s)}.${$4a2e9c875ee76649$var$pad100(ms_)}"`;
    return `${$4a2e9c875ee76649$var$pad10(s)}.${$4a2e9c875ee76649$var$pad100(ms_)}"`;
};
const $4a2e9c875ee76649$var$toLowerCase = (str)=>str.toLowerCase();
const $4a2e9c875ee76649$var$toUpperCase = (str)=>str.toUpperCase();
const $4a2e9c875ee76649$export$ecc754f99843e759 = {
    ellipse: $4a2e9c875ee76649$var$ellipse,
    matcher1: $4a2e9c875ee76649$var$matcher1,
    matcher2: $4a2e9c875ee76649$var$matcher2,
    matcher3: $4a2e9c875ee76649$var$matcher3,
    stripMargins: $4a2e9c875ee76649$var$stripMargins,
    pad10: $4a2e9c875ee76649$var$pad10,
    cleanUTF8ToASCII: $4a2e9c875ee76649$var$cleanUTF8ToASCII,
    cleanChampionName: $4a2e9c875ee76649$var$cleanChampionName,
    cleanHtml: $4a2e9c875ee76649$var$cleanHtml,
    prettyMs: $4a2e9c875ee76649$var$prettyMs,
    toLowerCase: $4a2e9c875ee76649$var$toLowerCase,
    toUpperCase: $4a2e9c875ee76649$var$toUpperCase
};

});


parcelRegister("6H0K7", function(module, exports) {

$parcel$export(module.exports, "StaticDataContextProvider", function () { return $b979803b3c087316$export$33d831eb72d359f8; });
$parcel$export(module.exports, "useStaticData", function () { return $b979803b3c087316$export$221db652f891ae59; });
/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $bh6RR = parcelRequire("bh6RR");

var $k8rBo = parcelRequire("k8rBo");

var $dW1pp = parcelRequire("dW1pp");

var $br0yu = parcelRequire("br0yu");

var $iGStR = parcelRequire("iGStR");

var $aGpBO = parcelRequire("aGpBO");

var $iPRex = parcelRequire("iPRex");

var $sjwE0 = parcelRequire("sjwE0");

var $9g4gL = parcelRequire("9g4gL");

var $7Dhdf = parcelRequire("7Dhdf");

var $31rfl = parcelRequire("31rfl");

var $4MEuc = parcelRequire("4MEuc");
const { ddragonCdn: $b979803b3c087316$var$ddragonCdn } = (0, $aGpBO.DDragonUtils);
const $b979803b3c087316$var$StaticDataContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
const $b979803b3c087316$export$33d831eb72d359f8 = ({ children: children })=>{
    const { lang: lang } = (0, $4MEuc.useTranslation)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
        ...(0, $7Dhdf.useSWRHttp)((0, $k8rBo.apiRoutes).staticData(lang).get, {}, [
            (0, $dW1pp.ValidatedSoft).decoder((0, $iGStR.StaticData).codec, $4BSZX.string),
            'ValidatedSoft<StaticData, string>'
        ], {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }),
        children: (data)=>/*#__PURE__*/ (0, $ih19M.jsx)($b979803b3c087316$var$StaticDataLoaded, {
                data: data,
                children: children
            })
    });
};
const $b979803b3c087316$var$StaticDataLoaded = ({ data: data, children: children })=>{
    const { version: version, champions: champions } = data.value;
    const { showToaster: showToaster } = (0, $31rfl.useToaster)();
    (0, $bh6RR.useEffect)(()=>{
        if ((0, $sjwE0.List).isNonEmpty(data.errors)) {
            console.warn((0, $sjwE0.List).mkString('Static data errors:\n- ', '\n- ', '\n')(data.errors));
            showToaster('warn', 'Static data warning');
        }
    }, [
        data.errors,
        showToaster
    ]);
    const championByKey = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(champions, (0, $iPRex.ListUtils).findFirstBy((0, $br0yu.ChampionKey).Eq)((c)=>c.key)), [
        champions
    ]);
    const value = {
        champions: champions,
        championByKey: championByKey,
        assets: {
            champion: {
                square: (0, $f5id0.flow)(championByKey, (0, $sjwE0.Maybe).map((c)=>c.id), (0, $sjwE0.Maybe).toNullable, (name)=>$b979803b3c087316$var$ddragonCdn(version, `/img/champion/${name}.png`))
            },
            summonerIcon: (iconId)=>$b979803b3c087316$var$ddragonCdn(version, `/img/profileicon/${iconId}.png`),
            summonerSpell: (spellId)=>$b979803b3c087316$var$ddragonCdn(version, `/img/spell/${spellId}.png`),
            item: (itemId)=>$b979803b3c087316$var$ddragonCdn(version, `/img/item/${itemId}.png`)
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($b979803b3c087316$var$StaticDataContext.Provider, {
        value: value,
        children: children
    });
};
const $b979803b3c087316$export$221db652f891ae59 = ()=>{
    const context = (0, $bh6RR.useContext)($b979803b3c087316$var$StaticDataContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useStaticData must be used within a StaticDataContextProvider');
    return context;
};

});
parcelRegister("k8rBo", function(module, exports) {

$parcel$export(module.exports, "apiRoutes", function () { return $9a3cbb0ef185cd19$export$926815f3873d207a; });

var $kwhzj = parcelRequire("kwhzj");
var $c7lJu = parcelRequire("c7lJu");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $iDoEG = parcelRequire("iDoEG");

var $ewM3A = parcelRequire("ewM3A");

var $ebDzf = parcelRequire("ebDzf");

var $gl9GP = parcelRequire("gl9GP");

var $4o3f8 = parcelRequire("4o3f8");

var $fp7Nf = parcelRequire("fp7Nf");

var $fC0sb = parcelRequire("fC0sb");

var $3vjpe = parcelRequire("3vjpe");

var $hHBpg = parcelRequire("hHBpg");
const { codec: $9a3cbb0ef185cd19$var$codec } = (0, $3vjpe.RouterUtils);
/**
 * matches
 */ // intermediate
const $9a3cbb0ef185cd19$var$langM = $9a3cbb0ef185cd19$var$codec('lang', (0, $ewM3A.Lang).codec);
const $9a3cbb0ef185cd19$var$platformM = $9a3cbb0ef185cd19$var$codec('platform', (0, $ebDzf.Platform).codec);
const $9a3cbb0ef185cd19$var$puuidM = $9a3cbb0ef185cd19$var$codec('puuid', (0, $gl9GP.Puuid).codec);
const $9a3cbb0ef185cd19$var$riotIdM = $9a3cbb0ef185cd19$var$codec('gameName', (0, $4o3f8.GameName).codec).then($9a3cbb0ef185cd19$var$codec('tagLine', (0, $fC0sb.TagLine).codec)).imap(({ gameName: gameName, tagLine: tagLine })=>({
        riotId: (0, $fp7Nf.RiotId)(gameName, tagLine)
    }), ({ riotId: riotId })=>riotId);
const $9a3cbb0ef185cd19$var$gameIdM = $9a3cbb0ef185cd19$var$codec('gameId', (0, $f5id0.pipe)((0, $hHBpg.NumberFromString).codec, $jPaL5.compose((0, $iDoEG.GameId).codec)));
const $9a3cbb0ef185cd19$var$api = (0, $kwhzj.lit)('api');
const $9a3cbb0ef185cd19$var$staticDataLang = $9a3cbb0ef185cd19$var$api.then((0, $kwhzj.lit)('staticData')).then($9a3cbb0ef185cd19$var$langM);
const $9a3cbb0ef185cd19$var$summoner = $9a3cbb0ef185cd19$var$api.then((0, $kwhzj.lit)('summoner'));
const $9a3cbb0ef185cd19$var$summonerByPuuid = $9a3cbb0ef185cd19$var$summoner.then((0, $kwhzj.lit)('byPuuid')).then($9a3cbb0ef185cd19$var$platformM).then($9a3cbb0ef185cd19$var$puuidM);
const $9a3cbb0ef185cd19$var$summonerByRiotId = $9a3cbb0ef185cd19$var$summoner.then((0, $kwhzj.lit)('byRiotId')).then($9a3cbb0ef185cd19$var$platformM).then($9a3cbb0ef185cd19$var$riotIdM);
const $9a3cbb0ef185cd19$var$user = $9a3cbb0ef185cd19$var$api.then((0, $kwhzj.lit)('user'));
const $9a3cbb0ef185cd19$var$userSelf = $9a3cbb0ef185cd19$var$user.then((0, $kwhzj.lit)('self'));
const $9a3cbb0ef185cd19$var$userSelfFavorites = $9a3cbb0ef185cd19$var$userSelf.then((0, $kwhzj.lit)('favorites'));
const $9a3cbb0ef185cd19$var$userLogin = $9a3cbb0ef185cd19$var$user.then((0, $kwhzj.lit)('login'));
const $9a3cbb0ef185cd19$var$userRegister = $9a3cbb0ef185cd19$var$user.then((0, $kwhzj.lit)('register'));
const $9a3cbb0ef185cd19$var$admin = $9a3cbb0ef185cd19$var$api.then((0, $kwhzj.lit)('admin'));
const $9a3cbb0ef185cd19$var$adminHallOfFame = $9a3cbb0ef185cd19$var$admin.then((0, $kwhzj.lit)('hallOfFame'));
const $9a3cbb0ef185cd19$var$madosayentisuto = $9a3cbb0ef185cd19$var$api.then((0, $kwhzj.lit)('madosayentisuto'));
// final
const $9a3cbb0ef185cd19$var$healthcheckGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$api.then((0, $kwhzj.lit)('healthcheck')), 'get');
const $9a3cbb0ef185cd19$var$staticDataLangGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$staticDataLang, 'get');
const $9a3cbb0ef185cd19$var$staticDataLangAdditionalGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$staticDataLang.then((0, $kwhzj.lit)('additional')), 'get');
const $9a3cbb0ef185cd19$var$summonerByPuuidGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByPuuid, 'get');
const $9a3cbb0ef185cd19$var$summonerByPuuidMasteriesGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByPuuid.then((0, $kwhzj.lit)('masteries')), 'get');
const $9a3cbb0ef185cd19$var$summonerByPuuidChallengesGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByPuuid.then((0, $kwhzj.lit)('challenges')), 'get');
const $9a3cbb0ef185cd19$var$summonerByPuuidActiveGameLangGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByPuuid.then((0, $kwhzj.lit)('activeGame').then($9a3cbb0ef185cd19$var$langM)), 'get');
const $9a3cbb0ef185cd19$var$summonerByRiotIdGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByRiotId, 'get');
const $9a3cbb0ef185cd19$var$summonerByRiotIdMasteriesGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByRiotId.then((0, $kwhzj.lit)('masteries')), 'get');
const $9a3cbb0ef185cd19$var$summonerByRiotIdActiveGameLangGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$summonerByRiotId.then((0, $kwhzj.lit)('activeGame').then($9a3cbb0ef185cd19$var$langM)), 'get');
const $9a3cbb0ef185cd19$var$userSelfGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userSelf, 'get');
const $9a3cbb0ef185cd19$var$userSelfFavoritesPut = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userSelfFavorites, 'put');
const $9a3cbb0ef185cd19$var$userSelfFavoritesDelete = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userSelfFavorites, 'delete');
const $9a3cbb0ef185cd19$var$userSelfSummonerChampionsShardsCountPost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userSelf.then((0, $kwhzj.lit)('summoner')).then($9a3cbb0ef185cd19$var$platformM).then($9a3cbb0ef185cd19$var$puuidM).then((0, $kwhzj.lit)('championsShardsCount')), 'post');
const $9a3cbb0ef185cd19$var$userLoginDiscordPost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userLogin.then((0, $kwhzj.lit)('discord')), 'post');
const $9a3cbb0ef185cd19$var$userLoginPasswordPost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userLogin.then((0, $kwhzj.lit)('password')), 'post');
const $9a3cbb0ef185cd19$var$userLogoutPost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$user.then((0, $kwhzj.lit)('logout')), 'post');
const $9a3cbb0ef185cd19$var$userRegisterPasswordPost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$userRegister.then((0, $kwhzj.lit)('password')), 'post');
const $9a3cbb0ef185cd19$var$adminHallOfFameGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$adminHallOfFame, 'get');
const $9a3cbb0ef185cd19$var$adminHallOfFamePost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$adminHallOfFame, 'post');
const $9a3cbb0ef185cd19$var$madosayentisutoStaticDataGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$madosayentisuto.then((0, $kwhzj.lit)('staticData')), 'get');
const $9a3cbb0ef185cd19$var$madosayentisutoMatchGet = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$madosayentisuto.then((0, $kwhzj.lit)('match').then($9a3cbb0ef185cd19$var$platformM).then($9a3cbb0ef185cd19$var$gameIdM)), 'get');
const $9a3cbb0ef185cd19$var$madosayentisutoUsersGetProgressionPost = $9a3cbb0ef185cd19$var$m($9a3cbb0ef185cd19$var$madosayentisuto.then((0, $kwhzj.lit)('users')).then((0, $kwhzj.lit)('getProgression')), 'post');
const $9a3cbb0ef185cd19$export$1506055a580f4d6d = {
    healthcheck: {
        get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$healthcheckGet)
    },
    staticData: {
        lang: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$staticDataLangGet),
            additional: {
                get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$staticDataLangAdditionalGet)
            }
        }
    },
    summoner: {
        byPuuid: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByPuuidGet),
            masteries: {
                get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByPuuidMasteriesGet)
            },
            challenges: {
                get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByPuuidChallengesGet)
            },
            activeGame: {
                lang: {
                    get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByPuuidActiveGameLangGet)
                }
            }
        },
        byRiotId: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByRiotIdGet),
            masteries: {
                get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByRiotIdMasteriesGet)
            },
            activeGame: {
                lang: {
                    get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$summonerByRiotIdActiveGameLangGet)
                }
            }
        }
    },
    user: {
        self: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userSelfGet),
            favorites: {
                put: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userSelfFavoritesPut),
                delete: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userSelfFavoritesDelete)
            },
            summoner: {
                championsShardsCount: {
                    post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userSelfSummonerChampionsShardsCountPost)
                }
            }
        },
        login: {
            discord: {
                post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userLoginDiscordPost)
            },
            password: {
                post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userLoginPasswordPost)
            }
        },
        logout: {
            post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userLogoutPost)
        },
        register: {
            password: {
                post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$userRegisterPasswordPost)
            }
        }
    },
    admin: {
        hallOfFame: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$adminHallOfFameGet),
            post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$adminHallOfFamePost)
        }
    },
    madosayentisuto: {
        staticData: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$madosayentisutoStaticDataGet)
        },
        match: {
            get: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$madosayentisutoMatchGet)
        },
        users: {
            getProgression: {
                post: $9a3cbb0ef185cd19$var$p($9a3cbb0ef185cd19$var$madosayentisutoUsersGetProgressionPost)
            }
        }
    }
};
const $9a3cbb0ef185cd19$export$926815f3873d207a = {
    staticData: (lang)=>({
            get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$staticDataLangGet, {
                lang: lang
            }),
            additional: {
                get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$staticDataLangAdditionalGet, {
                    lang: lang
                })
            }
        }),
    summoner: {
        byPuuid: (platform)=>(puuid)=>({
                    masteries: {
                        get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$summonerByPuuidMasteriesGet, {
                            platform: platform,
                            puuid: puuid
                        })
                    },
                    challenges: {
                        get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$summonerByPuuidChallengesGet, {
                            platform: platform,
                            puuid: puuid
                        })
                    },
                    activeGame: (lang)=>({
                            get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$summonerByPuuidActiveGameLangGet, {
                                platform: platform,
                                puuid: puuid,
                                lang: lang
                            })
                        })
                }),
        byRiotId: (platform)=>(riotId_)=>{
                const riotId = (0, $fp7Nf.RiotId).clean(riotId_);
                return {
                    get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$summonerByRiotIdGet, {
                        platform: platform,
                        riotId: riotId
                    }),
                    masteries: {
                        get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$summonerByRiotIdMasteriesGet, {
                            platform: platform,
                            riotId: riotId
                        })
                    },
                    activeGame: (lang)=>({
                            get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$summonerByRiotIdActiveGameLangGet, {
                                platform: platform,
                                riotId: riotId,
                                lang: lang
                            })
                        })
                };
            }
    },
    user: {
        self: {
            get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userSelfGet, {}),
            favorites: {
                put: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userSelfFavoritesPut, {}),
                delete: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userSelfFavoritesDelete, {})
            },
            summoner: (platform)=>(puuid)=>({
                        championsShardsCount: {
                            post: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userSelfSummonerChampionsShardsCountPost, {
                                platform: platform,
                                puuid: puuid
                            })
                        }
                    })
        },
        login: {
            discord: {
                post: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userLoginDiscordPost, {})
            },
            password: {
                post: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userLoginPasswordPost, {})
            }
        },
        logout: {
            post: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userLogoutPost, {})
        },
        register: {
            password: {
                post: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$userRegisterPasswordPost, {})
            }
        }
    },
    admin: {
        hallOfFame: {
            get: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$adminHallOfFameGet, {}),
            post: $9a3cbb0ef185cd19$var$r($9a3cbb0ef185cd19$var$adminHallOfFamePost, {})
        }
    }
};
// Match with Method
function $9a3cbb0ef185cd19$var$m(match, method) {
    return [
        match.then((0, $kwhzj.end)),
        method
    ];
}
// Parser with Method
function $9a3cbb0ef185cd19$var$p([match, method]) {
    return [
        match.parser,
        method
    ];
}
// Route with Method
function $9a3cbb0ef185cd19$var$r([match, method], a) {
    return [
        (0, $c7lJu.format)(match.formatter, a),
        method
    ];
}

});
parcelRegister("kwhzj", function(module, exports) {

$parcel$export(module.exports, "Match", function () { return $ef046c90b1e9ef6f$export$f421feb8fad20413; });
$parcel$export(module.exports, "end", function () { return $ef046c90b1e9ef6f$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "lit", function () { return $ef046c90b1e9ef6f$export$f9c0624c04b6af9f; });
/**
 * @since 0.6.0
 */ 
var $7cVq5 = parcelRequire("7cVq5");

var $f5id0 = parcelRequire("f5id0");

var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");

var $jjcgr = parcelRequire("jjcgr");

var $c7lJu = parcelRequire("c7lJu");

var $dc934 = parcelRequire("dc934");

var $fbpED = parcelRequire("fbpED");
/**
 * @category matchers
 * @since 0.4.0
 */ var $ef046c90b1e9ef6f$export$f421feb8fad20413 = /** @class */ function() {
    function Match(parser, formatter) {
        this.parser = parser;
        this.formatter = formatter;
    }
    /**
     * @since 0.4.0
     */ Match.prototype.imap = function(f, g) {
        return new Match(this.parser.map(f), this.formatter.contramap(g));
    };
    /**
     * @since 0.4.0
     */ Match.prototype.then = function(that) {
        return new Match(this.parser.then(that.parser), this.formatter.then(that.formatter));
    };
    return Match;
}();
var $ef046c90b1e9ef6f$export$b2517b0ab3a58435 = function(f, g) {
    return function(ma) {
        return ma.imap(f, g);
    };
};
var $ef046c90b1e9ef6f$export$ff2899a39f81dcfa = function(mb) {
    return function(ma) {
        return ma.then(mb);
    };
};
var $ef046c90b1e9ef6f$var$singleton = function(k, v) {
    var _a;
    return _a = {}, _a[k] = v, _a;
};
var $ef046c90b1e9ef6f$export$9094b7742a87955e = function(a) {
    return new $ef046c90b1e9ef6f$export$f421feb8fad20413(new (0, $dc934.Parser)(function(r) {
        return $hVAkz.some([
            a,
            r
        ]);
    }), new (0, $c7lJu.Formatter)((0, $f5id0.identity)));
};
var $ef046c90b1e9ef6f$export$bd5df0f255a350f8 = new $ef046c90b1e9ef6f$export$f421feb8fad20413(new (0, $dc934.Parser)(function(r) {
    return (0, $fbpED.Route).isEmpty(r) ? $hVAkz.some([
        {},
        r
    ]) : $hVAkz.none;
}), new (0, $c7lJu.Formatter)((0, $f5id0.identity)));
var $ef046c90b1e9ef6f$export$bf9fb029d174d554 = function(k, type) {
    return new $ef046c90b1e9ef6f$export$f421feb8fad20413(new (0, $dc934.Parser)(function(r) {
        if (r.parts.length === 0) return $hVAkz.none;
        return (0, $4CZFO.pipe)(type.decode(r.parts[0]), $hVAkz.fromEither, $hVAkz.map(function(a) {
            return [
                $ef046c90b1e9ef6f$var$singleton(k, a),
                new (0, $fbpED.Route)(r.parts.slice(1), r.query)
            ];
        }));
    }), new (0, $c7lJu.Formatter)(function(r, o) {
        return new (0, $fbpED.Route)(r.parts.concat(type.encode(o[k])), r.query);
    }));
};
var $ef046c90b1e9ef6f$export$42d51816ce590c93 = function(k) {
    return $ef046c90b1e9ef6f$export$bf9fb029d174d554(k, (0, $jjcgr.string));
};
var $ef046c90b1e9ef6f$export$74614f128b444bd0 = new (0, $jjcgr.Type)('IntegerFromString', function(u) {
    return (0, $jjcgr.Int).is(u);
}, function(u, c) {
    return (0, $4CZFO.pipe)((0, $jjcgr.string).validate(u, c), $7cVq5.chain(function(s) {
        var n = +s;
        return isNaN(n) || !Number.isInteger(n) ? (0, $jjcgr.failure)(s, c) : (0, $jjcgr.success)(n);
    }));
}, String);
var $ef046c90b1e9ef6f$export$7d260a2a5f8bc19e = function(k) {
    return $ef046c90b1e9ef6f$export$bf9fb029d174d554(k, $ef046c90b1e9ef6f$export$74614f128b444bd0);
};
var $ef046c90b1e9ef6f$export$f9c0624c04b6af9f = function(literal) {
    return new $ef046c90b1e9ef6f$export$f421feb8fad20413(new (0, $dc934.Parser)(function(r) {
        if (r.parts.length === 0) return $hVAkz.none;
        return r.parts[0] === literal ? $hVAkz.some([
            {},
            new (0, $fbpED.Route)(r.parts.slice(1), r.query)
        ]) : $hVAkz.none;
    }), new (0, $c7lJu.Formatter)(function(r) {
        return new (0, $fbpED.Route)(r.parts.concat(literal), r.query);
    }));
};
var $ef046c90b1e9ef6f$export$2fa187e846a241c4 = function(type) {
    return new $ef046c90b1e9ef6f$export$f421feb8fad20413(new (0, $dc934.Parser)(function(r) {
        return (0, $4CZFO.pipe)(type.decode(r.query), $hVAkz.fromEither, $hVAkz.map(function(query) {
            return [
                query,
                new (0, $fbpED.Route)(r.parts, {})
            ];
        }));
    }), new (0, $c7lJu.Formatter)(function(r, query) {
        return new (0, $fbpED.Route)(r.parts, type.encode(query));
    }));
};

});
parcelRegister("jjcgr", function(module, exports) {

$parcel$export(module.exports, "failure", function () { return $e0e94e1362c6c38c$export$af2dba6db4e9e1f0; });
$parcel$export(module.exports, "success", function () { return $e0e94e1362c6c38c$export$fe7c49d056ea1d88; });
$parcel$export(module.exports, "Type", function () { return $e0e94e1362c6c38c$export$92738401e1603719; });
$parcel$export(module.exports, "string", function () { return $e0e94e1362c6c38c$export$22b082955e083ec3; });
$parcel$export(module.exports, "Int", function () { return $e0e94e1362c6c38c$export$fdd676b64b72b00; });

var $7cVq5 = parcelRequire("7cVq5");
var $e0e94e1362c6c38c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e0e94e1362c6c38c$var$__assign = undefined && undefined.__assign || function() {
    $e0e94e1362c6c38c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e0e94e1362c6c38c$var$__assign.apply(this, arguments);
};
var $e0e94e1362c6c38c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e0e94e1362c6c38c$export$fd43912fe64ec8ed = (0, $7cVq5.left);
var $e0e94e1362c6c38c$export$af2dba6db4e9e1f0 = function(value, context, message) {
    return $e0e94e1362c6c38c$export$fd43912fe64ec8ed([
        {
            value: value,
            context: context,
            message: message
        }
    ]);
};
var $e0e94e1362c6c38c$export$fe7c49d056ea1d88 = (0, $7cVq5.right);
/**
 * @category Codec
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$92738401e1603719 = /** @class */ function() {
    function Type(/** a unique name for this codec */ name, /** a custom type guard */ is, /** succeeds if a value of type I can be decoded to a value of type A */ validate, /** converts a value of type A to a value of type O */ encode) {
        this.name = name;
        this.is = is;
        this.validate = validate;
        this.encode = encode;
        this.decode = this.decode.bind(this);
    }
    /**
     * @since 1.0.0
     */ Type.prototype.pipe = function(ab, name) {
        var _this = this;
        if (name === void 0) name = "pipe(".concat(this.name, ", ").concat(ab.name, ")");
        return new Type(name, ab.is, function(i, c) {
            var e = _this.validate(i, c);
            if ((0, $7cVq5.isLeft)(e)) return e;
            return ab.validate(e.right, c);
        }, this.encode === $e0e94e1362c6c38c$export$f0954fd7d5368655 && ab.encode === $e0e94e1362c6c38c$export$f0954fd7d5368655 ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(b) {
            return _this.encode(ab.encode(b));
        });
    };
    /**
     * @since 1.0.0
     */ Type.prototype.asDecoder = function() {
        return this;
    };
    /**
     * @since 1.0.0
     */ Type.prototype.asEncoder = function() {
        return this;
    };
    /**
     * a version of `validate` with a default context
     * @since 1.0.0
     */ Type.prototype.decode = function(i) {
        return this.validate(i, [
            {
                key: '',
                type: this,
                actual: i
            }
        ]);
    };
    return Type;
}();
var $e0e94e1362c6c38c$export$f0954fd7d5368655 = function(a) {
    return a;
};
function $e0e94e1362c6c38c$export$aad197c7121a6651(f) {
    return f.displayName || f.name || "<function".concat(f.length, ">");
}
function $e0e94e1362c6c38c$export$540babbc0c244fa1(key, decoder) {
    return {
        key: key,
        type: decoder
    };
}
function $e0e94e1362c6c38c$export$c5d593f2380f5045(c, key, decoder, actual) {
    var len = c.length;
    var r = Array(len + 1);
    for(var i = 0; i < len; i++)r[i] = c[i];
    r[len] = {
        key: key,
        type: decoder,
        actual: actual
    };
    return r;
}
function $e0e94e1362c6c38c$var$pushAll(xs, ys) {
    var l = ys.length;
    for(var i = 0; i < l; i++)xs.push(ys[i]);
}
var $e0e94e1362c6c38c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e0e94e1362c6c38c$var$getNameFromProps(props) {
    return Object.keys(props).map(function(k) {
        return "".concat(k, ": ").concat(props[k].name);
    }).join(', ');
}
function $e0e94e1362c6c38c$var$useIdentity(codecs) {
    for(var i = 0; i < codecs.length; i++){
        if (codecs[i].encode !== $e0e94e1362c6c38c$export$f0954fd7d5368655) return false;
    }
    return true;
}
function $e0e94e1362c6c38c$var$getInterfaceTypeName(props) {
    return "{ ".concat($e0e94e1362c6c38c$var$getNameFromProps(props), " }");
}
function $e0e94e1362c6c38c$var$getPartialTypeName(inner) {
    return "Partial<".concat(inner, ">");
}
function $e0e94e1362c6c38c$var$enumerableRecord(keys, domain, codomain, name) {
    if (name === void 0) name = "{ [K in ".concat(domain.name, "]: ").concat(codomain.name, " }");
    var len = keys.length;
    var props = {};
    for(var i = 0; i < len; i++)props[keys[i]] = codomain;
    var exactCodec = $e0e94e1362c6c38c$export$29be874c1daba180(props, name);
    return new $e0e94e1362c6c38c$export$b3333eddd0be649b(name, function(u) {
        return exactCodec.is(u);
    }, exactCodec.validate, exactCodec.encode, domain, codomain);
}
function $e0e94e1362c6c38c$export$e1d2dd375485c85d(domain) {
    var _a;
    if ($e0e94e1362c6c38c$var$isLiteralC(domain)) {
        var literal_1 = domain.value;
        if ($e0e94e1362c6c38c$export$22b082955e083ec3.is(literal_1)) return _a = {}, _a[literal_1] = null, _a;
    } else if ($e0e94e1362c6c38c$var$isKeyofC(domain)) return domain.keys;
    else if ($e0e94e1362c6c38c$var$isUnionC(domain)) {
        var keys = domain.types.map(function(type) {
            return $e0e94e1362c6c38c$export$e1d2dd375485c85d(type);
        });
        return keys.some($e0e94e1362c6c38c$export$1db45310990710a5.is) ? undefined : Object.assign.apply(Object, $e0e94e1362c6c38c$var$__spreadArray([
            {}
        ], keys, false));
    }
    return undefined;
}
function $e0e94e1362c6c38c$var$stripNonDomainKeys(o, domain) {
    var keys = Object.keys(o);
    var len = keys.length;
    var shouldStrip = false;
    var r = {};
    for(var i = 0; i < len; i++){
        var k = keys[i];
        if (domain.is(k)) r[k] = o[k];
        else shouldStrip = true;
    }
    return shouldStrip ? r : o;
}
function $e0e94e1362c6c38c$var$nonEnumerableRecord(domain, codomain, name) {
    if (name === void 0) name = "{ [K in ".concat(domain.name, "]: ").concat(codomain.name, " }");
    return new $e0e94e1362c6c38c$export$b3333eddd0be649b(name, function(u) {
        if ($e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(u)) return Object.keys(u).every(function(k) {
            return !domain.is(k) || codomain.is(u[k]);
        });
        return $e0e94e1362c6c38c$var$isAnyC(codomain) && Array.isArray(u);
    }, function(u, c) {
        if ($e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(u)) {
            var a = {};
            var errors = [];
            var keys = Object.keys(u);
            var len = keys.length;
            var changed = false;
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var ok = u[k];
                var domainResult = domain.validate(k, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, k, domain, k));
                if ((0, $7cVq5.isLeft)(domainResult)) changed = true;
                else {
                    var vk = domainResult.right;
                    changed = changed || vk !== k;
                    k = vk;
                    var codomainResult = codomain.validate(ok, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, k, codomain, ok));
                    if ((0, $7cVq5.isLeft)(codomainResult)) $e0e94e1362c6c38c$var$pushAll(errors, codomainResult.left);
                    else {
                        var vok = codomainResult.right;
                        changed = changed || vok !== ok;
                        a[k] = vok;
                    }
                }
            }
            return errors.length > 0 ? $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors) : $e0e94e1362c6c38c$export$fe7c49d056ea1d88(changed ? a : u);
        }
        if ($e0e94e1362c6c38c$var$isAnyC(codomain) && Array.isArray(u)) return $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u);
        return $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
    }, domain.encode === $e0e94e1362c6c38c$export$f0954fd7d5368655 && codomain.encode === $e0e94e1362c6c38c$export$f0954fd7d5368655 ? function(a) {
        return $e0e94e1362c6c38c$var$stripNonDomainKeys(a, domain);
    } : function(a) {
        var s = {};
        var keys = Object.keys($e0e94e1362c6c38c$var$stripNonDomainKeys(a, domain));
        var len = keys.length;
        for(var i = 0; i < len; i++){
            var k = keys[i];
            s[String(domain.encode(k))] = codomain.encode(a[k]);
        }
        return s;
    }, domain, codomain);
}
function $e0e94e1362c6c38c$var$getUnionName(codecs) {
    return '(' + codecs.map(function(type) {
        return type.name;
    }).join(' | ') + ')';
}
function $e0e94e1362c6c38c$export$18aef43295bbe906(base, us) {
    var equal = true;
    var primitive = true;
    var baseIsNotADictionary = !$e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(base);
    for(var _i = 0, us_1 = us; _i < us_1.length; _i++){
        var u = us_1[_i];
        if (u !== base) equal = false;
        if ($e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(u)) primitive = false;
    }
    if (equal) return base;
    else if (primitive) return us[us.length - 1];
    var r = {};
    for(var _a = 0, us_2 = us; _a < us_2.length; _a++){
        var u = us_2[_a];
        for(var k in u)if (!$e0e94e1362c6c38c$var$hasOwnProperty.call(r, k) || baseIsNotADictionary || u[k] !== base[k]) r[k] = u[k];
    }
    return r;
}
function $e0e94e1362c6c38c$var$getProps(codec) {
    switch(codec._tag){
        case 'RefinementType':
        case 'ReadonlyType':
            return $e0e94e1362c6c38c$var$getProps(codec.type);
        case 'InterfaceType':
        case 'StrictType':
        case 'PartialType':
            return codec.props;
        case 'IntersectionType':
            return codec.types.reduce(function(props, type) {
                return Object.assign(props, $e0e94e1362c6c38c$var$getProps(type));
            }, {});
    }
}
function $e0e94e1362c6c38c$var$stripKeys(o, props) {
    var keys = Object.getOwnPropertyNames(o);
    var shouldStrip = false;
    var r = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$e0e94e1362c6c38c$var$hasOwnProperty.call(props, key)) shouldStrip = true;
        else r[key] = o[key];
    }
    return shouldStrip ? r : o;
}
function $e0e94e1362c6c38c$var$getExactTypeName(codec) {
    if ($e0e94e1362c6c38c$var$isTypeC(codec)) return "{| ".concat($e0e94e1362c6c38c$var$getNameFromProps(codec.props), " |}");
    else if ($e0e94e1362c6c38c$var$isPartialC(codec)) return $e0e94e1362c6c38c$var$getPartialTypeName("{| ".concat($e0e94e1362c6c38c$var$getNameFromProps(codec.props), " |}"));
    return "Exact<".concat(codec.name, ">");
}
function $e0e94e1362c6c38c$var$isNonEmpty(as) {
    return as.length > 0;
}
var $e0e94e1362c6c38c$export$5a86f723dfda3441 = {};
function $e0e94e1362c6c38c$var$intersect(a, b) {
    var r = [];
    for(var _i = 0, a_1 = a; _i < a_1.length; _i++){
        var v = a_1[_i];
        if (b.indexOf(v) !== -1) r.push(v);
    }
    return r;
}
function $e0e94e1362c6c38c$var$mergeTags(a, b) {
    if (a === $e0e94e1362c6c38c$export$5a86f723dfda3441) return b;
    if (b === $e0e94e1362c6c38c$export$5a86f723dfda3441) return a;
    var r = Object.assign({}, a);
    for(var k in b)if ($e0e94e1362c6c38c$var$hasOwnProperty.call(a, k)) {
        var intersection_1 = $e0e94e1362c6c38c$var$intersect(a[k], b[k]);
        if ($e0e94e1362c6c38c$var$isNonEmpty(intersection_1)) r[k] = intersection_1;
        else {
            r = $e0e94e1362c6c38c$export$5a86f723dfda3441;
            break;
        }
    } else r[k] = b[k];
    return r;
}
function $e0e94e1362c6c38c$var$intersectTags(a, b) {
    if (a === $e0e94e1362c6c38c$export$5a86f723dfda3441 || b === $e0e94e1362c6c38c$export$5a86f723dfda3441) return $e0e94e1362c6c38c$export$5a86f723dfda3441;
    var r = $e0e94e1362c6c38c$export$5a86f723dfda3441;
    for(var k in a)if ($e0e94e1362c6c38c$var$hasOwnProperty.call(b, k)) {
        var intersection_2 = $e0e94e1362c6c38c$var$intersect(a[k], b[k]);
        if (intersection_2.length === 0) {
            if (r === $e0e94e1362c6c38c$export$5a86f723dfda3441) r = {};
            r[k] = a[k].concat(b[k]);
        }
    }
    return r;
}
// tslint:disable-next-line: deprecation
function $e0e94e1362c6c38c$var$isAnyC(codec) {
    return codec._tag === 'AnyType';
}
function $e0e94e1362c6c38c$var$isLiteralC(codec) {
    return codec._tag === 'LiteralType';
}
function $e0e94e1362c6c38c$var$isKeyofC(codec) {
    return codec._tag === 'KeyofType';
}
function $e0e94e1362c6c38c$var$isTypeC(codec) {
    return codec._tag === 'InterfaceType';
}
function $e0e94e1362c6c38c$var$isPartialC(codec) {
    return codec._tag === 'PartialType';
}
// tslint:disable-next-line: deprecation
function $e0e94e1362c6c38c$var$isStrictC(codec) {
    return codec._tag === 'StrictType';
}
function $e0e94e1362c6c38c$var$isExactC(codec) {
    return codec._tag === 'ExactType';
}
// tslint:disable-next-line: deprecation
function $e0e94e1362c6c38c$var$isRefinementC(codec) {
    return codec._tag === 'RefinementType';
}
function $e0e94e1362c6c38c$var$isIntersectionC(codec) {
    return codec._tag === 'IntersectionType';
}
function $e0e94e1362c6c38c$var$isUnionC(codec) {
    return codec._tag === 'UnionType';
}
function $e0e94e1362c6c38c$var$isRecursiveC(codec) {
    return codec._tag === 'RecursiveType';
}
function $e0e94e1362c6c38c$var$isReadonlyC(codec) {
    return codec._tag === 'ReadonlyType';
}
var $e0e94e1362c6c38c$var$lazyCodecs = [];
function $e0e94e1362c6c38c$export$af63d7414243dad3(codec) {
    if ($e0e94e1362c6c38c$var$lazyCodecs.indexOf(codec) !== -1) return $e0e94e1362c6c38c$export$5a86f723dfda3441;
    if ($e0e94e1362c6c38c$var$isTypeC(codec) || $e0e94e1362c6c38c$var$isStrictC(codec)) {
        var index = $e0e94e1362c6c38c$export$5a86f723dfda3441;
        // tslint:disable-next-line: forin
        for(var k in codec.props){
            var prop = codec.props[k];
            if ($e0e94e1362c6c38c$var$isLiteralC(prop)) {
                if (index === $e0e94e1362c6c38c$export$5a86f723dfda3441) index = {};
                index[k] = [
                    prop.value
                ];
            }
        }
        return index;
    } else if ($e0e94e1362c6c38c$var$isExactC(codec) || $e0e94e1362c6c38c$var$isRefinementC(codec) || $e0e94e1362c6c38c$var$isReadonlyC(codec)) return $e0e94e1362c6c38c$export$af63d7414243dad3(codec.type);
    else if ($e0e94e1362c6c38c$var$isIntersectionC(codec)) return codec.types.reduce(function(tags, codec) {
        return $e0e94e1362c6c38c$var$mergeTags(tags, $e0e94e1362c6c38c$export$af63d7414243dad3(codec));
    }, $e0e94e1362c6c38c$export$5a86f723dfda3441);
    else if ($e0e94e1362c6c38c$var$isUnionC(codec)) return codec.types.slice(1).reduce(function(tags, codec) {
        return $e0e94e1362c6c38c$var$intersectTags(tags, $e0e94e1362c6c38c$export$af63d7414243dad3(codec));
    }, $e0e94e1362c6c38c$export$af63d7414243dad3(codec.types[0]));
    else if ($e0e94e1362c6c38c$var$isRecursiveC(codec)) {
        $e0e94e1362c6c38c$var$lazyCodecs.push(codec);
        var tags = $e0e94e1362c6c38c$export$af63d7414243dad3(codec.type);
        $e0e94e1362c6c38c$var$lazyCodecs.pop();
        return tags;
    }
    return $e0e94e1362c6c38c$export$5a86f723dfda3441;
}
function $e0e94e1362c6c38c$export$ddfa24987dade61b(codecs) {
    var tags = $e0e94e1362c6c38c$export$af63d7414243dad3(codecs[0]);
    var keys = Object.keys(tags);
    var len = codecs.length;
    var _loop_1 = function(k) {
        var all = tags[k].slice();
        var index = [
            tags[k]
        ];
        for(var i = 1; i < len; i++){
            var codec = codecs[i];
            var ctags = $e0e94e1362c6c38c$export$af63d7414243dad3(codec);
            var values = ctags[k];
            // tslint:disable-next-line: strict-type-predicates
            if (values === undefined) return "continue-keys";
            else {
                if (values.some(function(v) {
                    return all.indexOf(v) !== -1;
                })) return "continue-keys";
                else {
                    all.push.apply(all, values);
                    index.push(values);
                }
            }
        }
        return {
            value: [
                k,
                index
            ]
        };
    };
    keys: for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var k = keys_1[_i];
        var state_1 = _loop_1(k);
        if (typeof state_1 === "object") return state_1.value;
        switch(state_1){
            case "continue-keys":
                continue keys;
        }
    }
    return undefined;
}
// -------------------------------------------------------------------------------------
// primitives
// -------------------------------------------------------------------------------------
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$95d6ca0ebe20dc35 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(NullType, _super);
    function NullType() {
        var _this = _super.call(this, 'null', function(u) {
            return u === null;
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NullType';
        return _this;
    }
    return NullType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$9d93593e0583cfae = new $e0e94e1362c6c38c$export$95d6ca0ebe20dc35();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$f2e4e29641fb7943 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(UndefinedType, _super);
    function UndefinedType() {
        var _this = _super.call(this, 'undefined', function(u) {
            return u === void 0;
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'UndefinedType';
        return _this;
    }
    return UndefinedType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$1db45310990710a5 = new $e0e94e1362c6c38c$export$f2e4e29641fb7943();
/**
 * @since 1.2.0
 */ var $e0e94e1362c6c38c$export$ba8a14deee5e9cf6 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(VoidType, _super);
    function VoidType() {
        var _this = _super.call(this, 'void', $e0e94e1362c6c38c$export$1db45310990710a5.is, $e0e94e1362c6c38c$export$1db45310990710a5.validate, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'VoidType';
        return _this;
    }
    return VoidType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$83daf831650100a1 = new $e0e94e1362c6c38c$export$ba8a14deee5e9cf6();
/**
 * @since 1.5.0
 */ var $e0e94e1362c6c38c$export$df145d679177b39 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(UnknownType, _super);
    function UnknownType() {
        var _this = _super.call(this, 'unknown', function(_) {
            return true;
        }, $e0e94e1362c6c38c$export$fe7c49d056ea1d88, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'UnknownType';
        return _this;
    }
    return UnknownType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$19282c40b967aec6 = new $e0e94e1362c6c38c$export$df145d679177b39();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$2b93044cbf134323 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(StringType, _super);
    function StringType() {
        var _this = _super.call(this, 'string', function(u) {
            return typeof u === 'string';
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'StringType';
        return _this;
    }
    return StringType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$22b082955e083ec3 = new $e0e94e1362c6c38c$export$2b93044cbf134323();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$86a7aca748b1e260 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(NumberType, _super);
    function NumberType() {
        var _this = _super.call(this, 'number', function(u) {
            return typeof u === 'number';
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NumberType';
        return _this;
    }
    return NumberType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$98e628dec113755e = new $e0e94e1362c6c38c$export$86a7aca748b1e260();
/**
 * @since 2.1.0
 */ var $e0e94e1362c6c38c$export$619c1c26d1e391ec = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(BigIntType, _super);
    function BigIntType() {
        var _this = _super.call(this, 'bigint', // tslint:disable-next-line: valid-typeof
        function(u) {
            return typeof u === 'bigint';
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'BigIntType';
        return _this;
    }
    return BigIntType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$a0f65b52274bcc00 = new $e0e94e1362c6c38c$export$619c1c26d1e391ec();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$240f7fffab1b25a0 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(BooleanType, _super);
    function BooleanType() {
        var _this = _super.call(this, 'boolean', function(u) {
            return typeof u === 'boolean';
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'BooleanType';
        return _this;
    }
    return BooleanType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$4a21f16c33752377 = new $e0e94e1362c6c38c$export$240f7fffab1b25a0();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$ac86d7574eec6a20 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(AnyArrayType, _super);
    function AnyArrayType() {
        var _this = _super.call(this, 'UnknownArray', Array.isArray, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyArrayType';
        return _this;
    }
    return AnyArrayType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$837c7bec7087434c = new $e0e94e1362c6c38c$export$ac86d7574eec6a20();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$114de0f37b8f7d23 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(AnyDictionaryType, _super);
    function AnyDictionaryType() {
        var _this = _super.call(this, 'UnknownRecord', function(u) {
            return u !== null && typeof u === 'object' && !Array.isArray(u);
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyDictionaryType';
        return _this;
    }
    return AnyDictionaryType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$ecfbd036cf5a99af = new $e0e94e1362c6c38c$export$114de0f37b8f7d23();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$d6c96d9c1c53b151 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(LiteralType, _super);
    function LiteralType(name, is, validate, encode, value) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.value = value;
        /**
         * @since 1.0.0
         */ _this._tag = 'LiteralType';
        return _this;
    }
    return LiteralType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$c8ec6e1ec9fefcb0(value, name) {
    if (name === void 0) name = JSON.stringify(value);
    var is = function(u) {
        return u === value;
    };
    return new $e0e94e1362c6c38c$export$d6c96d9c1c53b151(name, is, function(u, c) {
        return is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(value) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
    }, $e0e94e1362c6c38c$export$f0954fd7d5368655, value);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$9716a65a8e770652 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(KeyofType, _super);
    function KeyofType(name, is, validate, encode, keys) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.keys = keys;
        /**
         * @since 1.0.0
         */ _this._tag = 'KeyofType';
        return _this;
    }
    return KeyofType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$7e1278799275f68e(keys, name) {
    if (name === void 0) name = Object.keys(keys).map(function(k) {
        return JSON.stringify(k);
    }).join(' | ');
    var is = function(u) {
        return $e0e94e1362c6c38c$export$22b082955e083ec3.is(u) && $e0e94e1362c6c38c$var$hasOwnProperty.call(keys, u);
    };
    return new $e0e94e1362c6c38c$export$9716a65a8e770652(name, is, function(u, c) {
        return is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
    }, $e0e94e1362c6c38c$export$f0954fd7d5368655, keys);
}
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$75d4a1b670774175 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(RefinementType, _super);
    function RefinementType(name, is, validate, encode, type, predicate) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        _this.predicate = predicate;
        /**
         * @since 1.0.0
         */ _this._tag = 'RefinementType';
        return _this;
    }
    return RefinementType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$96ff94e0adb1d772(codec, predicate, name) {
    return $e0e94e1362c6c38c$export$99656c995101768a(codec, predicate, name);
}
var $e0e94e1362c6c38c$export$fdd676b64b72b00 = $e0e94e1362c6c38c$export$96ff94e0adb1d772($e0e94e1362c6c38c$export$98e628dec113755e, function(n) {
    return Number.isInteger(n);
}, 'Int');
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$430fa421231b5068 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(RecursiveType, _super);
    function RecursiveType(name, is, validate, encode, runDefinition) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.runDefinition = runDefinition;
        /**
         * @since 1.0.0
         */ _this._tag = 'RecursiveType';
        return _this;
    }
    return RecursiveType;
}($e0e94e1362c6c38c$export$92738401e1603719);
Object.defineProperty($e0e94e1362c6c38c$export$430fa421231b5068.prototype, 'type', {
    get: function() {
        return this.runDefinition();
    },
    enumerable: true,
    configurable: true
});
function $e0e94e1362c6c38c$export$74c5cab0f9a94551(name, definition) {
    var cache;
    var runDefinition = function() {
        if (!cache) {
            cache = definition(Self);
            cache.name = name;
        }
        return cache;
    };
    var Self = new $e0e94e1362c6c38c$export$430fa421231b5068(name, function(u) {
        return runDefinition().is(u);
    }, function(u, c) {
        return runDefinition().validate(u, c);
    }, function(a) {
        return runDefinition().encode(a);
    }, runDefinition);
    return Self;
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$49c146ea18b05474 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(ArrayType, _super);
    function ArrayType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ArrayType';
        return _this;
    }
    return ArrayType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$2f23118c22fb2630(item, name) {
    if (name === void 0) name = "Array<".concat(item.name, ">");
    return new $e0e94e1362c6c38c$export$49c146ea18b05474(name, function(u) {
        return $e0e94e1362c6c38c$export$837c7bec7087434c.is(u) && u.every(item.is);
    }, function(u, c) {
        var e = $e0e94e1362c6c38c$export$837c7bec7087434c.validate(u, c);
        if ((0, $7cVq5.isLeft)(e)) return e;
        var us = e.right;
        var len = us.length;
        var as = us;
        var errors = [];
        for(var i = 0; i < len; i++){
            var ui = us[i];
            var result = item.validate(ui, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, String(i), item, ui));
            if ((0, $7cVq5.isLeft)(result)) $e0e94e1362c6c38c$var$pushAll(errors, result.left);
            else {
                var ai = result.right;
                if (ai !== ui) {
                    if (as === us) as = us.slice();
                    as[i] = ai;
                }
            }
        }
        return errors.length > 0 ? $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors) : $e0e94e1362c6c38c$export$fe7c49d056ea1d88(as);
    }, item.encode === $e0e94e1362c6c38c$export$f0954fd7d5368655 ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
        return a.map(item.encode);
    }, item);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$f57ee166a379f505 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(InterfaceType, _super);
    function InterfaceType(name, is, validate, encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'InterfaceType';
        return _this;
    }
    return InterfaceType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$bf9fb029d174d554(props, name) {
    if (name === void 0) name = $e0e94e1362c6c38c$var$getInterfaceTypeName(props);
    var keys = Object.keys(props);
    var types = keys.map(function(key) {
        return props[key];
    });
    var len = keys.length;
    return new $e0e94e1362c6c38c$export$f57ee166a379f505(name, function(u) {
        if ($e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(u)) {
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var uk = u[k];
                if (uk === undefined && !$e0e94e1362c6c38c$var$hasOwnProperty.call(u, k) || !types[i].is(uk)) return false;
            }
            return true;
        }
        return false;
    }, function(u, c) {
        var e = $e0e94e1362c6c38c$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $7cVq5.isLeft)(e)) return e;
        var o = e.right;
        var a = o;
        var errors = [];
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            var type_1 = types[i];
            var result = type_1.validate(ak, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, k, type_1, ak));
            if ((0, $7cVq5.isLeft)(result)) $e0e94e1362c6c38c$var$pushAll(errors, result.left);
            else {
                var vak = result.right;
                if (vak !== ak || vak === undefined && !$e0e94e1362c6c38c$var$hasOwnProperty.call(a, k)) {
                    /* istanbul ignore next */ if (a === o) a = $e0e94e1362c6c38c$var$__assign({}, o);
                    a[k] = vak;
                }
            }
        }
        return errors.length > 0 ? $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors) : $e0e94e1362c6c38c$export$fe7c49d056ea1d88(a);
    }, $e0e94e1362c6c38c$var$useIdentity(types) ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
        var s = $e0e94e1362c6c38c$var$__assign({}, a);
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var encode = types[i].encode;
            if (encode !== $e0e94e1362c6c38c$export$f0954fd7d5368655) s[k] = encode(a[k]);
        }
        return s;
    }, props);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$3c1c44baadfdf95a = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(PartialType, _super);
    function PartialType(name, is, validate, encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'PartialType';
        return _this;
    }
    return PartialType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$e45945969df8035a(props, name) {
    if (name === void 0) name = $e0e94e1362c6c38c$var$getPartialTypeName($e0e94e1362c6c38c$var$getInterfaceTypeName(props));
    var keys = Object.keys(props);
    var types = keys.map(function(key) {
        return props[key];
    });
    var len = keys.length;
    return new $e0e94e1362c6c38c$export$3c1c44baadfdf95a(name, function(u) {
        if ($e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(u)) {
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var uk = u[k];
                if (uk !== undefined && !props[k].is(uk)) return false;
            }
            return true;
        }
        return false;
    }, function(u, c) {
        var e = $e0e94e1362c6c38c$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $7cVq5.isLeft)(e)) return e;
        var o = e.right;
        var a = o;
        var errors = [];
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            var type_2 = props[k];
            var result = type_2.validate(ak, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, k, type_2, ak));
            if ((0, $7cVq5.isLeft)(result)) {
                if (ak !== undefined) $e0e94e1362c6c38c$var$pushAll(errors, result.left);
            } else {
                var vak = result.right;
                if (vak !== ak) {
                    /* istanbul ignore next */ if (a === o) a = $e0e94e1362c6c38c$var$__assign({}, o);
                    a[k] = vak;
                }
            }
        }
        return errors.length > 0 ? $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors) : $e0e94e1362c6c38c$export$fe7c49d056ea1d88(a);
    }, $e0e94e1362c6c38c$var$useIdentity(types) ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
        var s = $e0e94e1362c6c38c$var$__assign({}, a);
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            if (ak !== undefined) s[k] = types[i].encode(ak);
        }
        return s;
    }, props);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$b3333eddd0be649b = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(DictionaryType, _super);
    function DictionaryType(name, is, validate, encode, domain, codomain) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.domain = domain;
        _this.codomain = codomain;
        /**
         * @since 1.0.0
         */ _this._tag = 'DictionaryType';
        return _this;
    }
    return DictionaryType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$e5185e241753e543(domain, codomain, name) {
    var keys = $e0e94e1362c6c38c$export$e1d2dd375485c85d(domain);
    return keys ? $e0e94e1362c6c38c$var$enumerableRecord(Object.keys(keys), domain, codomain, name) : $e0e94e1362c6c38c$var$nonEnumerableRecord(domain, codomain, name);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$9b31524cbbc7993 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(UnionType, _super);
    function UnionType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'UnionType';
        return _this;
    }
    return UnionType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$971dd5b0dfd021b6(codecs, name) {
    if (name === void 0) name = $e0e94e1362c6c38c$var$getUnionName(codecs);
    var index = $e0e94e1362c6c38c$export$ddfa24987dade61b(codecs);
    if (index !== undefined && codecs.length > 0) {
        var tag_1 = index[0], groups_1 = index[1];
        var len_1 = groups_1.length;
        var find_1 = function(value) {
            for(var i = 0; i < len_1; i++){
                if (groups_1[i].indexOf(value) !== -1) return i;
            }
            return undefined;
        };
        // tslint:disable-next-line: deprecation
        return new $e0e94e1362c6c38c$export$b00fe6dbb0de05b6(name, function(u) {
            if ($e0e94e1362c6c38c$export$ecfbd036cf5a99af.is(u)) {
                var i = find_1(u[tag_1]);
                return i !== undefined ? codecs[i].is(u) : false;
            }
            return false;
        }, function(u, c) {
            var e = $e0e94e1362c6c38c$export$ecfbd036cf5a99af.validate(u, c);
            if ((0, $7cVq5.isLeft)(e)) return e;
            var r = e.right;
            var i = find_1(r[tag_1]);
            if (i === undefined) return $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
            var codec = codecs[i];
            return codec.validate(r, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, String(i), codec, r));
        }, $e0e94e1362c6c38c$var$useIdentity(codecs) ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
            var i = find_1(a[tag_1]);
            if (i === undefined) // https://github.com/gcanti/io-ts/pull/305
            throw new Error("no codec found to encode value in union codec ".concat(name));
            else return codecs[i].encode(a);
        }, codecs, tag_1);
    } else return new $e0e94e1362c6c38c$export$9b31524cbbc7993(name, function(u) {
        return codecs.some(function(type) {
            return type.is(u);
        });
    }, function(u, c) {
        var errors = [];
        for(var i = 0; i < codecs.length; i++){
            var codec = codecs[i];
            var result = codec.validate(u, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, String(i), codec, u));
            if ((0, $7cVq5.isLeft)(result)) $e0e94e1362c6c38c$var$pushAll(errors, result.left);
            else return $e0e94e1362c6c38c$export$fe7c49d056ea1d88(result.right);
        }
        return $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors);
    }, $e0e94e1362c6c38c$var$useIdentity(codecs) ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
        for(var _i = 0, codecs_1 = codecs; _i < codecs_1.length; _i++){
            var codec = codecs_1[_i];
            if (codec.is(a)) return codec.encode(a);
        }
        // https://github.com/gcanti/io-ts/pull/305
        throw new Error("no codec found to encode value in union type ".concat(name));
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$28e23bba31d0f3b2 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(IntersectionType, _super);
    function IntersectionType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'IntersectionType';
        return _this;
    }
    return IntersectionType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$bc86dfbf7795668c(codecs, name) {
    if (name === void 0) name = "(".concat(codecs.map(function(type) {
        return type.name;
    }).join(' & '), ")");
    var len = codecs.length;
    return new $e0e94e1362c6c38c$export$28e23bba31d0f3b2(name, function(u) {
        return codecs.every(function(type) {
            return type.is(u);
        });
    }, codecs.length === 0 ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88 : function(u, c) {
        var us = [];
        var errors = [];
        for(var i = 0; i < len; i++){
            var codec = codecs[i];
            var result = codec.validate(u, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, String(i), codec, u));
            if ((0, $7cVq5.isLeft)(result)) $e0e94e1362c6c38c$var$pushAll(errors, result.left);
            else us.push(result.right);
        }
        return errors.length > 0 ? $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors) : $e0e94e1362c6c38c$export$fe7c49d056ea1d88($e0e94e1362c6c38c$export$18aef43295bbe906(u, us));
    }, codecs.length === 0 ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
        return $e0e94e1362c6c38c$export$18aef43295bbe906(a, codecs.map(function(codec) {
            return codec.encode(a);
        }));
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$4e91a628a05a1342 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(TupleType, _super);
    function TupleType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'TupleType';
        return _this;
    }
    return TupleType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$65e3907585753458(codecs, name) {
    if (name === void 0) name = "[".concat(codecs.map(function(type) {
        return type.name;
    }).join(', '), "]");
    var len = codecs.length;
    return new $e0e94e1362c6c38c$export$4e91a628a05a1342(name, function(u) {
        return $e0e94e1362c6c38c$export$837c7bec7087434c.is(u) && u.length === len && codecs.every(function(type, i) {
            return type.is(u[i]);
        });
    }, function(u, c) {
        var e = $e0e94e1362c6c38c$export$837c7bec7087434c.validate(u, c);
        if ((0, $7cVq5.isLeft)(e)) return e;
        var us = e.right;
        var as = us.length > len ? us.slice(0, len) : us; // strip additional components
        var errors = [];
        for(var i = 0; i < len; i++){
            var a = us[i];
            var type_3 = codecs[i];
            var result = type_3.validate(a, $e0e94e1362c6c38c$export$c5d593f2380f5045(c, String(i), type_3, a));
            if ((0, $7cVq5.isLeft)(result)) $e0e94e1362c6c38c$var$pushAll(errors, result.left);
            else {
                var va = result.right;
                if (va !== a) {
                    /* istanbul ignore next */ if (as === us) as = us.slice();
                    as[i] = va;
                }
            }
        }
        return errors.length > 0 ? $e0e94e1362c6c38c$export$fd43912fe64ec8ed(errors) : $e0e94e1362c6c38c$export$fe7c49d056ea1d88(as);
    }, $e0e94e1362c6c38c$var$useIdentity(codecs) ? $e0e94e1362c6c38c$export$f0954fd7d5368655 : function(a) {
        return codecs.map(function(type, i) {
            return type.encode(a[i]);
        });
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$13011d386df050c2 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(ReadonlyType, _super);
    function ReadonlyType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ReadonlyType';
        return _this;
    }
    return ReadonlyType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$6ec456bd5b7b3c51(codec, name) {
    if (name === void 0) name = "Readonly<".concat(codec.name, ">");
    return new $e0e94e1362c6c38c$export$13011d386df050c2(name, codec.is, codec.validate, codec.encode, codec);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$fe6530276c28a251 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(ReadonlyArrayType, _super);
    function ReadonlyArrayType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ReadonlyArrayType';
        return _this;
    }
    return ReadonlyArrayType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$95ca155af9fd5713(item, name) {
    if (name === void 0) name = "ReadonlyArray<".concat(item.name, ">");
    var codec = $e0e94e1362c6c38c$export$2f23118c22fb2630(item);
    return new $e0e94e1362c6c38c$export$fe6530276c28a251(name, codec.is, codec.validate, codec.encode, item);
}
var $e0e94e1362c6c38c$export$29be874c1daba180 = function(props, name) {
    return $e0e94e1362c6c38c$export$5f3c29cf4492ebb9($e0e94e1362c6c38c$export$bf9fb029d174d554(props), name);
};
/**
 * @since 1.1.0
 */ var $e0e94e1362c6c38c$export$aee107ca284ccf4e = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(ExactType, _super);
    function ExactType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ExactType';
        return _this;
    }
    return ExactType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$5f3c29cf4492ebb9(codec, name) {
    if (name === void 0) name = $e0e94e1362c6c38c$var$getExactTypeName(codec);
    var props = $e0e94e1362c6c38c$var$getProps(codec);
    return new $e0e94e1362c6c38c$export$aee107ca284ccf4e(name, codec.is, function(u, c) {
        var e = $e0e94e1362c6c38c$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $7cVq5.isLeft)(e)) return e;
        var ce = codec.validate(u, c);
        if ((0, $7cVq5.isLeft)(ce)) return ce;
        return (0, $7cVq5.right)($e0e94e1362c6c38c$var$stripKeys(ce.right, props));
    }, function(a) {
        return codec.encode($e0e94e1362c6c38c$var$stripKeys(a, props));
    }, codec);
}
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$47dda4034ce65bf2 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(FunctionType, _super);
    function FunctionType() {
        var _this = _super.call(this, 'Function', // tslint:disable-next-line:strict-type-predicates
        function(u) {
            return typeof u === 'function';
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'FunctionType';
        return _this;
    }
    return FunctionType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$f3890eeaf6851387 = new $e0e94e1362c6c38c$export$47dda4034ce65bf2();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$203633b10d4a485e = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(NeverType, _super);
    function NeverType() {
        var _this = _super.call(this, 'never', function(_) {
            return false;
        }, function(u, c) {
            return $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, /* istanbul ignore next */ function() {
            throw new Error('cannot encode never');
        }) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NeverType';
        return _this;
    }
    return NeverType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$b3e22bcfd64c1022 = new $e0e94e1362c6c38c$export$203633b10d4a485e();
/**
 * @since 1.0.0
 */ var $e0e94e1362c6c38c$export$ec4c9a150bae86cd = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(AnyType, _super);
    function AnyType() {
        var _this = _super.call(this, 'any', function(_) {
            return true;
        }, $e0e94e1362c6c38c$export$fe7c49d056ea1d88, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyType';
        return _this;
    }
    return AnyType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$4154a199d7d90455 = new $e0e94e1362c6c38c$export$ec4c9a150bae86cd();
function $e0e94e1362c6c38c$export$99656c995101768a(codec, predicate, name) {
    if (name === void 0) name = "(".concat(codec.name, " | ").concat($e0e94e1362c6c38c$export$aad197c7121a6651(predicate), ")");
    return new $e0e94e1362c6c38c$export$75d4a1b670774175(name, function(u) {
        return codec.is(u) && predicate(u);
    }, function(i, c) {
        var e = codec.validate(i, c);
        if ((0, $7cVq5.isLeft)(e)) return e;
        var a = e.right;
        return predicate(a) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(a) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(a, c);
    }, codec.encode, codec, predicate);
}
var $e0e94e1362c6c38c$export$70ffa26850098d01 = $e0e94e1362c6c38c$export$99656c995101768a($e0e94e1362c6c38c$export$98e628dec113755e, Number.isInteger, 'Integer');
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * @since 1.3.0
 * @deprecated
 */ var $e0e94e1362c6c38c$export$b00fe6dbb0de05b6 = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(TaggedUnionType, _super);
    function TaggedUnionType(name, // tslint:disable-next-line: deprecation
    is, // tslint:disable-next-line: deprecation
    validate, // tslint:disable-next-line: deprecation
    encode, codecs, tag) {
        var _this = _super.call(this, name, is, validate, encode, codecs) // <= workaround for https://github.com/Microsoft/TypeScript/issues/13455
         || this;
        _this.tag = tag;
        return _this;
    }
    return TaggedUnionType;
}($e0e94e1362c6c38c$export$9b31524cbbc7993);
var $e0e94e1362c6c38c$export$fd8e3b454da0843e = function(tag, codecs, name) {
    if (name === void 0) name = $e0e94e1362c6c38c$var$getUnionName(codecs);
    var U = $e0e94e1362c6c38c$export$971dd5b0dfd021b6(codecs, name);
    // tslint:disable-next-line: deprecation
    if (U instanceof $e0e94e1362c6c38c$export$b00fe6dbb0de05b6) return U;
    else {
        console.warn("[io-ts] Cannot build a tagged union for ".concat(name, ", returning a de-optimized union"));
        // tslint:disable-next-line: deprecation
        return new $e0e94e1362c6c38c$export$b00fe6dbb0de05b6(name, U.is, U.validate, U.encode, codecs, tag);
    }
};
var $e0e94e1362c6c38c$export$519bb523eb7aafa2 /* istanbul ignore next */  = function(value, context) {
    return {
        value: value,
        context: context
    };
};
var $e0e94e1362c6c38c$export$6cb944b539722d98 /* istanbul ignore next */  = function(decoder) {
    return [
        {
            key: '',
            type: decoder
        }
    ];
};
var $e0e94e1362c6c38c$export$4ee70ab773570fb9 = $e0e94e1362c6c38c$export$ecfbd036cf5a99af;
/**
 * @since 1.0.0
 * @deprecated
 */ var $e0e94e1362c6c38c$export$53f0d9fcb05d9d1d = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(ObjectType, _super);
    function ObjectType() {
        var _this = _super.call(this, 'object', function(u) {
            return u !== null && typeof u === 'object';
        }, function(u, c) {
            return _this.is(u) ? $e0e94e1362c6c38c$export$fe7c49d056ea1d88(u) : $e0e94e1362c6c38c$export$af2dba6db4e9e1f0(u, c);
        }, $e0e94e1362c6c38c$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'ObjectType';
        return _this;
    }
    return ObjectType;
}($e0e94e1362c6c38c$export$92738401e1603719);
var $e0e94e1362c6c38c$export$be5493f9613cbbe = new $e0e94e1362c6c38c$export$53f0d9fcb05d9d1d();
var $e0e94e1362c6c38c$export$d3757880ed390b62 = $e0e94e1362c6c38c$export$e5185e241753e543;
/**
 * @since 1.0.0
 * @deprecated
 */ var $e0e94e1362c6c38c$export$b343c5704aeb93fd = /** @class */ function(_super) {
    $e0e94e1362c6c38c$var$__extends(StrictType, _super);
    function StrictType(name, // tslint:disable-next-line: deprecation
    is, // tslint:disable-next-line: deprecation
    validate, // tslint:disable-next-line: deprecation
    encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'StrictType';
        return _this;
    }
    return StrictType;
}($e0e94e1362c6c38c$export$92738401e1603719);
function $e0e94e1362c6c38c$export$cf0b2a6c63f9e656(codec) {
    return codec;
}
function $e0e94e1362c6c38c$export$8de3e08801b34e5a(codec) {
    return function() {
        return codec;
    };
}

});

parcelRegister("c7lJu", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $8d26ff28b9ce2435$export$a06636add2a09fd8; });
$parcel$export(module.exports, "format", function () { return $8d26ff28b9ce2435$export$d9468344d3651243; });

var $fbpED = parcelRequire("fbpED");
/**
 * @category formatters
 * @since 0.4.0
 */ var $8d26ff28b9ce2435$export$a06636add2a09fd8 = /** @class */ function() {
    function Formatter(run) {
        this.run = run;
    }
    /**
     * @since 0.4.0
     */ Formatter.prototype.contramap = function(f) {
        var _this = this;
        return new Formatter(function(r, b) {
            return _this.run(r, f(b));
        });
    };
    /**
     * @since 0.4.0
     */ Formatter.prototype.then = function(that) {
        var _this = this;
        return new Formatter(function(r, ab) {
            return that.run(_this.run(r, ab), ab);
        });
    };
    return Formatter;
}();
var $8d26ff28b9ce2435$var$FORMATTER_URI = 'fp-ts-routing/Formatter';
var $8d26ff28b9ce2435$export$4bedd3f7d169f13c = {
    URI: $8d26ff28b9ce2435$var$FORMATTER_URI,
    contramap: function(fa, f) {
        return fa.contramap(f);
    }
};
var $8d26ff28b9ce2435$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $8d26ff28b9ce2435$export$4bedd3f7d169f13c.contramap(fa, f);
    };
};
var $8d26ff28b9ce2435$export$ff2899a39f81dcfa = function(fb) {
    return function(fa) {
        return fa.then(fb);
    };
};
var $8d26ff28b9ce2435$export$d9468344d3651243 = function(formatter, a, encode) {
    if (encode === void 0) encode = true;
    return formatter.run((0, $fbpED.Route).empty, a).toString(encode);
};

});
parcelRegister("fbpED", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $b0dbc8821848873b$export$e7b0ac011bb776c6; });

var $kCuv4 = parcelRequire("kCuv4");
var $b0dbc8821848873b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $b0dbc8821848873b$export$e7b0ac011bb776c6 = /** @class */ function() {
    function Route(parts, query) {
        this.parts = parts;
        this.query = query;
    }
    /**
     * @since 0.4.0
     */ Route.isEmpty = function(r) {
        return r.parts.length === 0 && (0, $kCuv4.isEmpty)(r.query);
    };
    /**
     * @since 0.4.0
     */ Route.parse = function(s, decode) {
        var _a;
        if (decode === void 0) decode = true;
        var pathname = (_a = new URL(s, 'http://localhost'), _a.pathname), searchParams = _a.searchParams; // `base` is needed when `path` is relative
        var segments = pathname.split('/').filter(Boolean);
        var parts = decode ? segments.map(decodeURIComponent) : segments;
        return new Route(parts, $b0dbc8821848873b$var$toQuery(searchParams));
    };
    /**
     * @since 0.4.0
     */ Route.prototype.toString = function(encode) {
        if (encode === void 0) encode = true;
        var qs = $b0dbc8821848873b$var$fromQuery(this.query).toString();
        var parts = encode ? this.parts.map(encodeURIComponent) : this.parts;
        return '/' + parts.join('/') + (qs ? '?' + qs : '');
    };
    /**
     * @since 0.4.0
     */ Route.empty = new Route([], {});
    return Route;
}();
var $b0dbc8821848873b$var$fromQuery = function(query) {
    var qs = new URLSearchParams();
    Object.entries(query).forEach(function(_a) {
        var k = _a[0], v = _a[1];
        if (typeof v === 'undefined') return;
        return Array.isArray(v) ? v.forEach(function(x) {
            return qs.append(k, x);
        }) : qs.set(k, v);
    });
    return qs;
};
var $b0dbc8821848873b$var$toQuery = function(params) {
    var q = {};
    params.forEach(function(v, k) {
        var current = q[k];
        if (current) q[k] = Array.isArray(current) ? $b0dbc8821848873b$var$__spreadArray($b0dbc8821848873b$var$__spreadArray([], current, true), [
            v
        ], false) : [
            current,
            v
        ];
        else q[k] = v;
    });
    return q;
};

});
parcelRegister("kCuv4", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $f02f03f872342947$export$dd1bc94b04021eeb; });

var $7XKUT = parcelRequire("7XKUT");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $aByOK = parcelRequire("aByOK");

var $g4z4j = parcelRequire("g4z4j");

var $i0LNv = parcelRequire("i0LNv");

var $68YxT = parcelRequire("68YxT");

var $erGUW = parcelRequire("erGUW");
var $f02f03f872342947$var$__assign = undefined && undefined.__assign || function() {
    $f02f03f872342947$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f02f03f872342947$var$__assign.apply(this, arguments);
};
var $f02f03f872342947$export$346677f925de839c = $g4z4j.size;
var $f02f03f872342947$export$dd1bc94b04021eeb = $g4z4j.isEmpty;
var $f02f03f872342947$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $f02f03f872342947$export$ed97f33186d4b816 = /*#__PURE__*/ $f02f03f872342947$var$keys_($68YxT.Ord);
function $f02f03f872342947$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $f02f03f872342947$export$bb44f104e3c54dae($68YxT.Ord)(O);
    var keysO = $f02f03f872342947$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $f02f03f872342947$export$45b10814cc054894 = /*#__PURE__*/ $f02f03f872342947$export$bb44f104e3c54dae($68YxT.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $f02f03f872342947$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $f02f03f872342947$export$45b10814cc054894(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $aByOK.some([
                sas[b],
                b + 1
            ]) : $aByOK.none;
        });
    };
}
var $f02f03f872342947$export$ff82449ce381c54a = $g4z4j.upsertAt;
var $f02f03f872342947$export$a4f4bb6b1453fff5 = $g4z4j.has;
function $f02f03f872342947$export$90f9093465da3136(k) {
    return function(r) {
        if (!$aByOK.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $f02f03f872342947$export$b6d8713d53419d4c = function(k, a) {
    return $f02f03f872342947$export$cba09f9e3d3e58eb(k, function() {
        return a;
    });
};
var $f02f03f872342947$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$f02f03f872342947$export$a4f4bb6b1453fff5(k, r)) return $aByOK.none;
        var out = Object.assign({}, r);
        out[k] = f(r[k]);
        return $aByOK.some(out);
    };
};
function $f02f03f872342947$export$3e41007ebfff0e64(k) {
    var deleteAtk = $f02f03f872342947$export$90f9093465da3136(k);
    return function(r) {
        var oa = $f02f03f872342947$export$dfc7155ac0343b8(k, r);
        return $aByOK.isNone(oa) ? $aByOK.none : $aByOK.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
var $f02f03f872342947$export$36e6f76a1d117b8a = $g4z4j.isSubrecord;
var $f02f03f872342947$export$dfc7155ac0343b8 = $g4z4j.lookup;
var $f02f03f872342947$export$8f07ddce13659f50 = $g4z4j.mapWithIndex;
var $f02f03f872342947$export$871de8747c9eaa88 = $g4z4j.map;
function $f02f03f872342947$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $g4z4j.reduceWithIndex(args[0]) : $g4z4j.reduceWithIndex($68YxT.Ord).apply(void 0, args);
}
function $f02f03f872342947$export$18153bb1181268e5(O) {
    return 'compare' in O ? $g4z4j.foldMapWithIndex(O) : $g4z4j.foldMapWithIndex($68YxT.Ord)(O);
}
function $f02f03f872342947$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $g4z4j.reduceRightWithIndex(args[0]) : $g4z4j.reduceRightWithIndex($68YxT.Ord).apply(void 0, args);
}
var $f02f03f872342947$export$439306a4dcaafbb9 = $g4z4j.singleton;
function $f02f03f872342947$export$955fdc0d24efa249(F) {
    return $g4z4j.traverseWithIndex(F);
}
function $f02f03f872342947$export$df3f009e3d155b20(F) {
    return $g4z4j.traverse(F);
}
function $f02f03f872342947$export$49bb65c2ea163039(F) {
    return $g4z4j.sequence(F);
}
var $f02f03f872342947$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $f02f03f872342947$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $f5id0.pipe)(fa, traverseF(f)), $f02f03f872342947$export$8e16b83750b44988);
        };
    };
};
var $f02f03f872342947$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $f02f03f872342947$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $f5id0.pipe)(fa, traverseF(f)), $f02f03f872342947$export$709f6946f4e97408);
        };
    };
};
var $f02f03f872342947$export$bc7c0794b9c6f3ba = $g4z4j.partitionMapWithIndex;
function $f02f03f872342947$export$dad5e500f2bab9bc(predicateWithIndex) {
    return $g4z4j.partitionWithIndex(predicateWithIndex);
}
var $f02f03f872342947$export$30c5cbe848021e97 = $g4z4j.filterMapWithIndex;
function $f02f03f872342947$export$36e42aef19fc7171(predicateWithIndex) {
    return $g4z4j.filterWithIndex(predicateWithIndex);
}
function $f02f03f872342947$export$b7d5d9bb9ff52072(M, F) {
    return $g4z4j.fromFoldable(M, F);
}
var $f02f03f872342947$export$9f69d28786a8399c = $f02f03f872342947$export$45b10814cc054894;
var $f02f03f872342947$export$5150077fc2e7c662 = function(fa) {
    return $f02f03f872342947$export$b7d5d9bb9ff52072($i0LNv.last(), $7XKUT.Foldable)(fa);
};
function $f02f03f872342947$export$f658682c0065ad25(M, F) {
    return $g4z4j.fromFoldableMap(M, F);
}
var $f02f03f872342947$export$7ecc1a3b11b57dab = $g4z4j.every;
var $f02f03f872342947$export$ad14ef4001db2bcd = $g4z4j.some;
var $f02f03f872342947$export$5bf96401662340b7 = $g4z4j.elem;
var $f02f03f872342947$export$971dd5b0dfd021b6 = function(M) {
    var unionM = $g4z4j.union(M);
    return function(second) {
        return function(first) {
            if ($f02f03f872342947$export$dd1bc94b04021eeb(first)) return $f02f03f872342947$var$__assign({}, second);
            if ($f02f03f872342947$export$dd1bc94b04021eeb(second)) return $f02f03f872342947$var$__assign({}, first);
            return unionM(second)(first);
        };
    };
};
var $f02f03f872342947$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($f02f03f872342947$export$dd1bc94b04021eeb(first) || $f02f03f872342947$export$dd1bc94b04021eeb(second)) return {};
            return $g4z4j.intersection(M)(second)(first);
        };
    };
};
var $f02f03f872342947$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($f02f03f872342947$export$dd1bc94b04021eeb(first)) return $f02f03f872342947$var$__assign({}, second);
        if ($f02f03f872342947$export$dd1bc94b04021eeb(second)) return $f02f03f872342947$var$__assign({}, first);
        return $g4z4j.difference(second)(first);
    };
};
var $f02f03f872342947$var$_map = $g4z4j._map;
var $f02f03f872342947$var$_mapWithIndex = $g4z4j._mapWithIndex;
var $f02f03f872342947$var$_reduce = $g4z4j._reduce;
var $f02f03f872342947$var$_foldMap = $g4z4j._foldMap;
var $f02f03f872342947$var$_reduceRight = $g4z4j._reduceRight;
var $f02f03f872342947$var$_filter = $g4z4j._filter;
var $f02f03f872342947$var$_filterMap = $g4z4j._filterMap;
var $f02f03f872342947$var$_partition = $g4z4j._partition;
var $f02f03f872342947$var$_partitionMap = $g4z4j._partitionMap;
var $f02f03f872342947$var$_reduceWithIndex = $g4z4j._reduceWithIndex;
var $f02f03f872342947$var$_foldMapWithIndex = $g4z4j._foldMapWithIndex;
var $f02f03f872342947$var$_reduceRightWithIndex = $g4z4j._reduceRightWithIndex;
var $f02f03f872342947$var$_partitionMapWithIndex = $g4z4j._partitionMapWithIndex;
var $f02f03f872342947$var$_partitionWithIndex = $g4z4j._partitionWithIndex;
var $f02f03f872342947$var$_filterMapWithIndex = $g4z4j._filterMapWithIndex;
var $f02f03f872342947$var$_filterWithIndex = $g4z4j._filterWithIndex;
var $f02f03f872342947$var$_traverse = $g4z4j._traverse;
var $f02f03f872342947$var$_sequence = $g4z4j._sequence;
var $f02f03f872342947$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $f02f03f872342947$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of({});
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        r[key] = b;
                        return r;
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $f02f03f872342947$export$3dea766d36a8935f = $g4z4j.filter;
var $f02f03f872342947$export$a04c6c6965dd4709 = $g4z4j.filterMap;
var $f02f03f872342947$export$b29f828819edca8d = $g4z4j.partition;
var $f02f03f872342947$export$3117e3f9ececb6bc = $g4z4j.partitionMap;
function $f02f03f872342947$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $g4z4j.reduce(args[0]) : $g4z4j.reduce($68YxT.Ord).apply(void 0, args);
}
function $f02f03f872342947$export$b66cdc0497d8a99a(O) {
    return 'compare' in O ? $g4z4j.foldMap(O) : $g4z4j.foldMap($68YxT.Ord)(O);
}
function $f02f03f872342947$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $g4z4j.reduceRight(args[0]) : $g4z4j.reduceRight($68YxT.Ord).apply(void 0, args);
}
var $f02f03f872342947$export$8e16b83750b44988 = $g4z4j.compact;
var $f02f03f872342947$export$709f6946f4e97408 = $g4z4j.separate;
var $f02f03f872342947$export$9156e739aa33e19f = 'Record';
function $f02f03f872342947$export$3cb5cd7f7776c81(O) {
    return 'compare' in O ? $g4z4j.getShow(O) : $g4z4j.getShow($68YxT.Ord)(O);
}
var $f02f03f872342947$export$804fed467fde44e4 = $g4z4j.getEq;
var $f02f03f872342947$export$c2a7ef2cc9b32b31 = $g4z4j.getMonoid;
var $f02f03f872342947$export$bd5b6bfc5fa2ee61 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map
};
var $f02f03f872342947$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $hrfTw.flap)($f02f03f872342947$export$bd5b6bfc5fa2ee61);
var $f02f03f872342947$export$9fdffe0fe1e91cad = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    mapWithIndex: $f02f03f872342947$var$_mapWithIndex
};
var $f02f03f872342947$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $f02f03f872342947$export$9156e739aa33e19f,
        reduce: $f02f03f872342947$var$_reduce(O),
        foldMap: $f02f03f872342947$var$_foldMap(O),
        reduceRight: $f02f03f872342947$var$_reduceRight(O)
    };
};
var $f02f03f872342947$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $f02f03f872342947$export$9156e739aa33e19f,
        reduce: $f02f03f872342947$var$_reduce(O),
        foldMap: $f02f03f872342947$var$_foldMap(O),
        reduceRight: $f02f03f872342947$var$_reduceRight(O),
        reduceWithIndex: $f02f03f872342947$var$_reduceWithIndex(O),
        foldMapWithIndex: $f02f03f872342947$var$_foldMapWithIndex(O),
        reduceRightWithIndex: $f02f03f872342947$var$_reduceRightWithIndex(O)
    };
};
var $f02f03f872342947$export$4a21ac48141ac3c9 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    compact: $f02f03f872342947$export$8e16b83750b44988,
    separate: $f02f03f872342947$export$709f6946f4e97408
};
var $f02f03f872342947$export$d00e1c48fb621173 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    compact: $f02f03f872342947$export$8e16b83750b44988,
    separate: $f02f03f872342947$export$709f6946f4e97408,
    filter: $f02f03f872342947$var$_filter,
    filterMap: $f02f03f872342947$var$_filterMap,
    partition: $f02f03f872342947$var$_partition,
    partitionMap: $f02f03f872342947$var$_partitionMap
};
var $f02f03f872342947$export$c29a647071e542ec = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    mapWithIndex: $f02f03f872342947$var$_mapWithIndex,
    compact: $f02f03f872342947$export$8e16b83750b44988,
    separate: $f02f03f872342947$export$709f6946f4e97408,
    filter: $f02f03f872342947$var$_filter,
    filterMap: $f02f03f872342947$var$_filterMap,
    partition: $f02f03f872342947$var$_partition,
    partitionMap: $f02f03f872342947$var$_partitionMap,
    filterMapWithIndex: $f02f03f872342947$var$_filterMapWithIndex,
    filterWithIndex: $f02f03f872342947$var$_filterWithIndex,
    partitionMapWithIndex: $f02f03f872342947$var$_partitionMapWithIndex,
    partitionWithIndex: $f02f03f872342947$var$_partitionWithIndex
};
var $f02f03f872342947$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $f02f03f872342947$export$9156e739aa33e19f,
        map: $f02f03f872342947$var$_map,
        reduce: $f02f03f872342947$var$_reduce(O),
        foldMap: $f02f03f872342947$var$_foldMap(O),
        reduceRight: $f02f03f872342947$var$_reduceRight(O),
        traverse: $f02f03f872342947$var$_traverse(O),
        sequence: $f02f03f872342947$var$_sequence(O)
    };
};
var $f02f03f872342947$export$46b81797a3375b8c = function(O) {
    return {
        URI: $f02f03f872342947$export$9156e739aa33e19f,
        map: $f02f03f872342947$var$_map,
        mapWithIndex: $f02f03f872342947$var$_mapWithIndex,
        reduce: $f02f03f872342947$var$_reduce(O),
        foldMap: $f02f03f872342947$var$_foldMap(O),
        reduceRight: $f02f03f872342947$var$_reduceRight(O),
        reduceWithIndex: $f02f03f872342947$var$_reduceWithIndex(O),
        foldMapWithIndex: $f02f03f872342947$var$_foldMapWithIndex(O),
        reduceRightWithIndex: $f02f03f872342947$var$_reduceRightWithIndex(O),
        traverse: $f02f03f872342947$var$_traverse(O),
        sequence: $f02f03f872342947$var$_sequence(O),
        traverseWithIndex: $f02f03f872342947$var$_traverseWithIndex(O)
    };
};
var $f02f03f872342947$export$bb8ef26a634cac7b = function(O) {
    var T = $f02f03f872342947$export$4e0ffba11065d2c1(O);
    return {
        URI: $f02f03f872342947$export$9156e739aa33e19f,
        map: $f02f03f872342947$var$_map,
        reduce: $f02f03f872342947$var$_reduce(O),
        foldMap: $f02f03f872342947$var$_foldMap(O),
        reduceRight: $f02f03f872342947$var$_reduceRight(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $f02f03f872342947$export$8e16b83750b44988,
        separate: $f02f03f872342947$export$709f6946f4e97408,
        filter: $f02f03f872342947$var$_filter,
        filterMap: $f02f03f872342947$var$_filterMap,
        partition: $f02f03f872342947$var$_partition,
        partitionMap: $f02f03f872342947$var$_partitionMap,
        wither: (0, $erGUW.witherDefault)(T, $f02f03f872342947$export$4a21ac48141ac3c9),
        wilt: (0, $erGUW.wiltDefault)(T, $f02f03f872342947$export$4a21ac48141ac3c9)
    };
};
var $f02f03f872342947$export$baca17b4aff42f82 = function(S) {
    var unionS = $f02f03f872342947$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $f02f03f872342947$export$c487aac9f4157837 = function(S) {
    return {
        concat: $f02f03f872342947$export$baca17b4aff42f82(S).concat,
        empty: {}
    };
};
var $f02f03f872342947$export$d379a869a72e4055 = function(S) {
    var intersectionS = $f02f03f872342947$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $f02f03f872342947$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $f02f03f872342947$export$acaf96a27438246b(second)(first);
        }
    };
};
var $f02f03f872342947$export$41404b31838667c9 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $f02f03f872342947$var$_reduce($68YxT.Ord),
    foldMap: /*#__PURE__*/ $f02f03f872342947$var$_foldMap($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $f02f03f872342947$var$_reduceRight($68YxT.Ord)
};
var $f02f03f872342947$export$e8f7d17aaff345cb = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $f02f03f872342947$var$_reduce($68YxT.Ord),
    foldMap: /*#__PURE__*/ $f02f03f872342947$var$_foldMap($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $f02f03f872342947$var$_reduceRight($68YxT.Ord),
    reduceWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_reduceWithIndex($68YxT.Ord),
    foldMapWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_foldMapWithIndex($68YxT.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_reduceRightWithIndex($68YxT.Ord)
};
var $f02f03f872342947$export$a0202666c3bda011 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    reduce: /*#__PURE__*/ $f02f03f872342947$var$_reduce($68YxT.Ord),
    foldMap: /*#__PURE__*/ $f02f03f872342947$var$_foldMap($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $f02f03f872342947$var$_reduceRight($68YxT.Ord),
    traverse: /*#__PURE__*/ $f02f03f872342947$var$_traverse($68YxT.Ord),
    sequence: $f02f03f872342947$export$49bb65c2ea163039
};
var $f02f03f872342947$export$bd7b528d8c36ec41 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    mapWithIndex: $f02f03f872342947$var$_mapWithIndex,
    reduce: /*#__PURE__*/ $f02f03f872342947$var$_reduce($68YxT.Ord),
    foldMap: /*#__PURE__*/ $f02f03f872342947$var$_foldMap($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $f02f03f872342947$var$_reduceRight($68YxT.Ord),
    reduceWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_reduceWithIndex($68YxT.Ord),
    foldMapWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_foldMapWithIndex($68YxT.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_reduceRightWithIndex($68YxT.Ord),
    traverse: /*#__PURE__*/ $f02f03f872342947$var$_traverse($68YxT.Ord),
    sequence: $f02f03f872342947$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_traverseWithIndex($68YxT.Ord)
};
var $f02f03f872342947$var$_wither = /*#__PURE__*/ (0, $erGUW.witherDefault)($f02f03f872342947$export$a0202666c3bda011, $f02f03f872342947$export$4a21ac48141ac3c9);
var $f02f03f872342947$var$_wilt = /*#__PURE__*/ (0, $erGUW.wiltDefault)($f02f03f872342947$export$a0202666c3bda011, $f02f03f872342947$export$4a21ac48141ac3c9);
var $f02f03f872342947$export$748d317b4c426f96 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    reduce: /*#__PURE__*/ $f02f03f872342947$var$_reduce($68YxT.Ord),
    foldMap: /*#__PURE__*/ $f02f03f872342947$var$_foldMap($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $f02f03f872342947$var$_reduceRight($68YxT.Ord),
    traverse: /*#__PURE__*/ $f02f03f872342947$var$_traverse($68YxT.Ord),
    sequence: $f02f03f872342947$export$49bb65c2ea163039,
    compact: $f02f03f872342947$export$8e16b83750b44988,
    separate: $f02f03f872342947$export$709f6946f4e97408,
    filter: $f02f03f872342947$var$_filter,
    filterMap: $f02f03f872342947$var$_filterMap,
    partition: $f02f03f872342947$var$_partition,
    partitionMap: $f02f03f872342947$var$_partitionMap,
    wither: $f02f03f872342947$var$_wither,
    wilt: $f02f03f872342947$var$_wilt
};
var $f02f03f872342947$export$6e22c362a0406a2c = {};
var $f02f03f872342947$export$9f200c4466975173 = $f02f03f872342947$export$ff82449ce381c54a;
var $f02f03f872342947$export$5a15a386532a5ea4 = $g4z4j.hasOwnProperty;
var $f02f03f872342947$export$e5185e241753e543 = {
    URI: $f02f03f872342947$export$9156e739aa33e19f,
    map: $f02f03f872342947$var$_map,
    reduce: /*#__PURE__*/ $f02f03f872342947$var$_reduce($68YxT.Ord),
    foldMap: /*#__PURE__*/ $f02f03f872342947$var$_foldMap($68YxT.Ord),
    reduceRight: /*#__PURE__*/ $f02f03f872342947$var$_reduceRight($68YxT.Ord),
    traverse: /*#__PURE__*/ $f02f03f872342947$var$_traverse($68YxT.Ord),
    sequence: $f02f03f872342947$export$49bb65c2ea163039,
    compact: $f02f03f872342947$export$8e16b83750b44988,
    separate: $f02f03f872342947$export$709f6946f4e97408,
    filter: $f02f03f872342947$var$_filter,
    filterMap: $f02f03f872342947$var$_filterMap,
    partition: $f02f03f872342947$var$_partition,
    partitionMap: $f02f03f872342947$var$_partitionMap,
    mapWithIndex: $f02f03f872342947$var$_mapWithIndex,
    reduceWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_reduceWithIndex($68YxT.Ord),
    foldMapWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_foldMapWithIndex($68YxT.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_reduceRightWithIndex($68YxT.Ord),
    filterMapWithIndex: $f02f03f872342947$var$_filterMapWithIndex,
    filterWithIndex: $f02f03f872342947$var$_filterWithIndex,
    partitionMapWithIndex: $f02f03f872342947$var$_partitionMapWithIndex,
    partitionWithIndex: $f02f03f872342947$var$_partitionWithIndex,
    traverseWithIndex: /*#__PURE__*/ $f02f03f872342947$var$_traverseWithIndex($68YxT.Ord),
    wither: $f02f03f872342947$var$_wither,
    wilt: $f02f03f872342947$var$_wilt
};

});



parcelRegister("dc934", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return Parser; });
$parcel$export(module.exports, "zero", function () { return zero; });
$parcel$export(module.exports, "parse", function () { return parse; });

var $f5id0 = parcelRequire("f5id0");

var $hVAkz = parcelRequire("hVAkz");

var $4CZFO = parcelRequire("4CZFO");
var PARSER_URI = 'fp-ts-routing/Parser';
/**
 * @category parsers
 * @since 0.4.0
 */ var Parser = /** @class */ function() {
    function Parser(run) {
        this.run = run;
    }
    /**
     * @since 0.4.0
     */ Parser.of = function(a) {
        return new Parser(function(s) {
            return $hVAkz.some([
                a,
                s
            ]);
        });
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.map = function(f) {
        return this.chain(function(a) {
            return Parser.of(f(a));
        }); // <= derived
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.ap = function(fab) {
        var _this = this;
        return fab.chain(function(f) {
            return _this.map(f);
        }); // <= derived
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.chain = function(f) {
        var _this = this;
        return new Parser(function(r) {
            return (0, $4CZFO.pipe)(_this.run(r), $hVAkz.chain(function(_a) {
                var a = _a[0], r2 = _a[1];
                return f(a).run(r2);
            }));
        });
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.alt = function(that) {
        var _this = this;
        return new Parser(function(r) {
            return (0, $4CZFO.pipe)(_this.run(r), $hVAkz.alt(function() {
                return that.run(r);
            }));
        });
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.then = function(that) {
        return that.ap(this.map(assign));
    };
    return Parser;
}();
var zero = function() {
    return new Parser(function() {
        return $hVAkz.none;
    });
};
var parse = function(parser, r, a) {
    return (0, $4CZFO.pipe)(parser.run(r), $hVAkz.fold(function() {
        return a;
    }, function(_a) {
        var x = _a[0];
        return x;
    }));
};
var getParserMonoid = function() {
    return {
        concat: function(x, y) {
            return x.alt(y);
        },
        empty: zero()
    };
};
var parser = {
    URI: PARSER_URI,
    map: function(ma, f) {
        return ma.map(f);
    },
    of: Parser.of,
    ap: function(mab, ma) {
        return ma.ap(mab);
    },
    chain: function(ma, f) {
        return ma.chain(f);
    },
    alt: function(fx, f) {
        return new Parser(function(r) {
            return (0, $4CZFO.pipe)(fx.run(r), $hVAkz.alt(function() {
                return f().run(r);
            }));
        });
    },
    zero: zero
};
var alt = function(that) {
    return function(fa) {
        return parser.alt(fa, that);
    };
};
var ap = function(fa) {
    return function(fab) {
        return parser.ap(fab, fa);
    };
};
var apFirst = function(fb) {
    return function(fa) {
        return parser.ap(parser.map(fa, function(a) {
            return function() {
                return a;
            };
        }), fb);
    };
};
var apSecond = function(fb) {
    return function(fa) {
        return parser.ap(parser.map(fa, function() {
            return function(b) {
                return b;
            };
        }), fb);
    };
};
var chain = function(f) {
    return function(ma) {
        return parser.chain(ma, f);
    };
};
var chainFirst = function(f) {
    return function(ma) {
        return parser.chain(ma, function(a) {
            return parser.map(f(a), function() {
                return a;
            });
        });
    };
};
var flatten = function(mma) {
    return parser.chain(mma, (0, $f5id0.identity));
};
var map = function(f) {
    return function(fa) {
        return parser.map(fa, f);
    };
};
var then = function(fb) {
    return function(fa) {
        return fa.then(fb);
    };
};
// --- Helpers
var assign = function(a) {
    return function(b) {
        return Object.assign({}, a, b);
    };
};

});


parcelRegister("iDoEG", function(module, exports) {

$parcel$export(module.exports, "GameId", function () { return $f91d1151976b3619$export$27b7f43ad4dafa40; });

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $f91d1151976b3619$var$wrap, unwrap: $f91d1151976b3619$var$unwrap } = (0, $1k68G.iso)();
const $f91d1151976b3619$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $f91d1151976b3619$export$27b7f43ad4dafa40 = (0, $sjwE0.immutableAssign)($f91d1151976b3619$var$wrap, {
    unwrap: $f91d1151976b3619$var$unwrap,
    codec: $f91d1151976b3619$var$codec
});

});

parcelRegister("ewM3A", function(module, exports) {

$parcel$export(module.exports, "Lang", function () { return $0c6a0aca52b0148c$export$8a4528ea5590497a; });

var $j839F = parcelRequire("j839F");
const $0c6a0aca52b0148c$var$e = (0, $j839F.createEnum)(// 'en_US',
// 'cs_CZ',
// 'de_DE',
// 'el_GR',
// 'en_AU',
'en_GB', // 'en_PH',
// 'en_SG',
// 'es_AR',
// 'es_ES',
// 'es_MX',
'fr_FR');
const $0c6a0aca52b0148c$var$fromNavigatorLanguage = (lang)=>{
    switch(lang){
        // case 'es-ES':
        // case 'es':
        //   return 'es_ES'
        case 'fr-FR':
        case 'fr':
            return 'fr_FR';
        default:
            return 'en_GB';
    }
};
const $0c6a0aca52b0148c$export$8a4528ea5590497a = {
    ...$0c6a0aca52b0148c$var$e,
    fromNavigatorLanguage: $0c6a0aca52b0148c$var$fromNavigatorLanguage
};

});
parcelRegister("j839F", function(module, exports) {

$parcel$export(module.exports, "createEnum", function () { return $4a28c42c69fc1e76$export$37b2eedf6b7b231a; });

var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");
var $12uqT = parcelRequire("12uqT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $sjwE0 = parcelRequire("sjwE0");
const $4a28c42c69fc1e76$export$37b2eedf6b7b231a = (...values)=>{
    const [head, ...tail] = values;
    const decoder = $4BSZX.literal(head, ...tail);
    const encoder = $d9q5l.id();
    const codec = $jPaL5.make(decoder, encoder);
    const Eq = (0, $kJAjV).eqStrict;
    const Ord = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((value)=>(0, $f5id0.pipe)(values, (0, $sjwE0.List).findIndex((v)=>Eq.equals(v, value)), (0, $sjwE0.Maybe).getOrElse(()=>Infinity))));
    const res = {
        values: values,
        decoder: decoder,
        encoder: encoder,
        codec: codec,
        Eq: Eq,
        Ord: Ord
    };
    return res;
};

});


parcelRegister("ebDzf", function(module, exports) {

$parcel$export(module.exports, "Platform", function () { return $2854a5495e063c1c$export$2dffd0b5373a4389; });

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $dOJeV = parcelRequire("dOJeV");

var $j839F = parcelRequire("j839F");
const $2854a5495e063c1c$var$e = (0, $j839F.createEnum)('BR', 'EUN', 'EUW', 'JP', 'KR', 'LA1', 'LA2', 'NA', 'OC', 'TR', 'RU', 'PH2', 'SG2', 'TH2', 'TW2', 'VN2');
const $2854a5495e063c1c$var$decoderLower = $4BSZX.literal(// eslint-disable-next-line @typescript-eslint/no-explicit-any
...$2854a5495e063c1c$var$e.values.map((0, $dOJeV.StringUtils).toLowerCase));
const $2854a5495e063c1c$var$encoderLower = {
    encode: (0, $dOJeV.StringUtils).toLowerCase
};
const $2854a5495e063c1c$var$orLowerCaseCodec = $jPaL5.make($4BSZX.union($2854a5495e063c1c$var$e.decoder, $2854a5495e063c1c$var$decoderLower), $2854a5495e063c1c$var$encoderLower);
const $2854a5495e063c1c$var$defaultPlatform = 'EUW';
const $2854a5495e063c1c$export$2dffd0b5373a4389 = {
    ...$2854a5495e063c1c$var$e,
    encoderLower: $2854a5495e063c1c$var$encoderLower,
    orLowerCaseCodec: $2854a5495e063c1c$var$orLowerCaseCodec,
    defaultPlatform: $2854a5495e063c1c$var$defaultPlatform
};

});

parcelRegister("gl9GP", function(module, exports) {

$parcel$export(module.exports, "Puuid", function () { return $2e113cff6a4840fd$export$75429ad826a6037b; });

var $kJAjV = parcelRequire("kJAjV");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $2e113cff6a4840fd$var$wrap, unwrap: $2e113cff6a4840fd$var$unwrap } = (0, $1k68G.iso)();
const $2e113cff6a4840fd$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $2e113cff6a4840fd$var$Eq = (0, $f5id0.pipe)((0, $68YxT).Eq, (0, $kJAjV).contramap($2e113cff6a4840fd$var$unwrap));
const $2e113cff6a4840fd$export$75429ad826a6037b = (0, $sjwE0.immutableAssign)($2e113cff6a4840fd$var$wrap, {
    unwrap: $2e113cff6a4840fd$var$unwrap,
    codec: $2e113cff6a4840fd$var$codec,
    Eq: $2e113cff6a4840fd$var$Eq
});

});

parcelRegister("4o3f8", function(module, exports) {

$parcel$export(module.exports, "GameName", function () { return $9d25075a2219d57d$export$5317697ff0dbedd3; });

var $kJAjV = parcelRequire("kJAjV");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $9d25075a2219d57d$var$wrap, unwrap: $9d25075a2219d57d$var$unwrap } = (0, $1k68G.iso)();
const $9d25075a2219d57d$var$modify = (0, $f5id0.identity);
const $9d25075a2219d57d$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $9d25075a2219d57d$var$trim = $9d25075a2219d57d$var$modify((0, $68YxT).trim);
const $9d25075a2219d57d$var$whiteSpaces = /\s+/g;
const $9d25075a2219d57d$var$clean = $9d25075a2219d57d$var$modify((name)=>name.toLowerCase().replaceAll($9d25075a2219d57d$var$whiteSpaces, ''));
const $9d25075a2219d57d$var$Eq = (0, $f5id0.pipe)((0, $68YxT).Eq, (0, $kJAjV).contramap($9d25075a2219d57d$var$unwrap));
const $9d25075a2219d57d$export$5317697ff0dbedd3 = (0, $sjwE0.immutableAssign)($9d25075a2219d57d$var$wrap, {
    unwrap: $9d25075a2219d57d$var$unwrap,
    codec: $9d25075a2219d57d$var$codec,
    trim: $9d25075a2219d57d$var$trim,
    clean: $9d25075a2219d57d$var$clean,
    Eq: $9d25075a2219d57d$var$Eq
});

});

parcelRegister("fp7Nf", function(module, exports) {

$parcel$export(module.exports, "RiotId", function () { return $bcdcb04f7f13be5b$export$5c53af361d6e628b; });

var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $4o3f8 = parcelRequire("4o3f8");

var $fC0sb = parcelRequire("fC0sb");
const $bcdcb04f7f13be5b$var$empty = {
    gameName: (0, $4o3f8.GameName)(''),
    tagLine: (0, $fC0sb.TagLine)('')
};
function $bcdcb04f7f13be5b$var$construct(gameName, tagLine) {
    return {
        gameName: gameName,
        tagLine: tagLine
    };
}
// {3-16}#{3-5}
function $bcdcb04f7f13be5b$var$regex(sep) {
    return RegExp(`^(.+)${sep}([^${sep}]+)$`);
}
function $bcdcb04f7f13be5b$var$getFromStringDecoder(sep) {
    return {
        decode: (str)=>(0, $f5id0.pipe)(str, (0, $dOJeV.StringUtils).matcher2($bcdcb04f7f13be5b$var$regex(sep)), (0, $sjwE0.Maybe).fold(()=>$4BSZX.failure(str, `RiotId[${sep}]`), ([gameName, tagLine])=>$4BSZX.success($bcdcb04f7f13be5b$var$construct((0, $4o3f8.GameName)(gameName), (0, $fC0sb.TagLine)(tagLine)))))
    };
}
function $bcdcb04f7f13be5b$var$getFromStringUnknownDecoder(sep) {
    return (0, $f5id0.pipe)($4BSZX.string, $4BSZX.compose($bcdcb04f7f13be5b$var$getFromStringDecoder(sep)));
}
const $bcdcb04f7f13be5b$var$getStringify = (sep)=>({ gameName: gameName, tagLine: tagLine })=>`${gameName}${sep}${tagLine}`;
function $bcdcb04f7f13be5b$var$getFromStringEncoder(sep) {
    return (0, $f5id0.pipe)($d9q5l.id(), $d9q5l.contramap($bcdcb04f7f13be5b$var$getStringify(sep)));
}
function $bcdcb04f7f13be5b$var$getFromStringCodec(sep) {
    return $jPaL5.make($bcdcb04f7f13be5b$var$getFromStringUnknownDecoder(sep), $bcdcb04f7f13be5b$var$getFromStringEncoder(sep));
}
function $bcdcb04f7f13be5b$var$trim({ gameName: gameName, tagLine: tagLine }) {
    return {
        gameName: (0, $4o3f8.GameName).trim(gameName),
        tagLine: (0, $fC0sb.TagLine).trim(tagLine)
    };
}
function $bcdcb04f7f13be5b$var$clean({ gameName: gameName, tagLine: tagLine }) {
    return {
        gameName: (0, $4o3f8.GameName).clean(gameName),
        tagLine: (0, $fC0sb.TagLine).clean(tagLine)
    };
}
const $bcdcb04f7f13be5b$var$Eq = (0, $kJAjV).struct({
    gameName: (0, $4o3f8.GameName).Eq,
    tagLine: (0, $fC0sb.TagLine).Eq
});
const $bcdcb04f7f13be5b$export$5c53af361d6e628b = (0, $sjwE0.immutableAssign)($bcdcb04f7f13be5b$var$construct, {
    empty: $bcdcb04f7f13be5b$var$empty,
    getFromStringCodec: $bcdcb04f7f13be5b$var$getFromStringCodec,
    fromStringDecoder: $bcdcb04f7f13be5b$var$getFromStringDecoder('#'),
    fromStringCodec: $bcdcb04f7f13be5b$var$getFromStringCodec('#'),
    stringify: $bcdcb04f7f13be5b$var$getStringify('#'),
    trim: $bcdcb04f7f13be5b$var$trim,
    clean: $bcdcb04f7f13be5b$var$clean,
    Eq: $bcdcb04f7f13be5b$var$Eq
});

});
parcelRegister("fC0sb", function(module, exports) {

$parcel$export(module.exports, "TagLine", function () { return $5b1398a1a70cd784$export$eb80c4b532487e1b; });

var $kJAjV = parcelRequire("kJAjV");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $5b1398a1a70cd784$var$wrap, unwrap: $5b1398a1a70cd784$var$unwrap } = (0, $1k68G.iso)();
const $5b1398a1a70cd784$var$modify = (0, $f5id0.identity);
const $5b1398a1a70cd784$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $5b1398a1a70cd784$var$trim = $5b1398a1a70cd784$var$modify((0, $68YxT).trim);
const $5b1398a1a70cd784$var$whiteSpaces = /\s+/g;
const $5b1398a1a70cd784$var$clean = $5b1398a1a70cd784$var$modify((name)=>name.toLowerCase().replaceAll($5b1398a1a70cd784$var$whiteSpaces, ''));
const $5b1398a1a70cd784$var$Eq = (0, $f5id0.pipe)((0, $68YxT).Eq, (0, $kJAjV).contramap($5b1398a1a70cd784$var$unwrap));
const $5b1398a1a70cd784$export$eb80c4b532487e1b = (0, $sjwE0.immutableAssign)($5b1398a1a70cd784$var$wrap, {
    unwrap: $5b1398a1a70cd784$var$unwrap,
    codec: $5b1398a1a70cd784$var$codec,
    trim: $5b1398a1a70cd784$var$trim,
    clean: $5b1398a1a70cd784$var$clean,
    Eq: $5b1398a1a70cd784$var$Eq
});

});


parcelRegister("3vjpe", function(module, exports) {

$parcel$export(module.exports, "RouterUtils", function () { return $99869551947b494c$export$68c7f300a63aab8e; });

var $c7lJu = parcelRequire("c7lJu");
var $kwhzj = parcelRequire("kwhzj");
var $dc934 = parcelRequire("dc934");
var $fbpED = parcelRequire("fbpED");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
const $99869551947b494c$var$codec_ = (k, codec)=>new (0, $kwhzj.Match)(new (0, $dc934.Parser)((r)=>{
        if (!(0, $sjwE0.List).isNonEmpty(r.parts)) return (0, $sjwE0.Maybe).none;
        const [head, tail] = (0, $sjwE0.NonEmptyArray).unprepend(r.parts);
        return (0, $f5id0.pipe)(codec.decode(head), (0, $sjwE0.Maybe).fromEither, (0, $sjwE0.Maybe).map((a)=>(0, $sjwE0.Tuple).of($99869551947b494c$var$singleton(k, a), new (0, $fbpED.Route)((0, $sjwE0.List).asMutable(tail), r.query))));
    }), new (0, $c7lJu.Formatter)((r, o)=>new (0, $fbpED.Route)(r.parts.concat(codec.encode(o[k])), r.query)));
const $99869551947b494c$var$singleton = (k, a)=>({
        [k]: a
    });
const $99869551947b494c$export$68c7f300a63aab8e = {
    codec: $99869551947b494c$var$codec_
};

});


parcelRegister("dW1pp", function(module, exports) {

$parcel$export(module.exports, "ValidatedSoft", function () { return $3ac0ba25b88936eb$export$47e6e6513f17b8f2; });

var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $sjwE0 = parcelRequire("sjwE0");
const $3ac0ba25b88936eb$var$URI = 'ValidatedSoft';
function $3ac0ba25b88936eb$var$of(value, ...errors) {
    return {
        value: value,
        errors: errors
    };
}
const $3ac0ba25b88936eb$var$fromOption = (onNone)=>(0, $sjwE0.Maybe).fold(()=>$3ac0ba25b88936eb$var$of(...onNone()), $3ac0ba25b88936eb$var$of);
const $3ac0ba25b88936eb$var$value = (fa)=>fa.value;
const $3ac0ba25b88936eb$var$errors = (fa)=>fa.errors;
const $3ac0ba25b88936eb$var$map = (f)=>(fa)=>({
            value: f(fa.value),
            errors: fa.errors
        });
const $3ac0ba25b88936eb$var$mapLeft = (f)=>(fa)=>({
            value: fa.value,
            errors: fa.errors.map(f)
        });
const $3ac0ba25b88936eb$var$bimap = (g, f)=>(fa)=>({
            value: f(fa.value),
            errors: fa.errors.map(g)
        });
function $3ac0ba25b88936eb$var$ap_(fab, fa) {
    return {
        value: fab.value(fa.value),
        errors: (0, $f5id0.pipe)(fab.errors, (0, $sjwE0.List).concat(fa.errors))
    };
}
const $3ac0ba25b88936eb$var$chain = (f)=>(fa)=>{
        const fb = f(fa.value);
        return {
            value: fb.value,
            errors: (0, $f5id0.pipe)(fa.errors, (0, $sjwE0.List).concat(fb.errors))
        };
    };
const $3ac0ba25b88936eb$var$chainFirst = (f)=>$3ac0ba25b88936eb$var$chain((a)=>(0, $f5id0.pipe)(f(a), $3ac0ba25b88936eb$var$map(()=>a)));
const $3ac0ba25b88936eb$var$map_ = (fa, f)=>(0, $f5id0.pipe)(fa, $3ac0ba25b88936eb$var$map(f));
const $3ac0ba25b88936eb$var$Applicative = {
    URI: $3ac0ba25b88936eb$var$URI,
    map: $3ac0ba25b88936eb$var$map_,
    ap: $3ac0ba25b88936eb$var$ap_,
    of: $3ac0ba25b88936eb$var$of
};
function $3ac0ba25b88936eb$var$decoder(valueDecoder, errorDecoder) {
    return $4BSZX.struct({
        value: valueDecoder,
        errors: $4BSZX.array(errorDecoder)
    });
}
// don't declare encoder to enforce empty errors if no permission for user
const $3ac0ba25b88936eb$export$47e6e6513f17b8f2 = (0, $sjwE0.immutableAssign)($3ac0ba25b88936eb$var$of, {
    fromOption: $3ac0ba25b88936eb$var$fromOption,
    value: $3ac0ba25b88936eb$var$value,
    errors: $3ac0ba25b88936eb$var$errors,
    map: $3ac0ba25b88936eb$var$map,
    mapLeft: $3ac0ba25b88936eb$var$mapLeft,
    bimap: $3ac0ba25b88936eb$var$bimap,
    chain: $3ac0ba25b88936eb$var$chain,
    chainFirst: $3ac0ba25b88936eb$var$chainFirst,
    Applicative: $3ac0ba25b88936eb$var$Applicative,
    decoder: $3ac0ba25b88936eb$var$decoder
});

});

parcelRegister("br0yu", function(module, exports) {

$parcel$export(module.exports, "ChampionKey", function () { return $080c873d6565577b$export$6743586dfba67091; });

var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $080c873d6565577b$var$wrap, unwrap: $080c873d6565577b$var$unwrap } = (0, $1k68G.iso)();
const $080c873d6565577b$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $080c873d6565577b$var$fromStringCodec = $jPaL5.make((0, $f5id0.pipe)((0, $hHBpg.NumberFromString).decoder, $4BSZX.map($080c873d6565577b$var$wrap)), {
    encode: String
});
const $080c873d6565577b$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($080c873d6565577b$var$unwrap));
const $080c873d6565577b$export$6743586dfba67091 = (0, $sjwE0.immutableAssign)($080c873d6565577b$var$wrap, {
    unwrap: $080c873d6565577b$var$unwrap,
    codec: $080c873d6565577b$var$codec,
    fromStringCodec: $080c873d6565577b$var$fromStringCodec,
    Eq: $080c873d6565577b$var$Eq
});

});

parcelRegister("iGStR", function(module, exports) {

$parcel$export(module.exports, "StaticData", function () { return $6947b08a0a5e378a$export$6dbc8f75f0b63bf9; });

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $1xLAE = parcelRequire("1xLAE");

var $25oLT = parcelRequire("25oLT");
const $6947b08a0a5e378a$var$codec = $jPaL5.struct({
    version: (0, $1xLAE.DDragonVersion).codec,
    champions: (0, $sjwE0.List).codec((0, $25oLT.StaticDataChampion).codec)
});
const $6947b08a0a5e378a$export$6dbc8f75f0b63bf9 = {
    codec: $6947b08a0a5e378a$var$codec
};

});
parcelRegister("1xLAE", function(module, exports) {

$parcel$export(module.exports, "DDragonVersion", function () { return $44ed42387fbe5c38$export$3fff7f6212ffbb69; });

var $kJAjV = parcelRequire("kJAjV");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $hHBpg = parcelRequire("hHBpg");
const { unwrap: $44ed42387fbe5c38$var$unwrap } = (0, $1k68G.iso)();
const $44ed42387fbe5c38$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $44ed42387fbe5c38$var$Eq = (0, $f5id0.pipe)((0, $68YxT).Eq, (0, $kJAjV).contramap($44ed42387fbe5c38$var$unwrap));
const $44ed42387fbe5c38$export$3fff7f6212ffbb69 = {
    codec: $44ed42387fbe5c38$var$codec,
    Eq: $44ed42387fbe5c38$var$Eq
};

});

parcelRegister("25oLT", function(module, exports) {

$parcel$export(module.exports, "StaticDataChampion", function () { return $4efc74a4654369a4$export$1f782643d91c024c; });

var $12uqT = parcelRequire("12uqT");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $jX7N3 = parcelRequire("jX7N3");

var $vkIKL = parcelRequire("vkIKL");

var $hIfPn = parcelRequire("hIfPn");

var $br0yu = parcelRequire("br0yu");

var $65UVg = parcelRequire("65UVg");
const $4efc74a4654369a4$var$codec = $jPaL5.struct({
    id: (0, $hIfPn.ChampionId).codec,
    key: (0, $br0yu.ChampionKey).codec,
    name: $jPaL5.string,
    positions: (0, $sjwE0.List).codec((0, $65UVg.ChampionPosition).codec),
    factions: (0, $sjwE0.List).codec((0, $vkIKL.ChampionFaction).codec),
    aram: (0, $jX7N3.MapChangesData).codec,
    urf: (0, $jX7N3.MapChangesData).codec
});
const $4efc74a4654369a4$var$getFaction = (0, $f5id0.flow)((0, $sjwE0.List).head, (0, $sjwE0.Maybe).getOrElse(()=>'none'));
const $4efc74a4654369a4$var$byName = (0, $f5id0.pipe)((0, $68YxT).Ord, (0, $12uqT).contramap((c)=>(0, $dOJeV.StringUtils).cleanUTF8ToASCII(c.name)));
const $4efc74a4654369a4$export$1f782643d91c024c = {
    codec: $4efc74a4654369a4$var$codec,
    getFaction: $4efc74a4654369a4$var$getFaction,
    Ord: {
        byName: $4efc74a4654369a4$var$byName
    }
};

});
parcelRegister("jX7N3", function(module, exports) {

$parcel$export(module.exports, "MapChangesData", function () { return $059aeef721e4cb7a$export$22f9c37e0e6f8419; });

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $2DVbf = parcelRequire("2DVbf");

var $lyBkQ = parcelRequire("lyBkQ");

var $jTWFQ = parcelRequire("jTWFQ");
const $059aeef721e4cb7a$var$mapChangesDataAbilityCodec = $jPaL5.struct({
    icon: $jPaL5.string,
    description: $jPaL5.string
});
const $059aeef721e4cb7a$var$abilitiesCodec = (0, $hHBpg.MapFromArray).codec((0, $sjwE0.idcOrd)((0, $lyBkQ.Ability).Eq))((0, $lyBkQ.Ability).codec, $059aeef721e4cb7a$var$mapChangesDataAbilityCodec);
const $059aeef721e4cb7a$var$skillCodec = $jPaL5.struct({
    name: (0, $lyBkQ.Ability).codec,
    icon: $jPaL5.string,
    abilities: $059aeef721e4cb7a$var$abilitiesCodec
});
const $059aeef721e4cb7a$var$skillsProperties = (0, $f5id0.pipe)((0, $jTWFQ.Skill).values, (0, $sjwE0.List).reduce((0, $sjwE0.Dict).empty(), (acc, skill)=>({
        ...acc,
        [skill]: $059aeef721e4cb7a$var$skillCodec
    })));
const $059aeef721e4cb7a$var$skillsCodec = $jPaL5.partial($059aeef721e4cb7a$var$skillsProperties);
const $059aeef721e4cb7a$var$codec = $jPaL5.struct({
    stats: (0, $sjwE0.Maybe).codec((0, $2DVbf.WikiStatsBalance).codec),
    skills: (0, $sjwE0.Maybe).codec($059aeef721e4cb7a$var$skillsCodec)
});
const $059aeef721e4cb7a$var$empty = {
    stats: (0, $sjwE0.Maybe).none,
    skills: (0, $sjwE0.Maybe).none
};
const $059aeef721e4cb7a$export$22f9c37e0e6f8419 = {
    codec: $059aeef721e4cb7a$var$codec,
    empty: $059aeef721e4cb7a$var$empty
};

});
parcelRegister("2DVbf", function(module, exports) {

$parcel$export(module.exports, "WikiStatsBalance", function () { return $4a4bed23f5e95d45$export$35c2593264a51fd1; });

var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $895LH = parcelRequire("895LH");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const $4a4bed23f5e95d45$var$properties = {
    dmg_dealt: $jPaL5.number,
    dmg_taken: $jPaL5.number,
    healing: $jPaL5.number,
    shielding: $jPaL5.number,
    ability_haste: $jPaL5.number,
    energyregen_mod: $jPaL5.number,
    total_as: $jPaL5.number,
    movement_speed: $jPaL5.number,
    tenacity: $jPaL5.number
};
const $4a4bed23f5e95d45$var$rawCodec = (0, $hHBpg.StrictPartial).codec($4a4bed23f5e95d45$var$properties);
const $4a4bed23f5e95d45$var$codec = $jPaL5.make((0, $f5id0.pipe)($4a4bed23f5e95d45$var$rawCodec, $4BSZX.map((0, $f5id0.flow)((0, $895LH.DictUtils).partial.entries, (0, $sjwE0.List).reduce({}, (acc, [key, val])=>{
    if (val === undefined) return acc;
    if ($4a4bed23f5e95d45$var$isModifierStat(key)) {
        if (val === 1) return acc;
    } else {
        if (val === 0) return acc;
    }
    return {
        ...acc,
        [key]: val
    };
})))), $4a4bed23f5e95d45$var$rawCodec);
const $4a4bed23f5e95d45$var$Eq = (0, $68YxT).Eq;
const $4a4bed23f5e95d45$var$keys = (0, $895LH.DictUtils).keys($4a4bed23f5e95d45$var$properties);
const $4a4bed23f5e95d45$var$modifierStats = [
    'dmg_dealt',
    'dmg_taken',
    'healing',
    'shielding',
    'energyregen_mod',
    'total_as',
    'movement_speed',
    'tenacity'
];
const $4a4bed23f5e95d45$var$percentsStats = (0, $f5id0.pipe)($4a4bed23f5e95d45$var$modifierStats, (0, $sjwE0.List).difference($4a4bed23f5e95d45$var$Eq)([
    'tenacity'
]));
const $4a4bed23f5e95d45$var$malusStats = [
    'dmg_taken'
];
const $4a4bed23f5e95d45$var$isModifierStat = (stat)=>(0, $sjwE0.List).elem($4a4bed23f5e95d45$var$Eq)(stat, $4a4bed23f5e95d45$var$modifierStats);
const $4a4bed23f5e95d45$var$isPercentsStat = (stat)=>(0, $sjwE0.List).elem($4a4bed23f5e95d45$var$Eq)(stat, $4a4bed23f5e95d45$var$percentsStats);
const $4a4bed23f5e95d45$var$isMalusStat = (stat)=>(0, $sjwE0.List).elem($4a4bed23f5e95d45$var$Eq)(stat, $4a4bed23f5e95d45$var$malusStats);
const $4a4bed23f5e95d45$export$35c2593264a51fd1 = {
    keys: $4a4bed23f5e95d45$var$keys,
    codec: $4a4bed23f5e95d45$var$codec,
    isModifierStat: $4a4bed23f5e95d45$var$isModifierStat,
    isPercentsStat: $4a4bed23f5e95d45$var$isPercentsStat,
    isMalusStat: $4a4bed23f5e95d45$var$isMalusStat,
    Eq: $4a4bed23f5e95d45$var$Eq
};

});

parcelRegister("lyBkQ", function(module, exports) {

$parcel$export(module.exports, "Ability", function () { return $7e182926cfd2de6c$export$b6ec296273510720; });

var $kJAjV = parcelRequire("kJAjV");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $7e182926cfd2de6c$var$wrap, unwrap: $7e182926cfd2de6c$var$unwrap } = (0, $1k68G.iso)();
const $7e182926cfd2de6c$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $7e182926cfd2de6c$var$Eq = (0, $f5id0.pipe)((0, $68YxT).Eq, (0, $kJAjV).contramap($7e182926cfd2de6c$var$unwrap));
const $7e182926cfd2de6c$export$b6ec296273510720 = (0, $sjwE0.immutableAssign)($7e182926cfd2de6c$var$wrap, {
    unwrap: $7e182926cfd2de6c$var$unwrap,
    codec: $7e182926cfd2de6c$var$codec,
    Eq: $7e182926cfd2de6c$var$Eq
});

});

parcelRegister("jTWFQ", function(module, exports) {

$parcel$export(module.exports, "Skill", function () { return $577e5c68307a7d94$export$118171a82d109c04; });

var $j839F = parcelRequire("j839F");
const $577e5c68307a7d94$var$e = (0, $j839F.createEnum)('I', 'Q', 'W', 'E', 'R');
const $577e5c68307a7d94$export$118171a82d109c04 = $577e5c68307a7d94$var$e;

});


parcelRegister("vkIKL", function(module, exports) {

$parcel$export(module.exports, "ChampionFaction", function () { return $0229db0ef4f672d6$export$e5c84eb6bac9e227; });
$parcel$export(module.exports, "ChampionFactionOrNone", function () { return $0229db0ef4f672d6$export$ceff5ef58cc8afca; });

var $f5id0 = parcelRequire("f5id0");

var $j839F = parcelRequire("j839F");

var $sjwE0 = parcelRequire("sjwE0");
const $0229db0ef4f672d6$var$e = (0, $j839F.createEnum)('bandle', 'bilgewater', 'demacia', 'freljord', 'ionia', 'ixtal', 'noxus', 'piltover', 'shadowIsles', 'shurima', 'targon', 'void', 'zaun');
const $0229db0ef4f672d6$export$e5c84eb6bac9e227 = $0229db0ef4f672d6$var$e;
const $0229db0ef4f672d6$var$eOrNone = (0, $j839F.createEnum)(...$0229db0ef4f672d6$var$e.values, 'none');
// sortBy, but always with 'none' as last
const $0229db0ef4f672d6$var$valuesSortBy = (ords)=>(0, $f5id0.pipe)($0229db0ef4f672d6$export$e5c84eb6bac9e227.values, (0, $sjwE0.List).sortBy(ords), (0, $sjwE0.List).append('none'));
const $0229db0ef4f672d6$export$ceff5ef58cc8afca = {
    ...$0229db0ef4f672d6$var$eOrNone,
    valuesSortBy: $0229db0ef4f672d6$var$valuesSortBy
};

});

parcelRegister("hIfPn", function(module, exports) {

$parcel$export(module.exports, "ChampionId", function () { return $62c4ed1da9bbd775$export$4a330e2d617c0861; });

var $jPaL5 = parcelRequire("jPaL5");

var $hHBpg = parcelRequire("hHBpg");
const $62c4ed1da9bbd775$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $62c4ed1da9bbd775$export$4a330e2d617c0861 = {
    codec: $62c4ed1da9bbd775$var$codec
};

});

parcelRegister("65UVg", function(module, exports) {

$parcel$export(module.exports, "ChampionPosition", function () { return $a5ee057bfcde8b9f$export$a7d164f5e8c25a4d; });

var $j839F = parcelRequire("j839F");
const $a5ee057bfcde8b9f$var$e = (0, $j839F.createEnum)('top', 'jun', 'mid', 'bot', 'sup');
const $a5ee057bfcde8b9f$export$a7d164f5e8c25a4d = $a5ee057bfcde8b9f$var$e;

});



parcelRegister("aGpBO", function(module, exports) {

$parcel$export(module.exports, "DDragonUtils", function () { return $9bcd1f7ad3c65eb8$export$c5501039374a79ad; });
const $9bcd1f7ad3c65eb8$var$ddragon = (path)=>`https://ddragon.leagueoflegends.com${path}`;
const $9bcd1f7ad3c65eb8$var$ddragonCdn = (version, path)=>$9bcd1f7ad3c65eb8$var$ddragon(`/cdn/${version}${path}`);
const $9bcd1f7ad3c65eb8$export$c5501039374a79ad = {
    ddragon: $9bcd1f7ad3c65eb8$var$ddragon,
    ddragonCdn: $9bcd1f7ad3c65eb8$var$ddragonCdn
};

});

parcelRegister("iPRex", function(module, exports) {

$parcel$export(module.exports, "ListUtils", function () { return $9fa570a1318b4cdc$export$f2e7765fb620050; });

var $10ZIc = parcelRequire("10ZIc");
var $12uqT = parcelRequire("12uqT");
var $4CDo2 = parcelRequire("4CDo2");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
const $9fa570a1318b4cdc$var$findFirstBy = (eq)=>(f)=>(as)=>(value)=>(0, $f5id0.pipe)(as, (0, $sjwE0.List).findFirst((v)=>eq.equals(f(v), value)));
const $9fa570a1318b4cdc$var$findFirstWithIndex = (predicate)=>(as)=>(0, $f5id0.pipe)(as, (0, $sjwE0.List).findIndex(predicate), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $sjwE0.Maybe).map((i)=>(0, $sjwE0.Tuple).of(i, as[i])));
const $9fa570a1318b4cdc$var$findFirstWithPrevious = (f)=>(as)=>{
        // eslint-disable-next-line functional/no-let
        let prev = (0, $sjwE0.Maybe).none;
        return (0, $f5id0.pipe)(as, (0, $sjwE0.List).findFirst((a)=>{
            const res = f(prev, a);
            // eslint-disable-next-line functional/no-expression-statements
            prev = (0, $sjwE0.Maybe).some(a);
            return res;
        }));
    };
const $9fa570a1318b4cdc$var$groupByAsMap = (eq)=>(f)=>(as)=>(0, $f5id0.pipe)(as, (0, $sjwE0.List).map((0, $f5id0.flow)(f, (0, $sjwE0.Tuple).mapSnd((0, $sjwE0.NonEmptyArray).of))), (0, $4CDo2).fromFoldable(eq, (0, $sjwE0.NonEmptyArray).getSemigroup(), (0, $sjwE0.List).Foldable));
const $9fa570a1318b4cdc$var$mapWithPrevious = (f)=>(as)=>{
        // eslint-disable-next-line functional/no-let
        let prev = (0, $sjwE0.Maybe).none;
        return (0, $f5id0.pipe)(as, (0, $sjwE0.List).map((a)=>{
            const res = f(prev, a);
            // eslint-disable-next-line functional/no-expression-statements
            prev = (0, $sjwE0.Maybe).some(a);
            return res;
        }));
    };
const $9fa570a1318b4cdc$var$multipleGroupBy = (f)=>(as)=>{
        const out = {};
        /* eslint-disable functional/no-loop-statements */ for (const a of as){
            const ks = f(a);
            for (const k of ks)/* eslint-enable functional/no-loop-statements */ if ($9fa570a1318b4cdc$var$has.call(out, k)) /* eslint-disable functional/no-expression-statements */ // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            out[k].push(a);
            else // eslint-disable-next-line functional/immutable-data
            out[k] = [
                a
            ];
        }
        return out;
    };
const $9fa570a1318b4cdc$var$updateOrAppend = (eq)=>(a)=>(as)=>(0, $f5id0.pipe)(as, (0, $sjwE0.List).findIndex((a_)=>eq.equals(a_, a)), (0, $sjwE0.Maybe).fold(()=>(0, $f5id0.pipe)(as, (0, $sjwE0.List).append(a)), (i)=>(0, $sjwE0.List).unsafeUpdateAt(i, a, as)));
const $9fa570a1318b4cdc$var$padEnd = (maxLength, fillWith)=>(as)=>maxLength <= as.length ? as : (0, $f5id0.pipe)(as, (0, $sjwE0.List).concatW((0, $sjwE0.List).makeBy(maxLength - as.length, ()=>fillWith)));
const $9fa570a1318b4cdc$var$listLengthOrd = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((0, $sjwE0.List).size));
const $9fa570a1318b4cdc$var$commonElems = (eq)=>(as)=>{
        if (!(0, $sjwE0.List).isNonEmpty(as)) return [];
        if (as.length === 1) return (0, $sjwE0.NonEmptyArray).head(as);
        const [shortest, remain] = (0, $f5id0.pipe)(as, (0, $sjwE0.NonEmptyArray).sort($9fa570a1318b4cdc$var$listLengthOrd), (0, $sjwE0.NonEmptyArray).unprepend);
        if (!(0, $sjwE0.List).isNonEmpty(shortest)) return [];
        return (0, $f5id0.pipe)(shortest, (0, $sjwE0.List).filter((a)=>(0, $f5id0.pipe)(remain, (0, $sjwE0.List).every((0, $sjwE0.List).elem(eq)(a)))), (0, $sjwE0.List).uniq(eq));
    };
/**
 * https://github.com/granteagon/move/blob/master/src/index.js
 *
 * Note: This is a pure function so a new array will be returned, instead of altering the array argument.
 *
 * @param as Array in which to move an item.
 * @param moveIndex The index of the item to move.
 * @param toIndex The index to move item at moveIndex to.
 * @returns
 */ const $9fa570a1318b4cdc$var$move = (as, moveIndex, toIndex)=>{
    const item = as[moveIndex];
    const length = as.length;
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...as.slice(0, toIndex),
        item,
        ...as.slice(toIndex, moveIndex),
        ...as.slice(moveIndex + 1, length)
    ];
    if (diff < 0) {
        // move right
        const targetIndex = toIndex + 1;
        return [
            ...as.slice(0, moveIndex),
            ...as.slice(moveIndex + 1, targetIndex),
            item,
            ...as.slice(targetIndex, length)
        ];
    }
    return as;
};
const $9fa570a1318b4cdc$var$swap = (as, swapIndex, toIndex)=>{
    const res = as.slice();
    /* eslint-disable @typescript-eslint/no-non-null-assertion, functional/no-expression-statements, functional/immutable-data */ res[swapIndex] = as[toIndex];
    res[toIndex] = as[swapIndex];
    /* eslint-enable functional/no-expression-statements, functional/immutable-data */ return res;
};
const $9fa570a1318b4cdc$export$f2e7765fb620050 = {
    findFirstBy: $9fa570a1318b4cdc$var$findFirstBy,
    findFirstWithIndex: $9fa570a1318b4cdc$var$findFirstWithIndex,
    findFirstWithPrevious: $9fa570a1318b4cdc$var$findFirstWithPrevious,
    groupByAsMap: $9fa570a1318b4cdc$var$groupByAsMap,
    mapWithPrevious: $9fa570a1318b4cdc$var$mapWithPrevious,
    multipleGroupBy: $9fa570a1318b4cdc$var$multipleGroupBy,
    updateOrAppend: $9fa570a1318b4cdc$var$updateOrAppend,
    padEnd: $9fa570a1318b4cdc$var$padEnd,
    commonElems: $9fa570a1318b4cdc$var$commonElems,
    move: $9fa570a1318b4cdc$var$move,
    swap: $9fa570a1318b4cdc$var$swap
};
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9fa570a1318b4cdc$var$has = Object.prototype.hasOwnProperty;

});

parcelRegister("9g4gL", function(module, exports) {

$parcel$export(module.exports, "AsyncRenderer", function () { return $16fce0a8bf62143a$export$e13071d3daf42cea; });

var $ih19M = parcelRequire("ih19M");

var $jFuet = parcelRequire("jFuet");

var $4MEuc = parcelRequire("4MEuc");

var $fVW4p = parcelRequire("fVW4p");

var $kmQDF = parcelRequire("kmQDF");
function $16fce0a8bf62143a$export$e13071d3daf42cea({ data: data, error: error, children: children }) {
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    if (error !== undefined) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex justify-center",
        children: error instanceof (0, $jFuet.HTTPError) && error.response.status === 404 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmQDF.Pre), {
            className: "mt-4",
            children: t.notFound
        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmQDF.Pre), {
            className: "mt-4",
            children: t.error
        })
    });
    if (data === undefined) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
            className: "mt-4 h-6"
        })
    });
    return children(data);
}

});
parcelRegister("jFuet", function(module, exports) {

$parcel$export(module.exports, "HTTPError", function () { return $e5194c33f09c98c1$export$aa9d629c530f62a7; });
class $e5194c33f09c98c1$export$aa9d629c530f62a7 extends Error {
    response;
    request;
    options;
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText || '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}: ${request.method} ${request.url}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
    }
}

});

parcelRegister("4MEuc", function(module, exports) {

$parcel$export(module.exports, "TranslationContextProvider", function () { return $bc06d0c62b757e4a$export$6dd9d1cecb6d3d0; });
$parcel$export(module.exports, "useTranslation", function () { return $bc06d0c62b757e4a$export$9fc83ad70ead8663; });

var $ih19M = parcelRequire("ih19M");

var $6omhk = parcelRequire("6omhk");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $3WFZ7 = parcelRequire("3WFZ7");

var $ewM3A = parcelRequire("ewM3A");

var $fVW4p = parcelRequire("fVW4p");

var $kmQDF = parcelRequire("kmQDF");

var $854vE = parcelRequire("854vE");


const $bc06d0c62b757e4a$var$translations = {
    en_GB: $bc06d0c62b757e4a$var$tDefault(()=>(parcelRequire("82Y20"))),
    fr_FR: $bc06d0c62b757e4a$var$tDefault(()=>(parcelRequire("lU3mG")))
};
const $bc06d0c62b757e4a$var$languageKey = 'language';
const $bc06d0c62b757e4a$var$TranslationContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
const $bc06d0c62b757e4a$export$6dd9d1cecb6d3d0 = ({ children: children })=>{
    const [lang, setLang] = (0, $854vE.useLocalStorageState)($bc06d0c62b757e4a$var$languageKey, [
        (0, $ewM3A.Lang).codec,
        'Lang'
    ], (0, $ewM3A.Lang).fromNavigatorLanguage(window.navigator.language));
    const { data: data, error: error } = (0, $3WFZ7.default)([
        lang
    ], ([lang_])=>$bc06d0c62b757e4a$var$translations[lang_]());
    if (error !== undefined) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmQDF.Pre), {
            className: "mt-4",
            children: "error."
        })
    });
    if (data === undefined) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
            className: "mt-4 h-6"
        })
    });
    const value = {
        lang: lang,
        setLang: setLang,
        t: data
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($bc06d0c62b757e4a$var$TranslationContext.Provider, {
        value: value,
        children: children
    });
};
function $bc06d0c62b757e4a$export$9fc83ad70ead8663(key) {
    const context = (0, $bh6RR.useContext)($bc06d0c62b757e4a$var$TranslationContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useTranslation must be used within a TranslationContextProvider');
    if (key === undefined) return context;
    const { t: t, ...context_ } = context;
    return {
        ...context_,
        t: t[key]
    };
}
function $bc06d0c62b757e4a$var$tDefault(fa) {
    return (0, $f5id0.pipe)(fa, (0, $6omhk).map((t)=>t.default));
}

});
parcelRegister("3WFZ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $262e48cb5db1fd25$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $hVYK3 = parcelRequire("hVYK3");

var $c6b4G = parcelRequire("c6b4G");parcelRequire("yr2dg");
var $c6b4G = parcelRequire("c6b4G");
var $yr2dg = parcelRequire("yr2dg");
var $kps74 = parcelRequire("kps74");
// Shared state between server components and client components
const $262e48cb5db1fd25$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $262e48cb5db1fd25$var$UNDEFINED = /*#__NOINLINE__*/ $262e48cb5db1fd25$var$noop();
const $262e48cb5db1fd25$var$OBJECT = Object;
const $262e48cb5db1fd25$var$isUndefined = (v)=>v === $262e48cb5db1fd25$var$UNDEFINED;
const $262e48cb5db1fd25$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $262e48cb5db1fd25$var$table = new WeakMap();
const $262e48cb5db1fd25$var$isObjectType = (value, type)=>$262e48cb5db1fd25$var$OBJECT.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $262e48cb5db1fd25$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $262e48cb5db1fd25$var$stableHash = (arg)=>{
    const type = typeof arg;
    const isDate = $262e48cb5db1fd25$var$isObjectType(arg, 'Date');
    const isRegex = $262e48cb5db1fd25$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $262e48cb5db1fd25$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($262e48cb5db1fd25$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $262e48cb5db1fd25$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$262e48cb5db1fd25$var$counter + '~';
        $262e48cb5db1fd25$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $262e48cb5db1fd25$var$stableHash(arg[index]) + ',';
            $262e48cb5db1fd25$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $262e48cb5db1fd25$var$OBJECT.keys(arg).sort();
            while(!$262e48cb5db1fd25$var$isUndefined(index = keys.pop()))if (!$262e48cb5db1fd25$var$isUndefined(arg[index])) result += index + ':' + $262e48cb5db1fd25$var$stableHash(arg[index]) + ',';
            $262e48cb5db1fd25$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $262e48cb5db1fd25$var$serialize = (key)=>{
    if ($262e48cb5db1fd25$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $262e48cb5db1fd25$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $262e48cb5db1fd25$export$dbab534a48e651ef = (key)=>$262e48cb5db1fd25$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $262e48cb5db1fd25$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $262e48cb5db1fd25$var$WITH_DEDUPE = {
    dedupe: true
};
const $262e48cb5db1fd25$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $c6b4G.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $c6b4G.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $bh6RR.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $bh6RR.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $bh6RR.useRef)(key);
    const fetcherRef = (0, $bh6RR.useRef)(fetcher);
    const configRef = (0, $bh6RR.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $c6b4G.z)(cache, key);
    const stateDependencies = (0, $bh6RR.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $c6b4G.e)(fallbackData) ? (0, $c6b4G.e)(config.fallback) ? (0, $c6b4G.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $c6b4G.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $bh6RR.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $c6b4G.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $c6b4G.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $hVYK3.useSyncExternalStore)((0, $bh6RR.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $c6b4G.e)(cachedData) ? fallback && (0, $c6b4G.B)(fallback) ? $262e48cb5db1fd25$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $bh6RR.useRef)(data);
    const returnedData = keepPreviousData ? (0, $c6b4G.e)(cachedData) ? (0, $c6b4G.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $c6b4G.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $c6b4G.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $c6b4G.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $c6b4G.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $c6b4G.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $c6b4G.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $bh6RR.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $c6b4G.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $c6b4G.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $c6b4G.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $c6b4G.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $c6b4G.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $c6b4G.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $c6b4G.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $kps74).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $bh6RR.useCallback)((...args)=>{
        return (0, $c6b4G.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $c6b4G.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $c6b4G.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $c6b4G.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $c6b4G.U), $262e48cb5db1fd25$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $kps74).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $kps74).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $kps74).MUTATE_EVENT) return revalidate();
            else if (type == (0, $kps74).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $yr2dg.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $c6b4G.e)(data) || (0, $c6b4G.r)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $c6b4G.t)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $c6b4G.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $c6b4G.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($262e48cb5db1fd25$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $bh6RR.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $c6b4G.e)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $c6b4G.I) && (0, $c6b4G.r)) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $c6b4G.e)(req)) {
            const promise = boundMutate(req);
            $262e48cb5db1fd25$var$use(promise);
        }
        if ((0, $c6b4G.e)(error)) {
            const promise = revalidate($262e48cb5db1fd25$var$WITH_DEDUPE);
            if (!(0, $c6b4G.e)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $262e48cb5db1fd25$var$use(promise);
        } else throw error;
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $262e48cb5db1fd25$export$4c7bbecdacc3ca2c = (0, $c6b4G.O).defineProperty((0, $c6b4G.g), 'defaultValue', {
    value: (0, $c6b4G.d)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $262e48cb5db1fd25$export$2e2bcd8739ae039 = (0, $yr2dg.withArgs)($262e48cb5db1fd25$var$useSWRHandler);

});
parcelRegister("hVYK3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1JHgz"));

});
parcelRegister("1JHgz", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $143b8e347aaa867b$export$306c0aa65ff9ec16; }, function (v) { return $143b8e347aaa867b$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $143b8e347aaa867b$export$306c0aa65ff9ec16;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $143b8e347aaa867b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $143b8e347aaa867b$var$objectIs = "function" === typeof Object.is ? Object.is : $143b8e347aaa867b$var$is, $143b8e347aaa867b$var$useState = $bh6RR.useState, $143b8e347aaa867b$var$useEffect = $bh6RR.useEffect, $143b8e347aaa867b$var$useLayoutEffect = $bh6RR.useLayoutEffect, $143b8e347aaa867b$var$useDebugValue = $bh6RR.useDebugValue;
function $143b8e347aaa867b$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $143b8e347aaa867b$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $143b8e347aaa867b$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $143b8e347aaa867b$var$useEffect(function() {
        $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $143b8e347aaa867b$var$useDebugValue(value);
    return value;
}
function $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$143b8e347aaa867b$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $143b8e347aaa867b$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $143b8e347aaa867b$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $143b8e347aaa867b$var$useSyncExternalStore$1 : $143b8e347aaa867b$var$useSyncExternalStore$2;
$143b8e347aaa867b$export$306c0aa65ff9ec16 = void 0 !== $bh6RR.useSyncExternalStore ? $bh6RR.useSyncExternalStore : $143b8e347aaa867b$var$shim;

});


parcelRegister("c6b4G", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $b3da8f28cab7b4d7$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "U", function () { return $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "O", function () { return $b3da8f28cab7b4d7$export$c4ce752e73470fba; });
$parcel$export(module.exports, "e", function () { return $b3da8f28cab7b4d7$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $b3da8f28cab7b4d7$export$407448d2b89b1813; });
$parcel$export(module.exports, "m", function () { return $b3da8f28cab7b4d7$export$953cecd6e717a553; });
$parcel$export(module.exports, "B", function () { return $b3da8f28cab7b4d7$export$ef35774e6d314e91; });
$parcel$export(module.exports, "i", function () { return $b3da8f28cab7b4d7$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "z", function () { return $b3da8f28cab7b4d7$export$df995fae86a55f06; });
$parcel$export(module.exports, "I", function () { return $b3da8f28cab7b4d7$export$9bb611d729802a56; });
$parcel$export(module.exports, "r", function () { return $b3da8f28cab7b4d7$export$43caf9889c228507; });
$parcel$export(module.exports, "t", function () { return $b3da8f28cab7b4d7$export$625550452a3fa3ec; });
$parcel$export(module.exports, "u", function () { return $b3da8f28cab7b4d7$export$3b14a55fb2447963; });
$parcel$export(module.exports, "s", function () { return $b3da8f28cab7b4d7$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "o", function () { return $b3da8f28cab7b4d7$export$ae1af26003f05816; });
$parcel$export(module.exports, "n", function () { return $b3da8f28cab7b4d7$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "c", function () { return $b3da8f28cab7b4d7$export$db3b6bfb95261072; });
$parcel$export(module.exports, "d", function () { return $b3da8f28cab7b4d7$export$4368d992c4eafac0; });
$parcel$export(module.exports, "f", function () { return $b3da8f28cab7b4d7$export$2d1720544b23b823; });
$parcel$export(module.exports, "S", function () { return $b3da8f28cab7b4d7$export$25ce5a424b770e84; });
$parcel$export(module.exports, "g", function () { return $b3da8f28cab7b4d7$export$39b482c5e57630a8; });

var $bh6RR = parcelRequire("bh6RR");

var $kps74 = parcelRequire("kps74");

var $2HcVG = parcelRequire("2HcVG");
'use client';
// Global state used to deduplicate requests and store listeners
const $b3da8f28cab7b4d7$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $b3da8f28cab7b4d7$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $b3da8f28cab7b4d7$export$ebd11618f299a286();
const $b3da8f28cab7b4d7$export$c4ce752e73470fba = Object;
const $b3da8f28cab7b4d7$export$f1e1789686576879 = (v)=>v === $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08;
const $b3da8f28cab7b4d7$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $b3da8f28cab7b4d7$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $b3da8f28cab7b4d7$export$ef35774e6d314e91 = (x)=>$b3da8f28cab7b4d7$export$407448d2b89b1813(x.then);
const $b3da8f28cab7b4d7$var$EMPTY_CACHE = {};
const $b3da8f28cab7b4d7$var$INITIAL_CACHE = {};
const $b3da8f28cab7b4d7$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $b3da8f28cab7b4d7$export$23f2a1d2818174ef = typeof window != $b3da8f28cab7b4d7$var$STR_UNDEFINED;
const $b3da8f28cab7b4d7$export$efccba1c4a2ef57b = typeof document != $b3da8f28cab7b4d7$var$STR_UNDEFINED;
const $b3da8f28cab7b4d7$export$d141bba7fdc215a3 = $b3da8f28cab7b4d7$export$23f2a1d2818174ef && 'Deno' in window;
const $b3da8f28cab7b4d7$export$4a5767248b18ef41 = ()=>$b3da8f28cab7b4d7$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $b3da8f28cab7b4d7$var$STR_UNDEFINED;
const $b3da8f28cab7b4d7$export$df995fae86a55f06 = (cache, key)=>{
    const state = $b3da8f28cab7b4d7$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$b3da8f28cab7b4d7$export$f1e1789686576879(key) && cache.get(key) || $b3da8f28cab7b4d7$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$b3da8f28cab7b4d7$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $b3da8f28cab7b4d7$var$INITIAL_CACHE)) $b3da8f28cab7b4d7$var$INITIAL_CACHE[key] = prev;
                state[5](key, $b3da8f28cab7b4d7$export$953cecd6e717a553(prev, info), prev || $b3da8f28cab7b4d7$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$b3da8f28cab7b4d7$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $b3da8f28cab7b4d7$var$INITIAL_CACHE) return $b3da8f28cab7b4d7$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$b3da8f28cab7b4d7$export$f1e1789686576879(key) && cache.get(key) || $b3da8f28cab7b4d7$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $b3da8f28cab7b4d7$var$online = true;
const $b3da8f28cab7b4d7$var$isOnline = ()=>$b3da8f28cab7b4d7$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$b3da8f28cab7b4d7$var$onWindowEvent, $b3da8f28cab7b4d7$var$offWindowEvent] = $b3da8f28cab7b4d7$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $b3da8f28cab7b4d7$export$ebd11618f299a286,
    $b3da8f28cab7b4d7$export$ebd11618f299a286
];
const $b3da8f28cab7b4d7$var$isVisible = ()=>{
    const visibilityState = $b3da8f28cab7b4d7$export$efccba1c4a2ef57b && document.visibilityState;
    return $b3da8f28cab7b4d7$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $b3da8f28cab7b4d7$var$initFocus = (callback)=>{
    // focus revalidate
    if ($b3da8f28cab7b4d7$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $b3da8f28cab7b4d7$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($b3da8f28cab7b4d7$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $b3da8f28cab7b4d7$var$offWindowEvent('focus', callback);
    };
};
const $b3da8f28cab7b4d7$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $b3da8f28cab7b4d7$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $b3da8f28cab7b4d7$var$online = false;
    };
    $b3da8f28cab7b4d7$var$onWindowEvent('online', onOnline);
    $b3da8f28cab7b4d7$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $b3da8f28cab7b4d7$var$offWindowEvent('online', onOnline);
        $b3da8f28cab7b4d7$var$offWindowEvent('offline', onOffline);
    };
};
const $b3da8f28cab7b4d7$export$ffb5f4729a158638 = {
    isOnline: $b3da8f28cab7b4d7$var$isOnline,
    isVisible: $b3da8f28cab7b4d7$var$isVisible
};
const $b3da8f28cab7b4d7$export$9e5f44173e64f162 = {
    initFocus: $b3da8f28cab7b4d7$var$initFocus,
    initReconnect: $b3da8f28cab7b4d7$var$initReconnect
};
const $b3da8f28cab7b4d7$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useId;
const $b3da8f28cab7b4d7$export$43caf9889c228507 = !$b3da8f28cab7b4d7$export$23f2a1d2818174ef || $b3da8f28cab7b4d7$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $b3da8f28cab7b4d7$export$625550452a3fa3ec = (f)=>$b3da8f28cab7b4d7$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $b3da8f28cab7b4d7$export$3b14a55fb2447963 = $b3da8f28cab7b4d7$export$43caf9889c228507 ? (0, $bh6RR.useEffect) : (0, $bh6RR.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $b3da8f28cab7b4d7$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $b3da8f28cab7b4d7$export$90a7f3efeed30595 = !$b3da8f28cab7b4d7$export$43caf9889c228507 && $b3da8f28cab7b4d7$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($b3da8f28cab7b4d7$var$navigatorConnection.effectiveType) || $b3da8f28cab7b4d7$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $b3da8f28cab7b4d7$var$table = new WeakMap();
const $b3da8f28cab7b4d7$var$isObjectType = (value, type)=>$b3da8f28cab7b4d7$export$c4ce752e73470fba.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $b3da8f28cab7b4d7$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $b3da8f28cab7b4d7$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const isDate = $b3da8f28cab7b4d7$var$isObjectType(arg, 'Date');
    const isRegex = $b3da8f28cab7b4d7$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $b3da8f28cab7b4d7$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($b3da8f28cab7b4d7$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $b3da8f28cab7b4d7$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$b3da8f28cab7b4d7$var$counter + '~';
        $b3da8f28cab7b4d7$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $b3da8f28cab7b4d7$export$882b5998b3b9117c(arg[index]) + ',';
            $b3da8f28cab7b4d7$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $b3da8f28cab7b4d7$export$c4ce752e73470fba.keys(arg).sort();
            while(!$b3da8f28cab7b4d7$export$f1e1789686576879(index = keys.pop()))if (!$b3da8f28cab7b4d7$export$f1e1789686576879(arg[index])) result += index + ':' + $b3da8f28cab7b4d7$export$882b5998b3b9117c(arg[index]) + ',';
            $b3da8f28cab7b4d7$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $b3da8f28cab7b4d7$export$2408f22a0fab9ae5 = (key)=>{
    if ($b3da8f28cab7b4d7$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $b3da8f28cab7b4d7$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $b3da8f28cab7b4d7$var$__timestamp = 0;
const $b3da8f28cab7b4d7$export$ae1af26003f05816 = ()=>++$b3da8f28cab7b4d7$var$__timestamp;
async function $b3da8f28cab7b4d7$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $b3da8f28cab7b4d7$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($b3da8f28cab7b4d7$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $b3da8f28cab7b4d7$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $b3da8f28cab7b4d7$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $b3da8f28cab7b4d7$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $b3da8f28cab7b4d7$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($kps74.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $b3da8f28cab7b4d7$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$b3da8f28cab7b4d7$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $b3da8f28cab7b4d7$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $b3da8f28cab7b4d7$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($b3da8f28cab7b4d7$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $b3da8f28cab7b4d7$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($b3da8f28cab7b4d7$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08,
                        _c: $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08,
                    _c: $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $b3da8f28cab7b4d7$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $b3da8f28cab7b4d7$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $b3da8f28cab7b4d7$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$b3da8f28cab7b4d7$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $b3da8f28cab7b4d7$export$953cecd6e717a553($b3da8f28cab7b4d7$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $b3da8f28cab7b4d7$export$7ccc53e8f1e7dfc5.bind($b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08, provider);
        let unmount = $b3da8f28cab7b4d7$export$ebd11618f299a286;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$b3da8f28cab7b4d7$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $b3da8f28cab7b4d7$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$b3da8f28cab7b4d7$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08, $b3da8f28cab7b4d7$var$revalidateAllKeys.bind($b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $kps74.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08, $b3da8f28cab7b4d7$var$revalidateAllKeys.bind($b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $kps74.RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $b3da8f28cab7b4d7$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $b3da8f28cab7b4d7$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $b3da8f28cab7b4d7$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$b3da8f28cab7b4d7$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $b3da8f28cab7b4d7$export$342063e11d6c3cad = (0, $2HcVG.dequal);
// Default cache provider
const [$b3da8f28cab7b4d7$export$db3b6bfb95261072, $b3da8f28cab7b4d7$export$35e795649ee09318] = $b3da8f28cab7b4d7$export$dda1d9f60106f0e9(new Map());
// Default config
const $b3da8f28cab7b4d7$export$4368d992c4eafac0 = $b3da8f28cab7b4d7$export$953cecd6e717a553({
    // events
    onLoadingSlow: $b3da8f28cab7b4d7$export$ebd11618f299a286,
    onSuccess: $b3da8f28cab7b4d7$export$ebd11618f299a286,
    onError: $b3da8f28cab7b4d7$export$ebd11618f299a286,
    onErrorRetry: $b3da8f28cab7b4d7$var$onErrorRetry,
    onDiscarded: $b3da8f28cab7b4d7$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $b3da8f28cab7b4d7$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $b3da8f28cab7b4d7$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $b3da8f28cab7b4d7$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $b3da8f28cab7b4d7$export$db3b6bfb95261072,
    mutate: $b3da8f28cab7b4d7$export$35e795649ee09318,
    fallback: {}
}, $b3da8f28cab7b4d7$export$ffb5f4729a158638);
const $b3da8f28cab7b4d7$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $b3da8f28cab7b4d7$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $b3da8f28cab7b4d7$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $b3da8f28cab7b4d7$export$25ce5a424b770e84 = (0, $bh6RR.createContext)({});
const $b3da8f28cab7b4d7$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $bh6RR.useContext)($b3da8f28cab7b4d7$export$25ce5a424b770e84);
    const isFunctionalConfig = $b3da8f28cab7b4d7$export$407448d2b89b1813(value);
    const config = (0, $bh6RR.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $bh6RR.useMemo)(()=>isFunctionalConfig ? config : $b3da8f28cab7b4d7$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $bh6RR.useRef)($b3da8f28cab7b4d7$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $b3da8f28cab7b4d7$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $b3da8f28cab7b4d7$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $b3da8f28cab7b4d7$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $bh6RR.createElement)($b3da8f28cab7b4d7$export$25ce5a424b770e84.Provider, $b3da8f28cab7b4d7$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};

});
parcelRegister("kps74", function(module, exports) {

$parcel$export(module.exports, "FOCUS_EVENT", function () { return $80891d2696501c51$export$831c820ad60f9d12; });
$parcel$export(module.exports, "RECONNECT_EVENT", function () { return $80891d2696501c51$export$24e9454cb99a11dc; });
$parcel$export(module.exports, "MUTATE_EVENT", function () { return $80891d2696501c51$export$75ea288459391154; });
$parcel$export(module.exports, "ERROR_REVALIDATE_EVENT", function () { return $80891d2696501c51$export$b019c3839228f243; });
const $80891d2696501c51$export$831c820ad60f9d12 = 0;
const $80891d2696501c51$export$24e9454cb99a11dc = 1;
const $80891d2696501c51$export$75ea288459391154 = 2;
const $80891d2696501c51$export$b019c3839228f243 = 3;

});

parcelRegister("2HcVG", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $ca54f9897a47d81e$export$de8294bb3be0322f; });
var $ca54f9897a47d81e$var$has = Object.prototype.hasOwnProperty;
function $ca54f9897a47d81e$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $ca54f9897a47d81e$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($ca54f9897a47d81e$var$has.call(foo, ctor) && ++len && !$ca54f9897a47d81e$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$ca54f9897a47d81e$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("yr2dg", function(module, exports) {

$parcel$export(module.exports, "useSWRConfig", function () { return $df6da0731a166f07$export$f1dc0e282d4c1c0; });
$parcel$export(module.exports, "withArgs", function () { return $df6da0731a166f07$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $df6da0731a166f07$export$e005210ed621746; });
$parcel$export(module.exports, "SWRGlobalState", function () { return (parcelRequire("c6b4G")).b; });
$parcel$export(module.exports, "defaultConfig", function () { return (parcelRequire("c6b4G")).d; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("c6b4G")).a; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("c6b4G")).e; });
$parcel$export(module.exports, "mergeObjects", function () { return (parcelRequire("c6b4G")).m; });
$parcel$export(module.exports, "serialize", function () { return (parcelRequire("c6b4G")).s; });

var $c6b4G = parcelRequire("c6b4G");

var $kps74 = parcelRequire("kps74");

var $lFZPo = parcelRequire("lFZPo");

var $bh6RR = parcelRequire("bh6RR");

// @ts-expect-error
const $df6da0731a166f07$var$enableDevtools = (0, $c6b4G.i) && window.__SWR_DEVTOOLS_USE__;
const $df6da0731a166f07$var$use = $df6da0731a166f07$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $df6da0731a166f07$var$setupDevTools = ()=>{
    if ($df6da0731a166f07$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)));
};
const $df6da0731a166f07$export$a3295358bff77e = (args)=>{
    return (0, $c6b4G.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $df6da0731a166f07$export$f1dc0e282d4c1c0 = ()=>{
    return (0, $c6b4G.m)((0, $c6b4G.d), (0, $bh6RR.useContext)((0, $c6b4G.S)));
};
const $df6da0731a166f07$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $c6b4G.s)(key_);
    const [, , , PRELOAD] = (0, $c6b4G.b).get((0, $c6b4G.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $df6da0731a166f07$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $c6b4G.s)(key_);
            const [, , , PRELOAD] = (0, $c6b4G.b).get((0, $c6b4G.c));
            if (key.startsWith((0, $lFZPo.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $c6b4G.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $df6da0731a166f07$var$BUILT_IN_MIDDLEWARE = $df6da0731a166f07$var$use.concat($df6da0731a166f07$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $df6da0731a166f07$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $df6da0731a166f07$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $df6da0731a166f07$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $c6b4G.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($df6da0731a166f07$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $df6da0731a166f07$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $df6da0731a166f07$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $df6da0731a166f07$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$df6da0731a166f07$var$setupDevTools();

});
parcelRegister("lFZPo", function(module, exports) {

$parcel$export(module.exports, "INFINITE_PREFIX", function () { return $21729f084729e9bb$export$8667f065faedc62c; });
const $21729f084729e9bb$export$8667f065faedc62c = '$inf$';

});



parcelRegister("fVW4p", function(module, exports) {

$parcel$export(module.exports, "Loading", function () { return $d4a11b4bb1687b2f$export$669f6ea7d267feaf; });

var $ih19M = parcelRequire("ih19M");

var $jK7ok = parcelRequire("jK7ok");
const $d4a11b4bb1687b2f$export$669f6ea7d267feaf = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        className: (0, $jK7ok.cx)('animate-spin', className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "4",
                opacity: 0.25
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                fill: "currentColor",
                opacity: 0.75
            })
        ]
    });

});
parcelRegister("jK7ok", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $f40bea1f709d5715$export$a274e22fb40f762e; });

var $sjwE0 = parcelRequire("sjwE0");
function $f40bea1f709d5715$export$a274e22fb40f762e(...c) {
    const classes = c.flatMap((arg)=>{
        if (arg === undefined) return [];
        if (typeof arg === 'string') return [
            arg
        ];
        if ($f40bea1f709d5715$var$isArray(arg)) {
            const [className, display] = arg;
            if (className === undefined || !display) return [];
            return [
                className
            ];
        }
        return (0, $sjwE0.Dict).toReadonlyArray(arg).flatMap(([className, display])=>display ? [
                className
            ] : []);
    });
    if ((0, $sjwE0.List).isEmpty(classes)) return undefined;
    return classes.join(' ');
}
const $f40bea1f709d5715$var$isArray = Array.isArray;

});


parcelRegister("kmQDF", function(module, exports) {

$parcel$export(module.exports, "Pre", function () { return $744d81c5cde218d5$export$bba54bd7e8a0d398; });

var $ih19M = parcelRequire("ih19M");

var $jK7ok = parcelRequire("jK7ok");
const $744d81c5cde218d5$export$bba54bd7e8a0d398 = ({ className: className, children: children, ...props })=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: (0, $jK7ok.cx)('font-lib-mono', className),
        ...props,
        children: children
    });

});

parcelRegister("854vE", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageState", function () { return $5be45cbf92b114ed$export$b313845ce8fd18ca; });

var $aUw4I = parcelRequire("aUw4I");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const $5be45cbf92b114ed$export$b313845ce8fd18ca = (key, [codec, codecName], initialState)=>{
    const [a, setA] = (0, $bh6RR.useState)(()=>{
        const item = localStorage.getItem(key);
        if (item === null) return $5be45cbf92b114ed$var$init(initialState);
        return (0, $f5id0.pipe)((0, $aUw4I).parse(item), (0, $sjwE0.Either).mapLeft((0, $sjwE0.Either).toError), (0, $sjwE0.Either).chain((u)=>(0, $f5id0.pipe)(codec.decode(u), (0, $sjwE0.Either).mapLeft((0, $hHBpg.decodeError)(codecName)(u)))), (0, $sjwE0.Either).getOrElse((e)=>{
            console.warn('useLocalStorageState: error while reading from localStorage', e);
            return $5be45cbf92b114ed$var$init(initialState);
        }));
    });
    (0, $bh6RR.useEffect)(()=>(0, $f5id0.pipe)(codec.encode(a), (0, $aUw4I).stringify, (0, $sjwE0.Either).mapLeft((0, $sjwE0.Either).toError), (0, $sjwE0.Either).fold((e)=>console.warn('useLocalStorageState: error while writing to localStorage', e), (str)=>localStorage.setItem(key, str))), [
        a,
        codec,
        key
    ]);
    return [
        a,
        setA
    ];
};
const $5be45cbf92b114ed$var$init = (a)=>$5be45cbf92b114ed$var$isFunction(a) ? a() : a;
const $5be45cbf92b114ed$var$isFunction = (a)=>typeof a === 'function';

});

parcelRegister("82Y20", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("c4nBX").then(()=>parcelRequire('2OvSu'));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("lU3mG", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("8exhq").then(()=>parcelRequire('hsdnt'));

});



parcelRegister("7Dhdf", function(module, exports) {

$parcel$export(module.exports, "useSWRHttp", function () { return $e279bf4fec177686$export$4d6a303bc40d3272; });

var $3WFZ7 = parcelRequire("3WFZ7");

var $c6xfg = parcelRequire("c6xfg");

var $7VlB6 = parcelRequire("7VlB6");

var $2sln7 = parcelRequire("2sln7");
const $e279bf4fec177686$export$4d6a303bc40d3272 = (urlWithMethod, httpOptions, decoderWithName, swrOptions)=>(0, $3WFZ7.default)(urlWithMethod, (urlWithMethod_)=>(0, $7VlB6.futureRunUnsafe)((0, $2sln7.http)(urlWithMethod_, {
            ...httpOptions
        }, decoderWithName)), {
        ...swrOptions,
        revalidateIfStale: swrOptions?.revalidateIfStale ?? !(0, $c6xfg.config).isDev,
        revalidateOnFocus: swrOptions?.revalidateOnFocus ?? !(0, $c6xfg.config).isDev,
        revalidateOnReconnect: swrOptions?.revalidateOnReconnect ?? !(0, $c6xfg.config).isDev
    });

});
parcelRegister("c6xfg", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $bf17d2c800a637a9$export$e506a1d27d1eaa20; });

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");

var $beLTA = parcelRequire("beLTA");
// It's important to have process.env.ENV_VAR fully, as it is inlined by Parcel
const $bf17d2c800a637a9$var$inlined = {
    IS_DEV: "false",
    API_HOST: "https://laquete.blbl.ch",
    DISCORD_CLIENT_ID: "703679541117190155",
    DISCORD_CLIENT_REDIRECT_URI: "https://laquete.blbl.ch/discordRedirect",
    PORO_BASE_URL: "https://porofessor.gg"
};
const $bf17d2c800a637a9$export$e506a1d27d1eaa20 = (0, $f5id0.pipe)($bf17d2c800a637a9$var$inlined, (0, $beLTA.Config).parse, (0, $sjwE0.Try).getUnsafe);

});
parcelRegister("beLTA", function(module, exports) {

$parcel$export(module.exports, "Config", function () { return $97181c3979ffd7d0$export$29cd7b75162a9425; });

var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $8MVVP = parcelRequire("8MVVP");

var $4nKV6 = parcelRequire("4nKV6");

var $fHSsS = parcelRequire("fHSsS");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const $97181c3979ffd7d0$var$seqS = (0, $8MVVP.ValidatedNea).getSeqS();
const $97181c3979ffd7d0$var$parse = (rawConfig)=>(0, $fHSsS.parseConfig)(rawConfig)((r)=>$97181c3979ffd7d0$var$seqS({
            isDev: (0, $f5id0.pipe)(r((0, $sjwE0.Maybe).decoder((0, $hHBpg.BooleanFromString).decoder))('IS_DEV'), (0, $sjwE0.Either).map((0, $sjwE0.Maybe).getOrElseW(()=>false))),
            apiHost: r((0, $hHBpg.URLFromString).decoder)('API_HOST'),
            discordClient: $97181c3979ffd7d0$var$seqS({
                id: r((0, $4nKV6.DiscordUserId).codec)('DISCORD_CLIENT_ID'),
                redirectUri: r($4BSZX.string)('DISCORD_CLIENT_REDIRECT_URI')
            }),
            poroApiBaseUrl: r($4BSZX.string)('PORO_BASE_URL')
        }));
const $97181c3979ffd7d0$export$29cd7b75162a9425 = {
    parse: $97181c3979ffd7d0$var$parse
};

});
parcelRegister("8MVVP", function(module, exports) {

$parcel$export(module.exports, "ValidatedNea", function () { return $f78784f04af9e33f$export$f6fe293a33f3a9aa; });

var $6IQDS = parcelRequire("6IQDS");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
const $f78784f04af9e33f$var$valid = (0, $sjwE0.Either).right;
const $f78784f04af9e33f$var$invalid = (0, $sjwE0.Either).left;
const $f78784f04af9e33f$var$fromEither = (0, $sjwE0.Either).mapLeft((0, $sjwE0.NonEmptyArray).of);
const $f78784f04af9e33f$var$fromOption = (onNone)=>(0, $f5id0.flow)((0, $sjwE0.Either).fromOption(onNone), $f78784f04af9e33f$var$fromEither);
const $f78784f04af9e33f$var$fromEmptyE = (e)=>(0, $sjwE0.Either).mapLeft((0, $f5id0.flow)((0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).getOrElse(()=>(0, $sjwE0.NonEmptyArray).of(e))));
const $f78784f04af9e33f$var$fromEmptyErrors = $f78784f04af9e33f$var$fromEmptyE('Got empty Errors from codec');
const $f78784f04af9e33f$var$chainOptionK = (onNone)=>(f)=>(0, $sjwE0.Either).chain((0, $f5id0.flow)(f, $f78784f04af9e33f$var$fromOption(onNone)));
const $f78784f04af9e33f$var$chainEitherK = (f)=>(0, $sjwE0.Either).chain((0, $f5id0.flow)(f, $f78784f04af9e33f$var$fromEither));
const $f78784f04af9e33f$var$bimap = (f, g)=>(0, $sjwE0.Either).bimap((0, $sjwE0.NonEmptyArray).map(f), g);
const $f78784f04af9e33f$var$getValidation = ()=>(0, $sjwE0.Either).getApplicativeValidation((0, $sjwE0.NonEmptyArray).getSemigroup());
const $f78784f04af9e33f$var$getSeqS = ()=>(0, $6IQDS).sequenceS($f78784f04af9e33f$var$getValidation());
const { left: {}, right: {}, ...$f78784f04af9e33f$var$validatedNea } = (0, $sjwE0.Either);
const $f78784f04af9e33f$export$f6fe293a33f3a9aa = {
    ...$f78784f04af9e33f$var$validatedNea,
    valid: $f78784f04af9e33f$var$valid,
    invalid: $f78784f04af9e33f$var$invalid,
    fromEither: $f78784f04af9e33f$var$fromEither,
    fromOption: $f78784f04af9e33f$var$fromOption,
    fromNullable: (0, $sjwE0.Either).fromNullable,
    fromEmptyE: $f78784f04af9e33f$var$fromEmptyE,
    fromEmptyErrors: $f78784f04af9e33f$var$fromEmptyErrors,
    fold: (0, $sjwE0.Either).fold,
    map: (0, $sjwE0.Either).map,
    chain: (0, $sjwE0.Either).chain,
    chainOptionK: $f78784f04af9e33f$var$chainOptionK,
    chainNullableK: (0, $sjwE0.Either).chainNullableK,
    chainEitherK: $f78784f04af9e33f$var$chainEitherK,
    bimap: $f78784f04af9e33f$var$bimap,
    bind: (0, $sjwE0.Either).bind,
    getValidation: $f78784f04af9e33f$var$getValidation,
    getSeqS: $f78784f04af9e33f$var$getSeqS
};

});

parcelRegister("4nKV6", function(module, exports) {

$parcel$export(module.exports, "DiscordUserId", function () { return $d4f432f6f024146e$export$a5b9a9eb90856ab; });

var $12uqT = parcelRequire("12uqT");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $d4f432f6f024146e$var$wrap, unwrap: $d4f432f6f024146e$var$unwrap } = (0, $1k68G.iso)();
const $d4f432f6f024146e$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $d4f432f6f024146e$var$Ord = (0, $f5id0.pipe)((0, $68YxT).Ord, (0, $12uqT).contramap($d4f432f6f024146e$var$unwrap));
const $d4f432f6f024146e$var$Eq = $d4f432f6f024146e$var$Ord;
const $d4f432f6f024146e$export$a5b9a9eb90856ab = (0, $sjwE0.immutableAssign)($d4f432f6f024146e$var$wrap, {
    codec: $d4f432f6f024146e$var$codec,
    unwrap: $d4f432f6f024146e$var$unwrap,
    Ord: $d4f432f6f024146e$var$Ord,
    Eq: $d4f432f6f024146e$var$Eq
});

});

parcelRegister("fHSsS", function(module, exports) {

$parcel$export(module.exports, "parseConfig", function () { return $71136c795c38791c$export$ddb7710e72db552d; });

var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $sjwE0 = parcelRequire("sjwE0");
const $71136c795c38791c$export$ddb7710e72db552d = (rawConfig)=>(f)=>(0, $f5id0.pipe)(f((decoder)=>(key)=>(0, $f5id0.pipe)(decoder.decode(rawConfig[key]), (0, $sjwE0.Either).mapLeft((e)=>(0, $sjwE0.NonEmptyArray).of(`${key}: ${$4BSZX.draw(e)}`)))), (0, $sjwE0.Either).mapLeft((0, $f5id0.flow)((0, $sjwE0.List).mkString('Errors while reading config:\n', '\n', ''), Error)));

});



parcelRegister("7VlB6", function(module, exports) {

$parcel$export(module.exports, "futureRunUnsafe", function () { return $10814c7728264142$export$a7654a1d6fb561a8; });

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
const $10814c7728264142$export$a7654a1d6fb561a8 = (0, $f5id0.flow)((0, $sjwE0.Future).orElse((e)=>{
    console.error(e);
    return (0, $sjwE0.Future).failed(e);
}), (0, $sjwE0.Future).runUnsafe);

});

parcelRegister("2sln7", function(module, exports) {

$parcel$export(module.exports, "http", function () { return $87c6bd70b392093c$export$7d6f1c8842f9f527; });
$parcel$export(module.exports, "statusesToOption", function () { return $87c6bd70b392093c$export$a9d48c43ab87d831; });

var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $bQd2u = parcelRequire("bQd2u");
var $jFuet = parcelRequire("jFuet");

var $1GV7y = parcelRequire("1GV7y");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $c6xfg = parcelRequire("c6xfg");
function $87c6bd70b392093c$export$7d6f1c8842f9f527([url, method], { credentials: credentials, timeout: timeout, ...options } = {}, decoderWithName) {
    const json = (()=>{
        if (options.json === undefined) return undefined;
        const [encoder, b] = options.json;
        return encoder.encode(b);
    })();
    return (0, $f5id0.pipe)((0, $sjwE0.Future).tryCatch(()=>(0, $bQd2u.default)(new URL(url, (0, $c6xfg.config).apiHost), {
            ...options,
            method: method,
            json: json,
            credentials: credentials ?? 'include',
            ...timeout === undefined ? {} : {
                timeout: (0, $1GV7y.MsDuration).unwrap(timeout)
            }
        }).json()), (0, $sjwE0.Future).chainEitherK((u)=>{
        if (decoderWithName === undefined) return (0, $sjwE0.Either).right(u);
        const [decoder, decoderName] = decoderWithName;
        return (0, $f5id0.pipe)(decoder.decode(u), (0, $sjwE0.Either).mapLeft((0, $hHBpg.decodeError)(decoderName)(u)));
    }));
}
const $87c6bd70b392093c$export$a9d48c43ab87d831 = (...statuses)=>(0, $f5id0.flow)((0, $sjwE0.Future).map((0, $sjwE0.Maybe).some), (0, $sjwE0.Future).orElseEitherK((e)=>e instanceof (0, $jFuet.HTTPError) && (0, $f5id0.pipe)(statuses, (0, $sjwE0.List).elem((0, $10ZIc).Eq)(e.response.status)) ? (0, $sjwE0.Try).success((0, $sjwE0.Maybe).none) : (0, $sjwE0.Try).failure(e)));

});
parcelRegister("bQd2u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89eeaa52fcd9b15c$export$2e2bcd8739ae039; });
/*! MIT License © Sindre Sorhus */ 
var $h7tZS = parcelRequire("h7tZS");

var $8w96w = parcelRequire("8w96w");

var $4HQjY = parcelRequire("4HQjY");

var $jFuet = parcelRequire("jFuet");

const $89eeaa52fcd9b15c$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $h7tZS.Ky).create(input, (0, $4HQjY.validateAndMerge)(defaults, options));
    for (const method of (0, $8w96w.requestMethods))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $h7tZS.Ky).create(input, (0, $4HQjY.validateAndMerge)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$89eeaa52fcd9b15c$var$createInstance((0, $4HQjY.validateAndMerge)(newDefaults));
    ky.extend = (newDefaults)=>{
        if (typeof newDefaults === 'function') newDefaults = newDefaults(defaults ?? {});
        return $89eeaa52fcd9b15c$var$createInstance((0, $4HQjY.validateAndMerge)(defaults, newDefaults));
    };
    ky.stop = (0, $8w96w.stop);
    return ky;
};
const $89eeaa52fcd9b15c$var$ky = $89eeaa52fcd9b15c$var$createInstance();
var $89eeaa52fcd9b15c$export$2e2bcd8739ae039 = $89eeaa52fcd9b15c$var$ky;

});
parcelRegister("h7tZS", function(module, exports) {

$parcel$export(module.exports, "Ky", function () { return $c76a5be1a3b0d0b8$export$c482d6f00e170af3; });

var $jFuet = parcelRequire("jFuet");

var $2pY6K = parcelRequire("2pY6K");

var $4HQjY = parcelRequire("4HQjY");

var $aLLal = parcelRequire("aLLal");

var $i8bfv = parcelRequire("i8bfv");

var $lISGe = parcelRequire("lISGe");

var $2pamQ = parcelRequire("2pamQ");

var $8w96w = parcelRequire("8w96w");
class $c76a5be1a3b0d0b8$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $c76a5be1a3b0d0b8$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky._options.timeout === 'number' && ky._options.timeout > (0, $8w96w.maxSafeTimeout)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $8w96w.maxSafeTimeout)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new (0, $jFuet.HTTPError)(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error);
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!(0, $8w96w.supportsResponseStreams)) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return ky._stream(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = isRetriableMethod ? ky._retry(function_) : function_();
        for (const [type, mimeType] of Object.entries((0, $8w96w.responseTypes)))result[type] = async ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
            const response = await result;
            if (type === 'json') {
                if (response.status === 204) return '';
                const arrayBuffer = await response.clone().arrayBuffer();
                const responseSize = arrayBuffer.byteLength;
                if (responseSize === 0) return '';
                if (options.parseJson) return options.parseJson(await response.text());
            }
            return response[type]();
        };
        return result;
    }
    request;
    abortController;
    _retryCount = 0;
    _input;
    _options;
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        this._input = input;
        this._options = {
            ...options,
            headers: (0, $4HQjY.mergeHeaders)(this._input.headers, options.headers),
            hooks: (0, $4HQjY.mergeHooks)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $aLLal.normalizeRequestMethod)(options.method ?? this._input.method ?? 'GET'),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ''),
            retry: (0, $aLLal.normalizeRetryOptions)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis)
        };
        if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this._options.prefixUrl && typeof this._input === 'string') {
            if (this._input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this._options.prefixUrl.endsWith('/')) this._options.prefixUrl += '/';
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $8w96w.supportsAbortController) {
            this.abortController = new globalThis.AbortController();
            const originalSignal = this._options.signal ?? this._input.signal;
            if (originalSignal?.aborted) this.abortController.abort(originalSignal?.reason);
            originalSignal?.addEventListener('abort', ()=>{
                this.abortController.abort(originalSignal.reason);
            });
            this._options.signal = this.abortController.signal;
        }
        if (0, $8w96w.supportsRequestStreams) // @ts-expect-error - Types are outdated.
        this._options.duplex = 'half';
        if (this._options.json !== undefined) {
            this._options.body = this._options.stringifyJson?.(this._options.json) ?? JSON.stringify(this._options.json);
            this._options.headers.set('content-type', this._options.headers.get('content-type') ?? 'application/json');
        }
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === 'string' ? this._options.searchParams.replace(/^\?/, '') : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = '?' + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $8w96w.supportsFormData) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers['content-type'])) this.request.headers.delete('content-type');
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, {
                ...this.request
            }), this._options);
        }
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount > this._options.retry.limit || error instanceof (0, $2pY6K.TimeoutError)) throw error;
        if (error instanceof (0, $jFuet.HTTPError)) {
            if (!this._options.retry.statusCodes.includes(error.response.status)) throw error;
            const retryAfter = error.response.headers.get('Retry-After') ?? error.response.headers.get('RateLimit-Reset') ?? error.response.headers.get('X-RateLimit-Reset') // GitHub
             ?? error.response.headers.get('X-Rate-Limit-Reset'); // Twitter
            if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                let after = Number(retryAfter) * 1000;
                if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                else if (after >= Date.parse('2024-01-01')) // A large number is treated as a timestamp (fixed threshold protects against clock skew)
                after -= Date.now();
                const max = this._options.retry.maxRetryAfter ?? after;
                return after < max ? after : max;
            }
            if (error.response.status === 413) throw error;
        }
        const retryDelay = this._options.retry.delay(this._retryCount);
        return Math.min(this._options.retry.backoffLimit, retryDelay);
    }
    _decorateResponse(response) {
        if (this._options.parseJson) response.json = async ()=>this._options.parseJson(await response.text());
        return response;
    }
    async _retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), (0, $8w96w.maxSafeTimeout));
            if (this._retryCount < 1) throw error;
            await (0, $lISGe.default)(ms, {
                signal: this._options.signal
            });
            for (const hook of this._options.hooks.beforeRetry){
                // eslint-disable-next-line no-await-in-loop
                const hookResult = await hook({
                    request: this.request,
                    options: this._options,
                    error: error,
                    retryCount: this._retryCount
                });
                // If `stop` is returned from the hook, the retry process is stopped
                if (hookResult === (0, $8w96w.stop)) return;
            }
            return this._retry(function_);
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        const nonRequestOptions = (0, $2pamQ.findUnknownOptions)(this.request, this._options);
        // Cloning is done here to prepare in advance for retries
        const mainRequest = this.request;
        this.request = mainRequest.clone();
        if (this._options.timeout === false) return this._options.fetch(mainRequest, nonRequestOptions);
        return (0, $i8bfv.default)(mainRequest, nonRequestOptions, this.abortController, this._options);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get('content-length')) || 0;
        let transferredBytes = 0;
        if (response.status === 204) {
            if (onDownloadProgress) onDownloadProgress({
                percent: 1,
                totalBytes: totalBytes,
                transferredBytes: transferredBytes
            }, new Uint8Array());
            return new globalThis.Response(null, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return new globalThis.Response(new globalThis.ReadableStream({
            async start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    await read();
                }
                await read();
            }
        }), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
}

});
parcelRegister("2pY6K", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", function () { return $1c2c8ab814e178c3$export$66d311bf29d5c89c; });
class $1c2c8ab814e178c3$export$66d311bf29d5c89c extends Error {
    request;
    constructor(request){
        super(`Request timed out: ${request.method} ${request.url}`);
        this.name = 'TimeoutError';
        this.request = request;
    }
}

});

parcelRegister("4HQjY", function(module, exports) {

$parcel$export(module.exports, "validateAndMerge", function () { return $36d3c37700a2d819$export$8886f5ba30bd5e0; });
$parcel$export(module.exports, "mergeHeaders", function () { return $36d3c37700a2d819$export$eee1781d075786ae; });
$parcel$export(module.exports, "mergeHooks", function () { return $36d3c37700a2d819$export$3de1ffbf114b9f2d; });

var $iyh8y = parcelRequire("iyh8y");
const $36d3c37700a2d819$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $iyh8y.isObject)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError('The `options` argument must be an object');
    }
    return $36d3c37700a2d819$export$6969335ea1e4e77c({}, ...sources);
};
const $36d3c37700a2d819$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === 'undefined' || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
function $36d3c37700a2d819$var$newHookValue(original, incoming, property) {
    return Object.hasOwn(incoming, property) && incoming[property] === undefined ? [] : $36d3c37700a2d819$export$6969335ea1e4e77c(original[property] ?? [], incoming[property] ?? []);
}
const $36d3c37700a2d819$export$3de1ffbf114b9f2d = (original = {}, incoming = {})=>({
        beforeRequest: $36d3c37700a2d819$var$newHookValue(original, incoming, 'beforeRequest'),
        beforeRetry: $36d3c37700a2d819$var$newHookValue(original, incoming, 'beforeRetry'),
        afterResponse: $36d3c37700a2d819$var$newHookValue(original, incoming, 'afterResponse'),
        beforeError: $36d3c37700a2d819$var$newHookValue(original, incoming, 'beforeError')
    });
const $36d3c37700a2d819$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    let hooks = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $iyh8y.isObject)(source)) {
            for (let [key, value] of Object.entries(source)){
                if ((0, $iyh8y.isObject)(value) && key in returnValue) value = $36d3c37700a2d819$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $iyh8y.isObject)(source.hooks)) {
                hooks = $36d3c37700a2d819$export$3de1ffbf114b9f2d(hooks, source.hooks);
                returnValue.hooks = hooks;
            }
            if ((0, $iyh8y.isObject)(source.headers)) {
                headers = $36d3c37700a2d819$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};

});
parcelRegister("iyh8y", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $d818b2029133ed73$export$a6cdc56e425d0d0a; });
// eslint-disable-next-line @typescript-eslint/ban-types
const $d818b2029133ed73$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === 'object';

});


parcelRegister("aLLal", function(module, exports) {

$parcel$export(module.exports, "normalizeRequestMethod", function () { return $7d72e14c89c69199$export$d585027d4667ffce; });
$parcel$export(module.exports, "normalizeRetryOptions", function () { return $7d72e14c89c69199$export$3e5471bb9440c9c1; });

var $8w96w = parcelRequire("8w96w");
const $7d72e14c89c69199$export$d585027d4667ffce = (input)=>(0, $8w96w.requestMethods).includes(input) ? input.toUpperCase() : input;
const $7d72e14c89c69199$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $7d72e14c89c69199$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $7d72e14c89c69199$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $7d72e14c89c69199$var$defaultRetryOptions = {
    limit: 2,
    methods: $7d72e14c89c69199$var$retryMethods,
    statusCodes: $7d72e14c89c69199$var$retryStatusCodes,
    afterStatusCodes: $7d72e14c89c69199$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000
};
const $7d72e14c89c69199$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$7d72e14c89c69199$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$7d72e14c89c69199$var$defaultRetryOptions,
        ...retry
    };
};

});
parcelRegister("8w96w", function(module, exports) {

$parcel$export(module.exports, "supportsRequestStreams", function () { return $63385fcee6f7fa9c$export$d8618555562b76b7; });
$parcel$export(module.exports, "supportsAbortController", function () { return $63385fcee6f7fa9c$export$6c0aacaed85a4966; });
$parcel$export(module.exports, "supportsResponseStreams", function () { return $63385fcee6f7fa9c$export$135162ac70ac2b21; });
$parcel$export(module.exports, "supportsFormData", function () { return $63385fcee6f7fa9c$export$f1525fa7979d0aa9; });
$parcel$export(module.exports, "requestMethods", function () { return $63385fcee6f7fa9c$export$fb003dbd6df95edb; });
$parcel$export(module.exports, "responseTypes", function () { return $63385fcee6f7fa9c$export$a6f212d4ee888d8c; });
$parcel$export(module.exports, "maxSafeTimeout", function () { return $63385fcee6f7fa9c$export$9b60a72e3f70a1d2; });
$parcel$export(module.exports, "stop", function () { return $63385fcee6f7fa9c$export$fa6813432f753b0d; });
$parcel$export(module.exports, "kyOptionKeys", function () { return $63385fcee6f7fa9c$export$601fffa09f19102d; });
$parcel$export(module.exports, "requestOptionsRegistry", function () { return $63385fcee6f7fa9c$export$b2ec467665ae937d; });
const $63385fcee6f7fa9c$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === 'function';
    const supportsRequest = typeof globalThis.Request === 'function';
    if (supportsReadableStream && supportsRequest) try {
        hasContentType = new globalThis.Request('https://empty.invalid', {
            body: new globalThis.ReadableStream(),
            method: 'POST',
            // @ts-expect-error - Types are outdated.
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
    } catch (error) {
        // QQBrowser on iOS throws "unsupported BodyInit type" error (see issue #581)
        if (error instanceof Error && error.message === 'unsupported BodyInit type') return false;
        throw error;
    }
    return duplexAccessed && !hasContentType;
})();
const $63385fcee6f7fa9c$export$6c0aacaed85a4966 = typeof globalThis.AbortController === 'function';
const $63385fcee6f7fa9c$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === 'function';
const $63385fcee6f7fa9c$export$f1525fa7979d0aa9 = typeof globalThis.FormData === 'function';
const $63385fcee6f7fa9c$export$fb003dbd6df95edb = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $63385fcee6f7fa9c$var$validate = ()=>undefined;
$63385fcee6f7fa9c$var$validate();
const $63385fcee6f7fa9c$export$a6f212d4ee888d8c = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*'
};
const $63385fcee6f7fa9c$export$9b60a72e3f70a1d2 = 2147483647;
const $63385fcee6f7fa9c$export$fa6813432f753b0d = Symbol('stop');
const $63385fcee6f7fa9c$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    stringifyJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true
};
const $63385fcee6f7fa9c$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    priority: true
};

});


parcelRegister("i8bfv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d331b33426f907b0$export$2e2bcd8739ae039; });

var $2pY6K = parcelRequire("2pY6K");
async function $d331b33426f907b0$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $2pY6K.TimeoutError)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}

});

parcelRegister("lISGe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd081f618258b6b0$export$2e2bcd8739ae039; });
// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $fd081f618258b6b0$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener('abort', abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
    });
}

});

parcelRegister("2pamQ", function(module, exports) {

$parcel$export(module.exports, "findUnknownOptions", function () { return $1c05f555c4899a3b$export$95d8775889ec941f; });

var $8w96w = parcelRequire("8w96w");
const $1c05f555c4899a3b$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options)if (!(key in (0, $8w96w.requestOptionsRegistry)) && !(key in (0, $8w96w.kyOptionKeys)) && !(key in request)) unknownOptions[key] = options[key];
    return unknownOptions;
};

});





parcelRegister("31rfl", function(module, exports) {

$parcel$export(module.exports, "ToasterContextProvider", function () { return $a12cea6d238bdfc9$export$49af044743387d11; });
$parcel$export(module.exports, "useToaster", function () { return $a12cea6d238bdfc9$export$f46171b59bb094f9; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $jRQku = parcelRequire("jRQku");
var $5DIoZ = parcelRequire("5DIoZ");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $1GV7y = parcelRequire("1GV7y");

var $sjwE0 = parcelRequire("sjwE0");

var $gwlG1 = parcelRequire("gwlG1");

var $bAMNu = parcelRequire("bAMNu");

var $jK7ok = parcelRequire("jK7ok");
const $a12cea6d238bdfc9$var$defaultDuration = (0, $1GV7y.MsDuration).seconds(3);
const $a12cea6d238bdfc9$var$config = {
    tension: 125,
    friction: 20,
    precision: 0.1
};
const $a12cea6d238bdfc9$var$toasterLayerId = 'toaster-layer';
const $a12cea6d238bdfc9$var$toasterLayer = document.getElementById($a12cea6d238bdfc9$var$toasterLayerId);
if ($a12cea6d238bdfc9$var$toasterLayer === null) // eslint-disable-next-line functional/no-throw-statements
throw Error(`Toaster layer not found: #${$a12cea6d238bdfc9$var$toasterLayerId}`);
const $a12cea6d238bdfc9$var$ToasterContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
const $a12cea6d238bdfc9$export$49af044743387d11 = ({ children: children })=>{
    const refMap = (0, $bh6RR.useMemo)(()=>new WeakMap(), []);
    const cancelMap = (0, $bh6RR.useMemo)(()=>new WeakMap(), []);
    const [toasters, setToasters] = (0, $bh6RR.useState)((0, $sjwE0.List).empty());
    const transitions = (0, $5DIoZ.useTransition)(toasters, {
        from: {
            opacity: 0,
            height: 0,
            ttl: 100
        },
        keys: (toaster)=>(0, $bAMNu.ToasterId).unwrap(toaster.id),
        enter: (toaster)=>(next, cancel)=>{
                cancelMap.set(toaster, cancel);
                return next({
                    opacity: 1,
                    height: refMap.get(toaster)?.offsetHeight
                }).then(()=>next({
                        ttl: 0
                    }));
            },
        leave: [
            {
                opacity: 0
            },
            {
                height: 0
            }
        ],
        onRest: (result, ctrl, toaster)=>{
            setToasters((0, $sjwE0.List).filter((t)=>!(0, $bAMNu.ToasterId).Eq.equals(t.id, toaster.id)));
        },
        config: (toaster, index, phase)=>(key)=>// eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
                phase === 'enter' && key === 'ttl' ? {
                    duration: (0, $1GV7y.MsDuration).unwrap(toaster.duration ?? (toaster.type === 'error' ? (0, $1GV7y.MsDuration).infinity : $a12cea6d238bdfc9$var$defaultDuration))
                } : $a12cea6d238bdfc9$var$config
    });
    const showToaster = (0, $bh6RR.useCallback)((type, content, options)=>{
        const id = (0, $bAMNu.ToasterId).generate();
        setToasters((0, $sjwE0.List).append({
            id: id,
            type: type,
            content: content,
            ...options
        }));
        return id;
    }, []);
    const onMount = (0, $bh6RR.useCallback)((toaster)=>(elt)=>{
            if (elt !== null) refMap.set(toaster, elt);
        }, [
        refMap
    ]);
    const onClick = (0, $bh6RR.useCallback)((ttl, toaster)=>()=>{
            if (cancelMap.has(toaster) && ttl.get() !== 0) cancelMap.get(toaster)?.();
        }, [
        cancelMap
    ]);
    const value = {
        showToaster: showToaster
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($a12cea6d238bdfc9$var$ToasterContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                children: /*#__PURE__*/ (0, $6afFj.createPortal)(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "absolute right-0 top-0 flex w-96 max-w-screen flex-col",
                    children: transitions(({ opacity: opacity, height: height, ttl: ttl }, toaster)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $jRQku.animated).div, {
                            style: {
                                opacity: opacity,
                                height: height
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                ref: onMount(toaster),
                                className: "pt-1",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: (0, $jK7ok.cx)('p-0.75 text-beige shadow-even', $a12cea6d238bdfc9$var$container[toaster.type]),
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: (0, $jK7ok.cx)('grid grid-cols-[1fr_auto] border-3 py-2 pl-2 pr-1', $a12cea6d238bdfc9$var$border[toaster.type]),
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: "text-sm",
                                                children: toaster.content
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                type: "button",
                                                onClick: onClick(ttl, toaster),
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CloseFilled), {
                                                    className: "w-5"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }))
                }), $a12cea6d238bdfc9$var$toasterLayer)
            })
        ]
    });
};
const $a12cea6d238bdfc9$var$container = {
    success: 'bg-green-toaster',
    warn: 'bg-orange-toaster',
    error: 'bg-red-toaster'
};
const $a12cea6d238bdfc9$var$border = {
    success: 'border-green-toaster-bis',
    warn: 'border-orange-toaster-bis',
    error: 'border-red-toaster-bis'
};
const $a12cea6d238bdfc9$export$f46171b59bb094f9 = ()=>{
    const context = (0, $bh6RR.useContext)($a12cea6d238bdfc9$var$ToasterContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useToaster must be used within a ToasterContextProvider');
    return context;
};

});
parcelRegister("jRQku", function(module, exports) {
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("8TAX3")).Globals; });
$parcel$export(module.exports, "useSprings", function () { return (parcelRequire("5DIoZ")).useSprings; });
$parcel$export(module.exports, "useTransition", function () { return (parcelRequire("5DIoZ")).useTransition; });

$parcel$export(module.exports, "animated", function () { return $e76b8f2030afb380$export$407448d2b89b1813; });
// src/index.ts
parcelRequire("5DIoZ");
var $8TAX3 = parcelRequire("8TAX3");

var $6afFj = parcelRequire("6afFj");

var $8TAX3 = parcelRequire("8TAX3");

var $22K8L = parcelRequire("22K8L");
// src/applyAnimatedValues.ts
var $e76b8f2030afb380$var$isCustomPropRE = /^--/;
function $e76b8f2030afb380$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$e76b8f2030afb380$var$isCustomPropRE.test(name) && !($e76b8f2030afb380$var$isUnitlessNumber.hasOwnProperty(name) && $e76b8f2030afb380$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $e76b8f2030afb380$var$attributeCache = {};
function $e76b8f2030afb380$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $e76b8f2030afb380$var$attributeCache[name] || ($e76b8f2030afb380$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $e76b8f2030afb380$var$dangerousStyleValue(name, style[name]);
        if ($e76b8f2030afb380$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $e76b8f2030afb380$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $e76b8f2030afb380$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $e76b8f2030afb380$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$e76b8f2030afb380$var$isUnitlessNumber = Object.keys($e76b8f2030afb380$var$isUnitlessNumber).reduce((acc, prop)=>{
    $e76b8f2030afb380$var$prefixes.forEach((prefix)=>acc[$e76b8f2030afb380$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $e76b8f2030afb380$var$isUnitlessNumber);
var $e76b8f2030afb380$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $e76b8f2030afb380$var$pxTransforms = /^(translate)/;
var $e76b8f2030afb380$var$degTransforms = /^(rotate|skew)/;
var $e76b8f2030afb380$var$addUnit = (value, unit)=>(0, $8TAX3.is).num(value) && value !== 0 ? value + unit : value;
var $e76b8f2030afb380$var$isValueIdentity = (value, id)=>(0, $8TAX3.is).arr(value) ? value.every((v)=>$e76b8f2030afb380$var$isValueIdentity(v, id)) : (0, $8TAX3.is).num(value) ? value === id : parseFloat(value) === id;
var $e76b8f2030afb380$var$AnimatedStyle = class extends (0, $22K8L.AnimatedObject) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$e76b8f2030afb380$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $e76b8f2030afb380$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $8TAX3.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($e76b8f2030afb380$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $8TAX3.is).und(value)) return;
                const unit = $e76b8f2030afb380$var$pxTransforms.test(key) ? "px" : $e76b8f2030afb380$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $8TAX3.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$e76b8f2030afb380$var$addUnit(deg, unit)})`,
                        $e76b8f2030afb380$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$e76b8f2030afb380$var$addUnit(v, unit)).join(",")})`,
                        $e76b8f2030afb380$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $e76b8f2030afb380$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $e76b8f2030afb380$var$FluidTransform = class extends (0, $8TAX3.FluidValue) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $8TAX3.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $8TAX3.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $8TAX3.is).arr(arg1) ? arg1 : input.map((0, $8TAX3.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $8TAX3.each)(this.inputs, (input)=>(0, $8TAX3.each)(input, (value)=>(0, $8TAX3.hasFluidValue)(value) && (0, $8TAX3.addFluidObserver)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $8TAX3.each)(this.inputs, (input)=>(0, $8TAX3.each)(input, (value)=>(0, $8TAX3.hasFluidValue)(value) && (0, $8TAX3.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $8TAX3.callFluidObservers)(this, event);
    }
};
// src/primitives.ts
var $e76b8f2030afb380$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $8TAX3.Globals).assign({
    batchedUpdates: (0, $6afFj.unstable_batchedUpdates),
    createStringInterpolator: $8TAX3.createStringInterpolator,
    colors: $8TAX3.colors
});
var $e76b8f2030afb380$var$host = (0, $22K8L.createHost)($e76b8f2030afb380$var$primitives, {
    applyAnimatedValues: $e76b8f2030afb380$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $e76b8f2030afb380$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $e76b8f2030afb380$export$407448d2b89b1813 = $e76b8f2030afb380$var$host.animated;

});
parcelRegister("5DIoZ", function(module, exports) {

$parcel$export(module.exports, "useSprings", function () { return $41b3099c4ff7ef63$export$15786d483ab9f469; });
$parcel$export(module.exports, "useTransition", function () { return $41b3099c4ff7ef63$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("8TAX3")).Globals; });
// src/hooks/useChain.ts

var $8TAX3 = parcelRequire("8TAX3");
var $1jvl8 = parcelRequire("1jvl8");

var $bh6RR = parcelRequire("bh6RR");

var $22K8L = parcelRequire("22K8L");
parcelRequire("jTNJs");
function $41b3099c4ff7ef63$var$callProp(value, ...args) {
    return (0, $8TAX3.is).fun(value) ? value(...args) : value;
}
var $41b3099c4ff7ef63$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $8TAX3.is).fun(value) ? value(key) : (0, $8TAX3.toArray)(value).includes(key)));
var $41b3099c4ff7ef63$var$resolveProp = (prop, key)=>(0, $8TAX3.is).obj(prop) ? key && prop[key] : prop;
var $41b3099c4ff7ef63$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $41b3099c4ff7ef63$var$noopTransform = (value)=>value;
var $41b3099c4ff7ef63$var$getDefaultProps = (props, transform = $41b3099c4ff7ef63$var$noopTransform)=>{
    let keys = $41b3099c4ff7ef63$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $8TAX3.is).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $41b3099c4ff7ef63$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $41b3099c4ff7ef63$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $41b3099c4ff7ef63$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $8TAX3.eachProp)(props, (value, prop)=>{
        if (!$41b3099c4ff7ef63$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $41b3099c4ff7ef63$export$b971039a739bf227(props) {
    const to2 = $41b3099c4ff7ef63$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $8TAX3.eachProp)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $41b3099c4ff7ef63$var$computeGoal(value) {
    value = (0, $8TAX3.getFluidValue)(value);
    return (0, $8TAX3.is).arr(value) ? value.map($41b3099c4ff7ef63$var$computeGoal) : (0, $8TAX3.isAnimatedString)(value) ? (0, $8TAX3.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $41b3099c4ff7ef63$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $41b3099c4ff7ef63$var$isAsyncTo(to2) {
    return (0, $8TAX3.is).fun(to2) || (0, $8TAX3.is).arr(to2) && (0, $8TAX3.is).obj(to2[0]);
}
function $41b3099c4ff7ef63$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $41b3099c4ff7ef63$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $41b3099c4ff7ef63$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $8TAX3.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $8TAX3.each)(controllers, (ctrl)=>{
                        (0, $8TAX3.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $41b3099c4ff7ef63$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $8TAX3.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $8TAX3.each)(controllers, (ctrl, i)=>(0, $8TAX3.each)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $41b3099c4ff7ef63$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $41b3099c4ff7ef63$var$defaults = {
    ...$41b3099c4ff7ef63$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $8TAX3.easings).linear,
    clamp: false
};
var $41b3099c4ff7ef63$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $41b3099c4ff7ef63$var$defaults);
    }
};
function $41b3099c4ff7ef63$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $41b3099c4ff7ef63$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $41b3099c4ff7ef63$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $41b3099c4ff7ef63$var$defaults)if (config2[key] == null) config2[key] = $41b3099c4ff7ef63$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $8TAX3.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $41b3099c4ff7ef63$var$sanitizeConfig(config2, props) {
    if (!(0, $8TAX3.is).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $8TAX3.is).und(props.tension) || !(0, $8TAX3.is).und(props.friction);
        if (isTensionConfig || !(0, $8TAX3.is).und(props.frequency) || !(0, $8TAX3.is).und(props.damping) || !(0, $8TAX3.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $41b3099c4ff7ef63$var$emptyArray = [];
var $41b3099c4ff7ef63$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $41b3099c4ff7ef63$var$emptyArray;
        this.toValues = null;
        this.fromValues = $41b3099c4ff7ef63$var$emptyArray;
        this.config = new $41b3099c4ff7ef63$var$AnimationConfig();
        this.immediate = false;
    }
};
function $41b3099c4ff7ef63$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $41b3099c4ff7ef63$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $8TAX3.is).und(props.pause)) state.paused = $41b3099c4ff7ef63$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $41b3099c4ff7ef63$var$matchProp(pause, key);
            delay = $41b3099c4ff7ef63$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $1jvl8.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $8TAX3.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, $1jvl8.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $41b3099c4ff7ef63$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $41b3099c4ff7ef63$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $41b3099c4ff7ef63$var$getNoopResult(target.get()) : $41b3099c4ff7ef63$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $41b3099c4ff7ef63$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $41b3099c4ff7ef63$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $41b3099c4ff7ef63$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $41b3099c4ff7ef63$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $41b3099c4ff7ef63$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $41b3099c4ff7ef63$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $41b3099c4ff7ef63$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $41b3099c4ff7ef63$export$d362d093fa99dc7();
            const skipAnimationSignal = new $41b3099c4ff7ef63$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $8TAX3.Globals).skipAnimation) {
                    $41b3099c4ff7ef63$var$stopAsync(state);
                    skipAnimationSignal.result = $41b3099c4ff7ef63$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $8TAX3.is).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $8TAX3.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $8TAX3.is).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $8TAX3.Globals).skipAnimation) {
            $41b3099c4ff7ef63$var$stopAsync(state);
            return $41b3099c4ff7ef63$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $8TAX3.is).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $41b3099c4ff7ef63$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $41b3099c4ff7ef63$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $41b3099c4ff7ef63$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $8TAX3.is).fun(onRest)) (0, $1jvl8.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $41b3099c4ff7ef63$var$stopAsync(state, cancelId) {
    (0, $8TAX3.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $41b3099c4ff7ef63$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $41b3099c4ff7ef63$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $41b3099c4ff7ef63$var$isFrameValue = (value)=>value instanceof $41b3099c4ff7ef63$export$8229896f80e2495e;
var $41b3099c4ff7ef63$var$nextId = 1;
var $41b3099c4ff7ef63$export$8229896f80e2495e = class extends (0, $8TAX3.FluidValue) {
    constructor(){
        super(...arguments);
        this.id = $41b3099c4ff7ef63$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $22K8L.getAnimated)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $8TAX3.Globals).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $8TAX3.deprecateInterpolate)();
        return (0, $8TAX3.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $8TAX3.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $8TAX3.frameLoop).sort(this);
        (0, $8TAX3.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $41b3099c4ff7ef63$var$$P = Symbol.for("SpringPhase");
var $41b3099c4ff7ef63$var$HAS_ANIMATED = 1;
var $41b3099c4ff7ef63$var$IS_ANIMATING = 2;
var $41b3099c4ff7ef63$var$IS_PAUSED = 4;
var $41b3099c4ff7ef63$var$hasAnimated = (target)=>(target[$41b3099c4ff7ef63$var$$P] & $41b3099c4ff7ef63$var$HAS_ANIMATED) > 0;
var $41b3099c4ff7ef63$var$isAnimating = (target)=>(target[$41b3099c4ff7ef63$var$$P] & $41b3099c4ff7ef63$var$IS_ANIMATING) > 0;
var $41b3099c4ff7ef63$var$isPaused = (target)=>(target[$41b3099c4ff7ef63$var$$P] & $41b3099c4ff7ef63$var$IS_PAUSED) > 0;
var $41b3099c4ff7ef63$var$setActiveBit = (target, active)=>active ? target[$41b3099c4ff7ef63$var$$P] |= $41b3099c4ff7ef63$var$IS_ANIMATING | $41b3099c4ff7ef63$var$HAS_ANIMATED : target[$41b3099c4ff7ef63$var$$P] &= ~$41b3099c4ff7ef63$var$IS_ANIMATING;
var $41b3099c4ff7ef63$var$setPausedBit = (target, paused)=>paused ? target[$41b3099c4ff7ef63$var$$P] |= $41b3099c4ff7ef63$var$IS_PAUSED : target[$41b3099c4ff7ef63$var$$P] &= ~$41b3099c4ff7ef63$var$IS_PAUSED;
// src/SpringValue.ts
var $41b3099c4ff7ef63$export$5854d13427d5a954 = class extends $41b3099c4ff7ef63$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $41b3099c4ff7ef63$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $8TAX3.is).und(arg1) || !(0, $8TAX3.is).und(arg2)) {
            const props = (0, $8TAX3.is).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $8TAX3.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($41b3099c4ff7ef63$var$isAnimating(this) || this._state.asyncTo) || $41b3099c4ff7ef63$var$isPaused(this);
    }
    get goal() {
        return (0, $8TAX3.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $22K8L.getAnimated)(this);
        return node instanceof (0, $22K8L.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $41b3099c4ff7ef63$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $41b3099c4ff7ef63$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $41b3099c4ff7ef63$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $22K8L.getPayload)(anim.to);
        if (!payload && (0, $8TAX3.hasFluidValue)(anim.to)) toValues = (0, $8TAX3.toArray)((0, $8TAX3.getFluidValue)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $22K8L.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $8TAX3.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $8TAX3.is).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $8TAX3.is).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $22K8L.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $8TAX3.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $1jvl8.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($41b3099c4ff7ef63$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $1jvl8.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $8TAX3.is).und(to2)) queue = [
            (0, $8TAX3.is).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$41b3099c4ff7ef63$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $41b3099c4ff7ef63$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $1jvl8.raf).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $8TAX3.is).obj(to2) ? to2[key] : to2;
        if (to2 == null || $41b3099c4ff7ef63$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $8TAX3.is).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$41b3099c4ff7ef63$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $8TAX3.getFluidValue)(from);
            if (!(0, $8TAX3.is).und(from)) this._set(from);
            else if (!(0, $22K8L.getAnimated)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $41b3099c4ff7ef63$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $41b3099c4ff7ef63$var$resolveProp(value, key) : value));
        $41b3099c4ff7ef63$var$mergeActiveFn(this, props, "onProps");
        $41b3099c4ff7ef63$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $41b3099c4ff7ef63$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$41b3099c4ff7ef63$var$isPaused(this)) {
                        $41b3099c4ff7ef63$var$setPausedBit(this, true);
                        (0, $8TAX3.flushCalls)(state.pauseQueue);
                        $41b3099c4ff7ef63$var$sendEvent(this, "onPause", $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($41b3099c4ff7ef63$var$isPaused(this)) {
                        $41b3099c4ff7ef63$var$setPausedBit(this, false);
                        if ($41b3099c4ff7ef63$var$isAnimating(this)) this._resume();
                        (0, $8TAX3.flushCalls)(state.resumeQueue);
                        $41b3099c4ff7ef63$var$sendEvent(this, "onResume", $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $41b3099c4ff7ef63$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($41b3099c4ff7ef63$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $8TAX3.is).und(range.to);
        const hasFromProp = !(0, $8TAX3.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($41b3099c4ff7ef63$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $8TAX3.is).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $8TAX3.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $8TAX3.getFluidValue)(from);
        const hasToChanged = !(0, $8TAX3.isEqual)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $41b3099c4ff7ef63$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $41b3099c4ff7ef63$var$mergeConfig(config2, $41b3099c4ff7ef63$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $41b3099c4ff7ef63$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $22K8L.getAnimated)(this);
        if (!node || (0, $8TAX3.is).und(to2)) return resolve($41b3099c4ff7ef63$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $8TAX3.is).und(props.reset) ? hasFromProp && !props.default : !(0, $8TAX3.is).und(from) && $41b3099c4ff7ef63$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $41b3099c4ff7ef63$var$computeGoal(to2);
        const isAnimatable = (0, $8TAX3.is).num(goal) || (0, $8TAX3.is).arr(goal) || (0, $8TAX3.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $41b3099c4ff7ef63$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $22K8L.getAnimatedType)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $8TAX3.hasFluidValue)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$41b3099c4ff7ef63$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $8TAX3.isEqual)($41b3099c4ff7ef63$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $8TAX3.isEqual)(anim.immediate, immediate) && !immediate || !(0, $8TAX3.isEqual)(config2.decay, decay) || !(0, $8TAX3.isEqual)(config2.velocity, velocity)) started = true;
        }
        if (finished && $41b3099c4ff7ef63$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $8TAX3.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $8TAX3.hasFluidValue)(to2) ? null : goalType == (0, $22K8L.AnimatedString) ? [
                    1
                ] : (0, $8TAX3.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $8TAX3.each)($41b3099c4ff7ef63$var$ACTIVE_EVENTS, (type)=>$41b3099c4ff7ef63$var$mergeActiveFn(this, props, type));
                const result = $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, prevTo));
                (0, $8TAX3.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $1jvl8.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $41b3099c4ff7ef63$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($41b3099c4ff7ef63$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($41b3099c4ff7ef63$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($41b3099c4ff7ef63$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $8TAX3.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $8TAX3.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $8TAX3.hasFluidValue)(to2)) {
            (0, $8TAX3.addFluidObserver)(to2, this);
            if ($41b3099c4ff7ef63$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $8TAX3.hasFluidValue)(to2)) (0, $8TAX3.removeFluidObserver)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $8TAX3.getFluidValue)(arg);
        if (!(0, $8TAX3.is).und(value)) {
            const oldNode = (0, $22K8L.getAnimated)(this);
            if (!oldNode || !(0, $8TAX3.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $22K8L.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $22K8L.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $1jvl8.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $22K8L.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $41b3099c4ff7ef63$var$sendEvent(this, "onStart", $41b3099c4ff7ef63$var$getFinishedResult(this, $41b3099c4ff7ef63$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $41b3099c4ff7ef63$var$callProp(this.animation.onChange, value, this);
        }
        $41b3099c4ff7ef63$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $22K8L.getAnimated)(this).reset((0, $8TAX3.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$41b3099c4ff7ef63$var$isAnimating(this)) {
            $41b3099c4ff7ef63$var$setActiveBit(this, true);
            if (!$41b3099c4ff7ef63$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $8TAX3.Globals).skipAnimation) this.finish();
        else (0, $8TAX3.frameLoop).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($41b3099c4ff7ef63$var$isAnimating(this)) {
            $41b3099c4ff7ef63$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $8TAX3.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $8TAX3.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $41b3099c4ff7ef63$var$getCancelledResult(this.get()) : $41b3099c4ff7ef63$var$getFinishedResult(this.get(), $41b3099c4ff7ef63$var$checkFinished(this, goal ?? anim.to));
            (0, $8TAX3.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $41b3099c4ff7ef63$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $41b3099c4ff7ef63$var$checkFinished(target, to2) {
    const goal = $41b3099c4ff7ef63$var$computeGoal(to2);
    const value = $41b3099c4ff7ef63$var$computeGoal(target.get());
    return (0, $8TAX3.isEqual)(value, goal);
}
function $41b3099c4ff7ef63$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $41b3099c4ff7ef63$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $41b3099c4ff7ef63$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $41b3099c4ff7ef63$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $41b3099c4ff7ef63$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $41b3099c4ff7ef63$var$createUpdate(props) {
    const { to: to2, from: from } = props = $41b3099c4ff7ef63$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $8TAX3.is).obj(to2)) $41b3099c4ff7ef63$var$findDefined(to2, keys);
    if ((0, $8TAX3.is).obj(from)) $41b3099c4ff7ef63$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $41b3099c4ff7ef63$var$declareUpdate(props) {
    const update2 = $41b3099c4ff7ef63$var$createUpdate(props);
    if ((0, $8TAX3.is).und(update2.default)) update2.default = $41b3099c4ff7ef63$var$getDefaultProps(update2);
    return update2;
}
function $41b3099c4ff7ef63$var$findDefined(values, keys) {
    (0, $8TAX3.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
var $41b3099c4ff7ef63$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $41b3099c4ff7ef63$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $41b3099c4ff7ef63$var$getDefaultProp(props, type) ? $41b3099c4ff7ef63$var$resolveProp(props[type], target.key) : void 0;
}
function $41b3099c4ff7ef63$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $41b3099c4ff7ef63$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $41b3099c4ff7ef63$var$nextId2 = 1;
var $41b3099c4ff7ef63$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $41b3099c4ff7ef63$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $8TAX3.is).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($41b3099c4ff7ef63$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $8TAX3.toArray)(props).map($41b3099c4ff7ef63$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $41b3099c4ff7ef63$var$prepareKeys(this, queue);
        return $41b3099c4ff7ef63$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $8TAX3.each)((0, $8TAX3.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $41b3099c4ff7ef63$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $8TAX3.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $8TAX3.each)((0, $8TAX3.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $8TAX3.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $8TAX3.each)((0, $8TAX3.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $8TAX3.eachProp)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $8TAX3.flush)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $8TAX3.flush)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $8TAX3.flush)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $1jvl8.raf).onFrame(this._onFrame);
    }
};
function $41b3099c4ff7ef63$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$41b3099c4ff7ef63$var$flushUpdate(ctrl, props))).then((results)=>$41b3099c4ff7ef63$var$getCombinedResult(ctrl, results));
}
async function $41b3099c4ff7ef63$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $8TAX3.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $8TAX3.is).arr(to2) || (0, $8TAX3.is).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $8TAX3.each)($41b3099c4ff7ef63$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $8TAX3.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $8TAX3.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $41b3099c4ff7ef63$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($41b3099c4ff7ef63$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $8TAX3.noop),
            resume: (0, $8TAX3.noop),
            start (props2, resolve) {
                if (cancel) {
                    $41b3099c4ff7ef63$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($41b3099c4ff7ef63$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($41b3099c4ff7ef63$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $41b3099c4ff7ef63$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $41b3099c4ff7ef63$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $41b3099c4ff7ef63$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $41b3099c4ff7ef63$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $1jvl8.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $41b3099c4ff7ef63$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $8TAX3.each)((0, $8TAX3.toArray)(props), (props2)=>{
        if ((0, $8TAX3.is).und(props2.keys)) props2 = $41b3099c4ff7ef63$var$createUpdate(props2);
        if (!(0, $8TAX3.is).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $41b3099c4ff7ef63$var$prepareSprings(springs, props2, (key)=>{
            return $41b3099c4ff7ef63$var$createSpring(key);
        });
    });
    $41b3099c4ff7ef63$var$setSprings(ctrl, springs);
    return springs;
}
function $41b3099c4ff7ef63$var$setSprings(ctrl, springs) {
    (0, $8TAX3.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $8TAX3.addFluidObserver)(spring, ctrl);
        }
    });
}
function $41b3099c4ff7ef63$var$createSpring(key, observer) {
    const spring = new $41b3099c4ff7ef63$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $8TAX3.addFluidObserver)(spring, observer);
    return spring;
}
function $41b3099c4ff7ef63$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $8TAX3.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $41b3099c4ff7ef63$var$prepareKeys(ctrl, queue) {
    (0, $8TAX3.each)(queue, (props)=>{
        $41b3099c4ff7ef63$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $41b3099c4ff7ef63$var$createSpring(key, ctrl);
        });
    });
}
var $41b3099c4ff7ef63$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $bh6RR.useContext)($41b3099c4ff7ef63$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $8TAX3.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $41b3099c4ff7ef63$var$ctx;
    return /* @__PURE__ */ $bh6RR.createElement(Provider, {
        value: props
    }, children);
};
var $41b3099c4ff7ef63$var$ctx = $41b3099c4ff7ef63$var$makeContext($41b3099c4ff7ef63$export$f12a216ec50d2cf1, {});
$41b3099c4ff7ef63$export$f12a216ec50d2cf1.Provider = $41b3099c4ff7ef63$var$ctx.Provider;
$41b3099c4ff7ef63$export$f12a216ec50d2cf1.Consumer = $41b3099c4ff7ef63$var$ctx.Consumer;
function $41b3099c4ff7ef63$var$makeContext(target, init) {
    Object.assign(target, $bh6RR.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $41b3099c4ff7ef63$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $8TAX3.deprecateDirectCall)();
        const results = [];
        (0, $8TAX3.each)(current, (ctrl, i)=>{
            if ((0, $8TAX3.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $8TAX3.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $8TAX3.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $8TAX3.each)(current, (ctrl, i)=>{
            const update2 = (0, $8TAX3.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $8TAX3.each)(current, (ctrl, i)=>{
            if ((0, $8TAX3.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $8TAX3.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $8TAX3.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $8TAX3.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $41b3099c4ff7ef63$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $8TAX3.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $bh6RR.useMemo)(()=>propsFn || arguments.length == 3 ? $41b3099c4ff7ef63$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $bh6RR.useRef)(0);
    const forceUpdate = (0, $8TAX3.useForceUpdate)();
    const state = (0, $bh6RR.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $41b3099c4ff7ef63$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $41b3099c4ff7ef63$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $41b3099c4ff7ef63$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($41b3099c4ff7ef63$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $bh6RR.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $8TAX3.usePrev)(length) || 0;
    (0, $bh6RR.useMemo)(()=>{
        (0, $8TAX3.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $41b3099c4ff7ef63$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $bh6RR.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $41b3099c4ff7ef63$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $41b3099c4ff7ef63$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$41b3099c4ff7ef63$var$getSprings(ctrl, updates[i]));
    const context = (0, $bh6RR.useContext)($41b3099c4ff7ef63$export$f12a216ec50d2cf1);
    const prevContext = (0, $8TAX3.usePrev)(context);
    const hasContext = context !== prevContext && $41b3099c4ff7ef63$var$hasProps(context);
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $8TAX3.each)(queue, (cb)=>cb());
        }
        (0, $8TAX3.each)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $41b3099c4ff7ef63$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $8TAX3.useOnce)(()=>()=>{
            (0, $8TAX3.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $41b3099c4ff7ef63$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $8TAX3.is).fun(props);
    const [[values], ref] = $41b3099c4ff7ef63$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $41b3099c4ff7ef63$var$initSpringRef = ()=>$41b3099c4ff7ef63$export$2471ae76e2946684();
var $41b3099c4ff7ef63$export$564bff9c23cad2ca = ()=>(0, $bh6RR.useState)($41b3099c4ff7ef63$var$initSpringRef)[0];
var $41b3099c4ff7ef63$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $8TAX3.useConstant)(()=>new $41b3099c4ff7ef63$export$5854d13427d5a954(initial, props));
    (0, $8TAX3.useOnce)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $41b3099c4ff7ef63$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $8TAX3.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $41b3099c4ff7ef63$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        (0, $8TAX3.each)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $41b3099c4ff7ef63$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $8TAX3.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $41b3099c4ff7ef63$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $8TAX3.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $bh6RR.useMemo)(()=>propsFn || arguments.length == 3 ? $41b3099c4ff7ef63$export$2471ae76e2946684() : void 0, []);
    const items = (0, $8TAX3.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $bh6RR.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $8TAX3.useOnce)(()=>{
        (0, $8TAX3.each)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $8TAX3.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $41b3099c4ff7ef63$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $41b3099c4ff7ef63$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>(0, $8TAX3.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $41b3099c4ff7ef63$var$detachRefs(ctrl, ref);
            $41b3099c4ff7ef63$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $8TAX3.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $8TAX3.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $41b3099c4ff7ef63$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $8TAX3.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $8TAX3.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $8TAX3.useForceUpdate)();
    const defaultProps = $41b3099c4ff7ef63$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $bh6RR.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $bh6RR.useRef)(false);
    (0, $8TAX3.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $41b3099c4ff7ef63$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $41b3099c4ff7ef63$var$callProp(to2, t.item, i);
        to2 = (0, $8TAX3.is).obj(to2) ? $41b3099c4ff7ef63$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $41b3099c4ff7ef63$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $8TAX3.is).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $8TAX3.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $41b3099c4ff7ef63$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $41b3099c4ff7ef63$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $41b3099c4ff7ef63$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $41b3099c4ff7ef63$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $bh6RR.useContext)($41b3099c4ff7ef63$export$f12a216ec50d2cf1);
    const prevContext = (0, $8TAX3.usePrev)(context);
    const hasContext = context !== prevContext && $41b3099c4ff7ef63$var$hasProps(context);
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        if (hasContext) (0, $8TAX3.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $8TAX3.each)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        (0, $8TAX3.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $41b3099c4ff7ef63$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $bh6RR.createElement(elem.type, {
                ...elem.props,
                key: (0, $8TAX3.is).str(t.key) || (0, $8TAX3.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $41b3099c4ff7ef63$var$nextKey = 1;
function $41b3099c4ff7ef63$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $41b3099c4ff7ef63$var$nextKey++;
        });
    }
    return (0, $8TAX3.is).und(keys) ? items : (0, $8TAX3.is).fun(keys) ? items.map(keys) : (0, $8TAX3.toArray)(keys);
}
var $41b3099c4ff7ef63$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $41b3099c4ff7ef63$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $8TAX3.onScroll)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $8TAX3.each)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $41b3099c4ff7ef63$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $41b3099c4ff7ef63$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $8TAX3.onResize)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $8TAX3.each)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $41b3099c4ff7ef63$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $41b3099c4ff7ef63$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $bh6RR.useState)(false);
    const ref = (0, $bh6RR.useRef)();
    const propsFn = (0, $8TAX3.is).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $41b3099c4ff7ef63$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $8TAX3.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $41b3099c4ff7ef63$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $41b3099c4ff7ef63$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($41b3099c4ff7ef63$export$c4af9125706c4d30(props));
}
function $41b3099c4ff7ef63$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $41b3099c4ff7ef63$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $8TAX3.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $41b3099c4ff7ef63$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $41b3099c4ff7ef63$export$7b286972b8d8ccbf(items, props)(children);
}
var $41b3099c4ff7ef63$export$b0cc4f9860136880 = class extends $41b3099c4ff7ef63$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $8TAX3.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $22K8L.getAnimatedType)(value);
        (0, $22K8L.setAnimated)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $8TAX3.isEqual)(value, oldValue)) {
            (0, $22K8L.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $41b3099c4ff7ef63$var$checkIdle(this._active)) $41b3099c4ff7ef63$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $8TAX3.is).arr(this.source) ? this.source.map((0, $8TAX3.getFluidValue)) : (0, $8TAX3.toArray)((0, $8TAX3.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$41b3099c4ff7ef63$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $8TAX3.each)((0, $22K8L.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $8TAX3.Globals).skipAnimation) {
                (0, $1jvl8.raf).batchedUpdates(()=>this.advance());
                $41b3099c4ff7ef63$var$becomeIdle(this);
            } else (0, $8TAX3.frameLoop).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $8TAX3.each)((0, $8TAX3.toArray)(this.source), (source)=>{
            if ((0, $8TAX3.hasFluidValue)(source)) (0, $8TAX3.addFluidObserver)(source, this);
            if ($41b3099c4ff7ef63$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $8TAX3.each)((0, $8TAX3.toArray)(this.source), (source)=>{
            if ((0, $8TAX3.hasFluidValue)(source)) (0, $8TAX3.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $41b3099c4ff7ef63$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $8TAX3.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($41b3099c4ff7ef63$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $41b3099c4ff7ef63$var$isIdle(source) {
    return source.idle !== false;
}
function $41b3099c4ff7ef63$var$checkIdle(active) {
    return !active.size || Array.from(active).every($41b3099c4ff7ef63$var$isIdle);
}
function $41b3099c4ff7ef63$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $8TAX3.each)((0, $22K8L.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $8TAX3.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $41b3099c4ff7ef63$export$2c618a4308a30424 = (source, ...args)=>new $41b3099c4ff7ef63$export$b0cc4f9860136880(source, args);
var $41b3099c4ff7ef63$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $8TAX3.deprecateInterpolate)(), new $41b3099c4ff7ef63$export$b0cc4f9860136880(source, args));
(0, $8TAX3.Globals).assign({
    createStringInterpolator: $8TAX3.createStringInterpolator,
    to: (source, args)=>new $41b3099c4ff7ef63$export$b0cc4f9860136880(source, args)
});
var $41b3099c4ff7ef63$export$722fbec263ad908a = (0, $8TAX3.frameLoop).advance;

});
parcelRegister("8TAX3", function(module, exports) {

$parcel$export(module.exports, "Globals", function () { return $67a01f8f769a9ff0$export$cceeabf822b64fc0; });
$parcel$export(module.exports, "noop", function () { return $67a01f8f769a9ff0$export$8793edee2d425525; });
$parcel$export(module.exports, "defineHidden", function () { return $67a01f8f769a9ff0$export$5c74248ea0e35446; });
$parcel$export(module.exports, "is", function () { return $67a01f8f769a9ff0$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isEqual", function () { return $67a01f8f769a9ff0$export$248d38f6296296c5; });
$parcel$export(module.exports, "each", function () { return $67a01f8f769a9ff0$export$79b2f7037acddd43; });
$parcel$export(module.exports, "eachProp", function () { return $67a01f8f769a9ff0$export$f4c6fe153f5a944e; });
$parcel$export(module.exports, "toArray", function () { return $67a01f8f769a9ff0$export$45b10814cc054894; });
$parcel$export(module.exports, "flush", function () { return $67a01f8f769a9ff0$export$4909b86c8034bf73; });
$parcel$export(module.exports, "flushCalls", function () { return $67a01f8f769a9ff0$export$7ba486852759e806; });
$parcel$export(module.exports, "frameLoop", function () { return $67a01f8f769a9ff0$export$a57f5080a3bcc90a; });
$parcel$export(module.exports, "colors", function () { return $67a01f8f769a9ff0$export$8f45430ccf837300; });
$parcel$export(module.exports, "createInterpolator", function () { return $67a01f8f769a9ff0$export$b12af43b97697ef5; });
$parcel$export(module.exports, "easings", function () { return $67a01f8f769a9ff0$export$15a0bf1b4bbacad8; });
$parcel$export(module.exports, "hasFluidValue", function () { return $67a01f8f769a9ff0$export$57ea7e3a7f6280c7; });
$parcel$export(module.exports, "getFluidValue", function () { return $67a01f8f769a9ff0$export$e37b7520edd66839; });
$parcel$export(module.exports, "getFluidObservers", function () { return $67a01f8f769a9ff0$export$133f54e9f7cf1796; });
$parcel$export(module.exports, "callFluidObservers", function () { return $67a01f8f769a9ff0$export$31752c40a5fab62a; });
$parcel$export(module.exports, "FluidValue", function () { return $67a01f8f769a9ff0$export$aff8e1ac1a016a2; });
$parcel$export(module.exports, "addFluidObserver", function () { return $67a01f8f769a9ff0$export$72d604e3f8d000a5; });
$parcel$export(module.exports, "removeFluidObserver", function () { return $67a01f8f769a9ff0$export$7a0eb830d336339b; });
$parcel$export(module.exports, "createStringInterpolator", function () { return $67a01f8f769a9ff0$export$4759a013d387347a; });
$parcel$export(module.exports, "deprecateInterpolate", function () { return $67a01f8f769a9ff0$export$2abfcde8ae218ba8; });
$parcel$export(module.exports, "deprecateDirectCall", function () { return $67a01f8f769a9ff0$export$d99d974913ad3b12; });
$parcel$export(module.exports, "isAnimatedString", function () { return $67a01f8f769a9ff0$export$75bed621f62abfa9; });
$parcel$export(module.exports, "onResize", function () { return $67a01f8f769a9ff0$export$45b39e67d4ce4921; });
$parcel$export(module.exports, "onScroll", function () { return $67a01f8f769a9ff0$export$d4d89fd61e5416ee; });
$parcel$export(module.exports, "useConstant", function () { return $67a01f8f769a9ff0$export$fe4300aa8eebea86; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $67a01f8f769a9ff0$export$700979bc83e7db82; });
$parcel$export(module.exports, "useForceUpdate", function () { return $67a01f8f769a9ff0$export$91db9bc4f8ac944a; });
$parcel$export(module.exports, "useMemoOne", function () { return $67a01f8f769a9ff0$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "useOnce", function () { return $67a01f8f769a9ff0$export$392544347a18b6ea; });
$parcel$export(module.exports, "usePrev", function () { return $67a01f8f769a9ff0$export$ef7ad0c4e19d7fbf; });
$parcel$export(module.exports, "raf", function () { return (parcelRequire("1jvl8")).raf; });

var $1jvl8 = parcelRequire("1jvl8");

var $bh6RR = parcelRequire("bh6RR");
var $67a01f8f769a9ff0$var$__defProp = Object.defineProperty;
var $67a01f8f769a9ff0$var$__export = (target, all)=>{
    for(var name in all)$67a01f8f769a9ff0$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $67a01f8f769a9ff0$export$cceeabf822b64fc0 = {};
$67a01f8f769a9ff0$var$__export($67a01f8f769a9ff0$export$cceeabf822b64fc0, {
    assign: ()=>$67a01f8f769a9ff0$var$assign,
    colors: ()=>$67a01f8f769a9ff0$var$colors,
    createStringInterpolator: ()=>$67a01f8f769a9ff0$var$createStringInterpolator,
    skipAnimation: ()=>$67a01f8f769a9ff0$var$skipAnimation,
    to: ()=>$67a01f8f769a9ff0$var$to,
    willAdvance: ()=>$67a01f8f769a9ff0$var$willAdvance
});
// src/helpers.ts
function $67a01f8f769a9ff0$export$8793edee2d425525() {}
var $67a01f8f769a9ff0$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $67a01f8f769a9ff0$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $67a01f8f769a9ff0$export$248d38f6296296c5(a, b) {
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(a)) {
        if (!$67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $67a01f8f769a9ff0$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $67a01f8f769a9ff0$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $67a01f8f769a9ff0$export$45b10814cc054894 = (a)=>$67a01f8f769a9ff0$export$226b3eccf92c9ed9.und(a) ? [] : $67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $67a01f8f769a9ff0$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $67a01f8f769a9ff0$export$79b2f7037acddd43(items, iterator);
    }
}
var $67a01f8f769a9ff0$export$7ba486852759e806 = (queue, ...args)=>$67a01f8f769a9ff0$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $67a01f8f769a9ff0$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $67a01f8f769a9ff0$var$createStringInterpolator;
var $67a01f8f769a9ff0$var$to;
var $67a01f8f769a9ff0$var$colors = null;
var $67a01f8f769a9ff0$var$skipAnimation = false;
var $67a01f8f769a9ff0$var$willAdvance = $67a01f8f769a9ff0$export$8793edee2d425525;
var $67a01f8f769a9ff0$var$assign = (globals)=>{
    if (globals.to) $67a01f8f769a9ff0$var$to = globals.to;
    if (globals.now) (0, $1jvl8.raf).now = globals.now;
    if (globals.colors !== void 0) $67a01f8f769a9ff0$var$colors = globals.colors;
    if (globals.skipAnimation != null) $67a01f8f769a9ff0$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $67a01f8f769a9ff0$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $1jvl8.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $1jvl8.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $67a01f8f769a9ff0$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $1jvl8.raf).frameLoop = globals.frameLoop;
};
var $67a01f8f769a9ff0$var$startQueue = /* @__PURE__ */ new Set();
var $67a01f8f769a9ff0$var$currentFrame = [];
var $67a01f8f769a9ff0$var$prevFrame = [];
var $67a01f8f769a9ff0$var$priority = 0;
var $67a01f8f769a9ff0$export$a57f5080a3bcc90a = {
    get idle () {
        return !$67a01f8f769a9ff0$var$startQueue.size && !$67a01f8f769a9ff0$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($67a01f8f769a9ff0$var$priority > animation.priority) {
            $67a01f8f769a9ff0$var$startQueue.add(animation);
            (0, $1jvl8.raf).onStart($67a01f8f769a9ff0$var$flushStartQueue);
        } else {
            $67a01f8f769a9ff0$var$startSafely(animation);
            (0, $1jvl8.raf)($67a01f8f769a9ff0$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $67a01f8f769a9ff0$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($67a01f8f769a9ff0$var$priority) (0, $1jvl8.raf).onFrame(()=>$67a01f8f769a9ff0$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $67a01f8f769a9ff0$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $67a01f8f769a9ff0$var$currentFrame.splice(prevIndex, 1);
                $67a01f8f769a9ff0$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $67a01f8f769a9ff0$var$currentFrame = [];
        $67a01f8f769a9ff0$var$startQueue.clear();
    }
};
function $67a01f8f769a9ff0$var$flushStartQueue() {
    $67a01f8f769a9ff0$var$startQueue.forEach($67a01f8f769a9ff0$var$startSafely);
    $67a01f8f769a9ff0$var$startQueue.clear();
    (0, $1jvl8.raf)($67a01f8f769a9ff0$var$advance);
}
function $67a01f8f769a9ff0$var$startSafely(animation) {
    if (!$67a01f8f769a9ff0$var$currentFrame.includes(animation)) $67a01f8f769a9ff0$var$startUnsafely(animation);
}
function $67a01f8f769a9ff0$var$startUnsafely(animation) {
    $67a01f8f769a9ff0$var$currentFrame.splice($67a01f8f769a9ff0$var$findIndex($67a01f8f769a9ff0$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $67a01f8f769a9ff0$var$advance(dt) {
    const nextFrame = $67a01f8f769a9ff0$var$prevFrame;
    for(let i = 0; i < $67a01f8f769a9ff0$var$currentFrame.length; i++){
        const animation = $67a01f8f769a9ff0$var$currentFrame[i];
        $67a01f8f769a9ff0$var$priority = animation.priority;
        if (!animation.idle) {
            $67a01f8f769a9ff0$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $67a01f8f769a9ff0$var$priority = 0;
    $67a01f8f769a9ff0$var$prevFrame = $67a01f8f769a9ff0$var$currentFrame;
    $67a01f8f769a9ff0$var$prevFrame.length = 0;
    $67a01f8f769a9ff0$var$currentFrame = nextFrame;
    return $67a01f8f769a9ff0$var$currentFrame.length > 0;
}
function $67a01f8f769a9ff0$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $67a01f8f769a9ff0$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $67a01f8f769a9ff0$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $67a01f8f769a9ff0$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $67a01f8f769a9ff0$var$PERCENTAGE = $67a01f8f769a9ff0$var$NUMBER + "%";
function $67a01f8f769a9ff0$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $67a01f8f769a9ff0$export$8972dc0e6ad9238f = new RegExp("rgb" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER));
var $67a01f8f769a9ff0$export$4e46ac54fc82cf3b = new RegExp("rgba" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$NUMBER));
var $67a01f8f769a9ff0$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$PERCENTAGE, $67a01f8f769a9ff0$var$PERCENTAGE));
var $67a01f8f769a9ff0$export$810b04175080204c = new RegExp("hsla" + $67a01f8f769a9ff0$var$call($67a01f8f769a9ff0$var$NUMBER, $67a01f8f769a9ff0$var$PERCENTAGE, $67a01f8f769a9ff0$var$PERCENTAGE, $67a01f8f769a9ff0$var$NUMBER));
var $67a01f8f769a9ff0$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $67a01f8f769a9ff0$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $67a01f8f769a9ff0$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $67a01f8f769a9ff0$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $67a01f8f769a9ff0$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $67a01f8f769a9ff0$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($67a01f8f769a9ff0$var$colors && $67a01f8f769a9ff0$var$colors[color] !== void 0) return $67a01f8f769a9ff0$var$colors[color];
    if (match = $67a01f8f769a9ff0$export$8972dc0e6ad9238f.exec(color)) return ($67a01f8f769a9ff0$var$parse255(match[1]) << 24 | // r
    $67a01f8f769a9ff0$var$parse255(match[2]) << 16 | // g
    $67a01f8f769a9ff0$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $67a01f8f769a9ff0$export$4e46ac54fc82cf3b.exec(color)) return ($67a01f8f769a9ff0$var$parse255(match[1]) << 24 | // r
    $67a01f8f769a9ff0$var$parse255(match[2]) << 16 | // g
    $67a01f8f769a9ff0$var$parse255(match[3]) << 8 | // b
    $67a01f8f769a9ff0$var$parse1(match[4])) >>> // a
    0;
    if (match = $67a01f8f769a9ff0$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $67a01f8f769a9ff0$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $67a01f8f769a9ff0$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $67a01f8f769a9ff0$export$8f4a7c0bb78e6ea8.exec(color)) return ($67a01f8f769a9ff0$var$hslToRgb($67a01f8f769a9ff0$var$parse360(match[1]), // h
    $67a01f8f769a9ff0$var$parsePercentage(match[2]), // s
    $67a01f8f769a9ff0$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $67a01f8f769a9ff0$export$810b04175080204c.exec(color)) return ($67a01f8f769a9ff0$var$hslToRgb($67a01f8f769a9ff0$var$parse360(match[1]), // h
    $67a01f8f769a9ff0$var$parsePercentage(match[2]), // s
    $67a01f8f769a9ff0$var$parsePercentage(match[3])) | $67a01f8f769a9ff0$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $67a01f8f769a9ff0$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $67a01f8f769a9ff0$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $67a01f8f769a9ff0$var$hue2rgb(p, q, h + 1 / 3);
    const g = $67a01f8f769a9ff0$var$hue2rgb(p, q, h);
    const b = $67a01f8f769a9ff0$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $67a01f8f769a9ff0$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $67a01f8f769a9ff0$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $67a01f8f769a9ff0$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $67a01f8f769a9ff0$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $67a01f8f769a9ff0$export$61db176b839af1f(input) {
    let int32Color = $67a01f8f769a9ff0$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $67a01f8f769a9ff0$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.arr(range)) return $67a01f8f769a9ff0$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($67a01f8f769a9ff0$export$226b3eccf92c9ed9.str(range.output[0])) return $67a01f8f769a9ff0$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $67a01f8f769a9ff0$var$findRange(input, inputRange);
        return $67a01f8f769a9ff0$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $67a01f8f769a9ff0$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $67a01f8f769a9ff0$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $67a01f8f769a9ff0$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $67a01f8f769a9ff0$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $67a01f8f769a9ff0$var$c1 = 1.70158;
var $67a01f8f769a9ff0$var$c2 = $67a01f8f769a9ff0$var$c1 * 1.525;
var $67a01f8f769a9ff0$var$c3 = $67a01f8f769a9ff0$var$c1 + 1;
var $67a01f8f769a9ff0$var$c4 = 2 * Math.PI / 3;
var $67a01f8f769a9ff0$var$c5 = 2 * Math.PI / 4.5;
var $67a01f8f769a9ff0$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $67a01f8f769a9ff0$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$67a01f8f769a9ff0$var$c3 * x * x * x - $67a01f8f769a9ff0$var$c1 * x * x,
    easeOutBack: (x)=>1 + $67a01f8f769a9ff0$var$c3 * Math.pow(x - 1, 3) + $67a01f8f769a9ff0$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($67a01f8f769a9ff0$var$c2 + 1) * 2 * x - $67a01f8f769a9ff0$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($67a01f8f769a9ff0$var$c2 + 1) * (x * 2 - 2) + $67a01f8f769a9ff0$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $67a01f8f769a9ff0$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $67a01f8f769a9ff0$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $67a01f8f769a9ff0$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $67a01f8f769a9ff0$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $67a01f8f769a9ff0$var$bounceOut(1 - x),
    easeOutBounce: $67a01f8f769a9ff0$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $67a01f8f769a9ff0$var$bounceOut(1 - 2 * x)) / 2 : (1 + $67a01f8f769a9ff0$var$bounceOut(2 * x - 1)) / 2,
    steps: $67a01f8f769a9ff0$var$steps
};
// src/fluids.ts
var $67a01f8f769a9ff0$var$$get = Symbol.for("FluidValue.get");
var $67a01f8f769a9ff0$var$$observers = Symbol.for("FluidValue.observers");
var $67a01f8f769a9ff0$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$67a01f8f769a9ff0$var$$get]);
var $67a01f8f769a9ff0$export$e37b7520edd66839 = (arg)=>arg && arg[$67a01f8f769a9ff0$var$$get] ? arg[$67a01f8f769a9ff0$var$$get]() : arg;
var $67a01f8f769a9ff0$export$133f54e9f7cf1796 = (target)=>target[$67a01f8f769a9ff0$var$$observers] || null;
function $67a01f8f769a9ff0$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $67a01f8f769a9ff0$export$31752c40a5fab62a(target, event) {
    const observers = target[$67a01f8f769a9ff0$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $67a01f8f769a9ff0$export$8cbca1207adce0c0(observer2, event);
    });
}
var $67a01f8f769a9ff0$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $67a01f8f769a9ff0$export$a3b4618659637aa3(this, get);
    }
};
$67a01f8f769a9ff0$var$$get, $67a01f8f769a9ff0$var$$observers;
var $67a01f8f769a9ff0$export$a3b4618659637aa3 = (target, get)=>$67a01f8f769a9ff0$var$setHidden(target, $67a01f8f769a9ff0$var$$get, get);
function $67a01f8f769a9ff0$export$72d604e3f8d000a5(target, observer2) {
    if (target[$67a01f8f769a9ff0$var$$get]) {
        let observers = target[$67a01f8f769a9ff0$var$$observers];
        if (!observers) $67a01f8f769a9ff0$var$setHidden(target, $67a01f8f769a9ff0$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $67a01f8f769a9ff0$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$67a01f8f769a9ff0$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$67a01f8f769a9ff0$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $67a01f8f769a9ff0$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $67a01f8f769a9ff0$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $67a01f8f769a9ff0$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $67a01f8f769a9ff0$var$unitRegex = new RegExp(`(${$67a01f8f769a9ff0$var$numberRegex.source})(%|[a-z]+)`, "i");
var $67a01f8f769a9ff0$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $67a01f8f769a9ff0$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $67a01f8f769a9ff0$var$variableToRgba = (input)=>{
    const [token, fallback] = $67a01f8f769a9ff0$var$parseCSSVariable(input);
    if (!token || $67a01f8f769a9ff0$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $67a01f8f769a9ff0$var$cssVariableRegex.test(fallback)) return $67a01f8f769a9ff0$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $67a01f8f769a9ff0$var$parseCSSVariable = (current)=>{
    const match = $67a01f8f769a9ff0$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $67a01f8f769a9ff0$var$namedColorRegex;
var $67a01f8f769a9ff0$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $67a01f8f769a9ff0$export$4759a013d387347a = (config)=>{
    if (!$67a01f8f769a9ff0$var$namedColorRegex) $67a01f8f769a9ff0$var$namedColorRegex = $67a01f8f769a9ff0$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($67a01f8f769a9ff0$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $67a01f8f769a9ff0$export$e37b7520edd66839(value).replace($67a01f8f769a9ff0$var$cssVariableRegex, $67a01f8f769a9ff0$var$variableToRgba).replace($67a01f8f769a9ff0$var$colorRegex, $67a01f8f769a9ff0$export$61db176b839af1f).replace($67a01f8f769a9ff0$var$namedColorRegex, $67a01f8f769a9ff0$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($67a01f8f769a9ff0$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$67a01f8f769a9ff0$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$67a01f8f769a9ff0$var$unitRegex.test(output[0]) && output.find((value)=>$67a01f8f769a9ff0$var$unitRegex.test(value))?.replace($67a01f8f769a9ff0$var$numberRegex, "");
        let i = 0;
        return output[0].replace($67a01f8f769a9ff0$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($67a01f8f769a9ff0$var$rgbaRegex, $67a01f8f769a9ff0$var$rgbaRound);
    };
};
// src/deprecations.ts
var $67a01f8f769a9ff0$export$82e9f45cca5ba907 = "react-spring: ";
var $67a01f8f769a9ff0$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$67a01f8f769a9ff0$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $67a01f8f769a9ff0$var$warnInterpolate = $67a01f8f769a9ff0$export$d2de3aaeafa91619(console.warn);
function $67a01f8f769a9ff0$export$2abfcde8ae218ba8() {
    $67a01f8f769a9ff0$var$warnInterpolate(`${$67a01f8f769a9ff0$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $67a01f8f769a9ff0$var$warnDirectCall = $67a01f8f769a9ff0$export$d2de3aaeafa91619(console.warn);
function $67a01f8f769a9ff0$export$d99d974913ad3b12() {
    $67a01f8f769a9ff0$var$warnDirectCall(`${$67a01f8f769a9ff0$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $67a01f8f769a9ff0$export$75bed621f62abfa9(value) {
    return $67a01f8f769a9ff0$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$67a01f8f769a9ff0$export$48d7c418edadb60c() && $67a01f8f769a9ff0$var$cssVariableRegex.test(value) || value in ($67a01f8f769a9ff0$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $67a01f8f769a9ff0$var$observer;
var $67a01f8f769a9ff0$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $67a01f8f769a9ff0$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $67a01f8f769a9ff0$var$resizeElement(handler, target) {
    if (!$67a01f8f769a9ff0$var$observer) {
        if (typeof ResizeObserver !== "undefined") $67a01f8f769a9ff0$var$observer = new ResizeObserver($67a01f8f769a9ff0$var$handleObservation);
    }
    let elementHandlers = $67a01f8f769a9ff0$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $67a01f8f769a9ff0$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($67a01f8f769a9ff0$var$observer) $67a01f8f769a9ff0$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $67a01f8f769a9ff0$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $67a01f8f769a9ff0$var$observer) $67a01f8f769a9ff0$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $67a01f8f769a9ff0$var$listeners = /* @__PURE__ */ new Set();
var $67a01f8f769a9ff0$var$cleanupWindowResizeHandler;
var $67a01f8f769a9ff0$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $67a01f8f769a9ff0$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $67a01f8f769a9ff0$var$resizeWindow = (callback)=>{
    $67a01f8f769a9ff0$var$listeners.add(callback);
    if (!$67a01f8f769a9ff0$var$cleanupWindowResizeHandler) $67a01f8f769a9ff0$var$cleanupWindowResizeHandler = $67a01f8f769a9ff0$var$createResizeHandler();
    return ()=>{
        $67a01f8f769a9ff0$var$listeners.delete(callback);
        if (!$67a01f8f769a9ff0$var$listeners.size && $67a01f8f769a9ff0$var$cleanupWindowResizeHandler) {
            $67a01f8f769a9ff0$var$cleanupWindowResizeHandler();
            $67a01f8f769a9ff0$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $67a01f8f769a9ff0$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $67a01f8f769a9ff0$var$resizeWindow(callback);
    else return $67a01f8f769a9ff0$var$resizeElement(callback, container);
};
// src/progress.ts
var $67a01f8f769a9ff0$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $67a01f8f769a9ff0$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $67a01f8f769a9ff0$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $67a01f8f769a9ff0$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $67a01f8f769a9ff0$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $67a01f8f769a9ff0$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $67a01f8f769a9ff0$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $67a01f8f769a9ff0$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $67a01f8f769a9ff0$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $67a01f8f769a9ff0$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $67a01f8f769a9ff0$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$67a01f8f769a9ff0$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $67a01f8f769a9ff0$var$scrollListeners.set(container, listener);
        const target = $67a01f8f769a9ff0$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $67a01f8f769a9ff0$var$resizeListeners.set(container, $67a01f8f769a9ff0$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $67a01f8f769a9ff0$var$scrollListeners.get(container);
    (0, $1jvl8.raf)(animateScroll);
    return ()=>{
        (0, $1jvl8.raf).cancel(animateScroll);
        const containerHandlers2 = $67a01f8f769a9ff0$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $67a01f8f769a9ff0$var$scrollListeners.get(container);
        $67a01f8f769a9ff0$var$scrollListeners.delete(container);
        if (listener) {
            $67a01f8f769a9ff0$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $67a01f8f769a9ff0$var$resizeListeners.get(container)?.();
        }
    };
};
function $67a01f8f769a9ff0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $67a01f8f769a9ff0$export$700979bc83e7db82 = $67a01f8f769a9ff0$export$48d7c418edadb60c() ? (0, $bh6RR.useEffect) : (0, $bh6RR.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $67a01f8f769a9ff0$var$useIsMounted = ()=>{
    const isMounted = (0, $bh6RR.useRef)(false);
    $67a01f8f769a9ff0$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $67a01f8f769a9ff0$export$91db9bc4f8ac944a() {
    const update = (0, $bh6RR.useState)()[1];
    const isMounted = $67a01f8f769a9ff0$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $67a01f8f769a9ff0$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $bh6RR.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $bh6RR.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $67a01f8f769a9ff0$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $bh6RR.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $67a01f8f769a9ff0$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $67a01f8f769a9ff0$export$392544347a18b6ea = (effect)=>(0, $bh6RR.useEffect)(effect, $67a01f8f769a9ff0$var$emptyDeps);
var $67a01f8f769a9ff0$var$emptyDeps = [];
function $67a01f8f769a9ff0$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $67a01f8f769a9ff0$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $bh6RR.useState)(null);
    $67a01f8f769a9ff0$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $67a01f8f769a9ff0$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

});
parcelRegister("1jvl8", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $0f4fe03d632663fd$export$27f233d61a9e2fa4; });
// src/index.ts
var $0f4fe03d632663fd$var$updateQueue = $0f4fe03d632663fd$var$makeQueue();
var $0f4fe03d632663fd$export$27f233d61a9e2fa4 = (fn)=>$0f4fe03d632663fd$var$schedule(fn, $0f4fe03d632663fd$var$updateQueue);
var $0f4fe03d632663fd$var$writeQueue = $0f4fe03d632663fd$var$makeQueue();
$0f4fe03d632663fd$export$27f233d61a9e2fa4.write = (fn)=>$0f4fe03d632663fd$var$schedule(fn, $0f4fe03d632663fd$var$writeQueue);
var $0f4fe03d632663fd$var$onStartQueue = $0f4fe03d632663fd$var$makeQueue();
$0f4fe03d632663fd$export$27f233d61a9e2fa4.onStart = (fn)=>$0f4fe03d632663fd$var$schedule(fn, $0f4fe03d632663fd$var$onStartQueue);
var $0f4fe03d632663fd$var$onFrameQueue = $0f4fe03d632663fd$var$makeQueue();
$0f4fe03d632663fd$export$27f233d61a9e2fa4.onFrame = (fn)=>$0f4fe03d632663fd$var$schedule(fn, $0f4fe03d632663fd$var$onFrameQueue);
var $0f4fe03d632663fd$var$onFinishQueue = $0f4fe03d632663fd$var$makeQueue();
$0f4fe03d632663fd$export$27f233d61a9e2fa4.onFinish = (fn)=>$0f4fe03d632663fd$var$schedule(fn, $0f4fe03d632663fd$var$onFinishQueue);
var $0f4fe03d632663fd$var$timeouts = [];
$0f4fe03d632663fd$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $0f4fe03d632663fd$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $0f4fe03d632663fd$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $0f4fe03d632663fd$var$timeouts.splice(i, 1);
        $0f4fe03d632663fd$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $0f4fe03d632663fd$var$timeouts.splice($0f4fe03d632663fd$var$findTimeout(time), 0, timeout);
    $0f4fe03d632663fd$var$pendingCount += 1;
    $0f4fe03d632663fd$var$start();
    return timeout;
};
var $0f4fe03d632663fd$var$findTimeout = (time)=>~(~$0f4fe03d632663fd$var$timeouts.findIndex((t)=>t.time > time) || ~$0f4fe03d632663fd$var$timeouts.length);
$0f4fe03d632663fd$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $0f4fe03d632663fd$var$onStartQueue.delete(fn);
    $0f4fe03d632663fd$var$onFrameQueue.delete(fn);
    $0f4fe03d632663fd$var$onFinishQueue.delete(fn);
    $0f4fe03d632663fd$var$updateQueue.delete(fn);
    $0f4fe03d632663fd$var$writeQueue.delete(fn);
};
$0f4fe03d632663fd$export$27f233d61a9e2fa4.sync = (fn)=>{
    $0f4fe03d632663fd$var$sync = true;
    $0f4fe03d632663fd$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $0f4fe03d632663fd$var$sync = false;
};
$0f4fe03d632663fd$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $0f4fe03d632663fd$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $0f4fe03d632663fd$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $0f4fe03d632663fd$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$0f4fe03d632663fd$export$27f233d61a9e2fa4.use = (impl)=>$0f4fe03d632663fd$var$nativeRaf = impl;
$0f4fe03d632663fd$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$0f4fe03d632663fd$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$0f4fe03d632663fd$export$27f233d61a9e2fa4.catch = console.error;
$0f4fe03d632663fd$export$27f233d61a9e2fa4.frameLoop = "always";
$0f4fe03d632663fd$export$27f233d61a9e2fa4.advance = ()=>{
    if ($0f4fe03d632663fd$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $0f4fe03d632663fd$var$update();
};
var $0f4fe03d632663fd$var$ts = -1;
var $0f4fe03d632663fd$var$pendingCount = 0;
var $0f4fe03d632663fd$var$sync = false;
function $0f4fe03d632663fd$var$schedule(fn, queue) {
    if ($0f4fe03d632663fd$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $0f4fe03d632663fd$var$start();
    }
}
function $0f4fe03d632663fd$var$start() {
    if ($0f4fe03d632663fd$var$ts < 0) {
        $0f4fe03d632663fd$var$ts = 0;
        if ($0f4fe03d632663fd$export$27f233d61a9e2fa4.frameLoop !== "demand") $0f4fe03d632663fd$var$nativeRaf($0f4fe03d632663fd$var$loop);
    }
}
function $0f4fe03d632663fd$var$stop() {
    $0f4fe03d632663fd$var$ts = -1;
}
function $0f4fe03d632663fd$var$loop() {
    if (~$0f4fe03d632663fd$var$ts) {
        $0f4fe03d632663fd$var$nativeRaf($0f4fe03d632663fd$var$loop);
        $0f4fe03d632663fd$export$27f233d61a9e2fa4.batchedUpdates($0f4fe03d632663fd$var$update);
    }
}
function $0f4fe03d632663fd$var$update() {
    const prevTs = $0f4fe03d632663fd$var$ts;
    $0f4fe03d632663fd$var$ts = $0f4fe03d632663fd$export$27f233d61a9e2fa4.now();
    const count = $0f4fe03d632663fd$var$findTimeout($0f4fe03d632663fd$var$ts);
    if (count) {
        $0f4fe03d632663fd$var$eachSafely($0f4fe03d632663fd$var$timeouts.splice(0, count), (t)=>t.handler());
        $0f4fe03d632663fd$var$pendingCount -= count;
    }
    if (!$0f4fe03d632663fd$var$pendingCount) {
        $0f4fe03d632663fd$var$stop();
        return;
    }
    $0f4fe03d632663fd$var$onStartQueue.flush();
    $0f4fe03d632663fd$var$updateQueue.flush(prevTs ? Math.min(64, $0f4fe03d632663fd$var$ts - prevTs) : 16.667);
    $0f4fe03d632663fd$var$onFrameQueue.flush();
    $0f4fe03d632663fd$var$writeQueue.flush();
    $0f4fe03d632663fd$var$onFinishQueue.flush();
}
function $0f4fe03d632663fd$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $0f4fe03d632663fd$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $0f4fe03d632663fd$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $0f4fe03d632663fd$var$pendingCount -= current.size;
                $0f4fe03d632663fd$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $0f4fe03d632663fd$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $0f4fe03d632663fd$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $0f4fe03d632663fd$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $0f4fe03d632663fd$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $0f4fe03d632663fd$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $0f4fe03d632663fd$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $0f4fe03d632663fd$var$ts = -1;
        $0f4fe03d632663fd$var$timeouts = [];
        $0f4fe03d632663fd$var$onStartQueue = $0f4fe03d632663fd$var$makeQueue();
        $0f4fe03d632663fd$var$updateQueue = $0f4fe03d632663fd$var$makeQueue();
        $0f4fe03d632663fd$var$onFrameQueue = $0f4fe03d632663fd$var$makeQueue();
        $0f4fe03d632663fd$var$writeQueue = $0f4fe03d632663fd$var$makeQueue();
        $0f4fe03d632663fd$var$onFinishQueue = $0f4fe03d632663fd$var$makeQueue();
        $0f4fe03d632663fd$var$pendingCount = 0;
    }
};

});


parcelRegister("22K8L", function(module, exports) {

$parcel$export(module.exports, "getAnimated", function () { return $17cf8f29d99824c1$export$6b63995194a3a9e4; });
$parcel$export(module.exports, "setAnimated", function () { return $17cf8f29d99824c1$export$b553cb5b22b81b04; });
$parcel$export(module.exports, "getPayload", function () { return $17cf8f29d99824c1$export$ccab2b64c5d440; });
$parcel$export(module.exports, "AnimatedValue", function () { return $17cf8f29d99824c1$export$cb1e8f3c05d37ad5; });
$parcel$export(module.exports, "AnimatedString", function () { return $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93; });
$parcel$export(module.exports, "AnimatedObject", function () { return $17cf8f29d99824c1$export$f1b0b9e366a6e2d4; });
$parcel$export(module.exports, "getAnimatedType", function () { return $17cf8f29d99824c1$export$e6b77ddbe47b132e; });
$parcel$export(module.exports, "createHost", function () { return $17cf8f29d99824c1$export$4ee5c78f6dcbcef; });
// src/Animated.ts

var $8TAX3 = parcelRequire("8TAX3");
var $1jvl8 = parcelRequire("1jvl8");

var $bh6RR = parcelRequire("bh6RR");
var $17cf8f29d99824c1$var$$node = Symbol.for("Animated:node");
var $17cf8f29d99824c1$export$3df5e165e801a70f = (value)=>!!value && value[$17cf8f29d99824c1$var$$node] === value;
var $17cf8f29d99824c1$export$6b63995194a3a9e4 = (owner)=>owner && owner[$17cf8f29d99824c1$var$$node];
var $17cf8f29d99824c1$export$b553cb5b22b81b04 = (owner, node)=>(0, $8TAX3.defineHidden)(owner, $17cf8f29d99824c1$var$$node, node);
var $17cf8f29d99824c1$export$ccab2b64c5d440 = (owner)=>owner && owner[$17cf8f29d99824c1$var$$node] && owner[$17cf8f29d99824c1$var$$node].getPayload();
var $17cf8f29d99824c1$export$31627395a3b18e54 = class {
    constructor(){
        $17cf8f29d99824c1$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $17cf8f29d99824c1$export$cb1e8f3c05d37ad5 = class extends $17cf8f29d99824c1$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $8TAX3.is).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $17cf8f29d99824c1$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $8TAX3.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $8TAX3.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93 = class extends $17cf8f29d99824c1$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $8TAX3.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $8TAX3.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $8TAX3.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $17cf8f29d99824c1$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $17cf8f29d99824c1$export$f1b0b9e366a6e2d4 = class extends $17cf8f29d99824c1$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $8TAX3.eachProp)(this.source, (source, key)=>{
            if ($17cf8f29d99824c1$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $8TAX3.hasFluidValue)(source)) values[key] = (0, $8TAX3.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $8TAX3.each)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $8TAX3.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($17cf8f29d99824c1$var$TreeContext.dependencies && (0, $8TAX3.hasFluidValue)(source)) $17cf8f29d99824c1$var$TreeContext.dependencies.add(source);
        const payload = $17cf8f29d99824c1$export$ccab2b64c5d440(source);
        if (payload) (0, $8TAX3.each)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $17cf8f29d99824c1$export$ede394683406942d = class extends $17cf8f29d99824c1$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $17cf8f29d99824c1$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($17cf8f29d99824c1$var$makeAnimated));
        return true;
    }
};
function $17cf8f29d99824c1$var$makeAnimated(value) {
    const nodeType = (0, $8TAX3.isAnimatedString)(value) ? $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93 : $17cf8f29d99824c1$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $17cf8f29d99824c1$export$e6b77ddbe47b132e(value) {
    const parentNode = $17cf8f29d99824c1$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $8TAX3.is).arr(value) ? $17cf8f29d99824c1$export$ede394683406942d : (0, $8TAX3.isAnimatedString)(value) ? $17cf8f29d99824c1$export$f6c6c4cbd7fa5b93 : $17cf8f29d99824c1$export$cb1e8f3c05d37ad5;
}
var $17cf8f29d99824c1$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $8TAX3.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $bh6RR.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $bh6RR.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $bh6RR.useCallback)((value)=>{
            instanceRef.current = $17cf8f29d99824c1$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $17cf8f29d99824c1$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $8TAX3.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $17cf8f29d99824c1$var$PropsObserver(callback, deps);
        const observerRef = (0, $bh6RR.useRef)();
        (0, $8TAX3.useIsomorphicLayoutEffect)(()=>{
            observerRef.current = observer;
            (0, $8TAX3.each)(deps, (dep)=>(0, $8TAX3.addFluidObserver)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $8TAX3.each)(observerRef.current.deps, (dep)=>(0, $8TAX3.removeFluidObserver)(dep, observerRef.current));
                    (0, $1jvl8.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, $bh6RR.useEffect)(callback, []);
        (0, $8TAX3.useOnce)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $8TAX3.each)(observer2.deps, (dep)=>(0, $8TAX3.removeFluidObserver)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $bh6RR.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $17cf8f29d99824c1$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $1jvl8.raf).write(this.update);
    }
};
function $17cf8f29d99824c1$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $17cf8f29d99824c1$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $17cf8f29d99824c1$export$f1b0b9e366a6e2d4(props);
    $17cf8f29d99824c1$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $17cf8f29d99824c1$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $8TAX3.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $17cf8f29d99824c1$var$cacheKey = Symbol.for("AnimatedComponent");
var $17cf8f29d99824c1$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $17cf8f29d99824c1$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $17cf8f29d99824c1$var$getDisplayName(Component) || "Anonymous";
        if ((0, $8TAX3.is).str(Component)) Component = animated[Component] || (animated[Component] = $17cf8f29d99824c1$var$withAnimated(Component, hostConfig));
        else Component = Component[$17cf8f29d99824c1$var$cacheKey] || (Component[$17cf8f29d99824c1$var$cacheKey] = $17cf8f29d99824c1$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $8TAX3.eachProp)(components, (Component, key)=>{
        if ((0, $8TAX3.is).arr(components)) key = $17cf8f29d99824c1$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $17cf8f29d99824c1$var$getDisplayName = (arg)=>(0, $8TAX3.is).str(arg) ? arg : arg && (0, $8TAX3.is).str(arg.displayName) ? arg.displayName : (0, $8TAX3.is).fun(arg) && arg.name || null;

});

parcelRegister("jTNJs", function(module, exports) {
// src/utils.ts
var $e7c9bb2cfef2c846$export$b24b633b1364b94b = class {
};

});


parcelRegister("6afFj", function(module, exports) {
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});


parcelRegister("gwlG1", function(module, exports) {

$parcel$export(module.exports, "AddOutline", function () { return $ba4f6b4ed3bc35bd$export$153c75dc7c5411ee; });
$parcel$export(module.exports, "AppsSharp", function () { return $ba4f6b4ed3bc35bd$export$7aad6ca0460ebff4; });
$parcel$export(module.exports, "CaretDownOutline", function () { return $ba4f6b4ed3bc35bd$export$1c2a14ef1dd3961e; });
$parcel$export(module.exports, "CaretUpOutline", function () { return $ba4f6b4ed3bc35bd$export$dc3c92c813e5ee59; });
$parcel$export(module.exports, "CaretUpSharpCropped", function () { return $ba4f6b4ed3bc35bd$export$baf835abbfe63f23; });
$parcel$export(module.exports, "CheckMarkSharp", function () { return $ba4f6b4ed3bc35bd$export$b8eb23a8127db75b; });
$parcel$export(module.exports, "ChevronForwardFilled", function () { return $ba4f6b4ed3bc35bd$export$a5dd0a93f2774df5; });
$parcel$export(module.exports, "CircleOffOutline", function () { return $ba4f6b4ed3bc35bd$export$8d5c269d0c171f30; });
$parcel$export(module.exports, "CloseFilled", function () { return $ba4f6b4ed3bc35bd$export$4300487bd08a483b; });
$parcel$export(module.exports, "DiceFilled", function () { return $ba4f6b4ed3bc35bd$export$74daf8fe3aed2eea; });
$parcel$export(module.exports, "HourglassOutline", function () { return $ba4f6b4ed3bc35bd$export$7654f4060bbdae0a; });
$parcel$export(module.exports, "InformationCircleOutline", function () { return $ba4f6b4ed3bc35bd$export$91af38ab072f1384; });
$parcel$export(module.exports, "LanguageOutline", function () { return $ba4f6b4ed3bc35bd$export$17b5d4fa44d8b948; });
$parcel$export(module.exports, "OpenInNew", function () { return $ba4f6b4ed3bc35bd$export$b7339c1e478ebfca; });
$parcel$export(module.exports, "PeopleSharp", function () { return $ba4f6b4ed3bc35bd$export$7895ee831b11a2f; });
$parcel$export(module.exports, "PersonFilled", function () { return $ba4f6b4ed3bc35bd$export$482a8d6d84213ca8; });
$parcel$export(module.exports, "RefreshOutline", function () { return $ba4f6b4ed3bc35bd$export$19549bcb22a57d52; });
$parcel$export(module.exports, "RemoveOutline", function () { return $ba4f6b4ed3bc35bd$export$93a54c445d204d44; });
$parcel$export(module.exports, "SearchOutline", function () { return $ba4f6b4ed3bc35bd$export$b77c0fd6d1c65b0a; });
$parcel$export(module.exports, "SparklesSharp", function () { return $ba4f6b4ed3bc35bd$export$beddf0d47ff121db; });
$parcel$export(module.exports, "SparkSolid", function () { return $ba4f6b4ed3bc35bd$export$af9f487d50a84b8a; });
$parcel$export(module.exports, "StarOutline", function () { return $ba4f6b4ed3bc35bd$export$ac31625c0615bb80; });
$parcel$export(module.exports, "StarFilled", function () { return $ba4f6b4ed3bc35bd$export$5c83eb0ad220f681; });
$parcel$export(module.exports, "StatsChartSharp", function () { return $ba4f6b4ed3bc35bd$export$2f92b5a5eafc51a5; });
$parcel$export(module.exports, "TimeOutline", function () { return $ba4f6b4ed3bc35bd$export$804ff2f92a91d6bd; });

var $ih19M = parcelRequire("ih19M");

var $hg2ot = parcelRequire("hg2ot");
const $ba4f6b4ed3bc35bd$export$153c75dc7c5411ee = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32",
            d: "M256 112v288M400 256H112"
        })
    });
const $ba4f6b4ed3bc35bd$export$7aad6ca0460ebff4 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "48",
                y: "48",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "200",
                y: "48",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "352",
                y: "48",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "48",
                y: "200",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "200",
                y: "200",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "352",
                y: "200",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "48",
                y: "352",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "200",
                y: "352",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "352",
                y: "352",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$6f417fd7cd228c34 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M58.79 439.13A16 16 0 0148 424c0-73.1 14.68-131.56 43.65-173.77 35-51 90.21-78.46 164.35-81.87V88a16 16 0 0127.05-11.57l176 168a16 16 0 010 23.14l-176 168A16 16 0 01256 424v-79.77c-45 1.36-79 8.65-106.07 22.64-29.25 15.12-50.46 37.71-73.32 67a16 16 0 01-17.82 5.28z"
        })
    });
const $ba4f6b4ed3bc35bd$export$1c2a14ef1dd3961e = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$dc3c92c813e5ee59 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$8c0dc4ceaba1bc68 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M448 368L256 144 64 368h384z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$baf835abbfe63f23 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 384 224",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("g", {
            transform: "translate(-64,-144)",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M448 368L256 144 64 368h384z",
                fill: "currentColor"
            })
        })
    });
const $ba4f6b4ed3bc35bd$export$b8eb23a8127db75b = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "44",
            d: "M416 128L192 384l-96-96"
        })
    });
const $ba4f6b4ed3bc35bd$export$a5dd0a93f2774df5 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48",
            d: "M184 112l144 144-144 144"
        })
    });
const $ba4f6b4ed3bc35bd$export$8d5c269d0c171f30 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M22.11 21.46L2.39 1.73L1.11 3L4.06 5.95C2.78 7.63 2 9.72 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.05 19.94L20.84 22.73L22.11 21.46M12 20C7.58 20 4 16.42 4 12C4 10.27 4.56 8.68 5.5 7.38L16.62 18.5C15.32 19.45 13.73 20 12 20M8.17 4.97L6.72 3.5C8.25 2.56 10.06 2 12 2C17.5 2 22 6.5 22 12C22 13.94 21.44 15.75 20.5 17.28L19.03 15.83C19.65 14.69 20 13.39 20 12C20 7.58 16.42 4 12 4C10.61 4 9.31 4.35 8.17 4.97Z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$4300487bd08a483b = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$4127fbdca3a71de6 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M121.72 32a4 4 0 00-3.72 5.56l2.3 5.43 40.7 94.9a4 4 0 006.88.82L243 38.4a4 4 0 00-3.2-6.4zM419.93 58.06l-41.28 96.37a4 4 0 003.68 5.57h101a4 4 0 003.4-6.11L427 57.53a4 4 0 00-7.07.53zM85 57.57l-59.71 96.32a4 4 0 003.4 6.11h101a4 4 0 003.67-5.58L92 58.1a4 4 0 00-7-.53zM393.27 32H267.82a1.94 1.94 0 00-1.56 3.11l79.92 106.46a1.94 1.94 0 003.34-.4L391.6 43l3.4-8.34a1.92 1.92 0 00-1.7-2.66zM239 448l-89.43-253.49A3.78 3.78 0 00146 192H25.7a3.72 3.72 0 00-2.95 6l216 279.81a5.06 5.06 0 006.39 1.37 5 5 0 002.39-6.08zM486.3 192H366a3.75 3.75 0 00-3.54 2.51l-98.2 278.16a5.21 5.21 0 002.42 6.31 5.22 5.22 0 006.61-1.39L489.25 198a3.72 3.72 0 00-2.95-6zM259.2 78.93l56 74.67a4 4 0 01-3.2 6.4H200a4 4 0 01-3.2-6.4l56-74.67a4 4 0 016.4 0zm-7 310.31l-67.7-191.91a4 4 0 013.77-5.33h135.46a4 4 0 013.77 5.33l-67.73 191.91a4 4 0 01-7.54 0z"
        })
    });
const $ba4f6b4ed3bc35bd$export$74daf8fe3aed2eea = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M440.88 129.37L288.16 40.62a64.14 64.14 0 00-64.33 0L71.12 129.37a4 4 0 000 6.9L254 243.85a4 4 0 004.06 0L440.9 136.27a4 4 0 00-.02-6.9zM256 152c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16zM238 270.81L54 163.48a4 4 0 00-6 3.46v173.92a48 48 0 0023.84 41.39L234 479.48a4 4 0 006-3.46V274.27a4 4 0 00-2-3.46zM96 368c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96-32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zM458 163.51L274 271.56a4 4 0 00-2 3.45V476a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.86V167a4 4 0 00-6-3.49zM320 424c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$8f597f99fda68ae5 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M69 153.99l187 110 187-110M256 463.99v-200"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "256",
                cy: "152",
                rx: "24",
                ry: "16"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "208",
                cy: "296",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "112",
                cy: "328",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "304",
                cy: "296",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "400",
                cy: "240",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "304",
                cy: "384",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "400",
                cy: "328",
                rx: "16",
                ry: "24"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$96a6722341cc5ba4 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34M394.67 394.67c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M256 48v416M464 256H48"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$5f2da371755202ed = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M277.42 247a24.68 24.68 0 00-4.08-5.47L255 223.44a21.63 21.63 0 00-6.56-4.57 20.93 20.93 0 00-23.28 4.27c-6.36 6.26-18 17.68-39 38.43C146 301.3 71.43 367.89 37.71 396.29a16 16 0 00-1.09 23.54l39 39.43a16.13 16.13 0 0023.67-.89c29.24-34.37 96.3-109 136-148.23 20.39-20.06 31.82-31.58 38.29-37.94a21.76 21.76 0 003.84-25.2zM478.43 201l-34.31-34a5.44 5.44 0 00-4-1.59 5.59 5.59 0 00-4 1.59h0a11.41 11.41 0 01-9.55 3.27c-4.48-.49-9.25-1.88-12.33-4.86-7-6.86 1.09-20.36-5.07-29a242.88 242.88 0 00-23.08-26.72c-7.06-7-34.81-33.47-81.55-52.53a123.79 123.79 0 00-47-9.24c-26.35 0-46.61 11.76-54 18.51-5.88 5.32-12 13.77-12 13.77a91.29 91.29 0 0110.81-3.2 79.53 79.53 0 0123.28-1.49C241.19 76.8 259.94 84.1 270 92c16.21 13 23.18 30.39 24.27 52.83.8 16.69-15.23 37.76-30.44 54.94a7.85 7.85 0 00.4 10.83l21.24 21.23a8 8 0 0011.14.1c13.93-13.51 31.09-28.47 40.82-34.46s17.58-7.68 21.35-8.09a35.71 35.71 0 0121.3 4.62 13.65 13.65 0 013.08 2.38c6.46 6.56 6.07 17.28-.5 23.74l-2 1.89a5.5 5.5 0 000 7.84l34.31 34a5.5 5.5 0 004 1.58 5.65 5.65 0 004-1.58L478.43 209a5.82 5.82 0 000-8z",
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32"
        })
    });
const $ba4f6b4ed3bc35bd$export$7654f4060bbdae0a = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M145.61 464h220.78c19.8 0 35.55-16.29 33.42-35.06C386.06 308 304 310 304 256s83.11-51 95.8-172.94c2-18.78-13.61-35.06-33.41-35.06H145.61c-19.8 0-35.37 16.28-33.41 35.06C124.89 205 208 201 208 256s-82.06 52-95.8 172.94c-2.14 18.77 13.61 35.06 33.41 35.06z",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.23 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z",
                fill: (0, $hg2ot.secondaryColor)
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$91af38ab072f1384 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        fill: "currentColor",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M220 220h32v116"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M208 340h88"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M248 130a26 26 0 1026 26 26 26 0 00-26-26z",
                fill: "currentColor"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$17b5d4fa44d8b948 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M48 112h288M192 64v48M272 448l96-224 96 224M301.5 384h133M281.3 112S257 206 199 277 80 384 80 384"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M256 336s-35-27-72-75-56-85-56-85",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$4463b97b803ca5c0 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M464 66.52A50 50 0 00414.12 17L97.64 16A49.65 49.65 0 0048 65.52V392c0 27.3 22.28 48 49.64 48H368l-13-44 109 100zM324.65 329.81s-8.72-10.39-16-19.32C340.39 301.55 352.5 282 352.5 282a139 139 0 01-27.85 14.25 173.31 173.31 0 01-35.11 10.39 170.05 170.05 0 01-62.72-.24 184.45 184.45 0 01-35.59-10.4 141.46 141.46 0 01-17.68-8.21c-.73-.48-1.45-.72-2.18-1.21-.49-.24-.73-.48-1-.48-4.36-2.42-6.78-4.11-6.78-4.11s11.62 19.09 42.38 28.26c-7.27 9.18-16.23 19.81-16.23 19.81-53.51-1.69-73.85-36.47-73.85-36.47 0-77.06 34.87-139.62 34.87-139.62 34.87-25.85 67.8-25.12 67.8-25.12l2.42 2.9c-43.59 12.32-63.44 31.4-63.44 31.4s5.32-2.9 14.28-6.77c25.91-11.35 46.5-14.25 55-15.21a24 24 0 014.12-.49 205.62 205.62 0 0148.91-.48 201.62 201.62 0 0172.89 22.95s-19.13-18.15-60.3-30.45l3.39-3.86s33.17-.73 67.81 25.16c0 0 34.87 62.56 34.87 139.62 0-.28-20.35 34.5-73.86 36.19z"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M212.05 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.8 0 24.7-11.83 24.7-26.57.25-14.76-10.9-26.57-24.7-26.57zM300.43 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.81 0 24.7-11.83 24.7-26.57S314 218 300.43 218z"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$11137d1629e065ab = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zM400 288v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48c-68.88 15.61-96 76.76-96 147.47V288l-48 64v48h384v-48z"
        })
    });
const $ba4f6b4ed3bc35bd$export$b7339c1e478ebfca = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fill: "currentColor",
            d: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
        })
    });
const $ba4f6b4ed3bc35bd$export$7895ee831b11a2f = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "152",
                cy: "184",
                r: "72",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "340",
                cy: "168",
                r: "88",
                fill: "currentColor"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$482a8d6d84213ca8 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6zM432 480H80a31 31 0 01-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75 1.94 10.73-.68 21.34-7.18 29.11A31 31 0 01432 480z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$19549bcb22a57d52 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M320 146s24.36-12-64-12a160 160 0 10160 160",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M256 58l80 80-80 80"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$93a54c445d204d44 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32",
            d: "M400 256H112"
        })
    });
const $ba4f6b4ed3bc35bd$export$b77c0fd6d1c65b0a = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M338.29 338.29L448 448"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$beddf0d47ff121db = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M208 512l-52.38-139.62L16 320l139.62-52.38L208 128l52.38 139.62L400 320l-139.62 52.38zM88 176l-23.57-64.43L0 88l64.43-23.57L88 0l23.57 64.43L176 88l-64.43 23.57zM400 256l-31.11-80.89L288 144l80.89-31.11L400 32l31.11 80.89L512 144l-80.89 31.11z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$af9f487d50a84b8a = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "2 2 20 20",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M3 12C9.26752 12 12 9.36306 12 3C12 9.36306 14.7134 12 21 12C14.7134 12 12 14.7134 12 21C12 14.7134 9.26752 12 3 12Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinejoin: "round"
        })
    });
const $ba4f6b4ed3bc35bd$export$ac31625c0615bb80 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z",
            fill: "none",
            stroke: "currentColor",
            strokeLinejoin: "round",
            strokeWidth: "32"
        })
    });
const $ba4f6b4ed3bc35bd$export$5c83eb0ad220f681 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$2f92b5a5eafc51a5 = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M128 496H48V304h80zM352 496h-80V208h80zM464 496h-80V96h80zM240 496h-80V16h80z",
            fill: "currentColor"
        })
    });
const $ba4f6b4ed3bc35bd$export$9ec12bcab4b99393 = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M2 4.31092C2 4.31092 6.22172 7.55158 9.88185 4.18414C13.542 0.8167 15.3333 2.34686 15.3333 2.34686L12.2222 12.6667H11.4379C11.4379 12.6667 12.1961 10.8619 7.52891 10.8619C2.39216 10.8619 2 4.31092 2 4.31092Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M16.2223 2.44444H18.0001L13.5556 18H11.7778L16.2223 2.44444Z",
                fill: "currentColor"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$804ff2f92a91d6bd = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M256 128v144h96"
            })
        ]
    });
const $ba4f6b4ed3bc35bd$export$1166f58a2eef63af = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M368 112H144C64.6 112 0 176.6 0 256s64.6 144 144 144h224c79.4 0 144-64.6 144-144s-64.6-144-144-144zm0 256a112 112 0 11112-112 112.12 112.12 0 01-112 112z",
            fill: "currentColor"
        })
    });

});
parcelRegister("hg2ot", function(module, exports) {

$parcel$export(module.exports, "secondaryColor", function () { return $33ce22fae063651f$export$8195e3f84f31a7bf; });
const $33ce22fae063651f$export$8195e3f84f31a7bf = 'var(--secondary-color, currentColor)';

});


parcelRegister("bAMNu", function(module, exports) {

$parcel$export(module.exports, "ToasterId", function () { return $328e403d81377abe$export$4786645933ae8b1e; });

var $9UH0L = parcelRequire("9UH0L");
var $kJAjV = parcelRequire("kJAjV");
var $4lr6f = parcelRequire("4lr6f");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $1k68G = parcelRequire("1k68G");
const { wrap: $328e403d81377abe$var$wrap, unwrap: $328e403d81377abe$var$unwrap } = (0, $1k68G.iso)();
const $328e403d81377abe$var$generate = (0, $f5id0.pipe)((0, $9UH0L).now, (0, $4lr6f).map($328e403d81377abe$var$wrap));
const $328e403d81377abe$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($328e403d81377abe$var$unwrap));
const $328e403d81377abe$export$4786645933ae8b1e = {
    generate: $328e403d81377abe$var$generate,
    unwrap: $328e403d81377abe$var$unwrap,
    Eq: $328e403d81377abe$var$Eq
};

});
parcelRegister("9UH0L", function(module, exports) {

$parcel$export(module.exports, "Eq", function () { return $737ab52b374ed5e1$export$a2050e5b0c4dcf10; });
$parcel$export(module.exports, "eqDate", function () { return $737ab52b374ed5e1$export$4eced57d6183c43d; });
$parcel$export(module.exports, "eqMonth", function () { return $737ab52b374ed5e1$export$927de8112dffb3f8; });
$parcel$export(module.exports, "eqYear", function () { return $737ab52b374ed5e1$export$a20272c1d8245ff5; });
$parcel$export(module.exports, "Ord", function () { return $737ab52b374ed5e1$export$ee8aa95bfab51c5; });
$parcel$export(module.exports, "create", function () { return $737ab52b374ed5e1$export$185802fd694ee1f5; });
$parcel$export(module.exports, "now", function () { return $737ab52b374ed5e1$export$461939dd4422153; });

var $f5id0 = parcelRequire("f5id0");

var $10ZIc = parcelRequire("10ZIc");

var $12uqT = parcelRequire("12uqT");
var $737ab52b374ed5e1$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};
var $737ab52b374ed5e1$export$4eced57d6183c43d = {
    equals: function(x, y) {
        return x.getDate() === y.getDate();
    }
};
var $737ab52b374ed5e1$export$927de8112dffb3f8 = {
    equals: function(x, y) {
        return x.getMonth() === y.getMonth();
    }
};
var $737ab52b374ed5e1$export$a20272c1d8245ff5 = {
    equals: function(x, y) {
        return x.getFullYear() === y.getFullYear();
    }
};
var $737ab52b374ed5e1$export$ee8aa95bfab51c5 = /*#__PURE__*/ (0, $f5id0.pipe)($10ZIc.Ord, /*#__PURE__*/ $12uqT.contramap(function(date) {
    return date.valueOf();
}));
var $737ab52b374ed5e1$export$185802fd694ee1f5 = function() {
    return new Date();
};
var $737ab52b374ed5e1$export$461939dd4422153 = function() {
    return new Date().getTime();
};

});




parcelRegister("j30iL", function(module, exports) {

$parcel$export(module.exports, "UserContextProvider", function () { return $fd43dfcc218143a2$export$2e7f18b06f26b111; });
$parcel$export(module.exports, "useUser", function () { return $fd43dfcc218143a2$export$23bbbc4533528f03; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $kJAjV = parcelRequire("kJAjV");
var $IYheM = parcelRequire("IYheM");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $bh6RR = parcelRequire("bh6RR");

var $3WFZ7 = parcelRequire("3WFZ7");

var $k8rBo = parcelRequire("k8rBo");

var $gl9GP = parcelRequire("gl9GP");

var $aZGGZ = parcelRequire("aZGGZ");

var $3lg7I = parcelRequire("3lg7I");

var $sjwE0 = parcelRequire("sjwE0");

var $2cHG6 = parcelRequire("2cHG6");

var $g7UIk = parcelRequire("g7UIk");

var $kmQDF = parcelRequire("kmQDF");

var $bVugR = parcelRequire("bVugR");

var $854vE = parcelRequire("854vE");

var $65dIW = parcelRequire("65dIW");

var $jIcvJ = parcelRequire("jIcvJ");

var $7VlB6 = parcelRequire("7VlB6");

var $2sln7 = parcelRequire("2sln7");

var $31rfl = parcelRequire("31rfl");

var $4MEuc = parcelRequire("4MEuc");
const $fd43dfcc218143a2$var$recentSearchesKey = 'recentSearches';
const $fd43dfcc218143a2$var$recentSearchesCodec = (0, $sjwE0.Tuple).of((0, $sjwE0.List).codec((0, $jIcvJ.PartialSummonerShort).codec), 'List<PartialSummonerShort>');
const $fd43dfcc218143a2$var$byPuuidEq = (0, $kJAjV).struct({
    puuid: (0, $gl9GP.Puuid).Eq
});
const $fd43dfcc218143a2$var$UserContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
const $fd43dfcc218143a2$export$2e7f18b06f26b111 = ({ children: children })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { showToaster: showToaster } = (0, $31rfl.useToaster)();
    const { data: data, error: error, mutate: mutate } = (0, $3WFZ7.default)((0, $k8rBo.apiRoutes).user.self.get, ([url, method])=>(0, $f5id0.pipe)((0, $2sln7.http)([
            url,
            method
        ], {
            retry: 0
        }, [
            (0, $3lg7I.UserView).codec,
            'UserView'
        ]), (0, $2sln7.statusesToOption)(401, 404), (0, $2cHG6.futureMaybe).map((0, $f5id0.pipe)((0, $3lg7I.UserView).Lens.favoriteSearches, (0, $gnzcc).modify((0, $sjwE0.List).sort((0, $aZGGZ.SummonerShort).byRiotIdOrd)))), (0, $sjwE0.Future).orElse((e)=>{
            console.error(e);
            showToaster('error', t.errors.fetchUserError);
            return (0, $sjwE0.Future).failed(e);
        }), (0, $7VlB6.futureRunUnsafe)), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const addFavoriteSearch = (0, $bh6RR.useCallback)((summoner)=>(0, $f5id0.pipe)((0, $sjwE0.Maybe).fromNullable(data), (0, $sjwE0.Maybe).flatten, (0, $sjwE0.Maybe).filter((0, $f5id0.flow)((0, $3lg7I.UserView).Lens.favoriteSearches.get, (0, $IYheM).not((0, $sjwE0.List).elem($fd43dfcc218143a2$var$byPuuidEq)(summoner)))), (0, $sjwE0.Maybe).map((oldData)=>(0, $f5id0.pipe)((0, $g7UIk.apiUserSelfFavoritesPut)(summoner), (0, $2sln7.statusesToOption)(404), (0, $2cHG6.futureMaybe).map(()=>{
                mutate((0, $sjwE0.Maybe).some((0, $f5id0.pipe)((0, $3lg7I.UserView).Lens.favoriteSearches, (0, $gnzcc).modify((0, $f5id0.flow)((0, $sjwE0.List).append(summoner), (0, $sjwE0.List).sort((0, $aZGGZ.SummonerShort).byRiotIdOrd))))(oldData)), {
                    revalidate: false
                });
                return 0, $sjwE0.NotUsed;
            }))), (0, $sjwE0.Maybe).getOrElse(()=>(0, $sjwE0.Future).failed(Error('Inconsistent state'))), (0, $sjwE0.Future).orElse((e)=>{
            console.error(e);
            showToaster('error', t.errors.addFavoriteError);
            return (0, $2cHG6.futureMaybe).some((0, $sjwE0.NotUsed));
        })), [
        data,
        mutate,
        showToaster,
        t
    ]);
    const removeFavoriteSearch = (0, $bh6RR.useCallback)((puuid)=>(0, $f5id0.pipe)((0, $sjwE0.Maybe).fromNullable(data), (0, $sjwE0.Maybe).flatten, (0, $sjwE0.Maybe).filter((0, $f5id0.flow)((0, $3lg7I.UserView).Lens.favoriteSearches.get, (0, $sjwE0.List).elem($fd43dfcc218143a2$var$byPuuidEq)({
            puuid: puuid
        }))), (0, $sjwE0.Maybe).map((oldData)=>(0, $f5id0.pipe)((0, $g7UIk.apiUserSelfFavoritesDelete)(puuid), (0, $sjwE0.Future).map(()=>{
                mutate((0, $sjwE0.Maybe).some((0, $f5id0.pipe)((0, $3lg7I.UserView).Lens.favoriteSearches, (0, $gnzcc).modify((0, $sjwE0.List).differenceW($fd43dfcc218143a2$var$byPuuidEq)([
                    {
                        puuid: puuid
                    }
                ])))(oldData)), {
                    revalidate: false
                });
                return 0, $sjwE0.NotUsed;
            }))), (0, $sjwE0.Maybe).getOrElse(()=>(0, $sjwE0.Future).failed(Error('Inconsistent state'))), (0, $sjwE0.Future).orElse((e)=>{
            console.error(e);
            showToaster('error', t.errors.removeFavoriteError);
            return (0, $sjwE0.Future).notUsed;
        })), [
        data,
        mutate,
        showToaster,
        t
    ]);
    const [recentSearches_, setRecentSearches_] = (0, $854vE.useLocalStorageState)($fd43dfcc218143a2$var$recentSearchesKey, $fd43dfcc218143a2$var$recentSearchesCodec, []);
    const addRecentSearch = (0, $bh6RR.useCallback)((summoner)=>setRecentSearches_((0, $f5id0.flow)((0, $sjwE0.List).prepend((0, $jIcvJ.PartialSummonerShort).fromSummonerShort(summoner)), (0, $sjwE0.List).uniq($fd43dfcc218143a2$var$byPuuidEq), (0, $sjwE0.List).takeLeft((0, $bVugR.constants).recentSearchesMaxCount))), [
        setRecentSearches_
    ]);
    const removeRecentSearch = (0, $bh6RR.useCallback)((puuid)=>setRecentSearches_((0, $sjwE0.List).differenceW($fd43dfcc218143a2$var$byPuuidEq)([
            {
                puuid: puuid
            }
        ])), [
        setRecentSearches_
    ]);
    const refreshUser = (0, $bh6RR.useMemo)(()=>(0, $sjwE0.Future).tryCatch(()=>mutate(()=>Promise.resolve(undefined))), [
        mutate
    ]);
    const user = (0, $bh6RR.useMemo)(()=>(0, $65dIW.AsyncState).fromSWR({
            data: data,
            error: error
        }), [
        data,
        error
    ]);
    const maybeUser = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(user, (0, $65dIW.AsyncState).toOption, (0, $sjwE0.Maybe).flatten), [
        user
    ]);
    const recentSearches = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(recentSearches_, (0, $sjwE0.List).differenceW($fd43dfcc218143a2$var$byPuuidEq)((0, $f5id0.pipe)((0, $sjwE0.List).fromOption(maybeUser), (0, $sjwE0.List).chain((u)=>(0, $f5id0.pipe)(u.favoriteSearches, (0, $sjwE0.List).concat((0, $sjwE0.List).fromOption(u.linkedRiotAccount))))))), [
        maybeUser,
        recentSearches_
    ]);
    if (error !== undefined) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmQDF.Pre), {
            className: "mt-4",
            children: "error"
        })
    });
    const value = {
        refreshUser: refreshUser,
        user: user,
        maybeUser: maybeUser,
        addFavoriteSearch: addFavoriteSearch,
        removeFavoriteSearch: removeFavoriteSearch,
        recentSearches: recentSearches,
        addRecentSearch: addRecentSearch,
        removeRecentSearch: removeRecentSearch
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($fd43dfcc218143a2$var$UserContext.Provider, {
        value: value,
        children: children
    });
};
const $fd43dfcc218143a2$export$23bbbc4533528f03 = ()=>{
    const context = (0, $bh6RR.useContext)($fd43dfcc218143a2$var$UserContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useUser must be used within a UserContextProvider');
    return context;
};

});
parcelRegister("aZGGZ", function(module, exports) {

$parcel$export(module.exports, "SummonerShort", function () { return $c8b29e43bc78e7a3$export$50e6e519eacc19ff; });

var $12uqT = parcelRequire("12uqT");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $fp7Nf = parcelRequire("fp7Nf");

var $ixYJp = parcelRequire("ixYJp");

var $ebDzf = parcelRequire("ebDzf");

var $gl9GP = parcelRequire("gl9GP");
const $c8b29e43bc78e7a3$var$codecProperties = {
    platform: (0, $ebDzf.Platform).codec,
    puuid: (0, $gl9GP.Puuid).codec,
    riotId: (0, $fp7Nf.RiotId).fromStringCodec,
    name: (0, $sjwE0.Maybe).codec((0, $ixYJp.SummonerName).codec),
    profileIconId: $jPaL5.number
};
const $c8b29e43bc78e7a3$var$codec = $jPaL5.struct($c8b29e43bc78e7a3$var$codecProperties);
const $c8b29e43bc78e7a3$var$byRiotIdOrd = (0, $f5id0.pipe)((0, $68YxT).Ord, (0, $12uqT).contramap((s)=>(0, $dOJeV.StringUtils).cleanUTF8ToASCII((0, $fp7Nf.RiotId).stringify(s.riotId)).toLowerCase()));
const $c8b29e43bc78e7a3$export$50e6e519eacc19ff = {
    codecProperties: $c8b29e43bc78e7a3$var$codecProperties,
    codec: $c8b29e43bc78e7a3$var$codec,
    byRiotIdOrd: $c8b29e43bc78e7a3$var$byRiotIdOrd
};

});
parcelRegister("ixYJp", function(module, exports) {

$parcel$export(module.exports, "SummonerName", function () { return $c3b3311a8c2f5a54$export$d838340f48ae024a; });

var $kJAjV = parcelRequire("kJAjV");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $c3b3311a8c2f5a54$var$wrap, unwrap: $c3b3311a8c2f5a54$var$unwrap } = (0, $1k68G.iso)();
const $c3b3311a8c2f5a54$var$modify = (0, $f5id0.identity);
const $c3b3311a8c2f5a54$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $c3b3311a8c2f5a54$var$whiteSpaces = /\s+/g;
const $c3b3311a8c2f5a54$var$clean = $c3b3311a8c2f5a54$var$modify((name)=>name.toLowerCase().replaceAll($c3b3311a8c2f5a54$var$whiteSpaces, ''));
const $c3b3311a8c2f5a54$var$Eq = (0, $f5id0.pipe)((0, $68YxT).Eq, (0, $kJAjV).contramap($c3b3311a8c2f5a54$var$unwrap));
const $c3b3311a8c2f5a54$export$d838340f48ae024a = (0, $sjwE0.immutableAssign)($c3b3311a8c2f5a54$var$wrap, {
    unwrap: $c3b3311a8c2f5a54$var$unwrap,
    codec: $c3b3311a8c2f5a54$var$codec,
    clean: $c3b3311a8c2f5a54$var$clean,
    Eq: $c3b3311a8c2f5a54$var$Eq
});

});


parcelRegister("3lg7I", function(module, exports) {

$parcel$export(module.exports, "UserView", function () { return $de76d9590547efcd$export$93c94555daa109c4; });

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $sjwE0 = parcelRequire("sjwE0");

var $aZGGZ = parcelRequire("aZGGZ");

var $1uIVV = parcelRequire("1uIVV");
const $de76d9590547efcd$var$codec = $jPaL5.struct({
    userName: $jPaL5.string,
    favoriteSearches: (0, $sjwE0.List).codec((0, $aZGGZ.SummonerShort).codec),
    linkedRiotAccount: (0, $sjwE0.Maybe).codec((0, $aZGGZ.SummonerShort).codec),
    role: (0, $1uIVV.UserRole).codec
});
const $de76d9590547efcd$var$favoriteSearchesLens = (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('favoriteSearches'));
const $de76d9590547efcd$export$93c94555daa109c4 = {
    codec: $de76d9590547efcd$var$codec,
    Lens: {
        favoriteSearches: $de76d9590547efcd$var$favoriteSearchesLens
    }
};

});
parcelRegister("1uIVV", function(module, exports) {

$parcel$export(module.exports, "UserRole", function () { return $e916da0b81189c36$export$eb3485a690c2f0b8; });

var $j839F = parcelRequire("j839F");
const $e916da0b81189c36$export$eb3485a690c2f0b8 = (0, $j839F.createEnum)('base', 'admin');

});


parcelRegister("2cHG6", function(module, exports) {

$parcel$export(module.exports, "futureMaybe", function () { return $a89b36bc0e679d63$export$7e537f1fc6d62628; });

var $6IQDS = parcelRequire("6IQDS");
var $lcDVT = parcelRequire("lcDVT");
var $hrfTw = parcelRequire("hrfTw");
var $exz6z = parcelRequire("exz6z");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
const $a89b36bc0e679d63$var$URI = 'TaskEitherOption';
const $a89b36bc0e679d63$var$some = (0, $exz6z).some((0, $sjwE0.Future).Pointed);
const $a89b36bc0e679d63$var$apPar_ = (fab, fa)=>(0, $f5id0.pipe)(fab, $a89b36bc0e679d63$var$ap(fa));
const $a89b36bc0e679d63$var$chain_ = (ma, f)=>(0, $f5id0.pipe)(ma, $a89b36bc0e679d63$var$chain(f));
const $a89b36bc0e679d63$var$map_ = (fa, f)=>(0, $f5id0.pipe)(fa, $a89b36bc0e679d63$var$map(f));
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const $a89b36bc0e679d63$var$Do = $a89b36bc0e679d63$var$some({});
const $a89b36bc0e679d63$var$ApplicativePar = {
    URI: $a89b36bc0e679d63$var$URI,
    map: $a89b36bc0e679d63$var$map_,
    ap: $a89b36bc0e679d63$var$apPar_,
    of: $a89b36bc0e679d63$var$some
};
const $a89b36bc0e679d63$var$ApplyPar = {
    URI: $a89b36bc0e679d63$var$URI,
    map: $a89b36bc0e679d63$var$map_,
    ap: $a89b36bc0e679d63$var$apPar_
};
const $a89b36bc0e679d63$var$Chain = {
    URI: $a89b36bc0e679d63$var$URI,
    map: $a89b36bc0e679d63$var$map_,
    ap: $a89b36bc0e679d63$var$apPar_,
    chain: $a89b36bc0e679d63$var$chain_
};
const $a89b36bc0e679d63$var$Functor = {
    URI: $a89b36bc0e679d63$var$URI,
    map: $a89b36bc0e679d63$var$map_
};
const $a89b36bc0e679d63$var$ap = (0, $exz6z).ap((0, $sjwE0.Future).ApplyPar);
const $a89b36bc0e679d63$var$chain = (0, $exz6z).chain((0, $sjwE0.Future).Monad);
const $a89b36bc0e679d63$var$chainEitherK = (f)=>$a89b36bc0e679d63$var$chainTaskEitherK((0, $f5id0.flow)(f, (0, $sjwE0.Future).fromEither));
const $a89b36bc0e679d63$var$chainNullableK = (0, $exz6z).chainNullableK((0, $sjwE0.Future).Monad);
const $a89b36bc0e679d63$var$chainOptionK = (0, $exz6z).chainOptionK((0, $sjwE0.Future).Monad);
const $a89b36bc0e679d63$var$chainTaskEitherK = (f)=>$a89b36bc0e679d63$var$chain((0, $f5id0.flow)(f, (0, $sjwE0.Future).map((0, $sjwE0.Maybe).some)));
const $a89b36bc0e679d63$var$chainIOK = (f)=>$a89b36bc0e679d63$var$chainTaskEitherK((0, $f5id0.flow)(f, (0, $sjwE0.Future).fromIO));
const $a89b36bc0e679d63$var$chainFirst = (0, $lcDVT).chainFirst($a89b36bc0e679d63$var$Chain);
const $a89b36bc0e679d63$var$chainFirstTaskEitherK = (f)=>$a89b36bc0e679d63$var$chainFirst((0, $f5id0.flow)(f, (0, $sjwE0.Future).map((0, $sjwE0.Maybe).some)));
const $a89b36bc0e679d63$var$chainFirstIOEitherK = (f)=>$a89b36bc0e679d63$var$chainFirstTaskEitherK((0, $f5id0.flow)(f, (0, $sjwE0.Future).fromIOEither));
const $a89b36bc0e679d63$var$filter = (0, $f5id0.flow)((0, $sjwE0.Maybe).filter, (0, $sjwE0.Future).map);
const $a89b36bc0e679d63$var$fromTaskEither = (0, $exz6z).fromF((0, $sjwE0.Future).Functor);
const $a89b36bc0e679d63$var$fromIO = (0, $f5id0.flow)((0, $sjwE0.Future).fromIO, $a89b36bc0e679d63$var$fromTaskEither);
const $a89b36bc0e679d63$var$fromNullable = (0, $exz6z).fromNullable((0, $sjwE0.Future).Pointed);
const $a89b36bc0e679d63$var$fromOption = (0, $exz6z).fromOptionK((0, $sjwE0.Future).Pointed)((0, $f5id0.identity));
const $a89b36bc0e679d63$var$fromIOEither = (0, $f5id0.flow)((0, $sjwE0.Future).fromIOEither, (0, $sjwE0.Future).map((0, $sjwE0.Maybe).some));
const $a89b36bc0e679d63$var$getOrElse = (0, $exz6z).getOrElse((0, $sjwE0.Future).Monad);
const $a89b36bc0e679d63$var$map = (0, $exz6z).map((0, $sjwE0.Future).Functor);
const $a89b36bc0e679d63$var$none = (0, $exz6z).zero((0, $sjwE0.Future).Pointed)();
const $a89b36bc0e679d63$export$7e537f1fc6d62628 = {
    Do: $a89b36bc0e679d63$var$Do,
    ApplicativePar: $a89b36bc0e679d63$var$ApplicativePar,
    ApplyPar: $a89b36bc0e679d63$var$ApplyPar,
    Functor: $a89b36bc0e679d63$var$Functor,
    alt: (0, $exz6z).alt((0, $sjwE0.Future).Monad),
    apS: (0, $6IQDS).apS($a89b36bc0e679d63$var$ApplyPar),
    bind: (0, $lcDVT).bind($a89b36bc0e679d63$var$Chain),
    bindTo: (0, $hrfTw).bindTo($a89b36bc0e679d63$var$Functor),
    let: (0, $hrfTw).let($a89b36bc0e679d63$var$Functor),
    chain: $a89b36bc0e679d63$var$chain,
    chainEitherK: $a89b36bc0e679d63$var$chainEitherK,
    chainNullableK: $a89b36bc0e679d63$var$chainNullableK,
    chainOptionK: $a89b36bc0e679d63$var$chainOptionK,
    chainTaskEitherK: $a89b36bc0e679d63$var$chainTaskEitherK,
    chainIOK: $a89b36bc0e679d63$var$chainIOK,
    chainFirst: $a89b36bc0e679d63$var$chainFirst,
    chainFirstTaskEitherK: $a89b36bc0e679d63$var$chainFirstTaskEitherK,
    chainFirstIOEitherK: $a89b36bc0e679d63$var$chainFirstIOEitherK,
    filter: $a89b36bc0e679d63$var$filter,
    fromTaskEither: $a89b36bc0e679d63$var$fromTaskEither,
    fromIO: $a89b36bc0e679d63$var$fromIO,
    fromNullable: $a89b36bc0e679d63$var$fromNullable,
    fromOption: $a89b36bc0e679d63$var$fromOption,
    fromIOEither: $a89b36bc0e679d63$var$fromIOEither,
    getOrElse: $a89b36bc0e679d63$var$getOrElse,
    map: $a89b36bc0e679d63$var$map,
    match: (0, $exz6z).match((0, $sjwE0.Future).Functor),
    matchE: (0, $exz6z).matchE((0, $sjwE0.Future).Chain),
    none: $a89b36bc0e679d63$var$none,
    some: $a89b36bc0e679d63$var$some
};

});
parcelRegister("exz6z", function(module, exports) {

$parcel$export(module.exports, "some", function () { return $a95f60e59f187da7$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "zero", function () { return $a95f60e59f187da7$export$7f9972325ebfd559; });
$parcel$export(module.exports, "fromF", function () { return $a95f60e59f187da7$export$f892bc4f66df4228; });
$parcel$export(module.exports, "fromNullable", function () { return $a95f60e59f187da7$export$b601f49376b4621a; });
$parcel$export(module.exports, "fromNullableK", function () { return $a95f60e59f187da7$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $a95f60e59f187da7$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "chain", function () { return $a95f60e59f187da7$export$e08e3b67e392101e; });
$parcel$export(module.exports, "fromOptionK", function () { return $a95f60e59f187da7$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $a95f60e59f187da7$export$12d26179deb6a68a; });
$parcel$export(module.exports, "fromPredicate", function () { return $a95f60e59f187da7$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromEither", function () { return $a95f60e59f187da7$export$80c878c9b1d77917; });
$parcel$export(module.exports, "match", function () { return $a95f60e59f187da7$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchE", function () { return $a95f60e59f187da7$export$398621f19e0a7e4; });
$parcel$export(module.exports, "getOrElse", function () { return $a95f60e59f187da7$export$8832081647a02ee7; });
$parcel$export(module.exports, "map", function () { return $a95f60e59f187da7$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $a95f60e59f187da7$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $a95f60e59f187da7$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "alt", function () { return $a95f60e59f187da7$export$228be17d80722ab; });
$parcel$export(module.exports, "getOptionM", function () { return $a95f60e59f187da7$export$76c6439d480fbaad; });

var $6IQDS = parcelRequire("6IQDS");

var $f5id0 = parcelRequire("f5id0");

var $hrfTw = parcelRequire("hrfTw");

var $hVAkz = parcelRequire("hVAkz");
function $a95f60e59f187da7$export$ad14ef4001db2bcd(F) {
    return (0, $f5id0.flow)($hVAkz.some, F.of);
}
function $a95f60e59f187da7$export$7f9972325ebfd559(F) {
    return (0, $f5id0.constant)(F.of($hVAkz.none));
}
function $a95f60e59f187da7$export$f892bc4f66df4228(F) {
    return function(ma) {
        return F.map(ma, $hVAkz.some);
    };
}
function $a95f60e59f187da7$export$b601f49376b4621a(F) {
    return (0, $f5id0.flow)($hVAkz.fromNullable, F.of);
}
function $a95f60e59f187da7$export$c69ca7b73fad45e1(F) {
    var fromNullableF = $a95f60e59f187da7$export$b601f49376b4621a(F);
    return function(f) {
        return (0, $f5id0.flow)(f, fromNullableF);
    };
}
function $a95f60e59f187da7$export$c81f992c08fd0bf3(M) {
    var chainM = $a95f60e59f187da7$export$e08e3b67e392101e(M);
    var fromNullableKM = $a95f60e59f187da7$export$c69ca7b73fad45e1(M);
    return function(f) {
        return chainM(fromNullableKM(f));
    };
}
function $a95f60e59f187da7$export$a907462f448b49f8(F) {
    return function(f) {
        return (0, $f5id0.flow)(f, F.of);
    };
}
function $a95f60e59f187da7$export$12d26179deb6a68a(M) {
    var chainM = $a95f60e59f187da7$export$e08e3b67e392101e(M);
    var fromOptionKM = $a95f60e59f187da7$export$a907462f448b49f8(M);
    return function(f) {
        return chainM(fromOptionKM(f));
    };
}
function $a95f60e59f187da7$export$23f31c55d7162b91(F) {
    return function(predicate) {
        return function(a) {
            return F.of($hVAkz.fromPredicate(predicate)(a));
        };
    };
}
function $a95f60e59f187da7$export$80c878c9b1d77917(F) {
    return (0, $f5id0.flow)($hVAkz.fromEither, F.of);
}
function $a95f60e59f187da7$export$4659b591c19bdf3d(F) {
    return function(onNone, onSome) {
        return function(ma) {
            return F.map(ma, $hVAkz.match(onNone, onSome));
        };
    };
}
function $a95f60e59f187da7$export$398621f19e0a7e4(M) {
    return function(onNone, onSome) {
        return function(ma) {
            return M.chain(ma, $hVAkz.match(onNone, onSome));
        };
    };
}
function $a95f60e59f187da7$export$8832081647a02ee7(M) {
    return function(onNone) {
        return function(fa) {
            return M.chain(fa, $hVAkz.match(onNone, M.of));
        };
    };
}
function $a95f60e59f187da7$export$871de8747c9eaa88(F) {
    return (0, $hrfTw.map)(F, $hVAkz.Functor);
}
function $a95f60e59f187da7$export$2f6ca3d3b1f80bf5(F) {
    return (0, $6IQDS.ap)(F, $hVAkz.Apply);
}
function $a95f60e59f187da7$export$e08e3b67e392101e(M) {
    var flatMapM = $a95f60e59f187da7$export$5b8affa63fc6df16(M);
    return function(f) {
        return function(ma) {
            return flatMapM(ma, f);
        };
    };
}
function $a95f60e59f187da7$export$5b8affa63fc6df16(M) {
    var zeroM = $a95f60e59f187da7$export$7f9972325ebfd559(M);
    return function(ma, f) {
        return M.chain(ma, $hVAkz.match(function() {
            return zeroM();
        }, f));
    };
}
function $a95f60e59f187da7$export$228be17d80722ab(M) {
    var _some = $a95f60e59f187da7$export$ad14ef4001db2bcd(M);
    return function(second) {
        return function(first) {
            return M.chain(first, $hVAkz.match(second, _some));
        };
    };
}
function $a95f60e59f187da7$export$76c6439d480fbaad(M) {
    var apM = $a95f60e59f187da7$export$2f6ca3d3b1f80bf5(M);
    var mapM = $a95f60e59f187da7$export$871de8747c9eaa88(M);
    var chainM = $a95f60e59f187da7$export$e08e3b67e392101e(M);
    var altM = $a95f60e59f187da7$export$228be17d80722ab(M);
    var foldM = $a95f60e59f187da7$export$398621f19e0a7e4(M);
    var getOrElseM = $a95f60e59f187da7$export$8832081647a02ee7(M);
    var zeroM = $a95f60e59f187da7$export$7f9972325ebfd559(M);
    return {
        map: function(fa, f) {
            return (0, $f5id0.pipe)(fa, mapM(f));
        },
        ap: function(fab, fa) {
            return (0, $f5id0.pipe)(fab, apM(fa));
        },
        of: $a95f60e59f187da7$export$ad14ef4001db2bcd(M),
        chain: function(ma, f) {
            return (0, $f5id0.pipe)(ma, chainM(f));
        },
        alt: function(fa, that) {
            return (0, $f5id0.pipe)(fa, altM(that));
        },
        fold: function(fa, onNone, onSome) {
            return (0, $f5id0.pipe)(fa, foldM(onNone, onSome));
        },
        getOrElse: function(fa, onNone) {
            return (0, $f5id0.pipe)(fa, getOrElseM(onNone));
        },
        fromM: $a95f60e59f187da7$export$f892bc4f66df4228(M),
        none: function() {
            return zeroM();
        }
    };
}

});


parcelRegister("g7UIk", function(module, exports) {

$parcel$export(module.exports, "apiSummonerGet", function () { return $a9dfea6663b8fc6f$export$d61a9862bcd571ae; });
$parcel$export(module.exports, "apiUserRegisterPost", function () { return $a9dfea6663b8fc6f$export$d64d5d74aa8cf9b6; });
$parcel$export(module.exports, "apiUserLoginPasswordPost", function () { return $a9dfea6663b8fc6f$export$45f5d04ed4119063; });
$parcel$export(module.exports, "apiUserLogoutPost", function () { return $a9dfea6663b8fc6f$export$329d70dc4dbea004; });
$parcel$export(module.exports, "apiUserSelfFavoritesPut", function () { return $a9dfea6663b8fc6f$export$a1a189d26ecb01d5; });
$parcel$export(module.exports, "apiUserSelfFavoritesDelete", function () { return $a9dfea6663b8fc6f$export$d4f91cea631a4f48; });
$parcel$export(module.exports, "apiUserSelfSummonerChampionsShardsCountPost", function () { return $a9dfea6663b8fc6f$export$67029896d27d4e4f; });
$parcel$export(module.exports, "apiAdminMadosayentisutoPost", function () { return $a9dfea6663b8fc6f$export$f0646fc238d5c797; });

var $f5id0 = parcelRequire("f5id0");

var $k8rBo = parcelRequire("k8rBo");

var $g0N66 = parcelRequire("g0N66");

var $2OEEz = parcelRequire("2OEEz");

var $1jyWr = parcelRequire("1jyWr");

var $gl9GP = parcelRequire("gl9GP");

var $aZGGZ = parcelRequire("aZGGZ");

var $fl6s9 = parcelRequire("fl6s9");

var $2sln7 = parcelRequire("2sln7");
function $a9dfea6663b8fc6f$export$d61a9862bcd571ae(platform, riotId) {
    return (0, $f5id0.pipe)((0, $2sln7.http)((0, $k8rBo.apiRoutes).summoner.byRiotId(platform)(riotId).get, {}, [
        (0, $aZGGZ.SummonerShort).codec,
        'SummonerShort'
    ]), (0, $2sln7.statusesToOption)(404));
}
function $a9dfea6663b8fc6f$export$d64d5d74aa8cf9b6(payload) {
    return (0, $2sln7.http)((0, $k8rBo.apiRoutes).user.register.password.post, {
        json: [
            (0, $fl6s9.LoginPasswordPayload).codec,
            payload
        ]
    });
}
function $a9dfea6663b8fc6f$export$45f5d04ed4119063(payload) {
    return (0, $2sln7.http)((0, $k8rBo.apiRoutes).user.login.password.post, {
        json: [
            (0, $fl6s9.LoginPasswordPayload).codec,
            payload
        ]
    });
}
const $a9dfea6663b8fc6f$export$329d70dc4dbea004 = (0, $2sln7.http)((0, $k8rBo.apiRoutes).user.logout.post);
function $a9dfea6663b8fc6f$export$a1a189d26ecb01d5(platformWithPuuid) {
    return (0, $2sln7.http)((0, $k8rBo.apiRoutes).user.self.favorites.put, {
        json: [
            (0, $1jyWr.PlatformWithPuuid).codec,
            platformWithPuuid
        ]
    });
}
function $a9dfea6663b8fc6f$export$d4f91cea631a4f48(puuid) {
    return (0, $2sln7.http)((0, $k8rBo.apiRoutes).user.self.favorites.delete, {
        json: [
            (0, $gl9GP.Puuid).codec,
            puuid
        ]
    });
}
function $a9dfea6663b8fc6f$export$67029896d27d4e4f(platform, puuid, championsShards) {
    return (0, $2sln7.http)((0, $k8rBo.apiRoutes).user.self.summoner(platform)(puuid).championsShardsCount.post, {
        json: [
            (0, $2OEEz.ChampionShardsPayload).codec,
            championsShards
        ]
    });
}
function $a9dfea6663b8fc6f$export$f0646fc238d5c797(payload) {
    return (0, $2sln7.http)((0, $k8rBo.apiRoutes).admin.hallOfFame.post, {
        json: [
            (0, $g0N66.HallOfFameMembersPayload).codec,
            payload
        ]
    });
}

});
parcelRegister("g0N66", function(module, exports) {

$parcel$export(module.exports, "HallOfFameMembersPayload", function () { return $7e40b4b0e1e35470$export$e36427e6de497278; });

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $4nKV6 = parcelRequire("4nKV6");

var $1jyWr = parcelRequire("1jyWr");
const $7e40b4b0e1e35470$var$codec = (0, $hHBpg.MapFromArray).codec((0, $sjwE0.idcOrd)((0, $4nKV6.DiscordUserId).Eq))((0, $4nKV6.DiscordUserId).codec, (0, $1jyWr.PlatformWithPuuid).codec);
const $7e40b4b0e1e35470$export$e36427e6de497278 = {
    codec: $7e40b4b0e1e35470$var$codec
};

});
parcelRegister("1jyWr", function(module, exports) {

$parcel$export(module.exports, "PlatformWithPuuid", function () { return $126b7e78c7a84556$export$dfc3df3713e6992c; });

var $jPaL5 = parcelRequire("jPaL5");

var $ebDzf = parcelRequire("ebDzf");

var $gl9GP = parcelRequire("gl9GP");
const $126b7e78c7a84556$var$codec = $jPaL5.struct({
    platform: (0, $ebDzf.Platform).codec,
    puuid: (0, $gl9GP.Puuid).codec
});
const $126b7e78c7a84556$export$dfc3df3713e6992c = {
    codec: $126b7e78c7a84556$var$codec
};

});


parcelRegister("2OEEz", function(module, exports) {

$parcel$export(module.exports, "ChampionShardsPayload", function () { return $e54e7d528302559f$export$7156dffe74864932; });

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $lbqn0 = parcelRequire("lbqn0");

var $br0yu = parcelRequire("br0yu");
const $e54e7d528302559f$var$shardCodec = $jPaL5.struct({
    championId: (0, $br0yu.ChampionKey).codec,
    shardsCount: (0, $lbqn0.ShardsCount).codec
});
const $e54e7d528302559f$export$24480d1f591a811a = {
    codec: $e54e7d528302559f$var$shardCodec
};
const $e54e7d528302559f$var$codec = (0, $sjwE0.NonEmptyArray).codec($e54e7d528302559f$export$24480d1f591a811a.codec);
const $e54e7d528302559f$export$7156dffe74864932 = {
    codec: $e54e7d528302559f$var$codec
};

});
parcelRegister("lbqn0", function(module, exports) {

$parcel$export(module.exports, "ShardsCount", function () { return $a0b967e251048ec2$export$2fa5e477db1261c8; });

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");
const $a0b967e251048ec2$var$decoder = (0, $f5id0.pipe)($4BSZX.number, $4BSZX.refine((n)=>Number.isInteger(n), 'Integer'), $4BSZX.refine((n)=>0 <= n && n <= 9, 'Between0And9'));
const $a0b967e251048ec2$var$encoder = $d9q5l.id();
const $a0b967e251048ec2$var$codec = $jPaL5.make($a0b967e251048ec2$var$decoder, $a0b967e251048ec2$var$encoder);
const $a0b967e251048ec2$export$2fa5e477db1261c8 = {
    codec: $a0b967e251048ec2$var$codec
};

});


parcelRegister("fl6s9", function(module, exports) {

$parcel$export(module.exports, "LoginPasswordPayload", function () { return $8c1892d89a8ab61e$export$8be910c59786c76d; });

var $jPaL5 = parcelRequire("jPaL5");

var $22neR = parcelRequire("22neR");

var $8nfdq = parcelRequire("8nfdq");
const $8c1892d89a8ab61e$var$codec = $jPaL5.struct({
    userName: (0, $8nfdq.UserName).codec,
    password: (0, $22neR.ClearPassword).codec
});
const $8c1892d89a8ab61e$export$8be910c59786c76d = {
    codec: $8c1892d89a8ab61e$var$codec
};

});
parcelRegister("22neR", function(module, exports) {

$parcel$export(module.exports, "ClearPassword", function () { return $33ac216274e9b738$export$c945fb7fdfdff4ef; });

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $33ac216274e9b738$var$wrap, unwrap: $33ac216274e9b738$var$unwrap } = (0, $1k68G.iso)();
const $33ac216274e9b738$var$codec = (0, $hHBpg.fromNewtype)((0, $hHBpg.NonEmptyString).codec);
const $33ac216274e9b738$export$c945fb7fdfdff4ef = (0, $sjwE0.immutableAssign)($33ac216274e9b738$var$wrap, {
    unwrap: $33ac216274e9b738$var$unwrap,
    codec: $33ac216274e9b738$var$codec
});

});

parcelRegister("8nfdq", function(module, exports) {

$parcel$export(module.exports, "UserName", function () { return $5eefa4eac0a9e860$export$7bf5e3f2a1fc0a63; });

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $5eefa4eac0a9e860$var$wrap, unwrap: $5eefa4eac0a9e860$var$unwrap } = (0, $1k68G.iso)();
const $5eefa4eac0a9e860$var$codec = (0, $hHBpg.fromNewtype)((0, $hHBpg.NonEmptyString).codec);
const $5eefa4eac0a9e860$export$7bf5e3f2a1fc0a63 = (0, $sjwE0.immutableAssign)($5eefa4eac0a9e860$var$wrap, {
    unwrap: $5eefa4eac0a9e860$var$unwrap,
    codec: $5eefa4eac0a9e860$var$codec
});

});



parcelRegister("bVugR", function(module, exports) {

$parcel$export(module.exports, "constants", function () { return $f5216fa8abd1d302$export$1a988e7317c65621; });
const $f5216fa8abd1d302$export$1a988e7317c65621 = {
    recentSearchesMaxCount: 10
};

});

parcelRegister("65dIW", function(module, exports) {

$parcel$export(module.exports, "AsyncState", function () { return $a0d5fb9173f5b9ea$export$e59cffac92a1baf3; });

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
const $a0d5fb9173f5b9ea$var$loading = {
    type: 'Loading'
};
const $a0d5fb9173f5b9ea$var$failure = (error)=>({
        type: 'Failure',
        error: error
    });
const $a0d5fb9173f5b9ea$var$success = (loadedValue)=>({
        type: 'Success',
        loadedValue: loadedValue
    });
const $a0d5fb9173f5b9ea$var$fromSWR = ({ data: data, error: error })=>{
    if (error !== undefined) return $a0d5fb9173f5b9ea$var$failure(error);
    if (data === undefined) return $a0d5fb9173f5b9ea$var$loading;
    return $a0d5fb9173f5b9ea$var$success(data);
};
const $a0d5fb9173f5b9ea$var$fold = (onLoading, onFailure, onSuccess)=>(as)=>{
        switch(as.type){
            case 'Loading':
                return onLoading();
            case 'Failure':
                return onFailure(as.error);
            case 'Success':
                return onSuccess(as.loadedValue);
        }
    };
const $a0d5fb9173f5b9ea$var$toOption = $a0d5fb9173f5b9ea$var$fold(()=>(0, $sjwE0.Maybe).none, ()=>(0, $sjwE0.Maybe).none, (0, $sjwE0.Maybe).some);
const $a0d5fb9173f5b9ea$var$toSWR = (as)=>(0, $f5id0.pipe)(as, $a0d5fb9173f5b9ea$var$fold(()=>({
            data: undefined,
            error: undefined
        }), (error)=>({
            data: undefined,
            error: error
        }), (data)=>({
            data: data,
            error: undefined
        })));
const $a0d5fb9173f5b9ea$export$e59cffac92a1baf3 = {
    fromSWR: $a0d5fb9173f5b9ea$var$fromSWR,
    fold: $a0d5fb9173f5b9ea$var$fold,
    toOption: $a0d5fb9173f5b9ea$var$toOption,
    toSWR: $a0d5fb9173f5b9ea$var$toSWR
};

});

parcelRegister("jIcvJ", function(module, exports) {

$parcel$export(module.exports, "PartialSummonerShort", function () { return $6ea4d1fc87bf4e6e$export$53a0f8657ff653de; });

var $jPaL5 = parcelRequire("jPaL5");

var $aZGGZ = parcelRequire("aZGGZ");

var $fp7Nf = parcelRequire("fp7Nf");

var $sjwE0 = parcelRequire("sjwE0");
const $6ea4d1fc87bf4e6e$var$codec = $jPaL5.struct({
    ...(0, $aZGGZ.SummonerShort).codecProperties,
    riotId: (0, $sjwE0.Maybe).codec((0, $fp7Nf.RiotId).fromStringCodec)
});
function $6ea4d1fc87bf4e6e$var$fromSummonerShort(summoner) {
    return {
        ...summoner,
        riotId: (0, $sjwE0.Maybe).some(summoner.riotId)
    };
}
const $6ea4d1fc87bf4e6e$export$53a0f8657ff653de = {
    codec: $6ea4d1fc87bf4e6e$var$codec,
    fromSummonerShort: $6ea4d1fc87bf4e6e$var$fromSummonerShort
};

});


parcelRegister("36sK8", function(module, exports) {

$parcel$export(module.exports, "Navigate", function () { return $64f3b76e5d19e577$export$444b3ab0cb9aec40; });
/* eslint-disable functional/no-expression-statements */ 
var $bh6RR = parcelRequire("bh6RR");

var $9xM77 = parcelRequire("9xM77");
const $64f3b76e5d19e577$export$444b3ab0cb9aec40 = ({ to: to, ...options })=>{
    const { navigate: navigate } = (0, $9xM77.useHistory)();
    (0, $bh6RR.useEffect)(()=>{
        navigate(to, options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

});
parcelRegister("9xM77", function(module, exports) {

$parcel$export(module.exports, "HistoryContextProvider", function () { return $858d41f63c21601d$export$a7f2b2c281690bcd; });
$parcel$export(module.exports, "HistoryState", function () { return $858d41f63c21601d$export$95c891a1f5736881; });
$parcel$export(module.exports, "useHistory", function () { return $858d41f63c21601d$export$3420e1dc2c4a518c; });
/* eslint-disable functional/no-expression-statements, 
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $87jRz = parcelRequire("87jRz");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $kGWxD = parcelRequire("kGWxD");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $2EH2o = parcelRequire("2EH2o");

var $8PgX5 = parcelRequire("8PgX5");

var $kiCtw = parcelRequire("kiCtw");

var $8Zv6u = parcelRequire("8Zv6u");
const $858d41f63c21601d$var$HistoryContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
const $858d41f63c21601d$export$a7f2b2c281690bcd = ({ children: children })=>{
    const historyStateRef = (0, $bh6RR.useRef)($858d41f63c21601d$export$95c891a1f5736881.empty);
    const modifyHistoryStateRef = (0, $bh6RR.useCallback)((f)=>{
        // eslint-disable-next-line functional/immutable-data
        historyStateRef.current = f(historyStateRef.current);
    }, []);
    const h = (0, $bh6RR.useMemo)(()=>$87jRz.createBrowserHistory(), []);
    const [location, setLocation] = (0, $bh6RR.useState)(h.location);
    (0, $bh6RR.useEffect)(()=>h.listen((l)=>setLocation(l.location)), [
        h
    ]);
    const navigate = (0, $bh6RR.useCallback)((pathname, { replace: replace = false } = {})=>{
        const to = {
            pathname: pathname,
            search: '',
            hash: ''
        };
        if (replace) return h.replace(to);
        return h.push(to);
    }, [
        h
    ]);
    const query = (0, $bh6RR.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kGWxD))).parse(location.search.slice(1)), [
        location.search
    ]);
    const masteriesQuery = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)((0, $8Zv6u.PartialMasteriesQuery).decoder.decode(query), (0, $sjwE0.Either).getOrElse(()=>({})), (0, $kiCtw.MasteriesQuery).fromPartial), [
        query
    ]);
    const updateMasteriesQuery = (0, $bh6RR.useCallback)((f)=>{
        const newQuery = f(masteriesQuery);
        const to = {
            search: (0, $f5id0.pipe)(newQuery, (0, $kiCtw.MasteriesQuery).toPartial, (0, $8Zv6u.PartialMasteriesQuery).qsStringify)
        };
        if (masteriesQuery.view !== newQuery.view) return h.push(to);
        return h.replace(to);
    }, [
        h,
        masteriesQuery
    ]);
    const genericQuery = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)((0, $8PgX5.PartialGenericQuery).decoder.decode(query), (0, $sjwE0.Either).getOrElse(()=>({})), (0, $2EH2o.GenericQuery).fromPartial), [
        query
    ]);
    const updateGenericQuery = (0, $bh6RR.useCallback)((f)=>h.replace({
            search: (0, $f5id0.pipe)(f(genericQuery), (0, $2EH2o.GenericQuery).toPartial, (0, $8PgX5.PartialGenericQuery).qsStringify)
        }), [
        genericQuery,
        h
    ]);
    const value = {
        historyStateRef: historyStateRef,
        modifyHistoryStateRef: modifyHistoryStateRef,
        location: location,
        navigate: navigate,
        query: query,
        masteriesQuery: masteriesQuery,
        updateMasteriesQuery: updateMasteriesQuery,
        genericQuery: genericQuery,
        updateGenericQuery: updateGenericQuery
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($858d41f63c21601d$var$HistoryContext.Provider, {
        value: value,
        children: children
    });
};
const $858d41f63c21601d$export$3420e1dc2c4a518c = ()=>{
    const context = (0, $bh6RR.useContext)($858d41f63c21601d$var$HistoryContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useHistory must be used within a HistoryContextProvider');
    return context;
};
const $858d41f63c21601d$var$empty = {
    masteries: (0, $sjwE0.Maybe).none,
    game: (0, $sjwE0.Maybe).none
};
const $858d41f63c21601d$export$95c891a1f5736881 = {
    empty: $858d41f63c21601d$var$empty,
    Lens: {
        masteries: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('masteries')),
        game: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('game'))
    }
};

});
parcelRegister("87jRz", function(module, exports) {

$parcel$export(module.exports, "createBrowserHistory", function () { return $5e8e62901b9f4415$export$719fc203c4e16dee; });

var $4WYaH = parcelRequire("4WYaH");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $5e8e62901b9f4415$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($5e8e62901b9f4415$export$e19cd5f9376f8cee || ($5e8e62901b9f4415$export$e19cd5f9376f8cee = {}));
var $5e8e62901b9f4415$var$readOnly = function(obj) {
    return obj;
};
function $5e8e62901b9f4415$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $5e8e62901b9f4415$var$BeforeUnloadEventType = 'beforeunload';
var $5e8e62901b9f4415$var$HashChangeEventType = 'hashchange';
var $5e8e62901b9f4415$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $5e8e62901b9f4415$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $5e8e62901b9f4415$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($5e8e62901b9f4415$var$PopStateEventType, handlePop);
    var action = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $5e8e62901b9f4415$var$createEvents();
    var blockers = $5e8e62901b9f4415$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $4WYaH.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $5e8e62901b9f4415$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $5e8e62901b9f4415$var$readOnly((0, $4WYaH.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $5e8e62901b9f4415$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $5e8e62901b9f4415$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($5e8e62901b9f4415$var$BeforeUnloadEventType, $5e8e62901b9f4415$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($5e8e62901b9f4415$var$BeforeUnloadEventType, $5e8e62901b9f4415$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $5e8e62901b9f4415$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $5e8e62901b9f4415$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $5e8e62901b9f4415$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($5e8e62901b9f4415$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($5e8e62901b9f4415$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($5e8e62901b9f4415$export$fe53371bee54353d(nextLocation) !== $5e8e62901b9f4415$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $5e8e62901b9f4415$var$createEvents();
    var blockers = $5e8e62901b9f4415$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $4WYaH.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $5e8e62901b9f4415$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $5e8e62901b9f4415$var$readOnly((0, $4WYaH.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $5e8e62901b9f4415$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $5e8e62901b9f4415$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($5e8e62901b9f4415$var$BeforeUnloadEventType, $5e8e62901b9f4415$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($5e8e62901b9f4415$var$BeforeUnloadEventType, $5e8e62901b9f4415$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $5e8e62901b9f4415$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $5e8e62901b9f4415$var$readOnly((0, $4WYaH.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $5e8e62901b9f4415$var$createKey()
        }, typeof entry === 'string' ? $5e8e62901b9f4415$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $5e8e62901b9f4415$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $5e8e62901b9f4415$var$createEvents();
    var blockers = $5e8e62901b9f4415$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $5e8e62901b9f4415$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $5e8e62901b9f4415$var$readOnly((0, $4WYaH.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $5e8e62901b9f4415$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $5e8e62901b9f4415$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $5e8e62901b9f4415$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $5e8e62901b9f4415$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $5e8e62901b9f4415$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $5e8e62901b9f4415$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $5e8e62901b9f4415$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $5e8e62901b9f4415$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $5e8e62901b9f4415$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $5e8e62901b9f4415$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}

});
parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}

});


parcelRegister("kGWxD", function(module, exports) {
'use strict';

var $jGHEN = parcelRequire("jGHEN");

var $h1p15 = parcelRequire("h1p15");

var $iSgbH = parcelRequire("iSgbH");
module.exports = {
    formats: $iSgbH,
    parse: $h1p15,
    stringify: $jGHEN
};

});
parcelRegister("jGHEN", function(module, exports) {
'use strict';

var $aLN2C = parcelRequire("aLN2C");

var $5vn5Z = parcelRequire("5vn5Z");

var $iSgbH = parcelRequire("iSgbH");
var $e553cde939346e03$var$has = Object.prototype.hasOwnProperty;
var $e553cde939346e03$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e553cde939346e03$var$isArray = Array.isArray;
var $e553cde939346e03$var$push = Array.prototype.push;
var $e553cde939346e03$var$pushToArray = function(arr, valueOrArray) {
    $e553cde939346e03$var$push.apply(arr, $e553cde939346e03$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e553cde939346e03$var$toISO = Date.prototype.toISOString;
var $e553cde939346e03$var$defaultFormat = $iSgbH.default;
var $e553cde939346e03$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $5vn5Z.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $e553cde939346e03$var$defaultFormat,
    formatter: $iSgbH.formatters[$e553cde939346e03$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e553cde939346e03$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e553cde939346e03$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $e553cde939346e03$var$sentinel = {};
var $e553cde939346e03$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e553cde939346e03$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e553cde939346e03$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $e553cde939346e03$var$isArray(obj)) obj = $5vn5Z.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e553cde939346e03$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($e553cde939346e03$var$isNonNullishPrimitive(obj) || $5vn5Z.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e553cde939346e03$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $e553cde939346e03$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $e553cde939346e03$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $5vn5Z.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($e553cde939346e03$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $e553cde939346e03$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $e553cde939346e03$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $e553cde939346e03$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $aLN2C();
        valueSideChannel.set($e553cde939346e03$var$sentinel, sideChannel);
        $e553cde939346e03$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $e553cde939346e03$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e553cde939346e03$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e553cde939346e03$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $e553cde939346e03$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $iSgbH.default;
    if (typeof opts.format !== 'undefined') {
        if (!$e553cde939346e03$var$has.call($iSgbH.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $iSgbH.formatters[format];
    var filter = $e553cde939346e03$var$defaults.filter;
    if (typeof opts.filter === 'function' || $e553cde939346e03$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e553cde939346e03$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $e553cde939346e03$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $e553cde939346e03$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $e553cde939346e03$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $e553cde939346e03$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $e553cde939346e03$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $e553cde939346e03$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $e553cde939346e03$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $e553cde939346e03$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $e553cde939346e03$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $e553cde939346e03$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $e553cde939346e03$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $e553cde939346e03$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $e553cde939346e03$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e553cde939346e03$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($e553cde939346e03$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $e553cde939346e03$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $aLN2C();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $e553cde939346e03$var$pushToArray(keys, $e553cde939346e03$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("aLN2C", function(module, exports) {
'use strict';

var $eDiIz = parcelRequire("eDiIz");

var $5reXs = parcelRequire("5reXs");

var $2h55P = parcelRequire("2h55P");

var $Sth43 = parcelRequire("Sth43");

var $4mZ6l = parcelRequire("4mZ6l");
var $7d7455b7eca66e61$var$makeChannel = $4mZ6l || $Sth43 || $2h55P;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $7d7455b7eca66e61$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("eDiIz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("5reXs", function(module, exports) {
var $3f5b13b16a751ddf$var$hasMap = typeof Map === 'function' && Map.prototype;
var $3f5b13b16a751ddf$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $3f5b13b16a751ddf$var$mapSize = $3f5b13b16a751ddf$var$hasMap && $3f5b13b16a751ddf$var$mapSizeDescriptor && typeof $3f5b13b16a751ddf$var$mapSizeDescriptor.get === 'function' ? $3f5b13b16a751ddf$var$mapSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$mapForEach = $3f5b13b16a751ddf$var$hasMap && Map.prototype.forEach;
var $3f5b13b16a751ddf$var$hasSet = typeof Set === 'function' && Set.prototype;
var $3f5b13b16a751ddf$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $3f5b13b16a751ddf$var$setSize = $3f5b13b16a751ddf$var$hasSet && $3f5b13b16a751ddf$var$setSizeDescriptor && typeof $3f5b13b16a751ddf$var$setSizeDescriptor.get === 'function' ? $3f5b13b16a751ddf$var$setSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$setForEach = $3f5b13b16a751ddf$var$hasSet && Set.prototype.forEach;
var $3f5b13b16a751ddf$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $3f5b13b16a751ddf$var$weakMapHas = $3f5b13b16a751ddf$var$hasWeakMap ? WeakMap.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $3f5b13b16a751ddf$var$weakSetHas = $3f5b13b16a751ddf$var$hasWeakSet ? WeakSet.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $3f5b13b16a751ddf$var$weakRefDeref = $3f5b13b16a751ddf$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $3f5b13b16a751ddf$var$booleanValueOf = Boolean.prototype.valueOf;
var $3f5b13b16a751ddf$var$objectToString = Object.prototype.toString;
var $3f5b13b16a751ddf$var$functionToString = Function.prototype.toString;
var $3f5b13b16a751ddf$var$$match = String.prototype.match;
var $3f5b13b16a751ddf$var$$slice = String.prototype.slice;
var $3f5b13b16a751ddf$var$$replace = String.prototype.replace;
var $3f5b13b16a751ddf$var$$toUpperCase = String.prototype.toUpperCase;
var $3f5b13b16a751ddf$var$$toLowerCase = String.prototype.toLowerCase;
var $3f5b13b16a751ddf$var$$test = RegExp.prototype.test;
var $3f5b13b16a751ddf$var$$concat = Array.prototype.concat;
var $3f5b13b16a751ddf$var$$join = Array.prototype.join;
var $3f5b13b16a751ddf$var$$arrSlice = Array.prototype.slice;
var $3f5b13b16a751ddf$var$$floor = Math.floor;
var $3f5b13b16a751ddf$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $3f5b13b16a751ddf$var$gOPS = Object.getOwnPropertySymbols;
var $3f5b13b16a751ddf$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $3f5b13b16a751ddf$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $3f5b13b16a751ddf$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $3f5b13b16a751ddf$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $3f5b13b16a751ddf$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $3f5b13b16a751ddf$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $3f5b13b16a751ddf$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $3f5b13b16a751ddf$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$3f5b13b16a751ddf$var$$floor(-num) : $3f5b13b16a751ddf$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $3f5b13b16a751ddf$var$$slice.call(str, intStr.length + 1);
            return $3f5b13b16a751ddf$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $3f5b13b16a751ddf$var$$replace.call(str, sepRegex, '$&_');
}

var $5Io6y = parcelRequire("5Io6y");
var $3f5b13b16a751ddf$var$inspectCustom = $5Io6y.custom;
var $3f5b13b16a751ddf$var$inspectSymbol = $3f5b13b16a751ddf$var$isSymbol($3f5b13b16a751ddf$var$inspectCustom) ? $3f5b13b16a751ddf$var$inspectCustom : null;
var $3f5b13b16a751ddf$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $3f5b13b16a751ddf$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($3f5b13b16a751ddf$var$has(opts, 'quoteStyle') && !$3f5b13b16a751ddf$var$has($3f5b13b16a751ddf$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($3f5b13b16a751ddf$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $3f5b13b16a751ddf$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($3f5b13b16a751ddf$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($3f5b13b16a751ddf$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $3f5b13b16a751ddf$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $3f5b13b16a751ddf$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $3f5b13b16a751ddf$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($3f5b13b16a751ddf$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $3f5b13b16a751ddf$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($3f5b13b16a751ddf$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var name = $3f5b13b16a751ddf$var$nameOf(obj);
        var keys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $3f5b13b16a751ddf$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($3f5b13b16a751ddf$var$isSymbol(obj)) {
        var symString = $3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $3f5b13b16a751ddf$var$symToString.call(obj);
        return typeof obj === 'object' && !$3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$markBoxed(symString) : symString;
    }
    if ($3f5b13b16a751ddf$var$isElement(obj)) {
        var s = '<' + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $3f5b13b16a751ddf$var$wrapQuotes($3f5b13b16a751ddf$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($3f5b13b16a751ddf$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (indent && !$3f5b13b16a751ddf$var$singleLineValues(xs)) return '[' + $3f5b13b16a751ddf$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $3f5b13b16a751ddf$var$$join.call(xs, ', ') + ' ]';
    }
    if ($3f5b13b16a751ddf$var$isError(obj)) {
        var parts = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$3f5b13b16a751ddf$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $3f5b13b16a751ddf$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($3f5b13b16a751ddf$var$inspectSymbol && typeof obj[$3f5b13b16a751ddf$var$inspectSymbol] === 'function' && $5Io6y) return $5Io6y(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($3f5b13b16a751ddf$var$isMap(obj)) {
        var mapParts = [];
        if ($3f5b13b16a751ddf$var$mapForEach) $3f5b13b16a751ddf$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf('Map', $3f5b13b16a751ddf$var$mapSize.call(obj), mapParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isSet(obj)) {
        var setParts = [];
        if ($3f5b13b16a751ddf$var$setForEach) $3f5b13b16a751ddf$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf('Set', $3f5b13b16a751ddf$var$setSize.call(obj), setParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isWeakMap(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakMap');
    if ($3f5b13b16a751ddf$var$isWeakSet(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakSet');
    if ($3f5b13b16a751ddf$var$isWeakRef(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakRef');
    if ($3f5b13b16a751ddf$var$isNumber(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(Number(obj)));
    if ($3f5b13b16a751ddf$var$isBigInt(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect($3f5b13b16a751ddf$var$bigIntValueOf.call(obj)));
    if ($3f5b13b16a751ddf$var$isBoolean(obj)) return $3f5b13b16a751ddf$var$markBoxed($3f5b13b16a751ddf$var$booleanValueOf.call(obj));
    if ($3f5b13b16a751ddf$var$isString(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$3f5b13b16a751ddf$var$isDate(obj) && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var ys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        var isPlainObject = $3f5b13b16a751ddf$var$gPO ? $3f5b13b16a751ddf$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $3f5b13b16a751ddf$var$toStringTag && Object(obj) === obj && $3f5b13b16a751ddf$var$toStringTag in obj ? $3f5b13b16a751ddf$var$$slice.call($3f5b13b16a751ddf$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $3f5b13b16a751ddf$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $3f5b13b16a751ddf$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $3f5b13b16a751ddf$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $3f5b13b16a751ddf$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $3f5b13b16a751ddf$var$quote(s) {
    return $3f5b13b16a751ddf$var$$replace.call(String(s), /"/g, '&quot;');
}
function $3f5b13b16a751ddf$var$canTrustToString(obj) {
    return !$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === 'object' && ($3f5b13b16a751ddf$var$toStringTag in obj || typeof obj[$3f5b13b16a751ddf$var$toStringTag] !== 'undefined'));
}
function $3f5b13b16a751ddf$var$isArray(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Array]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isDate(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Date]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isRegExp(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object RegExp]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isError(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Error]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isString(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object String]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isNumber(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Number]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isBoolean(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Boolean]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $3f5b13b16a751ddf$var$isSymbol(obj) {
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$3f5b13b16a751ddf$var$symToString) return false;
    try {
        $3f5b13b16a751ddf$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$3f5b13b16a751ddf$var$bigIntValueOf) return false;
    try {
        $3f5b13b16a751ddf$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $3f5b13b16a751ddf$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $3f5b13b16a751ddf$var$has(obj, key) {
    return $3f5b13b16a751ddf$var$hasOwn.call(obj, key);
}
function $3f5b13b16a751ddf$var$toStr(obj) {
    return $3f5b13b16a751ddf$var$objectToString.call(obj);
}
function $3f5b13b16a751ddf$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $3f5b13b16a751ddf$var$$match.call($3f5b13b16a751ddf$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $3f5b13b16a751ddf$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $3f5b13b16a751ddf$var$isMap(x) {
    if (!$3f5b13b16a751ddf$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$mapSize.call(x);
        try {
            $3f5b13b16a751ddf$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakMap(x) {
    if (!$3f5b13b16a751ddf$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        try {
            $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakRef(x) {
    if (!$3f5b13b16a751ddf$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isSet(x) {
    if (!$3f5b13b16a751ddf$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$setSize.call(x);
        try {
            $3f5b13b16a751ddf$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakSet(x) {
    if (!$3f5b13b16a751ddf$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        try {
            $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $3f5b13b16a751ddf$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $3f5b13b16a751ddf$var$inspectString($3f5b13b16a751ddf$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $3f5b13b16a751ddf$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $3f5b13b16a751ddf$var$lowbyte);
    return $3f5b13b16a751ddf$var$wrapQuotes(s, 'single', opts);
}
function $3f5b13b16a751ddf$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $3f5b13b16a751ddf$var$$toUpperCase.call(n.toString(16));
}
function $3f5b13b16a751ddf$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $3f5b13b16a751ddf$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $3f5b13b16a751ddf$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $3f5b13b16a751ddf$var$indentedJoin(entries, indent) : $3f5b13b16a751ddf$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $3f5b13b16a751ddf$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($3f5b13b16a751ddf$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $3f5b13b16a751ddf$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $3f5b13b16a751ddf$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $3f5b13b16a751ddf$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $3f5b13b16a751ddf$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $3f5b13b16a751ddf$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect) {
    var isArr = $3f5b13b16a751ddf$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $3f5b13b16a751ddf$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $3f5b13b16a751ddf$var$gOPS === 'function' ? $3f5b13b16a751ddf$var$gOPS(obj) : [];
    var symMap;
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$3f5b13b16a751ddf$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($3f5b13b16a751ddf$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($3f5b13b16a751ddf$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $3f5b13b16a751ddf$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($3f5b13b16a751ddf$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});


parcelRegister("2h55P", function(module, exports) {
'use strict';

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $1a811eae018032cc$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $1a811eae018032cc$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $1a811eae018032cc$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $1a811eae018032cc$var$listSet = function(objects, key, value) {
    var node = $1a811eae018032cc$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $1a811eae018032cc$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$1a811eae018032cc$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $1a811eae018032cc$var$listDelete = function(objects, key) {
    if (objects) return $1a811eae018032cc$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $1a811eae018032cc$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $1a811eae018032cc$var$listGet($o, key);
        },
        has: function(key) {
            return $1a811eae018032cc$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $1a811eae018032cc$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("Sth43", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $bhqNG = parcelRequire("bhqNG");

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
var $0a3bc083529cac57$var$$Map = $avqmt('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $0a3bc083529cac57$var$$mapGet = $bhqNG('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $0a3bc083529cac57$var$$mapSet = $bhqNG('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0a3bc083529cac57$var$$mapHas = $bhqNG('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0a3bc083529cac57$var$$mapDelete = $bhqNG('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $0a3bc083529cac57$var$$mapSize = $bhqNG('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$0a3bc083529cac57$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $0a3bc083529cac57$var$$mapDelete($m, key);
                if ($0a3bc083529cac57$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $0a3bc083529cac57$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $0a3bc083529cac57$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $0a3bc083529cac57$var$$Map();
            $0a3bc083529cac57$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("avqmt", function(module, exports) {
'use strict';
var $7a613f7503e09dde$var$undefined1;

var $7KrI3 = parcelRequire("7KrI3");

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");

var $db7xm = parcelRequire("db7xm");

var $gKnEJ = parcelRequire("gKnEJ");

var $42MO3 = parcelRequire("42MO3");

var $daBYy = parcelRequire("daBYy");

var $7VgwK = parcelRequire("7VgwK");

var $6GICW = parcelRequire("6GICW");

var $lj3GK = parcelRequire("lj3GK");
var $7a613f7503e09dde$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $crSdH = parcelRequire("crSdH");

var $4jAFO = parcelRequire("4jAFO");
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $7a613f7503e09dde$var$ThrowTypeError = $crSdH ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $crSdH(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $agKAf = parcelRequire("agKAf");

var $e351b = parcelRequire("e351b");

var $kF6dV = parcelRequire("kF6dV");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === 'undefined' || !$agKAf ? undefined : $agKAf(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGenerator%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncIteratorPrototype%': $7a613f7503e09dde$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $7a613f7503e09dde$var$$Function,
    '%GeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf($agKAf([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7KrI3,
    '%Object.getOwnPropertyDescriptor%': $crSdH,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $7a613f7503e09dde$var$ThrowTypeError,
    '%TypedArray%': $7a613f7503e09dde$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9RlYm,
    '%Function.prototype.apply%': $hsI1I,
    '%Object.defineProperty%': $4jAFO,
    '%Object.getPrototypeOf%': $e351b,
    '%Math.abs%': $db7xm,
    '%Math.floor%': $gKnEJ,
    '%Math.max%': $42MO3,
    '%Math.min%': $daBYy,
    '%Math.pow%': $7VgwK,
    '%Math.round%': $6GICW,
    '%Math.sign%': $lj3GK,
    '%Reflect.getPrototypeOf%': $kF6dV
};
if ($agKAf) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $agKAf($agKAf(e));
    $7a613f7503e09dde$var$INTRINSICS['%Error.prototype%'] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $agKAf) value = $agKAf(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $a7ABz.call($9RlYm, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call($hsI1I, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call($9RlYm, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call($9RlYm, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call($9RlYm, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($crSdH && i + 1 >= parts.length) {
                var desc = $crSdH(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("7KrI3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ki6v4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6ZF4E", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jFaeR", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aNqH3", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("iOgL8", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("guz3A", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("db7xm", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("gKnEJ", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("42MO3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("daBYy", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("7VgwK", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("6GICW", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lj3GK", function(module, exports) {
'use strict';

var $jhjZ6 = parcelRequire("jhjZ6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jhjZ6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jhjZ6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("crSdH", function(module, exports) {
'use strict';

var $gRO4r = parcelRequire("gRO4r");
var $9102109fbf1ea315$require$$gOPD = $gRO4r;
if ($9102109fbf1ea315$require$$gOPD) try {
    $9102109fbf1ea315$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$require$$gOPD = null;
}
module.exports = $9102109fbf1ea315$require$$gOPD;

});
parcelRegister("gRO4r", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("4jAFO", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $3245625cab00454b$var$$defineProperty = Object.defineProperty || false;
if ($3245625cab00454b$var$$defineProperty) try {
    $3245625cab00454b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3245625cab00454b$var$$defineProperty = false;
}
module.exports = $3245625cab00454b$var$$defineProperty;

});

parcelRegister("agKAf", function(module, exports) {
'use strict';

var $kF6dV = parcelRequire("kF6dV");

var $e351b = parcelRequire("e351b");

var $lMT7N = parcelRequire("lMT7N");
/** @type {import('.')} */ module.exports = $kF6dV ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kF6dV(O);
} : $e351b ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e351b(O);
} : $lMT7N ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lMT7N(O);
} : null;

});
parcelRegister("kF6dV", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("e351b", function(module, exports) {
'use strict';

var $7KrI3 = parcelRequire("7KrI3");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $7KrI3.getPrototypeOf || null;

});

parcelRegister("lMT7N", function(module, exports) {
'use strict';

var $csNIY = parcelRequire("csNIY");

var $crSdH = parcelRequire("crSdH");
var $fdc8d75150bf6587$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $fdc8d75150bf6587$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $fdc8d75150bf6587$var$desc = !!$fdc8d75150bf6587$var$hasProtoAccessor && $crSdH && $crSdH(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $fdc8d75150bf6587$var$$Object = Object;
var $fdc8d75150bf6587$var$$getPrototypeOf = $fdc8d75150bf6587$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $fdc8d75150bf6587$var$desc && typeof $fdc8d75150bf6587$var$desc.get === 'function' ? $csNIY([
    $fdc8d75150bf6587$var$desc.get
]) : typeof $fdc8d75150bf6587$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $fdc8d75150bf6587$var$$getPrototypeOf(value == null ? value : $fdc8d75150bf6587$var$$Object(value));
} : false;

});
parcelRegister("csNIY", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $eDiIz = parcelRequire("eDiIz");

var $9RlYm = parcelRequire("9RlYm");

var $2Y4BE = parcelRequire("2Y4BE");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eDiIz('a function is required');
    return $2Y4BE($a7ABz, $9RlYm, args);
};

});
parcelRegister("a7ABz", function(module, exports) {
'use strict';

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = '[object Function]';
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $923fbadf1e720976$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9RlYm", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("2Y4BE", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");

var $cnaFh = parcelRequire("cnaFh");
/** @type {import('./actualApply')} */ module.exports = $cnaFh || $a7ABz.call($9RlYm, $hsI1I);

});
parcelRegister("hsI1I", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cnaFh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("7Dte4", function(module, exports) {
'use strict';
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {import('.')} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});


parcelRegister("bhqNG", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $csNIY = parcelRequire("csNIY");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $8366123d1c7410f8$var$$indexOf = $csNIY([
    $avqmt('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ $avqmt(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8366123d1c7410f8$var$$indexOf(name, '.prototype.') > -1) return $csNIY([
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("4mZ6l", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $bhqNG = parcelRequire("bhqNG");

var $5reXs = parcelRequire("5reXs");

var $Sth43 = parcelRequire("Sth43");

var $eDiIz = parcelRequire("eDiIz");
var $32e89cf5f0eb8664$var$$WeakMap = $avqmt('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $32e89cf5f0eb8664$var$$weakMapGet = $bhqNG('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $32e89cf5f0eb8664$var$$weakMapSet = $bhqNG('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $32e89cf5f0eb8664$var$$weakMapHas = $bhqNG('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $32e89cf5f0eb8664$var$$weakMapDelete = $bhqNG('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $32e89cf5f0eb8664$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapDelete($wm, key);
            } else if ($Sth43) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $32e89cf5f0eb8664$var$$WeakMap();
                $32e89cf5f0eb8664$var$$weakMapSet($wm, key, value);
            } else if ($Sth43) {
                if (!$m) $m = $Sth43();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $Sth43;

});


parcelRegister("5vn5Z", function(module, exports) {
'use strict';

var $iSgbH = parcelRequire("iSgbH");
var $4021c34b736659c4$var$has = Object.prototype.hasOwnProperty;
var $4021c34b736659c4$var$isArray = Array.isArray;
var $4021c34b736659c4$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $4021c34b736659c4$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($4021c34b736659c4$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $4021c34b736659c4$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $4021c34b736659c4$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($4021c34b736659c4$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$4021c34b736659c4$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($4021c34b736659c4$var$isArray(target) && !$4021c34b736659c4$var$isArray(source)) mergeTarget = $4021c34b736659c4$var$arrayToObject(target, options);
    if ($4021c34b736659c4$var$isArray(target) && $4021c34b736659c4$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($4021c34b736659c4$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($4021c34b736659c4$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $4021c34b736659c4$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $4021c34b736659c4$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $4021c34b736659c4$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $4021c34b736659c4$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $4021c34b736659c4$var$limit){
        var segment = string.length >= $4021c34b736659c4$var$limit ? string.slice(j, j + $4021c34b736659c4$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $iSgbH.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $4021c34b736659c4$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $4021c34b736659c4$var$hexTable[0xC0 | c >> 6] + $4021c34b736659c4$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $4021c34b736659c4$var$hexTable[0xE0 | c >> 12] + $4021c34b736659c4$var$hexTable[0x80 | c >> 6 & 0x3F] + $4021c34b736659c4$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $4021c34b736659c4$var$hexTable[0xF0 | c >> 18] + $4021c34b736659c4$var$hexTable[0x80 | c >> 12 & 0x3F] + $4021c34b736659c4$var$hexTable[0x80 | c >> 6 & 0x3F] + $4021c34b736659c4$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $4021c34b736659c4$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $4021c34b736659c4$var$compactQueue(queue);
    return value;
};
var $4021c34b736659c4$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $4021c34b736659c4$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $4021c34b736659c4$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $4021c34b736659c4$var$maybeMap = function maybeMap(val, fn) {
    if ($4021c34b736659c4$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $4021c34b736659c4$var$arrayToObject,
    assign: $4021c34b736659c4$var$assign,
    combine: $4021c34b736659c4$var$combine,
    compact: $4021c34b736659c4$var$compact,
    decode: $4021c34b736659c4$var$decode,
    encode: $4021c34b736659c4$var$encode,
    isBuffer: $4021c34b736659c4$var$isBuffer,
    isRegExp: $4021c34b736659c4$var$isRegExp,
    maybeMap: $4021c34b736659c4$var$maybeMap,
    merge: $4021c34b736659c4$var$merge
};

});
parcelRegister("iSgbH", function(module, exports) {
'use strict';
var $dbd9d3a7d871eabc$var$replace = String.prototype.replace;
var $dbd9d3a7d871eabc$var$percentTwenties = /%20/g;
var $dbd9d3a7d871eabc$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $dbd9d3a7d871eabc$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $dbd9d3a7d871eabc$var$replace.call(value, $dbd9d3a7d871eabc$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $dbd9d3a7d871eabc$var$Format.RFC1738,
    RFC3986: $dbd9d3a7d871eabc$var$Format.RFC3986
};

});



parcelRegister("h1p15", function(module, exports) {
'use strict';

var $5vn5Z = parcelRequire("5vn5Z");
var $c645ef6de64ebcf4$var$has = Object.prototype.hasOwnProperty;
var $c645ef6de64ebcf4$var$isArray = Array.isArray;
var $c645ef6de64ebcf4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $5vn5Z.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $c645ef6de64ebcf4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $c645ef6de64ebcf4$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $c645ef6de64ebcf4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $c645ef6de64ebcf4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $c645ef6de64ebcf4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $c645ef6de64ebcf4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $c645ef6de64ebcf4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $c645ef6de64ebcf4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $c645ef6de64ebcf4$var$defaults.decoder, charset, 'key');
            val = $5vn5Z.maybeMap($c645ef6de64ebcf4$var$parseArrayValue(part.slice(pos + 1), options, $c645ef6de64ebcf4$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $c645ef6de64ebcf4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $c645ef6de64ebcf4$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $c645ef6de64ebcf4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $c645ef6de64ebcf4$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $5vn5Z.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $c645ef6de64ebcf4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $c645ef6de64ebcf4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $5vn5Z.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $c645ef6de64ebcf4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $c645ef6de64ebcf4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $c645ef6de64ebcf4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $c645ef6de64ebcf4$var$parseObject(keys, val, options, valuesParsed);
};
var $c645ef6de64ebcf4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $c645ef6de64ebcf4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $c645ef6de64ebcf4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $c645ef6de64ebcf4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $c645ef6de64ebcf4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $c645ef6de64ebcf4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $c645ef6de64ebcf4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $c645ef6de64ebcf4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $c645ef6de64ebcf4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $c645ef6de64ebcf4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $c645ef6de64ebcf4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $c645ef6de64ebcf4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $c645ef6de64ebcf4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $5vn5Z.isRegExp(opts.delimiter) ? opts.delimiter : $c645ef6de64ebcf4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $c645ef6de64ebcf4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $c645ef6de64ebcf4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $c645ef6de64ebcf4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $c645ef6de64ebcf4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $c645ef6de64ebcf4$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $c645ef6de64ebcf4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $c645ef6de64ebcf4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $c645ef6de64ebcf4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $c645ef6de64ebcf4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $5vn5Z.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $5vn5Z.compact(obj);
};

});


parcelRegister("2EH2o", function(module, exports) {

$parcel$export(module.exports, "GenericQuery", function () { return $23ed67a818122c32$export$5ba030c5649e7498; });

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $sjwE0 = parcelRequire("sjwE0");
const $23ed67a818122c32$var$fromPartial = (partial)=>({
        search: (0, $sjwE0.Maybe).fromNullable(partial.search)
    });
const $23ed67a818122c32$var$toPartial = (query)=>{
    const res = {
        search: (0, $sjwE0.Maybe).toUndefined(query.search)
    };
    return (0, $f5id0.pipe)(res, (0, $sjwE0.Dict).filter((val)=>val !== undefined));
};
const $23ed67a818122c32$var$Lens = {
    search: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('search'))
};
const $23ed67a818122c32$export$5ba030c5649e7498 = {
    fromPartial: $23ed67a818122c32$var$fromPartial,
    toPartial: $23ed67a818122c32$var$toPartial,
    Lens: $23ed67a818122c32$var$Lens
};

});

parcelRegister("8PgX5", function(module, exports) {

$parcel$export(module.exports, "PartialGenericQuery", function () { return $0beb613b4f9059a5$export$3dd2c3cb2f38ff53; });

var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $kGWxD = parcelRequire("kGWxD");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $5f8a7 = parcelRequire("5f8a7");
const $0beb613b4f9059a5$var$properties = {
    search: (0, $hHBpg.NonEmptyString).codec
};
const $0beb613b4f9059a5$var$decoder = $4BSZX.partial($0beb613b4f9059a5$var$properties);
const $0beb613b4f9059a5$var$encoder = $d9q5l.partial($0beb613b4f9059a5$var$properties);
const $0beb613b4f9059a5$var$qsStringify = (query)=>(0, $f5id0.pipe)(query, (0, $sjwE0.Dict).filter((0, $5f8a7.isDefined)), $0beb613b4f9059a5$var$encoder.encode, (0, (/*@__PURE__*/$parcel$interopDefault($kGWxD))).stringify);
const $0beb613b4f9059a5$export$3dd2c3cb2f38ff53 = {
    decoder: $0beb613b4f9059a5$var$decoder,
    qsStringify: $0beb613b4f9059a5$var$qsStringify
};

});
parcelRegister("5f8a7", function(module, exports) {

$parcel$export(module.exports, "isDefined", function () { return $4f5153ce5b75c212$export$4e62c701997796c1; });
const $4f5153ce5b75c212$export$4e62c701997796c1 = (a)=>a !== null && a !== undefined;

});


parcelRegister("kiCtw", function(module, exports) {

$parcel$export(module.exports, "MasteriesQuery", function () { return $373534bd5c756d7a$export$ae498ba88dc8a413; });

var $3JkJJ = parcelRequire("3JkJJ");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $vkIKL = parcelRequire("vkIKL");

var $aapGO = parcelRequire("aapGO");

var $65UVg = parcelRequire("65UVg");

var $sjwE0 = parcelRequire("sjwE0");

var $1ZcO3 = parcelRequire("1ZcO3");

var $4tRvs = parcelRequire("4tRvs");

var $gUt5F = parcelRequire("gUt5F");
const $373534bd5c756d7a$var$levelDefault = new Set((0, $aapGO.ChampionLevel).values);
const $373534bd5c756d7a$var$levelEq = (0, $3JkJJ).getEq((0, $aapGO.ChampionLevel).Eq);
const $373534bd5c756d7a$var$positionDefault = new Set((0, $65UVg.ChampionPosition).values);
const $373534bd5c756d7a$var$positionEq = (0, $3JkJJ).getEq((0, $65UVg.ChampionPosition).Eq);
const $373534bd5c756d7a$var$factionDefault = new Set((0, $vkIKL.ChampionFactionOrNone).values);
const $373534bd5c756d7a$var$factionEq = (0, $3JkJJ).getEq((0, $vkIKL.ChampionFactionOrNone).Eq);
const $373534bd5c756d7a$var$fromPartial = (partial)=>({
        sort: partial.sort ?? (0, $4tRvs.MasteriesQuerySort).default,
        order: partial.order ?? (0, $1ZcO3.MasteriesQueryOrder).default,
        view: partial.view ?? (0, $gUt5F.MasteriesQueryView).default,
        level: partial.level ?? $373534bd5c756d7a$var$levelDefault,
        faction: partial.faction ?? $373534bd5c756d7a$var$factionDefault,
        position: partial.position ?? $373534bd5c756d7a$var$positionDefault,
        search: (0, $sjwE0.Maybe).fromNullable(partial.search)
    });
const $373534bd5c756d7a$var$toPartial = (query)=>{
    const res = {
        sort: query.sort === (0, $4tRvs.MasteriesQuerySort).default ? undefined : query.sort,
        order: query.order === (0, $1ZcO3.MasteriesQueryOrder).default ? undefined : query.order,
        view: query.view === (0, $gUt5F.MasteriesQueryView).default ? undefined : query.view,
        level: $373534bd5c756d7a$var$levelEq.equals(query.level, $373534bd5c756d7a$var$levelDefault) ? undefined : query.level,
        faction: $373534bd5c756d7a$var$factionEq.equals(query.faction, $373534bd5c756d7a$var$factionDefault) ? undefined : query.faction,
        position: $373534bd5c756d7a$var$positionEq.equals(query.position, $373534bd5c756d7a$var$positionDefault) ? undefined : query.position,
        search: (0, $sjwE0.Maybe).toUndefined(query.search)
    };
    return (0, $f5id0.pipe)(res, (0, $sjwE0.Dict).filter((val)=>val !== undefined));
};
const $373534bd5c756d7a$var$Lens = {
    sort: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('sort')),
    order: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('order')),
    view: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('view')),
    level: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('level')),
    faction: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('faction')),
    position: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('position')),
    search: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('search'))
};
const $373534bd5c756d7a$export$ae498ba88dc8a413 = {
    fromPartial: $373534bd5c756d7a$var$fromPartial,
    toPartial: $373534bd5c756d7a$var$toPartial,
    Lens: $373534bd5c756d7a$var$Lens
};

});
parcelRegister("aapGO", function(module, exports) {

$parcel$export(module.exports, "ChampionLevel", function () { return $a12aebf8f84f110c$export$8e3f96dd5c74b907; });

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $j839F = parcelRequire("j839F");

var $hHBpg = parcelRequire("hHBpg");
const $a12aebf8f84f110c$var$e = (0, $j839F.createEnum)(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10);
const $a12aebf8f84f110c$var$stringCodec = (0, $f5id0.pipe)((0, $hHBpg.NumberFromString).codec, $jPaL5.compose($a12aebf8f84f110c$var$e.codec));
const $a12aebf8f84f110c$var$stringify = String;
const $a12aebf8f84f110c$var$values = $a12aebf8f84f110c$var$e.values;
function $a12aebf8f84f110c$var$isChampionLevel(n) {
    return $a12aebf8f84f110c$var$values.includes(n);
}
/**
 * @returns `10` if `n` is not a valid ChampionLevel
 */ function $a12aebf8f84f110c$var$fromNumber(n) {
    return $a12aebf8f84f110c$var$isChampionLevel(n) ? n : 10;
}
const $a12aebf8f84f110c$export$8e3f96dd5c74b907 = {
    codec: $a12aebf8f84f110c$var$e.codec,
    values: $a12aebf8f84f110c$var$e.values,
    stringCodec: $a12aebf8f84f110c$var$stringCodec,
    stringify: $a12aebf8f84f110c$var$stringify,
    fromNumber: $a12aebf8f84f110c$var$fromNumber,
    Eq: $a12aebf8f84f110c$var$e.Eq,
    Ord: $a12aebf8f84f110c$var$e.Ord
};

});

parcelRegister("1ZcO3", function(module, exports) {

$parcel$export(module.exports, "MasteriesQueryOrder", function () { return $fd25db767e7f5b61$export$1dedd29df924e3a3; });

var $j839F = parcelRequire("j839F");
const $fd25db767e7f5b61$var$e = (0, $j839F.createEnum)('desc', 'asc');
const $fd25db767e7f5b61$var$default_ = 'desc';
const $fd25db767e7f5b61$export$1dedd29df924e3a3 = {
    codec: $fd25db767e7f5b61$var$e.codec,
    values: $fd25db767e7f5b61$var$e.values,
    default: $fd25db767e7f5b61$var$default_
};

});

parcelRegister("4tRvs", function(module, exports) {

$parcel$export(module.exports, "MasteriesQuerySort", function () { return $8cde31b4ea4f2a9b$export$d056c52114b85b89; });

var $j839F = parcelRequire("j839F");
const $8cde31b4ea4f2a9b$var$e = (0, $j839F.createEnum)('level', 'percents', 'points', 'name');
const $8cde31b4ea4f2a9b$var$default_ = 'level';
const $8cde31b4ea4f2a9b$export$d056c52114b85b89 = {
    codec: $8cde31b4ea4f2a9b$var$e.codec,
    values: $8cde31b4ea4f2a9b$var$e.values,
    default: $8cde31b4ea4f2a9b$var$default_
};

});

parcelRegister("gUt5F", function(module, exports) {

$parcel$export(module.exports, "MasteriesQueryView", function () { return $8b58e464c59f6ec5$export$dd815ae300c96b75; });

var $j839F = parcelRequire("j839F");

var $sjwE0 = parcelRequire("sjwE0");
const $8b58e464c59f6ec5$var$balanceViews = [
    'aram',
    'urf'
];
const $8b58e464c59f6ec5$var$e = (0, $j839F.createEnum)('compact', 'histogram', ...$8b58e464c59f6ec5$var$balanceViews, 'factions');
const $8b58e464c59f6ec5$var$default_ = 'compact';
function $8b58e464c59f6ec5$var$isBalance(view) {
    return (0, $sjwE0.List).elem($8b58e464c59f6ec5$var$e.Eq)(view, $8b58e464c59f6ec5$var$balanceViews);
}
const $8b58e464c59f6ec5$export$dd815ae300c96b75 = {
    ...$8b58e464c59f6ec5$var$e,
    default: $8b58e464c59f6ec5$var$default_,
    isBalance: $8b58e464c59f6ec5$var$isBalance
};

});


parcelRegister("8Zv6u", function(module, exports) {

$parcel$export(module.exports, "PartialMasteriesQuery", function () { return $68b57b2731da66de$export$e0786fe8dcd5897f; });

var $3JkJJ = parcelRequire("3JkJJ");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $d9q5l = parcelRequire("d9q5l");

var $kGWxD = parcelRequire("kGWxD");

var $vkIKL = parcelRequire("vkIKL");

var $aapGO = parcelRequire("aapGO");

var $65UVg = parcelRequire("65UVg");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $5f8a7 = parcelRequire("5f8a7");

var $1ZcO3 = parcelRequire("1ZcO3");

var $4tRvs = parcelRequire("4tRvs");

var $gUt5F = parcelRequire("gUt5F");
const $68b57b2731da66de$var$setFromStringCodec = (0, $hHBpg.SetFromString).codec(',');
const $68b57b2731da66de$var$properties = {
    sort: (0, $4tRvs.MasteriesQuerySort).codec,
    order: (0, $1ZcO3.MasteriesQueryOrder).codec,
    view: (0, $gUt5F.MasteriesQueryView).codec,
    level: $68b57b2731da66de$var$setFromStringOrAllCodec((0, $aapGO.ChampionLevel).stringCodec, (0, $aapGO.ChampionLevel).Ord, new Set((0, $aapGO.ChampionLevel).values)),
    faction: $68b57b2731da66de$var$setFromStringOrAllCodec((0, $vkIKL.ChampionFactionOrNone).codec, (0, $vkIKL.ChampionFactionOrNone).Ord, new Set((0, $vkIKL.ChampionFactionOrNone).values)),
    position: $68b57b2731da66de$var$setFromStringOrAllCodec((0, $65UVg.ChampionPosition).codec, (0, $65UVg.ChampionPosition).Ord, new Set((0, $65UVg.ChampionPosition).values)),
    search: (0, $hHBpg.NonEmptyString).codec
};
const $68b57b2731da66de$var$decoder = $4BSZX.partial($68b57b2731da66de$var$properties);
const $68b57b2731da66de$var$encoder = $d9q5l.partial($68b57b2731da66de$var$properties);
const $68b57b2731da66de$var$qsStringify = (query)=>(0, $f5id0.pipe)(query, (0, $sjwE0.Dict).filter((0, $5f8a7.isDefined)), $68b57b2731da66de$var$encoder.encode, (0, (/*@__PURE__*/$parcel$interopDefault($kGWxD))).stringify);
const $68b57b2731da66de$export$e0786fe8dcd5897f = {
    decoder: $68b57b2731da66de$var$decoder,
    qsStringify: $68b57b2731da66de$var$qsStringify
};
function $68b57b2731da66de$var$setFromStringOrAllCodec(codec, ord, allValues) {
    const setCodec = $68b57b2731da66de$var$setFromStringCodec(codec, ord);
    const setEq = (0, $3JkJJ).getEq(ord);
    return $jPaL5.make($4BSZX.union((0, $f5id0.pipe)($4BSZX.literal('all'), $4BSZX.map(()=>allValues)), setCodec), {
        encode: (set)=>setEq.equals(set, allValues) ? 'all' : setCodec.encode(set)
    });
}

});



parcelRegister("tA0jd", function(module, exports) {

$parcel$export(module.exports, "MainLayout", function () { return $f105cf86d5ffc3fe$export$93af822566053b3e; });

var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");

var $ixfeS = parcelRequire("ixfeS");

var $jFynM = parcelRequire("jFynM");

var $1aCLo = parcelRequire("1aCLo");

var $gwlG1 = parcelRequire("gwlG1");

var $65dIW = parcelRequire("65dIW");

var $gE3ky = parcelRequire("gE3ky");

var $hnBhT = parcelRequire("hnBhT");

var $fVW4p = parcelRequire("fVW4p");

var $3KgVG = parcelRequire("3KgVG");

var $es0HS = parcelRequire("es0HS");

var $aLUD6 = parcelRequire("aLUD6");

var $iwgbI = parcelRequire("iwgbI");

var $gRZ9W = parcelRequire("gRZ9W");

var $gSWvX = parcelRequire("gSWvX");

var $MxrOL = parcelRequire("MxrOL");
const $f105cf86d5ffc3fe$export$93af822566053b3e = ({ children: children })=>{
    const { user: user } = (0, $j30iL.useUser)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const summoner = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).anyPlatformRiotId);
    const homeRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex h-full flex-col",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("header", {
                className: "flex justify-center border-b border-goldenrod bg-gradient-to-br from-zinc-950 to-zinc-900 px-3",
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "relative flex w-full max-w-7xl flex-wrap items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex grow basis-0 flex-wrap items-center gap-x-6",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                                    ref: homeRef,
                                    to: (0, $gE3ky.appRoutes).index,
                                    className: "pt-2",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                        src: (0, $jFynM.Assets).yuumiHome,
                                        alt: t.layout.yuumiHomeAlt,
                                        width: 224,
                                        height: 128,
                                        className: "h-14 w-auto text-2xs text-transparent opacity-90"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                    hoverRef: homeRef,
                                    children: t.layout.home
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex items-center gap-4 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                                            to: (0, $gE3ky.appRoutes).aram({}),
                                            parser: (0, $gE3ky.appParsers).aram,
                                            tooltip: t.layout.aramSpecificBalanceChanges,
                                            className: "py-2",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1aCLo.HowlingAbyssSimple), {
                                                className: "w-5 secondary-wheat/60"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                                            to: (0, $gE3ky.appRoutes).urf({}),
                                            parser: (0, $gE3ky.appParsers).urf,
                                            tooltip: t.layout.urfSpecificBalanceChanges,
                                            className: "py-2",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3KgVG.MaskedImage), {
                                                src: (0, $jFynM.Assets).spatula,
                                                className: "size-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                                            to: (0, $gE3ky.appRoutes).factions({}),
                                            parser: (0, $gE3ky.appParsers).factions,
                                            tooltip: t.layout.globetrotterChallenges,
                                            className: "py-2",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3KgVG.MaskedImage), {
                                                src: (0, $jFynM.Assets).runeterra,
                                                className: "size-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                                            to: (0, $gE3ky.appRoutes).timers,
                                            parser: (0, $gE3ky.appParsers).timers,
                                            tooltip: t.layout.timers,
                                            className: "overflow-x-hidden py-1",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.HourglassOutline), {
                                                className: "-mx-0.5 w-6 secondary-wheat/60"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $MxrOL.SearchSummoner), {}),
                                summoner !== undefined ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-4 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                                            to: (0, $gE3ky.appRoutes).platformRiotId(summoner.platform, summoner.riotId, {}),
                                            parser: (0, $gE3ky.appParsers).platformRiotId,
                                            tooltip: t.layout.championMasteries,
                                            className: "mt-0.5 py-0.5",
                                            children: t.layout.profile
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                                            to: (0, $gE3ky.appRoutes).platformRiotIdGame(summoner.platform, summoner.riotId),
                                            parser: (0, $gE3ky.appParsers).platformRiotIdGame,
                                            tooltip: t.layout.activeGame,
                                            className: "mt-0.5 py-0.5",
                                            children: t.layout.game
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex grow basis-0 flex-wrap items-center justify-end gap-x-4 self-stretch",
                            children: [
                                (0, $f5id0.pipe)(user, (0, $65dIW.AsyncState).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                                        className: "my-2 h-5"
                                    }), ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $iwgbI.AccountDisconnected), {}), (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $iwgbI.AccountDisconnected), {}), (u)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $aLUD6.AccountConnected), {
                                        user: u
                                    })))),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $gSWvX.Languages), {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("main", {
                className: "grow overflow-auto",
                children: children
            })
        ]
    });
};

});
parcelRegister("ixfeS", function(module, exports) {

$parcel$export(module.exports, "usePathMatch", function () { return $48711ffa88a81384$export$e9d005d8e9334cae; });

var $dc934 = parcelRequire("dc934");
var $fbpED = parcelRequire("fbpED");

var $bh6RR = parcelRequire("bh6RR");

var $9xM77 = parcelRequire("9xM77");
function $48711ffa88a81384$export$e9d005d8e9334cae(parser) {
    const { location: location } = (0, $9xM77.useHistory)();
    return (0, $bh6RR.useMemo)(()=>(0, $dc934.parse)(parser, (0, $fbpED.Route).parse(location.pathname), undefined), [
        location.pathname,
        parser
    ]);
}

});

parcelRegister("jFynM", function(module, exports) {

$parcel$export(module.exports, "Assets", function () { return $2c1feafb06da2398$export$c8eca95e306f7116; });













// https://wiki.leagueoflegends.com/en-us/Category:Lore_icons
const $2c1feafb06da2398$var$factions = {
    bandle: new URL((parcelRequire("2yrqT"))).toString(),
    bilgewater: new URL((parcelRequire("4MoR9"))).toString(),
    demacia: new URL((parcelRequire("hSwzB"))).toString(),
    freljord: new URL((parcelRequire("afMXz"))).toString(),
    ionia: new URL((parcelRequire("3Abo6"))).toString(),
    ixtal: new URL((parcelRequire("eKRsk"))).toString(),
    noxus: new URL((parcelRequire("ficWD"))).toString(),
    piltover: new URL((parcelRequire("3c4P5"))).toString(),
    shadowIsles: new URL((parcelRequire("1o8Pg"))).toString(),
    shurima: new URL((parcelRequire("copOq"))).toString(),
    targon: new URL((parcelRequire("hYONx"))).toString(),
    void: new URL((parcelRequire("5mSWG"))).toString(),
    zaun: new URL((parcelRequire("4rOUI"))).toString()
};











// https://raw.communitydragon.org/latest/plugins/rcp-fe-lol-shared-components/global/default/mastery-{n}.png
//
// Pre-process:
// 1. Put all masteries together (each in its own layer)
// 2. Create mastery 0 by removing wings of mastery 1
// 3. Crop to content
// 4. Commit those "large" versions
// 5. Reduce widths for actual use (2 times the in-app width):
//   - masteries 10-8: width 240
//   - masteries 7-0: width 116
const $2c1feafb06da2398$var$masteries = {
    0: new URL((parcelRequire("2UOxX"))).toString(),
    1: new URL((parcelRequire("e1Thi"))).toString(),
    2: new URL((parcelRequire("hFPar"))).toString(),
    3: new URL((parcelRequire("2rQ3G"))).toString(),
    4: new URL((parcelRequire("hcu5B"))).toString(),
    5: new URL((parcelRequire("3I5xk"))).toString(),
    6: new URL((parcelRequire("34E9y"))).toString(),
    7: new URL((parcelRequire("gL8fH"))).toString(),
    8: new URL((parcelRequire("8uaXu"))).toString(),
    9: new URL((parcelRequire("h7BE5"))).toString(),
    10: new URL((parcelRequire("cdu6C"))).toString()
};









// https://wiki.leagueoflegends.com/en-us/Category:Champion_stat_assets
const $2c1feafb06da2398$var$stats = {
    dmg_dealt: new URL((parcelRequire("1w2VV"))).toString(),
    dmg_taken: new URL((parcelRequire("l9U2H"))).toString(),
    healing: new URL((parcelRequire("7kj4p"))).toString(),
    shielding: new URL((parcelRequire("7tMMG"))).toString(),
    ability_haste: new URL((parcelRequire("3GzKe"))).toString(),
    energyregen_mod: new URL((parcelRequire("iNnzT"))).toString(),
    total_as: new URL((parcelRequire("kY0ND"))).toString(),
    movement_speed: new URL((parcelRequire("lDwT5"))).toString(),
    tenacity: new URL((parcelRequire("auquz"))).toString()
};










const $2c1feafb06da2398$export$c8eca95e306f7116 = {
    champion: new URL((parcelRequire("gqrQn"))).toString(),
    factions: $2c1feafb06da2398$var$factions,
    globetrotter: new URL((parcelRequire("j1oJc"))).toString(),
    masteries: $2c1feafb06da2398$var$masteries,
    runeterra: new URL((parcelRequire("2P3Q1"))).toString(),
    spatula: new URL((parcelRequire("2sVKN"))).toString(),
    stats: $2c1feafb06da2398$var$stats,
    thirdParty: {
        dpmLol: new URL((parcelRequire("4yBBB"))).toString(),
        leagueOfGraphs: new URL((parcelRequire("7hsip"))).toString(),
        opGg: new URL((parcelRequire("dIFBO"))).toString(),
        porofessor: new URL((parcelRequire("3WpWj"))).toString(),
        yearInLol: new URL((parcelRequire("fY3cB"))).toString()
    },
    yuumiHome: new URL((parcelRequire("b0SEB"))).toString()
};

});
parcelRegister("2yrqT", function(module, exports) {
module.exports = new URL("bandle.c006a2a6.webp", import.meta.url).toString();

});

parcelRegister("4MoR9", function(module, exports) {
module.exports = new URL("bilgewater.58d00087.webp", import.meta.url).toString();

});

parcelRegister("hSwzB", function(module, exports) {
module.exports = new URL("demacia.e4daa11c.webp", import.meta.url).toString();

});

parcelRegister("afMXz", function(module, exports) {
module.exports = new URL("freljord.744001bf.webp", import.meta.url).toString();

});

parcelRegister("3Abo6", function(module, exports) {
module.exports = new URL("ionia.6aea9ace.webp", import.meta.url).toString();

});

parcelRegister("eKRsk", function(module, exports) {
module.exports = new URL("ixtal.86197ae2.webp", import.meta.url).toString();

});

parcelRegister("ficWD", function(module, exports) {
module.exports = new URL("noxus.954ce344.webp", import.meta.url).toString();

});

parcelRegister("3c4P5", function(module, exports) {
module.exports = new URL("piltover.011e21bc.webp", import.meta.url).toString();

});

parcelRegister("1o8Pg", function(module, exports) {
module.exports = new URL("shadowIsles.25801c44.webp", import.meta.url).toString();

});

parcelRegister("copOq", function(module, exports) {
module.exports = new URL("shurima.3cd980ed.webp", import.meta.url).toString();

});

parcelRegister("hYONx", function(module, exports) {
module.exports = new URL("targon.23d59733.webp", import.meta.url).toString();

});

parcelRegister("5mSWG", function(module, exports) {
module.exports = new URL("void.43168c65.webp", import.meta.url).toString();

});

parcelRegister("4rOUI", function(module, exports) {
module.exports = new URL("zaun.e8da4a2f.webp", import.meta.url).toString();

});

parcelRegister("2UOxX", function(module, exports) {
module.exports = new URL("mastery-0.8fed1ae0.png", import.meta.url).toString();

});

parcelRegister("e1Thi", function(module, exports) {
module.exports = new URL("mastery-1.21920b27.png", import.meta.url).toString();

});

parcelRegister("hFPar", function(module, exports) {
module.exports = new URL("mastery-2.a4fc1478.png", import.meta.url).toString();

});

parcelRegister("2rQ3G", function(module, exports) {
module.exports = new URL("mastery-3.1cbe45a6.png", import.meta.url).toString();

});

parcelRegister("hcu5B", function(module, exports) {
module.exports = new URL("mastery-4.0c0f346b.png", import.meta.url).toString();

});

parcelRegister("3I5xk", function(module, exports) {
module.exports = new URL("mastery-5.cfc9ee95.png", import.meta.url).toString();

});

parcelRegister("34E9y", function(module, exports) {
module.exports = new URL("mastery-6.2b6317f1.png", import.meta.url).toString();

});

parcelRegister("gL8fH", function(module, exports) {
module.exports = new URL("mastery-7.d4edf5f3.png", import.meta.url).toString();

});

parcelRegister("8uaXu", function(module, exports) {
module.exports = new URL("mastery-8.ac344fe0.png", import.meta.url).toString();

});

parcelRegister("h7BE5", function(module, exports) {
module.exports = new URL("mastery-9.8f1c8b65.png", import.meta.url).toString();

});

parcelRegister("cdu6C", function(module, exports) {
module.exports = new URL("mastery-10.de3bd6c9.png", import.meta.url).toString();

});

parcelRegister("1w2VV", function(module, exports) {
module.exports = new URL("damage_amp.cb2ff0cf.webp", import.meta.url).toString();

});

parcelRegister("l9U2H", function(module, exports) {
module.exports = new URL("armor_penetration.66104771.webp", import.meta.url).toString();

});

parcelRegister("7kj4p", function(module, exports) {
module.exports = new URL("heal_power.c8b3d796.webp", import.meta.url).toString();

});

parcelRegister("7tMMG", function(module, exports) {
module.exports = new URL("shield_power.437195fc.webp", import.meta.url).toString();

});

parcelRegister("3GzKe", function(module, exports) {
module.exports = new URL("ability_haste.8fbe6db0.webp", import.meta.url).toString();

});

parcelRegister("iNnzT", function(module, exports) {
module.exports = new URL("energy_regen.f768e637.webp", import.meta.url).toString();

});

parcelRegister("kY0ND", function(module, exports) {
module.exports = new URL("attack_speed.81e8ef98.webp", import.meta.url).toString();

});

parcelRegister("lDwT5", function(module, exports) {
module.exports = new URL("movement_speed.bdd9f2d2.webp", import.meta.url).toString();

});

parcelRegister("auquz", function(module, exports) {
module.exports = new URL("tenacity.d3b34d47.webp", import.meta.url).toString();

});

parcelRegister("gqrQn", function(module, exports) {
module.exports = new URL("champion.3213ca9c.webp", import.meta.url).toString();

});

parcelRegister("j1oJc", function(module, exports) {
module.exports = new URL("globetrotter.8936141a.png", import.meta.url).toString();

});

parcelRegister("2P3Q1", function(module, exports) {
module.exports = new URL("runeterra.83ef5934.png", import.meta.url).toString();

});

parcelRegister("2sVKN", function(module, exports) {
module.exports = new URL("spatula.4655b2c1.png", import.meta.url).toString();

});

parcelRegister("4yBBB", function(module, exports) {
module.exports = new URL("dpm-lol.d7c4d9eb.png", import.meta.url).toString();

});

parcelRegister("7hsip", function(module, exports) {
module.exports = new URL("league-of-graphs.143b9e5d.png", import.meta.url).toString();

});

parcelRegister("dIFBO", function(module, exports) {
module.exports = new URL("op-gg.3c7751c0.png", import.meta.url).toString();

});

parcelRegister("3WpWj", function(module, exports) {
module.exports = new URL("porofessor.06889782.png", import.meta.url).toString();

});

parcelRegister("fY3cB", function(module, exports) {
module.exports = new URL("year-in-lol.1d22245c.png", import.meta.url).toString();

});

parcelRegister("b0SEB", function(module, exports) {
module.exports = new URL("yuumi-home.2e417a16.png", import.meta.url).toString();

});


parcelRegister("1aCLo", function(module, exports) {

$parcel$export(module.exports, "HowlingAbyssSimple", function () { return $d973193de183ba9f$export$d375e6851ad80dc0; });

var $ih19M = parcelRequire("ih19M");

var $hg2ot = parcelRequire("hg2ot");
const $d973193de183ba9f$export$6d4d0c47818f0b1f = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 91 91",
        className: className,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            transform: "translate(-5,-5)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeDasharray: "none",
                    d: "m 55.5,7.5 -6,6 h -8 l -6,6 h -16 v 16 l -6,6 v 8 L 7.5,55.5 V 93.5 H 45.5 l 6,-6 h 8 l 6,-6 h 16 v -16 l 6,-6 v -8 l 6,-6 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "3",
                    strokeDasharray: "none",
                    d: "M 55.5,7.5 43.5,19.5 H 19.5 V 43.5 L 7.5,55.5 V 93.5 H 45.5 L 57.5,81.5 H 81.5 V 57.5 L 93.5,45.5 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "5",
                    strokeDasharray: "none",
                    d: "M 55.5,7.5 37.5,25.5 H 25.5 V 37.5 L 7.5,55.5 V 93.5 H 45.5 L 63.5,75.5 H 75.5 V 63.5 L 93.5,45.5 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fill: (0, $hg2ot.secondaryColor),
                    stroke: "none",
                    d: "m 15.5,59.5 44,-44 h 26 v 26 l -44,44 h -26 z"
                })
            ]
        })
    });
const $d973193de183ba9f$export$d375e6851ad80dc0 = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96",
        className: className,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            transform: "translate(-2.5,-2.5)",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "10",
                    strokeDasharray: "none",
                    d: "M 55.5,7.5 43.5,19.5 H 19.5 V 43.5 L 7.5,55.5 V 93.5 H 45.5 L 57.5,81.5 H 81.5 V 57.5 L 93.5,45.5 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fill: (0, $hg2ot.secondaryColor),
                    stroke: "none",
                    d: "m 23.5,62.5 39,-39 h 15 v 15 l -39,39 h -15 z"
                })
            ]
        })
    });

});

parcelRegister("gE3ky", function(module, exports) {

$parcel$export(module.exports, "appMatches", function () { return $777b8f3947a8fd44$export$ca9aa00c3e4d1655; });
$parcel$export(module.exports, "appParsers", function () { return $777b8f3947a8fd44$export$bcd2c8cb769b6f17; });
$parcel$export(module.exports, "appRoutes", function () { return $777b8f3947a8fd44$export$61147a57d3c24ac8; });

var $kwhzj = parcelRequire("kwhzj");
var $c7lJu = parcelRequire("c7lJu");

var $ebDzf = parcelRequire("ebDzf");

var $gl9GP = parcelRequire("gl9GP");

var $fp7Nf = parcelRequire("fp7Nf");

var $3vjpe = parcelRequire("3vjpe");

var $dOJeV = parcelRequire("dOJeV");

var $8PgX5 = parcelRequire("8PgX5");

var $8Zv6u = parcelRequire("8Zv6u");

var $gL9kL = parcelRequire("gL9kL");
const { codec: $777b8f3947a8fd44$var$codec } = (0, $3vjpe.RouterUtils);
const $777b8f3947a8fd44$export$3ceb0509ba9dc0e5 = (0, $fp7Nf.RiotId).getFromStringCodec('-');
/**
 * matches
 */ const $777b8f3947a8fd44$var$platformM = $777b8f3947a8fd44$var$codec('platform', (0, $ebDzf.Platform).orLowerCaseCodec);
const $777b8f3947a8fd44$var$sPlatformPuuidMatch = (0, $kwhzj.lit)('s').then($777b8f3947a8fd44$var$platformM).then($777b8f3947a8fd44$var$codec('puuid', (0, $gl9GP.Puuid).codec));
const $777b8f3947a8fd44$var$sPlatformPuuidGameMatch = $777b8f3947a8fd44$var$sPlatformPuuidMatch.then((0, $kwhzj.lit)('game'));
const $777b8f3947a8fd44$var$platformRiotIdMatch = $777b8f3947a8fd44$var$platformM.then($777b8f3947a8fd44$var$codec('riotId', $777b8f3947a8fd44$export$3ceb0509ba9dc0e5));
const $777b8f3947a8fd44$var$platformRiotIdGameMatch = $777b8f3947a8fd44$var$platformRiotIdMatch.then((0, $kwhzj.lit)('game'));
const $777b8f3947a8fd44$var$aramMatch = (0, $kwhzj.lit)('aram');
const $777b8f3947a8fd44$var$urfMatch = (0, $kwhzj.lit)('urf');
const $777b8f3947a8fd44$var$factionsMatch = (0, $kwhzj.lit)('factions');
const $777b8f3947a8fd44$var$timersMatch = (0, $kwhzj.lit)('timers');
const $777b8f3947a8fd44$var$loginMatch = (0, $kwhzj.lit)('login');
const $777b8f3947a8fd44$var$registerMatch = (0, $kwhzj.lit)('register');
const $777b8f3947a8fd44$var$discordRedirectMatch = (0, $kwhzj.lit)('discordRedirect');
const $777b8f3947a8fd44$export$ca9aa00c3e4d1655 = {
    sPlatformPuuid: $777b8f3947a8fd44$var$sPlatformPuuidMatch.then((0, $kwhzj.end)),
    sPlatformPuuidGame: $777b8f3947a8fd44$var$sPlatformPuuidGameMatch.then((0, $kwhzj.end)),
    platformRiotId: $777b8f3947a8fd44$var$platformRiotIdMatch.then((0, $kwhzj.end)),
    platformRiotIdGame: $777b8f3947a8fd44$var$platformRiotIdGameMatch.then((0, $kwhzj.end))
};
/**
 * parsers
 *
 * Don't forget .then(end).parser (or use p)
 */ const $777b8f3947a8fd44$var$sPlatformPuuid = $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$sPlatformPuuidMatch);
const $777b8f3947a8fd44$var$sPlatformPuuidGame = $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$sPlatformPuuidGameMatch);
const $777b8f3947a8fd44$var$platformRiotId = $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$platformRiotIdMatch);
const $777b8f3947a8fd44$var$platformRiotIdGame = $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$platformRiotIdGameMatch);
const $777b8f3947a8fd44$var$anyPlatformRiotId = $777b8f3947a8fd44$var$platformRiotId.alt($777b8f3947a8fd44$var$platformRiotIdGame).map(({ platform: platform, riotId: riotId })=>({
        platform: (0, $dOJeV.StringUtils).toUpperCase(platform),
        riotId: riotId
    }));
const $777b8f3947a8fd44$var$anyPlatform = $777b8f3947a8fd44$var$sPlatformPuuid.alt($777b8f3947a8fd44$var$sPlatformPuuidGame).map(({ platform: platform })=>({
        platform: (0, $dOJeV.StringUtils).toUpperCase(platform)
    })).alt($777b8f3947a8fd44$var$anyPlatformRiotId);
const $777b8f3947a8fd44$export$bcd2c8cb769b6f17 = {
    index: (0, $kwhzj.end).parser,
    sPlatformPuuid: $777b8f3947a8fd44$var$sPlatformPuuid,
    sPlatformPuuidGame: $777b8f3947a8fd44$var$sPlatformPuuidGame,
    platformRiotId: $777b8f3947a8fd44$var$platformRiotId,
    platformRiotIdGame: $777b8f3947a8fd44$var$platformRiotIdGame,
    aram: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$aramMatch),
    urf: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$urfMatch),
    factions: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$factionsMatch),
    timers: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$timersMatch),
    login: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$loginMatch),
    register: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$registerMatch),
    discordRedirect: $777b8f3947a8fd44$var$p($777b8f3947a8fd44$var$discordRedirectMatch),
    anyAdmin: (0, $gL9kL.adminParsers).any,
    anyPlatform: $777b8f3947a8fd44$var$anyPlatform,
    anyPlatformRiotId: $777b8f3947a8fd44$var$anyPlatformRiotId
};
const $777b8f3947a8fd44$export$61147a57d3c24ac8 = {
    index: (0, $c7lJu.format)((0, $kwhzj.end).formatter, {}),
    sPlatformPuuid: (platform, puuid, query)=>$777b8f3947a8fd44$var$withQuery((0, $c7lJu.format)($777b8f3947a8fd44$var$sPlatformPuuidMatch.formatter, {
            platform: platform,
            puuid: puuid
        }), (0, $8Zv6u.PartialMasteriesQuery), query),
    sPlatformPuuidGame: (platform, puuid)=>(0, $c7lJu.format)($777b8f3947a8fd44$var$sPlatformPuuidGameMatch.formatter, {
            platform: platform,
            puuid: puuid
        }),
    platformRiotId: (platform, riotId, query)=>$777b8f3947a8fd44$var$withQuery((0, $c7lJu.format)($777b8f3947a8fd44$var$platformRiotIdMatch.formatter, {
            platform: platform,
            riotId: riotId
        }), (0, $8Zv6u.PartialMasteriesQuery), query),
    platformRiotIdGame: (platform, riotId)=>(0, $c7lJu.format)($777b8f3947a8fd44$var$platformRiotIdGameMatch.formatter, {
            platform: platform,
            riotId: riotId
        }),
    aram: (query)=>$777b8f3947a8fd44$var$withQuery((0, $c7lJu.format)($777b8f3947a8fd44$var$aramMatch.formatter, {}), (0, $8PgX5.PartialGenericQuery), query),
    urf: (query)=>$777b8f3947a8fd44$var$withQuery((0, $c7lJu.format)($777b8f3947a8fd44$var$urfMatch.formatter, {}), (0, $8PgX5.PartialGenericQuery), query),
    factions: (query)=>$777b8f3947a8fd44$var$withQuery((0, $c7lJu.format)($777b8f3947a8fd44$var$factionsMatch.formatter, {}), (0, $8PgX5.PartialGenericQuery), query),
    timers: (0, $c7lJu.format)($777b8f3947a8fd44$var$timersMatch.formatter, {}),
    login: (0, $c7lJu.format)($777b8f3947a8fd44$var$loginMatch.formatter, {}),
    register: (0, $c7lJu.format)($777b8f3947a8fd44$var$registerMatch.formatter, {})
};
const $777b8f3947a8fd44$var$withQuery = (path, { qsStringify: qsStringify }, a)=>{
    const query = qsStringify(a);
    return `${path}${query === '' ? '' : `?${query}`}`;
};
function $777b8f3947a8fd44$var$p(match) {
    return match.then((0, $kwhzj.end)).parser;
}

});
parcelRegister("gL9kL", function(module, exports) {

$parcel$export(module.exports, "adminParsers", function () { return $256f05e28b122d1d$export$49ed771160a51f2; });
$parcel$export(module.exports, "adminRoutes", function () { return $256f05e28b122d1d$export$37e8e188eda774db; });

var $kwhzj = parcelRequire("kwhzj");
var $c7lJu = parcelRequire("c7lJu");
/**
 * matches
 */ const $256f05e28b122d1d$var$admin = (0, $kwhzj.lit)('admin');
const $256f05e28b122d1d$var$adminHallOfFame = $256f05e28b122d1d$var$admin.then((0, $kwhzj.lit)('hall-of-fame'));
const $256f05e28b122d1d$export$49ed771160a51f2 = {
    index: $256f05e28b122d1d$var$p($256f05e28b122d1d$var$admin),
    hallOfFame: $256f05e28b122d1d$var$p($256f05e28b122d1d$var$adminHallOfFame),
    any: $256f05e28b122d1d$var$admin.parser
};
const $256f05e28b122d1d$export$37e8e188eda774db = {
    index: (0, $c7lJu.format)($256f05e28b122d1d$var$admin.formatter, {}),
    hallOfFame: (0, $c7lJu.format)($256f05e28b122d1d$var$adminHallOfFame.formatter, {})
};
function $256f05e28b122d1d$var$p(match) {
    return match.then((0, $kwhzj.end)).parser;
}

});


parcelRegister("hnBhT", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $fd05cb003083a587$export$a6c7ac8248d6e38a; });
/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $9xM77 = parcelRequire("9xM77");

var $jK7ok = parcelRequire("jK7ok");
const $fd05cb003083a587$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ to: to, onClick: onClick_, disabled: disabled = false, className: className, children: children }, ref)=>{
    const { navigate: navigate } = (0, $9xM77.useHistory)();
    const onClick = (0, $bh6RR.useCallback)((e)=>{
        if (disabled) e.preventDefault();
        else {
            onClick_?.(e);
            if (!e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                navigate(to);
            }
        }
    }, [
        disabled,
        navigate,
        onClick_,
        to
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("a", {
        ref: ref,
        href: to,
        onClick: onClick,
        className: (0, $jK7ok.cx)([
            'cursor-default',
            disabled
        ], className),
        children: children
    });
});

});

parcelRegister("3KgVG", function(module, exports) {

$parcel$export(module.exports, "MaskedImage", function () { return $a0552a23a7404609$export$defc10abee3e0fb8; });

var $ih19M = parcelRequire("ih19M");

var $jK7ok = parcelRequire("jK7ok");
const $a0552a23a7404609$export$defc10abee3e0fb8 = ({ src: src, className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: (0, $jK7ok.cx)('block bg-current', className),
        style: {
            maskImage: `url(${src})`,
            WebkitMaskImage: `url(${src})`,
            maskSize: '100% 100%, contain',
            WebkitMaskSize: '100% 100%, contain'
        }
    });

});

parcelRegister("es0HS", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $716489ef3a21dc08$export$28c660c63b792dea; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $1GV7y = parcelRequire("1GV7y");

var $sjwE0 = parcelRequire("sjwE0");

var $acRx0 = parcelRequire("acRx0");

var $gwlG1 = parcelRequire("gwlG1");

var $jK7ok = parcelRequire("jK7ok");
const $716489ef3a21dc08$var$tooltipLayerId = 'tooltip-layer';
const $716489ef3a21dc08$var$tooltipLayer = document.getElementById($716489ef3a21dc08$var$tooltipLayerId);
if ($716489ef3a21dc08$var$tooltipLayer === null) // eslint-disable-next-line functional/no-throw-statements
throw Error(`Tooltip layer not found: #${$716489ef3a21dc08$var$tooltipLayerId}`);
const $716489ef3a21dc08$export$28c660c63b792dea = ({ hoverRef: hoverRef_, placementRef: maybePlacementRef, openedDuration: openedDuration = (0, $1GV7y.MsDuration).seconds(3), placement: placement = 'bottom', alwaysVisible: alwaysVisible = false, shouldHide: shouldHide, className: className, children: children })=>{
    const hoverRefs_ = $716489ef3a21dc08$var$isArray(hoverRef_) ? hoverRef_ : (0, $sjwE0.NonEmptyArray).of(hoverRef_);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const hoverRefs = (0, $bh6RR.useMemo)(()=>hoverRefs_, hoverRefs_);
    const placementRef_ = maybePlacementRef ?? (0, $sjwE0.NonEmptyArray).head(hoverRefs);
    const [shouldDisplay_, setShouldDisplay_] = (0, $bh6RR.useState)(false);
    const tooltipRef = (0, $bh6RR.useRef)(null);
    const arrowRef = (0, $bh6RR.useRef)(null);
    const shouldDisplay = alwaysVisible || shouldDisplay_;
    const [eventListenersEnabled, setEventListenersEnabled] = (0, $bh6RR.useState)(false);
    const options = (0, $bh6RR.useMemo)(()=>({
            placement: placement,
            modifiers: [
                {
                    name: 'arrow',
                    options: {
                        element: arrowRef.current
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            7
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 8
                    }
                },
                {
                    name: 'flip',
                    options: {
                        padding: 8
                    }
                },
                {
                    name: 'eventListeners',
                    enabled: eventListenersEnabled
                }
            ]
        }), [
        eventListenersEnabled,
        placement
    ]);
    const { styles: styles, attributes: attributes } = (0, $acRx0.useVisiblePopper)(shouldDisplay, placementRef_.current, tooltipRef.current, options);
    const timer = (0, $bh6RR.useRef)();
    const hideTooltip = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(timer.current);
        setEventListenersEnabled(false);
        setShouldDisplay_(false);
    }, []);
    // Calls `hideTooltip` when changed to `true`
    (0, $bh6RR.useEffect)(()=>{
        if (shouldHide === true) hideTooltip();
    }, [
        hideTooltip,
        shouldHide
    ]);
    /**
   * Function that adds 'click' and 'mouseover/mouseleave' event listeners on 'hoverRef'.
   * Those listeners will mutate `shouldDisplayRef` inner value to control whether or not the tooltip should be displayed.
   */ const setupHoverClickListeners = (0, $bh6RR.useCallback)(()=>{
        const hovers = hoverRefs.map((r)=>r.current);
        function showTooltip() {
            if (hovers.every((h)=>h === null)) return;
            window.clearTimeout(timer.current);
            setEventListenersEnabled(true);
            setShouldDisplay_(true);
        }
        function clickTooltip() {
            showTooltip();
            // And hide it afterwards.
            // eslint-disable-next-line functional/immutable-data
            timer.current = window.setTimeout(()=>{
                hideTooltip();
            }, (0, $1GV7y.MsDuration).unwrap(openedDuration));
        }
        hovers.forEach((hover)=>{
            if (hover === null) return;
            // React to hover in / out for desktop users.
            hover.addEventListener('mouseover', showTooltip, true);
            hover.addEventListener('mouseleave', hideTooltip, true);
            // React to click / tap for tablet users.
            hover.addEventListener('click', clickTooltip, true);
        });
        return ()=>{
            window.clearTimeout(timer.current);
            hovers.forEach((hover)=>{
                if (hover === null) return;
                hover.removeEventListener('click', clickTooltip, true);
                hover.removeEventListener('mouseover', showTooltip, true);
                hover.removeEventListener('mouseleave', hideTooltip, true);
            });
        };
    }, [
        hideTooltip,
        hoverRefs,
        openedDuration
    ]);
    // Set hover / click listeners to display or hide the tooltip.
    (0, $bh6RR.useEffect)(setupHoverClickListeners, [
        setupHoverClickListeners
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $6afFj.createPortal)(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            ref: tooltipRef,
            className: (0, $jK7ok.cx)('group z-40 whitespace-nowrap border border-tooltip bg-zinc-900 px-2 py-1 text-sm text-wheat shadow-even shadow-black transition-opacity duration-300', shouldDisplay ? 'visible opacity-100' : 'invisible opacity-0', className),
            style: styles['popper'],
            ...attributes['popper'],
            children: [
                children,
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    ref: arrowRef,
                    className: "h-1.5 w-2.5 group-data-popper-top:-bottom-1.5 group-data-popper-bottom:-top-1.5 group-data-popper-left:-right-2 group-data-popper-right:-left-2",
                    style: styles['arrow'],
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CaretUpSharpCropped), {
                        className: (0, $jK7ok.cx)('text-tooltip group-data-popper-top:rotate-180', {
                            'group-data-popper-bottom:rotate-0': placement.startsWith('top'),
                            'group-data-popper-left:rotate-90 group-data-popper-right:-rotate-90': placement.startsWith('right') || placement.startsWith('left')
                        })
                    })
                })
            ]
        }), $716489ef3a21dc08$var$tooltipLayer)
    });
};
const $716489ef3a21dc08$var$isArray = Array.isArray;

});
parcelRegister("acRx0", function(module, exports) {

$parcel$export(module.exports, "useVisiblePopper", function () { return $fdec0a1ecc551870$export$7fa6200c0c44eb2e; });
/* eslint-disable functional/no-expression-statements */ 
var $bh6RR = parcelRequire("bh6RR");

var $jsttU = parcelRequire("jsttU");
function $fdec0a1ecc551870$export$7fa6200c0c44eb2e(isVisible, referenceElement, popperElement, options) {
    const result = (0, $jsttU.usePopper)(referenceElement, popperElement, options);
    const { update: update } = result;
    (0, $bh6RR.useEffect)(()=>{
        if (isVisible) update?.();
    }, [
        isVisible,
        update
    ]);
    return result;
}

});
parcelRegister("jsttU", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $e2a7803dce6e03b8$export$f4d5bf230a36dd6e; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $fZq58 = parcelRequire("fZq58");

var $4y4jn = parcelRequire("4y4jn");

var $kbbqr = parcelRequire("kbbqr");
var $e2a7803dce6e03b8$var$EMPTY_MODIFIERS = [];
var $e2a7803dce6e03b8$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $bh6RR.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $e2a7803dce6e03b8$var$EMPTY_MODIFIERS
    };
    var _React$useState = $bh6RR.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $bh6RR.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $6afFj.flushSync(function() {
                    setState({
                        styles: (0, $kbbqr.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $kbbqr.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $bh6RR.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $bh6RR.useRef();
    (0, $kbbqr.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $kbbqr.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $fZq58.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("fZq58", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9; });

var $fTJao = parcelRequire("fTJao");

var $745n9 = parcelRequire("745n9");

var $4mt2C = parcelRequire("4mt2C");

var $2SszJ = parcelRequire("2SszJ");

var $5KdgE = parcelRequire("5KdgE");

var $eqE9J = parcelRequire("eqE9J");

var $5QuYB = parcelRequire("5QuYB");

var $fVANH = parcelRequire("fVANH");

var $7HVwH = parcelRequire("7HVwH");

var $9bSGP = parcelRequire("9bSGP");


var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $745n9.default),
    (0, $4mt2C.default),
    (0, $2SszJ.default),
    (0, $5KdgE.default),
    (0, $eqE9J.default),
    (0, $5QuYB.default),
    (0, $fVANH.default),
    (0, $7HVwH.default),
    (0, $9bSGP.default)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fTJao.popperGenerator)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fTJao", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $b92f073993d3fb52$export$ed5e13716264f202; });

var $2HKsI = parcelRequire("2HKsI");

var $7oVdA = parcelRequire("7oVdA");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $2J8Wv = parcelRequire("2J8Wv");

var $1hlpY = parcelRequire("1hlpY");

var $jvpLE = parcelRequire("jvpLE");


var $1c9xk = parcelRequire("1c9xk");
var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1c9xk.isElement)(reference) ? (0, $iJYQU.default)(reference) : reference.contextElement ? (0, $iJYQU.default)(reference.contextElement) : [],
                    popper: (0, $iJYQU.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2J8Wv.default)((0, $jvpLE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2HKsI.default)(reference, (0, $aI24A.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $7oVdA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1hlpY.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("2HKsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f83a3590a58ca81$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $arVrm = parcelRequire("arVrm");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");

var $2vFiA = parcelRequire("2vFiA");

var $oVXMR = parcelRequire("oVXMR");

var $juuAX = parcelRequire("juuAX");

var $cQirN = parcelRequire("cQirN");
function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cQirN.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cQirN.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1c9xk.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1c9xk.isHTMLElement)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $oVXMR.default)(offsetParent);
    var rect = (0, $bsh7Q.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $a72Qo.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $juuAX.default)(documentElement)) scroll = (0, $arVrm.default)(offsetParent);
        if ((0, $1c9xk.isHTMLElement)(offsetParent)) {
            offsets = (0, $bsh7Q.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2vFiA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bsh7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $856f97fdf7a31786$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");

var $cQirN = parcelRequire("cQirN");

var $fWtCY = parcelRequire("fWtCY");

var $f2h41 = parcelRequire("f2h41");
function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1c9xk.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cQirN.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cQirN.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1c9xk.isElement)(element) ? (0, $fWtCY.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f2h41.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("1c9xk", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $0dee4f2dddb22277$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0dee4f2dddb22277$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0dee4f2dddb22277$export$af51f0f06c0f328a; });

var $fWtCY = parcelRequire("fWtCY");
function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWtCY.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWtCY.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWtCY.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWtCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b3413274c87e21$export$2e2bcd8739ae039; });
function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("cQirN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9598a69d154bbd1e$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9598a69d154bbd1e$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9598a69d154bbd1e$export$2077e0241d6afd3c; });
var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("f2h41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af244778ac85956c$export$2e2bcd8739ae039; });

var $eFBAH = parcelRequire("eFBAH");
function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eFBAH.default)());
}

});
parcelRegister("eFBAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae20dd24c8de568$export$2e2bcd8739ae039; });
function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("arVrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f698b37b56f293$export$2e2bcd8739ae039; });

var $6uoC5 = parcelRequire("6uoC5");

var $fWtCY = parcelRequire("fWtCY");

var $1c9xk = parcelRequire("1c9xk");

var $ea8tK = parcelRequire("ea8tK");
function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWtCY.default)(node) || !(0, $1c9xk.isHTMLElement)(node)) return (0, $6uoC5.default)(node);
    else return (0, $ea8tK.default)(node);
}

});
parcelRegister("6uoC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b98a3172bacf8ec$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $fWtCY.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ea8tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4f89398deb81d5a$export$2e2bcd8739ae039; });
function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("a72Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ccc39d2a806d7f$export$2e2bcd8739ae039; });
function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2vFiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d3e8317bca2b13b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $oVXMR = parcelRequire("oVXMR");

var $6uoC5 = parcelRequire("6uoC5");
function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bsh7Q.default)((0, $oVXMR.default)(element)).left + (0, $6uoC5.default)(element).scrollLeft;
}

});
parcelRegister("oVXMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04af344fb3b2461e$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1c9xk.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("juuAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3088d3b293d3951$export$2e2bcd8739ae039; });

var $2L33g = parcelRequire("2L33g");
function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2L33g.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("2L33g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202256889fb084f4$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $fWtCY.default)(element).getComputedStyle(element);
}

});



parcelRegister("7oVdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563728a12da0f86b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");
function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bsh7Q.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("iJYQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4ba1ff29e25ddd$export$2e2bcd8739ae039; });

var $l4kGm = parcelRequire("l4kGm");

var $aSiof = parcelRequire("aSiof");

var $fWtCY = parcelRequire("fWtCY");

var $juuAX = parcelRequire("juuAX");
function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $l4kGm.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWtCY.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $juuAX.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $aSiof.default)(target)));
}

});
parcelRegister("l4kGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f56a03bea423dc7d$export$2e2bcd8739ae039; });

var $aSiof = parcelRequire("aSiof");

var $juuAX = parcelRequire("juuAX");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $a72Qo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1c9xk.isHTMLElement)(node) && (0, $juuAX.default)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $aSiof.default)(node));
}

});
parcelRegister("aSiof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ead366da1fe435a$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $oVXMR = parcelRequire("oVXMR");

var $1c9xk = parcelRequire("1c9xk");
function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $a72Qo.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1c9xk.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $oVXMR.default)(element) // fallback
    );
}

});



parcelRegister("aI24A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cbf9f1a43b4b54b$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $a72Qo = parcelRequire("a72Qo");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bJ3lS = parcelRequire("bJ3lS");

var $aSiof = parcelRequire("aSiof");

var $eFBAH = parcelRequire("eFBAH");
function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $1c9xk.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2L33g.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eFBAH.default)());
    var isIE = /Trident/i.test((0, $eFBAH.default)());
    if (isIE && (0, $1c9xk.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2L33g.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aSiof.default)(element);
    if ((0, $1c9xk.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1c9xk.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $a72Qo.default)(currentNode)) < 0){
        var css = (0, $2L33g.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $fWtCY.default)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bJ3lS.default)(offsetParent) && (0, $2L33g.default)(offsetParent).position === 'static')offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $a72Qo.default)(offsetParent) === 'html' || (0, $a72Qo.default)(offsetParent) === 'body' && (0, $2L33g.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}

});
parcelRegister("bJ3lS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88967f4bf6e216d4$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");
function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $a72Qo.default)(element)) >= 0;
}

});


parcelRegister("2J8Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc6b88d850995f4$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");
function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $5juCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5juCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $3de679e4868fd918$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $3de679e4868fd918$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $3de679e4868fd918$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $3de679e4868fd918$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $3de679e4868fd918$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $3de679e4868fd918$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $3de679e4868fd918$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $3de679e4868fd918$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $3de679e4868fd918$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $3de679e4868fd918$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $3de679e4868fd918$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $3de679e4868fd918$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $3de679e4868fd918$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $3de679e4868fd918$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $3de679e4868fd918$export$d087d3878fdf71d5; });
var $3de679e4868fd918$export$1e95b668f3b82d = 'top';
var $3de679e4868fd918$export$40e543e69a8b3fbb = 'bottom';
var $3de679e4868fd918$export$79ffe56a765070d2 = 'right';
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = 'left';
var $3de679e4868fd918$export$dfb5619354ba860 = 'auto';
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = 'start';
var $3de679e4868fd918$export$bd5df0f255a350f8 = 'end';
var $3de679e4868fd918$export$390fd549c5303b4d = 'clippingParents';
var $3de679e4868fd918$export$d7b7311ec04a3e8f = 'viewport';
var $3de679e4868fd918$export$ae5ab1c730825774 = 'popper';
var $3de679e4868fd918$export$ca50aac9f3ba507f = 'reference';
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = 'beforeRead';
var $3de679e4868fd918$export$aafa59e2e03f2942 = 'read';
var $3de679e4868fd918$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = 'beforeMain';
var $3de679e4868fd918$export$f22da7240b7add18 = 'main';
var $3de679e4868fd918$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3de679e4868fd918$export$68d8715fc104d294 = 'write';
var $3de679e4868fd918$export$70a6e5159acce2e6 = 'afterWrite';
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];

});


parcelRegister("1hlpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee7fe20308229e3$export$2e2bcd8739ae039; });
function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jvpLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e334e679a8da4fd2$export$2e2bcd8739ae039; });
function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("745n9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524d12f5e3f410b7$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWtCY.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};

});

parcelRegister("4mt2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32cfbe7d0e900a5d$export$2e2bcd8739ae039; });

var $h8FhS = parcelRequire("h8FhS");
function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $h8FhS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};

});
parcelRegister("h8FhS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a335ce8d6c7e22$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $5JvSi = parcelRequire("5JvSi");

var $5juCh = parcelRequire("5juCh");
function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7HOne.default)(placement) : null;
    var variation = placement ? (0, $a9b5p.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5juCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5juCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5juCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5juCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5JvSi.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5juCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5juCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("7HOne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c39fbf33d0fa38$export$2e2bcd8739ae039; });

function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("a9b5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763358296bc7f0da$export$2e2bcd8739ae039; });
function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("5JvSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c9e163adb38c23$export$2e2bcd8739ae039; });
function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("2SszJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2186ca614d1914c5$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $aI24A = parcelRequire("aI24A");

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $cQirN = parcelRequire("cQirN");
var $2186ca614d1914c5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cQirN.round)(x * dpr) / dpr || 0,
        y: (0, $cQirN.round)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5juCh.left);
    var sideY = (0, $5juCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aI24A.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWtCY.default)(popper)) {
            offsetParent = (0, $oVXMR.default)(popper);
            if ((0, $2L33g.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5juCh.top) || (placement === (0, $5juCh.left) || placement === (0, $5juCh.right)) && variation === (0, $5juCh.end)) {
            sideY = (0, $5juCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5juCh.left) || (placement === (0, $5juCh.top) || placement === (0, $5juCh.bottom)) && variation === (0, $5juCh.end)) {
            sideX = (0, $5juCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWtCY.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7HOne.default)(state.placement),
        variation: (0, $a9b5p.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};

});

parcelRegister("5KdgE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42eb8a49ca42db39$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("eqE9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812a48e30738572$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $5juCh = parcelRequire("5juCh");
function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7HOne.default)(placement);
    var invertDistance = [
        (0, $5juCh.left),
        (0, $5juCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5juCh.placements).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a812a48e30738572$var$offset
};

});

parcelRegister("5QuYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4419d659c5aee896$export$2e2bcd8739ae039; });

var $1rXBE = parcelRequire("1rXBE");

var $7HOne = parcelRequire("7HOne");

var $3PXal = parcelRequire("3PXal");

var $5uUmA = parcelRequire("5uUmA");

var $cPMZw = parcelRequire("cPMZw");

var $5juCh = parcelRequire("5juCh");

var $a9b5p = parcelRequire("a9b5p");
function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7HOne.default)(placement) === (0, $5juCh.auto)) return [];
    var oppositePlacement = (0, $1rXBE.default)(placement);
    return [
        (0, $3PXal.default)(placement),
        oppositePlacement,
        (0, $3PXal.default)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7HOne.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1rXBE.default)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7HOne.default)(placement) === (0, $5juCh.auto) ? (0, $cPMZw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7HOne.default)(placement);
        var isStartVariation = (0, $a9b5p.default)(placement) === (0, $5juCh.start);
        var isVertical = [
            (0, $5juCh.top),
            (0, $5juCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5juCh.right) : (0, $5juCh.left) : isStartVariation ? (0, $5juCh.bottom) : (0, $5juCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var altVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1rXBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e68ca32d71e128$export$2e2bcd8739ae039; });
var $10e68ca32d71e128$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}

});

parcelRegister("3PXal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb407a558844daa$export$2e2bcd8739ae039; });
var $2cb407a558844daa$var$hash = {
    start: 'end',
    end: 'start'
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}

});

parcelRegister("5uUmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400b79aa76081eef$export$2e2bcd8739ae039; });

var $i1jxU = parcelRequire("i1jxU");

var $oVXMR = parcelRequire("oVXMR");

var $bsh7Q = parcelRequire("bsh7Q");

var $h8FhS = parcelRequire("h8FhS");

var $jWjgS = parcelRequire("jWjgS");

var $5juCh = parcelRequire("5juCh");

var $1c9xk = parcelRequire("1c9xk");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");
function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5juCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5juCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5juCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cg2ZW.default)(typeof padding !== 'number' ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
    var altContext = elementContext === (0, $5juCh.popper) ? (0, $5juCh.reference) : (0, $5juCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $i1jxU.default)((0, $1c9xk.isElement)(element) ? element : element.contextElement || (0, $oVXMR.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bsh7Q.default)(state.elements.reference);
    var popperOffsets = (0, $h8FhS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $jWjgS.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5juCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5juCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5juCh.right),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5juCh.top),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("i1jxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e77b65493ae185$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $43VfI = parcelRequire("43VfI");

var $1xbC0 = parcelRequire("1xbC0");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bsh7Q = parcelRequire("bsh7Q");

var $aSiof = parcelRequire("aSiof");

var $jFWJP = parcelRequire("jFWJP");

var $a72Qo = parcelRequire("a72Qo");

var $jWjgS = parcelRequire("jWjgS");

var $cQirN = parcelRequire("cQirN");
function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bsh7Q.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5juCh.viewport) ? (0, $jWjgS.default)((0, $43VfI.default)(element, strategy)) : (0, $1c9xk.isElement)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jWjgS.default)((0, $1xbC0.default)((0, $oVXMR.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $iJYQU.default)((0, $aSiof.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $2L33g.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1c9xk.isHTMLElement)(element) ? (0, $aI24A.default)(element) : element;
    if (!(0, $1c9xk.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1c9xk.isElement)(clippingParent) && (0, $jFWJP.default)(clippingParent, clipperElement) && (0, $a72Qo.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cQirN.max)(rect.top, accRect.top);
        accRect.right = (0, $cQirN.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cQirN.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cQirN.max)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("43VfI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53da607b3746be$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2vFiA = parcelRequire("2vFiA");

var $f2h41 = parcelRequire("f2h41");
function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWtCY.default)(element);
    var html = (0, $oVXMR.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f2h41.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2vFiA.default)(element),
        y: y
    };
}

});

parcelRegister("1xbC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e1e16d619599d0$export$2e2bcd8739ae039; });

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $2vFiA = parcelRequire("2vFiA");

var $6uoC5 = parcelRequire("6uoC5");

var $cQirN = parcelRequire("cQirN");
function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $oVXMR.default)(element);
    var winScroll = (0, $6uoC5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cQirN.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cQirN.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2vFiA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2L33g.default)(body || html).direction === 'rtl') x += (0, $cQirN.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jFWJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52f68d10ea05d88$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1c9xk.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jWjgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e84261f8276e3310$export$2e2bcd8739ae039; });
function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cg2ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec94e005bd060d7$export$2e2bcd8739ae039; });

var $kGFu9 = parcelRequire("kGFu9");
function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kGFu9.default)(), paddingObject);
}

});
parcelRegister("kGFu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f7e8fd5f6df53a$export$2e2bcd8739ae039; });
function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("aSXwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039; });
function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cPMZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958040209c61c1c6$export$2e2bcd8739ae039; });

var $a9b5p = parcelRequire("a9b5p");

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");

var $7HOne = parcelRequire("7HOne");
function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5juCh.placements) : _options$allowedAutoP;
    var variation = (0, $a9b5p.default)(placement);
    var placements = variation ? flipVariations ? (0, $5juCh.variationPlacements) : (0, $5juCh.variationPlacements).filter(function(placement) {
        return (0, $a9b5p.default)(placement) === variation;
    }) : (0, $5juCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7HOne.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fVANH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b988b9b26e42e386$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $7HOne = parcelRequire("7HOne");

var $5JvSi = parcelRequire("5JvSi");

var $6Eqmz = parcelRequire("6Eqmz");

var $16lvl = parcelRequire("16lvl");

var $7oVdA = parcelRequire("7oVdA");

var $aI24A = parcelRequire("aI24A");

var $5uUmA = parcelRequire("5uUmA");

var $a9b5p = parcelRequire("a9b5p");

var $kGFu9 = parcelRequire("kGFu9");

var $cQirN = parcelRequire("cQirN");
function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5uUmA.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7HOne.default)(state.placement);
    var variation = (0, $a9b5p.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5JvSi.default)(basePlacement);
    var altAxis = (0, $6Eqmz.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $5juCh.top) : (0, $5juCh.left);
        var altSide = mainAxis === 'y' ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5juCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5juCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7oVdA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $kGFu9.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $16lvl.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aI24A.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $16lvl.within)(tether ? (0, $cQirN.min)(min, tetherMin) : min, offset, tether ? (0, $cQirN.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $5juCh.top) : (0, $5juCh.left);
        var _altSide = mainAxis === 'x' ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5juCh.top),
            (0, $5juCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $16lvl.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $16lvl.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("6Eqmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039; });
function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("16lvl", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $0cd708593435dba4$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $0cd708593435dba4$export$86c8af6d3ef0b4a; });

var $cQirN = parcelRequire("cQirN");
function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $cQirN.max)(min, (0, $cQirN.min)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("7HVwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c92c1fc46a893e$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $7oVdA = parcelRequire("7oVdA");

var $jFWJP = parcelRequire("jFWJP");

var $aI24A = parcelRequire("aI24A");

var $5JvSi = parcelRequire("5JvSi");

var $16lvl = parcelRequire("16lvl");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");

var $5juCh = parcelRequire("5juCh");
var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cg2ZW.default)(typeof padding !== 'number' ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7HOne.default)(state.placement);
    var axis = (0, $5JvSi.default)(basePlacement);
    var isVertical = [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7oVdA.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $5juCh.top) : (0, $5juCh.left);
    var maxProp = axis === 'y' ? (0, $5juCh.bottom) : (0, $5juCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aI24A.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $16lvl.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jFWJP.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("9bSGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b0f9068ca75a57d$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");
function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5juCh.top),
        (0, $5juCh.right),
        (0, $5juCh.bottom),
        (0, $5juCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5uUmA.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5uUmA.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $6b0f9068ca75a57d$var$hide
};

});


parcelRegister("4y4jn", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $34fdae974607be90$var$hasElementType = typeof Element !== 'undefined';
var $34fdae974607be90$var$hasMap = typeof Map === 'function';
var $34fdae974607be90$var$hasSet = typeof Set === 'function';
var $34fdae974607be90$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $34fdae974607be90$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$34fdae974607be90$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($34fdae974607be90$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$34fdae974607be90$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($34fdae974607be90$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($34fdae974607be90$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($34fdae974607be90$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$34fdae974607be90$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $34fdae974607be90$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("kbbqr", function(module, exports) {

$parcel$export(module.exports, "fromEntries", function () { return $eb0db29d4fc67c08$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $eb0db29d4fc67c08$export$700979bc83e7db82; });

var $bh6RR = parcelRequire("bh6RR");
var $eb0db29d4fc67c08$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $eb0db29d4fc67c08$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $eb0db29d4fc67c08$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $eb0db29d4fc67c08$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $eb0db29d4fc67c08$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $eb0db29d4fc67c08$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;

});




parcelRegister("aLUD6", function(module, exports) {

$parcel$export(module.exports, "AccountConnected", function () { return $02202627897b2534$export$88ae9c2acfee7576; });
/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $6omhk = parcelRequire("6omhk");

var $dc934 = parcelRequire("dc934");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $cbQQe = parcelRequire("cbQQe");

var $8zS1t = parcelRequire("8zS1t");

var $4o3f8 = parcelRequire("4o3f8");

var $fp7Nf = parcelRequire("fp7Nf");

var $fC0sb = parcelRequire("fC0sb");

var $sjwE0 = parcelRequire("sjwE0");

var $g7UIk = parcelRequire("g7UIk");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");

var $ixfeS = parcelRequire("ixfeS");

var $kiCtw = parcelRequire("kiCtw");

var $gL9kL = parcelRequire("gL9kL");

var $gE3ky = parcelRequire("gE3ky");

var $7VlB6 = parcelRequire("7VlB6");

var $8c35e = parcelRequire("8c35e");

var $hnBhT = parcelRequire("hnBhT");

var $fVW4p = parcelRequire("fVW4p");

var $gRZ9W = parcelRequire("gRZ9W");

var $i42fe = parcelRequire("i42fe");
const $02202627897b2534$export$88ae9c2acfee7576 = ({ user: user })=>{
    const { masteriesQuery: masteriesQuery } = (0, $9xM77.useHistory)();
    const { refreshUser: refreshUser } = (0, $j30iL.useUser)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const staticData = (0, $6H0K7.useStaticData)();
    const summonerMatch = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).platformRiotId);
    const summonerGameMatch = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).platformRiotIdGame);
    const [menuIsVisible, setMenuIsVisible] = (0, $bh6RR.useState)(false);
    const toggleMenu = (0, $bh6RR.useCallback)(()=>setMenuIsVisible((v)=>!v), []);
    const hideMenu = (0, $bh6RR.useCallback)(()=>setMenuIsVisible(false), []);
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const disconnect = (0, $bh6RR.useCallback)((e)=>{
        e.stopPropagation();
        setIsLoading(true);
        return (0, $f5id0.pipe)((0, $g7UIk.apiUserLogoutPost), (0, $sjwE0.Future).chain(()=>refreshUser), (0, $6omhk).chainFirstIOK(()=>()=>setIsLoading(false)), (0, $7VlB6.futureRunUnsafe));
    }, [
        refreshUser
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8c35e.ClickOutside), {
        onClickOutside: hideMenu,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "relative flex items-center gap-4 self-stretch py-2",
            children: [
                (0, $f5id0.pipe)(user.linkedRiotAccount, (0, $sjwE0.Maybe).fold(()=>null, ({ platform: platform, puuid: puuid, riotId: riotId, profileIconId: profileIconId })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gRZ9W.HighlightLink), {
                        to: (summonerGameMatch !== undefined ? (0, $gE3ky.appRoutes).sPlatformPuuidGame : (0, $gE3ky.appRoutes).sPlatformPuuid)(platform, puuid, summonerMatch !== undefined ? (0, $kiCtw.MasteriesQuery).toPartial({
                            ...masteriesQuery,
                            search: (0, $sjwE0.Maybe).none
                        }) : {}),
                        parser: $02202627897b2534$var$anyPlatformSummonerExact(platform, riotId),
                        tooltip: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex items-baseline gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex items-baseline gap-px",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "font-medium text-goldenrod",
                                            children: (0, $4o3f8.GameName).unwrap(riotId.gameName)
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                            className: "text-grey-500",
                                            children: [
                                                "#",
                                                (0, $fC0sb.TagLine).unwrap(riotId.tagLine)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: "\u2014"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: platform
                                })
                            ]
                        }),
                        className: "py-1.5",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: staticData.assets.summonerIcon(profileIconId),
                            alt: t.summonerIconAlt((0, $fp7Nf.RiotId).stringify(riotId)),
                            className: "w-7.5 shadow-even shadow-black"
                        })
                    }))),
                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    type: "button",
                    onClick: toggleMenu,
                    className: "flex items-center gap-3 py-2",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: user.userName
                    })
                }),
                menuIsVisible ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $i42fe.Menu), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                        className: "flex flex-col gap-0.5",
                        children: [
                            (0, $cbQQe.Permissions).canViewAdmin(user.role) ? /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                className: "flex justify-center pb-1",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                                    to: (0, $gL9kL.adminRoutes).index,
                                    className: "hover:underline",
                                    children: "ADMIN"
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                    type: "button",
                                    onClick: disconnect,
                                    disabled: isLoading,
                                    className: "flex items-center gap-2 bg-goldenrod px-4 py-1 text-black hover:bg-goldenrod/75 disabled:bg-grey-disabled",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            children: t.layout.logout
                                        }),
                                        isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                                            className: "h-4"
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
function $02202627897b2534$var$anyPlatformSummonerExact(platform, riotId) {
    return new (0, $dc934.Parser)((r)=>(0, $f5id0.pipe)((0, $gE3ky.appParsers).anyPlatformRiotId.run(r), (0, $sjwE0.Maybe).filter(([a])=>(0, $8zS1t.PlatformWithRiotId).Eq.equals(a, {
                platform: platform,
                riotId: riotId
            }))));
}

});
parcelRegister("cbQQe", function(module, exports) {

$parcel$export(module.exports, "Permissions", function () { return $06219b4a5c8d51cc$export$2d41982586bbb6be; });
const $06219b4a5c8d51cc$var$isAdmin = (role)=>role === 'admin';
const $06219b4a5c8d51cc$export$2d41982586bbb6be = {
    canViewDocErrors: $06219b4a5c8d51cc$var$isAdmin,
    canViewAdmin: $06219b4a5c8d51cc$var$isAdmin,
    canUpdateAdmin: $06219b4a5c8d51cc$var$isAdmin
};

});

parcelRegister("8zS1t", function(module, exports) {

$parcel$export(module.exports, "PlatformWithRiotId", function () { return $9d4f59841bf53f5b$export$49fdbe4951252161; });

var $kJAjV = parcelRequire("kJAjV");

var $fp7Nf = parcelRequire("fp7Nf");

var $ebDzf = parcelRequire("ebDzf");
const $9d4f59841bf53f5b$var$Eq = (0, $kJAjV).struct({
    platform: (0, $ebDzf.Platform).Eq,
    riotId: (0, $fp7Nf.RiotId).Eq
});
const $9d4f59841bf53f5b$export$49fdbe4951252161 = {
    Eq: $9d4f59841bf53f5b$var$Eq
};

});

parcelRegister("8c35e", function(module, exports) {

$parcel$export(module.exports, "ClickOutside", function () { return $9c347e33ed211d89$export$c16e4f034c84cb3f; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $bh6RR = parcelRequire("bh6RR");
const $9c347e33ed211d89$export$c16e4f034c84cb3f = ({ onClickOutside: onClickOutside, children: children })=>{
    const refs = (0, $bh6RR.Children).map(children, ()=>/*#__PURE__*/ (0, $bh6RR.createRef)());
    const handleClick = (0, $bh6RR.useCallback)((e)=>{
        const isOutside = refs.every((ref)=>ref.current !== null && !ref.current.contains(e.target));
        if (isOutside) onClickOutside(e);
    }, [
        onClickOutside,
        refs
    ]);
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener('click', handleClick);
        return ()=>document.removeEventListener('click', handleClick);
    }, [
        handleClick
    ]);
    return (0, $bh6RR.Children).map(children, (elt, idx)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        /*#__PURE__*/ (0, $bh6RR.cloneElement)(elt, {
            ref: refs[idx]
        }));
};

});

parcelRegister("gRZ9W", function(module, exports) {

$parcel$export(module.exports, "HighlightLink", function () { return $49b12704babb647e$export$4b17acbdf2e2629c; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ixfeS = parcelRequire("ixfeS");

var $jK7ok = parcelRequire("jK7ok");

var $hnBhT = parcelRequire("hnBhT");

var $es0HS = parcelRequire("es0HS");
function $49b12704babb647e$export$4b17acbdf2e2629c({ parser: parser, tooltip: tooltip, className: className, ...props }) {
    const ref = (0, $bh6RR.useRef)(null);
    const matches = (0, $ixfeS.usePathMatch)(parser) !== undefined;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                ref: ref,
                ...props,
                disabled: matches,
                className: (0, $jK7ok.cx)('flex border-y border-t-transparent font-medium', matches ? 'border-b-goldenrod-bis' : 'border-b-transparent', className)
            }),
            tooltip !== undefined ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                children: tooltip
            }) : null
        ]
    });
}

});

parcelRegister("i42fe", function(module, exports) {

$parcel$export(module.exports, "Menu", function () { return $a3acb2371841356e$export$d9b273488cd8ce6f; });

var $ih19M = parcelRequire("ih19M");

var $jK7ok = parcelRequire("jK7ok");
const $a3acb2371841356e$export$d9b273488cd8ce6f = ({ className: className, children: children })=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: (0, $jK7ok.cx)('absolute right-0 top-full z-10 flex flex-col gap-3 border border-goldenrod bg-zinc-900 px-5 py-4', className),
        children: children
    });

});


parcelRegister("iwgbI", function(module, exports) {

$parcel$export(module.exports, "AccountDisconnected", function () { return $113c75e30988a174$export$e60d2459e69ce6b9; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $4MEuc = parcelRequire("4MEuc");

var $gE3ky = parcelRequire("gE3ky");

var $8c35e = parcelRequire("8c35e");

var $hnBhT = parcelRequire("hnBhT");

var $i42fe = parcelRequire("i42fe");
const $113c75e30988a174$export$e60d2459e69ce6b9 = ()=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const [loginIsVisible, setLoginIsVisible] = (0, $bh6RR.useState)(false);
    const toggleLogin = (0, $bh6RR.useCallback)(()=>setLoginIsVisible((v)=>!v), []);
    const hideLogin = (0, $bh6RR.useCallback)(()=>setLoginIsVisible(false), []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8c35e.ClickOutside), {
        onClickOutside: hideLogin,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "relative flex items-center self-stretch py-2",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    type: "button",
                    onClick: toggleLogin,
                    className: "border border-goldenrod bg-black px-4 py-1 hover:bg-goldenrod/75 hover:text-black",
                    children: t.layout.account
                }),
                loginIsVisible ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $i42fe.Menu), {
                    className: "items-center",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                            to: (0, $gE3ky.appRoutes).login,
                            className: "bg-goldenrod px-4 py-1 text-black enabled:hover:bg-goldenrod/75",
                            children: t.layout.login
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                                to: (0, $gE3ky.appRoutes).register,
                                className: "underline",
                                children: t.layout.register
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
};

});

parcelRegister("gSWvX", function(module, exports) {

$parcel$export(module.exports, "Languages", function () { return $b5e96c85b19af74d$export$3db4614a73ea75e3; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ewM3A = parcelRequire("ewM3A");

var $4MEuc = parcelRequire("4MEuc");

var $av0oH = parcelRequire("av0oH");

var $gwlG1 = parcelRequire("gwlG1");

var $chVfZ = parcelRequire("chVfZ");

var $jK7ok = parcelRequire("jK7ok");

var $8c35e = parcelRequire("8c35e");
const $b5e96c85b19af74d$export$3db4614a73ea75e3 = ()=>{
    const [languagesIsVisible, setLanguagesIsVisible] = (0, $bh6RR.useState)(false);
    const toggleLanguages = (0, $bh6RR.useCallback)(()=>setLanguagesIsVisible((v)=>!v), []);
    const hideLanguages = (0, $bh6RR.useCallback)(()=>setLanguagesIsVisible(false), []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8c35e.ClickOutside), {
        onClickOutside: hideLanguages,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "relative flex items-center self-stretch py-2",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    type: "button",
                    onClick: toggleLanguages,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.LanguageOutline), {
                        className: "h-5"
                    })
                }),
                languagesIsVisible ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "absolute right-[calc(1px_-_0.75rem)] top-full z-10 flex flex-col border border-goldenrod bg-zinc-900",
                    children: (0, $ewM3A.Lang).values.map((l)=>/*#__PURE__*/ (0, $ih19M.jsx)($b5e96c85b19af74d$var$LangButton, {
                            l: l
                        }, l))
                }) : null
            ]
        })
    });
};
const $b5e96c85b19af74d$var$LangButton = ({ l: l })=>{
    const { lang: lang, setLang: setLang } = (0, $4MEuc.useTranslation)();
    const handleClick = (0, $bh6RR.useCallback)(()=>setLang(l), [
        l,
        setLang
    ]);
    const isSelected = (0, $ewM3A.Lang).Eq.equals(l, lang);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        type: "button",
        disabled: isSelected,
        onClick: handleClick,
        className: (0, $jK7ok.cx)('group flex items-center justify-between gap-3.5 py-1.5 pl-4 pr-2', {
            'bg-zinc-700': isSelected
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: (0, $jK7ok.cx)('border-y border-y-transparent leading-4', {
                    'group-hover:border-b-goldenrod': !isSelected
                }),
                children: (0, $chVfZ.TranslationUtils).labels.lang[l]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "flex",
                children: $b5e96c85b19af74d$var$langEmoji[l]
            })
        ]
    });
};
const $b5e96c85b19af74d$var$langEmoji = {
    en_GB: /*#__PURE__*/ (0, $ih19M.jsx)((0, $av0oH.EmojiFlagGb), {
        className: "!h-6"
    }),
    fr_FR: /*#__PURE__*/ (0, $ih19M.jsx)((0, $av0oH.EmojiFlagFr), {
        className: "!h-6"
    })
};

});
parcelRegister("av0oH", function(module, exports) {

$parcel$export(module.exports, "EmojiFlagFr", function () { return $7f5ec0f168ab3bcc$export$c5993bc0065ea587; });
$parcel$export(module.exports, "EmojiFlagGb", function () { return $7f5ec0f168ab3bcc$export$b1b9b3b5c509404; });
$parcel$export(module.exports, "EmojiUpsideDown", function () { return $7f5ec0f168ab3bcc$export$c88907166fcd10ab; });

var $ih19M = parcelRequire("ih19M");

var $jK7ok = parcelRequire("jK7ok");
const $7f5ec0f168ab3bcc$var$baseClassName = 'h-[1em] inline';
const $7f5ec0f168ab3bcc$export$f690ff38f558e05d = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72 72",
        className: (0, $jK7ok.cx)($7f5ec0f168ab3bcc$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "#f1b31c"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "#d22f27",
                d: "M23,33v7a2.0059,2.0059,0,0,1-2,2H17a2.0059,2.0059,0,0,1-2-2V33"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "9",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "46",
                width: "62",
                height: "9",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "19",
                y: "33",
                width: "4",
                height: "4",
                fill: "#f1b31c"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "19",
                cy: "37",
                r: "1.5",
                fill: "#6a462f"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                x1: "27",
                x2: "27",
                y1: "33",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                x1: "11",
                x2: "11",
                y1: "33",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M15,30a8.5678,8.5678,0,0,1,4-1"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M23,30a8.5678,8.5678,0,0,0-4-1"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                x1: "15",
                x2: "23",
                y1: "33",
                y2: "33",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M23,33v7a2.0059,2.0059,0,0,1-2,2H17a2.0059,2.0059,0,0,1-2-2V33"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                x1: "10",
                x2: "12",
                y1: "42",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                x1: "26",
                x2: "28",
                y1: "42",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
const $7f5ec0f168ab3bcc$export$c5993bc0065ea587 = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72 72",
        className: (0, $jK7ok.cx)($7f5ec0f168ab3bcc$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "21",
                height: "38",
                fill: "#1e50a0"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "46",
                y: "17",
                width: "21",
                height: "38",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
const $7f5ec0f168ab3bcc$export$b1b9b3b5c509404 = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72 72",
        className: (0, $jK7ok.cx)($7f5ec0f168ab3bcc$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "#1e50a0"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#fff",
                points: "40 28.856 40 32 50.181 32 67 21.691 67 17 59.346 17 40 28.856"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#d22f27",
                points: "67 17 67 17 63.173 17 40 31.203 40 32 43.482 32 67 17.586 67 17"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#fff",
                points: "59.347 55 67 55 67 55 67 50.308 50.182 40 40 40 40 43.143 59.347 55"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#d22f27",
                points: "67 55 67 52.653 46.355 40 41.568 40 66.042 55 67 55 67 55"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#fff",
                points: "32 43.144 32 40 21.819 40 5 50.309 5 55 12.654 55 32 43.144"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#d22f27",
                points: "5 55 5 55 8.827 55 32 40.797 32 40 28.518 40 5 54.414 5 55"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#fff",
                points: "12.653 17 5 17 5 17 5 21.692 21.818 32 32 32 32 28.857 12.653 17"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                fill: "#d22f27",
                points: "5 17 5 19.347 25.646 32 30.432 32 5.958 17 5 17 5 17"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "31",
                width: "62",
                height: "10",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "31",
                y: "17",
                width: "10",
                height: "38",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "33",
                width: "62",
                height: "6",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "33",
                y: "17",
                width: "6",
                height: "38",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
const $7f5ec0f168ab3bcc$export$c88907166fcd10ab = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "12 12 48 48",
        className: (0, $jK7ok.cx)($7f5ec0f168ab3bcc$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "36",
                cy: "36",
                r: "23",
                fill: "#FCEA2B"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "36",
                cy: "36",
                r: "23",
                fill: "none",
                stroke: "#000000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "none",
                stroke: "#000000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M26.1851,27.0707 c2.8995-1.6362,6.2482-2.5699,9.8149-2.5699s6.9153,0.9336,9.8149,2.5699"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M42,41c0-1.6568,1.3448-3,3-3c1.6553,0,3,1.3433,3,3c0,1.6552-1.3447,3-3,3C43.3448,44,42,42.6552,42,41"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M24,41c0-1.6568,1.3447-3,3-3s3,1.3433,3,3c0,1.6552-1.3447,3-3,3S24,42.6552,24,41"
            })
        ]
    });

});

parcelRegister("chVfZ", function(module, exports) {

$parcel$export(module.exports, "TranslationUtils", function () { return $0f7b1cc22b802e54$export$804272ad78c9493; });

var $f5id0 = parcelRequire("f5id0");

var $1GI82 = parcelRequire("1GI82");

var $8i6VY = parcelRequire("8i6VY");

var $6nJ5H = parcelRequire("6nJ5H");

var $sjwE0 = parcelRequire("sjwE0");
const { round: $0f7b1cc22b802e54$var$round } = (0, $6nJ5H.NumberUtils);
const $0f7b1cc22b802e54$var$langLabel = {
    en_GB: 'English',
    fr_FR: "Fran\xe7ais"
};
const $0f7b1cc22b802e54$var$challenge = (onNone, onSome)=>(challengeId)=>(0, $f5id0.pipe)((0, $8i6VY.ChallengesView).idEntries, (0, $sjwE0.List).findFirst(([, id])=>(0, $1GI82.ChallengeId).Eq.equals(id, challengeId)), (0, $sjwE0.Maybe).fold(()=>onNone(challengeId), (0, $f5id0.flow)((0, $sjwE0.Tuple).fst, onSome)));
const $0f7b1cc22b802e54$var$numberUnit = (t)=>(pts)=>{
        if (1000000 <= pts) return t.numberM($0f7b1cc22b802e54$var$round(pts / 1000000, 1));
        if (1000 <= pts) return t.numberK($0f7b1cc22b802e54$var$round(pts / 1000, 1));
        return t.number(pts);
    };
const $0f7b1cc22b802e54$export$804272ad78c9493 = {
    labels: {
        lang: $0f7b1cc22b802e54$var$langLabel
    },
    challenge: $0f7b1cc22b802e54$var$challenge,
    numberUnit: $0f7b1cc22b802e54$var$numberUnit
};

});
parcelRegister("1GI82", function(module, exports) {

$parcel$export(module.exports, "ChallengeId", function () { return $50573b929fc8d63f$export$ed95df8e12a8d6d6; });

var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $50573b929fc8d63f$var$wrap, unwrap: $50573b929fc8d63f$var$unwrap } = (0, $1k68G.iso)();
const $50573b929fc8d63f$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $50573b929fc8d63f$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($50573b929fc8d63f$var$unwrap));
const $50573b929fc8d63f$export$ed95df8e12a8d6d6 = (0, $sjwE0.immutableAssign)($50573b929fc8d63f$var$wrap, {
    codec: $50573b929fc8d63f$var$codec,
    Eq: $50573b929fc8d63f$var$Eq
});

});

parcelRegister("8i6VY", function(module, exports) {

$parcel$export(module.exports, "ChallengesView", function () { return $5f9a800b6a9fe73b$export$f937a8a51add31a1; });

var $jPaL5 = parcelRequire("jPaL5");

var $895LH = parcelRequire("895LH");

var $sjwE0 = parcelRequire("sjwE0");

var $1GI82 = parcelRequire("1GI82");

var $8ZCb1 = parcelRequire("8ZCb1");
const $5f9a800b6a9fe73b$var$maybeChallengeCodec = (0, $sjwE0.Maybe).codec((0, $8ZCb1.ChallengeView).codec);
const $5f9a800b6a9fe73b$var$properties = {
    bandle: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    bilgewater: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    demacia: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    freljord: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    ionia: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    ixtal: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    noxus: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    piltover: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    shadowIsles: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    shurima: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    targon: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    void: $5f9a800b6a9fe73b$var$maybeChallengeCodec,
    zaun: $5f9a800b6a9fe73b$var$maybeChallengeCodec
};
const $5f9a800b6a9fe73b$var$codec = $jPaL5.struct($5f9a800b6a9fe73b$var$properties);
const $5f9a800b6a9fe73b$var$id = {
    bandle: (0, $1GI82.ChallengeId)(303501),
    bilgewater: (0, $1GI82.ChallengeId)(303502),
    demacia: (0, $1GI82.ChallengeId)(303503),
    freljord: (0, $1GI82.ChallengeId)(303504),
    ionia: (0, $1GI82.ChallengeId)(303505),
    ixtal: (0, $1GI82.ChallengeId)(303506),
    noxus: (0, $1GI82.ChallengeId)(303507),
    piltover: (0, $1GI82.ChallengeId)(303508),
    shadowIsles: (0, $1GI82.ChallengeId)(303509),
    shurima: (0, $1GI82.ChallengeId)(303510),
    targon: (0, $1GI82.ChallengeId)(303511),
    void: (0, $1GI82.ChallengeId)(303512),
    zaun: (0, $1GI82.ChallengeId)(303513)
};
const $5f9a800b6a9fe73b$var$idEntries = (0, $895LH.DictUtils).entries($5f9a800b6a9fe73b$var$id);
const $5f9a800b6a9fe73b$export$f937a8a51add31a1 = {
    id: $5f9a800b6a9fe73b$var$id,
    idEntries: $5f9a800b6a9fe73b$var$idEntries,
    codec: $5f9a800b6a9fe73b$var$codec
};

});
parcelRegister("8ZCb1", function(module, exports) {

$parcel$export(module.exports, "ChallengeView", function () { return $ec6f647b1bed037b$export$c2c09bafe967ecd8; });

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $5iN75 = parcelRequire("5iN75");
const $ec6f647b1bed037b$var$codec = $jPaL5.struct({
    level: (0, $sjwE0.Maybe).codec((0, $5iN75.LeagueTier).codec),
    value: $jPaL5.number
});
const $ec6f647b1bed037b$export$c2c09bafe967ecd8 = {
    codec: $ec6f647b1bed037b$var$codec
};

});
parcelRegister("5iN75", function(module, exports) {

$parcel$export(module.exports, "LeagueTier", function () { return $913e86d74df09b4c$export$9f1ee514706af278; });

var $j839F = parcelRequire("j839F");

var $sjwE0 = parcelRequire("sjwE0");
const $913e86d74df09b4c$export$a31d2d1626cc9f40 = (0, $j839F.createEnum)('IRON', 'BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'EMERALD', 'DIAMOND');
const $913e86d74df09b4c$export$668775a00367f28 = (0, $j839F.createEnum)('MASTER', 'GRANDMASTER', 'CHALLENGER');
const $913e86d74df09b4c$var$e = (0, $j839F.createEnum)(...$913e86d74df09b4c$export$a31d2d1626cc9f40.values, ...$913e86d74df09b4c$export$668775a00367f28.values);
const $913e86d74df09b4c$var$isApexTier = (tier)=>(0, $sjwE0.List).elem($913e86d74df09b4c$var$e.Eq)(tier, $913e86d74df09b4c$export$668775a00367f28.values);
const $913e86d74df09b4c$var$isRegularTier = (tier)=>(0, $sjwE0.List).elem($913e86d74df09b4c$var$e.Eq)(tier, $913e86d74df09b4c$export$a31d2d1626cc9f40.values);
const $913e86d74df09b4c$export$9f1ee514706af278 = {
    ...$913e86d74df09b4c$var$e,
    isApexTier: $913e86d74df09b4c$var$isApexTier,
    isRegularTier: $913e86d74df09b4c$var$isRegularTier
};

});



parcelRegister("6nJ5H", function(module, exports) {

$parcel$export(module.exports, "NumberUtils", function () { return $9779d96e9e6ecb61$export$231f628ed3e191f0; });

var $4x239 = parcelRequire("4x239");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");
const $9779d96e9e6ecb61$var$average = (ns)=>ns.length === 0 ? 0 : (0, $f5id0.pipe)(ns, (0, $4x239).concatAll((0, $10ZIc).MonoidSum)) / ns.length;
const $9779d96e9e6ecb61$var$round = (n, digits = 0)=>{
    const e = 10 ** digits;
    return e === 0 ? 0 : Math.round(n * e) / e;
};
/**
 * https://github.com/lodash/lodash/blob/master/clamp.js
 *
 * Clamps `n` within the inclusive `lower` and `upper` bounds.
 *
 * @param n The number to clamp.
 * @param lower The lower bound.
 * @param upper The upper bound.
 * @returns Returns the clamped number.
 * @example
 *
 * clamp(-10, -5, 5)
 * // => -5
 *
 * clamp(10, -5, 5)
 * // => 5
 */ const $9779d96e9e6ecb61$var$clamp = (n, lower, upper)=>{
    // eslint-disable-next-line functional/no-let
    let res = n;
    /* eslint-disable functional/no-expression-statements */ res = res <= upper ? res : upper;
    res = res >= lower ? res : lower;
    /* eslint-enable functional/no-expression-statements */ return res;
};
const $9779d96e9e6ecb61$export$231f628ed3e191f0 = {
    round: $9779d96e9e6ecb61$var$round,
    average: $9779d96e9e6ecb61$var$average,
    clamp: $9779d96e9e6ecb61$var$clamp
};

});



parcelRegister("MxrOL", function(module, exports) {

$parcel$export(module.exports, "SearchSummoner", function () { return $380ec3b3128d6125$export$ab1d845dde9a5149; });
/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $ebDzf = parcelRequire("ebDzf");

var $gl9GP = parcelRequire("gl9GP");

var $sjwE0 = parcelRequire("sjwE0");

var $9xM77 = parcelRequire("9xM77");

var $j30iL = parcelRequire("j30iL");

var $ixfeS = parcelRequire("ixfeS");

var $gwlG1 = parcelRequire("gwlG1");

var $kiCtw = parcelRequire("kiCtw");

var $jIcvJ = parcelRequire("jIcvJ");

var $gE3ky = parcelRequire("gE3ky");

var $jK7ok = parcelRequire("jK7ok");

var $8c35e = parcelRequire("8c35e");

var $bNf7M = parcelRequire("bNf7M");

var $ajq9p = parcelRequire("ajq9p");

var $cFpmW = parcelRequire("cFpmW");
const $380ec3b3128d6125$var$platformOptions = (0, $f5id0.pipe)((0, $ebDzf.Platform).values, (0, $sjwE0.List).map((0, $bNf7M.SelectOption)));
const $380ec3b3128d6125$export$ab1d845dde9a5149 = ()=>{
    const { navigate: navigate, masteriesQuery: masteriesQuery } = (0, $9xM77.useHistory)();
    const { maybeUser: maybeUser, recentSearches: recentSearches } = (0, $j30iL.useUser)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const close = (0, $bh6RR.useCallback)(()=>setIsOpen(false), []);
    const [platform, setPlatform] = (0, $bh6RR.useState)((0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).anyPlatform)?.platform ?? (0, $ebDzf.Platform).defaultPlatform);
    const summonerMatch = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).anyPlatformRiotId);
    const [summoner, setSummoner] = (0, $bh6RR.useState)(summonerMatch !== undefined ? (0, $sjwE0.Either).right(summonerMatch.riotId) : (0, $sjwE0.Either).left(''));
    (0, $bh6RR.useEffect)(()=>{
        if (summonerMatch !== undefined) setSummoner((0, $sjwE0.Either).right(summonerMatch.riotId));
    }, [
        summonerMatch
    ]);
    const handleFocus = (0, $bh6RR.useCallback)((e)=>{
        e.target.select();
        setIsOpen(true);
    }, []);
    const gameMatch = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).platformRiotIdGame);
    const handleSubmit = (0, $bh6RR.useCallback)((e)=>{
        e.preventDefault();
        if ((0, $sjwE0.Either).isRight(summoner)) navigate(gameMatch !== undefined ? (0, $gE3ky.appRoutes).platformRiotIdGame(platform, summoner.right) : (0, $gE3ky.appRoutes).platformRiotId(platform, summoner.right, (0, $kiCtw.MasteriesQuery).toPartial({
            ...masteriesQuery,
            search: (0, $sjwE0.Maybe).none
        })));
    }, [
        masteriesQuery,
        gameMatch,
        navigate,
        platform,
        summoner
    ]);
    const searches = (0, $sjwE0.List).compact([
        (0, $f5id0.pipe)(maybeUser, (0, $sjwE0.Maybe).chain((u)=>u.linkedRiotAccount), (0, $sjwE0.Maybe).map((s)=>// eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cFpmW.SummonerSearch), {
                type: "self",
                summoner: (0, $jIcvJ.PartialSummonerShort).fromSummonerShort(s)
            }))),
        (0, $f5id0.pipe)(maybeUser, (0, $sjwE0.Maybe).chain((u)=>(0, $sjwE0.NonEmptyArray).fromReadonlyArray(u.favoriteSearches)), (0, $sjwE0.Maybe).map((favoriteSearches)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                children: favoriteSearches.map((s)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $cFpmW.SummonerSearch), {
                        type: "favorite",
                        summoner: (0, $jIcvJ.PartialSummonerShort).fromSummonerShort(s)
                    }, (0, $gl9GP.Puuid).unwrap(s.puuid)))
            }))),
        (0, $f5id0.pipe)(recentSearches, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((recentSearches_)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                children: recentSearches_.map((s)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $cFpmW.SummonerSearch), {
                        type: "recent",
                        summoner: s
                    }, (0, $gl9GP.Puuid).unwrap(s.puuid)))
            })))
    ]);
    const showSearches = isOpen && (0, $sjwE0.List).isNonEmpty(searches);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "flex h-8 font-medium",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bNf7M.Select), {
                options: $380ec3b3128d6125$var$platformOptions,
                value: platform,
                onChange: setPlatform
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex gap-1 border border-goldenrod pr-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8c35e.ClickOutside), {
                        onClickOutside: close,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ajq9p.SearchSummonerInput), {
                                summoner: summoner,
                                setSummoner: setSummoner,
                                handleFocus: handleFocus
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                className: (0, $jK7ok.cx)('absolute top-full z-40 max-h-[calc(100vh_-_5rem)] min-w-84 items-center gap-y-3 overflow-auto border border-goldenrod bg-zinc-900 py-2', (0, $sjwE0.Maybe).isSome(maybeUser) ? 'grid-cols-[auto_auto_auto]' : 'grid-cols-[auto_1fr] pr-3', showSearches ? 'grid' : 'hidden'),
                                children: $380ec3b3128d6125$var$concatWithHr(searches)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        type: "submit",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.SearchOutline), {
                            className: "h-6 text-goldenrod"
                        })
                    })
                ]
            })
        ]
    });
};
function $380ec3b3128d6125$var$concatWithHr(es) {
    return (0, $f5id0.pipe)(es, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).fold(()=>null, (0, $sjwE0.NonEmptyArray).concatAll({
        concat: (x, y)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    x,
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "w-[calc(100%_-_1rem)] justify-self-end border-t border-goldenrod"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "border-t border-goldenrod"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "w-[calc(100%_-_1rem)] border-t border-goldenrod"
                    }),
                    y
                ]
            })
    })));
}

});
parcelRegister("bNf7M", function(module, exports) {

$parcel$export(module.exports, "SelectOption", function () { return $7e268f681232a632$export$11a8a1ea41bf55d8; });
$parcel$export(module.exports, "Select", function () { return $7e268f681232a632$export$ef9b1a59e592288f; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8FeGH = parcelRequire("8FeGH");

var $gwlG1 = parcelRequire("gwlG1");

var $jK7ok = parcelRequire("jK7ok");
function $7e268f681232a632$export$11a8a1ea41bf55d8(value, label = value) {
    return {
        value: value,
        label: label
    };
}
const $7e268f681232a632$var$ChevronForwardFilled = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.ChevronForwardFilled), {
        className: className
    });
function $7e268f681232a632$export$ef9b1a59e592288f({ options: options, value: value, onChange: onChange, className: className }) {
    const ref = (0, $bh6RR.useRef)(null);
    const menuIsOpenRef = (0, $bh6RR.useRef)(false);
    const handleChange = (0, $bh6RR.useCallback)((newValue)=>{
        if (newValue !== null) onChange(newValue.value);
    }, [
        onChange
    ]);
    const onMenuOpen = (0, $bh6RR.useCallback)(()=>{
        // eslint-disable-next-line functional/immutable-data
        menuIsOpenRef.current = true;
    }, []);
    const onMenuClose = (0, $bh6RR.useCallback)(()=>{
        // eslint-disable-next-line functional/immutable-data
        menuIsOpenRef.current = false;
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8FeGH.default), {
        ref: ref,
        options: options,
        value: $7e268f681232a632$export$11a8a1ea41bf55d8(value),
        onChange: handleChange,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        isSearchable: false,
        components: {
            IndicatorSeparator: null,
            DropdownIndicator: $7e268f681232a632$var$ChevronForwardFilled
        },
        className: className,
        styles: {
            control: (base)=>({
                    ...base,
                    minHeight: undefined,
                    backgroundColor: undefined,
                    borderRadius: undefined,
                    borderWidth: undefined,
                    borderColor: undefined,
                    '&:hover': undefined
                }),
            valueContainer: (base)=>({
                    ...base,
                    padding: undefined
                }),
            singleValue: (base)=>({
                    ...base,
                    marginRight: undefined,
                    marginLeft: undefined,
                    color: undefined
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    '& > svg': {
                        width: 16,
                        height: 16,
                        transform: menuIsOpenRef.current ? 'rotate(270deg)' : 'rotate(90deg)',
                        transition: 'transform 0.3s'
                    }
                }),
            menu: (base)=>({
                    ...base,
                    marginTop: undefined,
                    marginBottom: undefined,
                    backgroundColor: undefined,
                    borderRadius: undefined
                }),
            menuList: (base)=>({
                    ...base,
                    paddingTop: undefined,
                    paddingBottom: undefined
                }),
            option: (base)=>({
                    ...base,
                    padding: undefined,
                    backgroundColor: undefined,
                    color: undefined,
                    cursor: undefined
                })
        },
        classNames: {
            container: ()=>$7e268f681232a632$var$containerClassName,
            control: ()=>$7e268f681232a632$var$controlClassName,
            singleValue: ()=>$7e268f681232a632$var$singleValueClassName,
            menu: ()=>$7e268f681232a632$var$menuClassName,
            option: (p)=>(0, $jK7ok.cx)($7e268f681232a632$var$optionClassName, [
                    $7e268f681232a632$var$optionIsFocusedClassName,
                    p.isFocused
                ], p.isSelected ? $7e268f681232a632$var$optionIsSelectedClassName : $7e268f681232a632$var$optionNotSelectedClassName) ?? ''
        }
    });
}
const $7e268f681232a632$var$containerClassName = 'z-10';
const $7e268f681232a632$var$controlClassName = 'h-full pl-1.5 pr-1 gap-1 border-y border-l border-goldenrod';
const $7e268f681232a632$var$singleValueClassName = 'min-w-8';
const $7e268f681232a632$var$menuClassName = 'bg-zinc-700 rounded-b-md';
const $7e268f681232a632$var$optionClassName = 'py-0.75 px-1.5';
const $7e268f681232a632$var$optionIsFocusedClassName = 'bg-black';
const $7e268f681232a632$var$optionIsSelectedClassName = 'bg-goldenrod-bis';
const $7e268f681232a632$var$optionNotSelectedClassName = 'cursor-pointer hover:bg-black';

});
parcelRegister("8FeGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64ed8bba85887b71$export$2e2bcd8739ae039; });

var $4a1v4 = parcelRequire("4a1v4");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $fcq5W = parcelRequire("fcq5W");

var $hQwt8 = parcelRequire("hQwt8");

var $gbgGf = parcelRequire("gbgGf");

parcelRequire("4Ugt5");
parcelRequire("f0cZC");
parcelRequire("5ZFcU");
parcelRequire("bfbtb");
parcelRequire("kNrk6");
parcelRequire("ljhd4");
parcelRequire("5o7eN");
parcelRequire("cIAln");

parcelRequire("crtHL");
parcelRequire("b2LR8");
parcelRequire("jqdsN");
parcelRequire("6afFj");

parcelRequire("2ic0N");
var $64ed8bba85887b71$var$StateManagedSelect = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $4a1v4.u)(props);
    return /*#__PURE__*/ $bh6RR.createElement((0, $fcq5W.S), (0, $4WYaH.default)({
        ref: ref
    }, baseSelectProps));
});
var $64ed8bba85887b71$export$2e2bcd8739ae039 = $64ed8bba85887b71$var$StateManagedSelect;
var $64ed8bba85887b71$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $bh6RR.useMemo)(function() {
        return (0, $gbgGf.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $hQwt8.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("4a1v4", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $3079427ff38f46f7$export$3b14a55fb2447963; });

var $9UnxB = parcelRequire("9UnxB");

var $6oWCT = parcelRequire("6oWCT");

var $cSlhQ = parcelRequire("cSlhQ");

var $bh6RR = parcelRequire("bh6RR");
var $3079427ff38f46f7$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $3079427ff38f46f7$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $cSlhQ.default)(_ref, $3079427ff38f46f7$var$_excluded);
    var _useState = (0, $bh6RR.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $6oWCT.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $bh6RR.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $6oWCT.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $bh6RR.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $6oWCT.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $bh6RR.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $bh6RR.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $bh6RR.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $bh6RR.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $9UnxB.default)((0, $9UnxB.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("9UnxB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736b9ac59876ea24$export$2e2bcd8739ae039; });

var $2ryml = parcelRequire("2ryml");
function $736b9ac59876ea24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $736b9ac59876ea24$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $736b9ac59876ea24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2ryml.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $736b9ac59876ea24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("2ryml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c78c172f6af0e63$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $1c78c172f6af0e63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hTglg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("hTglg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0643fe154cb74c1$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $cMfNc = parcelRequire("cMfNc");
function $d0643fe154cb74c1$export$2e2bcd8739ae039(t) {
    var i = (0, $cMfNc.default)(t, "string");
    return "symbol" == (0, $51lpG.default)(i) ? i : i + "";
}

});
parcelRegister("51lpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7da7f4c81a8554$export$2e2bcd8739ae039; });
function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cMfNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94d637ce061dd3ca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");
function $94d637ce061dd3ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $51lpG.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $51lpG.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("6oWCT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a9275f4284d6709$export$2e2bcd8739ae039; });

var $klRdc = parcelRequire("klRdc");

var $jmtNi = parcelRequire("jmtNi");

var $9F6mQ = parcelRequire("9F6mQ");

var $1ZnLp = parcelRequire("1ZnLp");
function $4a9275f4284d6709$export$2e2bcd8739ae039(r, e) {
    return (0, $klRdc.default)(r) || (0, $jmtNi.default)(r, e) || (0, $9F6mQ.default)(r, e) || (0, $1ZnLp.default)();
}

});
parcelRegister("klRdc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed0f0b97866d6cfa$export$2e2bcd8739ae039; });
function $ed0f0b97866d6cfa$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("jmtNi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1872ee01ca16b60$export$2e2bcd8739ae039; });
function $e1872ee01ca16b60$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9F6mQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708ce1d4f20bd938$export$2e2bcd8739ae039; });

var $cnxX0 = parcelRequire("cnxX0");
function $708ce1d4f20bd938$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cnxX0.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cnxX0.default)(r, a) : void 0;
    }
}

});
parcelRegister("cnxX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9031f7f2924753e9$export$2e2bcd8739ae039; });
function $9031f7f2924753e9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1ZnLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $172debecf3a06e01$export$2e2bcd8739ae039; });
function $172debecf3a06e01$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cSlhQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95fb0a49c8a38020$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");
function $95fb0a49c8a38020$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hCIyK.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("fcq5W", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $b10c37de56d8c35c$export$25ce5a424b770e84; });

var $4WYaH = parcelRequire("4WYaH");

var $9UnxB = parcelRequire("9UnxB");

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $jX7qT = parcelRequire("jX7qT");

var $bh6RR = parcelRequire("bh6RR");

var $2jGpl = parcelRequire("2jGpl");

var $7hler = parcelRequire("7hler");

var $1XykX = parcelRequire("1XykX");

var $cSlhQ = parcelRequire("cSlhQ");
function $b10c37de56d8c35c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $b10c37de56d8c35c$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $b10c37de56d8c35c$var$A11yText = function A11yText(props) {
    return (0, $7hler.jsx)("span", (0, $4WYaH.default)({
        css: $b10c37de56d8c35c$var$_ref
    }, props));
};
var $b10c37de56d8c35c$var$A11yText$1 = $b10c37de56d8c35c$var$A11yText;
var $b10c37de56d8c35c$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $b10c37de56d8c35c$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $bh6RR.useMemo)(function() {
        return (0, $9UnxB.default)((0, $9UnxB.default)({}, $b10c37de56d8c35c$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $bh6RR.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $9UnxB.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $bh6RR.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $bh6RR.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $bh6RR.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $7hler.jsx)((0, $bh6RR.Fragment), null, (0, $7hler.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $7hler.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $7hler.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $7hler.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $7hler.jsx)((0, $bh6RR.Fragment), null, (0, $7hler.jsx)($b10c37de56d8c35c$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $7hler.jsx)($b10c37de56d8c35c$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $b10c37de56d8c35c$var$LiveRegion$1 = $b10c37de56d8c35c$var$LiveRegion;
var $b10c37de56d8c35c$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $b10c37de56d8c35c$var$anyDiacritic = new RegExp('[' + $b10c37de56d8c35c$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $b10c37de56d8c35c$var$diacriticToBase = {};
for(var $b10c37de56d8c35c$var$i = 0; $b10c37de56d8c35c$var$i < $b10c37de56d8c35c$var$diacritics.length; $b10c37de56d8c35c$var$i++){
    var $b10c37de56d8c35c$var$diacritic = $b10c37de56d8c35c$var$diacritics[$b10c37de56d8c35c$var$i];
    for(var $b10c37de56d8c35c$var$j = 0; $b10c37de56d8c35c$var$j < $b10c37de56d8c35c$var$diacritic.letters.length; $b10c37de56d8c35c$var$j++)$b10c37de56d8c35c$var$diacriticToBase[$b10c37de56d8c35c$var$diacritic.letters[$b10c37de56d8c35c$var$j]] = $b10c37de56d8c35c$var$diacritic.base;
}
var $b10c37de56d8c35c$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($b10c37de56d8c35c$var$anyDiacritic, function(match) {
        return $b10c37de56d8c35c$var$diacriticToBase[match];
    });
};
var $b10c37de56d8c35c$var$memoizedStripDiacriticsForInput = (0, $1XykX.default)($b10c37de56d8c35c$var$stripDiacritics);
var $b10c37de56d8c35c$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $b10c37de56d8c35c$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $b10c37de56d8c35c$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $9UnxB.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $b10c37de56d8c35c$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $b10c37de56d8c35c$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $b10c37de56d8c35c$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $b10c37de56d8c35c$var$memoizedStripDiacriticsForInput(input);
            candidate = $b10c37de56d8c35c$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $b10c37de56d8c35c$var$_excluded = [
    "innerRef"
];
function $b10c37de56d8c35c$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $cSlhQ.default)(_ref, $b10c37de56d8c35c$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $2jGpl.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $7hler.jsx)("input", (0, $4WYaH.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $7hler.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $b10c37de56d8c35c$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $b10c37de56d8c35c$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $bh6RR.useRef)(false);
    var isTop = (0, $bh6RR.useRef)(false);
    var touchStart = (0, $bh6RR.useRef)(0);
    var scrollTarget = (0, $bh6RR.useRef)(null);
    var handleEventDelta = (0, $bh6RR.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $b10c37de56d8c35c$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $bh6RR.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $bh6RR.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $bh6RR.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $bh6RR.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $2jGpl.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $bh6RR.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $b10c37de56d8c35c$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $b10c37de56d8c35c$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $b10c37de56d8c35c$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $b10c37de56d8c35c$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $b10c37de56d8c35c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $b10c37de56d8c35c$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $b10c37de56d8c35c$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $b10c37de56d8c35c$var$activeScrollLocks = 0;
var $b10c37de56d8c35c$var$listenerOptions = {
    capture: false,
    passive: false
};
function $b10c37de56d8c35c$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $bh6RR.useRef)({});
    var scrollTarget = (0, $bh6RR.useRef)(null);
    var addScrollLock = (0, $bh6RR.useCallback)(function(touchScrollTarget) {
        if (!$b10c37de56d8c35c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $b10c37de56d8c35c$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $b10c37de56d8c35c$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($b10c37de56d8c35c$var$LOCK_STYLES).forEach(function(key) {
                var val = $b10c37de56d8c35c$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $b10c37de56d8c35c$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $b10c37de56d8c35c$var$preventTouchMove, $b10c37de56d8c35c$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $b10c37de56d8c35c$var$preventInertiaScroll, $b10c37de56d8c35c$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $b10c37de56d8c35c$var$allowTouchMove, $b10c37de56d8c35c$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $b10c37de56d8c35c$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $bh6RR.useCallback)(function(touchScrollTarget) {
        if (!$b10c37de56d8c35c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $b10c37de56d8c35c$var$activeScrollLocks = Math.max($b10c37de56d8c35c$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $b10c37de56d8c35c$var$activeScrollLocks < 1) $b10c37de56d8c35c$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $b10c37de56d8c35c$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $b10c37de56d8c35c$var$preventTouchMove, $b10c37de56d8c35c$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $b10c37de56d8c35c$var$preventInertiaScroll, $b10c37de56d8c35c$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $b10c37de56d8c35c$var$allowTouchMove, $b10c37de56d8c35c$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $b10c37de56d8c35c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b10c37de56d8c35c$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $b10c37de56d8c35c$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $b10c37de56d8c35c$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $b10c37de56d8c35c$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $b10c37de56d8c35c$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $7hler.jsx)((0, $bh6RR.Fragment), null, lockEnabled && (0, $7hler.jsx)("div", {
        onClick: $b10c37de56d8c35c$var$blurSelectInput,
        css: $b10c37de56d8c35c$var$_ref2$1
    }), children(targetRef));
}
function $b10c37de56d8c35c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b10c37de56d8c35c$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $b10c37de56d8c35c$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $7hler.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $b10c37de56d8c35c$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $b10c37de56d8c35c$var$RequiredInput$1 = $b10c37de56d8c35c$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $b10c37de56d8c35c$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $b10c37de56d8c35c$var$isIPhone() {
    return $b10c37de56d8c35c$var$testPlatform(/^iPhone/i);
}
function $b10c37de56d8c35c$var$isMac() {
    return $b10c37de56d8c35c$var$testPlatform(/^Mac/i);
}
function $b10c37de56d8c35c$var$isIPad() {
    return $b10c37de56d8c35c$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b10c37de56d8c35c$var$isMac() && navigator.maxTouchPoints > 1;
}
function $b10c37de56d8c35c$var$isIOS() {
    return $b10c37de56d8c35c$var$isIPhone() || $b10c37de56d8c35c$var$isIPad();
}
function $b10c37de56d8c35c$var$isAppleDevice() {
    return $b10c37de56d8c35c$var$isMac() || $b10c37de56d8c35c$var$isIOS();
}
var $b10c37de56d8c35c$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $b10c37de56d8c35c$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $b10c37de56d8c35c$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $b10c37de56d8c35c$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $b10c37de56d8c35c$var$defaultStyles = {
    clearIndicator: (0, $2jGpl.a),
    container: (0, $2jGpl.b),
    control: (0, $2jGpl.d),
    dropdownIndicator: (0, $2jGpl.e),
    group: (0, $2jGpl.g),
    groupHeading: (0, $2jGpl.f),
    indicatorsContainer: (0, $2jGpl.i),
    indicatorSeparator: (0, $2jGpl.h),
    input: (0, $2jGpl.j),
    loadingIndicator: (0, $2jGpl.l),
    loadingMessage: (0, $2jGpl.k),
    menu: (0, $2jGpl.m),
    menuList: (0, $2jGpl.n),
    menuPortal: (0, $2jGpl.o),
    multiValue: (0, $2jGpl.p),
    multiValueLabel: (0, $2jGpl.q),
    multiValueRemove: (0, $2jGpl.t),
    noOptionsMessage: (0, $2jGpl.u),
    option: (0, $2jGpl.v),
    placeholder: (0, $2jGpl.w),
    singleValue: (0, $2jGpl.x),
    valueContainer: (0, $2jGpl.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $b10c37de56d8c35c$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $9UnxB.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $b10c37de56d8c35c$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $b10c37de56d8c35c$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $b10c37de56d8c35c$var$baseUnit = 4;
// The minimum height of the control
var $b10c37de56d8c35c$var$controlHeight = 38;
// The amount of space between the control and menu */
var $b10c37de56d8c35c$var$menuGutter = $b10c37de56d8c35c$var$baseUnit * 2;
var $b10c37de56d8c35c$var$spacing = {
    baseUnit: $b10c37de56d8c35c$var$baseUnit,
    controlHeight: $b10c37de56d8c35c$var$controlHeight,
    menuGutter: $b10c37de56d8c35c$var$menuGutter
};
var $b10c37de56d8c35c$export$4368d992c4eafac0 = {
    borderRadius: $b10c37de56d8c35c$var$borderRadius,
    colors: $b10c37de56d8c35c$var$colors,
    spacing: $b10c37de56d8c35c$var$spacing
};
var $b10c37de56d8c35c$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $2jGpl.z)(),
    captureMenuScroll: !(0, $2jGpl.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $b10c37de56d8c35c$export$db3b6bfb95261072(),
    formatGroupLabel: $b10c37de56d8c35c$var$formatGroupLabel,
    getOptionLabel: $b10c37de56d8c35c$export$8b22cf2602fb60ce,
    getOptionValue: $b10c37de56d8c35c$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $b10c37de56d8c35c$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $2jGpl.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $b10c37de56d8c35c$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $b10c37de56d8c35c$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $b10c37de56d8c35c$var$_isOptionSelected(props, option, selectValue);
    var label = $b10c37de56d8c35c$var$getOptionLabel(props, option);
    var value = $b10c37de56d8c35c$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $b10c37de56d8c35c$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $b10c37de56d8c35c$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $b10c37de56d8c35c$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $b10c37de56d8c35c$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $b10c37de56d8c35c$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $2jGpl.K));
}
function $b10c37de56d8c35c$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $jX7qT.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $b10c37de56d8c35c$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $jX7qT.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $b10c37de56d8c35c$var$buildFocusableOptions(props, selectValue) {
    return $b10c37de56d8c35c$var$buildFocusableOptionsFromCategorizedOptions($b10c37de56d8c35c$var$buildCategorizedOptions(props, selectValue));
}
function $b10c37de56d8c35c$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$b10c37de56d8c35c$var$shouldHideSelectedOptions(props) || !isSelected) && $b10c37de56d8c35c$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $b10c37de56d8c35c$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $b10c37de56d8c35c$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $b10c37de56d8c35c$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $b10c37de56d8c35c$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $b10c37de56d8c35c$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $b10c37de56d8c35c$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $b10c37de56d8c35c$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $b10c37de56d8c35c$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $b10c37de56d8c35c$var$getOptionValue(props, i) === candidate;
    });
}
function $b10c37de56d8c35c$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $b10c37de56d8c35c$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $b10c37de56d8c35c$var$instanceId = 1;
var $b10c37de56d8c35c$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $7uMzR.default)(Select, _Component);
    var _super = (0, $1JyKh.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $fivc7.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $b10c37de56d8c35c$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $2jGpl.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $2jGpl.B)([].concat((0, $jX7qT.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $2jGpl.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $2jGpl.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $2jGpl.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $2jGpl.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $2jGpl.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $b10c37de56d8c35c$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $b10c37de56d8c35c$var$buildFocusableOptionsWithIds($b10c37de56d8c35c$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $2jGpl.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $b10c37de56d8c35c$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $b10c37de56d8c35c$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $b10c37de56d8c35c$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $2jGpl.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $b10c37de56d8c35c$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $b10c37de56d8c35c$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $9UnxB.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $2jGpl.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $b10c37de56d8c35c$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$b10c37de56d8c35c$var$instanceId);
        _this.state.selectValue = (0, $2jGpl.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $b10c37de56d8c35c$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $kuNiL.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $2jGpl.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $2jGpl.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $b10c37de56d8c35c$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($b10c37de56d8c35c$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $9UnxB.default)((0, $9UnxB.default)({}, $b10c37de56d8c35c$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $b10c37de56d8c35c$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $b10c37de56d8c35c$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $b10c37de56d8c35c$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $9UnxB.default)((0, $9UnxB.default)((0, $9UnxB.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $bh6RR.createElement($b10c37de56d8c35c$var$DummyInput, (0, $4WYaH.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $2jGpl.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $bh6RR.createElement(Input, (0, $4WYaH.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $bh6RR.createElement(Placeholder, (0, $4WYaH.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $bh6RR.createElement(MultiValue, (0, $4WYaH.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $bh6RR.createElement(SingleValue, (0, $4WYaH.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $bh6RR.createElement(ClearIndicator, (0, $4WYaH.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $bh6RR.createElement(LoadingIndicator, (0, $4WYaH.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $bh6RR.createElement(IndicatorSeparator, (0, $4WYaH.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $bh6RR.createElement(DropdownIndicator, (0, $4WYaH.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $bh6RR.createElement(Option, (0, $4WYaH.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $bh6RR.createElement(Group, (0, $4WYaH.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $bh6RR.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $bh6RR.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $bh6RR.createElement((0, $2jGpl.M), (0, $4WYaH.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $bh6RR.createElement(Menu, (0, $4WYaH.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $bh6RR.createElement($b10c37de56d8c35c$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $bh6RR.createElement(MenuList, (0, $4WYaH.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $bh6RR.createElement(MenuPortal, (0, $4WYaH.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $bh6RR.createElement($b10c37de56d8c35c$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $bh6RR.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $bh6RR.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $bh6RR.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $bh6RR.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $bh6RR.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $bh6RR.createElement($b10c37de56d8c35c$var$LiveRegion$1, (0, $4WYaH.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $bh6RR.createElement(SelectContainer, (0, $4WYaH.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $bh6RR.createElement(Control, (0, $4WYaH.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $bh6RR.createElement(ValueContainer, (0, $4WYaH.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $bh6RR.createElement(IndicatorsContainer, (0, $4WYaH.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $2jGpl.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $b10c37de56d8c35c$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $b10c37de56d8c35c$var$buildFocusableOptionsWithIds($b10c37de56d8c35c$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $b10c37de56d8c35c$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $b10c37de56d8c35c$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $b10c37de56d8c35c$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $2jGpl.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $9UnxB.default)((0, $9UnxB.default)((0, $9UnxB.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $bh6RR.Component));
$b10c37de56d8c35c$export$25ce5a424b770e84.defaultProps = $b10c37de56d8c35c$export$407448d2b89b1813;

});
parcelRegister("fivc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b230bc0d4245014d$export$2e2bcd8739ae039; });
function $b230bc0d4245014d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kuNiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eebcda4657ff09bb$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $eebcda4657ff09bb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hTglg.default)(o.key), o);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(e, r, t) {
    return r && $eebcda4657ff09bb$var$_defineProperties(e.prototype, r), t && $eebcda4657ff09bb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("7uMzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5751042f9a4a77f6$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $5751042f9a4a77f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $hloi6.default)(t, e);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1JyKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1434f224efb0ce22$export$2e2bcd8739ae039; });

var $k5JCq = parcelRequire("k5JCq");

var $1TADt = parcelRequire("1TADt");

var $gLqR5 = parcelRequire("gLqR5");
function $1434f224efb0ce22$export$2e2bcd8739ae039(t) {
    var r = (0, $1TADt.default)();
    return function() {
        var e, o = (0, $k5JCq.default)(t);
        if (r) {
            var s = (0, $k5JCq.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $gLqR5.default)(this, e);
    };
}

});
parcelRegister("k5JCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea07a931d040ec2a$export$2e2bcd8739ae039; });
function $ea07a931d040ec2a$export$2e2bcd8739ae039(t) {
    return $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ea07a931d040ec2a$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1TADt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1617589007256c62$export$2e2bcd8739ae039; });
function $1617589007256c62$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1617589007256c62$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("gLqR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c345de07753d2fca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $hqR4t = parcelRequire("hqR4t");
function $c345de07753d2fca$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $51lpG.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hqR4t.default)(t);
}

});
parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("jX7qT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8694aff92b422dc$export$2e2bcd8739ae039; });

var $8yNIs = parcelRequire("8yNIs");

var $cq1as = parcelRequire("cq1as");

var $9F6mQ = parcelRequire("9F6mQ");

var $2tVCP = parcelRequire("2tVCP");
function $e8694aff92b422dc$export$2e2bcd8739ae039(r) {
    return (0, $8yNIs.default)(r) || (0, $cq1as.default)(r) || (0, $9F6mQ.default)(r) || (0, $2tVCP.default)();
}

});
parcelRegister("8yNIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b81041f3d12ee7$export$2e2bcd8739ae039; });

var $cnxX0 = parcelRequire("cnxX0");
function $63b81041f3d12ee7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $cnxX0.default)(r);
}

});

parcelRegister("cq1as", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90a8d1a06a2704aa$export$2e2bcd8739ae039; });
function $90a8d1a06a2704aa$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2tVCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ceafd62b5589195$export$2e2bcd8739ae039; });
function $1ceafd62b5589195$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2jGpl", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $1afe4070f52cad0a$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $1afe4070f52cad0a$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $1afe4070f52cad0a$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $1afe4070f52cad0a$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $1afe4070f52cad0a$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $1afe4070f52cad0a$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $1afe4070f52cad0a$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $1afe4070f52cad0a$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $1afe4070f52cad0a$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $1afe4070f52cad0a$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $1afe4070f52cad0a$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $1afe4070f52cad0a$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $1afe4070f52cad0a$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $1afe4070f52cad0a$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $1afe4070f52cad0a$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $1afe4070f52cad0a$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $1afe4070f52cad0a$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $1afe4070f52cad0a$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $1afe4070f52cad0a$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $1afe4070f52cad0a$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $1afe4070f52cad0a$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $1afe4070f52cad0a$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $1afe4070f52cad0a$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $1afe4070f52cad0a$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $1afe4070f52cad0a$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $1afe4070f52cad0a$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $1afe4070f52cad0a$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $1afe4070f52cad0a$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $1afe4070f52cad0a$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $1afe4070f52cad0a$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $1afe4070f52cad0a$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $1afe4070f52cad0a$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $1afe4070f52cad0a$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $1afe4070f52cad0a$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $1afe4070f52cad0a$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $1afe4070f52cad0a$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "F", function () { return $1afe4070f52cad0a$export$d66501df72047452; });

var $9UnxB = parcelRequire("9UnxB");

var $4WYaH = parcelRequire("4WYaH");

var $7hler = parcelRequire("7hler");

var $6oWCT = parcelRequire("6oWCT");

var $cSlhQ = parcelRequire("cSlhQ");

var $51lpG = parcelRequire("51lpG");

var $aFCZd = parcelRequire("aFCZd");

var $2ryml = parcelRequire("2ryml");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $d55hh = parcelRequire("d55hh");

var $2ic0N = parcelRequire("2ic0N");
var $1afe4070f52cad0a$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $1afe4070f52cad0a$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $1afe4070f52cad0a$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $1afe4070f52cad0a$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($1afe4070f52cad0a$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $1afe4070f52cad0a$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($1afe4070f52cad0a$var$isArray(value)) return value.filter(Boolean);
    if ((0, $51lpG.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $1afe4070f52cad0a$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $cSlhQ.default)(props, $1afe4070f52cad0a$var$_excluded$4);
    return (0, $9UnxB.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $1afe4070f52cad0a$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $1afe4070f52cad0a$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $1afe4070f52cad0a$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $1afe4070f52cad0a$var$normalizedHeight(el) {
    if ($1afe4070f52cad0a$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $1afe4070f52cad0a$var$getScrollTop(el) {
    if ($1afe4070f52cad0a$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1afe4070f52cad0a$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1afe4070f52cad0a$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $1afe4070f52cad0a$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $1afe4070f52cad0a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1afe4070f52cad0a$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $1afe4070f52cad0a$export$b4171a6734a65d42;
    var start = $1afe4070f52cad0a$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $1afe4070f52cad0a$var$easeOutCubic(currentTime, start, change, duration);
        $1afe4070f52cad0a$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $1afe4070f52cad0a$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $1afe4070f52cad0a$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $1afe4070f52cad0a$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $1afe4070f52cad0a$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $1afe4070f52cad0a$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $1afe4070f52cad0a$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $1afe4070f52cad0a$var$passiveOptionAccessed = false;
var $1afe4070f52cad0a$var$options = {
    get passive () {
        return $1afe4070f52cad0a$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $1afe4070f52cad0a$var$w = typeof window !== 'undefined' ? window : {};
if ($1afe4070f52cad0a$var$w.addEventListener && $1afe4070f52cad0a$var$w.removeEventListener) {
    $1afe4070f52cad0a$var$w.addEventListener('p', $1afe4070f52cad0a$export$b4171a6734a65d42, $1afe4070f52cad0a$var$options);
    $1afe4070f52cad0a$var$w.removeEventListener('p', $1afe4070f52cad0a$export$b4171a6734a65d42, false);
}
var $1afe4070f52cad0a$export$2408f22a0fab9ae5 = $1afe4070f52cad0a$var$passiveOptionAccessed;
function $1afe4070f52cad0a$export$3466f893ebf79586(item) {
    return item != null;
}
function $1afe4070f52cad0a$var$isArray(arg) {
    return Array.isArray(arg);
}
function $1afe4070f52cad0a$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $1afe4070f52cad0a$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $1afe4070f52cad0a$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $1afe4070f52cad0a$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $6oWCT.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $6oWCT.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $1afe4070f52cad0a$var$_excluded$3 = [
    "children",
    "innerProps"
], $1afe4070f52cad0a$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $1afe4070f52cad0a$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $1afe4070f52cad0a$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $1afe4070f52cad0a$var$normalizedHeight(scrollParent);
    var scrollTop = $1afe4070f52cad0a$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1afe4070f52cad0a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $1afe4070f52cad0a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $1afe4070f52cad0a$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1afe4070f52cad0a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $1afe4070f52cad0a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $1afe4070f52cad0a$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $1afe4070f52cad0a$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $1afe4070f52cad0a$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $9UnxB.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $2ryml.default)(_objectSpread2, $1afe4070f52cad0a$var$alignToControl(placement), '100%'), (0, $2ryml.default)(_objectSpread2, "position", 'absolute'), (0, $2ryml.default)(_objectSpread2, "width", '100%'), (0, $2ryml.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $1afe4070f52cad0a$var$PortalPlacementContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
// NOTE: internal only
var $1afe4070f52cad0a$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $bh6RR.useContext)($1afe4070f52cad0a$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $bh6RR.useRef)(null);
    var _useState = (0, $bh6RR.useState)(maxMenuHeight), _useState2 = (0, $6oWCT.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $bh6RR.useState)(null), _useState4 = (0, $6oWCT.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $2ic0N.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $1afe4070f52cad0a$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $9UnxB.default)((0, $9UnxB.default)({}, props), {}, {
            placement: placement || $1afe4070f52cad0a$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $1afe4070f52cad0a$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $1afe4070f52cad0a$var$Menu$1 = $1afe4070f52cad0a$var$Menu;
// ==============================
// Menu List
// ==============================
var $1afe4070f52cad0a$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $9UnxB.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $1afe4070f52cad0a$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $1afe4070f52cad0a$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $9UnxB.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $1afe4070f52cad0a$export$3b14a55fb2447963 = $1afe4070f52cad0a$var$noticeCSS;
var $1afe4070f52cad0a$export$342063e11d6c3cad = $1afe4070f52cad0a$var$noticeCSS;
var $1afe4070f52cad0a$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $cSlhQ.default)(_ref6, $1afe4070f52cad0a$var$_excluded$3);
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps((0, $9UnxB.default)((0, $9UnxB.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $1afe4070f52cad0a$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $cSlhQ.default)(_ref7, $1afe4070f52cad0a$var$_excluded2$1);
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps((0, $9UnxB.default)((0, $9UnxB.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $1afe4070f52cad0a$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $1afe4070f52cad0a$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $bh6RR.useRef)(null);
    var cleanupRef = (0, $bh6RR.useRef)(null);
    var _useState5 = (0, $bh6RR.useState)($1afe4070f52cad0a$var$coercePlacement(menuPlacement)), _useState6 = (0, $6oWCT.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $bh6RR.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $bh6RR.useState)(null), _useState8 = (0, $6oWCT.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $bh6RR.useCallback)(function() {
        if (!controlElement) return;
        var rect = $1afe4070f52cad0a$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $2ic0N.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $bh6RR.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $d55hh.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $2ic0N.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $bh6RR.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $7hler.jsx)("div", (0, $4WYaH.default)({
        ref: setMenuPortalElement
    }, $1afe4070f52cad0a$var$getStyleProps((0, $9UnxB.default)((0, $9UnxB.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $7hler.jsx)($1afe4070f52cad0a$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $6afFj.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $1afe4070f52cad0a$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $1afe4070f52cad0a$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $1afe4070f52cad0a$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $9UnxB.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $1afe4070f52cad0a$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $1afe4070f52cad0a$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $1afe4070f52cad0a$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $1afe4070f52cad0a$var$_templateObject;
var $1afe4070f52cad0a$var$_excluded$2 = [
    "size"
], $1afe4070f52cad0a$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $1afe4070f52cad0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $1afe4070f52cad0a$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $1afe4070f52cad0a$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $cSlhQ.default)(_ref, $1afe4070f52cad0a$var$_excluded$2);
    return (0, $7hler.jsx)("svg", (0, $4WYaH.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $1afe4070f52cad0a$var$_ref2
    }, props));
};
var $1afe4070f52cad0a$var$CrossIcon = function CrossIcon(props) {
    return (0, $7hler.jsx)($1afe4070f52cad0a$var$Svg, (0, $4WYaH.default)({
        size: 20
    }, props), (0, $7hler.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $1afe4070f52cad0a$var$DownChevron = function DownChevron(props) {
    return (0, $7hler.jsx)($1afe4070f52cad0a$var$Svg, (0, $4WYaH.default)({
        size: 20
    }, props), (0, $7hler.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $1afe4070f52cad0a$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $9UnxB.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $1afe4070f52cad0a$export$f1e1789686576879 = $1afe4070f52cad0a$var$baseCSS;
var $1afe4070f52cad0a$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $7hler.jsx)($1afe4070f52cad0a$var$DownChevron, null));
};
var $1afe4070f52cad0a$export$407448d2b89b1813 = $1afe4070f52cad0a$var$baseCSS;
var $1afe4070f52cad0a$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $7hler.jsx)($1afe4070f52cad0a$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $1afe4070f52cad0a$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $9UnxB.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $1afe4070f52cad0a$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $7hler.jsx)("span", (0, $4WYaH.default)({}, innerProps, $1afe4070f52cad0a$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $1afe4070f52cad0a$var$loadingDotAnimations = (0, $7hler.keyframes)($1afe4070f52cad0a$var$_templateObject || ($1afe4070f52cad0a$var$_templateObject = (0, $aFCZd.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $1afe4070f52cad0a$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $9UnxB.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $1afe4070f52cad0a$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $7hler.jsx)("span", {
        css: /*#__PURE__*/ (0, $7hler.css)({
            animation: "".concat($1afe4070f52cad0a$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $1afe4070f52cad0a$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $cSlhQ.default)(_ref7, $1afe4070f52cad0a$var$_excluded2);
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps((0, $9UnxB.default)((0, $9UnxB.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $7hler.jsx)($1afe4070f52cad0a$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $7hler.jsx)($1afe4070f52cad0a$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $7hler.jsx)($1afe4070f52cad0a$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $1afe4070f52cad0a$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $9UnxB.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $1afe4070f52cad0a$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({
        ref: innerRef
    }, $1afe4070f52cad0a$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $1afe4070f52cad0a$var$Control$1 = $1afe4070f52cad0a$var$Control;
var $1afe4070f52cad0a$var$_excluded$1 = [
    "data"
];
var $1afe4070f52cad0a$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $1afe4070f52cad0a$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $7hler.jsx)(Heading, (0, $4WYaH.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $7hler.jsx)("div", null, children));
};
var $1afe4070f52cad0a$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $9UnxB.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $1afe4070f52cad0a$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $1afe4070f52cad0a$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $cSlhQ.default)(_cleanCommonProps, $1afe4070f52cad0a$var$_excluded$1);
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $1afe4070f52cad0a$var$Group$1 = $1afe4070f52cad0a$var$Group;
var $1afe4070f52cad0a$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $1afe4070f52cad0a$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9UnxB.default)((0, $9UnxB.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $1afe4070f52cad0a$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $1afe4070f52cad0a$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $1afe4070f52cad0a$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $9UnxB.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $1afe4070f52cad0a$var$spacingStyle)
};
var $1afe4070f52cad0a$var$inputStyle = function inputStyle(isHidden) {
    return (0, $9UnxB.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $1afe4070f52cad0a$var$spacingStyle);
};
var $1afe4070f52cad0a$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $1afe4070f52cad0a$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $cSlhQ.default)(_cleanCommonProps, $1afe4070f52cad0a$var$_excluded);
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $7hler.jsx)("input", (0, $4WYaH.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $1afe4070f52cad0a$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $1afe4070f52cad0a$var$Input$1 = $1afe4070f52cad0a$var$Input;
var $1afe4070f52cad0a$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $9UnxB.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $1afe4070f52cad0a$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $9UnxB.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $1afe4070f52cad0a$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $9UnxB.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $1afe4070f52cad0a$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $7hler.jsx)("div", innerProps, children);
};
var $1afe4070f52cad0a$var$MultiValueContainer = $1afe4070f52cad0a$var$MultiValueGeneric;
var $1afe4070f52cad0a$var$MultiValueLabel = $1afe4070f52cad0a$var$MultiValueGeneric;
function $1afe4070f52cad0a$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({
        role: "button"
    }, innerProps), children || (0, $7hler.jsx)($1afe4070f52cad0a$var$CrossIcon, {
        size: 14
    }));
}
var $1afe4070f52cad0a$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $7hler.jsx)(Container, {
        data: data,
        innerProps: (0, $9UnxB.default)((0, $9UnxB.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $7hler.jsx)(Label, {
        data: data,
        innerProps: (0, $9UnxB.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $7hler.jsx)(Remove, {
        data: data,
        innerProps: (0, $9UnxB.default)((0, $9UnxB.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $1afe4070f52cad0a$var$MultiValue$1 = $1afe4070f52cad0a$var$MultiValue;
var $1afe4070f52cad0a$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9UnxB.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $1afe4070f52cad0a$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $1afe4070f52cad0a$var$Option$1 = $1afe4070f52cad0a$var$Option;
var $1afe4070f52cad0a$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9UnxB.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $1afe4070f52cad0a$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $1afe4070f52cad0a$var$Placeholder$1 = $1afe4070f52cad0a$var$Placeholder;
var $1afe4070f52cad0a$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $9UnxB.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $1afe4070f52cad0a$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $7hler.jsx)("div", (0, $4WYaH.default)({}, $1afe4070f52cad0a$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $1afe4070f52cad0a$var$SingleValue$1 = $1afe4070f52cad0a$var$SingleValue;
var $1afe4070f52cad0a$export$db3b6bfb95261072 = {
    ClearIndicator: $1afe4070f52cad0a$var$ClearIndicator,
    Control: $1afe4070f52cad0a$var$Control$1,
    DropdownIndicator: $1afe4070f52cad0a$var$DropdownIndicator,
    DownChevron: $1afe4070f52cad0a$var$DownChevron,
    CrossIcon: $1afe4070f52cad0a$var$CrossIcon,
    Group: $1afe4070f52cad0a$var$Group$1,
    GroupHeading: $1afe4070f52cad0a$var$GroupHeading,
    IndicatorsContainer: $1afe4070f52cad0a$var$IndicatorsContainer,
    IndicatorSeparator: $1afe4070f52cad0a$var$IndicatorSeparator,
    Input: $1afe4070f52cad0a$var$Input$1,
    LoadingIndicator: $1afe4070f52cad0a$var$LoadingIndicator,
    Menu: $1afe4070f52cad0a$var$Menu$1,
    MenuList: $1afe4070f52cad0a$var$MenuList,
    MenuPortal: $1afe4070f52cad0a$var$MenuPortal,
    LoadingMessage: $1afe4070f52cad0a$var$LoadingMessage,
    NoOptionsMessage: $1afe4070f52cad0a$var$NoOptionsMessage,
    MultiValue: $1afe4070f52cad0a$var$MultiValue$1,
    MultiValueContainer: $1afe4070f52cad0a$var$MultiValueContainer,
    MultiValueLabel: $1afe4070f52cad0a$var$MultiValueLabel,
    MultiValueRemove: $1afe4070f52cad0a$var$MultiValueRemove,
    Option: $1afe4070f52cad0a$var$Option$1,
    Placeholder: $1afe4070f52cad0a$var$Placeholder$1,
    SelectContainer: $1afe4070f52cad0a$var$SelectContainer,
    SingleValue: $1afe4070f52cad0a$var$SingleValue$1,
    ValueContainer: $1afe4070f52cad0a$var$ValueContainer
};
var $1afe4070f52cad0a$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $9UnxB.default)((0, $9UnxB.default)({}, $1afe4070f52cad0a$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("7hler", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $54ca97295c8c5003$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $54ca97295c8c5003$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $54ca97295c8c5003$export$c8a8987d4410bf2d; });

var $hQwt8 = parcelRequire("hQwt8");

var $bh6RR = parcelRequire("bh6RR");

var $cdpIC = parcelRequire("cdpIC");

var $fPHYJ = parcelRequire("fPHYJ");

var $9v6T8 = parcelRequire("9v6T8");
parcelRequire("gbgGf");
parcelRequire("3Tqyg");
parcelRequire("ieFqf");

parcelRequire("adG4d");
var $54ca97295c8c5003$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $hQwt8.h).call(props, 'css')) return $bh6RR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $hQwt8.E);
    createElementArgArray[1] = (0, $hQwt8.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $bh6RR.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($54ca97295c8c5003$export$c8a8987d4410bf2d || ($54ca97295c8c5003$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $54ca97295c8c5003$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $hQwt8.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $9v6T8.serializeStyles)([
        styles
    ], undefined, $bh6RR.useContext((0, $hQwt8.T)));
    if (!(0, $hQwt8.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bh6RR.useRef();
    (0, $fPHYJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fPHYJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $cdpIC.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $54ca97295c8c5003$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9v6T8.serializeStyles)(args);
}
function $54ca97295c8c5003$export$d25ddfdf17c3ad3e() {
    var insertable = $54ca97295c8c5003$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $54ca97295c8c5003$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $54ca97295c8c5003$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $cdpIC.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $54ca97295c8c5003$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $cdpIC.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $hQwt8.i) && res !== undefined) rules += res;
        }
        if (!(0, $hQwt8.i)) return rules;
    });
    if (!(0, $hQwt8.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $54ca97295c8c5003$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $hQwt8.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $hQwt8.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $9v6T8.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $cdpIC.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $hQwt8.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $54ca97295c8c5003$var$merge(cache.registered, css, $54ca97295c8c5003$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bh6RR.useContext((0, $hQwt8.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($54ca97295c8c5003$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("hQwt8", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $cfe07aa2f624ca43$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $cfe07aa2f624ca43$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $cfe07aa2f624ca43$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $cfe07aa2f624ca43$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $cfe07aa2f624ca43$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $cfe07aa2f624ca43$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $cfe07aa2f624ca43$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $cfe07aa2f624ca43$export$a9c23c6ac3fc3eca; });

var $bh6RR = parcelRequire("bh6RR");

var $gbgGf = parcelRequire("gbgGf");

var $4WYaH = parcelRequire("4WYaH");

var $ieFqf = parcelRequire("ieFqf");

var $fFdqN = parcelRequire("fFdqN");

var $cdpIC = parcelRequire("cdpIC");

var $9v6T8 = parcelRequire("9v6T8");

var $fPHYJ = parcelRequire("fPHYJ");
var $cfe07aa2f624ca43$export$407448d2b89b1813 = false;
var $cfe07aa2f624ca43$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $cfe07aa2f624ca43$var$EmotionCacheContext = /* #__PURE__ */ $bh6RR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $gbgGf.default)({
    key: 'css'
}) : null);
var $cfe07aa2f624ca43$export$e7094788287c5e9b = $cfe07aa2f624ca43$var$EmotionCacheContext.Provider;
var $cfe07aa2f624ca43$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $bh6RR.useContext)($cfe07aa2f624ca43$var$EmotionCacheContext);
};
var $cfe07aa2f624ca43$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bh6RR.useContext)($cfe07aa2f624ca43$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$cfe07aa2f624ca43$export$23f2a1d2818174ef) $cfe07aa2f624ca43$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $bh6RR.useContext)($cfe07aa2f624ca43$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $gbgGf.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $bh6RR.createElement($cfe07aa2f624ca43$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $cfe07aa2f624ca43$export$971d5caa766a69d7 = /* #__PURE__ */ $bh6RR.createContext({});
var $cfe07aa2f624ca43$export$3b14a55fb2447963 = function useTheme() {
    return $bh6RR.useContext($cfe07aa2f624ca43$export$971d5caa766a69d7);
};
var $cfe07aa2f624ca43$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, theme);
};
var $cfe07aa2f624ca43$var$createCacheWithTheme = /* #__PURE__ */ (0, $ieFqf.default)(function(outerTheme) {
    return (0, $ieFqf.default)(function(theme) {
        return $cfe07aa2f624ca43$var$getTheme(outerTheme, theme);
    });
});
var $cfe07aa2f624ca43$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $bh6RR.useContext($cfe07aa2f624ca43$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $cfe07aa2f624ca43$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bh6RR.createElement($cfe07aa2f624ca43$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $cfe07aa2f624ca43$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $bh6RR.forwardRef(function render(props, ref) {
        var theme = $bh6RR.useContext($cfe07aa2f624ca43$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bh6RR.createElement(Component, (0, $4WYaH.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fFdqN.default)(WithTheme, Component);
}
var $cfe07aa2f624ca43$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $cfe07aa2f624ca43$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $cfe07aa2f624ca43$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($cfe07aa2f624ca43$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$cfe07aa2f624ca43$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $cfe07aa2f624ca43$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cdpIC.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cdpIC.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$cfe07aa2f624ca43$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $cfe07aa2f624ca43$var$Emotion = /* #__PURE__ */ $cfe07aa2f624ca43$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$cfe07aa2f624ca43$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $cdpIC.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $9v6T8.serializeStyles)(registeredStyles, undefined, $bh6RR.useContext($cfe07aa2f624ca43$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($cfe07aa2f624ca43$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $cfe07aa2f624ca43$var$typePropName && !$cfe07aa2f624ca43$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($cfe07aa2f624ca43$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $bh6RR.createElement(WrappedComponent, newProps));
});
var $cfe07aa2f624ca43$export$a9c23c6ac3fc3eca = $cfe07aa2f624ca43$var$Emotion;

});
parcelRegister("gbgGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7a9ccd09b383ef$export$2e2bcd8739ae039; });

var $k2OLv = parcelRequire("k2OLv");

var $sdBdz = parcelRequire("sdBdz");

var $ieFqf = parcelRequire("ieFqf");

var $cthCm = parcelRequire("cthCm");
var $bc7a9ccd09b383ef$var$isBrowser = typeof document !== 'undefined';
var $bc7a9ccd09b383ef$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $sdBdz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $sdBdz.token)(character)) break;
        (0, $sdBdz.next)();
    }
    return (0, $sdBdz.slice)(begin, (0, $sdBdz.position));
};
var $bc7a9ccd09b383ef$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $sdBdz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $sdBdz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bc7a9ccd09b383ef$var$identifierWithPointTracking((0, $sdBdz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $sdBdz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $sdBdz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $sdBdz.from)(character);
    }
    while (character = (0, $sdBdz.next)());
    return parsed;
};
var $bc7a9ccd09b383ef$var$getRules = function getRules(value, points) {
    return (0, $sdBdz.dealloc)($bc7a9ccd09b383ef$var$toRules((0, $sdBdz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bc7a9ccd09b383ef$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bc7a9ccd09b383ef$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bc7a9ccd09b383ef$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bc7a9ccd09b383ef$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bc7a9ccd09b383ef$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bc7a9ccd09b383ef$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $bc7a9ccd09b383ef$var$prefix(value, length) {
    switch((0, $sdBdz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $sdBdz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $sdBdz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MOZ) + value + (0, $sdBdz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
        // order
        case 6165:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.replace)(value, /(\w+).+(:[^]+)/, (0, $sdBdz.WEBKIT) + 'box-$1$2' + (0, $sdBdz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + 'flex-item-' + (0, $sdBdz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + 'flex-line-pack' + (0, $sdBdz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $sdBdz.WEBKIT) + 'box-' + (0, $sdBdz.replace)(value, '-grow', '') + (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $sdBdz.WEBKIT) + (0, $sdBdz.replace)(value, /([^-])(transform)/g, '$1' + (0, $sdBdz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(zoom-|grab)/, (0, $sdBdz.WEBKIT) + '$1'), /(image-set)/, (0, $sdBdz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $sdBdz.replace)(value, /(image-set\([^]*)/, (0, $sdBdz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $sdBdz.WEBKIT) + 'box-pack:$3' + (0, $sdBdz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $sdBdz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $sdBdz.replace)(value, /(.+)-inline(.+)/, (0, $sdBdz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $sdBdz.strlen)(value) - 1 - length > 6) switch((0, $sdBdz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $sdBdz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $sdBdz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $sdBdz.WEBKIT) + '$2-$3' + '$1' + (0, $sdBdz.MOZ) + ((0, $sdBdz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $sdBdz.indexof)(value, 'stretch') ? $bc7a9ccd09b383ef$var$prefix((0, $sdBdz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $sdBdz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $sdBdz.charat)(value, (0, $sdBdz.strlen)(value) - 3 - (~(0, $sdBdz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $sdBdz.replace)(value, ':', ':' + (0, $sdBdz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $sdBdz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $sdBdz.WEBKIT) + ((0, $sdBdz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $sdBdz.WEBKIT) + '$2$3' + '$1' + (0, $sdBdz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $sdBdz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
    }
    return value;
}
var $bc7a9ccd09b383ef$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $sdBdz.DECLARATION:
                element["return"] = $bc7a9ccd09b383ef$var$prefix(element.value, element.length);
                break;
            case 0, $sdBdz.KEYFRAMES:
                return (0, $sdBdz.serialize)([
                    (0, $sdBdz.copy)(element, {
                        value: (0, $sdBdz.replace)(element.value, '@', '@' + (0, $sdBdz.WEBKIT))
                    })
                ], callback);
            case 0, $sdBdz.RULESET:
                if (element.length) return (0, $sdBdz.combine)(element.props, function(value) {
                    switch((0, $sdBdz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(read-\w+)/, ':' + (0, $sdBdz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ':' + (0, $sdBdz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ':' + (0, $sdBdz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, (0, $sdBdz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $bc7a9ccd09b383ef$var$getServerStylisCache = $bc7a9ccd09b383ef$var$isBrowser ? undefined : (0, $ieFqf.default)(function() {
    return (0, $cthCm.default)(function() {
        return {};
    });
});
var $bc7a9ccd09b383ef$var$defaultStylisPlugins = [
    $bc7a9ccd09b383ef$var$prefixer
];
var $bc7a9ccd09b383ef$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($bc7a9ccd09b383ef$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $bc7a9ccd09b383ef$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($bc7a9ccd09b383ef$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $bc7a9ccd09b383ef$var$compat,
        $bc7a9ccd09b383ef$var$removeLabel
    ];
    if (!$bc7a9ccd09b383ef$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $sdBdz.stringify),
            (0, $sdBdz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $sdBdz.stringify)
        ];
        var _serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), _serializer);
        };
        var serverStylisCache = $bc7a9ccd09b383ef$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $k2OLv.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("k2OLv", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e97b5f72ed127b53$export$9d753cd7ae895cce; });
var $e97b5f72ed127b53$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e97b5f72ed127b53$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e97b5f72ed127b53$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e97b5f72ed127b53$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e97b5f72ed127b53$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e97b5f72ed127b53$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e97b5f72ed127b53$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("sdBdz", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $783faa7ec18221fc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $783faa7ec18221fc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $783faa7ec18221fc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $783faa7ec18221fc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $783faa7ec18221fc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $783faa7ec18221fc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $783faa7ec18221fc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $783faa7ec18221fc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $783faa7ec18221fc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $783faa7ec18221fc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $783faa7ec18221fc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $783faa7ec18221fc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $783faa7ec18221fc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $783faa7ec18221fc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $783faa7ec18221fc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $783faa7ec18221fc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $783faa7ec18221fc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $783faa7ec18221fc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $783faa7ec18221fc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $783faa7ec18221fc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $783faa7ec18221fc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $783faa7ec18221fc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $783faa7ec18221fc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $783faa7ec18221fc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $783faa7ec18221fc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $783faa7ec18221fc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $783faa7ec18221fc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $783faa7ec18221fc$export$38bcb760f1d4871c; });
var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(j += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $783faa7ec18221fc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(j) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(y = $783faa7ec18221fc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, y, y, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $783faa7ec18221fc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) j += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(g = j += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $783faa7ec18221fc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $783faa7ec18221fc$export$2f35ab04d2335697(e, v + 1, v = $783faa7ec18221fc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $783faa7ec18221fc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span") ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch") ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $783faa7ec18221fc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ieFqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d469aa6647f846c1$export$2e2bcd8739ae039; });
var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("fFdqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6751a8254c8738e$export$2e2bcd8739ae039; });

var $adG4d = parcelRequire("adG4d");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b6751a8254c8738e$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(targetComponent, sourceComponent);
};

});
parcelRegister("adG4d", function(module, exports) {
'use strict';

var $lhF4u = parcelRequire("lhF4u");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($lhF4u.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component['$$typeof']] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("lhF4u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g4WQO"));

});
parcelRegister("g4WQO", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bb4aab9d21a68c2e$export$2b8d127b894957b9; }, function (v) { return $bb4aab9d21a68c2e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bb4aab9d21a68c2e$export$cea3a54a6425200c; }, function (v) { return $bb4aab9d21a68c2e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae; }, function (v) { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d; }, function (v) { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac; }, function (v) { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35; }, function (v) { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb4aab9d21a68c2e$export$ffb0004e005737fa; }, function (v) { return $bb4aab9d21a68c2e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bb4aab9d21a68c2e$export$b624eff549462981; }, function (v) { return $bb4aab9d21a68c2e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bb4aab9d21a68c2e$export$7897aa7841a5380c; }, function (v) { return $bb4aab9d21a68c2e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bb4aab9d21a68c2e$export$602eac185826482c; }, function (v) { return $bb4aab9d21a68c2e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb4aab9d21a68c2e$export$e2c29f18771995cb; }, function (v) { return $bb4aab9d21a68c2e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb4aab9d21a68c2e$export$5f8d39834fd61797; }, function (v) { return $bb4aab9d21a68c2e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5; }, function (v) { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bb4aab9d21a68c2e$export$92387174baf9b227; }, function (v) { return $bb4aab9d21a68c2e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6; }, function (v) { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bb4aab9d21a68c2e$export$b706b080d889d2c9; }, function (v) { return $bb4aab9d21a68c2e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc; }, function (v) { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d; }, function (v) { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bb4aab9d21a68c2e$export$455c2e768291efa6; }, function (v) { return $bb4aab9d21a68c2e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bb4aab9d21a68c2e$export$9522e17588c12572; }, function (v) { return $bb4aab9d21a68c2e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bb4aab9d21a68c2e$export$2110ac352bb060b9; }, function (v) { return $bb4aab9d21a68c2e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab; }, function (v) { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de; }, function (v) { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bb4aab9d21a68c2e$export$b82d16f27459e05a; }, function (v) { return $bb4aab9d21a68c2e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8; }, function (v) { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6; }, function (v) { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bb4aab9d21a68c2e$export$9b621391a187a31a; }, function (v) { return $bb4aab9d21a68c2e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f; }, function (v) { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb4aab9d21a68c2e$export$2b8d127b894957b9;
var $bb4aab9d21a68c2e$export$cea3a54a6425200c;
var $bb4aab9d21a68c2e$export$a7c73072b1a182ae;
var $bb4aab9d21a68c2e$export$9f27bc3417b4524d;
var $bb4aab9d21a68c2e$export$db77ccec0bb4ccac;
var $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35;
var $bb4aab9d21a68c2e$export$ffb0004e005737fa;
var $bb4aab9d21a68c2e$export$b624eff549462981;
var $bb4aab9d21a68c2e$export$7897aa7841a5380c;
var $bb4aab9d21a68c2e$export$602eac185826482c;
var $bb4aab9d21a68c2e$export$e2c29f18771995cb;
var $bb4aab9d21a68c2e$export$5f8d39834fd61797;
var $bb4aab9d21a68c2e$export$74bf444e3cd11ea5;
var $bb4aab9d21a68c2e$export$92387174baf9b227;
var $bb4aab9d21a68c2e$export$ec112efeb987d9c6;
var $bb4aab9d21a68c2e$export$b706b080d889d2c9;
var $bb4aab9d21a68c2e$export$5be5a87408f70ddc;
var $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d;
var $bb4aab9d21a68c2e$export$455c2e768291efa6;
var $bb4aab9d21a68c2e$export$9522e17588c12572;
var $bb4aab9d21a68c2e$export$2110ac352bb060b9;
var $bb4aab9d21a68c2e$export$56885ab8b9c456ab;
var $bb4aab9d21a68c2e$export$d927fcb6adf8f9de;
var $bb4aab9d21a68c2e$export$b82d16f27459e05a;
var $bb4aab9d21a68c2e$export$522c17b4f5e123e8;
var $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6;
var $bb4aab9d21a68c2e$export$9b621391a187a31a;
var $bb4aab9d21a68c2e$export$f5bbd400c2f4426f;
'use strict';
var $bb4aab9d21a68c2e$var$b = "function" === typeof Symbol && Symbol.for, $bb4aab9d21a68c2e$var$c = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.element") : 60103, $bb4aab9d21a68c2e$var$d = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.portal") : 60106, $bb4aab9d21a68c2e$var$e = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fragment") : 60107, $bb4aab9d21a68c2e$var$f = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.strict_mode") : 60108, $bb4aab9d21a68c2e$var$g = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.profiler") : 60114, $bb4aab9d21a68c2e$var$h = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.provider") : 60109, $bb4aab9d21a68c2e$var$k = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.context") : 60110, $bb4aab9d21a68c2e$var$l = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.async_mode") : 60111, $bb4aab9d21a68c2e$var$m = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bb4aab9d21a68c2e$var$n = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.forward_ref") : 60112, $bb4aab9d21a68c2e$var$p = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense") : 60113, $bb4aab9d21a68c2e$var$q = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense_list") : 60120, $bb4aab9d21a68c2e$var$r = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.memo") : 60115, $bb4aab9d21a68c2e$var$t = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.lazy") : 60116, $bb4aab9d21a68c2e$var$v = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.block") : 60121, $bb4aab9d21a68c2e$var$w = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fundamental") : 60117, $bb4aab9d21a68c2e$var$x = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.responder") : 60118, $bb4aab9d21a68c2e$var$y = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.scope") : 60119;
function $bb4aab9d21a68c2e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bb4aab9d21a68c2e$var$c:
                switch(a = a.type, a){
                    case $bb4aab9d21a68c2e$var$l:
                    case $bb4aab9d21a68c2e$var$m:
                    case $bb4aab9d21a68c2e$var$e:
                    case $bb4aab9d21a68c2e$var$g:
                    case $bb4aab9d21a68c2e$var$f:
                    case $bb4aab9d21a68c2e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bb4aab9d21a68c2e$var$k:
                            case $bb4aab9d21a68c2e$var$n:
                            case $bb4aab9d21a68c2e$var$t:
                            case $bb4aab9d21a68c2e$var$r:
                            case $bb4aab9d21a68c2e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bb4aab9d21a68c2e$var$d:
                return u;
        }
    }
}
function $bb4aab9d21a68c2e$var$A(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$m;
}
$bb4aab9d21a68c2e$export$2b8d127b894957b9 = $bb4aab9d21a68c2e$var$l;
$bb4aab9d21a68c2e$export$cea3a54a6425200c = $bb4aab9d21a68c2e$var$m;
$bb4aab9d21a68c2e$export$a7c73072b1a182ae = $bb4aab9d21a68c2e$var$k;
$bb4aab9d21a68c2e$export$9f27bc3417b4524d = $bb4aab9d21a68c2e$var$h;
$bb4aab9d21a68c2e$export$db77ccec0bb4ccac = $bb4aab9d21a68c2e$var$c;
$bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = $bb4aab9d21a68c2e$var$n;
$bb4aab9d21a68c2e$export$ffb0004e005737fa = $bb4aab9d21a68c2e$var$e;
$bb4aab9d21a68c2e$export$b624eff549462981 = $bb4aab9d21a68c2e$var$t;
$bb4aab9d21a68c2e$export$7897aa7841a5380c = $bb4aab9d21a68c2e$var$r;
$bb4aab9d21a68c2e$export$602eac185826482c = $bb4aab9d21a68c2e$var$d;
$bb4aab9d21a68c2e$export$e2c29f18771995cb = $bb4aab9d21a68c2e$var$g;
$bb4aab9d21a68c2e$export$5f8d39834fd61797 = $bb4aab9d21a68c2e$var$f;
$bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = $bb4aab9d21a68c2e$var$p;
$bb4aab9d21a68c2e$export$92387174baf9b227 = function(a) {
    return $bb4aab9d21a68c2e$var$A(a) || $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$l;
};
$bb4aab9d21a68c2e$export$ec112efeb987d9c6 = $bb4aab9d21a68c2e$var$A;
$bb4aab9d21a68c2e$export$b706b080d889d2c9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$k;
};
$bb4aab9d21a68c2e$export$5be5a87408f70ddc = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$h;
};
$bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb4aab9d21a68c2e$var$c;
};
$bb4aab9d21a68c2e$export$455c2e768291efa6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$n;
};
$bb4aab9d21a68c2e$export$9522e17588c12572 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$e;
};
$bb4aab9d21a68c2e$export$2110ac352bb060b9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$t;
};
$bb4aab9d21a68c2e$export$56885ab8b9c456ab = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$r;
};
$bb4aab9d21a68c2e$export$d927fcb6adf8f9de = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$d;
};
$bb4aab9d21a68c2e$export$b82d16f27459e05a = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$g;
};
$bb4aab9d21a68c2e$export$522c17b4f5e123e8 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$f;
};
$bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$p;
};
$bb4aab9d21a68c2e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bb4aab9d21a68c2e$var$e || a === $bb4aab9d21a68c2e$var$m || a === $bb4aab9d21a68c2e$var$g || a === $bb4aab9d21a68c2e$var$f || a === $bb4aab9d21a68c2e$var$p || a === $bb4aab9d21a68c2e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bb4aab9d21a68c2e$var$t || a.$$typeof === $bb4aab9d21a68c2e$var$r || a.$$typeof === $bb4aab9d21a68c2e$var$h || a.$$typeof === $bb4aab9d21a68c2e$var$k || a.$$typeof === $bb4aab9d21a68c2e$var$n || a.$$typeof === $bb4aab9d21a68c2e$var$w || a.$$typeof === $bb4aab9d21a68c2e$var$x || a.$$typeof === $bb4aab9d21a68c2e$var$y || a.$$typeof === $bb4aab9d21a68c2e$var$v);
};
$bb4aab9d21a68c2e$export$f5bbd400c2f4426f = $bb4aab9d21a68c2e$var$z;

});




parcelRegister("cdpIC", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $8e4aa61dd4b95f07$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $8e4aa61dd4b95f07$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $8e4aa61dd4b95f07$export$6f077d94b33a01aa; });
var $8e4aa61dd4b95f07$var$isBrowser = typeof document !== 'undefined';
function $8e4aa61dd4b95f07$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $8e4aa61dd4b95f07$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8e4aa61dd4b95f07$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8e4aa61dd4b95f07$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8e4aa61dd4b95f07$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$8e4aa61dd4b95f07$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8e4aa61dd4b95f07$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("9v6T8", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $6eac5a28f6e72cd5$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $amwve = parcelRequire("amwve");

var $cthCm = parcelRequire("cthCm");
var $6eac5a28f6e72cd5$var$isDevelopment = false;
var $6eac5a28f6e72cd5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6eac5a28f6e72cd5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6eac5a28f6e72cd5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6eac5a28f6e72cd5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $6eac5a28f6e72cd5$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $6eac5a28f6e72cd5$var$isCustomProperty(styleName) ? styleName : styleName.replace($6eac5a28f6e72cd5$var$hyphenateRegex, '-$&').toLowerCase();
});
var $6eac5a28f6e72cd5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($6eac5a28f6e72cd5$var$animationRegex, function(match, p1, p2) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $amwve.default)[key] !== 1 && !$6eac5a28f6e72cd5$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $6eac5a28f6e72cd5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6eac5a28f6e72cd5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6eac5a28f6e72cd5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $6eac5a28f6e72cd5$var$cursor;
                var result = interpolation(mergedProps);
                $6eac5a28f6e72cd5$var$cursor = previousCursor;
                return $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($6eac5a28f6e72cd5$var$isProcessableValue(asString)) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $6eac5a28f6e72cd5$var$isDevelopment) throw new Error($6eac5a28f6e72cd5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($6eac5a28f6e72cd5$var$isProcessableValue(value[_i])) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $6eac5a28f6e72cd5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $6eac5a28f6e72cd5$var$cursor;
function $6eac5a28f6e72cd5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $6eac5a28f6e72cd5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $6eac5a28f6e72cd5$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6eac5a28f6e72cd5$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6eac5a28f6e72cd5$var$cursor
    };
}

});
parcelRegister("171Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf7dd2d70c55cf3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("amwve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b52bced097bc64$export$2e2bcd8739ae039; });
var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fPHYJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b86dbba518057278$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b86dbba518057278$export$811a713a7276cb9d; });

var $bh6RR = parcelRequire("bh6RR");
var $b86dbba518057278$var$isBrowser = typeof document !== 'undefined';
var $b86dbba518057278$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b86dbba518057278$var$useInsertionEffect = $bh6RR.useInsertionEffect ? $bh6RR.useInsertionEffect : false;
var $b86dbba518057278$export$db21c7ffa21794e7 = !$b86dbba518057278$var$isBrowser ? $b86dbba518057278$var$syncFallback : $b86dbba518057278$var$useInsertionEffect || $b86dbba518057278$var$syncFallback;
var $b86dbba518057278$export$811a713a7276cb9d = $b86dbba518057278$var$useInsertionEffect || $bh6RR.useLayoutEffect;

});


parcelRegister("3Tqyg", function(module, exports) {
function $2d5b1ac1574da936$var$_extends() {
    return module.exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2d5b1ac1574da936$var$_extends.apply(null, arguments);
}
module.exports = $2d5b1ac1574da936$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aFCZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c4bf992c3b23621$export$2e2bcd8739ae039; });
function $7c4bf992c3b23621$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("d55hh", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $985fd6054d85832a$export$deee3a793edee05f; });

var $czcm8 = parcelRequire("czcm8");
var $1VYLM = parcelRequire("1VYLM");

var $1VYLM = parcelRequire("1VYLM");

var $c9Xpd = parcelRequire("c9Xpd");
function $985fd6054d85832a$var$getCssDimensions(element) {
    const css = (0, $c9Xpd.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c9Xpd.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1VYLM.round)(width) !== offsetWidth || (0, $1VYLM.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $985fd6054d85832a$var$unwrapElement(element) {
    return !(0, $c9Xpd.isElement)(element) ? element.contextElement : element;
}
function $985fd6054d85832a$var$getScale(element) {
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    if (!(0, $c9Xpd.isHTMLElement)(domElement)) return (0, $1VYLM.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $985fd6054d85832a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1VYLM.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1VYLM.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $985fd6054d85832a$var$noOffsets = /*#__PURE__*/ (0, $1VYLM.createCoords)(0);
function $985fd6054d85832a$var$getVisualOffsets(element) {
    const win = (0, $c9Xpd.getWindow)(element);
    if (!(0, $c9Xpd.isWebKit)() || !win.visualViewport) return $985fd6054d85832a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $985fd6054d85832a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c9Xpd.getWindow)(element)) return false;
    return isFixed;
}
function $985fd6054d85832a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    let scale = (0, $1VYLM.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c9Xpd.isElement)(offsetParent)) scale = $985fd6054d85832a$var$getScale(offsetParent);
        } else scale = $985fd6054d85832a$var$getScale(element);
    }
    const visualOffsets = $985fd6054d85832a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $985fd6054d85832a$var$getVisualOffsets(domElement) : (0, $1VYLM.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c9Xpd.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $c9Xpd.isElement)(offsetParent) ? (0, $c9Xpd.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c9Xpd.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $985fd6054d85832a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c9Xpd.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c9Xpd.getWindow)(currentIFrame);
            currentIFrame = (0, $c9Xpd.getFrameElement)(currentWin);
        }
    }
    return (0, $1VYLM.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $985fd6054d85832a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c9Xpd.getNodeScroll)(element).scrollLeft;
    if (!rect) return $985fd6054d85832a$var$getBoundingClientRect((0, $c9Xpd.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $985fd6054d85832a$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $985fd6054d85832a$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c9Xpd.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $c9Xpd.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1VYLM.createCoords)(1);
    const offsets = (0, $1VYLM.createCoords)(0);
    const isOffsetParentAnElement = (0, $c9Xpd.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c9Xpd.getNodeName)(offsetParent) !== 'body' || (0, $c9Xpd.isOverflowElement)(documentElement)) scroll = (0, $c9Xpd.getNodeScroll)(offsetParent);
        if ((0, $c9Xpd.isHTMLElement)(offsetParent)) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent);
            scale = $985fd6054d85832a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $985fd6054d85832a$var$getHTMLOffset(documentElement, scroll, true) : (0, $1VYLM.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $985fd6054d85832a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $985fd6054d85832a$var$getDocumentRect(element) {
    const html = (0, $c9Xpd.getDocumentElement)(element);
    const scroll = (0, $c9Xpd.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1VYLM.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1VYLM.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $985fd6054d85832a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c9Xpd.getComputedStyle)(body).direction === 'rtl') x += (0, $1VYLM.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getViewportRect(element, strategy) {
    const win = (0, $c9Xpd.getWindow)(element);
    const html = (0, $c9Xpd.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c9Xpd.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $985fd6054d85832a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $985fd6054d85832a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c9Xpd.isHTMLElement)(element) ? $985fd6054d85832a$var$getScale(element) : (0, $1VYLM.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $985fd6054d85832a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $985fd6054d85832a$var$getDocumentRect((0, $c9Xpd.getDocumentElement)(element));
    else if ((0, $c9Xpd.isElement)(clippingAncestor)) rect = $985fd6054d85832a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $985fd6054d85832a$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1VYLM.rectToClientRect)(rect);
}
function $985fd6054d85832a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c9Xpd.getParentNode)(element);
    if (parentNode === stopNode || !(0, $c9Xpd.isElement)(parentNode) || (0, $c9Xpd.isLastTraversableNode)(parentNode)) return false;
    return (0, $c9Xpd.getComputedStyle)(parentNode).position === 'fixed' || $985fd6054d85832a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $985fd6054d85832a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c9Xpd.getOverflowAncestors)(element, [], false).filter((el)=>(0, $c9Xpd.isElement)(el) && (0, $c9Xpd.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c9Xpd.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c9Xpd.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c9Xpd.isElement)(currentNode) && !(0, $c9Xpd.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $c9Xpd.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $c9Xpd.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $c9Xpd.isOverflowElement)(currentNode) && !currentNodeIsContaining && $985fd6054d85832a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c9Xpd.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $985fd6054d85832a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c9Xpd.isTopLayer)(element) ? [] : $985fd6054d85832a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1VYLM.max)(rect.top, accRect.top);
        accRect.right = (0, $1VYLM.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1VYLM.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1VYLM.max)(rect.left, accRect.left);
        return accRect;
    }, $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $985fd6054d85832a$var$getDimensions(element) {
    const { width: width, height: height } = $985fd6054d85832a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $985fd6054d85832a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c9Xpd.isHTMLElement)(offsetParent);
    const documentElement = (0, $c9Xpd.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1VYLM.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c9Xpd.getNodeName)(offsetParent) !== 'body' || (0, $c9Xpd.isOverflowElement)(documentElement)) scroll = (0, $c9Xpd.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $985fd6054d85832a$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $985fd6054d85832a$var$getHTMLOffset(documentElement, scroll) : (0, $1VYLM.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $985fd6054d85832a$var$isStaticPositioned(element) {
    return (0, $c9Xpd.getComputedStyle)(element).position === 'static';
}
function $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c9Xpd.isHTMLElement)(element) || (0, $c9Xpd.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c9Xpd.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $985fd6054d85832a$var$getOffsetParent(element, polyfill) {
    const win = (0, $c9Xpd.getWindow)(element);
    if ((0, $c9Xpd.isTopLayer)(element)) return win;
    if (!(0, $c9Xpd.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $c9Xpd.getParentNode)(element);
        while(svgOffsetParent && !(0, $c9Xpd.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $c9Xpd.isElement)(svgOffsetParent) && !$985fd6054d85832a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c9Xpd.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c9Xpd.isTableElement)(offsetParent) && $985fd6054d85832a$var$isStaticPositioned(offsetParent))offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c9Xpd.isLastTraversableNode)(offsetParent) && $985fd6054d85832a$var$isStaticPositioned(offsetParent) && !(0, $c9Xpd.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $c9Xpd.getContainingBlock)(element) || win;
}
const $985fd6054d85832a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $985fd6054d85832a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $985fd6054d85832a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $985fd6054d85832a$var$isRTL(element) {
    return (0, $c9Xpd.getComputedStyle)(element).direction === 'rtl';
}
const $985fd6054d85832a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c9Xpd.getDocumentElement,
    getClippingRect: $985fd6054d85832a$var$getClippingRect,
    getOffsetParent: $985fd6054d85832a$var$getOffsetParent,
    getElementRects: $985fd6054d85832a$var$getElementRects,
    getClientRects: $985fd6054d85832a$var$getClientRects,
    getDimensions: $985fd6054d85832a$var$getDimensions,
    getScale: $985fd6054d85832a$var$getScale,
    isElement: $c9Xpd.isElement,
    isRTL: $985fd6054d85832a$var$isRTL
};
function $985fd6054d85832a$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $985fd6054d85832a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c9Xpd.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1VYLM.floor)(top);
        const insetRight = (0, $1VYLM.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1VYLM.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1VYLM.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1VYLM.max)(0, (0, $1VYLM.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$985fd6054d85832a$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $985fd6054d85832a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $985fd6054d85832a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c9Xpd.getOverflowAncestors)(referenceEl) : [],
        ...(0, $c9Xpd.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $985fd6054d85832a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $985fd6054d85832a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $985fd6054d85832a$var$getBoundingClientRect(reference);
        if (prevRefRect && !$985fd6054d85832a$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $985fd6054d85832a$export$37b6bde19b108ecc = (0, $czcm8.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $985fd6054d85832a$export$cc800923e997bb8 = (0, $czcm8.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $985fd6054d85832a$export$91fb6ecbd551914 = (0, $czcm8.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $985fd6054d85832a$export$fba63a578e423eb = (0, $czcm8.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $985fd6054d85832a$export$8a83211c878a3f1f = (0, $czcm8.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $985fd6054d85832a$export$346677f925de839c = (0, $czcm8.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $985fd6054d85832a$export$fe8985bb6374093c = (0, $czcm8.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $985fd6054d85832a$export$f2120bbfa5450bd2 = (0, $czcm8.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $985fd6054d85832a$export$18c8ad048e32c7d5 = (0, $czcm8.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $985fd6054d85832a$export$7bf07e38f3dc4b69 = (0, $czcm8.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $985fd6054d85832a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $985fd6054d85832a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $czcm8.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("czcm8", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $926256944d3cd62f$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $926256944d3cd62f$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $926256944d3cd62f$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $926256944d3cd62f$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $926256944d3cd62f$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $926256944d3cd62f$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $926256944d3cd62f$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $926256944d3cd62f$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $926256944d3cd62f$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $926256944d3cd62f$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $926256944d3cd62f$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("1VYLM")).rectToClientRect; });

var $1VYLM = parcelRequire("1VYLM");
function $926256944d3cd62f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1VYLM.getSideAxis)(placement);
    const alignmentAxis = (0, $1VYLM.getAlignmentAxis)(placement);
    const alignLength = (0, $1VYLM.getAxisLength)(alignmentAxis);
    const side = (0, $1VYLM.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1VYLM.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $926256944d3cd62f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $926256944d3cd62f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1VYLM.evaluate)(options, state);
    const paddingObject = (0, $1VYLM.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1VYLM.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1VYLM.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $926256944d3cd62f$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1VYLM.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1VYLM.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1VYLM.getAlignmentAxis)(placement);
            const length = (0, $1VYLM.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1VYLM.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1VYLM.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1VYLM.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1VYLM.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $926256944d3cd62f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1VYLM.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1VYLM.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1VYLM.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1VYLM.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1VYLM.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $926256944d3cd62f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1VYLM.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1VYLM.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1VYLM.placements) ? $926256944d3cd62f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1VYLM.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1VYLM.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1VYLM.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1VYLM.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $926256944d3cd62f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1VYLM.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1VYLM.getSide)(placement);
            const initialSideAxis = (0, $1VYLM.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1VYLM.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1VYLM.getOppositePlacement)(initialPlacement)
            ] : (0, $1VYLM.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1VYLM.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1VYLM.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1VYLM.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $926256944d3cd62f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $926256944d3cd62f$var$isAnySideFullyClipped(overflow) {
    return (0, $1VYLM.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $926256944d3cd62f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $1VYLM.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $926256944d3cd62f$var$getBoundingRect(rects) {
    const minX = (0, $1VYLM.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1VYLM.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1VYLM.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1VYLM.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $926256944d3cd62f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1VYLM.rectToClientRect)($926256944d3cd62f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $926256944d3cd62f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1VYLM.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $926256944d3cd62f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1VYLM.rectToClientRect)($926256944d3cd62f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1VYLM.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1VYLM.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1VYLM.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1VYLM.getSide)(placement) === 'left';
                    const maxRight = (0, $1VYLM.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1VYLM.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $926256944d3cd62f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1VYLM.getSide)(placement);
    const alignment = (0, $1VYLM.getAlignment)(placement);
    const isVertical = (0, $1VYLM.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1VYLM.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $926256944d3cd62f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $926256944d3cd62f$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $926256944d3cd62f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1VYLM.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1VYLM.getSideAxis)((0, $1VYLM.getSide)(placement));
            const mainAxis = (0, $1VYLM.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1VYLM.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1VYLM.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $926256944d3cd62f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1VYLM.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1VYLM.getSideAxis)(placement);
            const mainAxis = (0, $1VYLM.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1VYLM.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $1VYLM.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $926256944d3cd62f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1VYLM.evaluate)(options, state);
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1VYLM.getSide)(placement);
            const alignment = (0, $1VYLM.getAlignment)(placement);
            const isYAxis = (0, $1VYLM.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1VYLM.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1VYLM.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1VYLM.max)(overflow.left, 0);
                const xMax = (0, $1VYLM.max)(overflow.right, 0);
                const yMin = (0, $1VYLM.max)(overflow.top, 0);
                const yMax = (0, $1VYLM.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1VYLM.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1VYLM.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1VYLM", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $168a40e325c04e1b$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $168a40e325c04e1b$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $168a40e325c04e1b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $168a40e325c04e1b$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $168a40e325c04e1b$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $168a40e325c04e1b$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $168a40e325c04e1b$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $168a40e325c04e1b$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $168a40e325c04e1b$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $168a40e325c04e1b$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $168a40e325c04e1b$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $168a40e325c04e1b$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $168a40e325c04e1b$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $168a40e325c04e1b$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $168a40e325c04e1b$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $168a40e325c04e1b$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $168a40e325c04e1b$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $168a40e325c04e1b$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $168a40e325c04e1b$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $168a40e325c04e1b$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $168a40e325c04e1b$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $168a40e325c04e1b$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $168a40e325c04e1b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $168a40e325c04e1b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $168a40e325c04e1b$export$803cd8101b6c182b = /*#__PURE__*/ $168a40e325c04e1b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[0], side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[1]), []);
const $168a40e325c04e1b$export$96ec731ed4dcb222 = Math.min;
const $168a40e325c04e1b$export$8960430cfd85939f = Math.max;
const $168a40e325c04e1b$export$2077e0241d6afd3c = Math.round;
const $168a40e325c04e1b$export$a3fe094919f356fd = Math.floor;
const $168a40e325c04e1b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $168a40e325c04e1b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $168a40e325c04e1b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $168a40e325c04e1b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $168a40e325c04e1b$export$8960430cfd85939f(start, $168a40e325c04e1b$export$96ec731ed4dcb222(value, end));
}
function $168a40e325c04e1b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $168a40e325c04e1b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $168a40e325c04e1b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $168a40e325c04e1b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $168a40e325c04e1b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $168a40e325c04e1b$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($168a40e325c04e1b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement) {
    return $168a40e325c04e1b$export$8a000a963141ac32($168a40e325c04e1b$export$f28e8f882010718a(placement));
}
function $168a40e325c04e1b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement);
    const length = $168a40e325c04e1b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $168a40e325c04e1b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $168a40e325c04e1b$export$9c5e28bad23365fa(placement);
    return [
        $168a40e325c04e1b$export$2b182c584985588b(placement),
        oppositePlacement,
        $168a40e325c04e1b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $168a40e325c04e1b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$168a40e325c04e1b$var$oppositeAlignmentMap[alignment]);
}
function $168a40e325c04e1b$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $168a40e325c04e1b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    let list = $168a40e325c04e1b$var$getSideList($168a40e325c04e1b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($168a40e325c04e1b$export$2b182c584985588b));
    }
    return list;
}
function $168a40e325c04e1b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$168a40e325c04e1b$var$oppositeSideMap[side]);
}
function $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $168a40e325c04e1b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $168a40e325c04e1b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("c9Xpd", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $8da4680c6d092b5b$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $8da4680c6d092b5b$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $8da4680c6d092b5b$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $8da4680c6d092b5b$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $8da4680c6d092b5b$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $8da4680c6d092b5b$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $8da4680c6d092b5b$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $8da4680c6d092b5b$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $8da4680c6d092b5b$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $8da4680c6d092b5b$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $8da4680c6d092b5b$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $8da4680c6d092b5b$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $8da4680c6d092b5b$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $8da4680c6d092b5b$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $8da4680c6d092b5b$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $8da4680c6d092b5b$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $8da4680c6d092b5b$export$7bf1f8740e3e34af; });
function $8da4680c6d092b5b$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $8da4680c6d092b5b$export$651544f548703224(node) {
    if ($8da4680c6d092b5b$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $8da4680c6d092b5b$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $8da4680c6d092b5b$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($8da4680c6d092b5b$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $8da4680c6d092b5b$export$8ee0fc9ee280b4ee(value) {
    if (!$8da4680c6d092b5b$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).Node;
}
function $8da4680c6d092b5b$export$45a5e7f76e0caa8d(value) {
    if (!$8da4680c6d092b5b$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).Element;
}
function $8da4680c6d092b5b$export$1b3bfaa9684536aa(value) {
    if (!$8da4680c6d092b5b$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).HTMLElement;
}
function $8da4680c6d092b5b$export$af51f0f06c0f328a(value) {
    if (!$8da4680c6d092b5b$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $8da4680c6d092b5b$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $8da4680c6d092b5b$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $8da4680c6d092b5b$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $8da4680c6d092b5b$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($8da4680c6d092b5b$export$651544f548703224(element));
}
function $8da4680c6d092b5b$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $8da4680c6d092b5b$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $8da4680c6d092b5b$export$78551043582a6a98();
    const css = $8da4680c6d092b5b$export$45a5e7f76e0caa8d(elementOrCss) ? $8da4680c6d092b5b$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $8da4680c6d092b5b$export$940d8225183e1404(element) {
    let currentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(element);
    while($8da4680c6d092b5b$export$1b3bfaa9684536aa(currentNode) && !$8da4680c6d092b5b$export$d1162fb0b6d4cd51(currentNode)){
        if ($8da4680c6d092b5b$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($8da4680c6d092b5b$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $8da4680c6d092b5b$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $8da4680c6d092b5b$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($8da4680c6d092b5b$export$651544f548703224(node));
}
function $8da4680c6d092b5b$export$3735103072e4a80(element) {
    return $8da4680c6d092b5b$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $8da4680c6d092b5b$export$dc8fc79fa2800137(element) {
    if ($8da4680c6d092b5b$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $8da4680c6d092b5b$export$4e12058fc4d51d56(node) {
    if ($8da4680c6d092b5b$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $8da4680c6d092b5b$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $8da4680c6d092b5b$export$e495491855dc5418(node);
    return $8da4680c6d092b5b$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $8da4680c6d092b5b$export$7cd01a57c8ca906c(node) {
    const parentNode = $8da4680c6d092b5b$export$4e12058fc4d51d56(node);
    if ($8da4680c6d092b5b$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($8da4680c6d092b5b$export$1b3bfaa9684536aa(parentNode) && $8da4680c6d092b5b$export$989e911fa9af580a(parentNode)) return parentNode;
    return $8da4680c6d092b5b$export$7cd01a57c8ca906c(parentNode);
}
function $8da4680c6d092b5b$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $8da4680c6d092b5b$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $8da4680c6d092b5b$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $8da4680c6d092b5b$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $8da4680c6d092b5b$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $8da4680c6d092b5b$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $8da4680c6d092b5b$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $8da4680c6d092b5b$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("2ic0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ab6948683118df1$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
var $1ab6948683118df1$export$2e2bcd8739ae039 = (0, $bh6RR.useLayoutEffect);

});


parcelRegister("1XykX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d5efbf3de5c533$export$2e2bcd8739ae039; });
var $16d5efbf3de5c533$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $16d5efbf3de5c533$var$isEqual(first, second) {
    if (first === second) return true;
    if ($16d5efbf3de5c533$var$safeIsNaN(first) && $16d5efbf3de5c533$var$safeIsNaN(second)) return true;
    return false;
}
function $16d5efbf3de5c533$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$16d5efbf3de5c533$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $16d5efbf3de5c533$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $16d5efbf3de5c533$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("4Ugt5", function(module, exports) {

var $jqdsN = parcelRequire("jqdsN");
function $39292a9b5a7ccf44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39292a9b5a7ccf44$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39292a9b5a7ccf44$var$ownKeys(Object(t), !0).forEach(function(r) {
            $jqdsN(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39292a9b5a7ccf44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $39292a9b5a7ccf44$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jqdsN", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $e23ae39501459ba4$var$_defineProperty(e, r, t) {
    return (r = $7keJs(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $e23ae39501459ba4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7keJs", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $5555d428bd3bf37b$var$_typeof = $crtHL.default;

var $2PEUm = parcelRequire("2PEUm");
function $5555d428bd3bf37b$var$toPropertyKey(t) {
    var i = $2PEUm(t, "string");
    return "symbol" == $5555d428bd3bf37b$var$_typeof(i) ? i : i + "";
}
module.exports = $5555d428bd3bf37b$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(o);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2PEUm", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $210013a7b1d5e66c$var$_typeof = $crtHL.default;
function $210013a7b1d5e66c$var$toPrimitive(t, r) {
    if ("object" != $210013a7b1d5e66c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $210013a7b1d5e66c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $210013a7b1d5e66c$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("f0cZC", function(module, exports) {

var $kAaco = parcelRequire("kAaco");

var $gHGyu = parcelRequire("gHGyu");

var $idGQ9 = parcelRequire("idGQ9");

var $nxncW = parcelRequire("nxncW");
function $aec0ef34f2c5a862$var$_slicedToArray(r, e) {
    return $kAaco(r) || $gHGyu(r, e) || $idGQ9(r, e) || $nxncW();
}
module.exports = $aec0ef34f2c5a862$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kAaco", function(module, exports) {
function $efbf14b6e6102ff5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $efbf14b6e6102ff5$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gHGyu", function(module, exports) {
function $c291ac134490aa92$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $c291ac134490aa92$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("idGQ9", function(module, exports) {

var $70hlF = parcelRequire("70hlF");
function $036c4d1914e85e94$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $70hlF(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $70hlF(r, a) : void 0;
    }
}
module.exports = $036c4d1914e85e94$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("70hlF", function(module, exports) {
function $5195fd8f0d7eac4d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $5195fd8f0d7eac4d$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("nxncW", function(module, exports) {
function $046c0957b668f83c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $046c0957b668f83c$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5ZFcU", function(module, exports) {

var $4bIUn = parcelRequire("4bIUn");
function $45d29d2a9970da25$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4bIUn(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $45d29d2a9970da25$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4bIUn", function(module, exports) {
function $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bfbtb", function(module, exports) {
function $82f9fe10102e948b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $82f9fe10102e948b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kNrk6", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $f23d94100a43e193$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7keJs(o.key), o);
    }
}
function $f23d94100a43e193$var$_createClass(e, r, t) {
    return r && $f23d94100a43e193$var$_defineProperties(e.prototype, r), t && $f23d94100a43e193$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $f23d94100a43e193$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ljhd4", function(module, exports) {

var $96bT5 = parcelRequire("96bT5");
function $f838b8d3ab72d3a5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $96bT5(t, e);
}
module.exports = $f838b8d3ab72d3a5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("96bT5", function(module, exports) {
function $69fde538af35e679$var$_setPrototypeOf(t, e) {
    return module.exports = $69fde538af35e679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $69fde538af35e679$var$_setPrototypeOf(t, e);
}
module.exports = $69fde538af35e679$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5o7eN", function(module, exports) {

var $j4o1m = parcelRequire("j4o1m");

var $2HAU5 = parcelRequire("2HAU5");

var $cybvJ = parcelRequire("cybvJ");
function $3ec4cedce6102910$var$_createSuper(t) {
    var r = $2HAU5();
    return function() {
        var e, o = $j4o1m(t);
        if (r) {
            var s = $j4o1m(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $cybvJ(this, e);
    };
}
module.exports = $3ec4cedce6102910$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j4o1m", function(module, exports) {
function $de21061e32125644$var$_getPrototypeOf(t) {
    return module.exports = $de21061e32125644$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $de21061e32125644$var$_getPrototypeOf(t);
}
module.exports = $de21061e32125644$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2HAU5", function(module, exports) {
function $1f7c3937d2ae6b75$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $1f7c3937d2ae6b75$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $1f7c3937d2ae6b75$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cybvJ", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $923196d71df5e353$var$_typeof = $crtHL.default;

var $eiXAs = parcelRequire("eiXAs");
function $923196d71df5e353$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $923196d71df5e353$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $eiXAs(t);
}
module.exports = $923196d71df5e353$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eiXAs", function(module, exports) {
function $a6a0f7da525baef5$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $a6a0f7da525baef5$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("cIAln", function(module, exports) {

var $dQH8r = parcelRequire("dQH8r");

var $2eRAt = parcelRequire("2eRAt");

var $idGQ9 = parcelRequire("idGQ9");

var $bMH5E = parcelRequire("bMH5E");
function $9425c93b578bde03$var$_toConsumableArray(r) {
    return $dQH8r(r) || $2eRAt(r) || $idGQ9(r) || $bMH5E();
}
module.exports = $9425c93b578bde03$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dQH8r", function(module, exports) {

var $70hlF = parcelRequire("70hlF");
function $a15197716c9fc410$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $70hlF(r);
}
module.exports = $a15197716c9fc410$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2eRAt", function(module, exports) {
function $1a1674df30a2d79d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $1a1674df30a2d79d$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bMH5E", function(module, exports) {
function $89459a34ed9af2cc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $89459a34ed9af2cc$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("b2LR8", function(module, exports) {
function $80a500d5a5e7c6c2$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $80a500d5a5e7c6c2$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ajq9p", function(module, exports) {

$parcel$export(module.exports, "SearchSummonerInput", function () { return $4a413fdd7de81cad$export$601b49857336bd70; });

var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $4o3f8 = parcelRequire("4o3f8");

var $fp7Nf = parcelRequire("fp7Nf");

var $fC0sb = parcelRequire("fC0sb");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");
const $4a413fdd7de81cad$export$601b49857336bd70 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ summoner: summoner, setSummoner: setSummoner, handleFocus: handleFocus }, ref)=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const handleChange = (0, $bh6RR.useCallback)((e)=>setSummoner((0, $f5id0.pipe)((0, $fp7Nf.RiotId).fromStringDecoder.decode(e.target.value), (0, $sjwE0.Either).mapLeft(()=>e.target.value))), [
        setSummoner
    ]);
    const summonerRaw = (0, $f5id0.pipe)(summoner, (0, $sjwE0.Either).fold((0, $f5id0.identity), (0, $fp7Nf.RiotId).stringify));
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: ref,
        className: "grid min-w-50 items-center area-1",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "w-full px-2 area-1",
                children: (0, $f5id0.pipe)(summoner, (0, $sjwE0.Either).fold((name)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: name
                    }), ({ gameName: gameName, tagLine: tagLine })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-goldenrod",
                                children: (0, $4o3f8.GameName).unwrap(gameName)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                className: "text-grey-500",
                                children: [
                                    "#",
                                    (0, $fC0sb.TagLine).unwrap(tagLine)
                                ]
                            })
                        ]
                    })))
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                type: "text",
                value: summonerRaw,
                onChange: handleChange,
                onFocus: handleFocus,
                placeholder: t.layout.searchSummoner,
                className: (0, $jK7ok.cx)('w-0 min-w-full bg-transparent px-2 text-wheat/0 caret-wheat area-1', {
                    'font-normal': summonerRaw === ''
                })
            })
        ]
    });
});

});

parcelRegister("cFpmW", function(module, exports) {

$parcel$export(module.exports, "SummonerSearch", function () { return $fb21cb9bd17b03bb$export$69be8bc94117727d; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $6omhk = parcelRequire("6omhk");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $4o3f8 = parcelRequire("4o3f8");

var $fp7Nf = parcelRequire("fp7Nf");

var $ixYJp = parcelRequire("ixYJp");

var $fC0sb = parcelRequire("fC0sb");

var $sjwE0 = parcelRequire("sjwE0");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");

var $ixfeS = parcelRequire("ixfeS");

var $gwlG1 = parcelRequire("gwlG1");

var $kiCtw = parcelRequire("kiCtw");

var $gE3ky = parcelRequire("gE3ky");

var $jK7ok = parcelRequire("jK7ok");

var $7VlB6 = parcelRequire("7VlB6");

var $hnBhT = parcelRequire("hnBhT");

var $fVW4p = parcelRequire("fVW4p");
const $fb21cb9bd17b03bb$export$69be8bc94117727d = ({ type: type, summoner: summoner })=>{
    const { navigate: navigate, masteriesQuery: masteriesQuery } = (0, $9xM77.useHistory)();
    const { maybeUser: maybeUser, addFavoriteSearch: addFavoriteSearch, removeFavoriteSearch: removeFavoriteSearch, removeRecentSearch: removeRecentSearch } = (0, $j30iL.useUser)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const staticData = (0, $6H0K7.useStaticData)();
    const summonerMatch = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).platformRiotId);
    const summonerGameMatch = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).platformRiotIdGame);
    // with current masteriesQuery
    const puuidRoute = (0, $bh6RR.useCallback)((platform, puuid)=>(summonerGameMatch !== undefined ? (0, $gE3ky.appRoutes).sPlatformPuuidGame : (0, $gE3ky.appRoutes).sPlatformPuuid)(platform, puuid, summonerMatch !== undefined ? (0, $kiCtw.MasteriesQuery).toPartial({
            ...masteriesQuery,
            search: (0, $sjwE0.Maybe).none
        }) : {}), [
        masteriesQuery,
        summonerGameMatch,
        summonerMatch
    ]);
    const removeRecent = (0, $bh6RR.useCallback)((e)=>{
        e.stopPropagation();
        removeRecentSearch(summoner.puuid);
    }, [
        removeRecentSearch,
        summoner
    ]);
    const [favoriteIsLoading, setFavoriteIsLoading] = (0, $bh6RR.useState)(false);
    const addFavorite = (0, $bh6RR.useCallback)((e)=>{
        e.stopPropagation();
        if ((0, $sjwE0.Maybe).isNone(summoner.riotId)) return navigateToSummoner();
        setFavoriteIsLoading(true);
        return (0, $f5id0.pipe)(addFavoriteSearch({
            ...summoner,
            riotId: summoner.riotId.value
        }), // on not found
        (0, $sjwE0.Future).map((0, $sjwE0.Maybe).getOrElseW(()=>navigateToSummoner())), (0, $6omhk).chainFirstIOK(()=>()=>setFavoriteIsLoading(false)), (0, $7VlB6.futureRunUnsafe));
        function navigateToSummoner() {
            return navigate(puuidRoute(summoner.platform, summoner.puuid));
        }
    }, [
        addFavoriteSearch,
        navigate,
        puuidRoute,
        summoner
    ]);
    const removeFavorite = (0, $bh6RR.useCallback)((e)=>{
        e.stopPropagation();
        setFavoriteIsLoading(true);
        return (0, $f5id0.pipe)(removeFavoriteSearch(summoner.puuid), (0, $6omhk).chainFirstIOK(()=>()=>setFavoriteIsLoading(false)), (0, $7VlB6.futureRunUnsafe));
    }, [
        removeFavoriteSearch,
        summoner
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
        className: "contents",
        children: [
            $fb21cb9bd17b03bb$var$renderRecent(type, removeRecent),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $hnBhT.Link), {
                to: puuidRoute(summoner.platform, summoner.puuid),
                className: "group flex items-center leading-4",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: staticData.assets.summonerIcon(summoner.profileIconId),
                        alt: t.summonerIconAlt((0, $f5id0.pipe)(summoner.riotId, (0, $sjwE0.Maybe).map((0, $fp7Nf.RiotId).stringify), (0, $sjwE0.Maybe).alt(()=>(0, $f5id0.pipe)(summoner.name, (0, $sjwE0.Maybe).map((0, $ixYJp.SummonerName).unwrap))), (0, $sjwE0.Maybe).getOrElse(()=>`<Summoner ${summoner.puuid}>`))),
                        className: "w-12"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "ml-2 flex grow items-baseline gap-0.5",
                        children: (0, $f5id0.pipe)(summoner.riotId, (0, $sjwE0.Maybe).map((riotId)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: (0, $jK7ok.cx)($fb21cb9bd17b03bb$var$linkClassName, 'text-goldenrod'),
                                        children: (0, $4o3f8.GameName).unwrap(riotId.gameName)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "font-normal text-grey-500",
                                        children: [
                                            "#",
                                            (0, $fC0sb.TagLine).unwrap(riotId.tagLine)
                                        ]
                                    })
                                ]
                            })), (0, $sjwE0.Maybe).alt(()=>(0, $f5id0.pipe)(summoner.name, (0, $sjwE0.Maybe).map((name)=>// eslint-disable-next-line react/jsx-key
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: $fb21cb9bd17b03bb$var$linkClassName,
                                    children: (0, $ixYJp.SummonerName).unwrap(name)
                                })))), (0, $sjwE0.Maybe).toNullable)
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, $jK7ok.cx)($fb21cb9bd17b03bb$var$linkClassName, 'ml-4 font-normal'),
                        children: summoner.platform
                    })
                ]
            }),
            (0, $sjwE0.Maybe).isSome(maybeUser) ? $fb21cb9bd17b03bb$var$renderFavorite(type, favoriteIsLoading, addFavorite, removeFavorite) : null
        ]
    });
};
const $fb21cb9bd17b03bb$var$linkClassName = 'border-y border-y-transparent group-hover:border-b-current';
function $fb21cb9bd17b03bb$var$renderRecent(type, removeRecent) {
    switch(type){
        case 'self':
            return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "w-3"
            });
        case 'favorite':
            return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "w-3"
            });
        case 'recent':
            return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                type: "button",
                onClick: removeRecent,
                className: "group p-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.TimeOutline), {
                        className: "h-4 text-goldenrod group-hover:hidden"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CloseFilled), {
                        className: "hidden h-4 text-red group-hover:flex"
                    })
                ]
            });
    }
}
function $fb21cb9bd17b03bb$var$renderFavorite(type, isLoading, addFavorite, removeFavorite) {
    switch(type){
        case 'self':
            return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "px-3",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.PersonFilled), {
                    className: "h-4"
                })
            });
        case 'favorite':
            return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: removeFavorite,
                disabled: isLoading,
                className: "px-3 pb-3 pt-2 text-goldenrod enabled:hover:text-red",
                children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                    className: "h-5"
                }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.StarFilled), {
                    className: "h-5"
                })
            });
        case 'recent':
            return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: addFavorite,
                disabled: isLoading,
                className: "px-3 pb-3 pt-2 text-goldenrod enabled:hover:text-wheat",
                children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                    className: "h-5"
                }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.StarOutline), {
                    className: "h-5"
                })
            });
    }
}

});



parcelRegister("eojvT", function(module, exports) {

$parcel$export(module.exports, "getRouterComponent", function () { return $c6bbdd287a5c7328$export$19e2bdbb5ff92a3d; });
$parcel$export(module.exports, "e", function () { return $c6bbdd287a5c7328$export$f1e1789686576879; });
/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $dc934 = parcelRequire("dc934");
var $fbpED = parcelRequire("fbpED");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $9xM77 = parcelRequire("9xM77");

var $4MEuc = parcelRequire("4MEuc");

var $dk6Sm = parcelRequire("dk6Sm");
function $c6bbdd287a5c7328$export$19e2bdbb5ff92a3d(parser) {
    return function RouterComponent() {
        const { t: t } = (0, $4MEuc.useTranslation)('router');
        const { location: location } = (0, $9xM77.useHistory)();
        const [node, title] = (0, $bh6RR.useMemo)(()=>{
            const [node_, subTitle] = (0, $dc934.parse)(parser, (0, $fbpED.Route).parse(location.pathname), $c6bbdd287a5c7328$export$f1e1789686576879(/*#__PURE__*/ (0, $ih19M.jsx)((0, $dk6Sm.NotFound), {}), (t_)=>t_.notFound));
            const title_ = (0, $f5id0.pipe)([
                (0, $f5id0.pipe)(subTitle, (0, $sjwE0.Maybe).map((s)=>s(t))),
                (0, $sjwE0.Maybe).some(t.theQuest)
            ], (0, $sjwE0.List).compact, (0, $sjwE0.List).mkString(' | '));
            return [
                node_,
                title_
            ];
        }, [
            location.pathname,
            t
        ]);
        (0, $bh6RR.useEffect)(()=>{
            // eslint-disable-next-line functional/immutable-data
            document.title = title;
        }, [
            title
        ]);
        return node;
    };
}
function $c6bbdd287a5c7328$export$f1e1789686576879(element, title) {
    return (0, $sjwE0.Tuple).of(element, (0, $sjwE0.Maybe).fromNullable(title));
}

});
parcelRegister("dk6Sm", function(module, exports) {

$parcel$export(module.exports, "NotFound", function () { return $61cc8d15b2abf433$export$271f9f08425019c7; });

var $ih19M = parcelRequire("ih19M");

var $hnBhT = parcelRequire("hnBhT");

var $4MEuc = parcelRequire("4MEuc");

var $gE3ky = parcelRequire("gE3ky");
const $61cc8d15b2abf433$export$271f9f08425019c7 = ()=>{
    const { t: t } = (0, $4MEuc.useTranslation)('notFound');
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex flex-col items-center gap-4 p-6",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                className: "text-xl",
                children: t.thisPageDoesntExist
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                to: (0, $gE3ky.appRoutes).index,
                className: "font-medium underline",
                children: t.home
            })
        ]
    });
};

});


parcelRegister("6twHP", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("7FWne").then(()=>parcelRequire('gGmFa'));

});

var $189854943ea01f77$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gyVte\",\"index.249dab3c.js\",\"c4nBX\",\"enGB.13fcd177.js\",\"8exhq\",\"frFR.e54f7933.js\",\"hMfrI\",\"bandle.c006a2a6.webp\",\"iFihQ\",\"bilgewater.58d00087.webp\",\"k2ZMs\",\"demacia.e4daa11c.webp\",\"4Ucwg\",\"freljord.744001bf.webp\",\"aCvzj\",\"ionia.6aea9ace.webp\",\"5IwYl\",\"ixtal.86197ae2.webp\",\"cTCkP\",\"noxus.954ce344.webp\",\"jvL9W\",\"piltover.011e21bc.webp\",\"fmRjI\",\"shadowIsles.25801c44.webp\",\"1PBkU\",\"shurima.3cd980ed.webp\",\"dM7ta\",\"targon.23d59733.webp\",\"M1Ztt\",\"void.43168c65.webp\",\"hBv8C\",\"zaun.e8da4a2f.webp\",\"dZpcd\",\"mastery-0.8fed1ae0.png\",\"7Vpzd\",\"mastery-1.21920b27.png\",\"6MFnr\",\"mastery-2.a4fc1478.png\",\"2dtDr\",\"mastery-3.1cbe45a6.png\",\"iGBVR\",\"mastery-4.0c0f346b.png\",\"PANsm\",\"mastery-5.cfc9ee95.png\",\"nD8AY\",\"mastery-6.2b6317f1.png\",\"c7jrJ\",\"mastery-7.d4edf5f3.png\",\"cwIiB\",\"mastery-8.ac344fe0.png\",\"3C7In\",\"mastery-9.8f1c8b65.png\",\"4I1lr\",\"mastery-10.de3bd6c9.png\",\"358fC\",\"damage_amp.cb2ff0cf.webp\",\"6Qboo\",\"armor_penetration.66104771.webp\",\"2hqje\",\"heal_power.c8b3d796.webp\",\"jiUXc\",\"shield_power.437195fc.webp\",\"5mvzX\",\"ability_haste.8fbe6db0.webp\",\"9MQX5\",\"energy_regen.f768e637.webp\",\"7C2Uy\",\"attack_speed.81e8ef98.webp\",\"ebhgh\",\"movement_speed.bdd9f2d2.webp\",\"66GEe\",\"tenacity.d3b34d47.webp\",\"gn9Rr\",\"champion.3213ca9c.webp\",\"cucU9\",\"globetrotter.8936141a.png\",\"8KjiF\",\"runeterra.83ef5934.png\",\"diIGG\",\"spatula.4655b2c1.png\",\"lYlll\",\"dpm-lol.d7c4d9eb.png\",\"7brax\",\"league-of-graphs.143b9e5d.png\",\"cipM1\",\"op-gg.3c7751c0.png\",\"7ip7L\",\"porofessor.06889782.png\",\"694SG\",\"year-in-lol.1d22245c.png\",\"kdEOT\",\"yuumi-home.2e417a16.png\",\"7FWne\",\"AdminRouterComponent.f1cc704f.js\"]"));


var $ih19M = parcelRequire("ih19M");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
'use strict';

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;



var $ih19M = parcelRequire("ih19M");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $31rfl = parcelRequire("31rfl");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");

var $ih19M = parcelRequire("ih19M");

var $c7lJu = parcelRequire("c7lJu");
var $dc934 = parcelRequire("dc934");

var $bh6RR = parcelRequire("bh6RR");

var $fp7Nf = parcelRequire("fp7Nf");

var $dOJeV = parcelRequire("dOJeV");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $fVW4p = parcelRequire("fVW4p");
const $ee34040125966ac9$export$ac1a3f0c836eba03 = ({ children: children })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
        fallback: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                className: "mt-4 h-6"
            })
        }),
        children: children
    });



var $36sK8 = parcelRequire("36sK8");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $4lr6f = parcelRequire("4lr6f");var $2566e9e25df745a4$exports = {};

$parcel$export($2566e9e25df745a4$exports, "random", function () { return $2566e9e25df745a4$export$4385e60b38654f68; });
$parcel$export($2566e9e25df745a4$exports, "randomInt", function () { return $2566e9e25df745a4$export$3c5f89dae98e900b; });
$parcel$export($2566e9e25df745a4$exports, "randomRange", function () { return $2566e9e25df745a4$export$5c61011b8a176cb5; });
$parcel$export($2566e9e25df745a4$exports, "randomBool", function () { return $2566e9e25df745a4$export$b3b584c8d6ffe165; });
$parcel$export($2566e9e25df745a4$exports, "randomElem", function () { return $2566e9e25df745a4$export$3626835d6c2414ab; });
/**
 * @since 2.0.0
 */ 
var $f5id0 = parcelRequire("f5id0");

var $4lr6f = parcelRequire("4lr6f");
var $2566e9e25df745a4$export$4385e60b38654f68 = function() {
    return Math.random();
};
function $2566e9e25df745a4$export$3c5f89dae98e900b(low, high) {
    return (0, $f5id0.pipe)($2566e9e25df745a4$export$4385e60b38654f68, (0, $4lr6f.map)(function(n) {
        return Math.floor((high - low + 1) * n + low);
    }));
}
function $2566e9e25df745a4$export$5c61011b8a176cb5(min, max) {
    return (0, $f5id0.pipe)($2566e9e25df745a4$export$4385e60b38654f68, (0, $4lr6f.map)(function(n) {
        return (max - min) * n + min;
    }));
}
var $2566e9e25df745a4$export$b3b584c8d6ffe165 = /*#__PURE__*/ (0, $f5id0.pipe)($2566e9e25df745a4$export$4385e60b38654f68, (0, $4lr6f.map)(function(n) {
    return n < 0.5;
}));
var $2566e9e25df745a4$export$3626835d6c2414ab = function(as) {
    return (0, $f5id0.pipe)($2566e9e25df745a4$export$3c5f89dae98e900b(0, as.length - 1), (0, $4lr6f.map)(function(i) {
        return as[i];
    }));
};



var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $br0yu = parcelRequire("br0yu");

var $25oLT = parcelRequire("25oLT");

var $iPRex = parcelRequire("iPRex");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $4MEuc = parcelRequire("4MEuc");

var $gwlG1 = parcelRequire("gwlG1");

var $jK7ok = parcelRequire("jK7ok");

var $es0HS = parcelRequire("es0HS");
const $0928d021cbbf7cbd$export$13c8a39fad75a36b = ({ category: category, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('mapChanges');
    const hoverRef = (0, $bh6RR.useRef)(null);
    const placementRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: (0, $jK7ok.cx)('col-span-full flex pb-1', className),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("h2", {
            ref: hoverRef,
            className: "flex items-center gap-2 font-semibold",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    children: t.category.label[category]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    ref: placementRef,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.InformationCircleOutline), {
                        className: "h-4"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                    hoverRef: hoverRef,
                    placementRef: placementRef,
                    className: "max-w-xl !whitespace-normal break-normal py-2",
                    children: t.category.description[category]
                })
            ]
        })
    });
};


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $4lr6f = parcelRequire("4lr6f");
var $IYheM = parcelRequire("IYheM");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $gwlG1 = parcelRequire("gwlG1");

var $jK7ok = parcelRequire("jK7ok");

var $es0HS = parcelRequire("es0HS");
const $755ee31adc777f55$export$bb60b672622fdba0 = ({ searchCount: searchCount, randomChampion: randomChampion, initialSearch: initialSearch, onChange: onChange, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const searchRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        const onKeyup = (e)=>{
            if ((e.key.toLowerCase() === 'f' && (e.ctrlKey || e.metaKey) || e.key === '/' || e.key === 'F3') && searchRef.current !== null) {
                e.preventDefault();
                searchRef.current.select();
            }
        };
        document.addEventListener('keydown', onKeyup, true);
        return ()=>document.removeEventListener('keydown', onKeyup, true);
    }, []);
    const [search, setSearch] = (0, $bh6RR.useState)((0, $f5id0.pipe)(initialSearch, (0, $sjwE0.Maybe).getOrElse(()=>'')));
    const emptySearch = (0, $bh6RR.useCallback)(()=>{
        setSearch('');
        searchRef.current?.focus();
    }, []);
    const handleKeyDown = (0, $bh6RR.useCallback)((e)=>{
        if (e.key === 'Escape') {
            setSearch('');
            searchRef.current?.blur();
        }
    }, []);
    const updateSearch = (0, $bh6RR.useMemo)(()=>(0, $f5id0.flow)((0, $68YxT).trim, (0, $sjwE0.Maybe).fromPredicate((0, $IYheM).not((0, $68YxT).isEmpty)), onChange), [
        onChange
    ]);
    (0, $bh6RR.useEffect)(()=>{
        updateSearch(search);
    }, [
        updateSearch,
        search
    ]);
    const handleSearchChange = (0, $bh6RR.useCallback)((e)=>setSearch(e.target.value), []);
    const onFocus = (0, $bh6RR.useCallback)((e)=>e.target.select(), []);
    const handleRandomClick = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(randomChampion, (0, $sjwE0.Maybe).map((0, $4lr6f).map(setSearch)), (0, $sjwE0.Maybe).toUndefined), [
        randomChampion
    ]);
    const randomButtonRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, $jK7ok.cx)('flex flex-wrap items-center gap-3', className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "relative flex flex-col items-center text-xs",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "grid items-center",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                ref: searchRef,
                                type: "text",
                                value: search,
                                onChange: handleSearchChange,
                                onKeyDown: handleKeyDown,
                                onFocus: onFocus,
                                placeholder: t.searchChamion,
                                className: (0, $jK7ok.cx)('w-32.5 justify-self-start rounded-sm border border-grey-disabled bg-transparent py-0.5 pl-2 area-1', search === '' ? 'pr-2' : 'pr-7')
                            }),
                            search !== '' ? /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                type: "button",
                                onClick: emptySearch,
                                className: "mr-1 justify-self-end area-1",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CloseFilled), {
                                    className: "h-5 text-wheat"
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, $jK7ok.cx)('absolute top-full pt-0.5 text-zinc-400', {
                            hidden: (0, $sjwE0.Maybe).isNone(initialSearch)
                        }),
                        children: t.nResults(searchCount)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                ref: randomButtonRef,
                type: "button",
                onClick: handleRandomClick,
                disabled: (0, $sjwE0.Maybe).isNone(randomChampion),
                className: "group -mx-0.5 overflow-hidden p-0.5 disabled:opacity-30",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.DiceFilled), {
                    className: "h-7 transition-transform duration-300 group-enabled:group-hover:animate-dice"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: randomButtonRef,
                placement: "top",
                children: t.randomChampion
            })
        ]
    });
};



var $tA0jd = parcelRequire("tA0jd");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $4x239 = parcelRequire("4x239");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $2DVbf = parcelRequire("2DVbf");

var $895LH = parcelRequire("895LH");

var $j839F = parcelRequire("j839F");

var $sjwE0 = parcelRequire("sjwE0");
const $7432f0671d5622f7$var$e = (0, $j839F.createEnum)('buffed', 'nerfed', 'other', 'balanced');
const $7432f0671d5622f7$var$fromData = (data)=>(0, $f5id0.pipe)(data.stats, (0, $sjwE0.Maybe).map((stats)=>{
        const normalized = $7432f0671d5622f7$var$normalizeStats(stats);
        return normalized < 0 ? 'nerfed' : 0 < normalized ? 'buffed' : 'other';
    }), (0, $sjwE0.Maybe).getOrElse(()=>(0, $f5id0.pipe)(data.skills, (0, $sjwE0.Maybe).fold(()=>'balanced', ()=>'other'))));
const $7432f0671d5622f7$var$normalizeStats = (stats)=>(0, $f5id0.pipe)(stats, (0, $895LH.DictUtils).partial.entries, (0, $sjwE0.List).map(([key, val])=>{
        if (val === undefined || val === 0) return 0;
        return (((0, $2DVbf.WikiStatsBalance).isModifierStat(key) ? val - 1 : val) < 0 ? -1 : 1) * ((0, $2DVbf.WikiStatsBalance).isMalusStat(key) ? -1 : 1);
    }), (0, $4x239).concatAll((0, $10ZIc).MonoidSum));
const $7432f0671d5622f7$export$dc50577efab52c43 = {
    values: $7432f0671d5622f7$var$e.values,
    fromData: $7432f0671d5622f7$var$fromData,
    Eq: $7432f0671d5622f7$var$e.Eq
};



var $2EH2o = parcelRequire("2EH2o");

var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $ih19M = parcelRequire("ih19M");

var $jK7ok = parcelRequire("jK7ok");
const $c3c80580245b1da4$var$masteryBgColorClassName = {
    10: 'text-[#fdf2fc]',
    9: 'text-[#d2651b]',
    8: 'text-[#8d12c9]',
    7: 'text-[#0369a1]',
    6: 'text-[#329055]',
    5: 'text-[#94a3b8]',
    4: 'text-[#71717a]',
    3: 'text-[#71717a]',
    2: 'text-[#71717a]',
    1: 'text-[#71717a]'
};
const $c3c80580245b1da4$export$641527e078380b15 = /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "size-0",
    children: /*#__PURE__*/ (0, $ih19M.jsxs)("defs", {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
                id: $c3c80580245b1da4$export$b06b879d73ad6baf(10),
                x1: "1",
                y1: "0",
                x2: "0",
                y2: "0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                        offset: "30%",
                        stopColor: "#f3eafb"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                        offset: "55%",
                        stopColor: "#fffad8"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                        offset: "80%",
                        stopColor: "#c8fdfc"
                    })
                ]
            }),
            $c3c80580245b1da4$var$gradient(9, '#d2651b', '#8e3d25'),
            $c3c80580245b1da4$var$gradient(8, '#8d12c9', '#560292'),
            $c3c80580245b1da4$var$gradient(7, '#0369a1', '#324bd0'),
            $c3c80580245b1da4$var$gradient(6, '#329055', '#266846'),
            $c3c80580245b1da4$var$gradient(5, '#94a3b8', '#475569'),
            $c3c80580245b1da4$var$gradient(4, '#71717a', '#52525b'),
            $c3c80580245b1da4$var$gradient(3, '#71717a', '#52525b'),
            $c3c80580245b1da4$var$gradient(2, '#71717a', '#52525b'),
            $c3c80580245b1da4$var$gradient(1, '#71717a', '#52525b')
        ]
    })
});
function $c3c80580245b1da4$var$gradient(level, from, to) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("linearGradient", {
        id: $c3c80580245b1da4$export$b06b879d73ad6baf(level),
        x1: "1",
        y1: "0",
        x2: "0",
        y2: "0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                offset: "0%",
                stopColor: from
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("stop", {
                offset: "100%",
                stopColor: to
            })
        ]
    });
}
// Update in sync with `masterySquareBorderGradientDefs` above.
// Define some `text-...` for `<ChampionTooltip />` better contrast (default: black)
const $c3c80580245b1da4$var$masteryHistogramGradientClassName = {
    10: 'from-[#f3eafb] via-[#fffad8] to-[#c8fdfc] text-black',
    9: 'from-[#d2651b] to-[#8e3d25] text-shadow',
    8: 'from-[#8d12c9] to-[#560292] text-shadow',
    7: 'from-[#0369a1] to-[#324bd0] text-shadow',
    6: 'from-[#329055] to-[#266846] text-shadow',
    5: 'from-[#94a3b8] to-[#475569] text-shadow',
    4: 'from-[#71717a] to-[#52525b] text-shadow',
    3: 'from-[#71717a] to-[#52525b] text-shadow',
    2: 'from-[#71717a] to-[#52525b] text-shadow',
    1: 'from-[#71717a] to-[#52525b] text-shadow'
};
// Need iife for Tailwind extension to work ✨
const $c3c80580245b1da4$var$masteryTextColorClassName = (()=>{
    const className = {
        10: 'text-[#f3eafb]',
        9: 'text-[#f6a738]',
        8: 'text-[#e752fb]',
        7: 'text-[#3b82f6]',
        6: 'text-[#22c55e]',
        5: 'text-[#cbd5e1]'
    };
    return className;
})();
const $c3c80580245b1da4$var$masteryTextColorDefaultClassName = 'text-[#d4d4d4]';
const $c3c80580245b1da4$var$masteryRulerColorClassName = (()=>{
    const className = {
        10: 'border-grey-500',
        8: 'border-grey-500',
        7: 'border-grey-500'
    };
    return className;
})();
const $c3c80580245b1da4$var$masteryRulerColorDefaultClassName = 'border-grey-400';
function $c3c80580245b1da4$export$910cc3307d8b09db(championLevel) {
    const level = $c3c80580245b1da4$var$clampChampionLevel(championLevel);
    if (level === 0) return undefined;
    return $c3c80580245b1da4$var$masteryBgColorClassName[level];
}
function $c3c80580245b1da4$export$b06b879d73ad6baf(championLevel) {
    return `linear-${$c3c80580245b1da4$var$clampChampionLevel(championLevel)}`;
}
function $c3c80580245b1da4$export$ba5db2e5993f4709(championLevel) {
    const level = $c3c80580245b1da4$var$clampChampionLevel(championLevel);
    if (level === 0) return undefined;
    const commonClassName = 'bg-gradient-to-br from-30% to-80%';
    return (0, $jK7ok.cx)(commonClassName, $c3c80580245b1da4$var$masteryHistogramGradientClassName[level]);
}
function $c3c80580245b1da4$export$5d6f9a79aaea5f31(championLevel) {
    return $c3c80580245b1da4$var$masteryTextColorClassName[$c3c80580245b1da4$var$clampChampionLevel(championLevel)] ?? $c3c80580245b1da4$var$masteryTextColorDefaultClassName;
}
function $c3c80580245b1da4$export$9842f088a6739769(championLevel) {
    return $c3c80580245b1da4$var$masteryRulerColorClassName[$c3c80580245b1da4$var$clampChampionLevel(championLevel)] ?? $c3c80580245b1da4$var$masteryRulerColorDefaultClassName;
}
/**
 * @param championLevel Should be >= 0
 */ function $c3c80580245b1da4$var$clampChampionLevel(championLevel) {
    return Math.min(championLevel, 10);
}



var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $jFynM = parcelRequire("jFynM");

var $3KgVG = parcelRequire("3KgVG");
const $5830f7eb344f362f$export$1d957f0f68a69614 = ({ faction: faction, className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $3KgVG.MaskedImage), {
        src: (0, $jFynM.Assets).factions[faction],
        className: className
    });



var $ih19M = parcelRequire("ih19M");

var $ih19M = parcelRequire("ih19M");
const $9ac485fb8c3c7749$export$f7842826a842b266 = {
    top: ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    opacity: "0.5",
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M21,14H14v7h7V14Zm5-3V26L11.014,26l-4,4H30V7.016Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                    fill: "currentColor",
                    points: "4 4 4.003 28.045 9 23 9 9 23 9 28.045 4.003 4 4"
                })
            ]
        }),
    jun: ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M25,3c-2.128,3.3-5.147,6.851-6.966,11.469A42.373,42.373,0,0,1,20,20a27.7,27.7,0,0,1,1-3C21,12.023,22.856,8.277,25,3ZM13,20c-1.488-4.487-4.76-6.966-9-9,3.868,3.136,4.422,7.52,5,12l3.743,3.312C14.215,27.917,16.527,30.451,17,31c4.555-9.445-3.366-20.8-8-28C11.67,9.573,13.717,13.342,13,20Zm8,5a15.271,15.271,0,0,1,0,2l4-4c0.578-4.48,1.132-8.864,5-12C24.712,13.537,22.134,18.854,21,25Z"
            })
        }),
    mid: ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    opacity: "0.5",
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M30,12.968l-4.008,4L26,26H17l-4,4H30ZM16.979,8L21,4H4V20.977L8,17,8,8h8.981Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                    fill: "currentColor",
                    points: "25 4 4 25 4 30 9 30 30 9 30 4 25 4"
                })
            ]
        }),
    bot: ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    opacity: "0.5",
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M13,20h7V13H13v7ZM4,4V26.984l3.955-4L8,8,22.986,8l4-4H4Z"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                    fill: "currentColor",
                    points: "29.997 5.955 25 11 25 25 11 25 5.955 29.997 30 30 29.997 5.955"
                })
            ]
        }),
    sup: ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M26,13c3.535,0,8-4,8-4H23l-3,3,2,7,5-2-3-4h2ZM22,5L20.827,3H13.062L12,5l5,6Zm-5,9-1-1L13,28l4,3,4-3L18,13ZM11,9H0s4.465,4,8,4h2L7,17l5,2,2-7Z"
            })
        })
};


const $2fef2422e6a814aa$export$12e8b9f23d53a496 = ({ position: position, className: className })=>{
    const Position = (0, $9ac485fb8c3c7749$export$f7842826a842b266)[position];
    return /*#__PURE__*/ (0, $ih19M.jsx)(Position, {
        className: className
    });
};


const $71c737632df86b04$export$c5545b89bafb388 = ({ masteries: masteries, name: name, shardsCount: shardsCount, positions: positions, factions: factions })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const percentsElement = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: "relative flex items-center py-0.5 pl-1.5 font-semibold shadow-black text-shadow",
        children: masteries !== undefined ? t.common.percents(Math.round(masteries.percents)) : t.masteries.unknownPercents
    });
    const tokenShards = (0, $f5id0.pipe)([
        masteries !== undefined && 0 < masteries.markRequiredForNextLevel ? (0, $sjwE0.Maybe).some(/*#__PURE__*/ (0, $ih19M.jsx)("span", {
            children: t.masteries.nMarksOfMastery(masteries.tokensEarned, masteries.markRequiredForNextLevel)
        }, "tokens")) : (0, $sjwE0.Maybe).none,
        (0, $f5id0.pipe)(shardsCount, (0, $sjwE0.Maybe).map((shards)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: t.masteries.nShards(shards)
            }, "shards")))
    ], (0, $sjwE0.List).compact, (0, $sjwE0.NonEmptyArray).fromReadonlyArray);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "relative flex overflow-hidden border-b border-tooltip",
                children: [
                    percentsElement,
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "absolute left-0",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "absolute -right-2 -top-4 size-[200%] rotate-12 bg-goldenrod-bis shadow-inner shadow-black"
                            }),
                            percentsElement
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                        className: (0, $jK7ok.cx)('grow py-0.5 pl-4 pr-2 text-center font-bold shadow-black', (0, $c3c80580245b1da4$export$ba5db2e5993f4709)(masteries?.championLevel ?? 0)),
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                className: "border-b border-tooltip px-2 py-1 text-center",
                children: masteries !== undefined ? t.masteries.points(masteries.championPoints, masteries.championPoints + masteries.championPointsUntilNextLevel, 'font-semibold') : t.masteries.unknownPoints('font-semibold')
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex grow flex-col items-center justify-center gap-1 px-2 py-1",
                children: [
                    (0, $f5id0.pipe)(tokenShards, (0, $sjwE0.Maybe).fold(()=>null, (nea)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "flex items-center gap-2",
                            children: nea
                        }))),
                    /*#__PURE__*/ (0, $ih19M.jsx)($71c737632df86b04$export$135d860430810669, {
                        positions: positions,
                        factions: factions
                    })
                ]
            })
        ]
    });
};
const $71c737632df86b04$export$135d860430810669 = ({ positions: positions, factions: factions })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    return /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
        className: "flex w-full max-w-41 flex-wrap items-center justify-center gap-x-3 gap-y-0.5",
        children: [
            (0, $sjwE0.List).isNonEmpty(positions) ? (0, $f5id0.pipe)(positions, (0, $sjwE0.NonEmptyArray).map((position)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                    className: "flex items-center gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $2fef2422e6a814aa$export$12e8b9f23d53a496), {
                            position: position,
                            className: "size-6 shrink-0 p-0.5 text-wheat-bis"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            children: t.labels.position[position]
                        })
                    ]
                }, position))) : null,
            (0, $sjwE0.List).isNonEmpty(factions) ? (0, $f5id0.pipe)(factions, (0, $sjwE0.NonEmptyArray).map((faction)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                    className: "flex items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $5830f7eb344f362f$export$1d957f0f68a69614), {
                            faction: faction,
                            className: "size-5 text-wheat-bis"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            children: t.labels.faction[faction]
                        })
                    ]
                }, faction))) : null
        ]
    });
};



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");
const $1576edad88dbd003$export$6028b0e8199948bf = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function({ championKey: championKey, championName: championName, as: as = 'div', className: className, children: children, ...props }, ref) {
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { assets: assets } = (0, $6H0K7.useStaticData)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $bh6RR.createElement)(as, {
            ...props,
            ref: ref,
            className: (0, $jK7ok.cx)('overflow-hidden', className)
        }, /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: assets.champion.square(championKey),
            alt: t.championIconAlt(championName),
            className: "m-[-6%] w-[112%] max-w-none"
        }), children)
    });
});



var $ih19M = parcelRequire("ih19M");

var $gwlG1 = parcelRequire("gwlG1");
const $10c33ecf202858d4$export$24a214d9165f464d = ({ href: href })=>/*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        className: "mt-24 flex items-center gap-2 self-center text-sm",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.OpenInNew), {
                className: "invisible size-3.5"
            }),
            " ",
            /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noreferrer",
                className: "peer border-b border-b-wheat/50 transition-all duration-100 hover:border-b-goldenrod",
                children: href
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.OpenInNew), {
                className: "invisible size-3.5 opacity-0 transition-all duration-100 peer-hover:visible peer-hover:opacity-100"
            })
        ]
    });



var $es0HS = parcelRequire("es0HS");

var $ih19M = parcelRequire("ih19M");

var $bFSl4 = parcelRequire("bFSl4");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $es0HS = parcelRequire("es0HS");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lyBkQ = parcelRequire("lyBkQ");

var $4MEuc = parcelRequire("4MEuc");

var $f5id0 = parcelRequire("f5id0");

var $2DVbf = parcelRequire("2DVbf");

var $jTWFQ = parcelRequire("jTWFQ");

var $sjwE0 = parcelRequire("sjwE0");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $d311e1d1f335f84f$var$MapChangeStat(name, value) {
    return {
        type: 'stat',
        name: name,
        value: value
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $d311e1d1f335f84f$var$MapChangeSkill(skill, changes) {
    return {
        type: 'skill',
        skill: skill,
        changes: changes
    };
}
function $d311e1d1f335f84f$export$90c20a432e29f511(data) {
    const maybes = (0, $f5id0.pipe)([
        (0, $f5id0.pipe)(data.stats, (0, $sjwE0.Maybe).chain((stats)=>(0, $f5id0.pipe)((0, $2DVbf.WikiStatsBalance).keys, (0, $sjwE0.List).filterMap((key)=>(0, $f5id0.pipe)((0, $sjwE0.Dict).lookup(key, stats), (0, $sjwE0.Maybe).map((value)=>$d311e1d1f335f84f$var$MapChangeStat(key, value)))), (0, $sjwE0.NonEmptyArray).fromReadonlyArray))),
        (0, $f5id0.pipe)(data.skills, (0, $sjwE0.Maybe).chain((skills)=>(0, $f5id0.pipe)((0, $jTWFQ.Skill).values, (0, $sjwE0.List).filterMap((skill)=>(0, $f5id0.pipe)((0, $sjwE0.Dict).lookup(skill, skills), (0, $sjwE0.Maybe).map((changes)=>$d311e1d1f335f84f$var$MapChangeSkill(skill, changes)))), (0, $sjwE0.NonEmptyArray).fromReadonlyArray)))
    ]);
    return (0, $f5id0.pipe)(maybes, (0, $sjwE0.List).compact, (0, $sjwE0.List).chain((0, $f5id0.identity)));
}
const $d311e1d1f335f84f$export$35cd56382745d8d0 = ({ limit: limitSize, ...sizes })=>(data)=>$d311e1d1f335f84f$var$splitWhileSmallerThanRec(sizes, limitSize, data, []);
function $d311e1d1f335f84f$var$splitWhileSmallerThanRec(sizes, limitSize, data, acc) {
    if (limitSize < 0) return {
        left: acc,
        right: data
    };
    const [head, ...tail] = data;
    if (head === undefined) return {
        left: acc,
        right: tail
    };
    return $d311e1d1f335f84f$var$splitWhileSmallerThanRec(sizes, limitSize - sizes[head.type], tail, (0, $f5id0.pipe)(acc, (0, $sjwE0.List).append(head)));
}



var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $2DVbf = parcelRequire("2DVbf");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $jFynM = parcelRequire("jFynM");

var $jK7ok = parcelRequire("jK7ok");
const $012fc4ed5defaf60$export$728851338d8b3809 = ({ name: name, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('mapChanges');
    return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
        src: (0, $jFynM.Assets).stats[name],
        alt: t.statIconAlt(name),
        className: (0, $jK7ok.cx)('shrink-0 bg-contain brightness-75 sepia', className)
    });
};
const $012fc4ed5defaf60$export$2cc79ca546e3ab80 = ({ name: name, value: value })=>{
    const isMalusStat = (0, $2DVbf.WikiStatsBalance).isMalusStat(name);
    const maybeUnit = (0, $2DVbf.WikiStatsBalance).isPercentsStat(name) ? (0, $sjwE0.Maybe).some('%') : (0, $sjwE0.Maybe).none;
    const n = (0, $2DVbf.WikiStatsBalance).isModifierStat(name) ? (value * 1000 - 1000) / 10 : value;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        className: (0, $jK7ok.cx)('flex shrink-0 font-lib-mono', (isMalusStat ? 0 < n : n < 0) ? 'text-red' : 'text-green'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                children: [
                    n < 0 ? null : '+',
                    n
                ]
            }),
            (0, $f5id0.pipe)(maybeUnit, (0, $sjwE0.Maybe).fold(()=>null, (u)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    children: u
                })))
        ]
    });
};


const $807a530abaaa1acf$export$8c094cd568b6439e = ({ data: data })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const changes = (0, $bh6RR.useMemo)(()=>(0, $d311e1d1f335f84f$export$90c20a432e29f511)(data), [
        data
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
        className: "grid max-w-sm grid-cols-[auto_1fr] items-center gap-y-2 py-1",
        children: changes.map((c)=>{
            switch(c.type){
                case 'stat':
                    return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                        className: "contents",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex items-center gap-2 pr-2",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $012fc4ed5defaf60$export$728851338d8b3809), {
                                        name: c.name,
                                        className: "size-4"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "grow",
                                        children: t.common.labels.wikiStatsBalance[c.name]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $012fc4ed5defaf60$export$2cc79ca546e3ab80), {
                                name: c.name,
                                value: c.value
                            })
                        ]
                    }, c.name);
                case 'skill':
                    return /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                        className: "col-span-2",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                            className: "flex flex-col gap-1",
                            children: Array.from(c.changes.abilities.entries()).map(([ability, { icon: icon, description: description }])=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: icon
                                                    },
                                                    className: "wiki large mr-1"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: (0, $lyBkQ.Ability).unwrap(c.changes.name)
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: t.mapChanges.skill(c.skill)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            },
                                            className: "wiki"
                                        })
                                    ]
                                }, (0, $lyBkQ.Ability).unwrap(ability)))
                        })
                    }, c.skill);
            }
        })
    });
};




var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");

const $d83a2e94fbf72603$export$9e4948ce114eaafb = {
    stat: 3,
    skill: 5
};
const $d83a2e94fbf72603$export$4c157fb38ec75dc = ({ name: name, value: value, reverse: reverse = false })=>{
    const elems = (0, $f5id0.pipe)([
        /*#__PURE__*/ (0, $ih19M.jsx)((0, $012fc4ed5defaf60$export$728851338d8b3809), {
            name: name,
            className: "size-2.5"
        }, "icon"),
        /*#__PURE__*/ (0, $ih19M.jsx)((0, $012fc4ed5defaf60$export$2cc79ca546e3ab80), {
            name: name,
            value: value
        }, "value")
    ], reverse ? (0, $sjwE0.List).reverse : (0, $f5id0.identity));
    return /*#__PURE__*/ (0, $ih19M.jsx)("li", {
        className: $d83a2e94fbf72603$var$gridClassName(reverse),
        children: elems
    });
};
const $d83a2e94fbf72603$export$8eae7b5b63fcf71d = ({ skill: skill, changes: changes, reverse: reverse = false })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const elems = (0, $f5id0.pipe)([
        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: changes.icon
            },
            className: "wiki compact"
        }, "html"),
        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            children: t.labels.skill[skill]
        }, "name")
    ], reverse ? (0, $sjwE0.List).reverse : (0, $f5id0.identity));
    return /*#__PURE__*/ (0, $ih19M.jsx)("li", {
        className: $d83a2e94fbf72603$var$gridClassName(reverse),
        children: elems
    });
};
function $d83a2e94fbf72603$var$gridClassName(reverse) {
    return (0, $jK7ok.cx)('grid items-center gap-1', reverse ? 'grid-cols-[1fr_max-content] justify-items-end' : 'grid-cols-[max-content_1fr]');
}


const $485b132d5e168e49$export$8feb69f2a1cfb779 = 'grid grid-cols-[auto_1fr] grid-rows-[auto_1fr] rounded-lg bg-aram-stats text-2xs';
const $485b132d5e168e49$export$60aa91691c7ccf90 = ({ tooltiPlacementRef: tooltiPlacementRef, wrapAfterSize: wrapAfterSize, data: data })=>{
    const initialRef = (0, $bh6RR.useRef)(null);
    const moreRef = (0, $bh6RR.useRef)(null);
    const { initial: initial, more: more } = (0, $bh6RR.useMemo)(()=>$485b132d5e168e49$var$partitionStatsWrap(wrapAfterSize, data), [
        data,
        wrapAfterSize
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                ref: initialRef,
                className: "row-span-2 grid place-items-center",
                children: (0, $sjwE0.List).isNonEmpty(initial) && /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                    className: "p-0.5",
                    children: initial
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                ref: moreRef,
                className: "grid items-end justify-items-center",
                children: (0, $sjwE0.List).isNonEmpty(more) && /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                    className: "p-0.5",
                    children: more
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: [
                    initialRef,
                    moreRef
                ],
                placementRef: tooltiPlacementRef,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $807a530abaaa1acf$export$8c094cd568b6439e), {
                    data: data
                })
            })
        ]
    });
};
/**
 * Puts elements in `initial` until `wrapAfterSize` is reached.
 * Then puts remaining even elements in `more`, and appends odd elements to `initial`.
 *
 * @param wrapAfterSize should be `imageSize - 2 x paddingYSize`
 */ function $485b132d5e168e49$var$partitionStatsWrap(wrapAfterSize, data) {
    const { left: initial, right: more } = (0, $f5id0.pipe)((0, $d311e1d1f335f84f$export$90c20a432e29f511)(data), (0, $d311e1d1f335f84f$export$35cd56382745d8d0)({
        ...(0, $d83a2e94fbf72603$export$9e4948ce114eaafb),
        limit: wrapAfterSize
    }), $485b132d5e168e49$var$evenOddRights, (0, $bFSl4).bimap($485b132d5e168e49$var$toElements, $485b132d5e168e49$var$toElements));
    return {
        initial: initial,
        more: more
    };
}
const $485b132d5e168e49$var$toElements = (0, $sjwE0.List).map((change)=>{
    switch(change.type){
        case 'stat':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d83a2e94fbf72603$export$4c157fb38ec75dc), {
                name: change.name,
                value: change.value
            }, change.name);
        case 'skill':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d83a2e94fbf72603$export$8eae7b5b63fcf71d), {
                skill: change.skill,
                changes: change.changes
            }, change.skill);
    }
});
function $485b132d5e168e49$var$evenOddRights({ left: left, right: right }) {
    const { left: odds, right: evens } = (0, $f5id0.pipe)(right, (0, $sjwE0.List).partitionWithIndex((i)=>i % 2 === 0));
    return {
        left: (0, $f5id0.pipe)(left, (0, $sjwE0.List).concat(odds)),
        right: evens
    };
}



const { cleanChampionName: $6832416c36d6fed8$var$cleanChampionName } = (0, $dOJeV.StringUtils);
const $6832416c36d6fed8$export$7cf138d016f88fdb = (wikiLink, getData)=>()=>{
        const { genericQuery: genericQuery, updateGenericQuery: updateGenericQuery } = (0, $9xM77.useHistory)();
        const { t: t } = (0, $4MEuc.useTranslation)('common');
        const { champions: champions } = (0, $6H0K7.useStaticData)();
        const { filteredAndSortedChampions: filteredAndSortedChampions, searchCount: searchCount } = (0, $bh6RR.useMemo)(()=>{
            const sortedChampions = (0, $f5id0.pipe)(champions, (0, $sjwE0.List).map((c)=>({
                    ...c,
                    isHidden: !(0, $f5id0.pipe)(genericQuery.search, (0, $sjwE0.Maybe).every((search)=>$6832416c36d6fed8$var$cleanChampionName(c.name).includes($6832416c36d6fed8$var$cleanChampionName(search)))),
                    category: (0, $7432f0671d5622f7$export$dc50577efab52c43).fromData(getData(c))
                })), (0, $sjwE0.List).sort((0, $25oLT.StaticDataChampion).Ord.byName));
            const grouped = (0, $f5id0.pipe)(sortedChampions, (0, $sjwE0.List).groupBy((a)=>a.isHidden ? 'hidden' : a.category));
            return {
                filteredAndSortedChampions: (0, $f5id0.pipe)((0, $7432f0671d5622f7$export$dc50577efab52c43).values, (0, $sjwE0.List).reduce((0, $sjwE0.List).empty(), (acc, category)=>(0, $f5id0.pipe)(acc, (0, $sjwE0.List).concat(grouped[category] ?? []))), (0, $sjwE0.List).concat(grouped.hidden ?? [])),
                searchCount: (0, $f5id0.pipe)(sortedChampions, (0, $sjwE0.List).filter((c)=>!c.isHidden), (0, $sjwE0.List).size)
            };
        }, [
            champions,
            genericQuery.search
        ]);
        const onSearchChange = (0, $bh6RR.useMemo)(()=>(0, $f5id0.flow)((0, $2EH2o.GenericQuery).Lens.search.set, updateGenericQuery), [
            updateGenericQuery
        ]);
        const randomChampion = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(filteredAndSortedChampions, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $f5id0.flow)((0, $2566e9e25df745a4$exports).randomElem, (0, $4lr6f).map((m)=>{
                updateGenericQuery((0, $2EH2o.GenericQuery).Lens.search.set((0, $sjwE0.Maybe).some(m.name)));
                return m.name;
            })))), [
            filteredAndSortedChampions,
            updateGenericQuery
        ]);
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex size-full flex-col overflow-y-auto px-2 pb-24 pt-3",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $755ee31adc777f55$export$bb60b672622fdba0), {
                        searchCount: searchCount,
                        randomChampion: randomChampion,
                        initialSearch: genericQuery.search,
                        onChange: onSearchChange,
                        className: "self-center"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "grid w-full grid-cols-[repeat(auto-fit,1px)] items-start gap-x-3.75 gap-y-1",
                        children: (0, $f5id0.pipe)(filteredAndSortedChampions, (0, $iPRex.ListUtils).mapWithPrevious((maybePrev, c)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
                                children: [
                                    !c.isHidden && !(0, $f5id0.pipe)(maybePrev, (0, $sjwE0.Maybe).exists((prev)=>(0, $7432f0671d5622f7$export$dc50577efab52c43).Eq.equals(prev.category, c.category))) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $0928d021cbbf7cbd$export$13c8a39fad75a36b), {
                                        category: c.category,
                                        className: "pt-4"
                                    }) : null,
                                    /*#__PURE__*/ (0, $ih19M.jsx)($6832416c36d6fed8$var$Champion, {
                                        getData: getData,
                                        champion: c
                                    })
                                ]
                            }, (0, $br0yu.ChampionKey).unwrap(c.key))))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "mt-6 self-center",
                        children: t.nChampionsFraction(searchCount, champions.length)
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $10c33ecf202858d4$export$24a214d9165f464d), {
                        href: wikiLink
                    })
                ]
            })
        });
    };
const $6832416c36d6fed8$var$Champion = ({ getData: getData, champion: champion })=>{
    const containerRef = (0, $bh6RR.useRef)(null);
    const championRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: containerRef,
        className: (0, $jK7ok.cx)((0, $485b132d5e168e49$export$8feb69f2a1cfb779), (0, $7432f0671d5622f7$export$dc50577efab52c43).fromData(getData(champion)) !== 'balanced' ? 'col-span-7' : 'col-span-4', [
            'hidden',
            champion.isHidden
        ]),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1576edad88dbd003$export$6028b0e8199948bf), {
                ref: championRef,
                championKey: champion.key,
                championName: champion.name,
                className: "size-12 rounded-lg shadow-even shadow-black"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: championRef,
                placement: "top",
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                        className: "self-center px-2 font-bold shadow-black text-shadow",
                        children: champion.name
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $71c737632df86b04$export$135d860430810669), {
                        positions: champion.positions,
                        factions: champion.factions
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $485b132d5e168e49$export$60aa91691c7ccf90), {
                tooltiPlacementRef: containerRef,
                wrapAfterSize: 11,
                data: getData(champion)
            })
        ]
    });
};


const $521ea6eb53652e14$export$97895786af974272 = (0, $6832416c36d6fed8$export$7cf138d016f88fdb)('https://wiki.leagueoflegends.com/en-us/ARAM#Mode-Specific_Changes', (c)=>c.aram);



var $ih19M = parcelRequire("ih19M");

var $6IQDS = parcelRequire("6IQDS");

var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $3WFZ7 = parcelRequire("3WFZ7");

var $k8rBo = parcelRequire("k8rBo");

var $1GV7y = parcelRequire("1GV7y");

var $jPaL5 = parcelRequire("jPaL5");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $hHBpg = parcelRequire("hHBpg");
const { unwrap: $638c0d8a40986743$var$unwrap } = (0, $1k68G.iso)();
const $638c0d8a40986743$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $638c0d8a40986743$export$fb03e79d05d8f11e = {
    unwrap: $638c0d8a40986743$var$unwrap,
    codec: $638c0d8a40986743$var$codec
};


const $69a6c31a14354d84$var$codec = $jPaL5.struct({
    code: (0, $638c0d8a40986743$export$fb03e79d05d8f11e).codec
});
const $69a6c31a14354d84$export$c138c21223413590 = {
    codec: $69a6c31a14354d84$var$codec
};




var $sjwE0 = parcelRequire("sjwE0");

var $9g4gL = parcelRequire("9g4gL");

var $hnBhT = parcelRequire("hnBhT");

var $36sK8 = parcelRequire("36sK8");

var $9xM77 = parcelRequire("9xM77");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");

var $gE3ky = parcelRequire("gE3ky");

var $7VlB6 = parcelRequire("7VlB6");

var $2sln7 = parcelRequire("2sln7");

var $dk6Sm = parcelRequire("dk6Sm");
const $80162b5831b6fb55$var$apiCallDelay = (0, $1GV7y.MsDuration).milliseconds(100);
const $80162b5831b6fb55$var$apiRoute = (0, $k8rBo.apiRoutes).user.login.discord.post;
const $80162b5831b6fb55$var$codeDecoder = $4BSZX.struct({
    code: (0, $638c0d8a40986743$export$fb03e79d05d8f11e).codec
});
const $80162b5831b6fb55$export$288f4777bbf2f735 = ()=>{
    const { query: query } = (0, $9xM77.useHistory)();
    return (0, $f5id0.pipe)($80162b5831b6fb55$var$codeDecoder.decode(query), (0, $sjwE0.Either).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $dk6Sm.NotFound), {}), ({ code: code })=>/*#__PURE__*/ (0, $ih19M.jsx)($80162b5831b6fb55$var$DiscordRedirectValidated, {
            code: code
        })));
};
const $80162b5831b6fb55$var$DiscordRedirectValidated = ({ code: code })=>{
    const { refreshUser: refreshUser } = (0, $j30iL.useUser)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { data: data, error: error } = (0, $3WFZ7.default)([
        ...$80162b5831b6fb55$var$apiRoute,
        code
    ], ([url, method, code_])=>(0, $f5id0.pipe)((0, $6IQDS).sequenceT((0, $sjwE0.Future).ApplyPar)((0, $f5id0.pipe)((0, $2sln7.http)([
            url,
            method
        ], {
            json: [
                (0, $69a6c31a14354d84$export$c138c21223413590).codec,
                {
                    code: code_
                }
            ]
        }), (0, $sjwE0.Future).chain(()=>refreshUser)), (0, $f5id0.pipe)((0, $sjwE0.Future).notUsed, (0, $sjwE0.Future).delay($80162b5831b6fb55$var$apiCallDelay))), (0, $7VlB6.futureRunUnsafe)), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
                data: data,
                error: error,
                children: ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $36sK8.Navigate), {
                        to: (0, $gE3ky.appRoutes).index,
                        replace: true
                    })
            }),
            error !== undefined ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                    to: (0, $gE3ky.appRoutes).index,
                    className: "mt-4 underline",
                    children: t.layout.home
                })
            }) : null
        ]
    });
};


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $4lr6f = parcelRequire("4lr6f");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $bh6RR = parcelRequire("bh6RR");

var $vkIKL = parcelRequire("vkIKL");

var $br0yu = parcelRequire("br0yu");

var $25oLT = parcelRequire("25oLT");

var $iPRex = parcelRequire("iPRex");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $8i6VY = parcelRequire("8i6VY");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $aGpBO = parcelRequire("aGpBO");

var $895LH = parcelRequire("895LH");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");

var $es0HS = parcelRequire("es0HS");
const $af8b81a03dc88b84$var$imgSrc = (id, tier)=>(0, $aGpBO.DDragonUtils).ddragon(`/cdn/img/challenges-images/${id}-${tier}.png`);
const $af8b81a03dc88b84$export$a50dcf13e7b62e9d = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ id: id, tier: tier, className: className }, ref)=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const src = $af8b81a03dc88b84$var$imgSrc(id, (0, $f5id0.pipe)(tier, (0, $sjwE0.Maybe).getOrElse(()=>'BRONZE')));
    const alt = t.challenge.iconAlt(id);
    return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
        ref: ref,
        src: src,
        alt: alt,
        className: (0, $jK7ok.cx)([
            'grayscale',
            (0, $sjwE0.Maybe).isNone(tier)
        ], className)
    });
});
const $af8b81a03dc88b84$export$199960b3365d3c01 = ({ id: id, tier: tier, value: maybeValue, thresholds: thresholds, iconClassName: iconClassName })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const hoverRef = (0, $bh6RR.useRef)(null);
    const placementRef = (0, $bh6RR.useRef)(null);
    const src = $af8b81a03dc88b84$var$imgSrc(id, (0, $f5id0.pipe)(tier, (0, $sjwE0.Maybe).getOrElse(()=>'BRONZE')));
    const alt = t.challenge.iconAlt(id);
    const value = (0, $f5id0.pipe)(maybeValue, (0, $sjwE0.Maybe).getOrElse(()=>0));
    const values = (0, $895LH.DictUtils).partial.values(thresholds);
    const total = (0, $f5id0.pipe)(values, (0, $sjwE0.List).filter((n)=>value < n), (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $sjwE0.NonEmptyArray).min((0, $10ZIc).Ord)), (0, $sjwE0.Maybe).alt(()=>(0, $f5id0.pipe)(values, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $sjwE0.NonEmptyArray).max((0, $10ZIc).Ord)))), (0, $sjwE0.Maybe).getOrElse(()=>0));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                ref: hoverRef,
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        ref: placementRef,
                        src: src,
                        alt: alt,
                        className: (0, $jK7ok.cx)([
                            'grayscale',
                            (0, $sjwE0.Maybe).isNone(tier)
                        ], iconClassName)
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "font-semibold",
                        children: t.fraction(value, total)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: hoverRef,
                placementRef: placementRef,
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "pl-1 pt-1",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                    src: src,
                                    alt: alt,
                                    className: (0, $jK7ok.cx)('size-20', [
                                        'grayscale',
                                        (0, $sjwE0.Maybe).isNone(tier)
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex flex-col self-center",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "flex items-baseline gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                children: t.challenge.challenge
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                                className: "font-bold",
                                                children: t.labels.challenge(id)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "pt-1",
                                        children: t.labels.challengeShort(id)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "flex gap-2 pt-2",
                                        children: [
                                            (0, $f5id0.pipe)(tier, (0, $sjwE0.Maybe).fold(()=>null, (t_)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: t.labels.leagueTier[t_]
                                                }))),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                children: t.fraction(value, total)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-wrap gap-2 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                children: t.challenge.thresholds
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                className: "flex flex-wrap gap-1.5 italic",
                                children: (0, $f5id0.pipe)(thresholds, (0, $895LH.DictUtils).partial.entries, (entries)=>entries.map(([key, val], i)=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                            children: t.challenge.valueTier(val ?? 0, key, {
                                                withComma: i !== entries.length - 1
                                            })
                                        }, key)))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $fVW4p = parcelRequire("fVW4p");

var $kmQDF = parcelRequire("kmQDF");

var $es0HS = parcelRequire("es0HS");
const $f556a3f1cb290003$export$2978b4beac7a3c02 = ({ challenges: challenges, faction: faction, count: { count: count, total: total }, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: (0, $jK7ok.cx)('col-span-full flex', className),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "flex items-baseline gap-4",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        faction !== 'none' ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5830f7eb344f362f$export$1d957f0f68a69614), {
                            faction: faction,
                            className: "size-7"
                        }) : null,
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "font-semibold",
                            children: t.labels.factionOrNone[faction]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            ref: ref,
                            className: "text-sm",
                            children: t.fraction(count, total, {
                                withParenthesis: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                    hoverRef: ref,
                    children: t.nChampionsFraction(count, total)
                }),
                faction !== 'none' ? (0, $f5id0.pipe)(challenges, (0, $sjwE0.Maybe).fold(()=>null, ({ data: data, error: error })=>error !== undefined ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmQDF.Pre), {
                        children: "error"
                    }) : data === undefined ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                        className: "h-4"
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $af8b81a03dc88b84$export$199960b3365d3c01), {
                        id: (0, $8i6VY.ChallengesView).id[faction],
                        tier: (0, $f5id0.pipe)(data[faction], (0, $sjwE0.Maybe).chain((c)=>c.level)),
                        value: (0, $f5id0.pipe)(data[faction], (0, $sjwE0.Maybe).map((c)=>c.value)),
                        thresholds: $f556a3f1cb290003$var$thresholds,
                        iconClassName: "h-7"
                    }))) : null
            ]
        })
    });
};
const $f556a3f1cb290003$var$thresholds = {
    GOLD: 1,
    PLATINUM: 3,
    DIAMOND: 6,
    MASTER: 10
};







var $tA0jd = parcelRequire("tA0jd");

var $es0HS = parcelRequire("es0HS");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");
const $873f54152d46e5ce$var$empty = {
    count: 0,
    total: 0
};
const $873f54152d46e5ce$export$1b9130a9fda2eb88 = {
    empty: $873f54152d46e5ce$var$empty
};



var $2EH2o = parcelRequire("2EH2o");

var $12uqT = parcelRequire("12uqT");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");

var $dOJeV = parcelRequire("dOJeV");
const { cleanUTF8ToASCII: $fdf08e5d15d06772$var$cleanUTF8ToASCII } = (0, $dOJeV.StringUtils);
const $fdf08e5d15d06772$export$6a3aa170c29c42fa = {
    Ord: {
        byLabel: (t)=>(0, $f5id0.pipe)((0, $68YxT).Ord, (0, $12uqT).contramap((f)=>$fdf08e5d15d06772$var$cleanUTF8ToASCII(t.labels.faction[f])))
    }
};



var $jK7ok = parcelRequire("jK7ok");
const { cleanChampionName: $082766cbe57dda99$var$cleanChampionName } = (0, $dOJeV.StringUtils);
const $082766cbe57dda99$var$EnrichedStaticDataChampion = {
    Lens: {
        faction: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('faction'))
    }
};
const $082766cbe57dda99$export$c454e4c3445e22b1 = ()=>{
    const { genericQuery: genericQuery, updateGenericQuery: updateGenericQuery } = (0, $9xM77.useHistory)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { champions: champions } = (0, $6H0K7.useStaticData)();
    const { filteredAndSortedChampions: filteredAndSortedChampions, factionsCount: factionsCount, searchCount: searchCount } = (0, $bh6RR.useMemo)(()=>{
        const sortedChampions = (0, $f5id0.pipe)(champions, (0, $sjwE0.List).map((c)=>({
                ...c,
                isHidden: !(0, $f5id0.pipe)(genericQuery.search, (0, $sjwE0.Maybe).every((search)=>$082766cbe57dda99$var$cleanChampionName(c.name).includes($082766cbe57dda99$var$cleanChampionName(search)))),
                faction: (0, $25oLT.StaticDataChampion).getFaction(c.factions)
            })), (0, $sjwE0.List).sort((0, $25oLT.StaticDataChampion).Ord.byName));
        const grouped = (0, $f5id0.pipe)(sortedChampions, (0, $iPRex.ListUtils).multipleGroupBy((c)=>{
            if (c.isHidden) return [
                'hidden'
            ];
            if ((0, $sjwE0.List).isNonEmpty(c.factions)) return c.factions;
            return [
                'none'
            ];
        }), (0, $sjwE0.PartialDict).mapWithIndex((faction, champions_)=>(0, $f5id0.pipe)(champions_, (0, $sjwE0.NonEmptyArray).map((c)=>faction === 'hidden' ? c : (0, $f5id0.pipe)(c, $082766cbe57dda99$var$EnrichedStaticDataChampion.Lens.faction.set(faction))))));
        const factionsCount_ = (0, $f5id0.pipe)(sortedChampions, (0, $iPRex.ListUtils).multipleGroupBy((c)=>(0, $sjwE0.List).isNonEmpty(c.factions) ? c.factions : [
                'none'
            ]), (0, $sjwE0.PartialDict).map((nea)=>({
                count: nea.filter((c)=>!c.isHidden).length,
                total: nea.length
            })));
        return {
            filteredAndSortedChampions: (0, $f5id0.pipe)((0, $vkIKL.ChampionFactionOrNone).valuesSortBy([
                (0, $fdf08e5d15d06772$export$6a3aa170c29c42fa).Ord.byLabel(t)
            ]), (0, $sjwE0.List).reduce((0, $sjwE0.List).empty(), (acc, faction)=>(0, $f5id0.pipe)(acc, (0, $sjwE0.List).concat(grouped[faction] ?? []))), (0, $sjwE0.List).concat(grouped.hidden ?? [])),
            factionsCount: factionsCount_,
            searchCount: (0, $f5id0.pipe)(sortedChampions, (0, $sjwE0.List).filter((c)=>!c.isHidden), (0, $sjwE0.List).size)
        };
    }, [
        champions,
        genericQuery.search,
        t
    ]);
    const onSearchChange = (0, $bh6RR.useMemo)(()=>(0, $f5id0.flow)((0, $2EH2o.GenericQuery).Lens.search.set, updateGenericQuery), [
        updateGenericQuery
    ]);
    const randomChampion = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(filteredAndSortedChampions, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $f5id0.flow)((0, $2566e9e25df745a4$exports).randomElem, (0, $4lr6f).map((m)=>{
            updateGenericQuery((0, $2EH2o.GenericQuery).Lens.search.set((0, $sjwE0.Maybe).some(m.name)));
            return m.name;
        })))), [
        filteredAndSortedChampions,
        updateGenericQuery
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "flex size-full flex-col overflow-y-auto px-2 pb-24 pt-3",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $755ee31adc777f55$export$bb60b672622fdba0), {
                    searchCount: searchCount,
                    randomChampion: randomChampion,
                    initialSearch: genericQuery.search,
                    onChange: onSearchChange,
                    className: "self-center"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "grid w-full grid-cols-[repeat(auto-fit,3rem)] items-start gap-2",
                    children: (0, $f5id0.pipe)(filteredAndSortedChampions, (0, $iPRex.ListUtils).mapWithPrevious((maybePrev, c)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
                            children: [
                                !c.isHidden && !(0, $f5id0.pipe)(maybePrev, (0, $sjwE0.Maybe).exists((prev)=>(0, $vkIKL.ChampionFactionOrNone).Eq.equals(prev.faction, c.faction))) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $f556a3f1cb290003$export$2978b4beac7a3c02), {
                                    challenges: (0, $sjwE0.Maybe).none,
                                    count: factionsCount[c.faction] ?? (0, $873f54152d46e5ce$export$1b9130a9fda2eb88).empty,
                                    faction: c.faction,
                                    className: "pt-3"
                                }) : null,
                                /*#__PURE__*/ (0, $ih19M.jsx)($082766cbe57dda99$var$Champion, {
                                    champion: c
                                })
                            ]
                        }, `${c.faction}${(0, $br0yu.ChampionKey).unwrap(c.key)}`)))
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "mt-6 self-center",
                    children: t.nChampionsFraction(searchCount, champions.length)
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $10c33ecf202858d4$export$24a214d9165f464d), {
                    href: "https://wiki.leagueoflegends.com/en-us/Challenges#Faction_Challenges"
                })
            ]
        })
    });
};
const $082766cbe57dda99$var$Champion = ({ champion: champion })=>{
    const hoverRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1576edad88dbd003$export$6028b0e8199948bf), {
                ref: hoverRef,
                championKey: champion.key,
                championName: champion.name,
                className: (0, $jK7ok.cx)('size-12 rounded-xl shadow-even shadow-black', [
                    'hidden',
                    champion.isHidden
                ])
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: hoverRef,
                placement: "top",
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                        className: "self-center px-2 font-bold shadow-black text-shadow",
                        children: champion.name
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $71c737632df86b04$export$135d860430810669), {
                        positions: champion.positions,
                        factions: []
                    })
                ]
            })
        ]
    });
};



var $ih19M = parcelRequire("ih19M");

var $tA0jd = parcelRequire("tA0jd");

var $4MEuc = parcelRequire("4MEuc");
const $77f21d9d368b3b7c$export$b94310965bed44e6 = ()=>{
    const { t: t } = (0, $4MEuc.useTranslation)('home');
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "grid h-full grid-rows-[1fr_auto] justify-center gap-3 p-3",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                    className: "place-self-center font-lib-mono text-2xl",
                    children: t.theQuest
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    className: "text-2xs",
                    children: t.isntEndorsed
                })
            ]
        })
    });
};


/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $6omhk = parcelRequire("6omhk");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $bh6RR = parcelRequire("bh6RR");

var $fl6s9 = parcelRequire("fl6s9");

var $sjwE0 = parcelRequire("sjwE0");

var $g7UIk = parcelRequire("g7UIk");

var $9g4gL = parcelRequire("9g4gL");

var $hnBhT = parcelRequire("hnBhT");

var $fVW4p = parcelRequire("fVW4p");

var $36sK8 = parcelRequire("36sK8");

var $tA0jd = parcelRequire("tA0jd");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");

var $ih19M = parcelRequire("ih19M");
const $987dd9a72d4a913a$export$42e8453a5b2d580 = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 508.67 96.36",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M170.85,20.2h27.3q9.87,0,16.7,3.08a22.5,22.5,0,0,1,10.21,8.58,23.34,23.34,0,0,1,3.4,12.56A23.24,23.24,0,0,1,224.93,57a23.94,23.94,0,0,1-10.79,8.92q-7.24,3.3-17.95,3.29H170.85Zm25.06,36.54q6.65,0,10.22-3.32a11.8,11.8,0,0,0,3.57-9.07,11.5,11.5,0,0,0-3.18-8.5q-3.2-3.18-9.63-3.19h-8.54V56.74Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M269.34,69.13a37,37,0,0,1-10.22-4.27V53.24a27.77,27.77,0,0,0,9.2,4.38,39.31,39.31,0,0,0,11.17,1.71,8.71,8.71,0,0,0,3.82-.66c.86-.44,1.29-1,1.29-1.58a2.37,2.37,0,0,0-.7-1.75,6.15,6.15,0,0,0-2.73-1.19l-8.4-1.89q-7.22-1.68-10.25-4.65a10.39,10.39,0,0,1-3-7.81,10.37,10.37,0,0,1,2.66-7.07,17.13,17.13,0,0,1,7.56-4.65,36,36,0,0,1,11.48-1.65A43.27,43.27,0,0,1,292,27.69a30.25,30.25,0,0,1,8.12,3.22v11a30,30,0,0,0-7.6-3.11,34,34,0,0,0-8.85-1.16q-6.58,0-6.58,2.24a1.69,1.69,0,0,0,1,1.58,16.14,16.14,0,0,0,3.74,1.08l7,1.26Q295.65,45,299,48t3.36,8.78a11.61,11.61,0,0,1-5.57,10.12Q291.26,70.61,281,70.6A46.41,46.41,0,0,1,269.34,69.13Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M318.9,67.66a21,21,0,0,1-9.07-8,21.59,21.59,0,0,1-3-11.34,20.62,20.62,0,0,1,3.15-11.27,21.16,21.16,0,0,1,9.24-7.8,34.25,34.25,0,0,1,14.56-2.84q10.5,0,17.43,4.41V43.65a21.84,21.84,0,0,0-5.7-2.73,22.65,22.65,0,0,0-7-1.05q-6.51,0-10.19,2.38a7.15,7.15,0,0,0-.1,12.43q3.57,2.41,10.36,2.41a23.91,23.91,0,0,0,6.9-1,25.71,25.71,0,0,0,5.84-2.49V66a34,34,0,0,1-17.85,4.62A32.93,32.93,0,0,1,318.9,67.66Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M368.64,67.66a21.77,21.77,0,0,1-9.25-8,21.14,21.14,0,0,1-3.18-11.41A20.27,20.27,0,0,1,359.39,37a21.42,21.42,0,0,1,9.21-7.74,38.17,38.17,0,0,1,28.7,0,21.25,21.25,0,0,1,9.17,7.7,20.41,20.41,0,0,1,3.15,11.27,21.29,21.29,0,0,1-3.15,11.41,21.51,21.51,0,0,1-9.2,8,36.32,36.32,0,0,1-28.63,0Zm21.27-12.42a9.12,9.12,0,0,0,2.56-6.76,8.87,8.87,0,0,0-2.56-6.68,9.53,9.53,0,0,0-7-2.49,9.67,9.67,0,0,0-7,2.49,8.9,8.9,0,0,0-2.55,6.68,9.15,9.15,0,0,0,2.55,6.76,9.53,9.53,0,0,0,7,2.55A9.4,9.4,0,0,0,389.91,55.24Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M451.69,29V44.14a12.47,12.47,0,0,0-6.93-1.75c-3.73,0-6.61,1.14-8.61,3.4s-3,5.77-3,10.53V69.2H416V28.25h16.8v13q1.4-7.14,4.52-10.53a10.38,10.38,0,0,1,8-3.4A11.71,11.71,0,0,1,451.69,29Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M508.67,18.8V69.2H491.52V60a16.23,16.23,0,0,1-6.62,7.88A20.81,20.81,0,0,1,474,70.6a18.11,18.11,0,0,1-10.15-2.83A18.6,18.6,0,0,1,457.11,60a25.75,25.75,0,0,1-2.34-11.17,24.87,24.87,0,0,1,2.48-11.55,19.43,19.43,0,0,1,7.21-8,19.85,19.85,0,0,1,10.61-2.87q12.24,0,16.45,10.64V18.8ZM489,55a8.83,8.83,0,0,0,2.63-6.62A8.42,8.42,0,0,0,489,42a11,11,0,0,0-13.89,0,8.55,8.55,0,0,0-2.59,6.47A8.67,8.67,0,0,0,475.14,55,9.42,9.42,0,0,0,482,57.51,9.56,9.56,0,0,0,489,55Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ellipse", {
                cx: "242.92",
                cy: "24.93",
                rx: "8.55",
                ry: "7.68",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M234.36,37.9a22.08,22.08,0,0,0,17.11,0V69.42H234.36Z",
                fill: "currentColor"
            })
        ]
    });



var $65dIW = parcelRequire("65dIW");

var $gE3ky = parcelRequire("gE3ky");

var $f5id0 = parcelRequire("f5id0");

var $kGWxD = parcelRequire("kGWxD");

var $sjwE0 = parcelRequire("sjwE0");

var $c6xfg = parcelRequire("c6xfg");
const $40cb1e1c6a727886$export$f8ebcce652de4cda = `https://discord.com/api/oauth2/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($kGWxD))).stringify({
    client_id: (0, $c6xfg.config).discordClient.id,
    redirect_uri: (0, $c6xfg.config).discordClient.redirectUri,
    response_type: 'code',
    scope: (0, $f5id0.pipe)([
        'identify',
        'connections'
    ], (0, $sjwE0.List).mkString(' ')),
    prompt: 'none'
})}`;



var $7VlB6 = parcelRequire("7VlB6");
const $da9d0305f9cddd74$var$emptyState = {
    userName: '',
    password: ''
};
const $da9d0305f9cddd74$export$68936a7c4bae5452 = (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('userName'));
const $da9d0305f9cddd74$export$2ef0475305ef813d = (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('password'));
const $da9d0305f9cddd74$export$21a94553ffa41578 = ()=>{
    const { user: user, refreshUser: refreshUser } = (0, $j30iL.useUser)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [error, setError] = (0, $bh6RR.useState)((0, $sjwE0.Maybe).none);
    const [state, setState] = (0, $bh6RR.useState)($da9d0305f9cddd74$var$emptyState);
    const updateUserName = (0, $bh6RR.useCallback)((e)=>{
        setState($da9d0305f9cddd74$export$68936a7c4bae5452.set(e.target.value));
        setError((0, $sjwE0.Maybe).none);
    }, []);
    const updatePassword = (0, $bh6RR.useCallback)((e)=>{
        setState($da9d0305f9cddd74$export$2ef0475305ef813d.set(e.target.value));
        setError((0, $sjwE0.Maybe).none);
    }, []);
    const validated = (0, $bh6RR.useMemo)(()=>(0, $fl6s9.LoginPasswordPayload).codec.decode(state), [
        state
    ]);
    const handleSubmit = (0, $bh6RR.useCallback)((e)=>{
        e.preventDefault();
        (0, $f5id0.pipe)(validated, (0, $sjwE0.Either).map((valid)=>{
            setIsLoading(true);
            return (0, $f5id0.pipe)(valid, (0, $g7UIk.apiUserLoginPasswordPost), (0, $sjwE0.Future).chain(()=>refreshUser), (0, $sjwE0.Future).orElseW(()=>(0, $sjwE0.Future).successful(setError((0, $sjwE0.Maybe).some('error')))), (0, $6omhk).chainFirstIOK(()=>()=>setIsLoading(false)), (0, $7VlB6.futureRunUnsafe));
        }));
    }, [
        refreshUser,
        validated
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
        ...(0, $65dIW.AsyncState).toSWR(user),
        children: (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "flex flex-col items-center gap-12 px-4 py-20",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                            href: (0, $40cb1e1c6a727886$export$f8ebcce652de4cda),
                            className: "flex items-center rounded-md bg-discord-blurple px-6 text-white",
                            children: t.form.loginWithDiscord(/*#__PURE__*/ (0, $ih19M.jsx)((0, $987dd9a72d4a913a$export$42e8453a5b2d580), {
                                className: "my-3 ml-3 h-6"
                            }))
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            children: t.form.or
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "flex flex-col items-center gap-8 border border-goldenrod bg-zinc-900 px-12 py-8",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                    className: "text-lg font-bold",
                                    children: t.layout.login
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "grid grid-cols-[auto_auto] gap-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: t.form.userName
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                    type: "text",
                                                    value: state.userName,
                                                    onChange: updateUserName,
                                                    className: "border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    className: "col-start-1 mt-2",
                                                    children: t.form.password
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                    type: "password",
                                                    value: state.password,
                                                    onChange: updatePassword,
                                                    className: "mt-2 border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex flex-col items-center gap-2 self-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                            type: "submit",
                                            disabled: isLoading || (0, $sjwE0.Either).isLeft(validated),
                                            className: "flex items-center gap-2 bg-goldenrod px-4 py-1 text-black enabled:hover:bg-goldenrod/75 disabled:bg-grey-disabled",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: t.form.login
                                                }),
                                                isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                                                    className: "h-4"
                                                }) : null
                                            ]
                                        }),
                                        (0, $f5id0.pipe)(error, (0, $sjwE0.Maybe).fold(()=>null, (e)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-red",
                                                children: e
                                            })))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex w-full max-w-xl flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: t.form.noAccount
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                                    to: (0, $gE3ky.appRoutes).register,
                                    className: "font-medium underline",
                                    children: t.form.register
                                })
                            ]
                        })
                    ]
                })
            }), ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $36sK8.Navigate), {
                to: (0, $gE3ky.appRoutes).index,
                replace: true
            }))
    });
};


/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $6omhk = parcelRequire("6omhk");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $bh6RR = parcelRequire("bh6RR");

var $22neR = parcelRequire("22neR");

var $fl6s9 = parcelRequire("fl6s9");

var $sjwE0 = parcelRequire("sjwE0");

var $22neR = parcelRequire("22neR");

var $sjwE0 = parcelRequire("sjwE0");
const $0e7137fbdb2ff9aa$export$4d2a7159fda5dc93 = (password)=>{
    const passwordStr = (0, $22neR.ClearPassword).unwrap(password);
    if (passwordStr.length < 8) return (0, $sjwE0.Either).left("Le mot de passe doit contenir au moins 8 caract\xe8res");
    if (!$0e7137fbdb2ff9aa$var$containsUpperLowerDigit(passwordStr)) return (0, $sjwE0.Either).left('Le mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre');
    return (0, $sjwE0.Either).right(password);
};
const $0e7137fbdb2ff9aa$var$containsUpperLowerDigit = (str)=>{
    const chars = str.split('');
    return $0e7137fbdb2ff9aa$var$containsLower(chars) && $0e7137fbdb2ff9aa$var$containsUpper(chars) && $0e7137fbdb2ff9aa$var$containsDigit(str);
};
const $0e7137fbdb2ff9aa$var$containsLower = (0, $sjwE0.List).exists((c)=>c.toLowerCase() === c);
const $0e7137fbdb2ff9aa$var$containsUpper = (0, $sjwE0.List).exists((c)=>c.toUpperCase() === c);
const $0e7137fbdb2ff9aa$var$digitsRegex = /[0-9]/;
const $0e7137fbdb2ff9aa$var$containsDigit = (str)=>$0e7137fbdb2ff9aa$var$digitsRegex.test(str);



var $g7UIk = parcelRequire("g7UIk");

var $9g4gL = parcelRequire("9g4gL");

var $hnBhT = parcelRequire("hnBhT");

var $fVW4p = parcelRequire("fVW4p");

var $36sK8 = parcelRequire("36sK8");

var $tA0jd = parcelRequire("tA0jd");

var $bVugR = parcelRequire("bVugR");

var $9xM77 = parcelRequire("9xM77");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");


var $gwlG1 = parcelRequire("gwlG1");

var $65dIW = parcelRequire("65dIW");

var $gE3ky = parcelRequire("gE3ky");

var $jK7ok = parcelRequire("jK7ok");


var $7VlB6 = parcelRequire("7VlB6");
const $931ea6bd6d9687ff$var$lesQuaisAbattoirs = {
    inviteLink: 'https://discord.gg/M4jnkHd',
    name: 'Les Quais-Abattoirs',
    image: 'https://cdn.discordapp.com/icons/707621148652994642/a_8b2674e8d2831749f540f330df66a63e.gif?size=240'
};
const $931ea6bd6d9687ff$var$emptyState = {
    userName: '',
    password: '',
    confirmPassword: ''
};
const $931ea6bd6d9687ff$var$userNameLens = (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('userName'));
const $931ea6bd6d9687ff$var$passwordLens = (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('password'));
const $931ea6bd6d9687ff$var$confirmPasswordLens = (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('confirmPassword'));
const $931ea6bd6d9687ff$export$157c131647dc68e = ()=>{
    const { navigate: navigate } = (0, $9xM77.useHistory)();
    const { user: user } = (0, $j30iL.useUser)();
    const { t: t } = (0, $4MEuc.useTranslation)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [error, setError] = (0, $bh6RR.useState)((0, $sjwE0.Maybe).none);
    const [state, setState] = (0, $bh6RR.useState)($931ea6bd6d9687ff$var$emptyState);
    const updateUserName = (0, $bh6RR.useCallback)((e)=>{
        setState($931ea6bd6d9687ff$var$userNameLens.set(e.target.value));
        setError((0, $sjwE0.Maybe).none);
    }, []);
    const updatePassword = (0, $bh6RR.useCallback)((e)=>{
        setState($931ea6bd6d9687ff$var$passwordLens.set(e.target.value));
        setError((0, $sjwE0.Maybe).none);
    }, []);
    const updateConfirmPassword = (0, $bh6RR.useCallback)((e)=>{
        setState($931ea6bd6d9687ff$var$confirmPasswordLens.set(e.target.value));
        setError((0, $sjwE0.Maybe).none);
    }, []);
    const validated = (0, $bh6RR.useMemo)(()=>(0, $fl6s9.LoginPasswordPayload).codec.decode(state), [
        state
    ]);
    const handleSubmit = (0, $bh6RR.useCallback)((e)=>{
        e.preventDefault();
        (0, $f5id0.pipe)(validated, (0, $sjwE0.Either).map((payload)=>{
            (0, $f5id0.pipe)($931ea6bd6d9687ff$var$validateOnSubmit(t.common)(payload.password, state.confirmPassword), (0, $sjwE0.Either).foldW((0, $f5id0.flow)((0, $sjwE0.Maybe).some, setError), ()=>{
                setIsLoading(true);
                return (0, $f5id0.pipe)((0, $g7UIk.apiUserRegisterPost)(payload), (0, $sjwE0.Future).map(()=>navigate((0, $gE3ky.appRoutes).login)), (0, $sjwE0.Future).orElse(()=>(0, $sjwE0.Future).successful(setError((0, $sjwE0.Maybe).some('error')))), (0, $6omhk).chainFirstIOK(()=>()=>setIsLoading(false)), (0, $7VlB6.futureRunUnsafe));
            }));
        }));
    }, [
        navigate,
        state.confirmPassword,
        t,
        validated
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
        ...(0, $65dIW.AsyncState).toSWR(user),
        children: (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "flex flex-col items-center gap-12 px-4 py-20",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("table", {
                            className: "grid grid-cols-[auto_1fr_1fr]",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("thead", {
                                    className: "contents",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("tr", {
                                        className: "contents",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("th", {}),
                                            /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Th, {
                                                children: t.register.withoutAccount
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Th, {
                                                children: t.register.withAccount
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("tbody", {
                                    className: "contents",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "border-l border-t border-goldenrod pl-10 pt-12",
                                                    children: t.register.accessSummonerDetails
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-t border-goldenrod pt-12",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-r border-t border-goldenrod pt-12",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "border-l border-goldenrod pl-10",
                                                    children: t.register.accessRecentSearches((0, $bVugR.constants).recentSearchesMaxCount)
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-r border-goldenrod",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "border-l border-goldenrod pl-10",
                                                    children: t.register.addSummonerToFavorites
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$EmptyTd, {}),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-r border-goldenrod",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "border-l border-goldenrod pl-10",
                                                    children: t.register.customiseChampionPositions
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$EmptyTd, {}),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-r border-goldenrod",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsxs)($931ea6bd6d9687ff$var$Td, {
                                                    className: "flex-col gap-3 border-b border-l border-goldenrod pb-12 pl-10",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                            className: "self-start",
                                                            children: t.register.discordHallOfFameRanking
                                                        }),
                                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                            className: "flex items-center self-start rounded bg-discord-darkgrey px-6 py-5 text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                                                    src: $931ea6bd6d9687ff$var$lesQuaisAbattoirs.image,
                                                                    alt: t.register.discordServerIconAlt($931ea6bd6d9687ff$var$lesQuaisAbattoirs.name),
                                                                    className: "w-12 rounded-xl"
                                                                }),
                                                                /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                                    className: "ml-4 flex flex-col",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                                            className: "font-bold",
                                                                            children: $931ea6bd6d9687ff$var$lesQuaisAbattoirs.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                                            className: "text-sm text-zinc-400",
                                                                            children: t.register.discordServer
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                                                    href: $931ea6bd6d9687ff$var$lesQuaisAbattoirs.inviteLink,
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    className: "ml-8 rounded bg-discord-darkgreen px-3 py-2 text-sm font-medium",
                                                                    children: t.register.join
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-b border-goldenrod pb-12",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
                                                    className: "justify-center border-b border-r border-goldenrod pb-12",
                                                    children: $931ea6bd6d9687ff$var$greenCheck
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("hr", {
                            className: "w-full max-w-xl border-t border-goldenrod"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                            href: (0, $40cb1e1c6a727886$export$f8ebcce652de4cda),
                            className: "flex items-center rounded-md bg-discord-blurple px-6 text-white",
                            children: t.common.form.loginWithDiscord(/*#__PURE__*/ (0, $ih19M.jsx)((0, $987dd9a72d4a913a$export$42e8453a5b2d580), {
                                className: "my-3 ml-3 h-6"
                            }))
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            children: t.common.form.or
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "flex flex-col items-center gap-8 border border-goldenrod bg-zinc-900 px-12 py-8",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                    className: "text-lg font-bold",
                                    children: t.common.layout.register
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "grid grid-cols-[auto_auto] gap-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: t.common.form.userName
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                    type: "text",
                                                    value: state.userName,
                                                    onChange: updateUserName,
                                                    className: "border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    className: "col-start-1 mt-2",
                                                    children: t.common.form.password
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                    type: "password",
                                                    value: state.password,
                                                    onChange: updatePassword,
                                                    className: "mt-2 border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    className: "col-start-1 mt-2",
                                                    children: t.common.form.confirmPassword
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                    type: "password",
                                                    value: state.confirmPassword,
                                                    onChange: updateConfirmPassword,
                                                    className: "mt-2 border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex flex-col items-center gap-2 self-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                            type: "submit",
                                            disabled: isLoading || (0, $sjwE0.Either).isLeft(validated),
                                            className: "flex items-center gap-2 bg-goldenrod px-4 py-1 text-black enabled:hover:bg-goldenrod/75 disabled:bg-grey-disabled",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: t.common.form.register
                                                }),
                                                isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                                                    className: "h-4"
                                                }) : null
                                            ]
                                        }),
                                        (0, $f5id0.pipe)(error, (0, $sjwE0.Maybe).fold(()=>null, (e)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-red",
                                                children: e
                                            })))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex w-full max-w-xl flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: t.common.form.alreadyAnAccount
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $hnBhT.Link), {
                                    to: (0, $gE3ky.appRoutes).login,
                                    className: "font-medium underline",
                                    children: t.common.form.login
                                })
                            ]
                        })
                    ]
                })
            }), ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $36sK8.Navigate), {
                to: (0, $gE3ky.appRoutes).index,
                replace: true
            }))
    });
};
const $931ea6bd6d9687ff$var$Th = ({ children: children })=>/*#__PURE__*/ (0, $ih19M.jsx)("th", {
        className: "flex items-center justify-center px-2 pb-3 font-medium",
        children: children
    });
const $931ea6bd6d9687ff$var$Td = ({ className: className, children: children })=>/*#__PURE__*/ (0, $ih19M.jsx)("td", {
        className: (0, $jK7ok.cx)('flex items-center bg-zinc-900 px-2 py-5', className),
        children: children
    });
const $931ea6bd6d9687ff$var$EmptyTd = ({ className: className })=>/*#__PURE__*/ (0, $ih19M.jsx)($931ea6bd6d9687ff$var$Td, {
        className: (0, $jK7ok.cx)('justify-center text-sm', className),
        children: "\u2014"
    });
const $931ea6bd6d9687ff$var$greenCheck = /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CheckMarkSharp), {
    className: "h-6 text-green"
});
const $931ea6bd6d9687ff$var$validateOnSubmit = (t)=>(password, confirmPassword)=>(0, $22neR.ClearPassword).unwrap(password) !== confirmPassword ? (0, $sjwE0.Either).left(t.form.passwordsShouldBeIdentical) : (0, $f5id0.pipe)((0, $0e7137fbdb2ff9aa$export$4d2a7159fda5dc93)(password), (0, $sjwE0.Either).map((0, $sjwE0.toNotUsed)));


/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $k8rBo = parcelRequire("k8rBo");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $1GV7y = parcelRequire("1GV7y");

var $jPaL5 = parcelRequire("jPaL5");

var $br0yu = parcelRequire("br0yu");
const $a089034b60bc58da$var$codec = $jPaL5.struct({
    championId: (0, $br0yu.ChampionKey).codec,
    championLevel: $jPaL5.number,
    championPoints: $jPaL5.number,
    championPointsSinceLastLevel: $jPaL5.number,
    championPointsUntilNextLevel: $jPaL5.number,
    tokensEarned: $jPaL5.number,
    markRequiredForNextLevel: $jPaL5.number
});
const $a089034b60bc58da$export$c891b48931e98110 = {
    codec: $a089034b60bc58da$var$codec
};



var $kJAjV = parcelRequire("kJAjV");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $br0yu = parcelRequire("br0yu");
const $cd69e178fde0199b$var$codec = $jPaL5.struct({
    champion: (0, $br0yu.ChampionKey).codec,
    count: $jPaL5.number
});
const $cd69e178fde0199b$var$byChampionEq = (0, $f5id0.pipe)((0, $br0yu.ChampionKey).Eq, (0, $kJAjV).contramap((s)=>s.champion));
const $cd69e178fde0199b$export$c8017683694e0c17 = {
    codec: $cd69e178fde0199b$var$codec,
    Eq: {
        byChampion: $cd69e178fde0199b$var$byChampionEq
    }
};



var $jPaL5 = parcelRequire("jPaL5");

var $895LH = parcelRequire("895LH");

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $j839F = parcelRequire("j839F");
const $ba5c745479cc334d$var$e = (0, $j839F.createEnum)('W', 'L', 'N');
const $ba5c745479cc334d$export$4584bab0cdf7c506 = $ba5c745479cc334d$var$e;



var $j839F = parcelRequire("j839F");
const $0a5f83a48eac44c9$export$254129c6bcc47359 = (0, $j839F.createEnum)('I', 'II', 'III', 'IV');



var $5iN75 = parcelRequire("5iN75");
const $7b572f686974d349$var$codec = $jPaL5.struct({
    currentSplit: (0, $sjwE0.Maybe).codec($jPaL5.struct({
        tier: (0, $5iN75.LeagueTier).codec,
        rank: (0, $0a5f83a48eac44c9$export$254129c6bcc47359).codec,
        leaguePoints: $jPaL5.number,
        wins: $jPaL5.number,
        losses: $jPaL5.number,
        miniSeriesProgress: (0, $sjwE0.Maybe).codec((0, $sjwE0.NonEmptyArray).codec((0, $ba5c745479cc334d$export$4584bab0cdf7c506).codec))
    })),
    // poro
    previousSplit: (0, $sjwE0.Maybe).codec($jPaL5.struct({
        tier: (0, $5iN75.LeagueTier).codec,
        rank: (0, $0a5f83a48eac44c9$export$254129c6bcc47359).codec
    }))
});
const $7b572f686974d349$export$d2c14bcabfcb358c = {
    codec: $7b572f686974d349$var$codec
};


const $4cb553f311fc5825$var$properties = {
    soloDuo: (0, $7b572f686974d349$export$d2c14bcabfcb358c).codec,
    flex: (0, $7b572f686974d349$export$d2c14bcabfcb358c).codec
};
const $4cb553f311fc5825$var$codec = $jPaL5.struct($4cb553f311fc5825$var$properties);
const $4cb553f311fc5825$var$keys = (0, $895LH.DictUtils).keys($4cb553f311fc5825$var$properties);
const $4cb553f311fc5825$export$34d6dd1c63e72828 = {
    codec: $4cb553f311fc5825$var$codec,
    keys: $4cb553f311fc5825$var$keys
};



var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $fp7Nf = parcelRequire("fp7Nf");

var $ixYJp = parcelRequire("ixYJp");

var $gl9GP = parcelRequire("gl9GP");
const $6f1ee8c9097efe75$var$codec = $jPaL5.struct({
    puuid: (0, $gl9GP.Puuid).codec,
    riotId: (0, $fp7Nf.RiotId).fromStringCodec,
    name: (0, $sjwE0.Maybe).codec((0, $ixYJp.SummonerName).codec),
    profileIconId: $jPaL5.number,
    summonerLevel: $jPaL5.number
});
const $6f1ee8c9097efe75$export$270856858defe778 = {
    codec: $6f1ee8c9097efe75$var$codec
};


const $d7d93897afbab07d$var$codec = $jPaL5.struct({
    summoner: (0, $6f1ee8c9097efe75$export$270856858defe778).codec,
    leagues: (0, $4cb553f311fc5825$export$34d6dd1c63e72828).codec,
    masteries: $jPaL5.struct({
        champions: (0, $sjwE0.List).codec((0, $a089034b60bc58da$export$c891b48931e98110).codec),
        insertedAt: (0, $hHBpg.DayJsFromISOString).codec,
        cacheDuration: (0, $1GV7y.MsDuration).codec
    }),
    championShards: (0, $sjwE0.Maybe).codec((0, $sjwE0.List).codec((0, $cd69e178fde0199b$export$c8017683694e0c17).codec))
});
const $d7d93897afbab07d$var$Lens = {
    championShards: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('championShards'), (0, $gnzcc).some)
};
const $d7d93897afbab07d$export$295b25f3552f2c84 = {
    codec: $d7d93897afbab07d$var$codec,
    Lens: $d7d93897afbab07d$var$Lens
};



var $sjwE0 = parcelRequire("sjwE0");

var $9g4gL = parcelRequire("9g4gL");

var $36sK8 = parcelRequire("36sK8");

var $tA0jd = parcelRequire("tA0jd");

var $9xM77 = parcelRequire("9xM77");

var $4MEuc = parcelRequire("4MEuc");

var $7Dhdf = parcelRequire("7Dhdf");

var $kiCtw = parcelRequire("kiCtw");

var $gE3ky = parcelRequire("gE3ky");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $f5id0 = parcelRequire("f5id0");

var $4BSZX = parcelRequire("4BSZX");

var $bh6RR = parcelRequire("bh6RR");

var $3WFZ7 = parcelRequire("3WFZ7");
var $yr2dg = parcelRequire("yr2dg");

var $k8rBo = parcelRequire("k8rBo");

var $1GV7y = parcelRequire("1GV7y");

var $dW1pp = parcelRequire("dW1pp");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");
var $asc1N = parcelRequire("asc1N");

var $sjwE0 = parcelRequire("sjwE0");

var $aZGGZ = parcelRequire("aZGGZ");

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $sjwE0 = parcelRequire("sjwE0");

var $fp7Nf = parcelRequire("fp7Nf");

var $br0yu = parcelRequire("br0yu");

var $65UVg = parcelRequire("65UVg");

var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $7340158445f0915b$var$wrap, unwrap: $7340158445f0915b$var$unwrap } = (0, $1k68G.iso)();
const $7340158445f0915b$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $7340158445f0915b$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($7340158445f0915b$var$unwrap));
const $7340158445f0915b$export$96c66196b0b4f739 = (0, $sjwE0.immutableAssign)($7340158445f0915b$var$wrap, {
    unwrap: $7340158445f0915b$var$unwrap,
    codec: $7340158445f0915b$var$codec,
    Eq: $7340158445f0915b$var$Eq
});



var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $56a38f105919baed$var$wrap, unwrap: $56a38f105919baed$var$unwrap } = (0, $1k68G.iso)();
const $56a38f105919baed$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $56a38f105919baed$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($56a38f105919baed$var$unwrap));
const $56a38f105919baed$export$597b42c1d60925a3 = (0, $sjwE0.immutableAssign)($56a38f105919baed$var$wrap, {
    codec: $56a38f105919baed$var$codec,
    Eq: $56a38f105919baed$var$Eq
});


const $e9f2a9cf002ccabc$var$codec = $jPaL5.struct({
    perkIds: (0, $sjwE0.List).codec((0, $7340158445f0915b$export$96c66196b0b4f739).codec),
    perkStyle: (0, $56a38f105919baed$export$597b42c1d60925a3).codec,
    perkSubStyle: (0, $56a38f105919baed$export$597b42c1d60925a3).codec
});
const $e9f2a9cf002ccabc$export$97e21419a10fd553 = {
    codec: $e9f2a9cf002ccabc$var$codec
};




var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $4BSZX = parcelRequire("4BSZX");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $87807dff4a3e74cf$var$wrap, unwrap: $87807dff4a3e74cf$var$unwrap } = (0, $1k68G.iso)();
const $87807dff4a3e74cf$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $87807dff4a3e74cf$var$fromStringCodec = $jPaL5.make((0, $f5id0.pipe)((0, $hHBpg.NumberFromString).decoder, $4BSZX.map($87807dff4a3e74cf$var$wrap)), {
    encode: String
});
const $87807dff4a3e74cf$var$isSmite = (spell)=>$87807dff4a3e74cf$var$unwrap(spell) === 11;
const $87807dff4a3e74cf$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($87807dff4a3e74cf$var$unwrap));
const $87807dff4a3e74cf$export$733cfc729a9b57a7 = (0, $sjwE0.immutableAssign)($87807dff4a3e74cf$var$wrap, {
    unwrap: $87807dff4a3e74cf$var$unwrap,
    codec: $87807dff4a3e74cf$var$codec,
    fromStringCodec: $87807dff4a3e74cf$var$fromStringCodec,
    isSmite: $87807dff4a3e74cf$var$isSmite,
    Eq: $87807dff4a3e74cf$var$Eq
});



var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $jPaL5 = parcelRequire("jPaL5");
const $c58709c1263165bb$var$codec = $jPaL5.struct({
    championLevel: $jPaL5.number,
    championPoints: $jPaL5.number,
    championPointsSinceLastLevel: $jPaL5.number,
    championPointsUntilNextLevel: $jPaL5.number,
    tokensEarned: $jPaL5.number,
    markRequiredForNextLevel: $jPaL5.number
});
const $c58709c1263165bb$export$790a5df3f4508560 = {
    codec: $c58709c1263165bb$var$codec
};


const $7cd981327afd5db6$var$codec = $jPaL5.struct({
    questPercents: $jPaL5.number,
    totalMasteryLevel: $jPaL5.number,
    totalMasteryPoints: $jPaL5.number,
    otpIndex: $jPaL5.number,
    champion: (0, $sjwE0.Maybe).codec((0, $c58709c1263165bb$export$790a5df3f4508560).codec)
});
const $7cd981327afd5db6$export$250ea29fceec4561 = {
    codec: $7cd981327afd5db6$var$codec
};



var $jPaL5 = parcelRequire("jPaL5");

var $j839F = parcelRequire("j839F");
const $02141bcab512d1c2$export$6330c36b36a471b6 = (0, $j839F.createEnum)(-1, 0, 1, 2);


const $3f820094f14eee6d$var$codec = $jPaL5.struct({
    niceness: (0, $02141bcab512d1c2$export$6330c36b36a471b6).codec,
    label: $jPaL5.string,
    tooltip: $jPaL5.string
});
const $3f820094f14eee6d$export$b2fed4ed588653e8 = {
    codec: $3f820094f14eee6d$var$codec
};


const $7365bbcb5e753bee$var$codec = $jPaL5.struct({
    riotId: (0, $sjwE0.Maybe).codec((0, $fp7Nf.RiotId).fromStringCodec),
    profileIconId: $jPaL5.number,
    leagues: (0, $sjwE0.Maybe).codec((0, $4cb553f311fc5825$export$34d6dd1c63e72828).codec),
    championId: (0, $br0yu.ChampionKey).codec,
    masteries: (0, $sjwE0.Maybe).codec((0, $7cd981327afd5db6$export$250ea29fceec4561).codec),
    shardsCount: (0, $sjwE0.Maybe).codec($jPaL5.number),
    spell1Id: (0, $87807dff4a3e74cf$export$733cfc729a9b57a7).codec,
    spell2Id: (0, $87807dff4a3e74cf$export$733cfc729a9b57a7).codec,
    perks: (0, $sjwE0.Maybe).codec((0, $e9f2a9cf002ccabc$export$97e21419a10fd553).codec),
    // poro
    premadeId: (0, $sjwE0.Maybe).codec($jPaL5.number),
    summonerLevel: (0, $sjwE0.Maybe).codec($jPaL5.number),
    championRankedStats: (0, $sjwE0.Maybe).codec($jPaL5.struct({
        wins: $jPaL5.number,
        losses: $jPaL5.number,
        kills: $jPaL5.number,
        deaths: $jPaL5.number,
        assists: $jPaL5.number
    })),
    role: (0, $sjwE0.Maybe).codec((0, $65UVg.ChampionPosition).codec),
    mainRoles: (0, $sjwE0.List).codec((0, $65UVg.ChampionPosition).codec),
    tags: (0, $sjwE0.List).codec((0, $3f820094f14eee6d$export$b2fed4ed588653e8).codec)
});
const $7365bbcb5e753bee$var$Lens = {
    shardsCount: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('shardsCount'))
};
const $7365bbcb5e753bee$export$31eb4e888063c573 = {
    codec: $7365bbcb5e753bee$var$codec,
    Lens: $7365bbcb5e753bee$var$Lens
};



var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $br0yu = parcelRequire("br0yu");
const $a8f9ed8c5cd7e1b2$var$codec = $jPaL5.struct({
    pickTurn: $jPaL5.number,
    championId: (0, $sjwE0.Maybe).codec((0, $br0yu.ChampionKey).codec)
});
const $a8f9ed8c5cd7e1b2$var$empty = {
    pickTurn: -1,
    championId: (0, $sjwE0.Maybe).none
};
const $a8f9ed8c5cd7e1b2$export$2ebb7b938507b895 = {
    codec: $a8f9ed8c5cd7e1b2$var$codec,
    empty: $a8f9ed8c5cd7e1b2$var$empty
};


const $df17f7fca0fd39a8$var$bannedChampionsProperties = {
    100: (0, $sjwE0.NonEmptyArray).codec((0, $a8f9ed8c5cd7e1b2$export$2ebb7b938507b895).codec),
    200: (0, $sjwE0.NonEmptyArray).codec((0, $a8f9ed8c5cd7e1b2$export$2ebb7b938507b895).codec)
};
const $df17f7fca0fd39a8$var$participantsProperties = {
    100: (0, $sjwE0.NonEmptyArray).codec((0, $7365bbcb5e753bee$export$31eb4e888063c573).codec),
    200: (0, $sjwE0.NonEmptyArray).codec((0, $7365bbcb5e753bee$export$31eb4e888063c573).codec)
};
const $df17f7fca0fd39a8$var$codec = $jPaL5.struct({
    gameStartTime: (0, $sjwE0.Maybe).codec((0, $hHBpg.DayJsFromISOString).codec),
    /** MapId */ mapId: $jPaL5.number,
    /** GameMode */ gameMode: $jPaL5.string,
    /** GameQueue */ gameQueueConfigId: $jPaL5.number,
    isDraft: $jPaL5.boolean,
    bannedChampions: $jPaL5.readonly($jPaL5.partial($df17f7fca0fd39a8$var$bannedChampionsProperties)),
    participants: $jPaL5.readonly($jPaL5.partial($df17f7fca0fd39a8$var$participantsProperties)),
    isPoroOK: $jPaL5.boolean
});
const $df17f7fca0fd39a8$export$d949d84c708ca152 = {
    codec: $df17f7fca0fd39a8$var$codec
};


const $ac148fc31832ed14$var$codec = $jPaL5.struct({
    summoner: (0, $aZGGZ.SummonerShort).codec,
    game: (0, $sjwE0.Maybe).codec((0, $df17f7fca0fd39a8$export$d949d84c708ca152).codec)
});
const $ac148fc31832ed14$var$Lens = {
    game: {
        participants: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('game'), (0, $gnzcc).some, (0, $asc1N).prop('participants'))
    }
};
const $ac148fc31832ed14$export$8609024c4106d527 = {
    codec: $ac148fc31832ed14$var$codec,
    Lens: $ac148fc31832ed14$var$Lens
};



var $sjwE0 = parcelRequire("sjwE0");

var $9xM77 = parcelRequire("9xM77");

var $7VlB6 = parcelRequire("7VlB6");

var $2sln7 = parcelRequire("2sln7");
const $41f7b65297f1c1ab$var$timeout = (0, $1GV7y.MsDuration).minute(1);
function $41f7b65297f1c1ab$export$1432bee435d2d13b(lang, platform, riotId) {
    const { mutate: mutate } = (0, $yr2dg.useSWRConfig)();
    const { historyStateRef: historyStateRef, modifyHistoryStateRef: modifyHistoryStateRef } = (0, $9xM77.useHistory)();
    const key = (0, $k8rBo.apiRoutes).summoner.byRiotId(platform)(riotId).activeGame(lang).get;
    const res = (0, $3WFZ7.default)(key, ([url, method])=>(0, $f5id0.pipe)(historyStateRef.current.game, (0, $sjwE0.Maybe).fold(()=>(0, $2sln7.http)([
                url,
                method
            ], {
                timeout: $41f7b65297f1c1ab$var$timeout
            }, $41f7b65297f1c1ab$export$9e6b371f9e8e5333), (0, $f5id0.flow)((0, $sjwE0.Future).successful, (0, $sjwE0.Future).chainFirstIOK(()=>()=>modifyHistoryStateRef((0, $9xM77.HistoryState).Lens.game.set((0, $sjwE0.Maybe).none))), (0, $sjwE0.Future).map((game)=>(0, $dW1pp.ValidatedSoft)(game)))), (0, $7VlB6.futureRunUnsafe)), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    $41f7b65297f1c1ab$export$d2fa983f8fa4372a(res.data?.errors);
    return {
        ...res,
        data: res.data?.value,
        mutate: (0, $bh6RR.useCallback)((data, opts)=>mutate(key, data, opts), // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...key,
            mutate
        ])
    };
}
const $41f7b65297f1c1ab$export$9e6b371f9e8e5333 = (0, $sjwE0.Tuple).of((0, $dW1pp.ValidatedSoft).decoder((0, $ac148fc31832ed14$export$8609024c4106d527).codec, $4BSZX.string), 'ValidatedSoft<SummonerActiveGameView, string>');
function $41f7b65297f1c1ab$export$d2fa983f8fa4372a(errors) {
    (0, $bh6RR.useEffect)(()=>{
        if (errors !== undefined && (0, $sjwE0.List).isNonEmpty(errors)) console.error((0, $sjwE0.List).mkString('Game errors:\n- ', '\n- ', '\n')(errors));
    }, [
        errors
    ]);
}


const $87dc3d03975134e5$export$689d97825c9414dc = ({ platform: platform, puuid: puuid })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
            ...(0, $7Dhdf.useSWRHttp)((0, $k8rBo.apiRoutes).summoner.byPuuid(platform)(puuid).masteries.get, {}, [
                (0, $d7d93897afbab07d$export$295b25f3552f2c84).codec,
                'SummonerMasteriesView'
            ]),
            children: (masteries)=>/*#__PURE__*/ (0, $ih19M.jsx)($87dc3d03975134e5$var$SummonerByProfileLoaded, {
                    platform: platform,
                    masteries: masteries
                })
        })
    });
const $87dc3d03975134e5$export$af8896da5ab9f805 = ({ platform: platform, puuid: puuid })=>{
    const { lang: lang } = (0, $4MEuc.useTranslation)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
            ...(0, $7Dhdf.useSWRHttp)((0, $k8rBo.apiRoutes).summoner.byPuuid(platform)(puuid).activeGame(lang).get, {}, (0, $41f7b65297f1c1ab$export$9e6b371f9e8e5333)),
            children: (data)=>/*#__PURE__*/ (0, $ih19M.jsx)($87dc3d03975134e5$var$SummonerByGameLoaded, {
                    platform: platform,
                    data: data
                })
        })
    });
};
const $87dc3d03975134e5$var$SummonerByProfileLoaded = ({ platform: platform, masteries: masteries })=>{
    const { modifyHistoryStateRef: modifyHistoryStateRef, masteriesQuery: masteriesQuery } = (0, $9xM77.useHistory)();
    (0, $bh6RR.useEffect)(()=>{
        modifyHistoryStateRef((0, $9xM77.HistoryState).Lens.masteries.set((0, $sjwE0.Maybe).some(masteries)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $36sK8.Navigate), {
        to: (0, $gE3ky.appRoutes).platformRiotId(platform, masteries.summoner.riotId, (0, $kiCtw.MasteriesQuery).toPartial(masteriesQuery)),
        replace: true
    });
};
const $87dc3d03975134e5$var$SummonerByGameLoaded = ({ platform: platform, data: data })=>{
    const game = data.value;
    (0, $41f7b65297f1c1ab$export$d2fa983f8fa4372a)(data.errors);
    const { modifyHistoryStateRef: modifyHistoryStateRef } = (0, $9xM77.useHistory)();
    (0, $bh6RR.useEffect)(()=>{
        modifyHistoryStateRef((0, $9xM77.HistoryState).Lens.game.set((0, $sjwE0.Maybe).some(game)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $36sK8.Navigate), {
        to: (0, $gE3ky.appRoutes).platformRiotIdGame(platform, game.summoner.riotId),
        replace: true
    });
};



var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $k8rBo = parcelRequire("k8rBo");

var $kJAjV = parcelRequire("kJAjV");
var $10ZIc = parcelRequire("10ZIc");

var $f5id0 = parcelRequire("f5id0");

var $jPaL5 = parcelRequire("jPaL5");

var $1k68G = parcelRequire("1k68G");

var $sjwE0 = parcelRequire("sjwE0");

var $hHBpg = parcelRequire("hHBpg");
const { wrap: $7155420a73f17f40$var$wrap, unwrap: $7155420a73f17f40$var$unwrap } = (0, $1k68G.iso)();
const $7155420a73f17f40$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.number);
const $7155420a73f17f40$var$Eq = (0, $f5id0.pipe)((0, $10ZIc).Eq, (0, $kJAjV).contramap($7155420a73f17f40$var$unwrap));
const $7155420a73f17f40$export$43ac25706d3b5d4a = (0, $sjwE0.immutableAssign)($7155420a73f17f40$var$wrap, {
    unwrap: $7155420a73f17f40$var$unwrap,
    codec: $7155420a73f17f40$var$codec,
    Eq: $7155420a73f17f40$var$Eq
});



var $65UVg = parcelRequire("65UVg");


var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");

var $1xLAE = parcelRequire("1xLAE");

var $jPaL5 = parcelRequire("jPaL5");

const $718140694ee8fb25$var$codec = $jPaL5.struct({
    id: (0, $7155420a73f17f40$export$43ac25706d3b5d4a).codec,
    name: $jPaL5.string,
    description: $jPaL5.string,
    plaintext: $jPaL5.string,
    image: $jPaL5.string
});
const $718140694ee8fb25$export$5d8566322c77991f = {
    codec: $718140694ee8fb25$var$codec
};



var $jPaL5 = parcelRequire("jPaL5");

const $dcd335b25e65576e$var$codec = $jPaL5.struct({
    id: (0, $7340158445f0915b$export$96c66196b0b4f739).codec,
    name: $jPaL5.string,
    longDesc: $jPaL5.string,
    iconPath: $jPaL5.string
});
const $dcd335b25e65576e$export$49b18f1aa22c1e57 = {
    codec: $dcd335b25e65576e$var$codec
};



var $jPaL5 = parcelRequire("jPaL5");

var $sjwE0 = parcelRequire("sjwE0");


const $fdb5793d0f1db8bf$var$codec = $jPaL5.struct({
    id: (0, $56a38f105919baed$export$597b42c1d60925a3).codec,
    icon: $jPaL5.string,
    name: $jPaL5.string,
    slots: (0, $sjwE0.List).codec($jPaL5.struct({
        runes: (0, $sjwE0.List).codec((0, $7340158445f0915b$export$96c66196b0b4f739).codec)
    }))
});
const $fdb5793d0f1db8bf$export$4ef9a04ed09bb111 = {
    codec: $fdb5793d0f1db8bf$var$codec
};



var $jPaL5 = parcelRequire("jPaL5");

var $jPaL5 = parcelRequire("jPaL5");

var $hHBpg = parcelRequire("hHBpg");
const $db9e2377ff0e7705$var$codec = (0, $hHBpg.fromNewtype)($jPaL5.string);
const $db9e2377ff0e7705$export$18b673513e92ca23 = {
    codec: $db9e2377ff0e7705$var$codec
};



const $f72e06b3921aed8d$var$codec = $jPaL5.struct({
    id: (0, $db9e2377ff0e7705$export$18b673513e92ca23).codec,
    key: (0, $87807dff4a3e74cf$export$733cfc729a9b57a7).codec,
    name: $jPaL5.string,
    description: $jPaL5.string,
    cooldown: $jPaL5.number
});
const $f72e06b3921aed8d$export$67dfffeeeae52312 = {
    codec: $f72e06b3921aed8d$var$codec
};


const $e8f514beccf46851$var$codec = $jPaL5.struct({
    version: (0, $1xLAE.DDragonVersion).codec,
    summonerSpells: (0, $sjwE0.List).codec((0, $f72e06b3921aed8d$export$67dfffeeeae52312).codec),
    runeStyles: (0, $sjwE0.List).codec((0, $fdb5793d0f1db8bf$export$4ef9a04ed09bb111).codec),
    runes: (0, $sjwE0.List).codec((0, $dcd335b25e65576e$export$49b18f1aa22c1e57).codec),
    items: (0, $sjwE0.List).codec((0, $718140694ee8fb25$export$5d8566322c77991f).codec)
});
const $e8f514beccf46851$export$94540228b78a751e = {
    codec: $e8f514beccf46851$var$codec
};




var $iPRex = parcelRequire("iPRex");

var $sjwE0 = parcelRequire("sjwE0");

var $9g4gL = parcelRequire("9g4gL");

/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");



var $sjwE0 = parcelRequire("sjwE0");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $aGpBO = parcelRequire("aGpBO");

var $4MEuc = parcelRequire("4MEuc");

var $es0HS = parcelRequire("es0HS");
const $a733205e276a6444$var$base = (0, $aGpBO.DDragonUtils).ddragon('/cdn/img/');
const $a733205e276a6444$export$dd4e3679fae405b5 = ({ icon: icon, name: name, description: description, tooltipShouldHide: tooltipShouldHide, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                ref: ref,
                src: `${$a733205e276a6444$var$base}${icon}`,
                alt: t.runeIconAlt(name),
                className: className
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                shouldHide: tooltipShouldHide,
                className: "flex max-w-xs flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "font-bold",
                        children: name
                    }),
                    description !== undefined && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: description
                        },
                        className: "whitespace-normal"
                    })
                ]
            })
        ]
    });
};



var $es0HS = parcelRequire("es0HS");
const $90a33c3d4666f1d8$export$e3b0796a61ebb801 = {
    id: (0, $7340158445f0915b$export$96c66196b0b4f739)(8347),
    haste: 18
};
const $90a33c3d4666f1d8$var$ionianBootsOfLucidity = {
    id: (0, $7155420a73f17f40$export$43ac25706d3b5d4a)(3158),
    haste: 10
};
const $90a33c3d4666f1d8$var$crimsonLucidity = {
    id: (0, $7155420a73f17f40$export$43ac25706d3b5d4a)(3171),
    haste: 20
};
const $90a33c3d4666f1d8$export$14b1c0db81189f0d = ({ runeById: runeById, itemById: itemById, totalHaste: totalHaste, onToggle: onToggle, cosmicInsightDefaultChecked: cosmicInsightDefaultChecked = false, cosmicInsightDisabled: cosmicInsightDisabled = false, canBuyCrimsonLucidity: canBuyCrimsonLucidity, size: size = 'large', className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const isSmall = size === 'small';
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                ref: ref,
                className: (0, $jK7ok.cx)('flex gap-2', className),
                children: [
                    (0, $f5id0.pipe)(runeById($90a33c3d4666f1d8$export$e3b0796a61ebb801.id), (0, $sjwE0.Maybe).fold(()=>null, (rune)=>/*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$RuneBonusCheckbox, {
                            defaultChecked: cosmicInsightDefaultChecked,
                            haste: $90a33c3d4666f1d8$export$e3b0796a61ebb801.haste,
                            rune: rune,
                            onToggle: onToggle,
                            disabled: cosmicInsightDisabled,
                            isSmall: isSmall
                        }))),
                    (0, $f5id0.pipe)(itemById($90a33c3d4666f1d8$var$ionianBootsOfLucidity.id), (0, $sjwE0.Maybe).fold(()=>null, (baseItem)=>/*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$BootsBonusRadio, {
                            baseHaste: $90a33c3d4666f1d8$var$ionianBootsOfLucidity.haste,
                            baseItem: baseItem,
                            upgradedHaste: $90a33c3d4666f1d8$var$crimsonLucidity.haste,
                            upgradedItem: (0, $f5id0.pipe)(itemById($90a33c3d4666f1d8$var$crimsonLucidity.id), (0, $sjwE0.Maybe).filter(()=>canBuyCrimsonLucidity)),
                            onToggle: onToggle,
                            isSmall: isSmall
                        })))
                ]
            }),
            totalHaste !== undefined && /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                placement: "top",
                children: t.totalHaste(totalHaste)
            })
        ]
    });
};
const $90a33c3d4666f1d8$var$RuneBonusCheckbox = ({ defaultChecked: defaultChecked, haste: haste, rune: rune, onToggle: onToggle, disabled: disabled, isSmall: isSmall })=>{
    const [checked, setChecked] = (0, $bh6RR.useState)(false);
    const onChange = (0, $bh6RR.useCallback)(()=>{
        if (checked) {
            onToggle(-haste);
            setChecked(false);
        } else {
            onToggle(haste);
            setChecked(true);
        }
    }, [
        checked,
        haste,
        onToggle
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (defaultChecked) onChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // only on mount
    ;
    const id = (0, $bh6RR.useId)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                type: "checkbox",
                id: id,
                checked: checked,
                onChange: onChange,
                disabled: disabled,
                className: "peer sr-only"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$Label, {
                htmlFor: id,
                isSmall: isSmall,
                crossedOut: !checked,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a733205e276a6444$export$dd4e3679fae405b5), {
                    icon: rune.iconPath,
                    name: rune.name,
                    description: rune.longDesc,
                    className: "w-full"
                })
            })
        ]
    });
};
const $90a33c3d4666f1d8$var$radioStateValues = [
    'none',
    'base',
    'upgraded'
];
const $90a33c3d4666f1d8$var$BootsBonusRadio = ({ baseHaste: baseHaste, baseItem: baseItem, upgradedHaste: upgradedHaste, upgradedItem: upgradedItem, onToggle: onToggle, isSmall: isSmall })=>{
    const [value, setValue] = (0, $bh6RR.useState)('none');
    const onClick = (0, $bh6RR.useCallback)(()=>{
        switch(value){
            case 'none':
                onToggle(baseHaste);
                return setValue('base');
            case 'base':
                if ((0, $sjwE0.Maybe).isSome(upgradedItem)) {
                    onToggle(-baseHaste + upgradedHaste);
                    return setValue('upgraded');
                }
                onToggle(-baseHaste);
                return setValue('none');
            case 'upgraded':
                onToggle(-upgradedHaste);
                return setValue('none');
            default:
                (0, $sjwE0.assertUnreachable)(value);
        }
    }, [
        baseHaste,
        onToggle,
        upgradedHaste,
        upgradedItem,
        value
    ]);
    const id = (0, $bh6RR.useId)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
        className: "flex",
        children: [
            $90a33c3d4666f1d8$var$radioStateValues.map((val)=>/*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$Radio, {
                    name: "hastBoots",
                    id: `${id}-${val}`,
                    value: val,
                    setValue: setValue,
                    isChecked: val === value
                }, val)),
            /*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$Label, {
                htmlFor: `${id}-${value}`,
                isSmall: isSmall,
                crossedOut: value === 'none',
                onClick: onClick,
                children: (0, $f5id0.pipe)(upgradedItem, (0, $sjwE0.Maybe).filter(()=>value === 'upgraded'), (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$Item, {
                        item: baseItem
                    }), (upgraded)=>/*#__PURE__*/ (0, $ih19M.jsx)($90a33c3d4666f1d8$var$Item, {
                        item: upgraded
                    })))
            })
        ]
    });
};
function $90a33c3d4666f1d8$var$Radio({ name: name, id: id, value: value, setValue: setValue, isChecked: isChecked }) {
    const onChange = (0, $bh6RR.useCallback)(()=>setValue(value), [
        setValue,
        value
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("input", {
        type: "radio",
        name: name,
        id: id,
        value: value,
        checked: isChecked,
        onChange: onChange,
        className: "peer sr-only" // peer enabled cursor pointer below
    });
}
const $90a33c3d4666f1d8$var$Item = ({ item: item })=>{
    const { assets: assets } = (0, $6H0K7.useStaticData)();
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                ref: ref,
                src: assets.item(item.id),
                alt: item.name,
                className: "w-full"
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                className: "flex max-w-xs flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "font-bold",
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "whitespace-break-spaces",
                        children: item.plaintext
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        },
                        className: "whitespace-normal"
                    })
                ]
            })
        ]
    });
};
const $90a33c3d4666f1d8$var$Label = ({ htmlFor: htmlFor, isSmall: isSmall, crossedOut: crossedOut, onClick: onClick, children: children })=>/*#__PURE__*/ (0, $ih19M.jsxs)("label", {
        htmlFor: htmlFor,
        // prevent drag and drop in parents
        onPointerDown: $90a33c3d4666f1d8$var$stopPropagation,
        onClick: onClick,
        className: (0, $jK7ok.cx)('relative flex overflow-hidden bg-black peer-enabled:cursor-pointer', isSmall ? 'w-7' : 'w-10'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: crossedOut ? 'opacity-60' : undefined,
                children: children
            }),
            crossedOut && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "absolute top-[calc(100%_-_0.125rem)] w-20 origin-left -rotate-45 border-t-4 border-red-ban shadow-even shadow-black"
            })
        ]
    });
function $90a33c3d4666f1d8$var$stopPropagation(e) {
    e.stopPropagation();
}


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $kXnAC = parcelRequire("kXnAC");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");

var $es0HS = parcelRequire("es0HS");
const $b72d2f6975f721d9$export$10199abf042bcb34 = ({ spell: spell, haste: haste = 0, tooltipShouldHide: tooltipShouldHide, className: className, timerClassName: timerClassName })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { assets: assets } = (0, $6H0K7.useStaticData)();
    // https://wiki.leagueoflegends.com/en-us/Haste#Formula
    const cooldown = spell.cooldown * (100 / (100 + haste));
    const ref = (0, $bh6RR.useRef)(null);
    const intervalId = (0, $bh6RR.useRef)();
    function clearInterval() {
        window.clearInterval(intervalId.current);
    }
    // clearInterval on unmount
    (0, $bh6RR.useEffect)(()=>clearInterval, []);
    const [remainingSeconds, setRemainingSeconds] = (0, $bh6RR.useState)();
    const onClick = (0, $bh6RR.useCallback)(()=>{
        if (intervalId.current !== undefined) window.clearInterval(intervalId.current);
        if (remainingSeconds === undefined) {
            // eslint-disable-next-line functional/immutable-data
            intervalId.current = window.setInterval(()=>{
                setRemainingSeconds((n)=>{
                    if (n === undefined) return n;
                    const newN = n - 1;
                    if (newN <= 0) {
                        clearInterval();
                        return undefined;
                    }
                    return newN;
                });
            }, 1000);
            setRemainingSeconds(cooldown);
        } else setRemainingSeconds(undefined);
    }, [
        remainingSeconds,
        cooldown
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                ref: ref,
                type: "button",
                onClick: onClick,
                // prevent drag and drop in parents
                onPointerDown: $b72d2f6975f721d9$var$stopPropagation,
                className: (0, $jK7ok.cx)('relative grid place-items-center', className),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: assets.summonerSpell(spell.id),
                        alt: t.spellIconAlt(spell.name),
                        className: "size-full area-1"
                    }),
                    remainingSeconds !== undefined && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, $jK7ok.cx)('grid size-full place-items-center bg-black/50 font-lib-mono text-white shadow-black area-1 text-shadow', timerClassName),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "-mx-96 area-1",
                            children: (0, $kXnAC.DayJs).Duration.formatSeconds(remainingSeconds)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                shouldHide: tooltipShouldHide,
                className: "grid max-w-xs grid-cols-[auto_auto] gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "font-bold",
                        children: spell.name
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "justify-self-end",
                        children: t.cooldownSeconds(cooldown, 'text-goldenrod')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "col-span-2 whitespace-normal",
                        children: spell.description
                    })
                ]
            })
        ]
    });
};
function $b72d2f6975f721d9$var$stopPropagation(e) {
    e.stopPropagation();
}



var $tA0jd = parcelRequire("tA0jd");

var $4MEuc = parcelRequire("4MEuc");

var $7Dhdf = parcelRequire("7Dhdf");
const $73419687c58f28ef$var$cleanse = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(1);
const $73419687c58f28ef$var$exhaust = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(3);
const $73419687c58f28ef$var$flash = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(4);
const $73419687c58f28ef$var$ghost = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(6);
const $73419687c58f28ef$var$heal = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(7);
const $73419687c58f28ef$var$smite = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(11);
const $73419687c58f28ef$var$teleport = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(12);
const $73419687c58f28ef$var$ignite = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(14);
const $73419687c58f28ef$var$barrier = (0, $87807dff4a3e74cf$export$733cfc729a9b57a7)(21);
const $73419687c58f28ef$var$normalSpells = new Set([
    $73419687c58f28ef$var$flash,
    $73419687c58f28ef$var$teleport,
    $73419687c58f28ef$var$ignite,
    $73419687c58f28ef$var$barrier,
    $73419687c58f28ef$var$heal,
    $73419687c58f28ef$var$ghost,
    $73419687c58f28ef$var$exhaust,
    $73419687c58f28ef$var$cleanse
]);
const $73419687c58f28ef$var$junSpells = new Set([
    ...$73419687c58f28ef$var$normalSpells,
    $73419687c58f28ef$var$smite
]);
const $73419687c58f28ef$export$8bb2c1fb2b1765a9 = ()=>{
    const { lang: lang } = (0, $4MEuc.useTranslation)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
            ...(0, $7Dhdf.useSWRHttp)((0, $k8rBo.apiRoutes).staticData(lang).additional.get, {}, [
                (0, $e8f514beccf46851$export$94540228b78a751e).codec,
                'AdditionalStaticData'
            ]),
            children: (additionalStaticData)=>/*#__PURE__*/ (0, $ih19M.jsx)($73419687c58f28ef$var$Loaded, {
                    additionalStaticData: additionalStaticData
                })
        })
    });
};
const $73419687c58f28ef$var$Loaded = ({ additionalStaticData: additionalStaticData })=>{
    const summonerSpellByKey = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.summonerSpells, (0, $iPRex.ListUtils).findFirstBy((0, $87807dff4a3e74cf$export$733cfc729a9b57a7).Eq)((s)=>s.key)), [
        additionalStaticData.summonerSpells
    ]);
    const runeById = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.runes, (0, $iPRex.ListUtils).findFirstBy((0, $7340158445f0915b$export$96c66196b0b4f739).Eq)((r)=>r.id)), [
        additionalStaticData.runes
    ]);
    const itemById = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.items, (0, $iPRex.ListUtils).findFirstBy((0, $7155420a73f17f40$export$43ac25706d3b5d4a).Eq)((i)=>i.id)), [
        additionalStaticData.items
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "grid min-h-full place-items-center",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
            className: "flex flex-col gap-5",
            children: (0, $65UVg.ChampionPosition).values.map((position)=>/*#__PURE__*/ (0, $ih19M.jsx)($73419687c58f28ef$var$Position, {
                    runeById: runeById,
                    itemById: itemById,
                    position: position,
                    spells: position === 'jun' ? $73419687c58f28ef$var$junSpells : $73419687c58f28ef$var$normalSpells,
                    summonerSpellByKey: summonerSpellByKey
                }, position))
        })
    });
};
const $73419687c58f28ef$var$Position = ({ runeById: runeById, itemById: itemById, position: position, spells: spells, summonerSpellByKey: summonerSpellByKey })=>{
    const [totalHaste, setTotalHaste] = (0, $bh6RR.useState)(0);
    const onToggleHaste = (0, $bh6RR.useCallback)((addHaste)=>setTotalHaste((h)=>h + addHaste), []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
        className: "flex items-center gap-5",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $90a33c3d4666f1d8$export$14b1c0db81189f0d), {
                runeById: runeById,
                itemById: itemById,
                totalHaste: totalHaste,
                onToggle: onToggleHaste,
                canBuyCrimsonLucidity: position === 'mid'
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2fef2422e6a814aa$export$12e8b9f23d53a496), {
                position: position,
                className: "size-12"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                className: "flex gap-3",
                children: (0, $f5id0.pipe)(Array.from(spells), (0, $sjwE0.List).filterMap((0, $f5id0.flow)(summonerSpellByKey, (0, $sjwE0.Maybe).map((spell)=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b72d2f6975f721d9$export$10199abf042bcb34), {
                            spell: spell,
                            haste: totalHaste,
                            className: "w-16 overflow-hidden rounded-lg",
                            timerClassName: "text-2xl bg-black/60"
                        })
                    }, (0, $87807dff4a3e74cf$export$733cfc729a9b57a7).unwrap(spell.key))))))
            })
        ]
    });
};



const $a58de5afbed04983$export$8f34c1ae61107b83 = (0, $6832416c36d6fed8$export$7cf138d016f88fdb)('http://wiki.leagueoflegends.com/en-us/Ultra_Rapid_Fire#Mode-Specific_Changes', (c)=>c.urf);


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");
parcelRequire("jRQku");
var $5DIoZ = parcelRequire("5DIoZ");
function $a5dd95fcc53b1ccd$var$clamp(v, min, max) {
    return Math.max(min, Math.min(v, max));
}
const $a5dd95fcc53b1ccd$export$e7c866399fa523f5 = {
    toVector (v, fallback) {
        if (v === undefined) v = fallback;
        return Array.isArray(v) ? v : [
            v,
            v
        ];
    },
    add (v1, v2) {
        return [
            v1[0] + v2[0],
            v1[1] + v2[1]
        ];
    },
    sub (v1, v2) {
        return [
            v1[0] - v2[0],
            v1[1] - v2[1]
        ];
    },
    addTo (v1, v2) {
        v1[0] += v2[0];
        v1[1] += v2[1];
    },
    subTo (v1, v2) {
        v1[0] -= v2[0];
        v1[1] -= v2[1];
    }
};
function $a5dd95fcc53b1ccd$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $a5dd95fcc53b1ccd$export$43caf9889c228507(position, min, max, constant = 0.15) {
    if (constant === 0) return $a5dd95fcc53b1ccd$var$clamp(position, min, max);
    if (position < min) return -$a5dd95fcc53b1ccd$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$a5dd95fcc53b1ccd$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $a5dd95fcc53b1ccd$export$db3b6bfb95261072(bounds, [Vx, Vy], [Rx, Ry]) {
    const [[X0, X1], [Y0, Y1]] = bounds;
    return [
        $a5dd95fcc53b1ccd$export$43caf9889c228507(Vx, X0, X1, Rx),
        $a5dd95fcc53b1ccd$export$43caf9889c228507(Vy, Y0, Y1, Ry)
    ];
}


function $12aee7b0cfe380c9$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $12aee7b0cfe380c9$var$_toPropertyKey(arg) {
    var key = $12aee7b0cfe380c9$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $12aee7b0cfe380c9$export$407448d2b89b1813(obj, key, value) {
    key = $12aee7b0cfe380c9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $12aee7b0cfe380c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12aee7b0cfe380c9$export$71511d61b312f219(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12aee7b0cfe380c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $12aee7b0cfe380c9$export$407448d2b89b1813(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12aee7b0cfe380c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $12aee7b0cfe380c9$var$EVENT_TYPE_MAP = {
    pointer: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    mouse: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    touch: {
        start: 'start',
        change: 'move',
        end: 'end'
    },
    gesture: {
        start: 'start',
        change: 'change',
        end: 'end'
    }
};
function $12aee7b0cfe380c9$var$capitalize(string) {
    if (!string) return '';
    return string[0].toUpperCase() + string.slice(1);
}
const $12aee7b0cfe380c9$var$actionsWithoutCaptureSupported = [
    'enter',
    'leave'
];
function $12aee7b0cfe380c9$var$hasCapture(capture = false, actionKey) {
    return capture && !$12aee7b0cfe380c9$var$actionsWithoutCaptureSupported.includes(actionKey);
}
function $12aee7b0cfe380c9$export$4368d992c4eafac0(device, action = '', capture = false) {
    const deviceProps = $12aee7b0cfe380c9$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return 'on' + $12aee7b0cfe380c9$var$capitalize(device) + $12aee7b0cfe380c9$var$capitalize(actionKey) + ($12aee7b0cfe380c9$var$hasCapture(capture, actionKey) ? 'Capture' : '');
}
const $12aee7b0cfe380c9$var$pointerCaptureEvents = [
    'gotpointercapture',
    'lostpointercapture'
];
function $12aee7b0cfe380c9$export$ffb5f4729a158638(prop) {
    let eventKey = prop.substring(2).toLowerCase();
    const passive = !!~eventKey.indexOf('passive');
    if (passive) eventKey = eventKey.replace('passive', '');
    const captureKey = $12aee7b0cfe380c9$var$pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
    const capture = !!~eventKey.indexOf(captureKey);
    if (capture) eventKey = eventKey.replace('capture', '');
    return {
        device: eventKey,
        capture: capture,
        passive: passive
    };
}
function $12aee7b0cfe380c9$export$625550452a3fa3ec(device, action = '') {
    const deviceProps = $12aee7b0cfe380c9$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return device + actionKey;
}
function $12aee7b0cfe380c9$export$23f2a1d2818174ef(event) {
    return 'touches' in event;
}
function $12aee7b0cfe380c9$var$getPointerType(event) {
    if ($12aee7b0cfe380c9$export$23f2a1d2818174ef(event)) return 'touch';
    if ('pointerType' in event) return event.pointerType;
    return 'mouse';
}
function $12aee7b0cfe380c9$var$getCurrentTargetTouchList(event) {
    return Array.from(event.touches).filter((e)=>{
        var _event$currentTarget, _event$currentTarget$;
        return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
    });
}
function $12aee7b0cfe380c9$var$getTouchList(event) {
    return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}
function $12aee7b0cfe380c9$var$getValueEvent(event) {
    return $12aee7b0cfe380c9$export$23f2a1d2818174ef(event) ? $12aee7b0cfe380c9$var$getTouchList(event)[0] : event;
}
function $12aee7b0cfe380c9$var$distanceAngle(P1, P2) {
    try {
        const dx = P2.clientX - P1.clientX;
        const dy = P2.clientY - P1.clientY;
        const cx = (P2.clientX + P1.clientX) / 2;
        const cy = (P2.clientY + P1.clientY) / 2;
        const distance = Math.hypot(dx, dy);
        const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
        const origin = [
            cx,
            cy
        ];
        return {
            angle: angle,
            distance: distance,
            origin: origin
        };
    } catch (_unused) {}
    return null;
}
function $12aee7b0cfe380c9$export$8b22cf2602fb60ce(event) {
    return $12aee7b0cfe380c9$var$getCurrentTargetTouchList(event).map((touch)=>touch.identifier);
}
function $12aee7b0cfe380c9$var$touchDistanceAngle(event, ids) {
    const [P1, P2] = Array.from(event.touches).filter((touch)=>ids.includes(touch.identifier));
    return $12aee7b0cfe380c9$var$distanceAngle(P1, P2);
}
function $12aee7b0cfe380c9$var$pointerId(event) {
    const valueEvent = $12aee7b0cfe380c9$var$getValueEvent(event);
    return $12aee7b0cfe380c9$export$23f2a1d2818174ef(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function $12aee7b0cfe380c9$var$pointerValues(event) {
    const valueEvent = $12aee7b0cfe380c9$var$getValueEvent(event);
    return [
        valueEvent.clientX,
        valueEvent.clientY
    ];
}
const $12aee7b0cfe380c9$var$LINE_HEIGHT = 40;
const $12aee7b0cfe380c9$var$PAGE_HEIGHT = 800;
function $12aee7b0cfe380c9$var$wheelValues(event) {
    let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
    if (deltaMode === 1) {
        deltaX *= $12aee7b0cfe380c9$var$LINE_HEIGHT;
        deltaY *= $12aee7b0cfe380c9$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $12aee7b0cfe380c9$var$PAGE_HEIGHT;
        deltaY *= $12aee7b0cfe380c9$var$PAGE_HEIGHT;
    }
    return [
        deltaX,
        deltaY
    ];
}
function $12aee7b0cfe380c9$var$scrollValues(event) {
    var _ref, _ref2;
    const { scrollX: scrollX, scrollY: scrollY, scrollLeft: scrollLeft, scrollTop: scrollTop } = event.currentTarget;
    return [
        (_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0,
        (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0
    ];
}
function $12aee7b0cfe380c9$var$getEventDetails(event) {
    const payload = {};
    if ('buttons' in event) payload.buttons = event.buttons;
    if ('shiftKey' in event) {
        const { shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, ctrlKey: ctrlKey } = event;
        Object.assign(payload, {
            shiftKey: shiftKey,
            altKey: altKey,
            metaKey: metaKey,
            ctrlKey: ctrlKey
        });
    }
    return payload;
}
function $12aee7b0cfe380c9$var$call(v, ...args) {
    if (typeof v === 'function') return v(...args);
    else return v;
}
function $12aee7b0cfe380c9$var$noop() {}
function $12aee7b0cfe380c9$export$db3b6bfb95261072(...fns) {
    if (fns.length === 0) return $12aee7b0cfe380c9$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        let result;
        for (const fn of fns)result = fn.apply(this, arguments) || result;
        return result;
    };
}
function $12aee7b0cfe380c9$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
const $12aee7b0cfe380c9$var$BEFORE_LAST_KINEMATICS_DELAY = 32;
class $12aee7b0cfe380c9$var$Engine {
    constructor(ctrl, args, key){
        this.ctrl = ctrl;
        this.args = args;
        this.key = key;
        if (!this.state) {
            this.state = {};
            this.computeValues([
                0,
                0
            ]);
            this.computeInitial();
            if (this.init) this.init();
            this.reset();
        }
    }
    get state() {
        return this.ctrl.state[this.key];
    }
    set state(state) {
        this.ctrl.state[this.key] = state;
    }
    get shared() {
        return this.ctrl.state.shared;
    }
    get eventStore() {
        return this.ctrl.gestureEventStores[this.key];
    }
    get timeoutStore() {
        return this.ctrl.gestureTimeoutStores[this.key];
    }
    get config() {
        return this.ctrl.config[this.key];
    }
    get sharedConfig() {
        return this.ctrl.config.shared;
    }
    get handler() {
        return this.ctrl.handlers[this.key];
    }
    reset() {
        const { state: state, shared: shared, ingKey: ingKey, args: args } = this;
        shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
        state._step = [
            false,
            false
        ];
        state.intentional = false;
        state._movement = [
            0,
            0
        ];
        state._distance = [
            0,
            0
        ];
        state._direction = [
            0,
            0
        ];
        state._delta = [
            0,
            0
        ];
        state._bounds = [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ];
        state.args = args;
        state.axis = undefined;
        state.memo = undefined;
        state.elapsedTime = state.timeDelta = 0;
        state.direction = [
            0,
            0
        ];
        state.distance = [
            0,
            0
        ];
        state.overflow = [
            0,
            0
        ];
        state._movementBound = [
            false,
            false
        ];
        state.velocity = [
            0,
            0
        ];
        state.movement = [
            0,
            0
        ];
        state.delta = [
            0,
            0
        ];
        state.timeStamp = 0;
    }
    start(event) {
        const state = this.state;
        const config = this.config;
        if (!state._active) {
            this.reset();
            this.computeInitial();
            state._active = true;
            state.target = event.target;
            state.currentTarget = event.currentTarget;
            state.lastOffset = config.from ? $12aee7b0cfe380c9$var$call(config.from, state) : state.offset;
            state.offset = state.lastOffset;
            state.startTime = state.timeStamp = event.timeStamp;
        }
    }
    computeValues(values) {
        const state = this.state;
        state._values = values;
        state.values = this.config.transform(values);
    }
    computeInitial() {
        const state = this.state;
        state._initial = state._values;
        state.initial = state.values;
    }
    compute(event) {
        const { state: state, config: config, shared: shared } = this;
        state.args = this.args;
        let dt = 0;
        if (event) {
            state.event = event;
            if (config.preventDefault && event.cancelable) state.event.preventDefault();
            state.type = event.type;
            shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
            shared.locked = !!document.pointerLockElement;
            Object.assign(shared, $12aee7b0cfe380c9$var$getEventDetails(event));
            shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
            dt = event.timeStamp - state.timeStamp;
            state.timeStamp = event.timeStamp;
            state.elapsedTime = state.timeStamp - state.startTime;
        }
        if (state._active) {
            const _absoluteDelta = state._delta.map(Math.abs);
            (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._distance, _absoluteDelta);
        }
        if (this.axisIntent) this.axisIntent(event);
        const [_m0, _m1] = state._movement;
        const [t0, t1] = config.threshold;
        const { _step: _step, values: values } = state;
        if (config.hasCustomTransform) {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
        } else {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
        }
        state.intentional = _step[0] !== false || _step[1] !== false;
        if (!state.intentional) return;
        const movement = [
            0,
            0
        ];
        if (config.hasCustomTransform) {
            const [v0, v1] = values;
            movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
        } else {
            movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
        }
        if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
        const previousOffset = state.offset;
        const gestureIsActive = state._active && !state._blocked || state.active;
        if (gestureIsActive) {
            state.first = state._active && !state.active;
            state.last = !state._active && state.active;
            state.active = shared[this.ingKey] = state._active;
            if (event) {
                if (state.first) {
                    if ('bounds' in config) state._bounds = $12aee7b0cfe380c9$var$call(config.bounds, state);
                    if (this.setup) this.setup();
                }
                state.movement = movement;
                this.computeOffset();
            }
        }
        const [ox, oy] = state.offset;
        const [[x0, x1], [y0, y1]] = state._bounds;
        state.overflow = [
            ox < x0 ? -1 : ox > x1 ? 1 : 0,
            oy < y0 ? -1 : oy > y1 ? 1 : 0
        ];
        state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
        state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
        const rubberband = state._active ? config.rubberband || [
            0,
            0
        ] : [
            0,
            0
        ];
        state.offset = (0, $a5dd95fcc53b1ccd$export$db3b6bfb95261072)(state._bounds, state.offset, rubberband);
        state.delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(state.offset, previousOffset);
        this.computeMovement();
        if (gestureIsActive && (!state.last || dt > $12aee7b0cfe380c9$var$BEFORE_LAST_KINEMATICS_DELAY)) {
            state.delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(state.offset, previousOffset);
            const absoluteDelta = state.delta.map(Math.abs);
            (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);
            if (!state.first && dt > 0) {
                state.velocity = [
                    absoluteDelta[0] / dt,
                    absoluteDelta[1] / dt
                ];
                state.timeDelta = dt;
            }
        }
    }
    emit() {
        const state = this.state;
        const shared = this.shared;
        const config = this.config;
        if (!state._active) this.clean();
        if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
        const memo = this.handler($12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, shared), state), {}, {
            [this.aliasKey]: state.values
        }));
        if (memo !== undefined) state.memo = memo;
    }
    clean() {
        this.eventStore.clean();
        this.timeoutStore.clean();
    }
}
function $12aee7b0cfe380c9$var$selectAxis([dx, dy], threshold) {
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);
    if (absDx > absDy && absDx > threshold) return 'x';
    if (absDy > absDx && absDy > threshold) return 'y';
    return undefined;
}
class $12aee7b0cfe380c9$var$CoordinatesEngine extends $12aee7b0cfe380c9$var$Engine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "aliasKey", 'xy');
    }
    reset() {
        super.reset();
        this.state.axis = undefined;
    }
    init() {
        this.state.offset = [
            0,
            0
        ];
        this.state.lastOffset = [
            0,
            0
        ];
    }
    computeOffset() {
        this.state.offset = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).add(this.state.lastOffset, this.state.movement);
    }
    computeMovement() {
        this.state.movement = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(this.state.offset, this.state.lastOffset);
    }
    axisIntent(event) {
        const state = this.state;
        const config = this.config;
        if (!state.axis && event) {
            const threshold = typeof config.axisThreshold === 'object' ? config.axisThreshold[$12aee7b0cfe380c9$var$getPointerType(event)] : config.axisThreshold;
            state.axis = $12aee7b0cfe380c9$var$selectAxis(state._movement, threshold);
        }
        state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
    restrictToAxis(v) {
        if (this.config.axis || this.config.lockDirection) switch(this.state.axis){
            case 'x':
                v[1] = 0;
                break;
            case 'y':
                v[0] = 0;
                break;
        }
    }
}
const $12aee7b0cfe380c9$var$identity = (v)=>v;
const $12aee7b0cfe380c9$var$DEFAULT_RUBBERBAND = 0.15;
const $12aee7b0cfe380c9$var$commonConfigResolver = {
    enabled (value = true) {
        return value;
    },
    eventOptions (value, _k, config) {
        return $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, config.shared.eventOptions), value);
    },
    preventDefault (value = false) {
        return value;
    },
    triggerAllEvents (value = false) {
        return value;
    },
    rubberband (value = 0) {
        switch(value){
            case true:
                return [
                    $12aee7b0cfe380c9$var$DEFAULT_RUBBERBAND,
                    $12aee7b0cfe380c9$var$DEFAULT_RUBBERBAND
                ];
            case false:
                return [
                    0,
                    0
                ];
            default:
                return (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(value);
        }
    },
    from (value) {
        if (typeof value === 'function') return value;
        if (value != null) return (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(value);
    },
    transform (value, _k, config) {
        const transform = value || config.shared.transform;
        this.hasCustomTransform = !!transform;
        var v;
        return transform || $12aee7b0cfe380c9$var$identity;
    },
    threshold (value) {
        return (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(value, 0);
    }
};
var $12aee7b0cfe380c9$var$value, $12aee7b0cfe380c9$var$value1, $12aee7b0cfe380c9$var$value2;
const $12aee7b0cfe380c9$var$DEFAULT_AXIS_THRESHOLD = 0;
const $12aee7b0cfe380c9$var$coordinatesConfigResolver = $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, $12aee7b0cfe380c9$var$commonConfigResolver), {}, {
    axis (_v, _k, { axis: axis }) {
        this.lockDirection = axis === 'lock';
        if (!this.lockDirection) return axis;
    },
    axisThreshold (value = $12aee7b0cfe380c9$var$DEFAULT_AXIS_THRESHOLD) {
        return value;
    },
    bounds (value = {}) {
        if (typeof value === 'function') return (state)=>$12aee7b0cfe380c9$var$coordinatesConfigResolver.bounds(value(state));
        if ('current' in value) return ()=>value.current;
        if (typeof HTMLElement === 'function' && value instanceof HTMLElement) return value;
        const { left: left = -Infinity, right: right = Infinity, top: top = -Infinity, bottom: bottom = Infinity } = value;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
const $12aee7b0cfe380c9$var$KEYS_DELTA_MAP = {
    ArrowRight: (displacement, factor = 1)=>[
            displacement * factor,
            0
        ],
    ArrowLeft: (displacement, factor = 1)=>[
            -1 * displacement * factor,
            0
        ],
    ArrowUp: (displacement, factor = 1)=>[
            0,
            -1 * displacement * factor
        ],
    ArrowDown: (displacement, factor = 1)=>[
            0,
            displacement * factor
        ]
};
class $12aee7b0cfe380c9$var$DragEngine extends $12aee7b0cfe380c9$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "ingKey", 'dragging');
    }
    reset() {
        super.reset();
        const state = this.state;
        state._pointerId = undefined;
        state._pointerActive = false;
        state._keyboardActive = false;
        state._preventScroll = false;
        state._delayed = false;
        state.swipe = [
            0,
            0
        ];
        state.tap = false;
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
    }
    setup() {
        const state = this.state;
        if (state._bounds instanceof HTMLElement) {
            const boundRect = state._bounds.getBoundingClientRect();
            const targetRect = state.currentTarget.getBoundingClientRect();
            const _bounds = {
                left: boundRect.left - targetRect.left + state.offset[0],
                right: boundRect.right - targetRect.right + state.offset[0],
                top: boundRect.top - targetRect.top + state.offset[1],
                bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
            };
            state._bounds = $12aee7b0cfe380c9$var$coordinatesConfigResolver.bounds(_bounds);
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        state.canceled = true;
        state._active = false;
        setTimeout(()=>{
            this.compute();
            this.emit();
        }, 0);
    }
    setActive() {
        this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
    clean() {
        this.pointerClean();
        this.state._pointerActive = false;
        this.state._keyboardActive = false;
        super.clean();
    }
    pointerDown(event) {
        const config = this.config;
        const state = this.state;
        if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
        const ctrlIds = this.ctrl.setEventIds(event);
        if (config.pointerCapture) event.target.setPointerCapture(event.pointerId);
        if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
        this.start(event);
        this.setupPointer(event);
        state._pointerId = $12aee7b0cfe380c9$var$pointerId(event);
        state._pointerActive = true;
        this.computeValues($12aee7b0cfe380c9$var$pointerValues(event));
        this.computeInitial();
        if (config.preventScrollAxis && $12aee7b0cfe380c9$var$getPointerType(event) !== 'mouse') {
            state._active = false;
            this.setupScrollPrevention(event);
        } else if (config.delay > 0) {
            this.setupDelayTrigger(event);
            if (config.triggerAllEvents) {
                this.compute(event);
                this.emit();
            }
        } else this.startPointerDrag(event);
    }
    startPointerDrag(event) {
        const state = this.state;
        state._active = true;
        state._preventScroll = true;
        state._delayed = false;
        this.compute(event);
        this.emit();
    }
    pointerMove(event) {
        const state = this.state;
        const config = this.config;
        if (!state._pointerActive) return;
        const id = $12aee7b0cfe380c9$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        const _values = $12aee7b0cfe380c9$var$pointerValues(event);
        if (document.pointerLockElement === event.target) state._delta = [
            event.movementX,
            event.movementY
        ];
        else {
            state._delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(_values, state._values);
            this.computeValues(_values);
        }
        (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.compute(event);
        if (state._delayed && state.intentional) {
            this.timeoutStore.remove('dragDelay');
            state.active = false;
            this.startPointerDrag(event);
            return;
        }
        if (config.preventScrollAxis && !state._preventScroll) {
            if (state.axis) {
                if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
                    state._active = false;
                    this.clean();
                    return;
                } else {
                    this.timeoutStore.remove('startPointerDrag');
                    this.startPointerDrag(event);
                    return;
                }
            } else return;
        }
        this.emit();
    }
    pointerUp(event) {
        this.ctrl.setEventIds(event);
        try {
            if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        const state = this.state;
        const config = this.config;
        if (!state._active || !state._pointerActive) return;
        const id = $12aee7b0cfe380c9$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        this.state._pointerActive = false;
        this.setActive();
        this.compute(event);
        const [dx, dy] = state._distance;
        state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
        if (state.tap && config.filterTaps) state._force = true;
        else {
            const [_dx, _dy] = state._delta;
            const [_mx, _my] = state._movement;
            const [svx, svy] = config.swipe.velocity;
            const [sx, sy] = config.swipe.distance;
            const sdt = config.swipe.duration;
            if (state.elapsedTime < sdt) {
                const _vx = Math.abs(_dx / state.timeDelta);
                const _vy = Math.abs(_dy / state.timeDelta);
                if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
                if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
            }
        }
        this.emit();
    }
    pointerClick(event) {
        if (!this.state.tap && event.detail > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    setupPointer(event) {
        const config = this.config;
        const device = config.device;
        var _unused2;
        if (config.pointerLock) event.currentTarget.requestPointerLock();
        if (!config.pointerCapture) {
            this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
        }
    }
    pointerClean() {
        if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) document.exitPointerLock();
    }
    preventScroll(event) {
        if (this.state._preventScroll && event.cancelable) event.preventDefault();
    }
    setupScrollPrevention(event) {
        this.state._preventScroll = false;
        $12aee7b0cfe380c9$var$persistEvent(event);
        const remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
            passive: false
        });
        this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
        this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
        this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
    setupDelayTrigger(event) {
        this.state._delayed = true;
        this.timeoutStore.add('dragDelay', ()=>{
            this.state._step = [
                0,
                0
            ];
            this.startPointerDrag(event);
        }, this.config.delay);
    }
    keyDown(event) {
        const deltaFn = $12aee7b0cfe380c9$var$KEYS_DELTA_MAP[event.key];
        if (deltaFn) {
            const state = this.state;
            const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
            this.start(event);
            state._delta = deltaFn(this.config.keyboardDisplacement, factor);
            state._keyboardActive = true;
            (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._movement, state._delta);
            this.compute(event);
            this.emit();
        }
    }
    keyUp(event) {
        if (!(event.key in $12aee7b0cfe380c9$var$KEYS_DELTA_MAP)) return;
        this.state._keyboardActive = false;
        this.setActive();
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        bindFunction(device, 'start', this.pointerDown.bind(this));
        if (this.config.pointerCapture) {
            bindFunction(device, 'change', this.pointerMove.bind(this));
            bindFunction(device, 'end', this.pointerUp.bind(this));
            bindFunction(device, 'cancel', this.pointerUp.bind(this));
            bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
        }
        if (this.config.keys) {
            bindFunction('key', 'down', this.keyDown.bind(this));
            bindFunction('key', 'up', this.keyUp.bind(this));
        }
        if (this.config.filterTaps) bindFunction('click', '', this.pointerClick.bind(this), {
            capture: true,
            passive: false
        });
    }
}
function $12aee7b0cfe380c9$var$persistEvent(event) {
    'persist' in event && typeof event.persist === 'function' && event.persist();
}
const $12aee7b0cfe380c9$var$isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
function $12aee7b0cfe380c9$var$supportsTouchEvents() {
    return $12aee7b0cfe380c9$var$isBrowser && 'ontouchstart' in window;
}
function $12aee7b0cfe380c9$var$isTouchScreen() {
    return $12aee7b0cfe380c9$var$supportsTouchEvents() || $12aee7b0cfe380c9$var$isBrowser && window.navigator.maxTouchPoints > 1;
}
function $12aee7b0cfe380c9$var$supportsPointerEvents() {
    return $12aee7b0cfe380c9$var$isBrowser && 'onpointerdown' in window;
}
function $12aee7b0cfe380c9$var$supportsPointerLock() {
    return $12aee7b0cfe380c9$var$isBrowser && 'exitPointerLock' in window.document;
}
function $12aee7b0cfe380c9$var$supportsGestureEvents() {
    try {
        return 'constructor' in GestureEvent;
    } catch (e) {
        return false;
    }
}
const $12aee7b0cfe380c9$export$25ce5a424b770e84 = {
    isBrowser: $12aee7b0cfe380c9$var$isBrowser,
    gesture: $12aee7b0cfe380c9$var$supportsGestureEvents(),
    touch: $12aee7b0cfe380c9$var$supportsTouchEvents(),
    touchscreen: $12aee7b0cfe380c9$var$isTouchScreen(),
    pointer: $12aee7b0cfe380c9$var$supportsPointerEvents(),
    pointerLock: $12aee7b0cfe380c9$var$supportsPointerLock()
};
const $12aee7b0cfe380c9$var$DEFAULT_PREVENT_SCROLL_DELAY = 250;
const $12aee7b0cfe380c9$var$DEFAULT_DRAG_DELAY = 180;
const $12aee7b0cfe380c9$var$DEFAULT_SWIPE_VELOCITY = 0.5;
const $12aee7b0cfe380c9$var$DEFAULT_SWIPE_DISTANCE = 50;
const $12aee7b0cfe380c9$var$DEFAULT_SWIPE_DURATION = 250;
const $12aee7b0cfe380c9$var$DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const $12aee7b0cfe380c9$var$DEFAULT_DRAG_AXIS_THRESHOLD = {
    mouse: 0,
    touch: 0,
    pen: 8
};
const $12aee7b0cfe380c9$var$dragConfigResolver = $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, $12aee7b0cfe380c9$var$coordinatesConfigResolver), {}, {
    device (_v, _k, { pointer: { touch: touch = false, lock: lock = false, mouse: mouse = false } = {} }) {
        this.pointerLock = lock && $12aee7b0cfe380c9$export$25ce5a424b770e84.pointerLock;
        if ($12aee7b0cfe380c9$export$25ce5a424b770e84.touch && touch) return 'touch';
        if (this.pointerLock) return 'mouse';
        if ($12aee7b0cfe380c9$export$25ce5a424b770e84.pointer && !mouse) return 'pointer';
        if ($12aee7b0cfe380c9$export$25ce5a424b770e84.touch) return 'touch';
        return 'mouse';
    },
    preventScrollAxis (value, _k, { preventScroll: preventScroll }) {
        this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? $12aee7b0cfe380c9$var$DEFAULT_PREVENT_SCROLL_DELAY : undefined;
        if (!$12aee7b0cfe380c9$export$25ce5a424b770e84.touchscreen || preventScroll === false) return undefined;
        return value ? value : preventScroll !== undefined ? 'y' : undefined;
    },
    pointerCapture (_v, _k, { pointer: { capture: capture = true, buttons: buttons = 1, keys: keys = true } = {} }) {
        this.pointerButtons = buttons;
        this.keys = keys;
        return !this.pointerLock && this.device === 'pointer' && capture;
    },
    threshold (value, _k, { filterTaps: filterTaps = false, tapsThreshold: tapsThreshold = 3, axis: axis }) {
        const threshold = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        this.tapsThreshold = tapsThreshold;
        return threshold;
    },
    swipe ({ velocity: velocity = $12aee7b0cfe380c9$var$DEFAULT_SWIPE_VELOCITY, distance: distance = $12aee7b0cfe380c9$var$DEFAULT_SWIPE_DISTANCE, duration: duration = $12aee7b0cfe380c9$var$DEFAULT_SWIPE_DURATION } = {}) {
        return {
            velocity: this.transform((0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(velocity)),
            distance: this.transform((0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(distance)),
            duration: duration
        };
    },
    delay (value = 0) {
        switch(value){
            case true:
                return $12aee7b0cfe380c9$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    },
    axisThreshold (value) {
        if (!value) return $12aee7b0cfe380c9$var$DEFAULT_DRAG_AXIS_THRESHOLD;
        return $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, $12aee7b0cfe380c9$var$DEFAULT_DRAG_AXIS_THRESHOLD), value);
    },
    keyboardDisplacement (value = $12aee7b0cfe380c9$var$DEFAULT_KEYBOARD_DISPLACEMENT) {
        return value;
    }
});
var $12aee7b0cfe380c9$var$value3, $12aee7b0cfe380c9$var$value4, $12aee7b0cfe380c9$var$value5, $12aee7b0cfe380c9$var$value6, $12aee7b0cfe380c9$var$value7;
function $12aee7b0cfe380c9$var$clampStateInternalMovementToBounds(state) {
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;
    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) state._movement[0] = state._movementBound[0];
    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) state._movement[1] = state._movementBound[1];
}
const $12aee7b0cfe380c9$var$SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const $12aee7b0cfe380c9$var$PINCH_WHEEL_RATIO = 100;
class $12aee7b0cfe380c9$var$PinchEngine extends $12aee7b0cfe380c9$var$Engine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "ingKey", 'pinching');
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "aliasKey", 'da');
    }
    init() {
        this.state.offset = [
            1,
            0
        ];
        this.state.lastOffset = [
            1,
            0
        ];
        this.state._pointerEvents = new Map();
    }
    reset() {
        super.reset();
        const state = this.state;
        state._touchIds = [];
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
        state.turns = 0;
    }
    computeOffset() {
        const { type: type, movement: movement, lastOffset: lastOffset } = this.state;
        if (type === 'wheel') this.state.offset = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).add(movement, lastOffset);
        else this.state.offset = [
            (1 + movement[0]) * lastOffset[0],
            movement[1] + lastOffset[1]
        ];
    }
    computeMovement() {
        const { offset: offset, lastOffset: lastOffset } = this.state;
        this.state.movement = [
            offset[0] / lastOffset[0],
            offset[1] - lastOffset[1]
        ];
    }
    axisIntent() {
        const state = this.state;
        const [_m0, _m1] = state._movement;
        if (!state.axis) {
            const axisMovementDifference = Math.abs(_m0) * $12aee7b0cfe380c9$var$SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
            if (axisMovementDifference < 0) state.axis = 'angle';
            else if (axisMovementDifference > 0) state.axis = 'scale';
        }
    }
    restrictToAxis(v) {
        if (this.config.lockDirection) {
            if (this.state.axis === 'scale') v[1] = 0;
            else if (this.state.axis === 'angle') v[0] = 0;
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        setTimeout(()=>{
            state.canceled = true;
            state._active = false;
            this.compute();
            this.emit();
        }, 0);
    }
    touchStart(event) {
        this.ctrl.setEventIds(event);
        const state = this.state;
        const ctrlTouchIds = this.ctrl.touchIds;
        if (state._active) {
            if (state._touchIds.every((id)=>ctrlTouchIds.has(id))) return;
        }
        if (ctrlTouchIds.size < 2) return;
        this.start(event);
        state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
        const payload = $12aee7b0cfe380c9$var$touchDistanceAngle(event, state._touchIds);
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pointerStart(event) {
        if (event.buttons != null && event.buttons % 2 !== 1) return;
        this.ctrl.setEventIds(event);
        event.target.setPointerCapture(event.pointerId);
        const state = this.state;
        const _pointerEvents = state._pointerEvents;
        const ctrlPointerIds = this.ctrl.pointerIds;
        if (state._active) {
            if (Array.from(_pointerEvents.keys()).every((id)=>ctrlPointerIds.has(id))) return;
        }
        if (_pointerEvents.size < 2) _pointerEvents.set(event.pointerId, event);
        if (state._pointerEvents.size < 2) return;
        this.start(event);
        const payload = $12aee7b0cfe380c9$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pinchStart(event, payload) {
        const state = this.state;
        state.origin = payload.origin;
        this.computeValues([
            payload.distance,
            payload.angle
        ]);
        this.computeInitial();
        this.compute(event);
        this.emit();
    }
    touchMove(event) {
        if (!this.state._active) return;
        const payload = $12aee7b0cfe380c9$var$touchDistanceAngle(event, this.state._touchIds);
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pointerMove(event) {
        const _pointerEvents = this.state._pointerEvents;
        if (_pointerEvents.has(event.pointerId)) _pointerEvents.set(event.pointerId, event);
        if (!this.state._active) return;
        const payload = $12aee7b0cfe380c9$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pinchMove(event, payload) {
        const state = this.state;
        const prev_a = state._values[1];
        const delta_a = payload.angle - prev_a;
        let delta_turns = 0;
        if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
        this.computeValues([
            payload.distance,
            payload.angle - 360 * delta_turns
        ]);
        state.origin = payload.origin;
        state.turns = delta_turns;
        state._movement = [
            state._values[0] / state._initial[0] - 1,
            state._values[1] - state._initial[1]
        ];
        this.compute(event);
        this.emit();
    }
    touchEnd(event) {
        this.ctrl.setEventIds(event);
        if (!this.state._active) return;
        if (this.state._touchIds.some((id)=>!this.ctrl.touchIds.has(id))) {
            this.state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    pointerEnd(event) {
        const state = this.state;
        this.ctrl.setEventIds(event);
        try {
            event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        if (state._pointerEvents.has(event.pointerId)) state._pointerEvents.delete(event.pointerId);
        if (!state._active) return;
        if (state._pointerEvents.size < 2) {
            state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    gestureStart(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        if (state._active) return;
        this.start(event);
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    gestureMove(event) {
        if (event.cancelable) event.preventDefault();
        if (!this.state._active) return;
        const state = this.state;
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        const _previousMovement = state._movement;
        state._movement = [
            event.scale - 1,
            event.rotation
        ];
        state._delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(state._movement, _previousMovement);
        this.compute(event);
        this.emit();
    }
    gestureEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    wheel(event) {
        const modifierKey = this.config.modifierKey;
        if (modifierKey && (Array.isArray(modifierKey) ? !modifierKey.find((k)=>event[k]) : !event[modifierKey])) return;
        if (!this.state._active) this.wheelStart(event);
        else this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelStart(event) {
        this.start(event);
        this.wheelChange(event);
    }
    wheelChange(event) {
        const isR3f = 'uv' in event;
        if (!isR3f) {
            if (event.cancelable) event.preventDefault();
        }
        const state = this.state;
        state._delta = [
            -$12aee7b0cfe380c9$var$wheelValues(event)[1] / $12aee7b0cfe380c9$var$PINCH_WHEEL_RATIO * state.offset[0],
            0
        ];
        (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $12aee7b0cfe380c9$var$clampStateInternalMovementToBounds(state);
        this.state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        if (!!device) {
            bindFunction(device, 'start', this[device + 'Start'].bind(this));
            bindFunction(device, 'change', this[device + 'Move'].bind(this));
            bindFunction(device, 'end', this[device + 'End'].bind(this));
            bindFunction(device, 'cancel', this[device + 'End'].bind(this));
            bindFunction('lostPointerCapture', '', this[device + 'End'].bind(this));
        }
        if (this.config.pinchOnWheel) bindFunction('wheel', '', this.wheel.bind(this), {
            passive: false
        });
    }
}
const $12aee7b0cfe380c9$var$pinchConfigResolver = $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, $12aee7b0cfe380c9$var$commonConfigResolver), {}, {
    device (_v, _k, { shared: shared, pointer: { touch: touch = false } = {} }) {
        const sharedConfig = shared;
        if (sharedConfig.target && !$12aee7b0cfe380c9$export$25ce5a424b770e84.touch && $12aee7b0cfe380c9$export$25ce5a424b770e84.gesture) return 'gesture';
        if ($12aee7b0cfe380c9$export$25ce5a424b770e84.touch && touch) return 'touch';
        if ($12aee7b0cfe380c9$export$25ce5a424b770e84.touchscreen) {
            if ($12aee7b0cfe380c9$export$25ce5a424b770e84.pointer) return 'pointer';
            if ($12aee7b0cfe380c9$export$25ce5a424b770e84.touch) return 'touch';
        }
    },
    bounds (_v, _k, { scaleBounds: scaleBounds = {}, angleBounds: angleBounds = {} }) {
        const _scaleBounds = (state)=>{
            const D = $12aee7b0cfe380c9$var$assignDefault($12aee7b0cfe380c9$var$call(scaleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        const _angleBounds = (state)=>{
            const A = $12aee7b0cfe380c9$var$assignDefault($12aee7b0cfe380c9$var$call(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [
            _scaleBounds(),
            _angleBounds()
        ];
        return (state)=>[
                _scaleBounds(state),
                _angleBounds(state)
            ];
    },
    threshold (value, _k, config) {
        this.lockDirection = config.axis === 'lock';
        const threshold = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).toVector(value, this.lockDirection ? [
            0.1,
            3
        ] : 0);
        return threshold;
    },
    modifierKey (value) {
        if (value === undefined) return 'ctrlKey';
        return value;
    },
    pinchOnWheel (value = true) {
        return value;
    }
});
class $12aee7b0cfe380c9$var$MoveEngine extends $12aee7b0cfe380c9$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "ingKey", 'moving');
    }
    move(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        if (!this.state._active) this.moveStart(event);
        else this.moveChange(event);
        this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
    }
    moveStart(event) {
        this.start(event);
        this.computeValues($12aee7b0cfe380c9$var$pointerValues(event));
        this.compute(event);
        this.computeInitial();
        this.emit();
    }
    moveChange(event) {
        if (!this.state._active) return;
        const values = $12aee7b0cfe380c9$var$pointerValues(event);
        const state = this.state;
        state._delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(values, state._values);
        (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    moveEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'change', this.move.bind(this));
        bindFunction('pointer', 'leave', this.moveEnd.bind(this));
    }
}
const $12aee7b0cfe380c9$var$moveConfigResolver = $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, $12aee7b0cfe380c9$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
class $12aee7b0cfe380c9$var$ScrollEngine extends $12aee7b0cfe380c9$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "ingKey", 'scrolling');
    }
    scroll(event) {
        if (!this.state._active) this.start(event);
        this.scrollChange(event);
        this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
    }
    scrollChange(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        const values = $12aee7b0cfe380c9$var$scrollValues(event);
        state._delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(values, state._values);
        (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    scrollEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('scroll', '', this.scroll.bind(this));
    }
}
const $12aee7b0cfe380c9$var$scrollConfigResolver = $12aee7b0cfe380c9$var$coordinatesConfigResolver;
class $12aee7b0cfe380c9$var$WheelEngine extends $12aee7b0cfe380c9$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "ingKey", 'wheeling');
    }
    wheel(event) {
        if (!this.state._active) this.start(event);
        this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelChange(event) {
        const state = this.state;
        state._delta = $12aee7b0cfe380c9$var$wheelValues(event);
        (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $12aee7b0cfe380c9$var$clampStateInternalMovementToBounds(state);
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('wheel', '', this.wheel.bind(this));
    }
}
const $12aee7b0cfe380c9$var$wheelConfigResolver = $12aee7b0cfe380c9$var$coordinatesConfigResolver;
class $12aee7b0cfe380c9$var$HoverEngine extends $12aee7b0cfe380c9$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $12aee7b0cfe380c9$export$407448d2b89b1813(this, "ingKey", 'hovering');
    }
    enter(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        this.start(event);
        this.computeValues($12aee7b0cfe380c9$var$pointerValues(event));
        this.compute(event);
        this.emit();
    }
    leave(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        const state = this.state;
        if (!state._active) return;
        state._active = false;
        const values = $12aee7b0cfe380c9$var$pointerValues(event);
        state._movement = state._delta = (0, $a5dd95fcc53b1ccd$export$e7c866399fa523f5).sub(values, state._values);
        this.computeValues(values);
        this.compute(event);
        state.delta = state.movement;
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'enter', this.enter.bind(this));
        bindFunction('pointer', 'leave', this.leave.bind(this));
    }
}
const $12aee7b0cfe380c9$var$hoverConfigResolver = $12aee7b0cfe380c9$export$71511d61b312f219($12aee7b0cfe380c9$export$71511d61b312f219({}, $12aee7b0cfe380c9$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
const $12aee7b0cfe380c9$export$a9c23c6ac3fc3eca = new Map();
const $12aee7b0cfe380c9$export$e7094788287c5e9b = new Map();
function $12aee7b0cfe380c9$export$43caf9889c228507(action) {
    $12aee7b0cfe380c9$export$a9c23c6ac3fc3eca.set(action.key, action.engine);
    $12aee7b0cfe380c9$export$e7094788287c5e9b.set(action.key, action.resolver);
}
const $12aee7b0cfe380c9$export$f1e1789686576879 = {
    key: 'drag',
    engine: $12aee7b0cfe380c9$var$DragEngine,
    resolver: $12aee7b0cfe380c9$var$dragConfigResolver
};
const $12aee7b0cfe380c9$export$dda1d9f60106f0e9 = {
    key: 'hover',
    engine: $12aee7b0cfe380c9$var$HoverEngine,
    resolver: $12aee7b0cfe380c9$var$hoverConfigResolver
};
const $12aee7b0cfe380c9$export$953cecd6e717a553 = {
    key: 'move',
    engine: $12aee7b0cfe380c9$var$MoveEngine,
    resolver: $12aee7b0cfe380c9$var$moveConfigResolver
};
const $12aee7b0cfe380c9$export$2d1720544b23b823 = {
    key: 'pinch',
    engine: $12aee7b0cfe380c9$var$PinchEngine,
    resolver: $12aee7b0cfe380c9$var$pinchConfigResolver
};
const $12aee7b0cfe380c9$export$2408f22a0fab9ae5 = {
    key: 'scroll',
    engine: $12aee7b0cfe380c9$var$ScrollEngine,
    resolver: $12aee7b0cfe380c9$var$scrollConfigResolver
};
const $12aee7b0cfe380c9$export$efccba1c4a2ef57b = {
    key: 'wheel',
    engine: $12aee7b0cfe380c9$var$WheelEngine,
    resolver: $12aee7b0cfe380c9$var$wheelConfigResolver
};






var $bh6RR = parcelRequire("bh6RR");


function $6955631256e6de43$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6955631256e6de43$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6955631256e6de43$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $6955631256e6de43$var$sharedConfigResolver = {
    target (value) {
        if (value) return ()=>'current' in value ? value.current : value;
        return undefined;
    },
    enabled (value = true) {
        return value;
    },
    window (value = (0, $12aee7b0cfe380c9$export$25ce5a424b770e84).isBrowser ? window : undefined) {
        return value;
    },
    eventOptions ({ passive: passive = true, capture: capture = false } = {}) {
        return {
            passive: passive,
            capture: capture
        };
    },
    transform (value) {
        return value;
    }
};
const $6955631256e6de43$var$_excluded = [
    "target",
    "eventOptions",
    "window",
    "enabled",
    "transform"
];
function $6955631256e6de43$var$resolveWith(config = {}, resolvers) {
    const result = {};
    for (const [key, resolver] of Object.entries(resolvers))switch(typeof resolver){
        case 'function':
            result[key] = resolver.call(result, config[key], key, config);
            break;
        case 'object':
            result[key] = $6955631256e6de43$var$resolveWith(config[key], resolver);
            break;
        case 'boolean':
            if (resolver) result[key] = config[key];
            break;
    }
    return result;
}
function $6955631256e6de43$var$parse(newConfig, gestureKey, _config = {}) {
    const _ref = newConfig, { target: target, eventOptions: eventOptions, window: window1, enabled: enabled, transform: transform } = _ref, rest = $6955631256e6de43$var$_objectWithoutProperties(_ref, $6955631256e6de43$var$_excluded);
    _config.shared = $6955631256e6de43$var$resolveWith({
        target: target,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled,
        transform: transform
    }, $6955631256e6de43$var$sharedConfigResolver);
    if (gestureKey) {
        const resolver = (0, $12aee7b0cfe380c9$export$e7094788287c5e9b).get(gestureKey);
        _config[gestureKey] = $6955631256e6de43$var$resolveWith((0, $12aee7b0cfe380c9$export$71511d61b312f219)({
            shared: _config.shared
        }, rest), resolver);
    } else for(const key in rest){
        const resolver = (0, $12aee7b0cfe380c9$export$e7094788287c5e9b).get(key);
        if (resolver) _config[key] = $6955631256e6de43$var$resolveWith((0, $12aee7b0cfe380c9$export$71511d61b312f219)({
            shared: _config.shared
        }, rest[key]), resolver);
    }
    return _config;
}
class $6955631256e6de43$var$EventStore {
    constructor(ctrl, gestureKey){
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "_listeners", new Set());
        this._ctrl = ctrl;
        this._gestureKey = gestureKey;
    }
    add(element, device, action, handler, options) {
        const listeners = this._listeners;
        const type = (0, $12aee7b0cfe380c9$export$625550452a3fa3ec)(device, action);
        const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
        const eventOptions = (0, $12aee7b0cfe380c9$export$71511d61b312f219)((0, $12aee7b0cfe380c9$export$71511d61b312f219)({}, _options), options);
        element.addEventListener(type, handler, eventOptions);
        const remove = ()=>{
            element.removeEventListener(type, handler, eventOptions);
            listeners.delete(remove);
        };
        listeners.add(remove);
        return remove;
    }
    clean() {
        this._listeners.forEach((remove)=>remove());
        this._listeners.clear();
    }
}
class $6955631256e6de43$var$TimeoutStore {
    constructor(){
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "_timeouts", new Map());
    }
    add(key, callback, ms = 140, ...args) {
        this.remove(key);
        this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
    }
    remove(key) {
        const timeout = this._timeouts.get(key);
        if (timeout) window.clearTimeout(timeout);
    }
    clean() {
        this._timeouts.forEach((timeout)=>void window.clearTimeout(timeout));
        this._timeouts.clear();
    }
}
class $6955631256e6de43$export$bd0bf19f25da8474 {
    constructor(handlers){
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "gestures", new Set());
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "_targetEventStore", new $6955631256e6de43$var$EventStore(this));
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "gestureEventStores", {});
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "gestureTimeoutStores", {});
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "handlers", {});
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "config", {});
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "pointerIds", new Set());
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "touchIds", new Set());
        (0, $12aee7b0cfe380c9$export$407448d2b89b1813)(this, "state", {
            shared: {
                shiftKey: false,
                metaKey: false,
                ctrlKey: false,
                altKey: false
            }
        });
        $6955631256e6de43$var$resolveGestures(this, handlers);
    }
    setEventIds(event) {
        if ((0, $12aee7b0cfe380c9$export$23f2a1d2818174ef)(event)) {
            this.touchIds = new Set((0, $12aee7b0cfe380c9$export$8b22cf2602fb60ce)(event));
            return this.touchIds;
        } else if ('pointerId' in event) {
            if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);
            else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
            return this.pointerIds;
        }
    }
    applyHandlers(handlers, nativeHandlers) {
        this.handlers = handlers;
        this.nativeHandlers = nativeHandlers;
    }
    applyConfig(config, gestureKey) {
        this.config = $6955631256e6de43$var$parse(config, gestureKey, this.config);
    }
    clean() {
        this._targetEventStore.clean();
        for (const key of this.gestures){
            this.gestureEventStores[key].clean();
            this.gestureTimeoutStores[key].clean();
        }
    }
    effect() {
        if (this.config.shared.target) this.bind();
        return ()=>this._targetEventStore.clean();
    }
    bind(...args) {
        const sharedConfig = this.config.shared;
        const props = {};
        let target;
        if (sharedConfig.target) {
            target = sharedConfig.target();
            if (!target) return;
        }
        if (sharedConfig.enabled) {
            for (const gestureKey of this.gestures){
                const gestureConfig = this.config[gestureKey];
                const bindFunction = $6955631256e6de43$var$bindToProps(props, gestureConfig.eventOptions, !!target);
                if (gestureConfig.enabled) {
                    const Engine = (0, $12aee7b0cfe380c9$export$a9c23c6ac3fc3eca).get(gestureKey);
                    new Engine(this, args, gestureKey).bind(bindFunction);
                }
            }
            const nativeBindFunction = $6955631256e6de43$var$bindToProps(props, sharedConfig.eventOptions, !!target);
            for(const eventKey in this.nativeHandlers)nativeBindFunction(eventKey, '', (event)=>this.nativeHandlers[eventKey]((0, $12aee7b0cfe380c9$export$71511d61b312f219)((0, $12aee7b0cfe380c9$export$71511d61b312f219)({}, this.state.shared), {}, {
                    event: event,
                    args: args
                })), undefined, true);
        }
        for(const handlerProp in props)props[handlerProp] = (0, $12aee7b0cfe380c9$export$db3b6bfb95261072)(...props[handlerProp]);
        if (!target) return props;
        for(const handlerProp in props){
            const { device: device, capture: capture, passive: passive } = (0, $12aee7b0cfe380c9$export$ffb5f4729a158638)(handlerProp);
            this._targetEventStore.add(target, device, '', props[handlerProp], {
                capture: capture,
                passive: passive
            });
        }
    }
}
function $6955631256e6de43$var$setupGesture(ctrl, gestureKey) {
    ctrl.gestures.add(gestureKey);
    ctrl.gestureEventStores[gestureKey] = new $6955631256e6de43$var$EventStore(ctrl, gestureKey);
    ctrl.gestureTimeoutStores[gestureKey] = new $6955631256e6de43$var$TimeoutStore();
}
function $6955631256e6de43$var$resolveGestures(ctrl, internalHandlers) {
    if (internalHandlers.drag) $6955631256e6de43$var$setupGesture(ctrl, 'drag');
    if (internalHandlers.wheel) $6955631256e6de43$var$setupGesture(ctrl, 'wheel');
    if (internalHandlers.scroll) $6955631256e6de43$var$setupGesture(ctrl, 'scroll');
    if (internalHandlers.move) $6955631256e6de43$var$setupGesture(ctrl, 'move');
    if (internalHandlers.pinch) $6955631256e6de43$var$setupGesture(ctrl, 'pinch');
    if (internalHandlers.hover) $6955631256e6de43$var$setupGesture(ctrl, 'hover');
}
const $6955631256e6de43$var$bindToProps = (props, eventOptions, withPassiveOption)=>(device, action, handler, options = {}, isNative = false)=>{
        var _options$capture, _options$passive;
        const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
        const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
        let handlerProp = isNative ? device : (0, $12aee7b0cfe380c9$export$4368d992c4eafac0)(device, action, capture);
        if (withPassiveOption && passive) handlerProp += 'Passive';
        props[handlerProp] = props[handlerProp] || [];
        props[handlerProp].push(handler);
    };
const $6955631256e6de43$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $6955631256e6de43$var$sortHandlers(_handlers) {
    const native = {};
    const handlers = {};
    const actions = new Set();
    for(let key in _handlers)if ($6955631256e6de43$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handlers[key] = _handlers[key];
    } else native[key] = _handlers[key];
    return [
        handlers,
        native,
        actions
    ];
}
function $6955631256e6de43$var$registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
    if (!actions.has(handlerKey)) return;
    if (!(0, $12aee7b0cfe380c9$export$a9c23c6ac3fc3eca).has(key)) return;
    const startKey = handlerKey + 'Start';
    const endKey = handlerKey + 'End';
    const fn = (state)=>{
        let memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    internalHandlers[key] = fn;
    config[key] = config[key] || {};
}
function $6955631256e6de43$export$c14d3c7045c4485d(mergedHandlers, mergedConfig) {
    const [handlers, nativeHandlers, actions] = $6955631256e6de43$var$sortHandlers(mergedHandlers);
    const internalHandlers = {};
    $6955631256e6de43$var$registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
    $6955631256e6de43$var$registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
    $6955631256e6de43$var$registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
    $6955631256e6de43$var$registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
    $6955631256e6de43$var$registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
    $6955631256e6de43$var$registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
    return {
        handlers: internalHandlers,
        config: mergedConfig,
        nativeHandlers: nativeHandlers
    };
}







function $63a572c3ce7ebf73$var$useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
    const ctrl = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>new (0, $6955631256e6de43$export$bd0bf19f25da8474)(handlers), []);
    ctrl.applyHandlers(handlers, nativeHandlers);
    ctrl.applyConfig(config, gestureKey);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(ctrl.effect.bind(ctrl));
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        return ctrl.clean.bind(ctrl);
    }, []);
    if (config.target === undefined) return ctrl.bind.bind(ctrl);
    return undefined;
}
function $63a572c3ce7ebf73$export$7941f8aafa4b6021(handler, config) {
    (0, $12aee7b0cfe380c9$export$43caf9889c228507)((0, $12aee7b0cfe380c9$export$f1e1789686576879));
    return $63a572c3ce7ebf73$var$useRecognizers({
        drag: handler
    }, config || {}, 'drag');
}
function $63a572c3ce7ebf73$export$ccc26886ea7dba8f(handler, config) {
    (0, $12aee7b0cfe380c9$export$43caf9889c228507)((0, $12aee7b0cfe380c9$export$2d1720544b23b823));
    return $63a572c3ce7ebf73$var$useRecognizers({
        pinch: handler
    }, config || {}, 'pinch');
}
function $63a572c3ce7ebf73$export$43260e1b277d5f62(handler, config) {
    (0, $12aee7b0cfe380c9$export$43caf9889c228507)((0, $12aee7b0cfe380c9$export$efccba1c4a2ef57b));
    return $63a572c3ce7ebf73$var$useRecognizers({
        wheel: handler
    }, config || {}, 'wheel');
}
function $63a572c3ce7ebf73$export$d928051c8cd740b(handler, config) {
    (0, $12aee7b0cfe380c9$export$43caf9889c228507)((0, $12aee7b0cfe380c9$export$2408f22a0fab9ae5));
    return $63a572c3ce7ebf73$var$useRecognizers({
        scroll: handler
    }, config || {}, 'scroll');
}
function $63a572c3ce7ebf73$export$36da96379f79f245(handler, config) {
    (0, $12aee7b0cfe380c9$export$43caf9889c228507)((0, $12aee7b0cfe380c9$export$953cecd6e717a553));
    return $63a572c3ce7ebf73$var$useRecognizers({
        move: handler
    }, config || {}, 'move');
}
function $63a572c3ce7ebf73$export$ae780daf29e6d456(handler, config) {
    (0, $12aee7b0cfe380c9$export$43caf9889c228507)((0, $12aee7b0cfe380c9$export$dda1d9f60106f0e9));
    return $63a572c3ce7ebf73$var$useRecognizers({
        hover: handler
    }, config || {}, 'hover');
}
function $63a572c3ce7ebf73$export$ee99e1f7df2b9180(actions) {
    actions.forEach((0, $12aee7b0cfe380c9$export$43caf9889c228507));
    return function useGesture(_handlers, _config) {
        const { handlers: handlers, nativeHandlers: nativeHandlers, config: config } = (0, $6955631256e6de43$export$c14d3c7045c4485d)(_handlers, _config || {});
        return $63a572c3ce7ebf73$var$useRecognizers(handlers, config, undefined, nativeHandlers);
    };
}
function $63a572c3ce7ebf73$export$ece84446a783717(handlers, config) {
    const hook = $63a572c3ce7ebf73$export$ee99e1f7df2b9180([
        (0, $12aee7b0cfe380c9$export$f1e1789686576879),
        (0, $12aee7b0cfe380c9$export$2d1720544b23b823),
        (0, $12aee7b0cfe380c9$export$2408f22a0fab9ae5),
        (0, $12aee7b0cfe380c9$export$efccba1c4a2ef57b),
        (0, $12aee7b0cfe380c9$export$953cecd6e717a553),
        (0, $12aee7b0cfe380c9$export$dda1d9f60106f0e9)
    ]);
    return hook(handlers, config || {});
}



var $f5id0 = parcelRequire("f5id0");

var $asc1N = parcelRequire("asc1N");

var $bh6RR = parcelRequire("bh6RR");

var $k8rBo = parcelRequire("k8rBo");

var $10ZIc = parcelRequire("10ZIc");
var $12uqT = parcelRequire("12uqT");

var $f5id0 = parcelRequire("f5id0");

var $sjwE0 = parcelRequire("sjwE0");
/**
 * Mastery level 10 or more = 100%.
 *
 * It takes 75,600 points to reach level 10 (counts for half the percentage calculation).
 *
 * It takes 7 Marks of Mastery to reach level 10 (counts for the other half of the calculation).
 */ function $e499b70a5fc06c1e$var$championPercents({ championLevel: championLevel, championPoints: championPoints, championPointsUntilNextLevel: championPointsUntilNextLevel, tokensEarned: tokensEarned }) {
    if (10 <= championLevel) return 100;
    const pointsPercents = Math.min(// `championPointsUntilNextLevel` can be negative
    Math.min(championPoints + championPointsUntilNextLevel, championPoints) / 75600, 1) * 50;
    const tokensPercents = Math.min((Math.max(championLevel - 4, 0) + tokensEarned) / 7, 1) * 50;
    return pointsPercents + tokensPercents;
}
const $e499b70a5fc06c1e$var$byPointsOrd = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((c)=>c.championPoints), (0, $12uqT).reverse);
function $e499b70a5fc06c1e$var$otpRatio(masteries, totalMasteryPoints) {
    return $e499b70a5fc06c1e$var$otpRatioRec(totalMasteryPoints / 2, (0, $f5id0.pipe)(masteries, (0, $sjwE0.List).sort($e499b70a5fc06c1e$var$byPointsOrd)), 0, 0);
}
function $e499b70a5fc06c1e$var$otpRatioRec(threshold, masteries, pointsAcc, countAcc) {
    if (!(0, $sjwE0.List).isNonEmpty(masteries)) return countAcc;
    const [head, tail] = (0, $sjwE0.NonEmptyArray).unprepend(masteries);
    const newPointsAcc = pointsAcc + head.championPoints;
    const newCountAcc = countAcc + 1;
    if (threshold <= newPointsAcc) return newCountAcc;
    return $e499b70a5fc06c1e$var$otpRatioRec(threshold, tail, newPointsAcc, newCountAcc);
}
const $e499b70a5fc06c1e$var$poroLang = {
    en_GB: 'en',
    fr_FR: 'fr'
};
const $e499b70a5fc06c1e$export$6d7a29d4960e3d83 = {
    championPercents: $e499b70a5fc06c1e$var$championPercents,
    otpRatio: $e499b70a5fc06c1e$var$otpRatio,
    poroLang: $e499b70a5fc06c1e$var$poroLang
};



var $kXnAC = parcelRequire("kXnAC");

var $1GV7y = parcelRequire("1GV7y");


var $10ZIc = parcelRequire("10ZIc");

var $sjwE0 = parcelRequire("sjwE0");
const $41656179bb7d4dbd$var$summonersRiftMaps = [
    1,
    2,
    11
];
// 3, // The Proving Grounds — Tutorial Map
// 4, // Twisted Treeline — Original Version
// 8, // The Crystal Scar — Dominion map
// 10, // Twisted Treeline — Last TT map
// 12, // Howling Abyss — ARAM map
// 14, // Butcher's Bridge — Alternate ARAM map
// 16, // Cosmic Ruins — Dark Star: Singularity map
// 18, // Valoran City Park — Star Guardian Invasion map
// 19, // Substructure 43 — PROJECT: Hunters map
// 20, // Crash Site — Odyssey: Extraction map
// 21, // Nexus Blitz — Nexus Blitz map
// 22, // Convergence — Teamfight Tactics map
// 30, // Rings of Wrath — Arena map
// 35, // The Bandlewood — Brawl map
function $41656179bb7d4dbd$var$isSummonersRift(map) {
    return (0, $sjwE0.List).elem((0, $10ZIc).Eq)(map, $41656179bb7d4dbd$var$summonersRiftMaps);
}
const $41656179bb7d4dbd$export$44c1e36a0d7bb01f = {
    isSummonersRift: $41656179bb7d4dbd$var$isSummonersRift
};



var $ebDzf = parcelRequire("ebDzf");



var $j839F = parcelRequire("j839F");
const $4709c62f841478e7$export$4718096832dec34e = (0, $j839F.createEnum)(100, 200);







var $fp7Nf = parcelRequire("fp7Nf");

var $iPRex = parcelRequire("iPRex");

var $6nJ5H = parcelRequire("6nJ5H");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $9g4gL = parcelRequire("9g4gL");

var $kmQDF = parcelRequire("kmQDF");

var $tA0jd = parcelRequire("tA0jd");

var $es0HS = parcelRequire("es0HS");

var $c6xfg = parcelRequire("c6xfg");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");
/* eslint-disable functional/no-expression-statements */ 
var $bh6RR = parcelRequire("bh6RR");

var $fp7Nf = parcelRequire("fp7Nf");

var $9xM77 = parcelRequire("9xM77");

var $j30iL = parcelRequire("j30iL");

var $gE3ky = parcelRequire("gE3ky");

var $ixfeS = parcelRequire("ixfeS");
function $9e1e0464b0af5656$export$f96ad7bfa050ed2(summoner, correctUrlCase) {
    const { navigate: navigate } = (0, $9xM77.useHistory)();
    const { addRecentSearch: addRecentSearch } = (0, $j30iL.useUser)();
    (0, $bh6RR.useEffect)(()=>addRecentSearch(summoner), [
        addRecentSearch,
        summoner
    ]);
    const riotIdFromLocation = (0, $ixfeS.usePathMatch)((0, $gE3ky.appParsers).anyPlatformRiotId)?.riotId;
    // Correct Riot ID's case in url
    (0, $bh6RR.useEffect)(()=>{
        if (riotIdFromLocation !== undefined && !(0, $fp7Nf.RiotId).Eq.equals(riotIdFromLocation, summoner.riotId)) navigate(correctUrlCase, {
            replace: true
        });
    }, [
        navigate,
        riotIdFromLocation,
        summoner.riotId,
        correctUrlCase
    ]);
}


/* eslint-disable functional/no-expression-statements */ 
var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");
const $258c1e51a9d18326$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $bh6RR.useRef)((0, $sjwE0.Maybe).none);
    (0, $bh6RR.useEffect)(()=>{
        // eslint-disable-next-line functional/immutable-data
        ref.current = (0, $sjwE0.Maybe).some(value);
    }, [
        value
    ]);
    return ref.current;
};



var $7Dhdf = parcelRequire("7Dhdf");

var $jFynM = parcelRequire("jFynM");

var $gwlG1 = parcelRequire("gwlG1");

var $gE3ky = parcelRequire("gE3ky");

var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");


var $8i6VY = parcelRequire("8i6VY");

var $vkIKL = parcelRequire("vkIKL");

var $iPRex = parcelRequire("iPRex");

var $sjwE0 = parcelRequire("sjwE0");



var $es0HS = parcelRequire("es0HS");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $jFynM = parcelRequire("jFynM");

var $jK7ok = parcelRequire("jK7ok");
const $c5ae0484ab2caf1e$export$e355dba6ae7236d1 = ({ isDraft: isDraft, bannedChampions: bannedChampions, participants: participants })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { championByKey: championByKey } = (0, $6H0K7.useStaticData)();
    const factions = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(participants, (0, $sjwE0.PartialDict).map((0, $f5id0.flow)((0, $sjwE0.NonEmptyArray).map((p)=>(0, $f5id0.pipe)(championByKey(p.championId), (0, $sjwE0.Maybe).fold(()=>[], (c)=>c.factions))), (0, $iPRex.ListUtils).commonElems((0, $vkIKL.ChampionFaction).Eq)))), [
        championByKey,
        participants
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex flex-wrap gap-16 px-3 text-sm text-goldenrod",
        children: (0, $4709c62f841478e7$export$4718096832dec34e).values.map((teamId, i)=>{
            const teamBans = bannedChampions[teamId];
            const reverse = i % 2 === 1;
            return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('flex grow basis-0 items-center gap-8', [
                    'flex-row-reverse',
                    reverse
                ]),
                children: [
                    isDraft ? /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                        className: "flex flex-wrap gap-1",
                        children: teamBans !== undefined ? (0, $f5id0.pipe)(teamBans, (0, $sjwE0.NonEmptyArray).map((bannedChampion)=>/*#__PURE__*/ (0, $ih19M.jsx)($c5ae0484ab2caf1e$var$Ban, {
                                bannedChampion: bannedChampion
                            }, bannedChampion.pickTurn))) : null
                    }) : null,
                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                        className: (0, $jK7ok.cx)('flex gap-4', [
                            'justify-end',
                            !reverse
                        ]),
                        children: (factions[teamId] ?? []).map((faction)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                className: (0, $jK7ok.cx)('flex items-center gap-1.5', [
                                    'flex-row-reverse',
                                    reverse
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $af8b81a03dc88b84$export$a50dcf13e7b62e9d), {
                                        id: (0, $8i6VY.ChallengesView).id[faction],
                                        tier: (0, $sjwE0.Maybe).some('GOLD'),
                                        className: "h-9"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "font-semibold",
                                        children: t.labels.faction[faction]
                                    })
                                ]
                            }, faction))
                    }, teamId)
                ]
            }, teamId);
        })
    });
};
const $c5ae0484ab2caf1e$var$Ban = ({ bannedChampion: bannedChampion })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const { championByKey: championByKey } = (0, $6H0K7.useStaticData)();
    const ref = (0, $bh6RR.useRef)(null);
    const [children, tooltip] = (0, $f5id0.pipe)(bannedChampion.championId, (0, $sjwE0.Maybe).fold(()=>(0, $sjwE0.Tuple).of(/*#__PURE__*/ (0, $ih19M.jsx)("li", {
            ref: ref,
            className: "relative flex size-10 items-center justify-center overflow-hidden bg-black",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, $jFynM.Assets).champion,
                alt: t.common.emptyChampionIconAlt,
                className: "size-6 opacity-50"
            })
        }), t.activeGame.empty), (championId)=>{
        const bannedChampionName = (0, $f5id0.pipe)(championByKey(championId), (0, $sjwE0.Maybe).fold(()=>t.common.championKey(championId), (c)=>c.name));
        return (0, $sjwE0.Tuple).of(/*#__PURE__*/ (0, $ih19M.jsx)((0, $1576edad88dbd003$export$6028b0e8199948bf), {
            ref: ref,
            championKey: championId,
            championName: bannedChampionName,
            as: "li",
            className: "relative size-10",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "absolute top-[calc(100%_-_0.125rem)] w-20 origin-left -rotate-45 border-t-4 border-red-ban shadow-even shadow-black"
            })
        }), bannedChampionName);
    }));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                className: "flex flex-col items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "font-medium",
                        children: tooltip
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-xs",
                        children: t.activeGame.bannedAtTurn(bannedChampion.pickTurn)
                    })
                ]
            })
        ]
    });
};



var $ih19M = parcelRequire("ih19M");

var $jRQku = parcelRequire("jRQku");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");





var $6nJ5H = parcelRequire("6nJ5H");

var $sjwE0 = parcelRequire("sjwE0");
/* eslint-disable functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $6nJ5H = parcelRequire("6nJ5H");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $gwlG1 = parcelRequire("gwlG1");


var $jK7ok = parcelRequire("jK7ok");



var $fVW4p = parcelRequire("fVW4p");

var $es0HS = parcelRequire("es0HS");
const { round: $3e823b497f8a8756$var$round } = (0, $6nJ5H.NumberUtils);
const $3e823b497f8a8756$export$f46140fe718f016b = ({ championId: championId, masteries: masteries, name: name, shardsCount: shardsCount, positions: positions, factions: factions, setChampionShards: setChampionShards, isHistogram: isHistogram = false, tooltipHoverRef: overrideHoverRef, tooltipPlacementRef: tooltipPlacementRef, tooltipPlacement: tooltipPlacement = 'bottom', tooltipShouldHide: tooltipShouldHide, centerLevel: centerLevel = true, centerShards: centerShards = false, noShadow: noShadow = false })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const setShardsCount = (0, $bh6RR.useMemo)(()=>setChampionShards !== null ? setChampionShards.run(championId) : null, [
        championId,
        setChampionShards
    ]);
    const filteredShardsCount = (0, $f5id0.pipe)(shardsCount, (0, $sjwE0.Maybe).filter((n)=>0 < n));
    const hoverRef_ = (0, $bh6RR.useRef)(null);
    const hoverRef = overrideHoverRef ?? hoverRef_;
    const tokens = (0, $f5id0.pipe)((0, $sjwE0.Maybe).fromNullable(masteries), (0, $sjwE0.Maybe).chain((m)=>(0, $f5id0.pipe)($3e823b497f8a8756$var$repeatElements(Math.min(m.tokensEarned, m.markRequiredForNextLevel), (i)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.SparkSolid), {
                className: (0, $jK7ok.cx)('-mt-px h-2.5', (0, $c3c80580245b1da4$export$5d6f9a79aaea5f31)(m.championLevel), {
                    'rotate-45': m.tokensEarned > m.markRequiredForNextLevel
                })
            }, i)), (0, $sjwE0.List).concat($3e823b497f8a8756$var$repeatElements(Math.max(m.markRequiredForNextLevel - m.tokensEarned, 0), (i)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "m-0.5 mt-px size-1.5 rounded-1/2 border border-grey-500"
            }, m.tokensEarned + i))), (0, $sjwE0.NonEmptyArray).fromReadonlyArray)));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                ref: hoverRef_,
                className: "grid size-16",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: (0, $jK7ok.cx)('size-full overflow-hidden rounded-bl-xl bg-black area-1', isHistogram ? 'rounded-br-xl' : 'rounded-tr-xl', [
                            'shadow-even shadow-black',
                            !noShadow
                        ]),
                        children: masteries !== undefined && 0 < masteries.championLevel ? /*#__PURE__*/ (0, $ih19M.jsx)($3e823b497f8a8756$var$LevelSVG, {
                            championLevel: masteries.championLevel,
                            ...isHistogram ? {
                                // always full for histogram
                                championPointsUntilNextLevel: 0,
                                championPointsSinceLastLevel: 1,
                                stroke: 'currentColor'
                            } : {
                                championPointsUntilNextLevel: masteries.championPointsUntilNextLevel,
                                championPointsSinceLastLevel: masteries.championPointsSinceLastLevel,
                                stroke: `url(#${(0, $c3c80580245b1da4$export$b06b879d73ad6baf)(masteries.championLevel)})`
                            }
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1576edad88dbd003$export$6028b0e8199948bf), {
                        championKey: championId,
                        championName: name,
                        className: (0, $jK7ok.cx)('size-13.5 self-center justify-self-center rounded-bl-lg bg-black text-2xs text-transparent area-1', isHistogram ? 'rounded-br-lg' : 'rounded-tr-lg')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex items-start place-self-start area-1",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: (0, $jK7ok.cx)('flex overflow-hidden bg-black pb-0.75 pr-1.25 text-sm font-bold leading-2.5', (0, $sjwE0.Maybe).isNone(tokens) ? 'rounded-br-lg' : 'rounded-br', [
                                    'pl-0.5 pt-0.5',
                                    centerLevel
                                ], (0, $c3c80580245b1da4$export$5d6f9a79aaea5f31)(masteries?.championLevel ?? 0)),
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: masteries !== undefined ? t.number(masteries.championLevel) : '?'
                                })
                            }),
                            (0, $f5id0.pipe)(tokens, (0, $sjwE0.Maybe).fold(()=>null, (elements)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "-ml-0.5 flex gap-0.5 rounded-br bg-black pb-0.5 pr-0.5",
                                    children: elements
                                })))
                        ]
                    }),
                    (0, $f5id0.pipe)(filteredShardsCount, (0, $sjwE0.Maybe).fold(()=>null, (shards)=>/*#__PURE__*/ (0, $ih19M.jsx)($3e823b497f8a8756$var$Shards, {
                            shardsCount: shards,
                            isLoading: setChampionShards?.isLoading === true,
                            setShardsCount: setShardsCount,
                            centerShards: centerShards
                        })))
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: hoverRef,
                placementRef: tooltipPlacementRef,
                placement: tooltipPlacement,
                shouldHide: tooltipShouldHide,
                className: "!p-0",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $71c737632df86b04$export$c5545b89bafb388), {
                    masteries: masteries,
                    name: name,
                    shardsCount: filteredShardsCount,
                    positions: positions,
                    factions: factions
                })
            })
        ]
    });
};
const $3e823b497f8a8756$var$totalLength = 100.5;
const $3e823b497f8a8756$var$LevelSVG = ({ championLevel: championLevel, championPointsSinceLastLevel: championPointsSinceLastLevel, championPointsUntilNextLevel: championPointsUntilNextLevel, stroke: stroke })=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        className: (0, $jK7ok.cx)('size-full', (0, $c3c80580245b1da4$export$910cc3307d8b09db)(championLevel)),
        children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "16",
            cy: "16",
            r: "16",
            stroke: stroke,
            strokeWidth: "16",
            strokeDasharray: $3e823b497f8a8756$var$totalLength,
            strokeDashoffset: $3e823b497f8a8756$var$totalLength - 0.96 * $3e823b497f8a8756$var$levelPercents({
                championPointsSinceLastLevel: championPointsSinceLastLevel,
                championPointsUntilNextLevel: championPointsUntilNextLevel
            }),
            className: "origin-center rotate-[-128.5deg]"
        })
    });
function $3e823b497f8a8756$var$levelPercents({ championPointsSinceLastLevel: championPointsSinceLastLevel, championPointsUntilNextLevel: championPointsUntilNextLevel }) {
    // championPointsSinceLastLevel can be negative because of new system
    // see server/services/MasteriesService#fixPointsSinceLastLevel
    if (championPointsSinceLastLevel < 0) return 0;
    const levelRange = championPointsSinceLastLevel + championPointsUntilNextLevel;
    if (levelRange === 0) return 0;
    return Math.min($3e823b497f8a8756$var$round(100 * championPointsSinceLastLevel / levelRange), 100);
}
function $3e823b497f8a8756$var$repeatElements(n, getA) {
    return (0, $f5id0.pipe)(Array.from({
        length: Math.max(n, 0)
    }), (0, $sjwE0.List).mapWithIndex(getA));
}
const $3e823b497f8a8756$var$Shards = ({ shardsCount: shardsCount, isLoading: isLoading, setShardsCount: setShardsCount, centerShards: centerShards = false })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('masteries');
    const addButtonRef = (0, $bh6RR.useRef)(null);
    const removeButtonRef = (0, $bh6RR.useRef)(null);
    const addShardCount = (0, $bh6RR.useCallback)(()=>setShardsCount?.(shardsCount + 1), [
        setShardsCount,
        shardsCount
    ]);
    const removeShardCount = (0, $bh6RR.useCallback)(()=>setShardsCount?.(shardsCount - 1), [
        setShardsCount,
        shardsCount
    ]);
    const canRemoveShard = 1 <= shardsCount;
    const canAddShard = shardsCount < 9;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "group relative flex h-2.5 flex-row-reverse items-end place-self-end area-1",
        children: [
            setShardsCount !== null ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('absolute -right-px z-10 hidden flex-col justify-center overflow-hidden bg-black p-px group-hover:flex', [
                    'gap-4',
                    canAddShard === canRemoveShard
                ], canAddShard ? '-top-4 rounded-t-5' : '-bottom-4 rounded-tl-5', [
                    'rounded-b-5',
                    canRemoveShard
                ]),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, $jK7ok.cx)('flex', [
                            'mb-3',
                            !canRemoveShard
                        ], [
                            'hidden',
                            !canAddShard
                        ]),
                        children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                            className: "w-3 text-goldenrod-bis"
                        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                    ref: addButtonRef,
                                    type: "button",
                                    onClick: addShardCount,
                                    className: "w-3 rounded-t bg-goldenrod text-black",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.AddOutline), {
                                        className: "w-full"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                    hoverRef: addButtonRef,
                                    placement: "right",
                                    className: "z-10 !text-xs",
                                    children: t.addShard
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, $jK7ok.cx)('flex', [
                            'mt-3.75',
                            !canAddShard
                        ], [
                            'hidden',
                            !canRemoveShard
                        ]),
                        children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                            className: "w-3 text-goldenrod-bis"
                        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                    ref: removeButtonRef,
                                    type: "button",
                                    onClick: removeShardCount,
                                    className: "w-3 rounded-b bg-goldenrod text-black",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.RemoveOutline), {
                                        className: "w-full"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                    hoverRef: removeButtonRef,
                                    placement: "right",
                                    className: "z-10 !text-xs",
                                    children: t.removeShard
                                })
                            ]
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: (0, $jK7ok.cx)('relative z-10 flex items-center justify-center overflow-hidden rounded-tl-lg bg-black pt-1 font-semibold', centerShards ? 'w-4 pl-1' : (0, $jK7ok.cx)('pl-1.5 group-hover:w-4 group-hover:pl-1', [
                    'group-hover:pt-0.5',
                    canAddShard
                ])),
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: "text-15",
                    children: shardsCount
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "relative z-10 -mr-0.75 rounded-tl bg-black pl-px pt-px",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.SparklesSharp), {
                    className: "size-2.5 rotate-180"
                })
            })
        ]
    });
};




var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $5iN75 = parcelRequire("5iN75");

var $sjwE0 = parcelRequire("sjwE0");

var $4MEuc = parcelRequire("4MEuc");

var $gwlG1 = parcelRequire("gwlG1");

var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5iN75 = parcelRequire("5iN75");

var $4MEuc = parcelRequire("4MEuc");

var $jK7ok = parcelRequire("jK7ok");
const $9dcad8d548d62354$export$de0c91b9dbecc60d = (tier)=>`https://raw.communitydragon.org/latest/plugins/rcp-fe-lol-static-assets/global/default/images/ranked-mini-crests/${tier.toLowerCase()}.svg`;
const $9dcad8d548d62354$export$d840247cdba25bd3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ tier: tier, rank: rank, className: className, style: style, ...props }, ref)=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        ref: ref,
        className: (0, $jK7ok.cx)('flex items-center overflow-hidden', className),
        style: style,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: $9dcad8d548d62354$export$de0c91b9dbecc60d(tier),
            alt: tier === 'unranked' ? t.league.unrankedIconAlt : t.league.tierRankAlt(tier, (0, $5iN75.LeagueTier).isRegularTier(tier) ? rank : undefined),
            className: (0, $jK7ok.cx)('mr-[-100%] max-w-none', $9dcad8d548d62354$var$imgClassName[tier]),
            ...props
        })
    });
});
const $9dcad8d548d62354$var$imgClassName = {
    unranked: 'w-[37%] ml-[31.5%]',
    IRON: 'w-[86%] mt-[9%] ml-[4.5%]',
    BRONZE: 'w-[90%] mt-[9%] ml-[5%]',
    SILVER: 'w-[90%] mt-[9%] ml-[5%]',
    GOLD: 'w-[92%] mt-[14.5%] ml-[6.5%]',
    PLATINUM: 'w-[106%] mt-[19%] ml-[-3%]',
    EMERALD: 'w-[106%] mt-[19%] ml-[-3%]',
    DIAMOND: 'w-[106%] mt-[19%] ml-[-3%]',
    MASTER: 'w-[106%] ml-[-6%]',
    GRANDMASTER: 'w-[106%] ml-[-6%]',
    CHALLENGER: 'w-[106%] ml-[-6%]'
};



var $es0HS = parcelRequire("es0HS");
const $6b812bf4602a0de7$export$9fc0e0d0ecb98c84 = ({ variant: variant = 'base', queue: queue, league: league, reverse: reverse = false, tooltipShouldHide: tooltipShouldHide, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const currentSplitRef = (0, $bh6RR.useRef)(null);
    const currentSplitIconRef = (0, $bh6RR.useRef)(null);
    const previousSplitRef = (0, $bh6RR.useRef)(null);
    const { tier: tier, rank: rank, description: description, subDescription: subDescription, currentSplitTooltip: currentSplitTooltip } = (0, $f5id0.pipe)(league.currentSplit, (0, $sjwE0.Maybe).fold(()=>({
            tier: 'unranked',
            rank: 'I',
            description: t.league.unranked,
            subDescription: undefined
        }), ({ leaguePoints: leaguePoints, wins: wins, losses: losses, miniSeriesProgress: miniSeriesProgress, ...s })=>{
        const tierRank = t.league.tierRank(s.tier, (0, $5iN75.LeagueTier).isRegularTier(s.tier) ? s.rank : undefined);
        const games = wins + losses;
        return {
            tier: s.tier,
            rank: s.rank,
            description: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: tierRank
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: t.league.leaguePoints(leaguePoints)
                    })
                ]
            }),
            subDescription: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "font-semibold",
                        children: t.percents(games === 0 ? 0 : Math.round(100 * wins / games))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-grey-400",
                        children: t.number(games, {
                            withParenthesis: true
                        })
                    })
                ]
            }),
            currentSplitTooltip: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    (0, $f5id0.pipe)(miniSeriesProgress, (0, $sjwE0.Maybe).fold(()=>null, (progress)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "col-span-2 mb-1 flex items-center gap-1 justify-self-center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "mr-1",
                                    children: t.league.serie
                                }),
                                progress.map((p, i)=>// eslint-disable-next-line react/no-array-index-key
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: $6b812bf4602a0de7$var$renderProgress(p)
                                    }, i))
                            ]
                        }))),
                    /*#__PURE__*/ (0, $ih19M.jsx)($6b812bf4602a0de7$var$WinLoss, {
                        value: wins,
                        label: t.league.wins,
                        valueClassName: "text-green"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($6b812bf4602a0de7$var$WinLoss, {
                        value: losses,
                        label: t.league.losses,
                        valueClassName: "text-red mb-0.5"
                    })
                ]
            })
        };
    }));
    const isSomeCurrentSplit = (0, $sjwE0.Maybe).isSome(league.currentSplit);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                ref: currentSplitRef,
                className: (0, $jK7ok.cx)('-mb-1 grid grid-cols-[auto_auto] items-center', [
                    'gap-3',
                    variant === 'base'
                ], [
                    'gap-2',
                    variant === 'small'
                ], className),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $9dcad8d548d62354$export$d840247cdba25bd3), {
                        ref: currentSplitIconRef,
                        tier: tier,
                        rank: rank,
                        className: (0, $jK7ok.cx)({
                            'size-16': variant === 'base',
                            'size-9': variant === 'small',
                            'col-start-2': reverse
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: (0, $jK7ok.cx)('flex text-sm', [
                            'col-start-1 row-start-1',
                            reverse
                        ], isSomeCurrentSplit ? (0, $jK7ok.cx)('flex-col', reverse ? 'items-end' : 'items-start') : (0, $jK7ok.cx)('items-center gap-2', [
                            'flex-row-reverse',
                            reverse
                        ]), [
                            'leading-4',
                            variant === 'small'
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: (0, $jK7ok.cx)('flex gap-1.5 whitespace-nowrap', {
                                    'font-semibold': isSomeCurrentSplit,
                                    'text-grey-400': variant === 'small'
                                }),
                                children: description
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                className: (0, $jK7ok.cx)('flex gap-3', [
                                    'flex-row-reverse',
                                    reverse
                                ]),
                                children: [
                                    subDescription,
                                    (0, $f5id0.pipe)(league.previousSplit, (0, $sjwE0.Maybe).fold(()=>null, (s)=>/*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                            ref: previousSplitRef,
                                            className: "flex items-center text-grey-400",
                                            children: [
                                                "(",
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $9dcad8d548d62354$export$d840247cdba25bd3), {
                                                    tier: s.tier,
                                                    rank: s.rank,
                                                    className: "mx-0.5 size-5"
                                                }),
                                                ")"
                                            ]
                                        })))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                hoverRef: currentSplitRef,
                placementRef: currentSplitIconRef,
                shouldHide: tooltipShouldHide,
                className: "grid grid-cols-[auto_auto] gap-x-1.5",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "col-span-2 justify-self-center font-semibold",
                        children: t.league.label[queue]
                    }),
                    currentSplitTooltip,
                    (0, $f5id0.pipe)(league.previousSplit, (0, $sjwE0.Maybe).fold(()=>null, (s)=>/*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                            className: "col-span-2 flex items-center gap-1.5 whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: t.league.previousSplit
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "font-semibold",
                                    children: t.league.tierRank(s.tier, (0, $5iN75.LeagueTier).isRegularTier(s.tier) ? s.rank : undefined)
                                })
                            ]
                        })))
                ]
            })
        ]
    });
};
const $6b812bf4602a0de7$var$WinLoss = ({ value: value, label: label, valueClassName: valueClassName })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: (0, $jK7ok.cx)('justify-self-end font-semibold', valueClassName),
                children: value
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: label(value)
            })
        ]
    });
const $6b812bf4602a0de7$var$renderProgress = (progress)=>{
    switch(progress){
        case 'W':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CheckMarkSharp), {
                className: "h-4 text-green"
            });
        case 'L':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CloseFilled), {
                className: "h-4 text-red"
            });
        case 'N':
            return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: "\u2014"
            });
    }
};





var $es0HS = parcelRequire("es0HS");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $bh6RR = parcelRequire("bh6RR");
const $29e3f37936105115$export$5ae0e7fb2375230f = (f)=>{
    const ref = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        const onResize = ()=>{
            if (ref.current !== null) f(ref.current);
        };
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, [
        f
    ]);
    return (0, $bh6RR.useCallback)((e)=>{
        // eslint-disable-next-line functional/immutable-data
        ref.current = e;
        if (e !== null) f(e);
    }, [
        f
    ]);
};



var $jK7ok = parcelRequire("jK7ok");

var $ih19M = parcelRequire("ih19M");

var $4x239 = parcelRequire("4x239");
var $10ZIc = parcelRequire("10ZIc");
var $bFSl4 = parcelRequire("bFSl4");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");



var $jK7ok = parcelRequire("jK7ok");
const $4f8f7710ab3c6502$export$aa446a51db8c710 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ data: data, reverse: reverse }, ref)=>{
    const { initial: initial, more: more } = (0, $bh6RR.useMemo)(()=>$4f8f7710ab3c6502$var$partitionStats2Cols(data, reverse), [
        data,
        reverse
    ]);
    const uls = (0, $f5id0.pipe)([
        initial,
        more
    ], (0, $sjwE0.List).filterMapWithIndex((i, lis)=>(0, $sjwE0.List).isNonEmpty(lis) ? (0, $sjwE0.Maybe).some(/*#__PURE__*/ (0, $ih19M.jsx)("ul", {
            children: lis
        }, i)) : (0, $sjwE0.Maybe).none), reverse ? (0, $sjwE0.List).reverse : (0, $f5id0.identity));
    if ((0, $sjwE0.List).isEmpty(uls)) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        ref: ref,
        className: (0, $jK7ok.cx)('grid items-center py-1 text-2xs', [
            'gap-1',
            uls.length > 1
        ]),
        style: {
            gridTemplateColumns: `repeat(${uls.length}, auto)`
        },
        children: uls
    });
});
const $4f8f7710ab3c6502$var$limitSize = 22.5 /* (padding) */ ;
function $4f8f7710ab3c6502$var$partitionStats2Cols(data, reverse) {
    const changes = (0, $d311e1d1f335f84f$export$90c20a432e29f511)(data);
    const sizes_ = changes.map((change)=>(0, $d83a2e94fbf72603$export$9e4948ce114eaafb)[change.type]);
    const totalSize = (0, $f5id0.pipe)(sizes_, (0, $4x239).concatAll((0, $10ZIc).MonoidSum));
    if (totalSize <= $4f8f7710ab3c6502$var$limitSize) return {
        initial: $4f8f7710ab3c6502$var$toElements(reverse)(changes),
        more: []
    };
    const { left: initial, right: more } = (0, $f5id0.pipe)((0, $d311e1d1f335f84f$export$35cd56382745d8d0)({
        ...(0, $d83a2e94fbf72603$export$9e4948ce114eaafb),
        limit: totalSize / 2
    })(changes), (0, $bFSl4).bimap($4f8f7710ab3c6502$var$toElements(reverse), $4f8f7710ab3c6502$var$toElements(reverse)));
    return {
        initial: initial,
        more: more
    };
}
const $4f8f7710ab3c6502$var$toElements = (reverse)=>(0, $sjwE0.List).map((change)=>{
        switch(change.type){
            case 'stat':
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d83a2e94fbf72603$export$4c157fb38ec75dc), {
                    name: change.name,
                    value: change.value,
                    reverse: reverse
                }, change.name);
            case 'skill':
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d83a2e94fbf72603$export$8eae7b5b63fcf71d), {
                    skill: change.skill,
                    changes: change.changes,
                    reverse: reverse
                }, change.skill);
        }
    });



var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");


var $sjwE0 = parcelRequire("sjwE0");


var $jK7ok = parcelRequire("jK7ok");
const $aa01d9d00716bdc6$export$12dda5e6511ff2f1 = ({ runeStyleById: runeStyleById, runeById: runeById, perks: perks, reverse: reverse, tooltipShouldHide: tooltipShouldHide })=>{
    const { keyStone: keyStone, primaryPath: primaryPath, secondaryPath: secondaryPath, shards: shards } = (0, $bh6RR.useMemo)(()=>{
        const findRunes = $aa01d9d00716bdc6$var$getFindRunes(runeStyleById, runeById, perks.perkIds);
        const primaryPath_ = findRunes(perks.perkStyle);
        const secondaryPath_ = findRunes(perks.perkSubStyle);
        const pathIds = (0, $f5id0.pipe)(primaryPath_, (0, $sjwE0.List).concat(secondaryPath_), (0, $sjwE0.List).map((rune)=>rune.id));
        return {
            keyStone: (0, $sjwE0.List).head(primaryPath_),
            primaryPath: (0, $f5id0.pipe)((0, $sjwE0.List).tail(primaryPath_), (0, $sjwE0.Maybe).getOrElseW(()=>[])),
            secondaryPath: secondaryPath_,
            shards: (0, $f5id0.pipe)(perks.perkIds, (0, $sjwE0.List).difference((0, $7340158445f0915b$export$96c66196b0b4f739).Eq)(pathIds), (0, $sjwE0.List).filterMap(runeById))
        };
    }, [
        perks,
        runeById,
        runeStyleById
    ]);
    const nonEmpty = (0, $sjwE0.List).isNonEmpty(primaryPath) || (0, $sjwE0.List).isNonEmpty(secondaryPath) || (0, $sjwE0.List).isNonEmpty(shards);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, $jK7ok.cx)('relative flex min-h-17 gap-1.5', reverse ? 'flex-row-reverse items-end' : 'items-start'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('grid gap-2', [
                    reverse ? 'pr-1' : 'pl-1',
                    nonEmpty
                ]),
                style: reverse ? {
                    gridTemplateAreas: '"shards" "secondary" "primary"',
                    gridTemplateRows: '.75rem 1.25rem 1.25rem'
                } : {
                    gridTemplateAreas: '"primary" "secondary" "shards"',
                    gridTemplateRows: '1.25rem 1.25rem .75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa01d9d00716bdc6$var$RunePath, {
                        runes: primaryPath,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "gap-1 area-[primary]"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa01d9d00716bdc6$var$RunePath, {
                        runes: secondaryPath,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "gap-1 area-[secondary]"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa01d9d00716bdc6$var$RunePath, {
                        runes: shards,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "gap-1.5 area-[shards]",
                        liClassName: "!size-3 overflow-hidden",
                        runeClassName: "!w-[calc(100%_+_0.5rem)] -m-1 max-w-none"
                    })
                ]
            }),
            (0, $sjwE0.List).isEmpty(secondaryPath) && (0, $f5id0.pipe)(runeStyleById(perks.perkSubStyle), (0, $sjwE0.Maybe).fold(()=>null, (rune)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: (0, $jK7ok.cx)('absolute size-5', reverse ? 'left-4 top-1' : 'bottom-1 right-4'),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a733205e276a6444$export$dd4e3679fae405b5), {
                        icon: rune.icon,
                        name: rune.name,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "w-full"
                    })
                }))),
            (0, $f5id0.pipe)(keyStone, (0, $sjwE0.Maybe).fold(()=>null, (r)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: (0, $jK7ok.cx)('flex size-9', reverse ? '-mb-1.5' : '-mt-1.5'),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a733205e276a6444$export$dd4e3679fae405b5), {
                        icon: r.iconPath,
                        name: r.name,
                        description: r.longDesc,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "w-full"
                    })
                })))
        ]
    });
};
const $aa01d9d00716bdc6$var$getFindRunes = (runeStyleById, runeById, runeIds)=>(styleId)=>{
        const runesInStyle = (0, $f5id0.pipe)(runeStyleById(styleId), (0, $sjwE0.Maybe).fold(()=>[], (style)=>(0, $f5id0.pipe)(style.slots, (0, $sjwE0.List).chain((slot)=>slot.runes))));
        return (0, $f5id0.pipe)(runeIds, (0, $sjwE0.List).filterMap((0, $f5id0.flow)((0, $sjwE0.Maybe).fromPredicate((runeId)=>(0, $sjwE0.List).elem((0, $7340158445f0915b$export$96c66196b0b4f739).Eq)(runeId, runesInStyle)), (0, $sjwE0.Maybe).chain(runeById))));
    };
const $aa01d9d00716bdc6$var$RunePath = ({ runes: runes, reverse: reverse, tooltipShouldHide: tooltipShouldHide, className: className, liClassName: liClassName, runeClassName: runeClassName })=>/*#__PURE__*/ (0, $ih19M.jsx)("ul", {
        className: (0, $jK7ok.cx)('flex justify-end', [
            'flex-row-reverse',
            !reverse
        ], className),
        children: runes.map((r, i)=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                className: (0, $jK7ok.cx)('w-5', liClassName),
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a733205e276a6444$export$dd4e3679fae405b5), {
                    icon: r.iconPath,
                    name: r.name,
                    description: r.longDesc,
                    tooltipShouldHide: tooltipShouldHide,
                    className: (0, $jK7ok.cx)('w-full', runeClassName)
                })
            }, i))
    });



var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $aapGO = parcelRequire("aapGO");

var $65UVg = parcelRequire("65UVg");

var $4o3f8 = parcelRequire("4o3f8");

var $fp7Nf = parcelRequire("fp7Nf");

var $fC0sb = parcelRequire("fC0sb");

var $6nJ5H = parcelRequire("6nJ5H");

var $sjwE0 = parcelRequire("sjwE0");


var $es0HS = parcelRequire("es0HS");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $gwlG1 = parcelRequire("gwlG1");

var $gE3ky = parcelRequire("gE3ky");

var $chVfZ = parcelRequire("chVfZ");

var $jK7ok = parcelRequire("jK7ok");
const { round: $e2f3728a18bce646$var$round } = (0, $6nJ5H.NumberUtils);
const $e2f3728a18bce646$var$allLevels = new Set((0, $aapGO.ChampionLevel).values);
const $e2f3728a18bce646$export$4cacbff04efabb77 = ({ platform: platform, riotId: riotId, profileIconId: profileIconId, masteries: masteries, premadeId: premadeId, summonerLevel: summonerLevel, role: role, mainRoles: mainRoles, reverse: reverse, tooltipShouldHide: tooltipShouldHide, padding: padding })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const { assets: assets } = (0, $6H0K7.useStaticData)();
    const summonerLevelRef = (0, $bh6RR.useRef)(null);
    const percentsRef = (0, $bh6RR.useRef)(null);
    const totalMasteriesRef = (0, $bh6RR.useRef)(null);
    const mainRolesRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex flex-col justify-center gap-1 pt-2",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('flex items-center gap-3', [
                    'flex-row-reverse',
                    reverse
                ]),
                children: [
                    (0, $f5id0.pipe)(premadeId, (0, $sjwE0.Maybe).fold(()=>null, (id)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: (0, $jK7ok.cx)('flex items-center gap-1 text-xs font-semibold text-white', padding, {
                                'flex-row-reverse': !reverse
                            }),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.PeopleSharp), {
                                    className: "h-3"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "mt-0.5",
                                    children: id
                                })
                            ]
                        }))),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: (0, $jK7ok.cx)('flex grow', reverse ? 'justify-start' : 'justify-end'),
                        children: (0, $f5id0.pipe)(riotId, (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "leading-5 text-grey-500",
                                children: t.activeGame.streamerMode
                            }), (id)=>/*#__PURE__*/ (0, $ih19M.jsxs)("a", {
                                href: (0, $gE3ky.appRoutes).platformRiotId(platform, id, {
                                    view: 'histogram',
                                    level: $e2f3728a18bce646$var$allLevels
                                }),
                                target: "_blank",
                                rel: "noreferrer",
                                className: "flex items-baseline gap-0.5 whitespace-pre",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "text-lg font-semibold leading-6 text-goldenrod",
                                        children: (0, $4o3f8.GameName).unwrap(id.gameName)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "leading-5 text-grey-500",
                                        children: [
                                            "#",
                                            (0, $fC0sb.TagLine).unwrap(id.tagLine)
                                        ]
                                    })
                                ]
                            })))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('flex items-center gap-2', [
                    'flex-row-reverse',
                    !reverse
                ]),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: assets.summonerIcon(profileIconId),
                        alt: t.common.summonerIconAlt((0, $f5id0.pipe)(riotId, (0, $sjwE0.Maybe).fold(()=>t.activeGame.streamerMode, (0, $fp7Nf.RiotId).stringify))),
                        className: "w-12"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: (0, $jK7ok.cx)('flex flex-col text-sm leading-3', reverse ? 'items-start' : 'items-end'),
                        children: [
                            (0, $f5id0.pipe)(summonerLevel, (0, $sjwE0.Maybe).fold(()=>null, (lvl)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            ref: summonerLevelRef,
                                            className: "text-grey-400",
                                            children: t.common.level(lvl, 'font-semibold')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                            hoverRef: summonerLevelRef,
                                            children: t.common.summonerLevel
                                        })
                                    ]
                                }))),
                            (0, $f5id0.pipe)(masteries, (0, $sjwE0.Maybe).fold(()=>null, (m)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "mt-1.25",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "flex gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                ref: percentsRef,
                                                className: "whitespace-nowrap font-semibold",
                                                children: t.common.percents($e2f3728a18bce646$var$round(m.questPercents, 1))
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                                hoverRef: percentsRef,
                                                shouldHide: tooltipShouldHide,
                                                children: t.activeGame.theQuestProgression
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                ref: totalMasteriesRef,
                                                className: "whitespace-nowrap text-grey-400",
                                                children: t.activeGame.totals(m.totalMasteryLevel, (0, $chVfZ.TranslationUtils).numberUnit(t.common)(m.totalMasteryPoints), 'font-semibold')
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                                                hoverRef: totalMasteriesRef,
                                                className: "flex flex-col items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        children: t.activeGame.masteryScoreAndPoints
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        children: t.activeGame.otpIndex(m.otpIndex, 'font-semibold')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }))),
                            (0, $sjwE0.List).isNonEmpty(mainRoles) ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                        ref: mainRolesRef,
                                        className: "mt-0.75 flex items-start gap-1",
                                        children: mainRoles.map((r)=>{
                                            const isCurrent = (0, $f5id0.pipe)(role, (0, $sjwE0.Maybe).elem((0, $65UVg.ChampionPosition).Eq)(r));
                                            return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: "relative flex flex-col items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $2fef2422e6a814aa$export$12e8b9f23d53a496), {
                                                        position: r,
                                                        className: (0, $jK7ok.cx)('w-4', [
                                                            'text-cyan-200',
                                                            isCurrent
                                                        ])
                                                    }),
                                                    isCurrent ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: "absolute -bottom-1 size-0.5 rounded-1/2 bg-cyan-200"
                                                    }) : null
                                                ]
                                            }, r);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                                        hoverRef: mainRolesRef,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                children: [
                                                    t.activeGame.mainRoles,
                                                    ' ',
                                                    mainRoles.map((r, i)=>{
                                                        const isCurrent = (0, $f5id0.pipe)(role, (0, $sjwE0.Maybe).elem((0, $65UVg.ChampionPosition).Eq)(r));
                                                        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                                    className: (0, $jK7ok.cx)('font-semibold', [
                                                                        'text-cyan-200',
                                                                        isCurrent
                                                                    ]),
                                                                    children: t.common.labels.position[r]
                                                                }),
                                                                i !== mainRoles.length - 1 ? ', ' : null
                                                            ]
                                                        }, r);
                                                    })
                                                ]
                                            }),
                                            (0, $f5id0.pipe)(role, (0, $sjwE0.Maybe).fold(()=>null, (r)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                    children: [
                                                        t.activeGame.currentRole,
                                                        ' ',
                                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                            className: "font-semibold text-cyan-200",
                                                            children: t.common.labels.position[r]
                                                        })
                                                    ]
                                                })))
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $es0HS = parcelRequire("es0HS");

var $jK7ok = parcelRequire("jK7ok");
const $bbeef527533dbdd1$export$9ef0be9c867d1434 = ({ niceness: niceness, label: label, tooltip: tooltip })=>{
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                ref: ref,
                className: (0, $jK7ok.cx)('whitespace-nowrap rounded-b px-0.5 text-white shadow-even shadow-black saturate-[0.7]', $bbeef527533dbdd1$var$nicenessClassName[niceness]),
                children: label
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                className: "max-w-xs",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: tooltip
                    },
                    className: "whitespace-normal"
                })
            })
        ]
    });
};
const $bbeef527533dbdd1$var$nicenessClassName = {
    '-1': 'bg-poro-red',
    0: 'bg-poro-orange',
    1: 'bg-poro-green',
    2: 'bg-poro-blue'
};


const { round: $0cc1e54068090c87$var$round } = (0, $6nJ5H.NumberUtils);
const $0cc1e54068090c87$var$gridTotalCols = 9;
const $0cc1e54068090c87$var$bevelWidth = 32 // px
;
const $0cc1e54068090c87$var$inspirationPath = (0, $56a38f105919baed$export$597b42c1d60925a3)(8300);
const $0cc1e54068090c87$export$2d6247fb34949a13 = {
    false: {
        gridTemplateColumns: `1fr repeat(7,auto) ${$0cc1e54068090c87$var$bevelWidth}px`
    },
    true: {
        gridTemplateColumns: `${$0cc1e54068090c87$var$bevelWidth}px repeat(7,auto) 1fr`
    }
};
const $0cc1e54068090c87$export$5cfb5b4baffb5bc9 = ({ summonerSpellByKey: summonerSpellByKey, runeStyleById: runeStyleById, runeById: runeById, itemById: itemById, platform: platform, gameMode: gameMode, participant: { riotId: riotId, profileIconId: profileIconId, leagues: leagues, championId: championId, masteries: masteries, shardsCount: shardsCount, spell1Id: spell1Id, spell2Id: spell2Id, perks: maybePerks, premadeId: premadeId, summonerLevel: summonerLevel, championRankedStats: championRankedStats, role: role, mainRoles: mainRoles, tags: tags }, shouldWrap: shouldWrap, highlight: highlight, reverse: reverse, index: index, isLast: isLast, isDragging: isDragging, springStyle: springStyle, gestureProps: gestureProps })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const { championByKey: championByKey } = (0, $6H0K7.useStaticData)();
    const championRef = (0, $bh6RR.useRef)(null);
    const championWinRateRef = (0, $bh6RR.useRef)(null);
    const mapChangesRef = (0, $bh6RR.useRef)(null);
    const totalHasteRef = (0, $bh6RR.useRef)(null);
    const spells = [
        spell1Id,
        spell2Id
    ].map((id)=>(0, $sjwE0.Tuple).of(id, summonerSpellByKey(id)));
    const [totalHaste, setTotalHaste] = (0, $bh6RR.useState)($0cc1e54068090c87$var$foldGameMode(gameMode, {
        onAram: 70,
        onUrf: 300,
        default: 0
    }));
    const onToggleHaste = (0, $bh6RR.useCallback)((addHaste)=>setTotalHaste((h)=>h + addHaste), []);
    const hasInspirationPath = (0, $f5id0.pipe)(maybePerks, (0, $sjwE0.Maybe).exists((perks)=>(0, $56a38f105919baed$export$597b42c1d60925a3).Eq.equals(perks.perkStyle, $0cc1e54068090c87$var$inspirationPath) || (0, $56a38f105919baed$export$597b42c1d60925a3).Eq.equals(perks.perkSubStyle, $0cc1e54068090c87$var$inspirationPath)));
    /** `runeById`, but only if rune style exists for rune `id` */ const filteredRuneById = (0, $bh6RR.useCallback)((id)=>{
        if ((0, $7340158445f0915b$export$96c66196b0b4f739).Eq.equals(id, (0, $90a33c3d4666f1d8$export$e3b0796a61ebb801).id)) return hasInspirationPath ? runeById(id) : (0, $sjwE0.Maybe).none;
        return runeById(id);
    }, [
        hasInspirationPath,
        runeById
    ]);
    const hasCosmicInsight = (0, $f5id0.pipe)(maybePerks, (0, $sjwE0.Maybe).exists((perks)=>(0, $sjwE0.List).elem((0, $7340158445f0915b$export$96c66196b0b4f739).Eq)((0, $90a33c3d4666f1d8$export$e3b0796a61ebb801).id, perks.perkIds)));
    const champion = championByKey(championId);
    const tooltipShouldHide = isDragging;
    const squareProps = (0, $f5id0.pipe)(champion, (0, $sjwE0.Maybe).map((c)=>({
            championId: championId,
            name: c.name,
            shardsCount: (0, $f5id0.pipe)(shardsCount, (0, $sjwE0.Maybe).filter((n)=>n !== 0)),
            positions: c.positions,
            factions: c.factions,
            setChampionShards: null,
            masteries: (0, $f5id0.pipe)(masteries, (0, $sjwE0.Maybe).chain((m)=>m.champion), (0, $sjwE0.Maybe).fold(()=>(0, $f5id0.pipe)(riotId, (0, $sjwE0.Maybe).map(()=>({
                        tokensEarned: 0,
                        markRequiredForNextLevel: 0,
                        championLevel: 0,
                        championPoints: 0,
                        championPointsSinceLastLevel: 0,
                        championPointsUntilNextLevel: 0,
                        percents: 0
                    }))), (m)=>(0, $sjwE0.Maybe).some({
                    ...m,
                    percents: (0, $e499b70a5fc06c1e$export$6d7a29d4960e3d83).championPercents(m)
                })), (0, $sjwE0.Maybe).toUndefined),
            tooltipShouldHide: tooltipShouldHide,
            centerShards: true,
            noShadow: true
        })));
    const [bevelHeight, setBevelHeight] = (0, $bh6RR.useState)(0);
    const onBevelMount = (0, $29e3f37936105115$export$5ae0e7fb2375230f)((0, $bh6RR.useCallback)((e)=>setBevelHeight(e.offsetHeight), []));
    const bevelRotate = (0, $bh6RR.useMemo)(()=>Math.atan($0cc1e54068090c87$var$bevelWidth / bevelHeight), [
        bevelHeight
    ]);
    const padding = reverse ? 'pr-2.5' : 'pl-2.5';
    return /*#__PURE__*/ (0, $ih19M.jsxs)($0cc1e54068090c87$var$Li, {
        reverse: reverse,
        gridRowStart: 3 * index + 1,
        springStyle: springStyle,
        gestureProps: gestureProps,
        className: isDragging ? 'cursor-grabbing' : 'cursor-grab',
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                gridRowOffset: 1,
                gridColStart: 1,
                className: (0, $jK7ok.cx)('h-4 text-xs', reverse ? 'col-span-9' : 'col-span-8'),
                children: (0, $sjwE0.List).isNonEmpty(tags) ? /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                    className: (0, $jK7ok.cx)('flex items-center justify-end gap-1 px-2', {
                        'flex-row-reverse': reverse
                    }),
                    children: tags.map((tag, i)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bbeef527533dbdd1$export$9ef0be9c867d1434), {
                            ...tag
                        }, i))
                }) : null
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                gridColStart: 1,
                className: "col-span-8 bg-current shadow-even shadow-black"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                ref: onBevelMount,
                gridColStart: 8,
                dontResetColor: true,
                className: "col-span-2 overflow-hidden",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "relative",
                    style: {
                        height: bevelHeight
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: (0, $jK7ok.cx)('absolute size-125 bg-current shadow-even shadow-black', reverse ? 'bottom-0 origin-bottom-left' : 'right-0 origin-top-right'),
                        style: {
                            transform: `rotate(${bevelRotate}rad)`
                        }
                    })
                })
            }),
            highlight ? /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                gridColStart: 1,
                className: (0, $jK7ok.cx)('border-goldenrod-bis', reverse ? 'border-r-4' : 'border-l-4')
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                gridColStart: 2,
                className: padding,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e2f3728a18bce646$export$4cacbff04efabb77), {
                    platform: platform,
                    riotId: riotId,
                    profileIconId: profileIconId,
                    masteries: masteries,
                    premadeId: premadeId,
                    summonerLevel: summonerLevel,
                    role: role,
                    mainRoles: mainRoles,
                    reverse: reverse,
                    tooltipShouldHide: tooltipShouldHide,
                    padding: padding
                })
            }),
            (0, $f5id0.pipe)(leagues, (0, $sjwE0.Maybe).fold(()=>null, ({ soloDuo: soloDuo, flex: flex })=>/*#__PURE__*/ (0, $ih19M.jsxs)($0cc1e54068090c87$var$Cell, {
                    gridColStart: 3,
                    className: (0, $jK7ok.cx)('flex flex-col justify-center gap-3', reverse ? 'items-end' : 'items-start', padding),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $6b812bf4602a0de7$export$9fc0e0d0ecb98c84), {
                            variant: "small",
                            queue: "soloDuo",
                            league: soloDuo,
                            reverse: reverse,
                            tooltipShouldHide: tooltipShouldHide,
                            className: "-mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $6b812bf4602a0de7$export$9fc0e0d0ecb98c84), {
                            variant: "small",
                            queue: "flex",
                            league: flex,
                            reverse: reverse,
                            tooltipShouldHide: tooltipShouldHide
                        })
                    ]
                }))),
            (0, $f5id0.pipe)(championRankedStats, (0, $sjwE0.Maybe).fold(()=>null, ({ wins: wins, losses: losses, kills: kills, deaths: deaths, assists: assists })=>{
                const played = wins + losses;
                const percents = played === 0 ? 0 : Math.round(100 * wins / played);
                return /*#__PURE__*/ (0, $ih19M.jsxs)($0cc1e54068090c87$var$Cell, {
                    gridColStart: 4,
                    className: (0, $jK7ok.cx)('flex flex-col justify-center text-sm', padding),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            ref: championWinRateRef,
                            className: (0, $jK7ok.cx)('flex flex-col', reverse ? 'items-start' : 'items-end'),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "whitespace-nowrap text-grey-400",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "font-semibold text-green",
                                            children: t.common.number(kills)
                                        }),
                                        " /",
                                        ' ',
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "font-semibold text-red",
                                            children: t.common.number(deaths)
                                        }),
                                        " /",
                                        ' ',
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "font-semibold text-goldenrod",
                                            children: t.common.number(assists)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "font-semibold",
                                            children: t.common.percents(percents)
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "text-grey-400",
                                            children: t.common.number(played, {
                                                withParenthesis: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                            hoverRef: championWinRateRef,
                            className: "grid grid-cols-[auto_auto] gap-x-1.5 gap-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "justify-self-end font-semibold text-green",
                                    children: wins
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: t.common.league.wins(wins)
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "justify-self-end font-semibold text-red",
                                    children: losses
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: t.common.league.losses(losses)
                                })
                            ]
                        })
                    ]
                });
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                gridColStart: 5,
                className: (0, $jK7ok.cx)('flex flex-col gap-px py-1 text-xs leading-3', padding),
                children: (0, $f5id0.pipe)(squareProps, (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "invisible",
                                children: "h"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "size-16 bg-black text-2xs",
                                children: t.common.championKey(championId)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "invisible",
                                children: "h"
                            })
                        ]
                    }), (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "invisible",
                                children: "h"
                            }),
                            props.masteries === undefined || props.masteries.championLevel < 5 ? // hide points
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3e823b497f8a8756$export$f46140fe718f016b), {
                                        ...props
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "invisible",
                                        children: "h"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                ref: championRef,
                                className: "flex flex-col items-center gap-px",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3e823b497f8a8756$export$f46140fe718f016b), {
                                        tooltipHoverRef: championRef,
                                        ...props
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "font-medium",
                                        children: t.common.numberK($0cc1e54068090c87$var$round(props.masteries.championPoints / 1000, 1))
                                    })
                                ]
                            })
                        ]
                    })))
            }),
            (0, $f5id0.pipe)(champion, (0, $sjwE0.Maybe).chain((c)=>$0cc1e54068090c87$var$foldGameMode(gameMode, {
                    onAram: (0, $sjwE0.Maybe).some(c.aram),
                    onUrf: (0, $sjwE0.Maybe).some(c.urf),
                    default: (0, $sjwE0.Maybe).none
                })), (0, $sjwE0.Maybe).fold(()=>null, (data)=>/*#__PURE__*/ (0, $ih19M.jsxs)($0cc1e54068090c87$var$Cell, {
                    gridColStart: 6,
                    className: (0, $jK7ok.cx)('flex flex-col justify-center', padding),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $4f8f7710ab3c6502$export$aa446a51db8c710), {
                            ref: mapChangesRef,
                            reverse: reverse,
                            data: data
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                            hoverRef: mapChangesRef,
                            shouldHide: tooltipShouldHide,
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $807a530abaaa1acf$export$8c094cd568b6439e), {
                                data: data
                            })
                        })
                    ]
                }))),
            /*#__PURE__*/ (0, $ih19M.jsxs)($0cc1e54068090c87$var$Cell, {
                type: (0, $jRQku.animated).div,
                gridColStart: 7,
                className: (0, $jK7ok.cx)('flex flex-col justify-center', padding),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        ref: totalHasteRef,
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                className: "flex gap-2",
                                children: spells.map(([id, spell])=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                        className: "size-7",
                                        children: (0, $f5id0.pipe)(spell, (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Empty, {
                                                className: "size-full",
                                                children: t.common.spellKey(id)
                                            }), (s)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $b72d2f6975f721d9$export$10199abf042bcb34), {
                                                spell: s,
                                                haste: totalHaste,
                                                tooltipShouldHide: tooltipShouldHide,
                                                className: "size-full"
                                            })))
                                    }, (0, $87807dff4a3e74cf$export$733cfc729a9b57a7).unwrap(id)))
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $90a33c3d4666f1d8$export$14b1c0db81189f0d), {
                                runeById: filteredRuneById,
                                itemById: itemById,
                                onToggle: onToggleHaste,
                                cosmicInsightDefaultChecked: true,
                                cosmicInsightDisabled: hasCosmicInsight,
                                canBuyCrimsonLucidity: (0, $f5id0.pipe)(role, (0, $sjwE0.Maybe).exists((r)=>r === 'mid')),
                                size: "small",
                                className: (0, $jK7ok.cx)('justify-center', reverse ? 'flex-row-reverse' : undefined)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                        hoverRef: totalHasteRef,
                        placement: "top",
                        children: t.common.totalHaste(totalHaste)
                    })
                ]
            }),
            (0, $f5id0.pipe)(maybePerks, (0, $sjwE0.Maybe).fold(()=>null, (perks)=>/*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                    gridColStart: 8,
                    className: (0, $jK7ok.cx)('col-span-2 flex items-center py-1', reverse ? 'pl-4' : 'pr-4', padding),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aa01d9d00716bdc6$export$12dda5e6511ff2f1), {
                        runeStyleById: runeStyleById,
                        runeById: runeById,
                        perks: perks,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide
                    })
                }))),
            !isLast ? /*#__PURE__*/ (0, $ih19M.jsx)($0cc1e54068090c87$var$Cell, {
                gridRowOffset: 2,
                gridColStart: 1,
                className: shouldWrap ? 'h-1' : 'h-4'
            }) : null
        ]
    });
};
const $0cc1e54068090c87$var$Li = ({ reverse: reverse, gridRowStart: gridRowStart, springStyle: springStyle, gestureProps: gestureProps, className: baseClassName, children: children })=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
        className: "contents",
        children: (0, $bh6RR.Children).map(children, (element)=>{
            if (element === null) return null;
            const { gridRowOffset: gridRowOffset = 0, className: className, style: style, ...props_ } = element.props;
            const props = {
                ...gestureProps,
                ...props_,
                gridRowOffset: gridRowOffset,
                reverse: reverse,
                className: (0, $jK7ok.cx)(baseClassName, className, 'touch-pinch-zoom select-none'),
                style: {
                    ...style,
                    gridRowStart: gridRowStart + gridRowOffset,
                    ...springStyle
                }
            };
            return /*#__PURE__*/ (0, $bh6RR.cloneElement)(element, props);
        })
    });
const $0cc1e54068090c87$var$Cell = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ type: type = (0, $jRQku.animated).div, gridColStart: gridColStart, // eslint-disable-next-line @typescript-eslint/no-unused-vars
gridRowOffset: _, reverse: reverse = false, dontResetColor: dontResetColor, className: className, style: style, children: children, ...props_ }, ref)=>{
    const props = {
        ...props_,
        ref: ref,
        className: (0, $jK7ok.cx)([
            '[&>*]:text-wheat',
            dontResetColor !== true
        ], className),
        style: {
            ...style,
            gridColumnStart: reverse ? undefined : gridColStart,
            gridColumnEnd: reverse ? $0cc1e54068090c87$var$gridTotalCols - gridColStart + 2 : undefined
        }
    };
    return /*#__PURE__*/ (0, $bh6RR.createElement)(type, props, children);
});
const $0cc1e54068090c87$var$Empty = ({ className: className, children: children })=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: (0, $jK7ok.cx)('bg-black text-2xs', className),
        children: children
    });
function $0cc1e54068090c87$var$foldGameMode(gameMode, { onAram: onAram, onUrf: onUrf, default: default_ }) {
    switch(gameMode){
        case 'ARAM':
            return onAram;
        case 'URF':
            return onUrf;
        default:
            return default_;
    }
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $65UVg = parcelRequire("65UVg");


var $es0HS = parcelRequire("es0HS");

var $4MEuc = parcelRequire("4MEuc");
// participant line 1 + participant line 2
const $59aaf07aeb955399$var$participantHeightWithoutSpacer = 114;
const $59aaf07aeb955399$export$daea3ea1fa035f44 = $59aaf07aeb955399$var$participantHeightWithoutSpacer + 4;
const $59aaf07aeb955399$export$8ddcd5fd8c1e34a3 = $59aaf07aeb955399$var$participantHeightWithoutSpacer + 16;
const $59aaf07aeb955399$export$e903137a303a952a = ({ shouldWrap: shouldWrap, rowMultiple: rowMultiple = 1, iconClassName: iconClassName })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: (0, $65UVg.ChampionPosition).values.map((position, i)=>{
            const isLast = i === (0, $65UVg.ChampionPosition).values.length - 1;
            return /*#__PURE__*/ (0, $ih19M.jsx)($59aaf07aeb955399$var$Span, {
                position: position,
                className: iconClassName,
                style: {
                    height: shouldWrap ? undefined : isLast ? $59aaf07aeb955399$var$participantHeightWithoutSpacer : $59aaf07aeb955399$export$8ddcd5fd8c1e34a3,
                    gridRowStart: rowMultiple * i + 1
                }
            }, position);
        })
    });
const $59aaf07aeb955399$var$Span = ({ position: position, className: className, style: style })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const ref = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                ref: ref,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2fef2422e6a814aa$export$12e8b9f23d53a496), {
                    position: position,
                    className: "size-5 text-grey-500"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: ref,
                children: t.labels.position[position]
            })
        ]
    });
};



/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $bh6RR = parcelRequire("bh6RR");
const $13739a01498cfe4b$export$bede44fc2a176ab2 = ()=>{
    const [shouldWrap, setShouldWrap] = (0, $bh6RR.useState)(false);
    const containerRef = (0, $bh6RR.useRef)(null);
    const leftRef = (0, $bh6RR.useRef)(null);
    const rightRef = (0, $bh6RR.useRef)(null);
    const updateShouldWrap = (0, $bh6RR.useCallback)(()=>{
        if (containerRef.current !== null && leftRef.current !== null && rightRef.current !== null) {
            const container = containerRef.current.getBoundingClientRect();
            const left = leftRef.current.getBoundingClientRect();
            const right = rightRef.current.getBoundingClientRect();
            setShouldWrap((shouldWrap_)=>{
                if (shouldWrap_ && left.right < right.left) return false;
                if (!shouldWrap_ && container.width < left.width + right.width) return true;
                return shouldWrap_;
            });
        }
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        window.addEventListener('resize', updateShouldWrap);
        return ()=>window.removeEventListener('resize', updateShouldWrap);
    }, [
        updateShouldWrap
    ]);
    return {
        shouldWrap: shouldWrap,
        onMountContainer: (0, $bh6RR.useCallback)((e)=>{
            // eslint-disable-next-line functional/immutable-data
            containerRef.current = e;
            updateShouldWrap();
        }, [
            updateShouldWrap
        ]),
        onMountLeft: (0, $bh6RR.useCallback)((e)=>{
            // eslint-disable-next-line functional/immutable-data
            leftRef.current = e;
            updateShouldWrap();
        }, [
            updateShouldWrap
        ]),
        onMountRight: (0, $bh6RR.useCallback)((e)=>{
            // eslint-disable-next-line functional/immutable-data
            rightRef.current = e;
            updateShouldWrap();
        }, [
            updateShouldWrap
        ])
    };
};


const { swap: $7ab2bc3670b99e36$var$swap } = (0, $iPRex.ListUtils);
const { clamp: $7ab2bc3670b99e36$var$clamp } = (0, $6nJ5H.NumberUtils);
const { pad10: $7ab2bc3670b99e36$var$pad10 } = (0, $dOJeV.StringUtils);
const $7ab2bc3670b99e36$var$refreshDelay = (0, $1GV7y.MsDuration).milliseconds(100);
const $7ab2bc3670b99e36$var$reloadInterval = (0, $1GV7y.MsDuration).seconds(10);
const $7ab2bc3670b99e36$var$timerInterval = (0, $1GV7y.MsDuration).second(1);
const $7ab2bc3670b99e36$export$85034e8d4bf2420 = ({ platform: platform, riotId: riotId })=>{
    const { maybeUser: maybeUser } = (0, $j30iL.useUser)();
    const { lang: lang } = (0, $4MEuc.useTranslation)();
    const { data: data, error: error, mutate: mutate } = (0, $41f7b65297f1c1ab$export$1432bee435d2d13b)(lang, platform, riotId);
    // Remove shards on user disconnect
    const previousUser = (0, $258c1e51a9d18326$export$5cae361ad82dce8b)(maybeUser);
    (0, $bh6RR.useEffect)(()=>{
        if (data !== undefined && (0, $sjwE0.Maybe).isNone(maybeUser) && (0, $sjwE0.Maybe).isSome((0, $sjwE0.Maybe).flatten(previousUser)) && (0, $sjwE0.Maybe).isSome(data.game)) mutate((0, $f5id0.pipe)((0, $ac148fc31832ed14$export$8609024c4106d527).Lens.game.participants, (0, $asc1N).modify((0, $sjwE0.PartialDict).map((0, $sjwE0.NonEmptyArray).map((0, $7365bbcb5e753bee$export$31eb4e888063c573).Lens.shardsCount.set((0, $sjwE0.Maybe).none)))))(data), {
            revalidate: false
        });
    }, [
        data,
        maybeUser,
        mutate,
        previousUser
    ]);
    const refreshGame = (0, $bh6RR.useCallback)(()=>{
        mutate(undefined, {
            revalidate: false
        });
        setTimeout(()=>mutate(undefined, {
                revalidate: true
            }), (0, $1GV7y.MsDuration).unwrap($7ab2bc3670b99e36$var$refreshDelay));
    }, [
        mutate
    ]);
    const reloadGame = (0, $bh6RR.useCallback)(()=>{
        mutate();
    }, [
        mutate
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
            data: data,
            error: error,
            children: (summonerGame)=>/*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$Loaded, {
                    platform: platform,
                    summoner: summonerGame.summoner,
                    game: summonerGame.game,
                    refreshGame: refreshGame,
                    reloadGame: reloadGame
                })
        })
    });
};
const $7ab2bc3670b99e36$var$Loaded = (props)=>{
    const { summoner: summoner, refreshGame: refreshGame } = props;
    const { t: t } = (0, $4MEuc.useTranslation)('activeGame');
    (0, $9e1e0464b0af5656$export$f96ad7bfa050ed2)(summoner, (0, $gE3ky.appRoutes).platformRiotIdGame(props.platform, summoner.riotId));
    return (0, $f5id0.pipe)(props.game, (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "flex flex-col items-center gap-4",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmQDF.Pre), {
                    className: "mt-4",
                    children: t.notInGame
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    type: "button",
                    onClick: refreshGame,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.RefreshOutline), {
                        className: "w-6"
                    })
                })
            ]
        }), (game)=>/*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$WithoutAdditional, {
            ...props,
            game: game
        })));
};
const $7ab2bc3670b99e36$var$WithoutAdditional = (props)=>{
    const { lang: lang } = (0, $4MEuc.useTranslation)();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
        ...(0, $7Dhdf.useSWRHttp)((0, $k8rBo.apiRoutes).staticData(lang).additional.get, {}, [
            (0, $e8f514beccf46851$export$94540228b78a751e).codec,
            'AdditionalStaticData'
        ]),
        children: (additionalStaticData)=>/*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$ActiveGameComponent, {
                ...props,
                additionalStaticData: additionalStaticData
            })
    });
};
const $7ab2bc3670b99e36$var$ActiveGameComponent = ({ additionalStaticData: additionalStaticData, platform: platform, summoner: summoner, game: { gameStartTime: gameStartTime, mapId: mapId, gameMode: gameMode, gameQueueConfigId: gameQueueConfigId, isDraft: isDraft, bannedChampions: bannedChampions, participants: participants, isPoroOK: isPoroOK }, refreshGame: refreshGame, reloadGame: reloadGame })=>{
    const { lang: lang, t: t } = (0, $4MEuc.useTranslation)();
    const { shouldWrap: shouldWrap, onMountContainer: onMountContainer, onMountLeft: onMountLeft, onMountRight: onMountRight } = (0, $13739a01498cfe4b$export$bede44fc2a176ab2)();
    const summonerSpellByKey = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.summonerSpells, (0, $iPRex.ListUtils).findFirstBy((0, $87807dff4a3e74cf$export$733cfc729a9b57a7).Eq)((s)=>s.key)), [
        additionalStaticData.summonerSpells
    ]);
    const runeStyleById = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.runeStyles, (0, $iPRex.ListUtils).findFirstBy((0, $56a38f105919baed$export$597b42c1d60925a3).Eq)((s)=>s.id)), [
        additionalStaticData.runeStyles
    ]);
    const runeById = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.runes, (0, $iPRex.ListUtils).findFirstBy((0, $7340158445f0915b$export$96c66196b0b4f739).Eq)((s)=>s.id)), [
        additionalStaticData.runes
    ]);
    const itemById = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(additionalStaticData.items, (0, $iPRex.ListUtils).findFirstBy((0, $7155420a73f17f40$export$43ac25706d3b5d4a).Eq)((i)=>i.id)), [
        additionalStaticData.items
    ]);
    const shouldShowPositions = (0, $41656179bb7d4dbd$export$44c1e36a0d7bb01f).isSummonersRift(mapId);
    const gameQueue = (0, $f5id0.pipe)(t.common.labels.gameQueue, (0, $sjwE0.Dict).lookup(`${gameQueueConfigId}`), (0, $sjwE0.Maybe).getOrElseW(()=>gameQueueConfigId));
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "grid min-h-full grid-rows-[1fr_auto_auto_1fr] gap-4 py-3",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex items-center justify-center gap-4 px-3",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        type: "button",
                        onClick: refreshGame,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.RefreshOutline), {
                            className: "w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                        className: "text-xl font-bold text-goldenrod",
                        children: gameQueue
                    }),
                    (0, $f5id0.pipe)(gameStartTime, (0, $sjwE0.Maybe).fold(()=>/*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$Loading, {
                            reload: reloadGame
                        }), (startTime)=>/*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$Timer, {
                            startTime: startTime
                        }))),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex items-center gap-0.5",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                href: $7ab2bc3670b99e36$var$poroLink(lang, platform, summoner.riotId),
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                    src: (0, $jFynM.Assets).thirdParty.porofessor,
                                    alt: t.activeGame.poroIconAlt,
                                    className: "h-5"
                                })
                            }),
                            isPoroOK ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CheckMarkSharp), {
                                className: "w-3 text-green"
                            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CloseFilled), {
                                className: "w-3 text-red"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $c5ae0484ab2caf1e$export$e355dba6ae7236d1), {
                isDraft: isDraft,
                bannedChampions: bannedChampions,
                participants: participants
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                ref: onMountContainer,
                className: shouldWrap ? 'flex flex-col items-start gap-1' : 'grid grid-cols-2',
                children: [
                    (0, $4709c62f841478e7$export$4718096832dec34e).values.map((teamId, i)=>{
                        const reverse = i % 2 === 1;
                        const participants_ = participants[teamId];
                        const mountRef = i === 0 ? onMountLeft : i === 1 ? onMountRight : undefined;
                        return /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                            className: (0, $jK7ok.cx)('grid', [
                                'self-end',
                                shouldWrap && reverse
                            ]),
                            style: {
                                ...shouldShowPositions && !shouldWrap ? {
                                    gridRowStart: Math.floor((i + 2) / 2),
                                    gridRowEnd: `span ${participants_?.length ?? 0}`
                                } : {},
                                gridColumnStart: reverse ? 2 : 1,
                                ...(0, $0cc1e54068090c87$export$2d6247fb34949a13)[`${reverse}`]
                            },
                            children: [
                                mountRef !== undefined ? /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    ref: mountRef,
                                    className: "col-span-full row-start-1"
                                }) : null,
                                shouldShowPositions && shouldWrap ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $59aaf07aeb955399$export$e903137a303a952a), {
                                    shouldWrap: shouldWrap,
                                    rowMultiple: 3,
                                    iconClassName: (0, $jK7ok.cx)('col-span-full col-start-1 pt-9.75', reverse ? 'justify-self-start -ml-2.5' : 'justify-self-end -mr-2.5')
                                }) : null,
                                participants_ === undefined ? null : /*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$Participants, {
                                    platform: platform,
                                    summoner: summoner,
                                    gameMode: gameMode,
                                    shouldWrap: shouldWrap,
                                    teamId: teamId,
                                    reverse: reverse,
                                    participants: participants_,
                                    summonerSpellByKey: summonerSpellByKey,
                                    runeStyleById: runeStyleById,
                                    runeById: runeById,
                                    itemById: itemById
                                })
                            ]
                        }, teamId);
                    }),
                    shouldShowPositions && !shouldWrap ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $59aaf07aeb955399$export$e903137a303a952a), {
                        shouldWrap: shouldWrap,
                        iconClassName: "col-span-2 justify-self-center col-start-1 pt-9.75"
                    }) : null
                ]
            })
        ]
    });
};
const $7ab2bc3670b99e36$var$poroLink = (lang, platform, { gameName: gameName, tagLine: tagLine })=>`${(0, $c6xfg.config).poroApiBaseUrl}/${(0, $e499b70a5fc06c1e$export$6d7a29d4960e3d83).poroLang[lang]}/live/${(0, $ebDzf.Platform).encoderLower.encode(platform)}/${gameName}-${tagLine}/season`;
const $7ab2bc3670b99e36$var$Participants = ({ platform: platform, summoner: summoner, gameMode: gameMode, shouldWrap: shouldWrap, teamId: teamId, reverse: reverse, participants: participants, summonerSpellByKey: summonerSpellByKey, runeStyleById: runeStyleById, runeById: runeById, itemById: itemById })=>{
    const [isDragging, setIsDragging] = (0, $bh6RR.useState)(false);
    const order = (0, $bh6RR.useRef)(participants.map((_, index)=>index)) // Store indicies as a local ref, this represents the item order
    ;
    const participantHeight = shouldWrap ? (0, $59aaf07aeb955399$export$daea3ea1fa035f44) : (0, $59aaf07aeb955399$export$8ddcd5fd8c1e34a3);
    const [springs, api] = (0, $5DIoZ.useSprings)(participants.length, $7ab2bc3670b99e36$var$fn(participantHeight, teamId, order.current)) // Create springs, each corresponds to an item, controlling its transform, etc.
    ;
    const bind = (0, $63a572c3ce7ebf73$export$7941f8aafa4b6021)(({ event: event, args: [activeIndex], active: active, movement: [, y] })=>{
        event.preventDefault();
        setIsDragging(active);
        const currentIndex = order.current.indexOf(activeIndex);
        const currentRow = $7ab2bc3670b99e36$var$clamp(Math.round((currentIndex * participantHeight + y) / participantHeight), 0, participants.length - 1);
        if (active) api.start($7ab2bc3670b99e36$var$fn(participantHeight, teamId, order.current, active, activeIndex, currentIndex, currentRow, y)) // Feed springs new style data, they'll animate the view without causing a single render
        ;
        else {
            const newOrder = $7ab2bc3670b99e36$var$swap(order.current, currentIndex, currentRow);
            api.start($7ab2bc3670b99e36$var$fn(participantHeight, teamId, newOrder, active, activeIndex, currentIndex, currentRow, y));
            // eslint-disable-next-line functional/immutable-data
            order.current = newOrder;
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: springs.map((springStyle, j)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const participant = participants[j];
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $0cc1e54068090c87$export$5cfb5b4baffb5bc9), {
                summonerSpellByKey: summonerSpellByKey,
                runeStyleById: runeStyleById,
                runeById: runeById,
                itemById: itemById,
                platform: platform,
                gameMode: gameMode,
                participant: participant,
                shouldWrap: shouldWrap,
                highlight: (0, $f5id0.pipe)(participant.riotId, (0, $sjwE0.Maybe).exists((id)=>(0, $fp7Nf.RiotId).Eq.equals(id, summoner.riotId))),
                reverse: reverse,
                index: j,
                isLast: j === springs.length - 1,
                isDragging: isDragging,
                springStyle: springStyle,
                gestureProps: bind(j)
            }, (0, $f5id0.pipe)(participant.riotId, (0, $sjwE0.Maybe).foldW(()=>j, (0, $fp7Nf.RiotId).stringify)));
        })
    });
};
const $7ab2bc3670b99e36$var$dragOffset = 20;
const $7ab2bc3670b99e36$var$fn = (participantHeight, teamId, order, active = false, originalIndex = 0, currentIndex = 0, currentRow = 0, y = 0)=>(index)=>{
        if (active && index === originalIndex) return {
            x: teamId === 100 ? $7ab2bc3670b99e36$var$dragOffset : -$7ab2bc3670b99e36$var$dragOffset,
            y: (currentIndex - originalIndex) * participantHeight + y,
            color: $7ab2bc3670b99e36$var$dragColor[teamId],
            zIndex: 2,
            immediate: (key)=>key === 'y' || key === 'zIndex'
        };
        const indexOf = order.indexOf(index);
        return {
            x: 0,
            y: (indexOf - index) * participantHeight,
            color: active && indexOf === currentRow ? $7ab2bc3670b99e36$var$dragOverColor : $7ab2bc3670b99e36$var$baseColor[teamId],
            zIndex: 1,
            immediate: false
        };
    };
const $7ab2bc3670b99e36$var$baseColor = {
    100: '#061b3e',
    200: '#261622'
};
const $7ab2bc3670b99e36$var$dragColor = {
    100: '#04285c',
    200: '#411a21'
};
const $7ab2bc3670b99e36$var$dragOverColor = '#525252';
const $7ab2bc3670b99e36$var$Loading = ({ reload: reload })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('activeGame');
    (0, $bh6RR.useEffect)(()=>{
        const id = window.setInterval(reload, (0, $1GV7y.MsDuration).unwrap($7ab2bc3670b99e36$var$reloadInterval));
        return ()=>window.clearInterval(id);
    }, [
        reload
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$GameInfo, {
        children: t.loading
    });
};
const $7ab2bc3670b99e36$var$Timer = ({ startTime: startTime })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('activeGame');
    const [gameDuration, setGameDuration] = (0, $bh6RR.useState)(()=>(0, $f5id0.pipe)((0, $kXnAC.DayJs).now(), (0, $kXnAC.DayJs).diff(startTime)));
    (0, $bh6RR.useEffect)(()=>{
        const id = window.setInterval(()=>setGameDuration((0, $1GV7y.MsDuration).add($7ab2bc3670b99e36$var$timerInterval)), (0, $1GV7y.MsDuration).unwrap($7ab2bc3670b99e36$var$timerInterval));
        return ()=>window.clearInterval(id);
    }, []);
    const timerRef = (0, $bh6RR.useRef)(null);
    const date = (0, $kXnAC.DayJs).toDate(startTime);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($7ab2bc3670b99e36$var$GameInfo, {
                ref: timerRef,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: "font-lib-mono",
                    children: $7ab2bc3670b99e36$var$prettyMs(gameDuration)
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: timerRef,
                children: t.gameStartedAt(date)
            })
        ]
    });
};
const $7ab2bc3670b99e36$var$prettyMs = (ms)=>{
    const date = (0, $kXnAC.DayJs).of((0, $1GV7y.MsDuration).unwrap(ms));
    const zero = (0, $kXnAC.DayJs).of(0);
    const d = (0, $f5id0.pipe)(date, (0, $kXnAC.DayJs).diff(zero, 'days'));
    const h = (0, $kXnAC.DayJs).hour.get(date);
    const m = (0, $kXnAC.DayJs).minute.get(date);
    const s = (0, $kXnAC.DayJs).second.get(date);
    return `${$7ab2bc3670b99e36$var$pad10(d * 24 + h)}:${$7ab2bc3670b99e36$var$pad10(m)}:${$7ab2bc3670b99e36$var$pad10(s)}`;
};
const $7ab2bc3670b99e36$var$GameInfo = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        ref: ref,
        className: "flex text-grey-400",
        children: [
            "(",
            children,
            ")"
        ]
    }));


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $4x239 = parcelRequire("4x239");
var $10ZIc = parcelRequire("10ZIc");
var $6omhk = parcelRequire("6omhk");

var $f5id0 = parcelRequire("f5id0");
var $3a60d30aee96367f$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $3a60d30aee96367f$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $3a60d30aee96367f$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $3a60d30aee96367f$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $3a60d30aee96367f$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $3a60d30aee96367f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $3a60d30aee96367f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $3a60d30aee96367f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $3a60d30aee96367f$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $3a60d30aee96367f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $3a60d30aee96367f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3a60d30aee96367f$var$root = $3a60d30aee96367f$var$freeGlobal || $3a60d30aee96367f$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $3a60d30aee96367f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3a60d30aee96367f$var$objectToString = $3a60d30aee96367f$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3a60d30aee96367f$var$nativeMax = Math.max, $3a60d30aee96367f$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $3a60d30aee96367f$var$now = function() {
    return $3a60d30aee96367f$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $3a60d30aee96367f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($3a60d30aee96367f$var$FUNC_ERROR_TEXT);
    wait = $3a60d30aee96367f$var$toNumber(wait) || 0;
    if ($3a60d30aee96367f$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $3a60d30aee96367f$var$nativeMax($3a60d30aee96367f$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $3a60d30aee96367f$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $3a60d30aee96367f$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($3a60d30aee96367f$var$now());
    }
    function debounced() {
        var time = $3a60d30aee96367f$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3a60d30aee96367f$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3a60d30aee96367f$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $3a60d30aee96367f$var$isSymbol(value) {
    return typeof value == 'symbol' || $3a60d30aee96367f$var$isObjectLike(value) && $3a60d30aee96367f$var$objectToString.call(value) == $3a60d30aee96367f$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $3a60d30aee96367f$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($3a60d30aee96367f$var$isSymbol(value)) return $3a60d30aee96367f$var$NAN;
    if ($3a60d30aee96367f$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $3a60d30aee96367f$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($3a60d30aee96367f$var$reTrim, '');
    var isBinary = $3a60d30aee96367f$var$reIsBinary.test(value);
    return isBinary || $3a60d30aee96367f$var$reIsOctal.test(value) ? $3a60d30aee96367f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $3a60d30aee96367f$var$reIsBadHex.test(value) ? $3a60d30aee96367f$var$NAN : +value;
}
$3a60d30aee96367f$exports = $3a60d30aee96367f$var$debounce;



var $asc1N = parcelRequire("asc1N");

var $bh6RR = parcelRequire("bh6RR");


var $1GV7y = parcelRequire("1GV7y");

var $br0yu = parcelRequire("br0yu");

var $aapGO = parcelRequire("aapGO");

var $25oLT = parcelRequire("25oLT");



var $iPRex = parcelRequire("iPRex");

var $6nJ5H = parcelRequire("6nJ5H");

var $dOJeV = parcelRequire("dOJeV");

var $sjwE0 = parcelRequire("sjwE0");

var $g7UIk = parcelRequire("g7UIk");

var $9g4gL = parcelRequire("9g4gL");

var $fVW4p = parcelRequire("fVW4p");

var $tA0jd = parcelRequire("tA0jd");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $31rfl = parcelRequire("31rfl");

var $4MEuc = parcelRequire("4MEuc");

var $j30iL = parcelRequire("j30iL");




var $kiCtw = parcelRequire("kiCtw");

var $gE3ky = parcelRequire("gE3ky");

var $jK7ok = parcelRequire("jK7ok");

var $7VlB6 = parcelRequire("7VlB6");
/* eslint-disable functional/no-expression-statements */ 
var $ih19M = parcelRequire("ih19M");

var $4lr6f = parcelRequire("4lr6f");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $vkIKL = parcelRequire("vkIKL");

var $br0yu = parcelRequire("br0yu");

var $iPRex = parcelRequire("iPRex");

var $6nJ5H = parcelRequire("6nJ5H");

var $sjwE0 = parcelRequire("sjwE0");





var $es0HS = parcelRequire("es0HS");

var $9xM77 = parcelRequire("9xM77");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");



var $kiCtw = parcelRequire("kiCtw");

var $gUt5F = parcelRequire("gUt5F");


var $jK7ok = parcelRequire("jK7ok");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $12uqT = parcelRequire("12uqT");
var $3JkJJ = parcelRequire("3JkJJ");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $bh6RR = parcelRequire("bh6RR");

var $vkIKL = parcelRequire("vkIKL");

var $aapGO = parcelRequire("aapGO");

var $65UVg = parcelRequire("65UVg");

var $sjwE0 = parcelRequire("sjwE0");



var $3KgVG = parcelRequire("3KgVG");

var $ih19M = parcelRequire("ih19M");

var $4MEuc = parcelRequire("4MEuc");

var $jFynM = parcelRequire("jFynM");

var $jK7ok = parcelRequire("jK7ok");
const $2e638aa5feeacb72$export$9ea228593aea6cc2 = ({ level: level, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
        src: (0, $jFynM.Assets).masteries[level],
        alt: t.masteryIconAlt(level),
        className: (0, $jK7ok.cx)([
            'grayscale',
            level === 0
        ], className)
    });
};


/* eslint-disable functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jK7ok = parcelRequire("jK7ok");
function $f243ee252323e221$export$e282af879c335b03({ name: name, value: value, setValue: setValue, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex flex-wrap",
        children: children.map(({ value: val, label: label })=>/*#__PURE__*/ (0, $ih19M.jsx)($f243ee252323e221$var$Radio, {
                name: name,
                value: val,
                setValue: setValue,
                label: label,
                isChecked: val === value
            }, val))
    });
}
function $f243ee252323e221$var$Radio({ name: name, value: value, setValue: setValue, label: label, isChecked: isChecked }) {
    const onChange = (0, $bh6RR.useCallback)(()=>setValue(value), [
        setValue,
        value
    ]);
    const id = (0, $bh6RR.useId)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        className: "group",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                type: "radio",
                name: name,
                id: id,
                checked: isChecked,
                onChange: onChange,
                className: "sr-only"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                htmlFor: id,
                className: (0, $jK7ok.cx)('flex border-l border-goldenrod-bis group-first:rounded-l-md group-first:border-l-0 group-last:rounded-r-md', isChecked ? 'bg-goldenrod-bis text-black' : 'cursor-pointer bg-zinc-700'),
                children: label
            })
        ]
    });
}
function $f243ee252323e221$export$f87cf8075df92fdf(value, label) {
    return {
        value: value,
        label: label
    };
}




var $es0HS = parcelRequire("es0HS");

var $9xM77 = parcelRequire("9xM77");

var $4MEuc = parcelRequire("4MEuc");

var $jFynM = parcelRequire("jFynM");

var $1aCLo = parcelRequire("1aCLo");

var $gwlG1 = parcelRequire("gwlG1");

var $kiCtw = parcelRequire("kiCtw");

var $1ZcO3 = parcelRequire("1ZcO3");

var $4tRvs = parcelRequire("4tRvs");

var $jK7ok = parcelRequire("jK7ok");
/* eslint-disable functional/no-return-void */ 
var $ih19M = parcelRequire("ih19M");

var $3JkJJ = parcelRequire("3JkJJ");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $sjwE0 = parcelRequire("sjwE0");

var $es0HS = parcelRequire("es0HS");

var $jK7ok = parcelRequire("jK7ok");
function $05dbbe6f3a5f42f9$export$2bc6b1ab4f9a3f({ eq: eq, values: values, checked: checked, toggleChecked: toggleChecked, isMenuVisible: isMenuVisible, onMouseEnter: onMouseEnter, tooltipPlacement: tooltipPlacement, iconClassName: iconClassName, className: className }) {
    const toggleChecked_ = (0, $bh6RR.useCallback)((value)=>(e)=>toggleChecked((prev)=>{
                const isAllChecked = (0, $3JkJJ).size(prev) === (0, $sjwE0.List).size(values);
                if (isAllChecked) return new Set([
                    value
                ]);
                const isChecked = (0, $3JkJJ).elem(eq)(value, prev);
                if (isChecked && (0, $3JkJJ).size(prev) === 1) return (0, $f5id0.pipe)(values, (0, $sjwE0.List).map((v)=>v.value), (0, $3JkJJ).fromReadonlyArray(eq));
                return (0, $f5id0.pipe)(prev, (e.target.checked ? (0, $3JkJJ).insert(eq) : (0, $3JkJJ).remove(eq))(value));
            }), [
        eq,
        toggleChecked,
        values
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        onMouseEnter: onMouseEnter,
        className: (0, $jK7ok.cx)('flex flex-wrap', className),
        children: (0, $f5id0.pipe)(values, (0, $sjwE0.List).map(({ key: key, value: value, icon: icon, label: label })=>/*#__PURE__*/ (0, $ih19M.jsx)($05dbbe6f3a5f42f9$var$LabelCheckbox, {
                eq: eq,
                isAllChecked: (0, $3JkJJ).size(checked) === (0, $sjwE0.List).size(values),
                value: value,
                icon: icon,
                label: label,
                checked: checked,
                toggleChecked: toggleChecked_,
                isMenuVisible: isMenuVisible,
                tooltipPlacement: tooltipPlacement,
                iconClassName: iconClassName
            }, key)))
    });
}
function $05dbbe6f3a5f42f9$var$LabelCheckbox({ eq: eq, isAllChecked: isAllChecked, value: value, icon: icon, label: label, checked: checked, toggleChecked: toggleChecked, isMenuVisible: isMenuVisible, tooltipPlacement: tooltipPlacement, iconClassName: iconClassName }) {
    const hoverRef = (0, $bh6RR.useRef)(null);
    const isChecked = isAllChecked ? false : (0, $3JkJJ).elem(eq)(value, checked);
    const id = (0, $bh6RR.useId)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        className: "group/checkbox",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                type: "checkbox",
                id: id,
                checked: isChecked,
                onChange: toggleChecked(value),
                className: "sr-only"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                ref: hoverRef,
                htmlFor: id,
                className: (0, $jK7ok.cx)('flex h-9 shrink-0 cursor-pointer items-center', isMenuVisible === true ? 'group-first/checkbox:rounded-tl-md group-last/checkbox:rounded-tr-md' : 'group-first/checkbox:rounded-l-md group-last/checkbox:rounded-r-md', isChecked ? 'bg-goldenrod-bis' : 'bg-zinc-700', iconClassName),
                children: icon(isChecked)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: hoverRef,
                placement: tooltipPlacement,
                children: label
            })
        ]
    });
}


const $40ad235304d280d1$export$a81e88d11f746f25 = ({ searchCount: searchCount, randomChampion: randomChampion })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const { masteriesQuery: masteriesQuery, updateMasteriesQuery: updateMasteriesQuery } = (0, $9xM77.useHistory)();
    const [levelsMenuIsVisible, setLevelsMenuIsVisible] = (0, $bh6RR.useState)(false);
    const handleMasteriesMouseEnter = (0, $bh6RR.useCallback)(()=>{
        if (!levelsMenuIsVisible) setLevelsMenuIsVisible(true);
    }, [
        levelsMenuIsVisible
    ]);
    const hideLevelsMenu = (0, $bh6RR.useCallback)(()=>setLevelsMenuIsVisible(false), []);
    const toggleMasteryChecked = (0, $bh6RR.useCallback)((f)=>{
        updateMasteriesQuery((0, $f5id0.pipe)((0, $kiCtw.MasteriesQuery).Lens.level, (0, $gnzcc).modify(f)));
        hideLevelsMenu();
    }, [
        hideLevelsMenu,
        updateMasteriesQuery
    ]);
    const SelectLevelsButton = (0, $bh6RR.useMemo)(()=>$40ad235304d280d1$var$getSelectLevelsButton(masteriesQuery.level, (0, $f5id0.flow)((0, $kiCtw.MasteriesQuery).Lens.level.set, updateMasteriesQuery, hideLevelsMenu)), [
        hideLevelsMenu,
        masteriesQuery.level,
        updateMasteriesQuery
    ]);
    const toggleFactionChecked = (0, $bh6RR.useCallback)((f)=>updateMasteriesQuery((0, $f5id0.pipe)((0, $kiCtw.MasteriesQuery).Lens.faction, (0, $gnzcc).modify(f))), [
        updateMasteriesQuery
    ]);
    const togglePositionChecked = (0, $bh6RR.useCallback)((f)=>updateMasteriesQuery((0, $f5id0.pipe)((0, $kiCtw.MasteriesQuery).Lens.position, (0, $gnzcc).modify(f))), [
        updateMasteriesQuery
    ]);
    const setSort = (0, $f5id0.flow)((0, $kiCtw.MasteriesQuery).Lens.sort.set, updateMasteriesQuery);
    const setOrder = (0, $f5id0.flow)((0, $kiCtw.MasteriesQuery).Lens.order.set, updateMasteriesQuery);
    const setView = (0, $f5id0.flow)((0, $kiCtw.MasteriesQuery).Lens.view.set, updateMasteriesQuery);
    const setQuerySearch = (0, $bh6RR.useMemo)(()=>(0, $f5id0.flow)((0, $kiCtw.MasteriesQuery).Lens.search.set, updateMasteriesQuery), [
        updateMasteriesQuery
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex w-full max-w-7xl flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $f243ee252323e221$export$e282af879c335b03), {
                        name: "view",
                        value: masteriesQuery.view,
                        setValue: setView,
                        children: [
                            (0, $f243ee252323e221$export$f87cf8075df92fdf)('compact', /*#__PURE__*/ (0, $ih19M.jsxs)($40ad235304d280d1$var$IconLabel, {
                                tooltip: t.masteries.filters.view.compact,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.AppsSharp), {
                                        className: "w-4"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: t.masteries.filters.viewShort.compact
                                    })
                                ]
                            })),
                            (0, $f243ee252323e221$export$f87cf8075df92fdf)('histogram', /*#__PURE__*/ (0, $ih19M.jsxs)($40ad235304d280d1$var$IconLabel, {
                                tooltip: t.masteries.filters.view.histogram,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.StatsChartSharp), {
                                        className: "w-5 rotate-90 -scale-x-100"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: t.masteries.filters.viewShort.histogram
                                    })
                                ]
                            })),
                            (0, $f243ee252323e221$export$f87cf8075df92fdf)('aram', /*#__PURE__*/ (0, $ih19M.jsxs)($40ad235304d280d1$var$IconLabel, {
                                tooltip: t.masteries.filters.view.aram,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1aCLo.HowlingAbyssSimple), {
                                        className: "w-4.5"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: t.masteries.filters.viewShort.aram
                                    })
                                ]
                            })),
                            (0, $f243ee252323e221$export$f87cf8075df92fdf)('urf', /*#__PURE__*/ (0, $ih19M.jsxs)($40ad235304d280d1$var$IconLabel, {
                                tooltip: t.masteries.filters.view.urf,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3KgVG.MaskedImage), {
                                        src: (0, $jFynM.Assets).spatula,
                                        className: "size-4.5"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: t.masteries.filters.viewShort.urf
                                    })
                                ]
                            })),
                            (0, $f243ee252323e221$export$f87cf8075df92fdf)('factions', /*#__PURE__*/ (0, $ih19M.jsxs)($40ad235304d280d1$var$IconLabel, {
                                tooltip: t.masteries.filters.view.factions,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3KgVG.MaskedImage), {
                                        src: (0, $jFynM.Assets).runeterra,
                                        className: "size-4.5"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: t.masteries.filters.viewShort.factions
                                    })
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $f243ee252323e221$export$e282af879c335b03), {
                                name: "sort",
                                value: masteriesQuery.sort,
                                setValue: setSort,
                                children: (0, $f5id0.pipe)((0, $4tRvs.MasteriesQuerySort).values, (0, $sjwE0.NonEmptyArray).map((value)=>(0, $f243ee252323e221$export$f87cf8075df92fdf)(value, /*#__PURE__*/ (0, $ih19M.jsx)($40ad235304d280d1$var$TextLabel, {
                                        tooltip: t.masteries.filters.sort[value],
                                        children: t.masteries.filters.sortShort[value]
                                    }))))
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $f243ee252323e221$export$e282af879c335b03), {
                                name: "order",
                                value: masteriesQuery.order,
                                setValue: setOrder,
                                children: (0, $f5id0.pipe)((0, $1ZcO3.MasteriesQueryOrder).values, (0, $sjwE0.NonEmptyArray).map((value)=>{
                                    const OrderIcon = $40ad235304d280d1$var$orderIcon[value];
                                    return (0, $f243ee252323e221$export$f87cf8075df92fdf)(value, /*#__PURE__*/ (0, $ih19M.jsx)($40ad235304d280d1$var$IconLabel, {
                                        tooltip: t.masteries.filters.order[value],
                                        className: "w-6",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)(OrderIcon, {
                                            className: "w-5"
                                        })
                                    }));
                                }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        onMouseLeave: hideLevelsMenu,
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $05dbbe6f3a5f42f9$export$2bc6b1ab4f9a3f), {
                                eq: (0, $aapGO.ChampionLevel).Eq,
                                values: (0, $f5id0.pipe)((0, $aapGO.ChampionLevel).values, (0, $sjwE0.List).reverse, (0, $sjwE0.List).map((level)=>({
                                        key: level,
                                        value: level,
                                        icon: (isChecked)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $2e638aa5feeacb72$export$9ea228593aea6cc2), {
                                                level: level,
                                                className: (0, $jK7ok.cx)('h-full', [
                                                    'drop-shadow-[0_0_3px_black]',
                                                    isChecked
                                                ])
                                            }),
                                        label: t.masteries.filters.level(level)
                                    }))),
                                checked: masteriesQuery.level,
                                toggleChecked: toggleMasteryChecked,
                                isMenuVisible: levelsMenuIsVisible,
                                onMouseEnter: handleMasteriesMouseEnter,
                                tooltipPlacement: "top",
                                iconClassName: "px-0.5 pt-1.5 pb-1",
                                className: "relative z-30"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                                className: (0, $jK7ok.cx)('absolute z-20 flex w-full flex-col overflow-hidden rounded-b-md border-t border-black bg-zinc-700 shadow-even shadow-black', [
                                    'hidden',
                                    !levelsMenuIsVisible
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)(SelectLevelsButton, {
                                        levels: (0, $aapGO.ChampionLevel).values,
                                        children: t.masteries.filters.all
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(SelectLevelsButton, {
                                        levels: [
                                            0,
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9
                                        ],
                                        children: t.masteries.filters.nineAndLess
                                    }),
                                    (0, $f5id0.pipe)((0, $aapGO.ChampionLevel).values, (0, $sjwE0.List).reverse, (0, $sjwE0.List).map((level)=>/*#__PURE__*/ (0, $ih19M.jsx)(SelectLevelsButton, {
                                            levels: [
                                                level
                                            ],
                                            children: level === 10 ? t.masteries.filters.tenAndMore : t.common.number(level)
                                        }, level)))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $05dbbe6f3a5f42f9$export$2bc6b1ab4f9a3f), {
                        eq: (0, $vkIKL.ChampionFactionOrNone).Eq,
                        values: (0, $f5id0.pipe)((0, $vkIKL.ChampionFactionOrNone).values, (0, $sjwE0.List).map((faction)=>({
                                key: faction,
                                value: faction,
                                icon: (isChecked)=>faction === 'none' ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: (0, $jK7ok.cx)('flex w-6 justify-center', isChecked ? 'text-black' : 'text-wheat-bis'),
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.CircleOffOutline), {
                                            className: "w-4 -rotate-90"
                                        })
                                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $5830f7eb344f362f$export$1d957f0f68a69614), {
                                        faction: faction,
                                        className: (0, $jK7ok.cx)('size-6', isChecked ? 'text-black' : 'text-wheat-bis')
                                    }),
                                label: t.common.labels.factionOrNone[faction]
                            }))),
                        checked: masteriesQuery.faction,
                        toggleChecked: toggleFactionChecked,
                        tooltipPlacement: "top",
                        iconClassName: "px-1"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $05dbbe6f3a5f42f9$export$2bc6b1ab4f9a3f), {
                        eq: (0, $65UVg.ChampionPosition).Eq,
                        values: (0, $f5id0.pipe)((0, $65UVg.ChampionPosition).values, (0, $sjwE0.List).map((position)=>({
                                key: position,
                                value: position,
                                icon: (isChecked)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $2fef2422e6a814aa$export$12e8b9f23d53a496), {
                                        position: position,
                                        className: (0, $jK7ok.cx)('w-6', isChecked ? 'text-black' : 'text-wheat-bis')
                                    }),
                                label: t.common.labels.position[position]
                            }))),
                        checked: masteriesQuery.position,
                        toggleChecked: togglePositionChecked,
                        tooltipPlacement: "top",
                        iconClassName: "px-1.5"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $755ee31adc777f55$export$bb60b672622fdba0), {
                        searchCount: searchCount,
                        randomChampion: randomChampion,
                        initialSearch: masteriesQuery.search,
                        onChange: setQuerySearch
                    })
                ]
            })
        ]
    });
};
const $40ad235304d280d1$var$getSelectLevelsButton = (selectedLevels, setLevels)=>({ levels: levels, children: children })=>{
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const levelsSet = (0, $bh6RR.useMemo)(()=>new Set(levels), levels);
        const handleClick = (0, $bh6RR.useCallback)(()=>setLevels(levelsSet), [
            levelsSet
        ]);
        const isSelected = (0, $3JkJJ).getEq((0, $aapGO.ChampionLevel).Eq).equals(selectedLevels, levelsSet);
        return /*#__PURE__*/ (0, $ih19M.jsx)("li", {
            className: "group contents",
            children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                type: "button",
                onClick: handleClick,
                disabled: isSelected,
                className: (0, $jK7ok.cx)('flex items-center justify-between gap-1 py-1.5 pl-4 pr-2 text-left text-sm font-medium', isSelected ? 'bg-goldenrod-bis text-black' : 'hover:bg-black'),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "flex gap-0.5",
                        children: (0, $f5id0.pipe)(levelsSet, (0, $3JkJJ).toReadonlyArray((0, $12uqT).reverse((0, $aapGO.ChampionLevel).Ord)), (0, $sjwE0.List).map((level)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $2e638aa5feeacb72$export$9ea228593aea6cc2), {
                                level: level,
                                className: (0, $jK7ok.cx)('h-5', [
                                    'drop-shadow-[0_0_3px_black]',
                                    isSelected
                                ])
                            }, level)))
                    })
                ]
            })
        });
    };
const $40ad235304d280d1$var$TextLabel = ({ tooltip: tooltip, className: className, children: children })=>{
    const hoverRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                ref: hoverRef,
                className: (0, $jK7ok.cx)('flex h-6 w-10 items-center justify-center text-sm font-semibold', className),
                children: children
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: hoverRef,
                placement: "top",
                children: tooltip
            })
        ]
    });
};
const $40ad235304d280d1$var$IconLabel = ({ tooltip: tooltip, className: className, children: children })=>{
    const hoverRef = (0, $bh6RR.useRef)(null);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                ref: hoverRef,
                className: (0, $jK7ok.cx)('flex h-6 items-center justify-center gap-1.5 text-sm font-medium', className),
                children: children
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                hoverRef: hoverRef,
                placement: "top",
                children: tooltip
            })
        ]
    });
};
const $40ad235304d280d1$var$orderIcon = {
    asc: (0, $gwlG1.CaretUpOutline),
    desc: (0, $gwlG1.CaretDownOutline)
};



var $10ZIc = parcelRequire("10ZIc");
var $12uqT = parcelRequire("12uqT");
var $IYheM = parcelRequire("IYheM");
var $3JkJJ = parcelRequire("3JkJJ");

var $f5id0 = parcelRequire("f5id0");

var $vkIKL = parcelRequire("vkIKL");

var $aapGO = parcelRequire("aapGO");

var $65UVg = parcelRequire("65UVg");

var $25oLT = parcelRequire("25oLT");

var $iPRex = parcelRequire("iPRex");

var $sjwE0 = parcelRequire("sjwE0");


var $gUt5F = parcelRequire("gUt5F");


var $10ZIc = parcelRequire("10ZIc");
var $12uqT = parcelRequire("12uqT");
var $68YxT = parcelRequire("68YxT");

var $f5id0 = parcelRequire("f5id0");
parcelRequire("8SAMq");
var $gnzcc = parcelRequire("gnzcc");

var $dOJeV = parcelRequire("dOJeV");
const $6ae303e0b413d56a$var$byLevel = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((c)=>c.championLevel));
const $6ae303e0b413d56a$var$byTokens = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((c)=>c.tokensEarned));
const $6ae303e0b413d56a$var$byPercents = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((c)=>c.percents));
const $6ae303e0b413d56a$var$byPoints = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((c)=>c.championPoints));
const $6ae303e0b413d56a$var$byName = (0, $f5id0.pipe)((0, $68YxT).Ord, (0, $12uqT).contramap((c)=>(0, $dOJeV.StringUtils).cleanUTF8ToASCII(c.name)));
const $6ae303e0b413d56a$export$72b76efde5641ade = {
    Ord: {
        byLevel: $6ae303e0b413d56a$var$byLevel,
        byTokens: $6ae303e0b413d56a$var$byTokens,
        byPercents: $6ae303e0b413d56a$var$byPercents,
        byPoints: $6ae303e0b413d56a$var$byPoints,
        byName: $6ae303e0b413d56a$var$byName
    },
    Lens: {
        shardsCount: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('shardsCount'), (0, $gnzcc).some),
        glow: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('glow')),
        faction: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('faction')),
        isHidden: (0, $f5id0.pipe)((0, $gnzcc).id(), (0, $gnzcc).prop('isHidden'))
    }
};


const $00d38bb7a7fcc017$var$hideInsteadOfGlowViews = new Set([
    'histogram',
    'aram',
    'urf',
    'factions'
]);
const $00d38bb7a7fcc017$export$4f133c75954dbf19 = (t, challenges, masteries, query)=>{
    const hideInsteadOfGlow = (0, $sjwE0.Maybe).isSome(query.search) && (0, $3JkJJ).elem((0, $gUt5F.MasteriesQueryView).Eq)(query.view, $00d38bb7a7fcc017$var$hideInsteadOfGlowViews);
    const isHidden = $00d38bb7a7fcc017$var$getIsHidden({
        hideInsteadOfGlow: hideInsteadOfGlow
    });
    const filterPredicate = (0, $f5id0.pipe)($00d38bb7a7fcc017$var$levelFilterPredicate(query.level), (0, $IYheM).and($00d38bb7a7fcc017$var$factionFilterPredicate(query.faction)), (0, $IYheM).and($00d38bb7a7fcc017$var$positionFilterPredicate(query.position)));
    const ords = $00d38bb7a7fcc017$var$getSortBy(query.sort, query.order);
    const filteredMasteries = (0, $f5id0.pipe)(masteries, (0, $sjwE0.List).map((m)=>(0, $f5id0.pipe)(m, filterPredicate(m) ? (0, $f5id0.identity) : (0, $6ae303e0b413d56a$export$72b76efde5641ade).Lens.isHidden.set(true))));
    return {
        filteredAndSortedMasteries: (0, $f5id0.pipe)(filteredMasteries, $00d38bb7a7fcc017$var$getSort(t, challenges, isHidden, query.view)(ords)),
        championsCount: (0, $f5id0.pipe)(filteredMasteries, (0, $sjwE0.List).filter((c)=>!c.isHidden), (0, $sjwE0.List).size),
        factionsCount: (0, $f5id0.pipe)(filteredMasteries, (0, $iPRex.ListUtils).multipleGroupBy((c)=>(0, $sjwE0.List).isNonEmpty(c.factions) ? c.factions : [
                'none'
            ]), (0, $sjwE0.PartialDict).map((nea)=>({
                count: nea.filter((c)=>!c.isHidden).length,
                total: nea.length
            }))),
        searchCount: (0, $f5id0.pipe)(filteredMasteries, (0, $sjwE0.List).filter((c)=>c.glow), (0, $sjwE0.List).size),
        maybeMaxPoints: (0, $f5id0.pipe)(filteredMasteries, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $f5id0.flow)((0, $sjwE0.NonEmptyArray).map((c)=>// `championPointsUntilNextLevel` can be negative
            Math.max(c.championPoints + c.championPointsUntilNextLevel, c.championPoints)), (0, $sjwE0.NonEmptyArray).max((0, $10ZIc).Ord)))),
        hideInsteadOfGlow: hideInsteadOfGlow,
        isHidden: isHidden
    };
};
const $00d38bb7a7fcc017$var$getSort = (t, challenges, isHidden, view)=>{
    switch(view){
        case 'compact':
        case 'histogram':
            return (0, $sjwE0.List).sortBy;
        case 'aram':
            return $00d38bb7a7fcc017$var$sortMapChanges(isHidden, (c)=>c.aram.category);
        case 'urf':
            return $00d38bb7a7fcc017$var$sortMapChanges(isHidden, (c)=>c.urf.category);
        case 'factions':
            return $00d38bb7a7fcc017$var$sortFactions(t, challenges, isHidden);
    }
};
const $00d38bb7a7fcc017$var$sortMapChanges = (isHidden, getCategory)=>(ords)=>(as)=>{
            const grouped = (0, $f5id0.pipe)(as, (0, $sjwE0.List).groupBy((c)=>isHidden(c) ? 'hidden' : getCategory(c)));
            return (0, $f5id0.pipe)((0, $7432f0671d5622f7$export$dc50577efab52c43).values, (0, $sjwE0.List).reduce((0, $sjwE0.List).empty(), (acc, category)=>(0, $f5id0.pipe)(acc, (0, $sjwE0.List).concat((0, $f5id0.pipe)(grouped[category] ?? [], (0, $sjwE0.List).sortBy(ords))))), (0, $sjwE0.List).concat(grouped.hidden ?? []));
        };
const $00d38bb7a7fcc017$var$sortFactions = (t, challenges, isHidden)=>(ords)=>(as)=>{
            const grouped = (0, $f5id0.pipe)(as, (0, $iPRex.ListUtils).multipleGroupBy((c)=>{
                if (isHidden(c)) return [
                    'hidden'
                ];
                if ((0, $sjwE0.List).isNonEmpty(c.factions)) return c.factions;
                return [
                    'none'
                ];
            }), (0, $sjwE0.PartialDict).mapWithIndex((faction, champions)=>(0, $f5id0.pipe)(champions, (0, $sjwE0.NonEmptyArray).map((c)=>(0, $f5id0.pipe)(c, (0, $6ae303e0b413d56a$export$72b76efde5641ade).Lens.faction.set(faction === 'hidden' ? (0, $25oLT.StaticDataChampion).getFaction(c.factions) : faction))))));
            return (0, $f5id0.pipe)((0, $vkIKL.ChampionFactionOrNone).valuesSortBy($00d38bb7a7fcc017$var$factionSortBy(t, challenges)), (0, $sjwE0.List).reduce((0, $sjwE0.List).empty(), (acc, faction)=>(0, $f5id0.pipe)(acc, (0, $sjwE0.List).concat((0, $f5id0.pipe)(grouped[faction] ?? [], (0, $sjwE0.List).sortBy(ords))))), (0, $sjwE0.List).concat(grouped.hidden ?? []));
        };
const $00d38bb7a7fcc017$var$factionSortBy = (t, { data: challenges })=>{
    const byLabel = (0, $fdf08e5d15d06772$export$6a3aa170c29c42fa).Ord.byLabel(t);
    if (challenges === undefined) return [
        byLabel
    ];
    const byChallengeValue = (0, $f5id0.pipe)((0, $10ZIc).Ord, (0, $12uqT).contramap((f)=>(0, $f5id0.pipe)(challenges[f], (0, $sjwE0.Maybe).fold(()=>0, (c)=>c.value))), (0, $12uqT).reverse);
    return [
        byChallengeValue,
        byLabel
    ];
};
const $00d38bb7a7fcc017$var$getIsHidden = ({ hideInsteadOfGlow: hideInsteadOfGlow })=>(c)=>c.isHidden || hideInsteadOfGlow && !c.glow;
const $00d38bb7a7fcc017$var$getSortBy = (sort, order)=>{
    switch(sort){
        case 'level':
            return [
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byLevel),
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byTokens),
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byPoints),
                (0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byName
            ];
        case 'percents':
            return [
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byPercents),
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byPoints),
                (0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byName
            ];
        case 'points':
            return [
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byPoints),
                (0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byName
            ];
        case 'name':
            return [
                reverseIfDesc((0, $6ae303e0b413d56a$export$72b76efde5641ade).Ord.byName)
            ];
    }
    function reverseIfDesc(o) {
        switch(order){
            case 'asc':
                return o;
            case 'desc':
                return (0, $12uqT).reverse(o);
        }
    }
};
const $00d38bb7a7fcc017$var$levelFilterPredicate = (levels)=>(c)=>// always keep if all levels are selected
        (0, $3JkJJ).size(levels) === (0, $aapGO.ChampionLevel).values.length || // convert to 10 if 10+
        (0, $3JkJJ).elem((0, $aapGO.ChampionLevel).Eq)((0, $aapGO.ChampionLevel).fromNumber(c.championLevel), levels);
const $00d38bb7a7fcc017$var$factionFilterPredicate = (factions)=>(c)=>(0, $3JkJJ).size(factions) === (0, $vkIKL.ChampionFactionOrNone).values.length || ((0, $sjwE0.List).isNonEmpty(c.factions) ? (0, $f5id0.pipe)(c.factions, (0, $sjwE0.List).some((faction)=>(0, $3JkJJ).elem((0, $vkIKL.ChampionFactionOrNone).Eq)(faction, factions))) : (0, $3JkJJ).elem((0, $vkIKL.ChampionFactionOrNone).Eq)('none', factions));
const $00d38bb7a7fcc017$var$positionFilterPredicate = (positions)=>(c)=>(0, $3JkJJ).size(positions) === (0, $65UVg.ChampionPosition).values.length || (0, $f5id0.pipe)(c.positions, (0, $sjwE0.List).some((position)=>(0, $3JkJJ).elem((0, $65UVg.ChampionPosition).Eq)(position, positions)));


const { round: $61a1acdfec0829fc$var$round } = (0, $6nJ5H.NumberUtils);
const $61a1acdfec0829fc$export$f62f504f0a1af108 = ({ challenges: challenges, masteries: masteries, setChampionShards: setChampionShards })=>{
    const { masteriesQuery: masteriesQuery, updateMasteriesQuery: updateMasteriesQuery } = (0, $9xM77.useHistory)();
    const { t: t } = (0, $4MEuc.useTranslation)('common');
    const { champions: champions } = (0, $6H0K7.useStaticData)();
    const { filteredAndSortedMasteries: filteredAndSortedMasteries, championsCount: championsCount, factionsCount: factionsCount, searchCount: searchCount, maybeMaxPoints: maybeMaxPoints, hideInsteadOfGlow: hideInsteadOfGlow, isHidden: isHidden } = (0, $bh6RR.useMemo)(()=>(0, $00d38bb7a7fcc017$export$4f133c75954dbf19)(t, challenges, masteries, masteriesQuery), [
        challenges,
        masteries,
        masteriesQuery,
        t
    ]);
    const randomChampion = (0, $bh6RR.useMemo)(()=>(0, $f5id0.pipe)(filteredAndSortedMasteries, (0, $sjwE0.List).filter((m)=>!m.isHidden), (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $f5id0.flow)((0, $2566e9e25df745a4$exports).randomElem, (0, $4lr6f).map((m)=>{
            updateMasteriesQuery((0, $kiCtw.MasteriesQuery).Lens.search.set((0, $sjwE0.Maybe).some(m.name)));
            return m.name;
        })))), [
        filteredAndSortedMasteries,
        updateMasteriesQuery
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $40ad235304d280d1$export$a81e88d11f746f25), {
                searchCount: searchCount,
                randomChampion: randomChampion
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: (0, $jK7ok.cx)('w-full', $61a1acdfec0829fc$var$viewContainerClassName[masteriesQuery.view]),
                children: (0, $f5id0.pipe)(filteredAndSortedMasteries, (0, $iPRex.ListUtils).mapWithPrevious((maybePrev, champion)=>/*#__PURE__*/ (0, $ih19M.jsx)($61a1acdfec0829fc$var$Champion, {
                        challenges: challenges,
                        factionsCount: factionsCount,
                        maybeMaxPoints: maybeMaxPoints,
                        isGlowing: !hideInsteadOfGlow && champion.glow,
                        isHidden: isHidden(champion),
                        maybePrev: maybePrev,
                        champion: champion,
                        setChampionShards: setChampionShards
                    }, `${champion.faction}${(0, $br0yu.ChampionKey).unwrap(champion.championId)}`)))
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "self-center text-sm",
                children: t.nChampionsFraction(championsCount, champions.length)
            })
        ]
    });
};
const $61a1acdfec0829fc$var$mapChangesClassName = 'grid grid-cols-[repeat(auto-fit,0.625rem)] items-start gap-x-4 gap-y-1';
const $61a1acdfec0829fc$var$viewContainerClassName = {
    compact: 'grid max-w-416 grid-cols-[repeat(auto-fit,4rem)] items-start gap-4',
    histogram: 'grid max-w-7xl grid-cols-[auto_1fr] gap-y-2',
    aram: $61a1acdfec0829fc$var$mapChangesClassName,
    urf: $61a1acdfec0829fc$var$mapChangesClassName,
    factions: 'grid max-w-416 grid-cols-[repeat(auto-fit,4rem)] items-start gap-4'
};
const $61a1acdfec0829fc$var$Champion = ({ challenges: challenges, factionsCount: factionsCount, maybeMaxPoints: maybeMaxPoints, isGlowing: isGlowing, isHidden: isHidden, maybePrev: maybePrev, champion: champion, setChampionShards: setChampionShards })=>{
    const { masteriesQuery: { view: view } } = (0, $9xM77.useHistory)();
    const containerRef = (0, $bh6RR.useRef)(null);
    const isHistogram = view === 'histogram';
    const isFactions = view === 'factions';
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            (0, $gUt5F.MasteriesQueryView).isBalance(view) && !isHidden && !(0, $f5id0.pipe)(maybePrev, (0, $sjwE0.Maybe).exists((prev)=>(0, $7432f0671d5622f7$export$dc50577efab52c43).Eq.equals(prev[view].category, champion[view].category))) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $0928d021cbbf7cbd$export$13c8a39fad75a36b), {
                category: champion[view].category,
                className: (0, $jK7ok.cx)([
                    'pt-4',
                    (0, $sjwE0.Maybe).isSome(maybePrev)
                ])
            }) : null,
            isFactions && !isHidden && !(0, $f5id0.pipe)(maybePrev, (0, $sjwE0.Maybe).exists((prev)=>(0, $vkIKL.ChampionFactionOrNone).Eq.equals(prev.faction, champion.faction))) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $f556a3f1cb290003$export$2978b4beac7a3c02), {
                challenges: (0, $sjwE0.Maybe).some(challenges),
                faction: champion.faction,
                count: factionsCount[champion.faction] ?? (0, $873f54152d46e5ce$export$1b9130a9fda2eb88).empty,
                className: (0, $jK7ok.cx)([
                    'pt-2',
                    (0, $sjwE0.Maybe).isSome(maybePrev)
                ])
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                ref: containerRef,
                className: (0, $jK7ok.cx)('relative', $61a1acdfec0829fc$var$colSpanClassName(view, champion), {
                    hidden: isHidden
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($61a1acdfec0829fc$var$Glow, {
                        isGlowing: isGlowing
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: (0, $485b132d5e168e49$export$8feb69f2a1cfb779),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3e823b497f8a8756$export$f46140fe718f016b), {
                                championId: champion.championId,
                                masteries: {
                                    tokensEarned: champion.tokensEarned,
                                    markRequiredForNextLevel: champion.markRequiredForNextLevel,
                                    championLevel: champion.championLevel,
                                    championPoints: champion.championPoints,
                                    championPointsSinceLastLevel: champion.championPointsSinceLastLevel,
                                    championPointsUntilNextLevel: champion.championPointsUntilNextLevel,
                                    percents: champion.percents
                                },
                                name: champion.name,
                                shardsCount: champion.shardsCount,
                                positions: champion.positions,
                                factions: champion.factions,
                                setChampionShards: setChampionShards,
                                isHistogram: isHistogram,
                                tooltipPlacementRef: containerRef,
                                tooltipPlacement: "top",
                                centerLevel: false
                            }),
                            (0, $gUt5F.MasteriesQueryView).isBalance(view) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $485b132d5e168e49$export$60aa91691c7ccf90), {
                                tooltiPlacementRef: containerRef,
                                wrapAfterSize: 15,
                                data: champion[view].data
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($61a1acdfec0829fc$var$ChampionMasteryHistogram, {
                maybeMaxPoints: maybeMaxPoints,
                champion: champion,
                className: (0, $jK7ok.cx)([
                    'hidden',
                    !isHistogram || isHidden
                ])
            })
        ]
    });
};
const $61a1acdfec0829fc$var$balancedClassName = 'col-span-3';
const $61a1acdfec0829fc$var$unbalancedClassName = 'col-span-5';
function $61a1acdfec0829fc$var$colSpanClassName(view, champion) {
    if ((0, $gUt5F.MasteriesQueryView).isBalance(view)) return champion[view].category === 'balanced' ? $61a1acdfec0829fc$var$balancedClassName : $61a1acdfec0829fc$var$unbalancedClassName;
    return undefined;
}
const $61a1acdfec0829fc$var$Glow = ({ isGlowing: isGlowing })=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: isGlowing ? 'absolute -left-1.75 -top-1.75 grid size-19.5 place-items-center overflow-hidden rounded-1/2' : 'hidden',
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "col-start-1 row-start-1 size-full animate-my-spin-reverse rounded-1/2 border-2 border-dashed border-white"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "col-start-1 row-start-1 size-[calc(100%_-_.25rem)] animate-my-spin rounded-1/2 border-2 border-dashed border-goldenrod"
            })
        ]
    });
const $61a1acdfec0829fc$var$ChampionMasteryHistogram = ({ maybeMaxPoints: maybeMaxPoints, champion: { championLevel: championLevel, championPoints: championPoints, championPointsSinceLastLevel: championPointsSinceLastLevel, championPointsUntilNextLevel: championPointsUntilNextLevel }, className: className })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const hoverRef1 = (0, $bh6RR.useRef)(null);
    const hoverRef2 = (0, $bh6RR.useRef)(null);
    const hoverRef3 = (0, $bh6RR.useRef)(null);
    const placementRef = (0, $bh6RR.useRef)(null);
    const pointsUntilAndSince = (0, $f5id0.pipe)([
        2 <= championLevel ? (0, $sjwE0.Maybe).some(t.masteries.pointsSinceLastLevel(championPointsSinceLastLevel, championLevel)) : (0, $sjwE0.Maybe).none,
        (0, $sjwE0.Maybe).some(t.masteries.pointsUntilNextLevel(championPointsUntilNextLevel, championLevel + 1))
    ], (0, $sjwE0.List).compact, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $sjwE0.List).mkString(" \u2014 ")));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('flex flex-col', className),
                children: [
                    (0, $f5id0.pipe)(maybeMaxPoints, (0, $sjwE0.Maybe).fold(()=>null, (maxPoints)=>{
                        function p(n) {
                            return `${$61a1acdfec0829fc$var$round(100 * n / maxPoints, 2)}%`;
                        }
                        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "relative h-7",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    ref: hoverRef2,
                                    className: (0, $jK7ok.cx)('absolute left-0 top-0 h-full', (0, $c3c80580245b1da4$export$ba5db2e5993f4709)(championLevel)),
                                    style: {
                                        width: p(championPoints)
                                    }
                                }),
                                0 < championPointsUntilNextLevel ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    ref: hoverRef1,
                                    className: "absolute top-0 h-full bg-histogram-grey/50",
                                    style: {
                                        width: p(championPointsUntilNextLevel),
                                        left: p(championPoints)
                                    }
                                }) : null,
                                2 <= championLevel ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    ref: hoverRef3,
                                    className: (0, $jK7ok.cx)('absolute top-0 h-full border-l', championPointsUntilNextLevel <= 0 ? 'border-x' : 'border-l', (0, $c3c80580245b1da4$export$9842f088a6739769)(championLevel)),
                                    style: {
                                        width: p(championPointsSinceLastLevel + championPointsUntilNextLevel),
                                        left: p(championPoints - championPointsSinceLastLevel)
                                    }
                                }) : null
                            ]
                        });
                    })),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            ref: placementRef,
                            className: (0, $jK7ok.cx)('pl-1.5 pt-1 font-semibold', (0, $c3c80580245b1da4$export$5d6f9a79aaea5f31)(championLevel)),
                            children: t.common.number(championPoints)
                        })
                    })
                ]
            }),
            (0, $f5id0.pipe)(pointsUntilAndSince, (0, $sjwE0.Maybe).fold(()=>null, (tooltip)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                    hoverRef: [
                        placementRef,
                        hoverRef1,
                        hoverRef2,
                        hoverRef3
                    ],
                    placement: "bottom-start",
                    children: tooltip
                })))
        ]
    });
};



var $ih19M = parcelRequire("ih19M");

var $f5id0 = parcelRequire("f5id0");

var $bh6RR = parcelRequire("bh6RR");

var $kXnAC = parcelRequire("kXnAC");

var $1GV7y = parcelRequire("1GV7y");

var $aapGO = parcelRequire("aapGO");


var $4o3f8 = parcelRequire("4o3f8");

var $fp7Nf = parcelRequire("fp7Nf");

var $ixYJp = parcelRequire("ixYJp");

var $fC0sb = parcelRequire("fC0sb");

var $6nJ5H = parcelRequire("6nJ5H");

var $sjwE0 = parcelRequire("sjwE0");



var $es0HS = parcelRequire("es0HS");

var $6H0K7 = parcelRequire("6H0K7");

var $4MEuc = parcelRequire("4MEuc");

var $jFynM = parcelRequire("jFynM");

var $gwlG1 = parcelRequire("gwlG1");

var $chVfZ = parcelRequire("chVfZ");


var $jK7ok = parcelRequire("jK7ok");
const { round: $b8cd6d1bb7a04112$var$round } = (0, $6nJ5H.NumberUtils);
const $b8cd6d1bb7a04112$export$7eec06b052b876ef = ({ platform: platform, summoner: { riotId: riotId, name: maybeName, profileIconId: profileIconId, summonerLevel: summonerLevel, questPercents: questPercents, totalMasteryLevel: totalMasteryLevel, totalMasteryPoints: totalMasteryPoints, otpIndex: otpIndex, masteriesCount: masteriesCount }, leagues: leagues, masteries: masteries })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const staticData = (0, $6H0K7.useStaticData)();
    const nameRef = (0, $bh6RR.useRef)(null);
    const levelRef = (0, $bh6RR.useRef)(null);
    const masteriesRef = (0, $bh6RR.useRef)(null);
    const infoRef = (0, $bh6RR.useRef)(null);
    const MasteryImgWithCount = (0, $bh6RR.useMemo)(()=>$b8cd6d1bb7a04112$var$getMasteryImgWithCount(t.common, masteriesCount), [
        masteriesCount,
        t
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "relative flex w-full max-w-7xl flex-wrap items-center justify-between gap-6",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-wrap gap-4",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: staticData.assets.summonerIcon(profileIconId),
                        alt: t.common.summonerIconAlt((0, $fp7Nf.RiotId).stringify(riotId)),
                        className: "size-24 rounded border border-goldenrod-bis"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "grid grid-rows-[1fr_auto]",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex flex-wrap items-baseline gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        ref: nameRef,
                                        className: "flex items-baseline gap-0.5 whitespace-pre",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-xl font-bold text-goldenrod",
                                                children: (0, $4o3f8.GameName).unwrap(riotId.gameName)
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                className: "text-lg text-grey-500",
                                                children: [
                                                    "#",
                                                    (0, $fC0sb.TagLine).unwrap(riotId.tagLine)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                                        hoverRef: nameRef,
                                        className: "flex flex-col items-center",
                                        children: [
                                            (0, $f5id0.pipe)(maybeName, (0, $sjwE0.Maybe).fold(()=>null, (name)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                    className: "flex items-baseline gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                            children: t.common.oldSummonerName
                                                        }),
                                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                            className: "whitespace-pre text-lg font-bold text-goldenrod",
                                                            children: (0, $ixYJp.SummonerName).unwrap(name)
                                                        })
                                                    ]
                                                }))),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-grey-500",
                                                children: t.summoner.masteriesCache.lastUpdate((0, $kXnAC.DayJs).unwrap(masteries.insertedAt).toDate())
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-grey-500",
                                                children: t.summoner.masteriesCache.duration($b8cd6d1bb7a04112$var$prettyMs(masteries.cacheDuration))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "text-grey-400",
                                        children: "\u2014"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        ref: levelRef,
                                        children: t.common.level(summonerLevel, 'font-semibold')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                        hoverRef: levelRef,
                                        placement: "right",
                                        children: t.common.summonerLevel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "flex flex-wrap gap-6",
                                children: (0, $4cb553f311fc5825$export$34d6dd1c63e72828).keys.map((queue)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6b812bf4602a0de7$export$9fc0e0d0ecb98c84), {
                                        queue: queue,
                                        league: leagues[queue]
                                    }, queue))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-col items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        ref: masteriesRef,
                        className: "flex items-end gap-3 pb-1",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                level: 10,
                                imgClassName: "!w-20"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                level: 9,
                                imgClassName: "!w-20 -mt-0.5",
                                className: "-mb-1"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                level: 8,
                                imgClassName: "!w-20 -mt-0.5",
                                className: "-mb-1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $es0HS.Tooltip), {
                        hoverRef: masteriesRef,
                        className: "flex flex-col items-center gap-2 px-5 pb-4 pt-3",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex items-end justify-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 7
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 6
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 5,
                                        imgClassName: "-mt-1",
                                        className: "-mx-0.5"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 4,
                                        imgClassName: "-mt-1",
                                        className: "-mx-1"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 3,
                                        imgClassName: "-mt-1.5",
                                        className: "-mx-1.5"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 2,
                                        imgClassName: "-mt-1.5",
                                        className: "-mx-2"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 1,
                                        imgClassName: "-mt-2",
                                        className: "-mx-2.5"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)(MasteryImgWithCount, {
                                        level: 0,
                                        imgClassName: "-mt-2",
                                        className: "-mx-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "grid grid-cols-[auto_auto] gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "justify-self-end",
                                        children: t.summoner.masteryScore
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "font-semibold",
                                        children: t.common.number(totalMasteryLevel)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "mt-1 justify-self-end",
                                        children: t.summoner.masteryPoints
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "mt-1 font-semibold",
                                        children: (0, $chVfZ.TranslationUtils).numberUnit(t.common)(totalMasteryPoints)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "mt-1 justify-self-end",
                                        children: t.summoner.otpIndex
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "mt-1 font-semibold",
                                        children: t.common.number(otpIndex)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "col-span-2 whitespace-pre-wrap text-center text-xs italic opacity-70",
                                        children: t.summoner.otpIndexExplanation
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                children: t.summoner.percentsProgression($b8cd6d1bb7a04112$var$round(questPercents, 2), 'font-semibold')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                ref: infoRef,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.InformationCircleOutline), {
                                    className: "h-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $es0HS.Tooltip), {
                                hoverRef: infoRef,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                    className: "list-disc pl-3 leading-6",
                                    children: t.summoner.masteriesExplanation
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "grid justify-items-end gap-1.5 self-start",
                children: Object.entries($b8cd6d1bb7a04112$var$otherThirdPartySites).map(([key, [icon, href]])=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "grid grid-cols-[auto,auto] items-center gap-1 self-center text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                href: href(platform, riotId),
                                target: "_blank",
                                rel: "noreferrer",
                                className: "peer border-b border-b-wheat/50 leading-none transition-all duration-100 hover:border-b-goldenrod",
                                children: key
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: icon,
                                className: "size-3.5 transition-[visibility,opacity] duration-100 area-[1/2] peer-hover:invisible peer-hover:opacity-0"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gwlG1.OpenInNew), {
                                className: "invisible size-3.5 opacity-0 transition-[visibility,opacity] duration-100 area-[1/2] peer-hover:visible peer-hover:opacity-100"
                            })
                        ]
                    }, key))
            })
        ]
    });
};
// TODO: platform
const $b8cd6d1bb7a04112$var$otherThirdPartySites = {
    'op.gg': [
        (0, $jFynM.Assets).thirdParty.opGg,
        (platform, riotId)=>`https://op.gg/lol/summoners/${$b8cd6d1bb7a04112$var$pr(platform, riotId)}`
    ],
    LeagueOfGraphs: [
        (0, $jFynM.Assets).thirdParty.leagueOfGraphs,
        (platform, riotId)=>`https://www.leagueofgraphs.com/summoner/${$b8cd6d1bb7a04112$var$pr(platform, riotId)}`
    ],
    'DPM.LOL': [
        (0, $jFynM.Assets).thirdParty.dpmLol,
        (_, riotId)=>`https://dpm.lol/${$b8cd6d1bb7a04112$var$r(riotId)}`
    ],
    'YearIn.LoL': [
        (0, $jFynM.Assets).thirdParty.yearInLol,
        (_, riotId)=>`https://yearin.lol/profile/${$b8cd6d1bb7a04112$var$r(riotId)}`
    ]
};
function $b8cd6d1bb7a04112$var$pr(platform, riotId) {
    return `${platform.toLowerCase()}/${$b8cd6d1bb7a04112$var$r(riotId)}`;
}
function $b8cd6d1bb7a04112$var$r(riotId) {
    return `${riotId.gameName}-${riotId.tagLine}`;
}
const $b8cd6d1bb7a04112$var$getMasteryImgWithCount = (t, masteriesCount)=>({ level: level, imgClassName: imgClassName, className: className })=>{
        const count = masteriesCount[(0, $aapGO.ChampionLevel).stringify(level)];
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: (0, $jK7ok.cx)('flex flex-col items-center', className),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: (0, $jK7ok.cx)('text-sm font-semibold', (0, $c3c80580245b1da4$export$5d6f9a79aaea5f31)(level)),
                    children: t.number(count ?? -1)
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $2e638aa5feeacb72$export$9ea228593aea6cc2), {
                    level: level,
                    className: (0, $jK7ok.cx)('w-13.5', imgClassName)
                })
            ]
        });
    };
function $b8cd6d1bb7a04112$var$prettyMs(ms) {
    const date = (0, $kXnAC.DayJs).of((0, $1GV7y.MsDuration).unwrap(ms));
    const zero = (0, $kXnAC.DayJs).of(0);
    const m = (0, $f5id0.pipe)(date, (0, $kXnAC.DayJs).diff(zero, 'minutes'));
    const s = (0, $kXnAC.DayJs).second.get(date) / 60;
    return m + s;
}



var $3WFZ7 = parcelRequire("3WFZ7");

var $k8rBo = parcelRequire("k8rBo");

var $8i6VY = parcelRequire("8i6VY");

var $c6xfg = parcelRequire("c6xfg");

var $9xM77 = parcelRequire("9xM77");

var $7VlB6 = parcelRequire("7VlB6");

var $2sln7 = parcelRequire("2sln7");
const $f96ed99dce29a6dd$export$af1539e67ee344d = (platform, puuid)=>{
    const { masteriesQuery: masteriesQuery } = (0, $9xM77.useHistory)();
    return (0, $3WFZ7.default)([
        ...(0, $k8rBo.apiRoutes).summoner.byPuuid(platform)(puuid).challenges.get,
        $f96ed99dce29a6dd$var$getShouldFetchChallenges(masteriesQuery.view)
    ], ([url, method, shouldFetchChallenges])=>shouldFetchChallenges ? (0, $7VlB6.futureRunUnsafe)((0, $2sln7.http)([
            url,
            method
        ], {}, [
            (0, $8i6VY.ChallengesView).codec,
            'ChallengesView'
        ])) : Promise.reject(Error('Challenges should not be used for this view')), {
        revalidateIfStale: !(0, $c6xfg.config).isDev,
        revalidateOnFocus: !(0, $c6xfg.config).isDev,
        revalidateOnReconnect: !(0, $c6xfg.config).isDev
    });
};
const $f96ed99dce29a6dd$var$getShouldFetchChallenges = (view)=>view === 'factions';



var $f5id0 = parcelRequire("f5id0");

var $3WFZ7 = parcelRequire("3WFZ7");

var $k8rBo = parcelRequire("k8rBo");


var $sjwE0 = parcelRequire("sjwE0");

var $c6xfg = parcelRequire("c6xfg");

var $9xM77 = parcelRequire("9xM77");

var $7VlB6 = parcelRequire("7VlB6");

var $2sln7 = parcelRequire("2sln7");
const $e4dfdddf65a2a3b1$export$6952cc2a2c7ff335 = (platform, riotId)=>{
    const { historyStateRef: historyStateRef, modifyHistoryStateRef: modifyHistoryStateRef } = (0, $9xM77.useHistory)();
    return (0, $3WFZ7.default)((0, $k8rBo.apiRoutes).summoner.byRiotId(platform)(riotId).masteries.get, ([url, method])=>(0, $f5id0.pipe)(historyStateRef.current.masteries, (0, $sjwE0.Maybe).fold(()=>(0, $2sln7.http)([
                url,
                method
            ], {}, [
                (0, $d7d93897afbab07d$export$295b25f3552f2c84).codec,
                'SummonerMasteriesView'
            ]), (0, $f5id0.flow)((0, $sjwE0.Future).successful, (0, $sjwE0.Future).chainFirstIOK(()=>()=>modifyHistoryStateRef((0, $9xM77.HistoryState).Lens.masteries.set((0, $sjwE0.Maybe).none))))), (0, $7VlB6.futureRunUnsafe)), {
        revalidateIfStale: !(0, $c6xfg.config).isDev,
        revalidateOnFocus: !(0, $c6xfg.config).isDev,
        revalidateOnReconnect: !(0, $c6xfg.config).isDev
    });
};


const { cleanChampionName: $138d91d6e72410c5$var$cleanChampionName } = (0, $dOJeV.StringUtils);
const $138d91d6e72410c5$var$shardsDebounceWait = (0, $1GV7y.MsDuration).second(1);
const $138d91d6e72410c5$export$f5c7402fca0d82db = ({ platform: platform, riotId: riotId })=>{
    const { t: t } = (0, $4MEuc.useTranslation)();
    const { showToaster: showToaster } = (0, $31rfl.useToaster)();
    const { maybeUser: maybeUser } = (0, $j30iL.useUser)();
    const { data: data, error: error, mutate: mutate } = (0, $e4dfdddf65a2a3b1$export$6952cc2a2c7ff335)(platform, riotId);
    // Remove shards on user disconnect
    const previousUser = (0, $258c1e51a9d18326$export$5cae361ad82dce8b)(maybeUser);
    (0, $bh6RR.useEffect)(()=>{
        if (data !== undefined && (0, $sjwE0.Maybe).isNone(maybeUser) && (0, $sjwE0.Maybe).isSome((0, $sjwE0.Maybe).flatten(previousUser))) mutate({
            ...data,
            championShards: (0, $sjwE0.Maybe).none
        }, {
            revalidate: false
        });
    }, [
        data,
        maybeUser,
        mutate,
        previousUser
    ]);
    const [shardsIsLoading, setShardsIsLoading] = (0, $bh6RR.useState)(false);
    const debouncedSetChampionsShardsBulk = (0, $bh6RR.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3a60d30aee96367f$exports)))((platform_, puuid, updates, optimisticMutation, oldData, newData)=>{
            setShardsIsLoading(true);
            return (0, $f5id0.pipe)((0, $g7UIk.apiUserSelfSummonerChampionsShardsCountPost)(platform_, puuid, updates), (0, $sjwE0.Future).map(()=>{
                if (!optimisticMutation) mutate(newData, {
                    revalidate: false
                });
                showToaster('success', t.masteries.updateShardsSucces);
                return 0, $sjwE0.NotUsed;
            }), (0, $sjwE0.Future).orElse((e)=>{
                if (optimisticMutation) mutate(oldData, {
                    revalidate: false
                });
                console.error(e);
                showToaster('error', t.masteries.updateShardsError);
                return (0, $sjwE0.Future).notUsed;
            }), (0, $6omhk).chainFirstIOK(()=>()=>setShardsIsLoading(false)), (0, $7VlB6.futureRunUnsafe));
        }, (0, $1GV7y.MsDuration).unwrap($138d91d6e72410c5$var$shardsDebounceWait)), [
        mutate,
        showToaster,
        t
    ]);
    const setChampionsShardsBulk = (0, $bh6RR.useCallback)((updates, { optimisticMutation: optimisticMutation })=>{
        if (data === undefined || (0, $sjwE0.Maybe).isNone(data.championShards)) return;
        const newData = (0, $f5id0.pipe)((0, $d7d93897afbab07d$export$295b25f3552f2c84).Lens.championShards, (0, $asc1N).modify((championsShards)=>(0, $f5id0.pipe)(updates, (0, $sjwE0.NonEmptyArray).reduce(championsShards, (acc, { championId: championId, shardsCount: shardsCount })=>(0, $f5id0.pipe)(acc, (0, $iPRex.ListUtils).updateOrAppend((0, $cd69e178fde0199b$export$c8017683694e0c17).Eq.byChampion)({
                    champion: championId,
                    count: shardsCount
                }))))))(data);
        if (optimisticMutation) mutate(newData, {
            revalidate: false
        });
        debouncedSetChampionsShardsBulk(platform, data.summoner.puuid, updates, optimisticMutation, data, newData);
    }, [
        data,
        debouncedSetChampionsShardsBulk,
        mutate,
        platform
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $tA0jd.MainLayout), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9g4gL.AsyncRenderer), {
            data: data,
            error: error,
            children: ({ summoner: summoner, leagues: leagues, masteries: masteries, championShards: championShards })=>/*#__PURE__*/ (0, $ih19M.jsx)($138d91d6e72410c5$var$SummonerViewComponent, {
                    platform: platform,
                    summoner: summoner,
                    leagues: leagues,
                    masteries: masteries,
                    championShards: championShards,
                    shardsIsLoading: shardsIsLoading,
                    setChampionsShardsBulk: setChampionsShardsBulk
                })
        })
    });
};
const $138d91d6e72410c5$var$SummonerViewComponent = ({ platform: platform, summoner: summoner, leagues: leagues, masteries: masteries, championShards: championShards, shardsIsLoading: shardsIsLoading, setChampionsShardsBulk: setChampionsShardsBulk })=>{
    const { masteriesQuery: masteriesQuery } = (0, $9xM77.useHistory)();
    const { champions: champions } = (0, $6H0K7.useStaticData)();
    const challenges = (0, $f96ed99dce29a6dd$export$af1539e67ee344d)(platform, summoner.puuid);
    (0, $9e1e0464b0af5656$export$f96ad7bfa050ed2)((0, $bh6RR.useMemo)(()=>({
            platform: platform,
            ...summoner
        }), [
        platform,
        summoner
    ]), (0, $gE3ky.appRoutes).platformRiotId(platform, summoner.riotId, (0, $kiCtw.MasteriesQuery).toPartial(masteriesQuery)));
    const { enrichedSummoner: enrichedSummoner, enrichedMasteries: enrichedMasteries } = (0, $bh6RR.useMemo)(()=>$138d91d6e72410c5$var$enrichAll(masteries.champions, championShards, masteriesQuery.search, champions), [
        championShards,
        champions,
        masteries.champions,
        masteriesQuery.search
    ]);
    const [uiIsBlocked, setUiIsBlocked] = (0, $bh6RR.useState)(true);
    (0, $bh6RR.useEffect)(()=>{
        setUiIsBlocked(false);
    }, []);
    const setChampionShards = (0, $bh6RR.useMemo)(()=>({
            isLoading: shardsIsLoading,
            run: (championKey)=>(shardsCount)=>setChampionsShardsBulk([
                        {
                            championId: championKey,
                            shardsCount: shardsCount
                        }
                    ], {
                        optimisticMutation: true
                    })
        }), [
        setChampionsShardsBulk,
        shardsIsLoading
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            uiIsBlocked ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fVW4p.Loading), {
                    className: "mt-4 h-6 self-center"
                })
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, $jK7ok.cx)('flex h-full flex-col items-center gap-6 overflow-y-auto overflow-x-hidden px-2 pb-24 pt-3', [
                    'hidden',
                    uiIsBlocked
                ]),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b8cd6d1bb7a04112$export$7eec06b052b876ef), {
                        platform: platform,
                        summoner: {
                            ...summoner,
                            ...enrichedSummoner
                        },
                        leagues: leagues,
                        masteries: masteries
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $61a1acdfec0829fc$export$f62f504f0a1af108), {
                        challenges: challenges,
                        masteries: enrichedMasteries,
                        setChampionShards: setChampionShards
                    })
                ]
            })
        ]
    });
};
const $138d91d6e72410c5$var$enrichAll = (masteries, championShards, maybeSearch, staticDataChampions)=>{
    const enrichedMasteries_ = (0, $f5id0.pipe)(staticDataChampions, (0, $sjwE0.List).map(({ key: key, name: name, positions: positions, factions: factions, aram: aram, urf: urf })=>{
        const shardsCount = (0, $f5id0.pipe)(championShards, (0, $sjwE0.Maybe).map((0, $f5id0.flow)((0, $sjwE0.List).findFirst((s)=>(0, $br0yu.ChampionKey).Eq.equals(s.champion, key)), (0, $sjwE0.Maybe).fold(()=>0, (s)=>s.count))));
        const glow = (0, $f5id0.pipe)(maybeSearch, (0, $sjwE0.Maybe).exists((search)=>$138d91d6e72410c5$var$cleanChampionName(name).includes($138d91d6e72410c5$var$cleanChampionName(search))));
        const aramCategory = (0, $7432f0671d5622f7$export$dc50577efab52c43).fromData(aram);
        const urfCategory = (0, $7432f0671d5622f7$export$dc50577efab52c43).fromData(urf);
        const faction = (0, $25oLT.StaticDataChampion).getFaction(factions);
        const isHidden = false;
        return (0, $f5id0.pipe)((0, $f5id0.pipe)(masteries, (0, $iPRex.ListUtils).findFirstBy((0, $br0yu.ChampionKey).Eq)((c)=>c.championId))(key), (0, $sjwE0.Maybe).fold(()=>({
                championId: key,
                championLevel: 0,
                championPoints: 0,
                championPointsSinceLastLevel: 0,
                championPointsUntilNextLevel: 0,
                tokensEarned: 0,
                markRequiredForNextLevel: 0,
                name: name,
                percents: 0,
                shardsCount: shardsCount,
                glow: glow,
                positions: positions,
                factions: factions,
                aram: {
                    category: aramCategory,
                    data: aram
                },
                urf: {
                    category: urfCategory,
                    data: urf
                },
                faction: faction,
                isHidden: isHidden
            }), (champion)=>({
                ...champion,
                name: name,
                percents: (0, $e499b70a5fc06c1e$export$6d7a29d4960e3d83).championPercents(champion),
                shardsCount: shardsCount,
                glow: glow,
                positions: positions,
                factions: factions,
                aram: {
                    category: aramCategory,
                    data: aram
                },
                urf: {
                    category: urfCategory,
                    data: urf
                },
                faction: faction,
                isHidden: isHidden
            })));
    }));
    const totalMasteryPoints = (0, $f5id0.pipe)(enrichedMasteries_, (0, $sjwE0.List).map((c)=>c.championPoints), (0, $4x239).concatAll((0, $10ZIc).MonoidSum));
    const grouped = (0, $f5id0.pipe)(enrichedMasteries_, (0, $sjwE0.NonEmptyArray).fromReadonlyArray, (0, $sjwE0.Maybe).map((0, $sjwE0.List).groupBy((c)=>(0, $f5id0.pipe)((0, $aapGO.ChampionLevel).fromNumber(c.championLevel), (0, $aapGO.ChampionLevel).stringify))), (0, $sjwE0.Maybe).getOrElse(()=>({})));
    return {
        enrichedSummoner: {
            questPercents: (0, $f5id0.pipe)(enrichedMasteries_, (0, $sjwE0.List).map((c)=>c.percents), (0, $6nJ5H.NumberUtils).average),
            totalMasteryLevel: (0, $f5id0.pipe)(enrichedMasteries_, (0, $sjwE0.List).map((c)=>c.championLevel), (0, $4x239).concatAll((0, $10ZIc).MonoidSum)),
            totalMasteryPoints: totalMasteryPoints,
            otpIndex: (0, $e499b70a5fc06c1e$export$6d7a29d4960e3d83).otpRatio(enrichedMasteries_, totalMasteryPoints),
            masteriesCount: (0, $f5id0.pipe)((0, $aapGO.ChampionLevel).values, (0, $sjwE0.List).reduce((0, $sjwE0.Dict).empty(), (acc, championLevel)=>{
                const lvl = (0, $aapGO.ChampionLevel).stringify(championLevel);
                const value = grouped[lvl]?.length ?? 0;
                return {
                    ...acc,
                    [lvl]: value
                };
            }))
        },
        enrichedMasteries: enrichedMasteries_
    };
};



var $gE3ky = parcelRequire("gE3ky");

var $eojvT = parcelRequire("eojvT");

const $ebadc45e248f5d54$var$AdminRouterComponent = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("6twHP")));
const $ebadc45e248f5d54$export$326dfe05f118f497 = (0, $eojvT.getRouterComponent)((0, $dc934.zero)().alt((0, $gE3ky.appParsers).index.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $77f21d9d368b3b7c$export$b94310965bed44e6), {})))).alt($ebadc45e248f5d54$var$withPlatformLower((0, $gE3ky.appMatches).sPlatformPuuid, ({ platform: platform, puuid: puuid })=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $87dc3d03975134e5$export$689d97825c9414dc), {
        platform: platform,
        puuid: puuid
    })))).alt($ebadc45e248f5d54$var$withPlatformLower((0, $gE3ky.appMatches).sPlatformPuuidGame, ({ platform: platform, puuid: puuid })=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $87dc3d03975134e5$export$af8896da5ab9f805), {
        platform: platform,
        puuid: puuid
    })))).alt($ebadc45e248f5d54$var$withPlatformLower((0, $gE3ky.appMatches).platformRiotId, ({ platform: platform, riotId: riotId })=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $138d91d6e72410c5$export$f5c7402fca0d82db), {
        platform: platform,
        riotId: riotId
    }), ()=>(0, $fp7Nf.RiotId).stringify(riotId)))).alt($ebadc45e248f5d54$var$withPlatformLower((0, $gE3ky.appMatches).platformRiotIdGame, ({ platform: platform, riotId: riotId })=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $7ab2bc3670b99e36$export$85034e8d4bf2420), {
        platform: platform,
        riotId: riotId
    }), (t)=>`${(0, $fp7Nf.RiotId).stringify(riotId)} \u{2014} ${t.game}`))).alt((0, $gE3ky.appParsers).aram.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $521ea6eb53652e14$export$97895786af974272), {}), (t)=>t.aram))).alt((0, $gE3ky.appParsers).urf.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $a58de5afbed04983$export$8f34c1ae61107b83), {}), (t)=>t.urf))).alt((0, $gE3ky.appParsers).factions.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $082766cbe57dda99$export$c454e4c3445e22b1), {}), (t)=>t.factions))).alt((0, $gE3ky.appParsers).timers.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $73419687c58f28ef$export$8bb2c1fb2b1765a9), {}), (t)=>t.timers))).alt((0, $gE3ky.appParsers).login.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $da9d0305f9cddd74$export$21a94553ffa41578), {}), (t)=>t.login))).alt((0, $gE3ky.appParsers).register.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $931ea6bd6d9687ff$export$157c131647dc68e), {}), (t)=>t.register))).alt((0, $gE3ky.appParsers).discordRedirect.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $80162b5831b6fb55$export$288f4777bbf2f735), {})))).alt((0, $gE3ky.appParsers).anyAdmin.map(()=>(0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $ee34040125966ac9$export$ac1a3f0c836eba03), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($ebadc45e248f5d54$var$AdminRouterComponent, {})
    })))));
// Redirect if upper case
function $ebadc45e248f5d54$var$withPlatformLower(match, f) {
    return match.parser.map((a)=>{
        const upperCase = (0, $dOJeV.StringUtils).toUpperCase(a.platform);
        const isUppercase = upperCase === a.platform;
        return isUppercase ? (0, $eojvT.e)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $36sK8.Navigate), {
            to: (0, $c7lJu.format)(match.formatter, {
                ...a,
                platform: a.platform.toLowerCase()
            }),
            replace: true
        })) : f({
            ...a,
            platform: upperCase
        });
    });
}



const $38ae817de484a6be$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $4MEuc.TranslationContextProvider), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $31rfl.ToasterContextProvider), {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9xM77.HistoryContextProvider), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j30iL.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6H0K7.StaticDataContextProvider), {
                        children: [
                            (0, $c3c80580245b1da4$export$641527e078380b15),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ebadc45e248f5d54$export$326dfe05f118f497), {})
                        ]
                    })
                })
            })
        })
    });


const $301aca1cc0a32798$var$rootEltId = 'root';
const $301aca1cc0a32798$var$rootElt = document.getElementById($301aca1cc0a32798$var$rootEltId);
if ($301aca1cc0a32798$var$rootElt === null) // eslint-disable-next-line functional/no-throw-statements
throw Error(`root element not found: #${$301aca1cc0a32798$var$rootEltId}`);
const $301aca1cc0a32798$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($301aca1cc0a32798$var$rootElt);
// eslint-disable-next-line functional/no-expression-statements
$301aca1cc0a32798$var$root.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $38ae817de484a6be$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.249dab3c.js.map
